import "./module.css";
import {jsx as $hopDi$jsx, jsxs as $hopDi$jsxs, Fragment as $hopDi$Fragment} from "react/jsx-runtime";
import $hopDi$react, {useEffect as $hopDi$useEffect, Suspense as $hopDi$Suspense, useState as $hopDi$useState, useRef as $hopDi$useRef, createElement as $hopDi$createElement, useCallback as $hopDi$useCallback} from "react";
import {BrowserRouter as $hopDi$BrowserRouter, Switch as $hopDi$Switch, Route as $hopDi$Route, useLocation as $hopDi$useLocation, useHistory as $hopDi$useHistory} from "react-router-dom";
import {removeClassesForHidingElements as $hopDi$removeClassesForHidingElements, Route404 as $hopDi$Route404, Global404 as $hopDi$Global404, hideElementsFromHostApp as $hopDi$hideElementsFromHostApp, Logger as $hopDi$Logger, localize as $hopDi$localize, getRandomString as $hopDi$getRandomString} from "@saviynt/common";
import {IntlProvider as $hopDi$IntlProvider, useIntl as $hopDi$useIntl} from "react-intl";
import $hopDi$proptypes from "prop-types";
import {useDispatch as $hopDi$useDispatch, useSelector as $hopDi$useSelector} from "react-redux";
import $hopDi$classnames from "classnames";
import {Cookies as $hopDi$Cookies} from "react-cookie";
import $hopDi$axios from "axios";
import {Button as $hopDi$Button, Icon as $hopDi$Icon, Typography as $hopDi$Typography, Color as $hopDi$Color, Chip as $hopDi$Chip, Box as $hopDi$Box, Popover as $hopDi$Popover, Checkbox as $hopDi$Checkbox, Loader as $hopDi$Loader, ModalIsland as $hopDi$ModalIsland, AlertBanner as $hopDi$AlertBanner, ButtonSelect as $hopDi$ButtonSelect, Badge as $hopDi$Badge, MenuMulti as $hopDi$MenuMulti, ButtonIcon as $hopDi$ButtonIcon, Link as $hopDi$Link, InlineMessage as $hopDi$InlineMessage, InputField as $hopDi$InputField, TabGroup as $hopDi$TabGroup, TabItem as $hopDi$TabItem, TabContent as $hopDi$TabContent, ButtonCore as $hopDi$ButtonCore, Tooltip as $hopDi$Tooltip, DateAndTimePicker as $hopDi$DateAndTimePicker, FooterActionBar as $hopDi$FooterActionBar, Avatar as $hopDi$Avatar, MenuInput as $hopDi$MenuInput, SidePanel as $hopDi$SidePanel, ToggleButtonGroup as $hopDi$ToggleButtonGroup, ToggleButton as $hopDi$ToggleButton, useUploadFile as $hopDi$useUploadFile, Upload as $hopDi$Upload} from "@saviynt/design-system";
import {DragDropContext as $hopDi$DragDropContext, Droppable as $hopDi$Droppable, Draggable as $hopDi$Draggable} from "react-beautiful-dnd";
import $hopDi$lottiereact from "lottie-react";
import $hopDi$moment from "moment";
import $hopDi$reactsignaturecanvas from "react-signature-canvas";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}








function $4b5d3b67c109436c$var$LocalizedWrapper({ children: children }) {
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$IntlProvider), {
        locale: "en",
        children: children
    });
}
$4b5d3b67c109436c$var$LocalizedWrapper.propTypes = {
    children: (0, $hopDi$proptypes).node.isRequired
};
var $4b5d3b67c109436c$export$2e2bcd8739ae039 = $4b5d3b67c109436c$var$LocalizedWrapper;


/**
 * Function wraps the hideHostElements function from common.
 * If anything changes (flag, etc), only this file needs to be updated.
 *
 * @function hideHostElementsWrapper
 * @returns {void}
 */ 
const $8420256091f3759b$var$hideHostElementsWrapper = ()=>{
    (0, $hopDi$hideElementsFromHostApp)(false, "certGen2Flag", "1");
};
var $8420256091f3759b$export$2e2bcd8739ae039 = $8420256091f3759b$var$hideHostElementsWrapper;
const $8420256091f3759b$export$9bc070677037150b = ()=>{
    const dynamicbody = document.getElementsByClassName("dynamicModules")[0];
    if (dynamicbody) dynamicbody.classList.remove("d-block");
};









const $54e13f0d39960013$var$AVERAGE_TICK_OF_MOUSE_WHEEL = 100;
// TODO: Consider this if it is a desired effect
// Alway true if no more data is available and near the bottom
// if (!isMoreDataAvailable && isNearBottom) {
//   console.log('!isMoreDataAvailable ===> ', !isMoreDataAvailable);
//   console.log(
//     'No more data is available and near the bottom ===> ',
//     isNearBottom
//   );
//   setIsVisible(true);
//   return;
// }
// if (isMoreDataAvailable) {
//   setIsVisible(false);
//   return;
// }
// Check if the content is short enough not to have a scrollbar
// if (scrollHeight <= clientHeight) {
//   setIsVisible(true);
//   return;
// }
// if (!isMoreDataAvailable && isNearBottom) {
//     setIsVisible(true);
//
//   return;
// }
const $54e13f0d39960013$var$useControlsVisibility = (containerRef, isMoreDataAvailable)=>{
    const [isVisible, setIsVisible] = (0, $hopDi$useState)(true);
    const lastScrollY = (0, $hopDi$useRef)(0);
    const lastWasNearBottom = (0, $hopDi$useRef)(false);
    (0, $hopDi$useEffect)(()=>{
        const controlHeaderVisibility = ()=>{
            if (!containerRef.current) return;
            const { scrollHeight: scrollHeight, clientHeight: clientHeight, scrollTop: scrollTop } = containerRef.current;
            const isNearBottom = scrollTop + clientHeight >= scrollHeight - $54e13f0d39960013$var$AVERAGE_TICK_OF_MOUSE_WHEEL;
            // Always shwo when at top
            if (scrollTop === 0) {
                setIsVisible(true);
                return;
            }
            // Modify visibility based on scroll direction when not near the bottom
            if (isNearBottom) // Avoid changing the visibility if we're near the bottom and the scroll position changes due to resizing
            // Hide and keep hidden near the bottom unless explicitly scrolled up
            {
                if (!lastWasNearBottom.current) setIsVisible(false);
            } else if (scrollTop < lastScrollY.current) setIsVisible(true); // Scrolling up
            else if (scrollTop > lastScrollY.current) setIsVisible(false); // Scrolling down
            // Update state to remember if we were near the bottom
            lastWasNearBottom.current = isNearBottom;
            // Update last known scroll position after handling visibility
            lastScrollY.current = scrollTop;
        };
        const element = containerRef.current;
        if (element) element.addEventListener("scroll", controlHeaderVisibility);
        return ()=>{
            if (element) element.removeEventListener("scroll", controlHeaderVisibility);
        };
    }, [
        containerRef,
        isMoreDataAvailable
    ]);
    return isVisible;
};
var $54e13f0d39960013$export$2e2bcd8739ae039 = $54e13f0d39960013$var$useControlsVisibility;


/* eslint-disable indent */ /* eslint-disable camelcase */ /* eslint-disable consistent-return */ 


const $d60257e8dc27bf16$export$7219e4813ca4abf0 = "Application";
const $d60257e8dc27bf16$export$1cc98074061c90d2 = "User";
const $d60257e8dc27bf16$export$7d6712c2cb8377b2 = "Role";
const $d60257e8dc27bf16$export$153ab95c08227093 = "Account";
const $d60257e8dc27bf16$export$be9a3074cb3ae0c7 = "Entitlement";
const $d60257e8dc27bf16$export$994f7af6d0b36256 = "CERT_ENTITLEMENT_VALUEKEY";
const $d60257e8dc27bf16$export$dc13af498303679 = "User_DISPLAYNAME";
const $d60257e8dc27bf16$export$76f2b9e2abf8cf0c = "User description";
const $d60257e8dc27bf16$export$669183101cc88fb6 = "Role_DISPLAYNAME";
const $d60257e8dc27bf16$export$71193c4d5e3b3956 = "LASTCERTIFIEDCAMPAIGNNAME";
const $d60257e8dc27bf16$export$843e8b0030038872 = "Account_DISPLAYNAME";
const $d60257e8dc27bf16$export$c0a9d10def3a6309 = "Account_DESCRIPTION";
const $d60257e8dc27bf16$export$9dee3ced165b51d1 = "Ent_DISPLAYNAME";
const $d60257e8dc27bf16$export$6940d0d32ae129a1 = "Ent_DESCRIPTION";
const $d60257e8dc27bf16$export$bde14d5a1cbdb371 = "tab_summary";
const $d60257e8dc27bf16$export$9b67fda1e37e6e63 = "tab_history";
const $d60257e8dc27bf16$export$a06b6c2be556dac8 = "tab_privilege";
const $d60257e8dc27bf16$export$6cc684447a8d7b17 = "tab_entitlement";
const $d60257e8dc27bf16$export$51f82826650bc3c3 = "tab_children";
const $d60257e8dc27bf16$export$ed0bf72b1f4a9681 = "tab_dependent";
const $d60257e8dc27bf16$export$8f78881bb4058858 = "tab_sod";
const $d60257e8dc27bf16$export$d66151c7af00715f = "tab_menu";


const $d44c789d5b60f9bf$export$48ae29ec3f91ef49 = "TAB_STATUS_TODO";
const $d44c789d5b60f9bf$export$807a0bc890800408 = "TAB_STATUS_DONE";
const $d44c789d5b60f9bf$export$d5eea126dff5a615 = "TAB_STATUS_ALL";
const $d44c789d5b60f9bf$export$b2766b46106d3053 = "TAB_STATUS_CONS";


/* eslint-disable no-param-reassign */ /* eslint-disable no-restricted-syntax */ /* eslint-disable guard-for-in */ const $135adfecc1ed8f07$export$49390a4605a2336a = {
    LIGHT: "light",
    DARK: "dark"
};
const $135adfecc1ed8f07$export$9f3245bec405e186 = {
    certs: {
        // Custom Keys added
        NOT_PROVIDED: {
            ATTESTATIONS: {
                id: "NOT_PROVIDED.ATTESTATIONS",
                defaultMessage: "Not Provided"
            }
        },
        userName: {
            ATTESTATIONS: {
                id: "userName.ATTESTATIONS",
                defaultMessage: "User Name"
            }
        },
        DEFAULT: {
            ATTESTATIONS: {
                id: "DEFAULT.ATTESTATIONS",
                defaultMessage: "Custom Property"
            }
        },
        // Custom keys addition ends here...
        PARENTMENU: {
            ATTESTATIONS: {
                id: "PARENTMENU.ATTESTATIONS",
                defaultMessage: "Attestations"
            }
        },
        SUBMENU: {
            ATTESTATIONS: {
                id: "SUBMENU.ATTESTATIONS.attestations_create",
                defaultMessage: "Create New attestation"
            }
        },
        SAVLEVEL: {
            ATTESTATIONS: {
                id: "SAVLEVEL.ATTESTATIONS",
                defaultMessage: "SAV Level"
            }
        },
        PRIVILEGED: {
            ATTESTATIONS: {
                id: "PRIVILEGED.ATTESTATIONS",
                defaultMessage: "Privileged"
            }
        },
        parentmenu: {
            ATTESTATIONS: {
                id: "parentmenu.ATTESTATION",
                defaultMessage: "Attestations"
            }
        },
        Childent_CERT_ENTITLEMENT_VALUEKEY: {
            ATTESTATIONS: {
                id: "Childent_CERT_ENTITLEMENT_VALUEKEY.ATTESTATIONS",
                defaultMessage: "Certification Entitlement Value Key"
            }
        },
        Childent_ENTITLEMENT_VALUEKEY: {
            ATTESTATIONS: {
                id: "Childent_ENTITLEMENT_VALUEKEY.ATTESTATIONS",
                defaultMessage: "Entitlement Value Key"
            }
        },
        Childent_ENTITLEMENT_VALUE: {
            ATTESTATIONS: {
                id: "Childent_ENTITLEMENT_VALUE.ATTESTATIONS",
                defaultMessage: "Entitlement Value"
            }
        },
        Childent_ENTITLEMENTTYPEKEY: {
            ATTESTATIONS: {
                id: "Childent_ENTITLEMENTTYPEKEY.ATTESTATIONS",
                defaultMessage: "Entitlement Type Key"
            }
        },
        Childent_CUSTOMPROPERTY1: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY1.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 1"
            }
        },
        Childent_CUSTOMPROPERTY2: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY2.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 2"
            }
        },
        Childent_CUSTOMPROPERTY3: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY3.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 3"
            }
        },
        Childent_CUSTOMPROPERTY4: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY4.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 4"
            }
        },
        Childent_CUSTOMPROPERTY5: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY5.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 5"
            }
        },
        Childent_CUSTOMPROPERTY6: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY6.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 6"
            }
        },
        Childent_CUSTOMPROPERTY7: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY7.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 7"
            }
        },
        Childent_CUSTOMPROPERTY8: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY8.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 8"
            }
        },
        Childent_CUSTOMPROPERTY9: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY9.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 9"
            }
        },
        Childent_CUSTOMPROPERTY10: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY10.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 10"
            }
        },
        Childent_CUSTOMPROPERTY11: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY11.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 11"
            }
        },
        Childent_CUSTOMPROPERTY12: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY12.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 12"
            }
        },
        Childent_CUSTOMPROPERTY13: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY13.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 13"
            }
        },
        Childent_CUSTOMPROPERTY14: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY14.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 14"
            }
        },
        Childent_CUSTOMPROPERTY15: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY15.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 15"
            }
        },
        Childent_CUSTOMPROPERTY16: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY16.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 16"
            }
        },
        Childent_CUSTOMPROPERTY17: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY17.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 17"
            }
        },
        Childent_CUSTOMPROPERTY18: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY18.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 18"
            }
        },
        Childent_CUSTOMPROPERTY19: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY19.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 19"
            }
        },
        Childent_CUSTOMPROPERTY20: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY20.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 20"
            }
        },
        Childent_CUSTOMPROPERTY21: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY21.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 21"
            }
        },
        Childent_CUSTOMPROPERTY22: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY22.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 22"
            }
        },
        Childent_CUSTOMPROPERTY23: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY23.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 23"
            }
        },
        Childent_CUSTOMPROPERTY24: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY24.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 24"
            }
        },
        Childent_CUSTOMPROPERTY25: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY25.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 25"
            }
        },
        Childent_CUSTOMPROPERTY26: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY26.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 26"
            }
        },
        Childent_CUSTOMPROPERTY27: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY27.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 27"
            }
        },
        Childent_CUSTOMPROPERTY28: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY28.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 28"
            }
        },
        Childent_CUSTOMPROPERTY29: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY29.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 29"
            }
        },
        Childent_CUSTOMPROPERTY30: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY30.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 30"
            }
        },
        Childent_CUSTOMPROPERTY31: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY31.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 31"
            }
        },
        Childent_CUSTOMPROPERTY32: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY32.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 32"
            }
        },
        Childent_CUSTOMPROPERTY33: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY33.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 33"
            }
        },
        Childent_CUSTOMPROPERTY34: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY34.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 34"
            }
        },
        Childent_CUSTOMPROPERTY35: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY35.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 35"
            }
        },
        Childent_CUSTOMPROPERTY36: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY36.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 36"
            }
        },
        Childent_CUSTOMPROPERTY37: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY37.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 37"
            }
        },
        Childent_CUSTOMPROPERTY38: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY38.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 38"
            }
        },
        Childent_CUSTOMPROPERTY39: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY39.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 39"
            }
        },
        Childent_CUSTOMPROPERTY40: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY40.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 40"
            }
        },
        Childent_DESCRIPTION: {
            ATTESTATIONS: {
                id: "Childent_DESCRIPTION.ATTESTATIONS",
                defaultMessage: "Entitlement Description"
            }
        },
        Childent_GLOSSARY: {
            ATTESTATIONS: {
                id: "Childent_GLOSSARY.ATTESTATIONS",
                defaultMessage: "Entitlement Glossary"
            }
        },
        Childent_ENTITLEMENT_GLOSSARY: {
            ATTESTATIONS: {
                id: "Childent_ENTITLEMENT_GLOSSARY.ATTESTATIONS",
                defaultMessage: "Entitlement Glossary"
            }
        },
        Childent_STATUS: {
            ATTESTATIONS: {
                id: "Childent_STATUS.ATTESTATIONS",
                defaultMessage: "Entitlement Status"
            }
        },
        Childent_UPDATEUSER: {
            ATTESTATIONS: {
                id: "Childent_UPDATEUSER.ATTESTATIONS",
                defaultMessage: "Entitlement Update User"
            }
        },
        Childent_RISK: {
            ATTESTATIONS: {
                id: "Childent_RISK.ATTESTATIONS",
                defaultMessage: "Entitlement Risk"
            }
        },
        Childent_SOXCRITICAL: {
            ATTESTATIONS: {
                id: "Childent_SOXCRITICAL.ATTESTATIONS",
                defaultMessage: "Entitlement SOX Critical"
            }
        },
        Childent_SYSCRITICAL: {
            ATTESTATIONS: {
                id: "Childent_SYSCRITICAL.ATTESTATIONS",
                defaultMessage: "Entitlement Sys Critical"
            }
        },
        Childent_ORPHAN: {
            ATTESTATIONS: {
                id: "Childent_ORPHAN.ATTESTATIONS",
                defaultMessage: "Entitlement Orphan"
            }
        },
        Childent_UPDATEDATE: {
            ATTESTATIONS: {
                id: "Childent_UPDATEDATE.ATTESTATIONS",
                defaultMessage: "Entitlement Update Date"
            }
        },
        Childent_SAVLEVEL: {
            ATTESTATIONS: {
                id: "Childent_SAVLEVEL.ATTESTATIONS",
                defaultMessage: "Entitlement SAV Level"
            }
        },
        Childent_PRIVILIGED: {
            ATTESTATIONS: {
                id: "Childent_PRIVILIGED.ATTESTATIONS",
                defaultMessage: "Entitlement Privileged"
            }
        },
        Childent_CONFIDENTIALITY: {
            ATTESTATIONS: {
                id: "Childent_CONFIDENTIALITY.ATTESTATIONS",
                defaultMessage: "Entitlement Confidentiality"
            }
        },
        Childent_SOD: {
            ATTESTATIONS: {
                id: "Childent_SOD.ATTESTATIONS",
                defaultMessage: "Entitlement SOD"
            }
        },
        Childent_DISPLAYNAME: {
            ATTESTATIONS: {
                id: "Childent_DISPLAYNAME.ATTESTATIONS",
                defaultMessage: "Entitlement Display Name"
            }
        },
        Childent_ENTITLEMENTID: {
            ATTESTATIONS: {
                id: "Childent_ENTITLEMENTID.ATTESTATIONS",
                defaultMessage: "Entitlement ID"
            }
        },
        Childent_PROGRAM: {
            ATTESTATIONS: {
                id: "Childent_PROGRAM.ATTESTATIONS",
                defaultMessage: "Entitlement Program"
            }
        },
        Childent_MODULE: {
            ATTESTATIONS: {
                id: "Childent_MODULE.ATTESTATIONS",
                defaultMessage: "Entitlement Module"
            }
        },
        Childent_ACCESS: {
            ATTESTATIONS: {
                id: "Childent_ACCESS.ATTESTATIONS",
                defaultMessage: "Entitlement Access"
            }
        },
        Childent_SCHEMANAME: {
            ATTESTATIONS: {
                id: "Childent_SCHEMANAME.ATTESTATIONS",
                defaultMessage: "Entitlement Schema Name"
            }
        },
        Childent_ENTCLASS: {
            ATTESTATIONS: {
                id: "Childent_ENTCLASS.ATTESTATIONS",
                defaultMessage: "Entitlement Classification"
            }
        },
        Childent_LASTSCANDATE: {
            ATTESTATIONS: {
                id: "Childent_LASTSCANDATE.ATTESTATIONS",
                defaultMessage: "Entitlement Last Scan Date"
            }
        },
        Childent_ENTITLEMGLOSSARY: {
            ATTESTATIONS: {
                id: "Childent_ENTITLEMGLOSSARY.ATTESTATIONS",
                defaultMessage: "Entitlement Glossary"
            }
        },
        Childent_JOBID: {
            ATTESTATIONS: {
                id: "Childent_JOBID.ATTESTATIONS",
                defaultMessage: "Entitlement Job ID"
            }
        },
        Childent_LASTUSEDENDDATE: {
            ATTESTATIONS: {
                id: "Childent_LASTUSEDENDDATE.ATTESTATIONS",
                defaultMessage: "Entitlement Last Used End Date"
            }
        },
        DASHBOARD: {
            ATTESTATIONS: {
                id: "DASHBOARD.ATTESTATION",
                defaultMessage: "Dashboard"
            }
        },
        ACCESSTHROUGH: {
            ATTESTATIONS: {
                id: "ACCESSTHROUGH.ATTESTATIONS",
                defaultMessage: "Granted Through"
            }
        },
        ENDPOINT: {
            ATTESTATIONS: {
                id: "ENDPOINT.ATTESTATIONS",
                defaultMessage: "Endpoint Name"
            }
        },
        LASTUSEDDATE: {
            ATTESTATIONS: {
                id: "LASTUSEDDATE.ATTESTATIONS",
                defaultMessage: "Last Used Date"
            }
        },
        Ent2_LASTUSEDDATE: {
            ATTESTATIONS: {
                id: "Ent2_LASTUSEDDATE.ATTESTATIONS",
                defaultMessage: "Last Used Date"
            }
        },
        USERNAME: {
            ATTESTATIONS: {
                id: "USERNAME.ATTESTATIONS",
                defaultMessage: "User ID"
            }
        },
        ENTITLEMENT_VALUE: {
            ATTESTATIONS: {
                id: "ENTITLEMENT_VALUE.ATTESTATIONS",
                defaultMessage: "Entitlement Value"
            }
        },
        ENTITLEMENTID: {
            ATTESTATIONS: {
                id: "ENTITLEMENTID.ATTESTATIONS",
                defaultMessage: "Entitlement ID"
            }
        },
        ENTITLEMENT_GLOSSARY: {
            ATTESTATIONS: {
                id: "ENTITLEMENT_GLOSSARY.ATTESTATIONS",
                defaultMessage: "Entitlement Glossary"
            }
        },
        JOB_ID: {
            ATTESTATIONS: {
                id: "JOB_ID.ATTESTATIONS",
                defaultMessage: "Entitlement Job ID"
            }
        },
        LASTREVIEWEDCAMPAIGNNAME: {
            ATTESTATIONS: {
                id: "LASTREVIEWEDCAMPAIGNNAME.ATTESTATIONS",
                defaultMessage: "Last Reviewed Campaign"
            }
        },
        LASTSCANDATE: {
            ATTESTATIONS: {
                id: "LASTSCANDATE.ATTESTATIONS",
                defaultMessage: "Entitlement Last Scan Date"
            }
        },
        ORPHAN: {
            ATTESTATIONS: {
                id: "ORPHAN.ATTESTATIONS",
                defaultMessage: "Entitlement Orphan"
            }
        },
        SOX_CRITICAL: {
            ATTESTATIONS: {
                id: "SOX_CRITICAL.ATTESTATIONS",
                defaultMessage: "Entitlement SOX Critical"
            }
        },
        SYS_CRITICAL: {
            ATTESTATIONS: {
                id: "SYS_CRITICAL.ATTESTATIONS",
                defaultMessage: "Entitlement Sys Critical"
            }
        },
        ACCOUNTNAME: {
            ATTESTATIONS: {
                id: "ACCOUNTNAME.ATTESTATIONS",
                defaultMessage: "Account Name"
            }
        },
        STATUS: {
            ATTESTATIONS: {
                id: "STATUS.ATTESTATIONS",
                defaultMessage: "Status"
            }
        },
        SYSTEMNAME: {
            ATTESTATIONS: {
                id: "SYSTEMNAME.ATTESTATIONS",
                defaultMessage: "System Name"
            }
        },
        COMMENTS: {
            ATTESTATIONS: {
                id: "COMMENTS.ATTESTATIONS",
                defaultMessage: "Comments"
            }
        },
        HISTORY: {
            ATTESTATIONS: {
                id: "HISTORY.ATTESTATIONS",
                defaultMessage: "History"
            }
        },
        JRMRULES: {
            ATTESTATIONS: {
                id: "JRMRULES.ATTESTATIONS.MESSAGE",
                defaultMessage: "Outlier Analysis"
            }
        },
        JRMNORULES: {
            ATTESTATIONS: {
                id: "JRMNORULES.ATTESTATIONS.MESSAGE",
                defaultMessage: "Less than 20% of users in the peer group have access to this data"
            }
        },
        LASTUSEDENDDATE: {
            ATTESTATIONS: {
                id: "LASTUSEDENDDATE.ATTESTATIONS",
                defaultMessage: "Last used"
            }
        },
        RISKS: {
            ATTESTATIONS: {
                id: "RISKS.ATTESTATIONS",
                defaultMessage: "SOD Risks"
            }
        },
        CERTIFICATION: {
            ATTESTATIONS: {
                id: "CERTIFICATION.ATTESTATIONS",
                defaultMessage: "Certification"
            }
        },
        CERTIFIER: {
            ATTESTATIONS: {
                id: "CERTIFIER.ATTESTATIONS",
                defaultMessage: "Certifier"
            }
        },
        Assign: {
            ATTESTATIONS: {
                id: "Assign.ATTESTATIONS.label",
                defaultMessage: "Consult"
            }
        },
        UPDATEDATE: {
            ATTESTATIONS: {
                id: "UPDATEDATE.ATTESTATIONS",
                defaultMessage: "Last Certified"
            }
        },
        SELECTALL: {
            ATTESTATIONS: {
                id: "SELECTALL.ATTESTATIONS",
                defaultMessage: "Select All"
            }
        },
        ACTION: {
            ATTESTATIONS: {
                id: "ACTION.ATTESTATIONS",
                defaultMessage: "Action"
            }
        },
        JRMRULESAVAILABLE: {
            ATTESTATIONS: {
                id: "JRMRULESAVAILABLE.ATTESTATIONS",
                defaultMessage: "Outlier Analysis"
            }
        },
        RISKSAVAILABLE: {
            ATTESTATIONS: {
                id: "RISKSAVAILABLE.ATTESTATIONS",
                defaultMessage: "SOD Risks"
            }
        },
        LASTCERTIFIEDCAMPAIGNNAME: {
            ATTESTATIONS: {
                id: "LASTCERTIFIEDCAMPAIGNNAME.ATTESTATIONS",
                defaultMessage: "Last Certified Campaign"
            }
        },
        LASTCERTIFIED: {
            ATTESTATIONS: {
                id: "LASTCERTIFIED.ATTESTATIONS",
                defaultMessage: "Last Certified Date"
            }
        },
        AUDIT_TRAIL: {
            ATTESTATIONS: {
                id: "AUDIT_TRAIL.ATTESTATIONS",
                defaultMessage: "History"
            }
        },
        CRITICALITY: {
            ATTESTATIONS: {
                id: "CRITICALITY.ATTESTATIONS",
                defaultMessage: "Entitlement Criticality"
            }
        },
        CERTIFIED: {
            ATTESTATIONS: {
                id: "CERTIFIED.ATTESTATIONS",
                defaultMessage: "Status"
            }
        },
        REASSIGNED: {
            ATTESTATIONS: {
                id: "REASSIGNED.ATTESTATIONS",
                defaultMessage: "Consulted"
            }
        },
        ENTITLEMENTTYPE: {
            ATTESTATIONS: {
                id: "ENTITLEMENTTYPE.ATTESTATIONS",
                defaultMessage: "Entitlement Type"
            }
        },
        Account_CERT_ACCOUNTKEY: {
            ATTESTATIONS: {
                id: "Account_CERT_ACCOUNTKEY.ATTESTATIONS",
                defaultMessage: "Account Certification Account Key"
            }
        },
        Account_ACCOUNTKEY: {
            ATTESTATIONS: {
                id: "Account_ACCOUNTKEY.ATTESTATIONS",
                defaultMessage: "Account Key"
            }
        },
        Account_NAME: {
            ATTESTATIONS: {
                id: "Account_NAME.ATTESTATIONS",
                defaultMessage: "Account Name"
            }
        },
        Account_REFERENCED_ACCOUNTKEY: {
            ATTESTATIONS: {
                id: "Account_REFERENCED_ACCOUNTKEY.ATTESTATIONS",
                defaultMessage: "Referenced Account"
            }
        },
        Account_DESCRIPTION: {
            ATTESTATIONS: {
                id: "Account_DESCRIPTION.ATTESTATIONS",
                defaultMessage: "Account Description"
            }
        },
        Account_COMMENTS: {
            ATTESTATIONS: {
                id: "Account_COMMENTS.ATTESTATIONS",
                defaultMessage: "Account Comments"
            }
        },
        Account_ACCOUNTTYPE: {
            ATTESTATIONS: {
                id: "Account_ACCOUNTTYPE.ATTESTATIONS",
                defaultMessage: "Account Type"
            }
        },
        Account_STATUS: {
            ATTESTATIONS: {
                id: "Account_STATUS.ATTESTATIONS",
                defaultMessage: "Account Status"
            }
        },
        Account_VALIDFROM: {
            ATTESTATIONS: {
                id: "Account_VALIDFROM.ATTESTATIONS",
                defaultMessage: "Account Valid From"
            }
        },
        Account_VALIDTHROUGH: {
            ATTESTATIONS: {
                id: "Account_VALIDTHROUGH.ATTESTATIONS",
                defaultMessage: "Account Valid Through"
            }
        },
        Account_USERLOCK: {
            ATTESTATIONS: {
                id: "Account_USERLOCK.ATTESTATIONS",
                defaultMessage: "Account User Lock"
            }
        },
        Account_CREATOR: {
            ATTESTATIONS: {
                id: "Account_CREATOR.ATTESTATIONS",
                defaultMessage: "Account Created By"
            }
        },
        Account_CREATED_ON: {
            ATTESTATIONS: {
                id: "Account_CREATED_ON.ATTESTATIONS",
                defaultMessage: "Account Created On"
            }
        },
        Account_LASTLOGONDATE: {
            ATTESTATIONS: {
                id: "Account_LASTLOGONDATE.ATTESTATIONS",
                defaultMessage: "Account Last Login Date"
            }
        },
        Account_ORPHAN: {
            ATTESTATIONS: {
                id: "Account_ORPHAN.ATTESTATIONS",
                defaultMessage: "Account Orphan"
            }
        },
        Account_JOBID: {
            ATTESTATIONS: {
                id: "Account_JOBID.ATTESTATIONS",
                defaultMessage: "Account Job ID"
            }
        },
        Account_PRIVILEGED: {
            ATTESTATIONS: {
                id: "Account_PRIVILEGED.ATTESTATIONS",
                defaultMessage: "Account Privileged"
            }
        },
        Account_ENDPOINTKEY: {
            ATTESTATIONS: {
                id: "Account_ENDPOINTKEY.ATTESTATIONS",
                defaultMessage: "Account Endpoint"
            }
        },
        Account_SYSTEMID: {
            ATTESTATIONS: {
                id: "Account_SYSTEMID.ATTESTATIONS",
                defaultMessage: "Account System"
            }
        },
        Account_INCORRECTLOGONS: {
            ATTESTATIONS: {
                id: "Account_INCORRECTLOGONS.ATTESTATIONS",
                defaultMessage: "Account Incorrect Logins"
            }
        },
        Account_LASTPASSWORDCHANGE: {
            ATTESTATIONS: {
                id: "Account_LASTPASSWORDCHANGE.ATTESTATIONS",
                defaultMessage: "Account Last Password Change"
            }
        },
        Account_PASSWORDLOCKDATE: {
            ATTESTATIONS: {
                id: "Account_PASSWORDLOCKDATE.ATTESTATIONS",
                defaultMessage: "Account Password Locked Date"
            }
        },
        Account_PASSWORDCHANGESTATUS: {
            ATTESTATIONS: {
                id: "Account_PASSWORDCHANGESTATUS.ATTESTATIONS",
                defaultMessage: "Account Password Change Status"
            }
        },
        Account_CUSTOMPROPERTY1: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY1.ATTESTATIONS",
                defaultMessage: "Account Custom Property 1"
            }
        },
        Account_CUSTOMPROPERTY2: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY2.ATTESTATIONS",
                defaultMessage: "Account Custom Property 2"
            }
        },
        Account_CUSTOMPROPERTY3: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY3.ATTESTATIONS",
                defaultMessage: "Account Custom Property 3"
            }
        },
        Account_CUSTOMPROPERTY4: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY4.ATTESTATIONS",
                defaultMessage: "Account Custom Property 4"
            }
        },
        Account_CUSTOMPROPERTY5: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY5.ATTESTATIONS",
                defaultMessage: "Account Custom Property 5"
            }
        },
        Account_CUSTOMPROPERTY6: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY6.ATTESTATIONS",
                defaultMessage: "Account Custom Property 6"
            }
        },
        Account_CUSTOMPROPERTY7: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY7.ATTESTATIONS",
                defaultMessage: "Account Custom Property 7"
            }
        },
        Account_CUSTOMPROPERTY8: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY8.ATTESTATIONS",
                defaultMessage: "Account Custom Property 8"
            }
        },
        Account_CUSTOMPROPERTY9: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY9.ATTESTATIONS",
                defaultMessage: "Account Custom Property 9"
            }
        },
        Account_CUSTOMPROPERTY10: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY10.ATTESTATIONS",
                defaultMessage: "Account Custom Property 10"
            }
        },
        Account_CUSTOMPROPERTY11: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY11.ATTESTATIONS",
                defaultMessage: "Account Custom Property 11"
            }
        },
        Account_CUSTOMPROPERTY12: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY12.ATTESTATIONS",
                defaultMessage: "Account Custom Property 12"
            }
        },
        Account_CUSTOMPROPERTY13: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY13.ATTESTATIONS",
                defaultMessage: "Account Custom Property 13"
            }
        },
        Account_CUSTOMPROPERTY14: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY14.ATTESTATIONS",
                defaultMessage: "Account Custom Property 14"
            }
        },
        Account_CUSTOMPROPERTY15: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY15.ATTESTATIONS",
                defaultMessage: "Account Custom Property 15"
            }
        },
        Account_CUSTOMPROPERTY16: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY16.ATTESTATIONS",
                defaultMessage: "Account Custom Property 16"
            }
        },
        Account_CUSTOMPROPERTY17: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY17.ATTESTATIONS",
                defaultMessage: "Account Custom Property 17"
            }
        },
        Account_CUSTOMPROPERTY18: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY18.ATTESTATIONS",
                defaultMessage: "Account Custom Property 18"
            }
        },
        Account_CUSTOMPROPERTY19: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY19.ATTESTATIONS",
                defaultMessage: "Account Custom Property 19"
            }
        },
        Account_CUSTOMPROPERTY20: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY20.ATTESTATIONS",
                defaultMessage: "Account Custom Property 20"
            }
        },
        Account_CUSTOMPROPERTY21: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY21.ATTESTATIONS",
                defaultMessage: "Account Custom Property 21"
            }
        },
        Account_CUSTOMPROPERTY22: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY22.ATTESTATIONS",
                defaultMessage: "Account Custom Property 22"
            }
        },
        Account_CUSTOMPROPERTY23: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY23.ATTESTATIONS",
                defaultMessage: "Account Custom Property 23"
            }
        },
        Account_CUSTOMPROPERTY24: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY24.ATTESTATIONS",
                defaultMessage: "Account Custom Property 24"
            }
        },
        Account_CUSTOMPROPERTY25: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY25.ATTESTATIONS",
                defaultMessage: "Account Custom Property 25"
            }
        },
        Account_CUSTOMPROPERTY26: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY26.ATTESTATIONS",
                defaultMessage: "Account Custom Property 26"
            }
        },
        Account_CUSTOMPROPERTY27: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY27.ATTESTATIONS",
                defaultMessage: "Account Custom Property 27"
            }
        },
        Account_CUSTOMPROPERTY28: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY28.ATTESTATIONS",
                defaultMessage: "Account Custom Property 28"
            }
        },
        Account_CUSTOMPROPERTY29: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY29.ATTESTATIONS",
                defaultMessage: "Account Custom Property 29"
            }
        },
        Account_CUSTOMPROPERTY30: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY30.ATTESTATIONS",
                defaultMessage: "Account Custom Property 30"
            }
        },
        Account_CUSTOMPROPERTY31: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY31.ATTESTATIONS",
                defaultMessage: "Account Custom Property 31"
            }
        },
        Account_CUSTOMPROPERTY32: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY32.ATTESTATIONS",
                defaultMessage: "Account Custom Property 32"
            }
        },
        Account_CUSTOMPROPERTY33: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY33.ATTESTATIONS",
                defaultMessage: "Account Custom Property 33"
            }
        },
        Account_CUSTOMPROPERTY34: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY34.ATTESTATIONS",
                defaultMessage: "Account Custom Property 34"
            }
        },
        Account_CUSTOMPROPERTY35: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY35.ATTESTATIONS",
                defaultMessage: "Account Custom Property 35"
            }
        },
        Account_CUSTOMPROPERTY36: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY36.ATTESTATIONS",
                defaultMessage: "Account Custom Property 36"
            }
        },
        Account_CUSTOMPROPERTY37: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY37.ATTESTATIONS",
                defaultMessage: "Account Custom Property 37"
            }
        },
        Account_CUSTOMPROPERTY38: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY38.ATTESTATIONS",
                defaultMessage: "Account Custom Property 38"
            }
        },
        Account_CUSTOMPROPERTY39: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY39.ATTESTATIONS",
                defaultMessage: "Account Custom Property 39"
            }
        },
        Account_CUSTOMPROPERTY40: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY40.ATTESTATIONS",
                defaultMessage: "Account Custom Property 40"
            }
        },
        Account_CUSTOMPROPERTY41: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY41.ATTESTATIONS",
                defaultMessage: "Account Custom Property 41"
            }
        },
        Account_CUSTOMPROPERTY42: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY42.ATTESTATIONS",
                defaultMessage: "Account Custom Property 42"
            }
        },
        Account_CUSTOMPROPERTY43: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY43.ATTESTATIONS",
                defaultMessage: "Account Custom Property 43"
            }
        },
        Account_CUSTOMPROPERTY44: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY44.ATTESTATIONS",
                defaultMessage: "Account Custom Property 44"
            }
        },
        Account_CUSTOMPROPERTY45: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY45.ATTESTATIONS",
                defaultMessage: "Account Custom Property 45"
            }
        },
        Account_CUSTOMPROPERTY46: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY46.ATTESTATIONS",
                defaultMessage: "Account Custom Property 46"
            }
        },
        Account_CUSTOMPROPERTY47: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY47.ATTESTATIONS",
                defaultMessage: "Account Custom Property 47"
            }
        },
        Account_CUSTOMPROPERTY48: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY48.ATTESTATIONS",
                defaultMessage: "Account Custom Property 48"
            }
        },
        Account_CUSTOMPROPERTY49: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY49.ATTESTATIONS",
                defaultMessage: "Account Custom Property 49"
            }
        },
        Account_CUSTOMPROPERTY50: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY50.ATTESTATIONS",
                defaultMessage: "Account Custom Property 50"
            }
        },
        Account_CUSTOMPROPERTY51: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY51.ATTESTATIONS",
                defaultMessage: "Account Custom Property 51"
            }
        },
        Account_CUSTOMPROPERTY52: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY52.ATTESTATIONS",
                defaultMessage: "Account Custom Property 52"
            }
        },
        Account_CUSTOMPROPERTY53: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY53.ATTESTATIONS",
                defaultMessage: "Account Custom Property 53"
            }
        },
        Account_CUSTOMPROPERTY54: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY54.ATTESTATIONS",
                defaultMessage: "Account Custom Property 54"
            }
        },
        Account_CUSTOMPROPERTY55: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY55.ATTESTATIONS",
                defaultMessage: "Account Custom Property 55"
            }
        },
        Account_CUSTOMPROPERTY56: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY56.ATTESTATIONS",
                defaultMessage: "Account Custom Property 56"
            }
        },
        Account_UPDATEDATE: {
            ATTESTATIONS: {
                id: "Account_UPDATEDATE.ATTESTATIONS",
                defaultMessage: "Account Update Date"
            }
        },
        Account_ACCOUNTID: {
            ATTESTATIONS: {
                id: "Account_ACCOUNTID.ATTESTATIONS",
                defaultMessage: "Account ID"
            }
        },
        Account_DISPLAYNAME: {
            ATTESTATIONS: {
                id: "Account_DISPLAYNAME.ATTESTATIONS",
                defaultMessage: "Account"
            }
        },
        Account_REFERENCED_ACCOUNTNAME: {
            ATTESTATIONS: {
                id: "Account_REFERENCED_ACCOUNTNAME.ATTESTATIONS",
                defaultMessage: "Referenced Account Name"
            }
        },
        Account_ACCOUNTCLASS: {
            ATTESTATIONS: {
                id: "Account_ACCOUNTCLASS.ATTESTATIONS",
                defaultMessage: "Account Classification"
            }
        },
        Account_USERGROUP: {
            ATTESTATIONS: {
                id: "Account_USERGROUP.ATTESTATIONS",
                defaultMessage: "Account User Group"
            }
        },
        User_ACCOUNT_CERT_ACCOUNTKEY: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CERT_ACCOUNTKEY.ATTESTATIONS",
                defaultMessage: "Account Certification Account Key"
            }
        },
        User_ACCOUNT_ACCOUNTKEY: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_ACCOUNTKEY.ATTESTATIONS",
                defaultMessage: "Account Key"
            }
        },
        User_ACCOUNT_NAME: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_NAME.ATTESTATIONS",
                defaultMessage: "Account Name"
            }
        },
        User_ACCOUNT_REFERENCED_ACCOUNTKEY: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_REFERENCED_ACCOUNTKEY.ATTESTATIONS",
                defaultMessage: "Referenced Account"
            }
        },
        User_ACCOUNT_DESCRIPTION: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_DESCRIPTION.ATTESTATIONS",
                defaultMessage: "Account Description"
            }
        },
        User_ACCOUNT_COMMENTS: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_COMMENTS.ATTESTATIONS",
                defaultMessage: "Account Comments"
            }
        },
        User_ACCOUNT_ACCOUNTTYPE: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_ACCOUNTTYPE.ATTESTATIONS",
                defaultMessage: "Account Type"
            }
        },
        User_ACCOUNT_STATUS: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_STATUS.ATTESTATIONS",
                defaultMessage: "Account Status"
            }
        },
        User_ACCOUNT_VALIDFROM: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_VALIDFROM.ATTESTATIONS",
                defaultMessage: "Account Valid From"
            }
        },
        User_ACCOUNT_VALIDTHROUGH: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_VALIDTHROUGH.ATTESTATIONS",
                defaultMessage: "Account Valid Through"
            }
        },
        User_ACCOUNT_USERLOCK: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_USERLOCK.ATTESTATIONS",
                defaultMessage: "Account User Lock"
            }
        },
        User_ACCOUNT_CREATOR: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CREATOR.ATTESTATIONS",
                defaultMessage: "Account Created By"
            }
        },
        User_ACCOUNT_CREATED_ON: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CREATED_ON.ATTESTATIONS",
                defaultMessage: "Account Created On"
            }
        },
        User_ACCOUNT_LASTLOGONDATE: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_LASTLOGONDATE.ATTESTATIONS",
                defaultMessage: "Account Last Login Date"
            }
        },
        User_ACCOUNT_ORPHAN: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_ORPHAN.ATTESTATIONS",
                defaultMessage: "Account Orphan"
            }
        },
        User_ACCOUNT_JOBID: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_JOBID.ATTESTATIONS",
                defaultMessage: "Account Job ID"
            }
        },
        User_ACCOUNT_PRIVILEGED: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_PRIVILEGED.ATTESTATIONS",
                defaultMessage: "Account Privileged"
            }
        },
        User_ACCOUNT_ENDPOINTKEY: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_ENDPOINTKEY.ATTESTATIONS",
                defaultMessage: "Account Endpoint"
            }
        },
        User_ACCOUNT_SYSTEMID: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_SYSTEMID.ATTESTATIONS",
                defaultMessage: "Account System"
            }
        },
        User_ACCOUNT_INCORRECTLOGONS: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_INCORRECTLOGONS.ATTESTATIONS",
                defaultMessage: "Account Incorrect Logins"
            }
        },
        User_ACCOUNT_LASTPASSWORDCHANGE: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_LASTPASSWORDCHANGE.ATTESTATIONS",
                defaultMessage: "Account Last Password Change"
            }
        },
        User_ACCOUNT_PASSWORDLOCKDATE: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_PASSWORDLOCKDATE.ATTESTATIONS",
                defaultMessage: "Account Password Locked Date"
            }
        },
        User_ACCOUNT_PASSWORDCHANGESTATUS: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_PASSWORDCHANGESTATUS.ATTESTATIONS",
                defaultMessage: "Account Password Change Status"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY1: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY1.ATTESTATIONS",
                defaultMessage: "Account Custom Property 1"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY2: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY2.ATTESTATIONS",
                defaultMessage: "Account Custom Property 2"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY3: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY3.ATTESTATIONS",
                defaultMessage: "Account Custom Property 3"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY4: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY4.ATTESTATIONS",
                defaultMessage: "Account Custom Property 4"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY5: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY5.ATTESTATIONS",
                defaultMessage: "Account Custom Property 5"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY6: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY6.ATTESTATIONS",
                defaultMessage: "Account Custom Property 6"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY7: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY7.ATTESTATIONS",
                defaultMessage: "Account Custom Property 7"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY8: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY8.ATTESTATIONS",
                defaultMessage: "Account Custom Property 8"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY9: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY9.ATTESTATIONS",
                defaultMessage: "Account Custom Property 9"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY10: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY10.ATTESTATIONS",
                defaultMessage: "Account Custom Property 10"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY11: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY11.ATTESTATIONS",
                defaultMessage: "Account Custom Property 11"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY12: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY12.ATTESTATIONS",
                defaultMessage: "Account Custom Property 12"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY13: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY13.ATTESTATIONS",
                defaultMessage: "Account Custom Property 13"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY14: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY14.ATTESTATIONS",
                defaultMessage: "Account Custom Property 14"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY15: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY15.ATTESTATIONS",
                defaultMessage: "Account Custom Property 15"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY16: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY16.ATTESTATIONS",
                defaultMessage: "Account Custom Property 16"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY17: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY17.ATTESTATIONS",
                defaultMessage: "Account Custom Property 17"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY18: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY18.ATTESTATIONS",
                defaultMessage: "Account Custom Property 18"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY19: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY19.ATTESTATIONS",
                defaultMessage: "Account Custom Property 19"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY20: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY20.ATTESTATIONS",
                defaultMessage: "Account Custom Property 20"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY21: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY21.ATTESTATIONS",
                defaultMessage: "Account Custom Property 21"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY22: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY22.ATTESTATIONS",
                defaultMessage: "Account Custom Property 22"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY23: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY23.ATTESTATIONS",
                defaultMessage: "Account Custom Property 23"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY24: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY24.ATTESTATIONS",
                defaultMessage: "Account Custom Property 24"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY25: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY25.ATTESTATIONS",
                defaultMessage: "Account Custom Property 25"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY26: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY26.ATTESTATIONS",
                defaultMessage: "Account Custom Property 26"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY27: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY27.ATTESTATIONS",
                defaultMessage: "Account Custom Property 27"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY28: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY28.ATTESTATIONS",
                defaultMessage: "Account Custom Property 28"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY29: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY29.ATTESTATIONS",
                defaultMessage: "Account Custom Property 29"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY30: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY30.ATTESTATIONS",
                defaultMessage: "Account Custom Property 30"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY31: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY31.ATTESTATIONS",
                defaultMessage: "Account Custom Property 31"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY32: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY32.ATTESTATIONS",
                defaultMessage: "Account Custom Property 32"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY33: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY33.ATTESTATIONS",
                defaultMessage: "Account Custom Property 33"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY34: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY34.ATTESTATIONS",
                defaultMessage: "Account Custom Property 34"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY35: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY35.ATTESTATIONS",
                defaultMessage: "Account Custom Property 35"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY36: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY36.ATTESTATIONS",
                defaultMessage: "Account Custom Property 36"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY37: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY37.ATTESTATIONS",
                defaultMessage: "Account Custom Property 37"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY38: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY38.ATTESTATIONS",
                defaultMessage: "Account Custom Property 38"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY39: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY39.ATTESTATIONS",
                defaultMessage: "Account Custom Property 39"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY40: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY40.ATTESTATIONS",
                defaultMessage: "Account Custom Property 40"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY41: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY41.ATTESTATIONS",
                defaultMessage: "Account Custom Property 41"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY42: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY42.ATTESTATIONS",
                defaultMessage: "Account Custom Property 42"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY43: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY43.ATTESTATIONS",
                defaultMessage: "Account Custom Property 43"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY44: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY44.ATTESTATIONS",
                defaultMessage: "Account Custom Property 44"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY45: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY45.ATTESTATIONS",
                defaultMessage: "Account Custom Property 45"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY46: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY46.ATTESTATIONS",
                defaultMessage: "Account Custom Property 46"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY47: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY47.ATTESTATIONS",
                defaultMessage: "Account Custom Property 47"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY48: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY48.ATTESTATIONS",
                defaultMessage: "Account Custom Property 48"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY49: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY49.ATTESTATIONS",
                defaultMessage: "Account Custom Property 49"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY50: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY50.ATTESTATIONS",
                defaultMessage: "Account Custom Property 50"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY51: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY51.ATTESTATIONS",
                defaultMessage: "Account Custom Property 51"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY52: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY52.ATTESTATIONS",
                defaultMessage: "Account Custom Property 52"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY53: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY53.ATTESTATIONS",
                defaultMessage: "Account Custom Property 53"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY54: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY54.ATTESTATIONS",
                defaultMessage: "Account Custom Property 54"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY55: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY55.ATTESTATIONS",
                defaultMessage: "Account Custom Property 55"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY56: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY56.ATTESTATIONS",
                defaultMessage: "Account Custom Property 56"
            }
        },
        User_ACCOUNT_ACCOUNTSTATUS: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_ACCOUNTSTATUS.ATTESTATIONS",
                defaultMessage: "Account Status"
            }
        },
        User_ACCOUNT_CREATEDON: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CREATEDON.ATTESTATIONS",
                defaultMessage: "Account Created On"
            }
        },
        User_ACCOUNT_OLDOWNER: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_OLDOWNER.ATTESTATIONS",
                defaultMessage: "Account Old Owner"
            }
        },
        User_ACCOUNT_NEWOWNER: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_NEWOWNER.ATTESTATIONS",
                defaultMessage: "Account New Owner"
            }
        },
        User_ACCOUNT_UPDATEDATE: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_UPDATEDATE.ATTESTATIONS",
                defaultMessage: "Account Update Date"
            }
        },
        User_ACCOUNT_ACCOUNTID: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_ACCOUNTID.ATTESTATIONS",
                defaultMessage: "Account ID"
            }
        },
        User_ACCOUNT_DISPLAYNAME: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_DISPLAYNAME.ATTESTATIONS",
                defaultMessage: "Account Display Name"
            }
        },
        User_ACCOUNT_REFERENCED_ACCOUNTNAME: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_REFERENCED_ACCOUNTNAME.ATTESTATIONS",
                defaultMessage: "Referenced Account Name"
            }
        },
        User_ACCOUNT_ACCOUNTCLASS: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_ACCOUNTCLASS.ATTESTATIONS",
                defaultMessage: "Account Classification"
            }
        },
        User_ACCOUNT_USERGROUP: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_USERGROUP.ATTESTATIONS",
                defaultMessage: "Account User Group"
            }
        },
        Ent_CERT_ENTITLEMENT_VALUEKEY: {
            ATTESTATIONS: {
                id: "Ent_CERT_ENTITLEMENT_VALUEKEY.ATTESTATIONS",
                defaultMessage: "Certification Entitlement Value Key"
            }
        },
        Ent_ENTITLEMENT_VALUEKEY: {
            ATTESTATIONS: {
                id: "Ent_ENTITLEMENT_VALUEKEY.ATTESTATIONS",
                defaultMessage: "Entitlement Value Key"
            }
        },
        Ent_ENTITLEMENT_VALUE: {
            ATTESTATIONS: {
                id: "Ent_ENTITLEMENT_VALUE.ATTESTATIONS",
                defaultMessage: "Entitlement Value"
            }
        },
        Ent_ENTITLEMENTTYPEKEY: {
            ATTESTATIONS: {
                id: "Ent_ENTITLEMENTTYPEKEY.ATTESTATIONS",
                defaultMessage: "Entitlement Type Key"
            }
        },
        Ent_CUSTOMPROPERTY1: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY1.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 1"
            }
        },
        Ent_CUSTOMPROPERTY2: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY2.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 2"
            }
        },
        Ent_CUSTOMPROPERTY3: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY3.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 3"
            }
        },
        Ent_CUSTOMPROPERTY4: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY4.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 4"
            }
        },
        Ent_CUSTOMPROPERTY5: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY5.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 5"
            }
        },
        Ent_CUSTOMPROPERTY6: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY6.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 6"
            }
        },
        Ent_CUSTOMPROPERTY7: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY7.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 7"
            }
        },
        Ent_CUSTOMPROPERTY8: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY8.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 8"
            }
        },
        Ent_CUSTOMPROPERTY9: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY9.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 9"
            }
        },
        Ent_CUSTOMPROPERTY10: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY10.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 10"
            }
        },
        Ent_CUSTOMPROPERTY11: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY11.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 11"
            }
        },
        Ent_CUSTOMPROPERTY12: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY12.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 12"
            }
        },
        Ent_CUSTOMPROPERTY13: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY13.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 13"
            }
        },
        Ent_CUSTOMPROPERTY14: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY14.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 14"
            }
        },
        Ent_CUSTOMPROPERTY15: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY15.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 15"
            }
        },
        Ent_CUSTOMPROPERTY16: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY16.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 16"
            }
        },
        Ent_CUSTOMPROPERTY17: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY17.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 17"
            }
        },
        Ent_CUSTOMPROPERTY18: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY18.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 18"
            }
        },
        Ent_CUSTOMPROPERTY19: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY19.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 19"
            }
        },
        Ent_CUSTOMPROPERTY20: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY20.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 20"
            }
        },
        Ent_CUSTOMPROPERTY21: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY21.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 21"
            }
        },
        Ent_CUSTOMPROPERTY22: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY22.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 22"
            }
        },
        Ent_CUSTOMPROPERTY23: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY23.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 23"
            }
        },
        Ent_CUSTOMPROPERTY24: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY24.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 24"
            }
        },
        Ent_CUSTOMPROPERTY25: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY25.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 25"
            }
        },
        Ent_CUSTOMPROPERTY26: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY26.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 26"
            }
        },
        Ent_CUSTOMPROPERTY27: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY27.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 27"
            }
        },
        Ent_CUSTOMPROPERTY28: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY28.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 28"
            }
        },
        Ent_CUSTOMPROPERTY29: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY29.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 29"
            }
        },
        Ent_CUSTOMPROPERTY30: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY30.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 30"
            }
        },
        Ent_CUSTOMPROPERTY31: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY31.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 31"
            }
        },
        Ent_CUSTOMPROPERTY32: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY32.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 32"
            }
        },
        Ent_CUSTOMPROPERTY33: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY33.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 33"
            }
        },
        Ent_CUSTOMPROPERTY34: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY34.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 34"
            }
        },
        Ent_CUSTOMPROPERTY35: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY35.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 35"
            }
        },
        Ent_CUSTOMPROPERTY36: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY36.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 36"
            }
        },
        Ent_CUSTOMPROPERTY37: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY37.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 37"
            }
        },
        Ent_CUSTOMPROPERTY38: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY38.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 38"
            }
        },
        Ent_CUSTOMPROPERTY39: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY39.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 39"
            }
        },
        Ent_CUSTOMPROPERTY40: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY40.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 40"
            }
        },
        Ent_DESCRIPTION: {
            ATTESTATIONS: {
                id: "Ent_DESCRIPTION.ATTESTATIONS",
                defaultMessage: "Entitlement Description"
            }
        },
        Ent_ENTITLEMENT_GLOSSARY: {
            ATTESTATIONS: {
                id: "Ent_ENTITLEMENT_GLOSSARY.ATTESTATIONS",
                defaultMessage: "Entitlement Glossary"
            }
        },
        Ent_STATUS: {
            ATTESTATIONS: {
                id: "Ent_STATUS.ATTESTATIONS",
                defaultMessage: "Entitlement Status"
            }
        },
        Ent_UPDATEUSER: {
            ATTESTATIONS: {
                id: "Ent_UPDATEUSER.ATTESTATIONS",
                defaultMessage: "Entitlement Update User"
            }
        },
        Ent_RISK: {
            ATTESTATIONS: {
                id: "Ent_RISK.ATTESTATIONS",
                defaultMessage: "Entitlement Risk"
            }
        },
        Ent_SOX_CRITICAL: {
            ATTESTATIONS: {
                id: "Ent_SOX_CRITICAL.ATTESTATIONS",
                defaultMessage: "Entitlement SOX Critical"
            }
        },
        Ent_SYS_CRITICAL: {
            ATTESTATIONS: {
                id: "Ent_SYS_CRITICAL.ATTESTATIONS",
                defaultMessage: "Entitlement Sys Critical"
            }
        },
        Ent_ORPHAN: {
            ATTESTATIONS: {
                id: "Ent_ORPHAN.ATTESTATIONS",
                defaultMessage: "Entitlement Orphan"
            }
        },
        Ent_UPDATEDATE: {
            ATTESTATIONS: {
                id: "Ent_UPDATEDATE.ATTESTATIONS",
                defaultMessage: "Entitlement Update Date"
            }
        },
        Ent_SAVLEVEL: {
            ATTESTATIONS: {
                id: "Ent_SAVLEVEL.ATTESTATIONS",
                defaultMessage: "Entitlement SAV Level"
            }
        },
        Ent_LEVEL: {
            ATTESTATIONS: {
                id: "Ent_LEVEL.ATTESTATIONS",
                defaultMessage: "Entitlement SAV Level"
            }
        },
        Ent_PRIVILEGED: {
            ATTESTATIONS: {
                id: "Ent_PRIVILEGED.ATTESTATIONS",
                defaultMessage: "Entitlement Privileged"
            }
        },
        Ent_CONFIDENTIALITY: {
            ATTESTATIONS: {
                id: "Ent_CONFIDENTIALITY.ATTESTATIONS",
                defaultMessage: "Entitlement Confidentiality"
            }
        },
        Ent_SOD: {
            ATTESTATIONS: {
                id: "Ent_SOD.ATTESTATIONS",
                defaultMessage: "Entitlement SOD"
            }
        },
        Ent_DISPLAYNAME: {
            ATTESTATIONS: {
                id: "Ent_DISPLAYNAME.ATTESTATIONS",
                defaultMessage: "Entitlement"
            }
        },
        Ent_ENTITLEMENTID: {
            ATTESTATIONS: {
                id: "Ent_ENTITLEMENTID.ATTESTATIONS",
                defaultMessage: "Entitlement ID"
            }
        },
        Ent_PROGRAM: {
            ATTESTATIONS: {
                id: "Ent_PROGRAM.ATTESTATIONS",
                defaultMessage: "Entitlement Program"
            }
        },
        Ent_MODULE: {
            ATTESTATIONS: {
                id: "Ent_MODULE.ATTESTATIONS",
                defaultMessage: "Entitlement Module"
            }
        },
        Ent_ACCESS: {
            ATTESTATIONS: {
                id: "Ent_ACCESS.ATTESTATIONS",
                defaultMessage: "Entitlement Access"
            }
        },
        Ent_SCHEMANAME: {
            ATTESTATIONS: {
                id: "Ent_SCHEMANAME.ATTESTATIONS",
                defaultMessage: "Entitlement Schema Name"
            }
        },
        Ent_ENTCLASS: {
            ATTESTATIONS: {
                id: "Ent_ENTCLASS.ATTESTATIONS",
                defaultMessage: "Entitlement Classification"
            }
        },
        Ent_LASTSCANDATE: {
            ATTESTATIONS: {
                id: "Ent_LASTSCANDATE.ATTESTATIONS",
                defaultMessage: "Entitlement Last Scan Date"
            }
        },
        Ent_ENTITLEMGLOSSARY: {
            ATTESTATIONS: {
                id: "Ent_ENTITLEMGLOSSARY.ATTESTATIONS",
                defaultMessage: "Entitlement Glossary"
            }
        },
        Ent_JOBID: {
            ATTESTATIONS: {
                id: "Ent_JOBID.ATTESTATIONS",
                defaultMessage: "Entitlement Job ID"
            }
        },
        Ent_SAVACCESS: {
            ATTESTATIONS: {
                id: "Ent_SAVACCESS.ATTESTATIONS",
                defaultMessage: "Entitlement Sav Access"
            }
        },
        User_CERT_USERKEY: {
            ATTESTATIONS: {
                id: "User_CERT_USERKEY.ATTESTATIONS",
                defaultMessage: "Certification User Key"
            }
        },
        User_DISPLAYNAME: {
            ATTESTATIONS: {
                id: "User_DISPLAYNAME.ATTESTATIONS",
                defaultMessage: "User"
            }
        },
        User_USERKEY: {
            ATTESTATIONS: {
                id: "User_USERKEY.ATTESTATIONS",
                defaultMessage: "User Key"
            }
        },
        User_USERNAME: {
            ATTESTATIONS: {
                id: "User_USERNAME.ATTESTATIONS",
                defaultMessage: "Username"
            }
        },
        User_TERMDATE: {
            ATTESTATIONS: {
                id: "User_TERMDATE.ATTESTATIONS",
                defaultMessage: "User Term Date"
            }
        },
        User_FIRSTNAME: {
            ATTESTATIONS: {
                id: "User_FIRSTNAME.ATTESTATIONS",
                defaultMessage: "User First Name"
            }
        },
        User_TOTALACCOUNTS: {
            ATTESTATIONS: {
                id: "User_TOTALACCOUNTS.ATTESTATIONS",
                defaultMessage: "Total Accounts"
            }
        },
        User_AUDITTRAIL: {
            ATTESTATIONS: {
                id: "User_AUDITTRAIL.ATTESTATIONS",
                defaultMessage: "History"
            }
        },
        User_UPDATEUSER: {
            ATTESTATIONS: {
                id: "User_UPDATEUSER.ATTESTATIONS",
                defaultMessage: "Update User"
            }
        },
        User_CERTIFIED: {
            ATTESTATIONS: {
                id: "User_CERTIFIED.ATTESTATIONS",
                defaultMessage: "Status"
            }
        },
        User_LASTNAME: {
            ATTESTATIONS: {
                id: "User_LASTNAME.ATTESTATIONS",
                defaultMessage: "User Last Name"
            }
        },
        User_MIDDLENAME: {
            ATTESTATIONS: {
                id: "User_MIDDLENAME.ATTESTATIONS",
                defaultMessage: "User Middle Name"
            }
        },
        User_STREET: {
            ATTESTATIONS: {
                id: "User_STREET.ATTESTATIONS",
                defaultMessage: "User Street"
            }
        },
        User_CITY: {
            ATTESTATIONS: {
                id: "User_CITY.ATTESTATIONS",
                defaultMessage: "User City"
            }
        },
        User_EMAIL: {
            ATTESTATIONS: {
                id: "User_EMAIL.ATTESTATIONS",
                defaultMessage: "User Email"
            }
        },
        User_COMMENTS: {
            ATTESTATIONS: {
                id: "User_COMMENTS.ATTESTATIONS",
                defaultMessage: "User Comments"
            }
        },
        User_STATUSKEY: {
            ATTESTATIONS: {
                id: "User_STATUSKEY.ATTESTATIONS",
                defaultMessage: "User Status"
            }
        },
        User_STARTDATE: {
            ATTESTATIONS: {
                id: "User_STARTDATE.ATTESTATIONS",
                defaultMessage: "User Start Date"
            }
        },
        User_ENDDATE: {
            ATTESTATIONS: {
                id: "User_ENDDATE.ATTESTATIONS",
                defaultMessage: "User End Date"
            }
        },
        User_MANAGER: {
            ATTESTATIONS: {
                id: "User_MANAGER.ATTESTATIONS",
                defaultMessage: "User Manager"
            }
        },
        User_PASSWORD: {
            ATTESTATIONS: {
                id: "User_PASSWORD.ATTESTATIONS",
                defaultMessage: "User Password"
            }
        },
        User_ENABLED: {
            ATTESTATIONS: {
                id: "User_ENABLED.ATTESTATIONS",
                defaultMessage: "User Enabled"
            }
        },
        User_LOCATION: {
            ATTESTATIONS: {
                id: "User_LOCATION.ATTESTATIONS",
                defaultMessage: "User Location"
            }
        },
        User_JOBCODE: {
            ATTESTATIONS: {
                id: "User_JOBCODE.ATTESTATIONS",
                defaultMessage: "User Job Code"
            }
        },
        User_JOBDESCRIPTION: {
            ATTESTATIONS: {
                id: "User_JOBDESCRIPTION.ATTESTATIONS",
                defaultMessage: "User Job Description"
            }
        },
        User_EMPLOYEETYPE: {
            ATTESTATIONS: {
                id: "User_EMPLOYEETYPE.ATTESTATIONS",
                defaultMessage: "User Employee Type"
            }
        },
        User_SYSTEMUSERNAME: {
            ATTESTATIONS: {
                id: "User_SYSTEMUSERNAME.ATTESTATIONS",
                defaultMessage: "User System Username"
            }
        },
        User_DEPARTMENTNUMBER: {
            ATTESTATIONS: {
                id: "User_DEPARTMENTNUMBER.ATTESTATIONS",
                defaultMessage: "User Department Number"
            }
        },
        User_TITLE: {
            ATTESTATIONS: {
                id: "User_TITLE.ATTESTATIONS",
                defaultMessage: "User Title"
            }
        },
        User_STATE: {
            ATTESTATIONS: {
                id: "User_STATE.ATTESTATIONS",
                defaultMessage: "User State"
            }
        },
        User_COMPANYNAME: {
            ATTESTATIONS: {
                id: "User_COMPANYNAME.ATTESTATIONS",
                defaultMessage: "User Company Name"
            }
        },
        User_COSTCENTER: {
            ATTESTATIONS: {
                id: "User_COSTCENTER.ATTESTATIONS",
                defaultMessage: "User Cost Centre"
            }
        },
        User_DEPARTMENTNAME: {
            ATTESTATIONS: {
                id: "User_DEPARTMENTNAME.ATTESTATIONS",
                defaultMessage: "User Department Name"
            }
        },
        User_EMPLOYEECLASS: {
            ATTESTATIONS: {
                id: "User_EMPLOYEECLASS.ATTESTATIONS",
                defaultMessage: "User Employee Class"
            }
        },
        User_ENTITY: {
            ATTESTATIONS: {
                id: "User_ENTITY.ATTESTATIONS",
                defaultMessage: "User Entity"
            }
        },
        User_JOBCODEDESC: {
            ATTESTATIONS: {
                id: "User_JOBCODEDESC.ATTESTATIONS",
                defaultMessage: "User Job Code Description"
            }
        },
        User_LOCATIONDESC: {
            ATTESTATIONS: {
                id: "User_LOCATIONDESC.ATTESTATIONS",
                defaultMessage: "User Location Description"
            }
        },
        User_LOCATIONNUMBER: {
            ATTESTATIONS: {
                id: "User_LOCATIONNUMBER.ATTESTATIONS",
                defaultMessage: "User Location Number"
            }
        },
        User_SITEID: {
            ATTESTATIONS: {
                id: "User_SITEID.ATTESTATIONS",
                defaultMessage: "User Site"
            }
        },
        User_ORGUNITID: {
            ATTESTATIONS: {
                id: "User_ORGUNITID.ATTESTATIONS",
                defaultMessage: "User Organization Unit"
            }
        },
        User_REGION: {
            ATTESTATIONS: {
                id: "User_REGION.ATTESTATIONS",
                defaultMessage: "User Region"
            }
        },
        User_REGIONCODE: {
            ATTESTATIONS: {
                id: "User_REGIONCODE.ATTESTATIONS",
                defaultMessage: "User Region Code"
            }
        },
        User_OWNER: {
            ATTESTATIONS: {
                id: "User_OWNER.ATTESTATIONS",
                defaultMessage: "User Owner"
            }
        },
        User_EMPLOYEEID: {
            ATTESTATIONS: {
                id: "User_EMPLOYEEID.ATTESTATIONS",
                defaultMessage: "User Employee"
            }
        },
        User_LASTSYNCDATE: {
            ATTESTATIONS: {
                id: "User_LASTSYNCDATE.ATTESTATIONS",
                defaultMessage: "User Last Sync Date"
            }
        },
        User_PHONENUMBER: {
            ATTESTATIONS: {
                id: "User_PHONENUMBER.ATTESTATIONS",
                defaultMessage: "User Phone Number"
            }
        },
        User_COUNTRY: {
            ATTESTATIONS: {
                id: "User_COUNTRY.ATTESTATIONS",
                defaultMessage: "User Country"
            }
        },
        User_ACCOUNTEXPIRED: {
            ATTESTATIONS: {
                id: "User_ACCOUNTEXPIRED.ATTESTATIONS",
                defaultMessage: "User Account Expired"
            }
        },
        User_ACCOUNTLOCKED: {
            ATTESTATIONS: {
                id: "User_ACCOUNTLOCKED.ATTESTATIONS",
                defaultMessage: "User Account Locked"
            }
        },
        User_PASSWORDEXPIRED: {
            ATTESTATIONS: {
                id: "User_PASSWORDEXPIRED.ATTESTATIONS",
                defaultMessage: "User Password Expired"
            }
        },
        User_JOB_FUNCTION: {
            ATTESTATIONS: {
                id: "User_JOB_FUNCTION.ATTESTATIONS",
                defaultMessage: "User Job Function"
            }
        },
        User_DONOTDISTURBDELEGATE: {
            ATTESTATIONS: {
                id: "User_DONOTDISTURBDELEGATE.ATTESTATIONS",
                defaultMessage: "User Do Not Disturb Delegate"
            }
        },
        User_CUSTOMPROPERTY1: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY1.ATTESTATIONS",
                defaultMessage: "User Custom Property 1"
            }
        },
        User_CUSTOMPROPERTY2: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY2.ATTESTATIONS",
                defaultMessage: "User Custom Property 2"
            }
        },
        User_CUSTOMPROPERTY3: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY3.ATTESTATIONS",
                defaultMessage: "User Custom Property 3"
            }
        },
        User_CUSTOMPROPERTY4: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY4.ATTESTATIONS",
                defaultMessage: "User Custom Property 4"
            }
        },
        User_CUSTOMPROPERTY5: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY5.ATTESTATIONS",
                defaultMessage: "User Custom Property 5"
            }
        },
        User_CUSTOMPROPERTY6: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY6.ATTESTATIONS",
                defaultMessage: "User Custom Property 6"
            }
        },
        User_CUSTOMPROPERTY7: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY7.ATTESTATIONS",
                defaultMessage: "User Custom Property 7"
            }
        },
        User_CUSTOMPROPERTY8: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY8.ATTESTATIONS",
                defaultMessage: "User Custom Property 8"
            }
        },
        User_CUSTOMPROPERTY9: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY9.ATTESTATIONS",
                defaultMessage: "User Custom Property 9"
            }
        },
        User_CUSTOMPROPERTY10: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY10.ATTESTATIONS",
                defaultMessage: "User Custom Property 10"
            }
        },
        User_CUSTOMPROPERTY11: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY11.ATTESTATIONS",
                defaultMessage: "User Custom Property 11"
            }
        },
        User_CUSTOMPROPERTY12: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY12.ATTESTATIONS",
                defaultMessage: "User Custom Property 12"
            }
        },
        User_CUSTOMPROPERTY13: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY13.ATTESTATIONS",
                defaultMessage: "User Custom Property 13"
            }
        },
        User_CUSTOMPROPERTY14: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY14.ATTESTATIONS",
                defaultMessage: "User Custom Property 14"
            }
        },
        User_CUSTOMPROPERTY15: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY15.ATTESTATIONS",
                defaultMessage: "User Custom Property 15"
            }
        },
        User_CUSTOMPROPERTY16: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY16.ATTESTATIONS",
                defaultMessage: "User Custom Property 16"
            }
        },
        User_CUSTOMPROPERTY17: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY17.ATTESTATIONS",
                defaultMessage: "User Custom Property 17"
            }
        },
        User_CUSTOMPROPERTY18: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY18.ATTESTATIONS",
                defaultMessage: "User Custom Property 18"
            }
        },
        User_CUSTOMPROPERTY19: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY19.ATTESTATIONS",
                defaultMessage: "User Custom Property 19"
            }
        },
        User_CUSTOMPROPERTY20: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY20.ATTESTATIONS",
                defaultMessage: "User Custom Property 20"
            }
        },
        User_CUSTOMPROPERTY21: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY21.ATTESTATIONS",
                defaultMessage: "User Custom Property 21"
            }
        },
        User_CUSTOMPROPERTY22: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY22.ATTESTATIONS",
                defaultMessage: "User Custom Property 22"
            }
        },
        User_CUSTOMPROPERTY23: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY23.ATTESTATIONS",
                defaultMessage: "User Custom Property 23"
            }
        },
        User_CUSTOMPROPERTY24: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY24.ATTESTATIONS",
                defaultMessage: "User Custom Property 24"
            }
        },
        User_CUSTOMPROPERTY25: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY25.ATTESTATIONS",
                defaultMessage: "User Custom Property 25"
            }
        },
        User_CUSTOMPROPERTY26: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY26.ATTESTATIONS",
                defaultMessage: "User Custom Property 26"
            }
        },
        User_CUSTOMPROPERTY27: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY27.ATTESTATIONS",
                defaultMessage: "User Custom Property 27"
            }
        },
        User_CUSTOMPROPERTY28: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY28.ATTESTATIONS",
                defaultMessage: "User Custom Property 28"
            }
        },
        User_CUSTOMPROPERTY29: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY29.ATTESTATIONS",
                defaultMessage: "User Custom Property 29"
            }
        },
        User_CUSTOMPROPERTY30: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY30.ATTESTATIONS",
                defaultMessage: "User Custom Property 30"
            }
        },
        User_CUSTOMPROPERTY31: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY31.ATTESTATIONS",
                defaultMessage: "User Custom Property 31"
            }
        },
        User_CUSTOMPROPERTY32: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY32.ATTESTATIONS",
                defaultMessage: "User Custom Property 32"
            }
        },
        User_CUSTOMPROPERTY33: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY33.ATTESTATIONS",
                defaultMessage: "User Custom Property 33"
            }
        },
        User_CUSTOMPROPERTY34: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY34.ATTESTATIONS",
                defaultMessage: "User Custom Property 34"
            }
        },
        User_CUSTOMPROPERTY35: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY35.ATTESTATIONS",
                defaultMessage: "User Custom Property 35"
            }
        },
        User_CUSTOMPROPERTY36: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY36.ATTESTATIONS",
                defaultMessage: "User Custom Property 36"
            }
        },
        User_CUSTOMPROPERTY37: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY37.ATTESTATIONS",
                defaultMessage: "User Custom Property 37"
            }
        },
        User_CUSTOMPROPERTY38: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY38.ATTESTATIONS",
                defaultMessage: "User Custom Property 38"
            }
        },
        User_CUSTOMPROPERTY39: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY39.ATTESTATIONS",
                defaultMessage: "User Custom Property 39"
            }
        },
        User_CUSTOMPROPERTY40: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY40.ATTESTATIONS",
                defaultMessage: "User Custom Property 40"
            }
        },
        User_RISKSCORE: {
            ATTESTATIONS: {
                id: "User_RISKSCORE.ATTESTATIONS",
                defaultMessage: "User Risk Score"
            }
        },
        User_EXTENDEDENDDATE: {
            ATTESTATIONS: {
                id: "User_EXTENDEDENDDATE.ATTESTATIONS",
                defaultMessage: "User Extended Date"
            }
        },
        User_LASTCERTIFIEDCAMPAIGNNAME: {
            ATTESTATIONS: {
                id: "User_LASTCERTIFIEDCAMPAIGNNAME.ATTESTATIONS",
                defaultMessage: "Last Certified Campaign"
            }
        },
        User_LASTCERTIFIEDDATE: {
            ATTESTATIONS: {
                id: "User_LASTCERTIFIEDDATE.ATTESTATIONS",
                defaultMessage: "Last Certified Date"
            }
        },
        User_LASTCERTIFIEDUSER: {
            ATTESTATIONS: {
                id: "User_LASTCERTIFIEDUSER.ATTESTATIONS",
                defaultMessage: "Last Certified User"
            }
        },
        ACCDESCRIPTION: {
            ATTESTATIONS: {
                id: "ACCDESCRIPTION.ATTESTATIONS",
                defaultMessage: "Account Description"
            }
        },
        ENTDESCRIPTION: {
            ATTESTATIONS: {
                id: "ENTDESCRIPTION.ATTESTATIONS",
                defaultMessage: "Entitlement Description"
            }
        },
        LASTCERTIFIEDUSER: {
            ATTESTATIONS: {
                id: "LASTCERTIFIEDUSER.ATTESTATIONS",
                defaultMessage: "Last Certified User"
            }
        },
        name: {
            ATTESTATIONS: {
                id: "name.ATTESTATIONS",
                defaultMessage: "Account Name"
            }
        },
        displayName: {
            ATTESTATIONS: {
                id: "displayName.ATTESTATIONS",
                defaultMessage: "DisplayName"
            }
        },
        comments: {
            ATTESTATIONS: {
                id: "comments.ATTESTATIONS",
                defaultMessage: "Comments"
            }
        },
        securitysystem: {
            ATTESTATIONS: {
                id: "securitysystem.ATTESTATIONS",
                defaultMessage: "Security System"
            }
        },
        auditTrail: {
            ATTESTATIONS: {
                id: "auditTrail.ATTESTATIONS",
                defaultMessage: "History"
            }
        },
        endpoints: {
            ATTESTATIONS: {
                id: "endpoints.ATTESTATIONS",
                defaultMessage: "Endpoints"
            }
        },
        description: {
            ATTESTATIONS: {
                id: "description.ATTESTATIONS",
                defaultMessage: "Description"
            }
        },
        enddate: {
            ATTESTATIONS: {
                id: "enddate.ATTESTATIONS",
                defaultMessage: "End Date"
            }
        },
        status: {
            ATTESTATIONS: {
                id: "status.ATTESTATIONS",
                defaultMessage: "Status"
            }
        },
        TASKID: {
            ATTESTATIONS: {
                id: "TASKID.ATTESTATIONS",
                defaultMessage: "Task Id"
            }
        },
        not_consulted: {
            ATTESTATIONS: {
                id: "not_consulted.ATTESTATIONS.label",
                defaultMessage: "Not Consulted"
            }
        },
        reassigned: {
            ATTESTATIONS: {
                id: "reassigned.ATTESTATIONS.label",
                defaultMessage: "Reassigned"
            }
        },
        consulted: {
            ATTESTATIONS: {
                id: "consulted..ATTESTATIONS.label",
                defaultMessage: "Consulted"
            }
        },
        IsConsulted: {
            ATTESTATIONS: {
                id: "IsConsulted.ATTESTATIONS",
                defaultMessage: "IsConsulted"
            }
        },
        Ent_NEWENTITLEMENTOWNER: {
            ATTESTATIONS: {
                id: "Ent_NEWENTITLEMENTOWNER.ATTESTATIONS",
                defaultMessage: "New Entitlement Owner"
            }
        },
        Role_RISK: {
            ATTESTATIONS: {
                id: "Role_RISK.ATTESTATIONS",
                defaultMessage: "Risk"
            }
        },
        Role_UPDATEDATE: {
            ATTESTATIONS: {
                id: "Role_UPDATEDATE.ATTESTATIONS",
                defaultMessage: "Role Update Date"
            }
        },
        Role_GLOSSARY: {
            ATTESTATIONS: {
                id: "Role_GLOSSARY.ATTESTATIONS",
                defaultMessage: "Glossary"
            }
        },
        Role_SOXCRITICAL: {
            ATTESTATIONS: {
                id: "Role_SOXCRITICAL.ATTESTATIONS",
                defaultMessage: "SOX Critical"
            }
        },
        Role_SYSCRITICAL: {
            ATTESTATIONS: {
                id: "Role_SYSCRITICAL.ATTESTATIONS",
                defaultMessage: "Sys Critical"
            }
        },
        Role_PRIVILIGED: {
            ATTESTATIONS: {
                id: "Role_PRIVILIGED.ATTESTATIONS",
                defaultMessage: "Privileged"
            }
        },
        Role_CONFIDENTIALITY: {
            ATTESTATIONS: {
                id: "Role_CONFIDENTIALITY.ATTESTATIONS",
                defaultMessage: "Confidentiality"
            }
        },
        Role_DEFAULTTIMEFRAMEHRS: {
            ATTESTATIONS: {
                id: "Role_DEFAULTTIMEFRAMEHRS.ATTESTATIONS",
                defaultMessage: "Default Time Frame"
            }
        },
        Role_REQUESTABLE: {
            ATTESTATIONS: {
                id: "Role_REQUESTABLE.ATTESTATIONS",
                defaultMessage: "Requestable"
            }
        },
        Role_ROLETYPE: {
            ATTESTATIONS: {
                id: "Role_ROLETYPE.ATTESTATIONS",
                defaultMessage: "Role Type"
            }
        },
        Role_ROLESTATE: {
            ATTESTATIONS: {
                id: "Role_ROLESTATE.ATTESTATIONS",
                defaultMessage: "Role State"
            }
        },
        Role_CUSTOMPROPERTY1: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY1.ATTESTATIONS",
                defaultMessage: "Custom Property 1"
            }
        },
        Role_CUSTOMPROPERTY10: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY10.ATTESTATIONS",
                defaultMessage: "Custom Property 10"
            }
        },
        Role_CUSTOMPROPERTY11: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY11.ATTESTATIONS",
                defaultMessage: "Custom Property 11"
            }
        },
        Role_CUSTOMPROPERTY12: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY12.ATTESTATIONS",
                defaultMessage: "Custom Property 12"
            }
        },
        Role_CUSTOMPROPERTY13: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY13.ATTESTATIONS",
                defaultMessage: "Custom Property 13"
            }
        },
        Role_CUSTOMPROPERTY14: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY14.ATTESTATIONS",
                defaultMessage: "Custom Property 14"
            }
        },
        Role_CUSTOMPROPERTY15: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY15.ATTESTATIONS",
                defaultMessage: "Custom Property 15"
            }
        },
        Role_CUSTOMPROPERTY16: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY16.ATTESTATIONS",
                defaultMessage: "Custom Property 16"
            }
        },
        Role_CUSTOMPROPERTY17: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY17.ATTESTATIONS",
                defaultMessage: "Custom Property 17"
            }
        },
        Role_CUSTOMPROPERTY18: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY18.ATTESTATIONS",
                defaultMessage: "Custom Property 18"
            }
        },
        Role_CUSTOMPROPERTY19: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY19.ATTESTATIONS",
                defaultMessage: "Custom Property 19"
            }
        },
        Role_CUSTOMPROPERTY2: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY2.ATTESTATIONS",
                defaultMessage: "Custom Property 2"
            }
        },
        Role_CUSTOMPROPERTY20: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY20.ATTESTATIONS",
                defaultMessage: "Custom Property 20"
            }
        },
        Role_CUSTOMPROPERTY3: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY3.ATTESTATIONS",
                defaultMessage: "Custom Property 3"
            }
        },
        Role_CUSTOMPROPERTY4: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY4.ATTESTATIONS",
                defaultMessage: "Custom Property 4"
            }
        },
        Role_CUSTOMPROPERTY5: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY5.ATTESTATIONS",
                defaultMessage: "Custom Property 5"
            }
        },
        Role_CUSTOMPROPERTY6: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY6.ATTESTATIONS",
                defaultMessage: "Custom Property 6"
            }
        },
        Role_CUSTOMPROPERTY7: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY7.ATTESTATIONS",
                defaultMessage: "Custom Property 7"
            }
        },
        Role_CUSTOMPROPERTY8: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY8.ATTESTATIONS",
                defaultMessage: "Custom Property 8"
            }
        },
        Role_CUSTOMPROPERTY9: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY9.ATTESTATIONS",
                defaultMessage: "Custom Property 9"
            }
        },
        Role_CUSTOMPROPERTY21: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY21.ATTESTATIONS",
                defaultMessage: "Custom Property 21"
            }
        },
        Role_CUSTOMPROPERTY22: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY22.ATTESTATIONS",
                defaultMessage: "Custom Property 22"
            }
        },
        Role_CUSTOMPROPERTY23: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY23.ATTESTATIONS",
                defaultMessage: "Custom Property 23"
            }
        },
        Role_CUSTOMPROPERTY24: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY24.ATTESTATIONS",
                defaultMessage: "Custom Property 24"
            }
        },
        Role_CUSTOMPROPERTY25: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY25.ATTESTATIONS",
                defaultMessage: "Custom Property 25"
            }
        },
        Role_CUSTOMPROPERTY26: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY26.ATTESTATIONS",
                defaultMessage: "Custom Property 26"
            }
        },
        Role_CUSTOMPROPERTY27: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY27.ATTESTATIONS",
                defaultMessage: "Custom Property 27"
            }
        },
        Role_CUSTOMPROPERTY28: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY28.ATTESTATIONS",
                defaultMessage: "Custom Property 28"
            }
        },
        Role_CUSTOMPROPERTY29: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY29.ATTESTATIONS",
                defaultMessage: "Custom Property 29"
            }
        },
        Role_CUSTOMPROPERTY30: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY30.ATTESTATIONS",
                defaultMessage: "Custom Property 30"
            }
        },
        Role_CUSTOMPROPERTY31: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY31.ATTESTATIONS",
                defaultMessage: "Custom Property 31"
            }
        },
        Role_CUSTOMPROPERTY32: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY32.ATTESTATIONS",
                defaultMessage: "Custom Property 32"
            }
        },
        Role_CUSTOMPROPERTY33: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY33.ATTESTATIONS",
                defaultMessage: "Custom Property 33"
            }
        },
        Role_CUSTOMPROPERTY34: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY34.ATTESTATIONS",
                defaultMessage: "Custom Property 34"
            }
        },
        Role_CUSTOMPROPERTY35: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY35.ATTESTATIONS",
                defaultMessage: "Custom Property 35"
            }
        },
        Role_CUSTOMPROPERTY36: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY36.ATTESTATIONS",
                defaultMessage: "Custom Property 36"
            }
        },
        Role_CUSTOMPROPERTY37: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY37.ATTESTATIONS",
                defaultMessage: "Custom Property 37"
            }
        },
        Role_CUSTOMPROPERTY38: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY38.ATTESTATIONS",
                defaultMessage: "Custom Property 38"
            }
        },
        Role_CUSTOMPROPERTY39: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY39.ATTESTATIONS",
                defaultMessage: "Custom Property 39"
            }
        },
        Role_CUSTOMPROPERTY40: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY40.ATTESTATIONS",
                defaultMessage: "Custom Property 40"
            }
        },
        Organization_LOGONAME: {
            ATTESTATIONS: {
                id: "Organization_LOGONAME.ATTESTATIONS",
                defaultMessage: "Logoname"
            }
        },
        Organization_LOCATION: {
            ATTESTATIONS: {
                id: "Organization_LOCATION.ATTESTATIONS",
                defaultMessage: "Location"
            }
        },
        Organization_PRIMARYVENDORCONTACT: {
            ATTESTATIONS: {
                id: "Organization_PRIMARYVENDORCONTACT.ATTESTATIONS",
                defaultMessage: "Primary Vendor Contact"
            }
        },
        Organization_CUSTOMPROPERTY1: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY1.ATTESTATIONS",
                defaultMessage: "Custom Property 1"
            }
        },
        Organization_CUSTOMPROPERTY10: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY10.ATTESTATIONS",
                defaultMessage: "Custom Property 10"
            }
        },
        Organization_CUSTOMPROPERTY11: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY11.ATTESTATIONS",
                defaultMessage: "Custom Property 11"
            }
        },
        Organization_CUSTOMPROPERTY12: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY12.ATTESTATIONS",
                defaultMessage: "Custom Property 12"
            }
        },
        Organization_CUSTOMPROPERTY13: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY13.ATTESTATIONS",
                defaultMessage: "Custom Property 13"
            }
        },
        Organization_CUSTOMPROPERTY14: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY14.ATTESTATIONS",
                defaultMessage: "Custom Property 14"
            }
        },
        Organization_CUSTOMPROPERTY15: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY15.ATTESTATIONS",
                defaultMessage: "Custom Property 15"
            }
        },
        Organization_CUSTOMPROPERTY16: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY16.ATTESTATIONS",
                defaultMessage: "Custom Property 16"
            }
        },
        Organization_CUSTOMPROPERTY17: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY17.ATTESTATIONS",
                defaultMessage: "Custom Property 17"
            }
        },
        Organization_CUSTOMPROPERTY18: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY18.ATTESTATIONS",
                defaultMessage: "Custom Property 18"
            }
        },
        Organization_CUSTOMPROPERTY19: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY19.ATTESTATIONS",
                defaultMessage: "Custom Property 19"
            }
        },
        Organization_CUSTOMPROPERTY2: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY2.ATTESTATIONS",
                defaultMessage: "Custom Property 2"
            }
        },
        Organization_CUSTOMPROPERTY20: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY20.ATTESTATIONS",
                defaultMessage: "Custom Property 20"
            }
        },
        Organization_CUSTOMPROPERTY3: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY3.ATTESTATIONS",
                defaultMessage: "Custom Property 3"
            }
        },
        Organization_CUSTOMPROPERTY4: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY4.ATTESTATIONS",
                defaultMessage: "Custom Property 4"
            }
        },
        Organization_CUSTOMPROPERTY5: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY5.ATTESTATIONS",
                defaultMessage: "Custom Property 5"
            }
        },
        Organization_CUSTOMPROPERTY6: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY6.ATTESTATIONS",
                defaultMessage: "Custom Property 6"
            }
        },
        Organization_CUSTOMPROPERTY7: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY7.ATTESTATIONS",
                defaultMessage: "Custom Property 7"
            }
        },
        Organization_CUSTOMPROPERTY8: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY8.ATTESTATIONS",
                defaultMessage: "Custom Property 8"
            }
        },
        Organization_CUSTOMPROPERTY9: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY9.ATTESTATIONS",
                defaultMessage: "Custom Property 9"
            }
        },
        Organization_CUSTOMPROPERTY21: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY21.ATTESTATIONS",
                defaultMessage: "Custom Property 21"
            }
        },
        Organization_CUSTOMPROPERTY22: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY22.ATTESTATIONS",
                defaultMessage: "Custom Property 22"
            }
        },
        Organization_CUSTOMPROPERTY23: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY23.ATTESTATIONS",
                defaultMessage: "Custom Property 23"
            }
        },
        Organization_CUSTOMPROPERTY24: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY24.ATTESTATIONS",
                defaultMessage: "Custom Property 24"
            }
        },
        Organization_CUSTOMPROPERTY25: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY25.ATTESTATIONS",
                defaultMessage: "Custom Property 25"
            }
        },
        Organization_CUSTOMPROPERTY26: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY26.ATTESTATIONS",
                defaultMessage: "Custom Property 26"
            }
        },
        Organization_CUSTOMPROPERTY27: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY27.ATTESTATIONS",
                defaultMessage: "Custom Property 27"
            }
        },
        Organization_CUSTOMPROPERTY28: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY28.ATTESTATIONS",
                defaultMessage: "Custom Property 28"
            }
        },
        Organization_COMMENTS: {
            ATTESTATIONS: {
                id: "Organization_COMMENTS.ATTESTATIONS",
                defaultMessage: "Comments"
            }
        },
        Organization_CUSTOMERCODE: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMERCODE.ATTESTATIONS",
                defaultMessage: "Organization Code"
            }
        },
        Organization_CUSTOMERNAME: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMERNAME.ATTESTATIONS",
                defaultMessage: "Organization Name"
            }
        },
        Organization_CUSTOMERNUMBER: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMERNUMBER.ATTESTATIONS",
                defaultMessage: "Organization Number"
            }
        },
        Organization_CUSTOMERTYPE: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMERTYPE.ATTESTATIONS",
                defaultMessage: "Organization Type"
            }
        },
        Organization_DESCRIPTION: {
            ATTESTATIONS: {
                id: "Organization_DESCRIPTION.ATTESTATIONS",
                defaultMessage: "Description"
            }
        },
        Organization_ENDDATE: {
            ATTESTATIONS: {
                id: "Organization_ENDDATE.ATTESTATIONS",
                defaultMessage: "End Date"
            }
        },
        Organization_LASTCERTIFICATIONDATE: {
            ATTESTATIONS: {
                id: "Organization_LASTCERTIFICATIONDATE.ATTESTATIONS",
                defaultMessage: "Last Certification Date"
            }
        },
        Organization_PHONENUMBER: {
            ATTESTATIONS: {
                id: "Organization_PHONENUMBER.ATTESTATIONS",
                defaultMessage: "Phone Number"
            }
        },
        Organization_RISK: {
            ATTESTATIONS: {
                id: "Organization_RISK.ATTESTATIONS",
                defaultMessage: "Risk"
            }
        },
        Organization_SCORE: {
            ATTESTATIONS: {
                id: "Organization_SCORE.ATTESTATIONS",
                defaultMessage: "Score"
            }
        },
        Organization_STARTDATE: {
            ATTESTATIONS: {
                id: "Organization_STARTDATE.ATTESTATIONS",
                defaultMessage: "Start Date"
            }
        },
        Organization_STATUS: {
            ATTESTATIONS: {
                id: "Organization_STATUS.ATTESTATIONS",
                defaultMessage: "Status"
            }
        },
        Organization_PARENTCUSTOMER: {
            ATTESTATIONS: {
                id: "Organization_PARENTCUSTOMER.ATTESTATIONS",
                defaultMessage: "Parent Organization"
            }
        },
        Organization_UPDATEUSER: {
            ATTESTATIONS: {
                id: "Organization_UPDATEUSER.ATTESTATIONS",
                defaultMessage: "Update User"
            }
        },
        Organization_VENDORMANAGER: {
            ATTESTATIONS: {
                id: "Organization_VENDORMANAGER.ATTESTATIONS",
                defaultMessage: "Vendor Manager"
            }
        },
        Organization_CREATEUSER: {
            ATTESTATIONS: {
                id: "Organization_CREATEUSER.ATTESTATIONS",
                defaultMessage: "Create User"
            }
        },
        Organization_EVENTSOURCE: {
            ATTESTATIONS: {
                id: "Organization_EVENTSOURCE.ATTESTATIONS",
                defaultMessage: "Event Source"
            }
        },
        Organization_LASTREVIEWEDDATE: {
            ATTESTATIONS: {
                id: "Organization_LASTREVIEWEDDATE.ATTESTATIONS",
                defaultMessage: "Last Reviewed Date"
            }
        },
        Organization_LASTREVIEWEDBY: {
            ATTESTATIONS: {
                id: "Organization_LASTREVIEWEDBY.ATTESTATIONS",
                defaultMessage: "Last Viewed By"
            }
        },
        Organization_LASTREVIEWEDCAMPAIGNNAME: {
            ATTESTATIONS: {
                id: "Organization_LASTREVIEWEDCAMPAIGNNAME.ATTESTATIONS",
                defaultMessage: "Last Viewed Campaign"
            }
        },
        Organization_SAVCREATEDATE: {
            ATTESTATIONS: {
                id: "Organization_SAVCREATEDATE.ATTESTATIONS",
                defaultMessage: "SAV Create Date"
            }
        },
        Organization_SAVUPDATEDATE: {
            ATTESTATIONS: {
                id: "Organization_SAVUPDATEDATE.ATTESTATIONS",
                defaultMessage: "SAV Update Date"
            }
        },
        Organization_JOBID: {
            ATTESTATIONS: {
                id: "Organization_JOBID.ATTESTATIONS",
                defaultMessage: "Job ID"
            }
        },
        Organization_ORGOWNERS: {
            ATTESTATIONS: {
                id: "Organization_ORGOWNERS.ATTESTATIONS",
                defaultMessage: "Organization Owners"
            }
        },
        Organization_DISPLAYNAME: {
            ATTESTATIONS: {
                id: "Organization_DISPLAYNAME.ATTESTATIONS",
                defaultMessage: "Display Name"
            }
        },
        Organization_CUSTOMER_TARGET_UNIQUE: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMER_TARGET_UNIQUE.ATTESTATIONS",
                defaultMessage: "Target Customer"
            }
        },
        Organization_CUSTOMER_SOURCE: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMER_SOURCE.ATTESTATIONS",
                defaultMessage: "Customer Source"
            }
        },
        Organization_CUSTOMERSOURCE: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMERSOURCE.ATTESTATIONS",
                defaultMessage: "Customer Source"
            }
        },
        LeftDefault_ENTITLEMENTTYPE: {
            ATTESTATIONS: {
                id: "LeftDefault_ENTITLEMENTTYPE.ATTESTATIONS",
                defaultMessage: "Entitlement Type"
            }
        },
        LeftDefault_ENDPOINT: {
            ATTESTATIONS: {
                id: "LeftDefault_ENDPOINT.ATTESTATIONS",
                defaultMessage: "Endpoint"
            }
        },
        LeftDefault_SYSTEMNAME: {
            ATTESTATIONS: {
                id: "LeftDefault_SYSTEMNAME.ATTESTATIONS",
                defaultMessage: "System Name"
            }
        },
        LeftDefault_RISKS: {
            ATTESTATIONS: {
                id: "LeftDefault_RISKS.ATTESTATIONS",
                defaultMessage: "Risks"
            }
        },
        LeftDefault_LASTUSEDENDDATE: {
            ATTESTATIONS: {
                id: "LeftDefault_LASTUSEDENDDATE.ATTESTATIONS",
                defaultMessage: "Last Used End Date"
            }
        },
        LeftDefault_LASTCERTIFIEDCAMPAIGNNAME: {
            ATTESTATIONS: {
                id: "LeftDefault_LASTCERTIFIEDCAMPAIGNNAME.ATTESTATIONS",
                defaultMessage: "Last Certified Campaign Name"
            }
        },
        LeftDefault_ACCESSTHROUGH: {
            ATTESTATIONS: {
                id: "LeftDefault_ACCESSTHROUGH.ATTESTATIONS",
                defaultMessage: "Acces Through"
            }
        },
        LeftDefault_JRMRULES: {
            ATTESTATIONS: {
                id: "LeftDefault_JRMRULES.ATTESTATIONS",
                defaultMessage: "Outlier Analysis"
            }
        },
        ShowAttStep1Default_AUDITTRAIL: {
            ATTESTATIONS: {
                id: "ShowAttStep1Default_AUDITTRAIL.ATTESTATIONS",
                defaultMessage: "History"
            }
        },
        ShowAttStep1Default_TOTALACCOUNTS: {
            ATTESTATIONS: {
                id: "ShowAttStep1Default_TOTALACCOUNTS.ATTESTATIONS",
                defaultMessage: "Total Accounts"
            }
        },
        ShowAttStep1Default_EXTENDEDENDDATE: {
            ATTESTATIONS: {
                id: "ShowAttStep1Default_EXTENDEDENDDATE.ATTESTATIONS",
                defaultMessage: "Extended End Date"
            }
        },
        ShowAttStep1Default_UPDATEUSER: {
            ATTESTATIONS: {
                id: "ShowAttStep1Default_UPDATEUSER.ATTESTATIONS",
                defaultMessage: "Update User"
            }
        },
        ShowAttStep1Default_COMMENTS: {
            ATTESTATIONS: {
                id: "ShowAttStep1Default_COMMENTS.ATTESTATIONS",
                defaultMessage: "Comments"
            }
        },
        ShowAttStep1Default_CERTIFIED: {
            ATTESTATIONS: {
                id: "ShowAttStep1Default_CERTIFIED.ATTESTATIONS",
                defaultMessage: "Status"
            }
        },
        ShowAttStep1Default_ENDDATE: {
            ATTESTATIONS: {
                id: "ShowAttStep1Default_ENDDATE.ATTESTATIONS",
                defaultMessage: "End Date"
            }
        },
        REASSIGNSTEP2: {
            ATTESTATIONS: {
                id: "REASSIGNSTEP2.ATTESTATIONS.label",
                defaultMessage: "Reassign"
            }
        },
        Account_CREATEDON: {
            ATTESTATIONS: {
                id: "Account_CREATEDON.ATTESTATIONS",
                defaultMessage: "Account Created On"
            }
        },
        Ent_PRIVILIGED: {
            ATTESTATIONS: {
                id: "Ent_PRIVILIGED.ATTESTATIONS",
                defaultMessage: "Entitlement Privileged"
            }
        },
        Ent_SYSCRITICAL: {
            ATTESTATIONS: {
                id: "Ent_SYSCRITICAL.ATTESTATIONS",
                defaultMessage: "Entitlement Sys Critical"
            }
        },
        Ent_SOXCRITICAL: {
            ATTESTATIONS: {
                id: "Ent_SOXCRITICAL.ATTESTATIONS",
                defaultMessage: "Entitlement SOX Critical"
            }
        },
        Ent_GLOSSARY: {
            ATTESTATIONS: {
                id: "Ent_GLOSSARY.ATTESTATIONS",
                defaultMessage: "Entitlement Glossary"
            }
        },
        YES_BelongsToMe: {
            ATTESTATIONS: {
                id: "YES_BelongsToMe.ATTESTATIONS",
                defaultMessage: "Belongs To Me"
            }
        },
        NO_Decommission: {
            ATTESTATIONS: {
                id: "NO_Decommission.ATTESTATIONS",
                defaultMessage: "Decommission"
            }
        },
        DOES_NOT_BELONG_TO_ME: {
            ATTESTATIONS: {
                id: "DOES_NOT_BELONG_TO_ME.ATTESTATIONS",
                defaultMessage: "Does Not Belong to Me"
            }
        },
        CONSULT: {
            ATTESTATIONS: {
                id: "CONSULT.ATTESTATIONS",
                defaultMessage: "Consult"
            }
        },
        YES_Approve: {
            ATTESTATIONS: {
                id: "YES_Approve.ATTESTATIONS",
                defaultMessage: "Approve"
            }
        },
        NO_Reject: {
            ATTESTATIONS: {
                id: "NO_Reject.ATTESTATIONS",
                defaultMessage: "Reject"
            }
        },
        User_SECONDARYPHONE: {
            ATTESTATIONS: {
                id: "User_SECONDARYPHONE.ATTESTATIONS",
                defaultMessage: "Secondary Phone"
            }
        },
        User_SECONDARYEMAIL: {
            ATTESTATIONS: {
                id: "User_SECONDARYEMAIL.ATTESTATIONS",
                defaultMessage: "Secondary Email"
            }
        },
        User_JOBID: {
            ATTESTATIONS: {
                id: "User_JOBID.ATTESTATIONS",
                defaultMessage: "User Job ID"
            }
        },
        User_UPDATEDATE: {
            ATTESTATIONS: {
                id: "User_UPDATEDATE.ATTESTATIONS",
                defaultMessage: "User Update Date"
            }
        },
        User_CREATEDBY: {
            ATTESTATIONS: {
                id: "User_CREATEDBY.ATTESTATIONS",
                defaultMessage: "Created By"
            }
        },
        User_LEAVESTATUS: {
            ATTESTATIONS: {
                id: "User_LEAVESTATUS.ATTESTATIONS",
                defaultMessage: "Leave Status"
            }
        },
        User_PREFEREDFIRSTNAME: {
            ATTESTATIONS: {
                id: "User_PREFEREDFIRSTNAME.ATTESTATIONS",
                defaultMessage: "Preferred First Name"
            }
        },
        User_CUSTOMER: {
            ATTESTATIONS: {
                id: "User_CUSTOMER.ATTESTATIONS",
                defaultMessage: "User Customer"
            }
        },
        User_LOCALE: {
            ATTESTATIONS: {
                id: "User_LOCALE.ATTESTATIONS",
                defaultMessage: "User Locale"
            }
        },
        User_CUSTOMPROPERTY41: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY41.ATTESTATIONS",
                defaultMessage: "User Custom Property 41"
            }
        },
        User_CUSTOMPROPERTY42: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY42.ATTESTATIONS",
                defaultMessage: "User Custom Property 42"
            }
        },
        User_CUSTOMPROPERTY43: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY43.ATTESTATIONS",
                defaultMessage: "User Custom Property 43"
            }
        },
        User_CUSTOMPROPERTY44: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY44.ATTESTATIONS",
                defaultMessage: "User Custom Property 44"
            }
        },
        User_CUSTOMPROPERTY45: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY45.ATTESTATIONS",
                defaultMessage: "User Custom Property 45"
            }
        },
        User_CUSTOMPROPERTY46: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY46.ATTESTATIONS",
                defaultMessage: "User Custom Property 46"
            }
        },
        User_CUSTOMPROPERTY47: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY47.ATTESTATIONS",
                defaultMessage: "User Custom Property 47"
            }
        },
        User_CUSTOMPROPERTY48: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY48.ATTESTATIONS",
                defaultMessage: "User Custom Property 48"
            }
        },
        User_CUSTOMPROPERTY49: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY49.ATTESTATIONS",
                defaultMessage: "User Custom Property 49"
            }
        },
        User_CUSTOMPROPERTY50: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY50.ATTESTATIONS",
                defaultMessage: "User Custom Property 50"
            }
        },
        User_CUSTOMPROPERTY51: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY51.ATTESTATIONS",
                defaultMessage: "User Custom Property 51"
            }
        },
        User_CUSTOMPROPERTY52: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY52.ATTESTATIONS",
                defaultMessage: "User Custom Property 52"
            }
        },
        User_CUSTOMPROPERTY53: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY53.ATTESTATIONS",
                defaultMessage: "User Custom Property 53"
            }
        },
        User_CUSTOMPROPERTY54: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY54.ATTESTATIONS",
                defaultMessage: "User Custom Property 54"
            }
        },
        User_CUSTOMPROPERTY55: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY55.ATTESTATIONS",
                defaultMessage: "User Custom Property 55"
            }
        },
        User_CUSTOMPROPERTY56: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY56.ATTESTATIONS",
                defaultMessage: "User Custom Property 56"
            }
        },
        User_CUSTOMPROPERTY57: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY57.ATTESTATIONS",
                defaultMessage: "User Custom Property 57"
            }
        },
        User_CUSTOMPROPERTY58: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY58.ATTESTATIONS",
                defaultMessage: "User Custom Property 58"
            }
        },
        User_CUSTOMPROPERTY59: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY59.ATTESTATIONS",
                defaultMessage: "User Custom Property 59"
            }
        },
        User_CUSTOMPROPERTY60: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY60.ATTESTATIONS",
                defaultMessage: "User Custom Property 60"
            }
        },
        User_CUSTOMPROPERTY61: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY61.ATTESTATIONS",
                defaultMessage: "User Custom Property 61"
            }
        },
        User_CUSTOMPROPERTY62: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY62.ATTESTATIONS",
                defaultMessage: "User Custom Property 62"
            }
        },
        User_CUSTOMPROPERTY63: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY63.ATTESTATIONS",
                defaultMessage: "User Custom Property 63"
            }
        },
        User_CUSTOMPROPERTY64: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY64.ATTESTATIONS",
                defaultMessage: "User Custom Property 64"
            }
        },
        User_CUSTOMPROPERTY65: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY65.ATTESTATIONS",
                defaultMessage: "User Custom Property 65"
            }
        },
        serviceAccDefault_NAME: {
            ATTESTATIONS: {
                id: "serviceAccDefault_NAME.ATTESTATIONS",
                defaultMessage: "Name"
            }
        },
        serviceAccDefault_DISPLAYNAME: {
            ATTESTATIONS: {
                id: "serviceAccDefault_DISPLAYNAME.ATTESTATIONS",
                defaultMessage: "Display Name"
            }
        },
        serviceAccDefault_SECURITYSYSTEM: {
            ATTESTATIONS: {
                id: "serviceAccDefault_SECURITYSYSTEM.ATTESTATIONS",
                defaultMessage: "Security System"
            }
        },
        serviceAccDefault_COMMENTS: {
            ATTESTATIONS: {
                id: "serviceAccDefault_COMMENTS.ATTESTATIONS",
                defaultMessage: "Comments"
            }
        },
        serviceAccDefault_AUDITTRAIL: {
            ATTESTATIONS: {
                id: "serviceAccDefault_AUDITTRAIL.ATTESTATIONS",
                defaultMessage: "Audit Trail"
            }
        },
        serviceAccDefault_ENDPOINTS: {
            ATTESTATIONS: {
                id: "serviceAccDefault_ENDPOINTS.ATTESTATIONS",
                defaultMessage: "Endpoints"
            }
        },
        serviceAccDefault_DESCRIPTION: {
            ATTESTATIONS: {
                id: "serviceAccDefault_DESCRIPTION.ATTESTATIONS",
                defaultMessage: "Description"
            }
        },
        serviceAccDefault_STATUS: {
            ATTESTATIONS: {
                id: "serviceAccDefault_STATUS.ATTESTATIONS",
                defaultMessage: "Status"
            }
        },
        JobControl: {
            ATTESTATIONS: {
                id: "JobControl.ATTESTATION.label",
                defaultMessage: "ATTESTATION"
            }
        },
        Account_ACCOUNTSTATUS: {
            ATTESTATIONS: {
                id: "Account_ACCOUNTSTATUS.ATTESTATIONS",
                defaultMessage: "Account Status"
            }
        },
        ELEMENTTYPE: {
            ATTESTATIONS: {
                id: "ELEMENTTYPE.ATTESTATIONS",
                defaultMessage: "Element Type"
            }
        },
        ENDPOINTNAME: {
            ATTESTATIONS: {
                id: "ENDPOINTNAME.ATTESTATIONS",
                defaultMessage: "Endpoint Name"
            }
        },
        Endpoint_ENDPOINTNAME: {
            ATTESTATIONS: {
                id: "Endpoint_ENDPOINTNAME.ATTESTATIONS",
                defaultMessage: "Endpointname"
            }
        },
        Endpoint_DESCRIPTION: {
            ATTESTATIONS: {
                id: "Endpoint_DESCRIPTION.ATTESTATIONS",
                defaultMessage: "Description"
            }
        },
        Endpoint_CUSTOMPROPERTY1: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY1.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property1"
            }
        },
        Endpoint_CUSTOMPROPERTY2: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY2.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property2"
            }
        },
        Endpoint_CUSTOMPROPERTY3: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY3.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property3"
            }
        },
        Endpoint_CUSTOMPROPERTY4: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY4.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property4"
            }
        },
        Endpoint_CUSTOMPROPERTY5: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY5.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property5"
            }
        },
        Endpoint_CUSTOMPROPERTY6: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY6.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property6"
            }
        },
        Endpoint_CUSTOMPROPERTY7: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY7.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property7"
            }
        },
        Endpoint_CUSTOMPROPERTY8: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY8.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property8"
            }
        },
        Endpoint_CUSTOMPROPERTY9: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY9.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property9"
            }
        },
        Endpoint_CUSTOMPROPERTY10: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY10.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property10"
            }
        },
        Endpoint_CUSTOMPROPERTY11: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY11.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property11"
            }
        },
        Endpoint_CUSTOMPROPERTY12: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY12.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property12"
            }
        },
        Endpoint_CUSTOMPROPERTY13: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY13.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property13"
            }
        },
        Endpoint_CUSTOMPROPERTY14: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY14.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property14"
            }
        },
        Endpoint_CUSTOMPROPERTY15: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY15.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property15"
            }
        },
        Endpoint_CUSTOMPROPERTY16: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY16.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property16"
            }
        },
        Endpoint_CUSTOMPROPERTY17: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY17.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property17"
            }
        },
        Endpoint_CUSTOMPROPERTY18: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY18.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property18"
            }
        },
        Endpoint_CUSTOMPROPERTY19: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY19.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property19"
            }
        },
        Endpoint_CUSTOMPROPERTY20: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY20.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property20"
            }
        },
        Endpoint_CUSTOMPROPERTY21: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY21.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property21"
            }
        },
        Endpoint_CUSTOMPROPERTY22: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY22.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property22"
            }
        },
        Endpoint_CUSTOMPROPERTY23: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY23.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property23"
            }
        },
        Endpoint_CUSTOMPROPERTY24: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY24.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property24"
            }
        },
        Endpoint_CUSTOMPROPERTY25: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY25.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property25"
            }
        },
        Endpoint_CUSTOMPROPERTY26: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY26.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property26"
            }
        },
        Endpoint_CUSTOMPROPERTY27: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY27.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property27"
            }
        },
        Endpoint_CUSTOMPROPERTY28: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY28.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property28"
            }
        },
        Endpoint_CUSTOMPROPERTY29: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY29.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property29"
            }
        },
        Endpoint_CUSTOMPROPERTY30: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY30.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property30"
            }
        },
        Endpoint_CUSTOMPROPERTY31: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY31.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property31"
            }
        },
        Endpoint_CUSTOMPROPERTY32: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY32.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property32"
            }
        },
        Endpoint_CUSTOMPROPERTY33: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY33.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property33"
            }
        },
        Endpoint_CUSTOMPROPERTY34: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY34.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property34"
            }
        },
        Endpoint_CUSTOMPROPERTY35: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY35.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property35"
            }
        },
        Endpoint_CUSTOMPROPERTY36: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY36.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property36"
            }
        },
        Endpoint_CUSTOMPROPERTY37: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY37.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property37"
            }
        },
        Endpoint_CUSTOMPROPERTY38: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY38.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property38"
            }
        },
        Endpoint_CUSTOMPROPERTY39: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY39.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property39"
            }
        },
        Endpoint_CUSTOMPROPERTY40: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY40.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property40"
            }
        },
        Endpoint_CUSTOMPROPERTY41: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY41.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property41"
            }
        },
        Endpoint_CUSTOMPROPERTY42: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY42.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property42"
            }
        },
        Endpoint_CUSTOMPROPERTY43: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY43.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property43"
            }
        },
        Endpoint_CUSTOMPROPERTY44: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY44.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property44"
            }
        },
        Endpoint_CUSTOMPROPERTY45: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY45.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property45"
            }
        },
        Endpoint_CUSTOMPROPERTY1LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY1LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 1 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY2LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY2LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 2 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY3LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY3LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 3 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY4LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY4LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 4 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY5LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY5LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 5 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY6LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY6LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 6 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY7LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY7LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 7 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY8LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY8LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 8 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY9LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY9LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 9 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY10LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY10LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 10 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY11LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY11LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 11 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY12LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY12LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 12 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY13LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY13LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 13 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY14LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY14LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 14 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY15LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY15LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 15 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY16LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY16LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 16 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY17LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY17LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 17 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY18LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY18LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 18 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY19LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY19LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 19 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY20LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY20LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 20 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY21LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY21LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 21 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY22LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY22LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 22 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY23LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY23LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 23 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY24LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY24LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 24 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY25LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY25LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 25 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY26LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY26LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 26 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY27LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY27LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 27 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY28LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY28LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 28 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY29LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY29LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 29 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY30LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY30LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 30 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY31LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY31LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 31 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY32LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY32LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 32 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY33LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY33LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 33 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY34LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY34LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 34 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY35LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY35LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 35 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY36LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY36LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 36 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY37LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY37LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 37 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY38LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY38LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 38 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY39LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY39LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 39 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY40LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY40LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 40 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY41LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY41LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 41 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY42LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY42LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 42 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY43LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY43LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 43 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY44LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY44LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 44 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY45LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY45LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 45 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY46LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY46LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 46 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY47LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY47LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 47 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY48LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY48LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 48 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY49LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY49LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 49 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY50LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY50LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 50 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY51LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY51LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 51 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY52LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY52LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 52 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY53LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY53LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 53 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY54LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY54LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 54 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY55LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY55LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 55 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY56LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY56LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 56 Label"
            }
        },
        Endpoint_DISPLAYNAME: {
            ATTESTATIONS: {
                id: "Endpoint_DISPLAYNAME.ATTESTATIONS",
                defaultMessage: "Displayname"
            }
        },
        Endpoint_STATUS: {
            ATTESTATIONS: {
                id: "Endpoint_STATUS.ATTESTATIONS",
                defaultMessage: "Status"
            }
        },
        Endpoint_ROLETYPEASJSON: {
            ATTESTATIONS: {
                id: "Endpoint_ROLETYPEASJSON.ATTESTATIONS",
                defaultMessage: "Role Type as Json"
            }
        },
        Endpoint_CREATEDBY: {
            ATTESTATIONS: {
                id: "Endpoint_CREATEDBY.ATTESTATIONS",
                defaultMessage: "Created By"
            }
        },
        Endpoint_UPDATEDATE: {
            ATTESTATIONS: {
                id: "Endpoint_UPDATEDATE.ATTESTATIONS",
                defaultMessage: "Update Date"
            }
        },
        Endpoint_CREATEDATE: {
            ATTESTATIONS: {
                id: "Endpoint_CREATEDATE.ATTESTATIONS",
                defaultMessage: "Create Date"
            }
        },
        Endpoint_UPDATEDBY: {
            ATTESTATIONS: {
                id: "Endpoint_UPDATEDBY.ATTESTATIONS",
                defaultMessage: "Updated By"
            }
        },
        Endpoint_CREATEDFROM: {
            ATTESTATIONS: {
                id: "Endpoint_CREATEDFROM.ATTESTATIONS",
                defaultMessage: "Created From"
            }
        },
        Endpoint_LASTREVIEWEDDATE: {
            ATTESTATIONS: {
                id: "Endpoint_LASTREVIEWEDDATE.ATTESTATIONS",
                defaultMessage: "Last Reviewed Date"
            }
        },
        Endpoint_LASTREVIEWEDBY: {
            ATTESTATIONS: {
                id: "Endpoint_LASTREVIEWEDBY.ATTESTATIONS",
                defaultMessage: "Last Reviewed By"
            }
        },
        Ent_SODDETAILDATA: {
            ATTESTATIONS: {
                id: "Ent_SODDETAILDATA.ATTESTATIONS",
                defaultMessage: "SOD Detail Data"
            }
        },
        Ent_CREATEDATE: {
            ATTESTATIONS: {
                id: "Ent_CREATEDATE.ATTESTATIONS",
                defaultMessage: "Create  Date"
            }
        },
        Role_ROLE_NAME: {
            ATTESTATIONS: {
                id: "Role_ROLE_NAME.ATTESTATIONS",
                defaultMessage: "Role Name"
            }
        },
        Role_DESCRIPTION: {
            ATTESTATIONS: {
                id: "Role_DESCRIPTION.ATTESTATIONS",
                defaultMessage: "Description"
            }
        },
        Role_DISPLAYNAME: {
            ATTESTATIONS: {
                id: "Role_DISPLAYNAME.ATTESTATIONS",
                defaultMessage: "Role"
            }
        },
        Role_STATUS: {
            ATTESTATIONS: {
                id: "Role_STATUS.ATTESTATIONS",
                defaultMessage: "Status"
            }
        },
        Role_CRITICALITY: {
            ATTESTATIONS: {
                id: "Role_CRITICALITY.ATTESTATIONS",
                defaultMessage: "Role Crititcality"
            }
        },
        Role_CUSTOMPROPERTY41: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY41.ATTESTATIONS",
                defaultMessage: "CustomProperty 41"
            }
        },
        Role_CUSTOMPROPERTY42: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY42.ATTESTATIONS",
                defaultMessage: "CustomProperty 42"
            }
        },
        Role_CUSTOMPROPERTY43: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY43.ATTESTATIONS",
                defaultMessage: "CustomProperty 43"
            }
        },
        Role_CUSTOMPROPERTY44: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY44.ATTESTATIONS",
                defaultMessage: "CustomProperty 44"
            }
        },
        Role_CUSTOMPROPERTY45: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY45.ATTESTATIONS",
                defaultMessage: "CustomProperty 45"
            }
        },
        Role_CUSTOMPROPERTY46: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY46.ATTESTATIONS",
                defaultMessage: "CustomProperty 46"
            }
        },
        Role_CUSTOMPROPERTY47: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY47.ATTESTATIONS",
                defaultMessage: "CustomProperty 47"
            }
        },
        Role_CUSTOMPROPERTY48: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY48.ATTESTATIONS",
                defaultMessage: "CustomProperty 48"
            }
        },
        Role_CUSTOMPROPERTY49: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY49.ATTESTATIONS",
                defaultMessage: "CustomProperty 49"
            }
        },
        Role_CUSTOMPROPERTY50: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY50.ATTESTATIONS",
                defaultMessage: "CustomProperty 50"
            }
        },
        Role_CUSTOMPROPERTY51: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY51.ATTESTATIONS",
                defaultMessage: "CustomProperty 51"
            }
        },
        Role_CUSTOMPROPERTY52: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY52.ATTESTATIONS",
                defaultMessage: "CustomProperty 52"
            }
        },
        Role_CUSTOMPROPERTY53: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY53.ATTESTATIONS",
                defaultMessage: "CustomProperty 53"
            }
        },
        Role_CUSTOMPROPERTY54: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY54.ATTESTATIONS",
                defaultMessage: "CustomProperty 54"
            }
        },
        Role_CUSTOMPROPERTY55: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY55.ATTESTATIONS",
                defaultMessage: "CustomProperty 55"
            }
        },
        Role_CUSTOMPROPERTY56: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY56.ATTESTATIONS",
                defaultMessage: "CustomProperty 56"
            }
        },
        Role_CUSTOMPROPERTY57: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY57.ATTESTATIONS",
                defaultMessage: "CustomProperty 57"
            }
        },
        Role_CUSTOMPROPERTY58: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY58.ATTESTATIONS",
                defaultMessage: "CustomProperty 58"
            }
        },
        Role_CUSTOMPROPERTY59: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY59.ATTESTATIONS",
                defaultMessage: "CustomProperty 59"
            }
        },
        Role_CUSTOMPROPERTY60: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY60.ATTESTATIONS",
                defaultMessage: "CustomProperty 60"
            }
        },
        EntitlementType_ENTITLEMENTNAME: {
            ATTESTATIONS: {
                id: "EntitlementType_ENTITLEMENTNAME.ATTESTATIONS",
                defaultMessage: "Entitlement Name"
            }
        },
        EntitlementType_ENTITLEMENTDESCRIPTION: {
            ATTESTATIONS: {
                id: "EntitlementType_ENTITLEMENTDESCRIPTION.ATTESTATIONS",
                defaultMessage: "Entitlement Description"
            }
        },
        EntitlementType_REQUIREDINREQUEST: {
            ATTESTATIONS: {
                id: "EntitlementType_REQUIREDINREQUEST.ATTESTATIONS",
                defaultMessage: "Required Inrequest"
            }
        },
        EntitlementType_CREATETASKACTION: {
            ATTESTATIONS: {
                id: "EntitlementType_CREATETASKACTION.ATTESTATIONS",
                defaultMessage: "Create Task Action"
            }
        },
        EntitlementType_RECON: {
            ATTESTATIONS: {
                id: "EntitlementType_RECON.ATTESTATIONS",
                defaultMessage: "Recon"
            }
        },
        EntitlementType_DISPLAYNAME: {
            ATTESTATIONS: {
                id: "EntitlementType_DISPLAYNAME.ATTESTATIONS",
                defaultMessage: "Displayname"
            }
        },
        EntitlementType_CUSTOMPROPERTY1_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY1_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 1 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY2_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY2_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 2 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY3_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY3_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 3 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY4_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY4_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 4 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY5_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY5_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 5 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY6_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY6_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 6 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY7_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY7_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 7 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY8_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY8_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 8 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY9_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY9_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 9 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY10_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY10_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 10 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY11_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY11_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 11 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY12_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY12_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 12 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY13_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY13_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 13 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY14_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY14_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 14 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY15_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY15_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 15 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY16_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY16_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 16 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY17_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY17_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 17 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY18_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY18_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 18 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY19_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY19_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 19 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY20_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY20_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 20 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY21_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY21_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 21 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY22_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY22_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 22 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY23_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY23_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 23 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY24_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY24_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 24 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY25_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY25_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 25 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY26_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY26_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 26 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY27_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY27_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 27 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY28_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY28_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 28 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY29_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY29_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 29 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY30_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY30_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 30 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY31_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY31_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 31 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY32_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY32_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 32 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY33_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY33_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 33 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY34_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY34_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 34 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY35_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY35_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 35 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY36_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY36_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 36 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY37_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY37_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 37 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY38_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY38_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 38 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY39_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY39_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 39 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY40_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY40_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 40 label"
            }
        },
        ROLE_NAME: {
            ATTESTATIONS: {
                id: "ROLE_NAME.ATTESTATIONS",
                defaultMessage: "Role Name"
            }
        },
        ROLETYPE: {
            ATTESTATIONS: {
                id: "ROLETYPE.ATTESTATIONS",
                defaultMessage: "Role Type"
            }
        },
        DESCRIPTION: {
            ATTESTATIONS: {
                id: "DESCRIPTION.ATTESTATIONS",
                defaultMessage: "Description"
            }
        },
        Ent_APPROVERNAME: {
            ATTESTATIONS: {
                id: "Ent_APPROVERNAME.ATTESTATIONS",
                defaultMessage: "Approver Level"
            }
        },
        APPROVERNAME: {
            ATTESTATIONS: {
                id: "APPROVERNAME.ATTESTATIONS",
                defaultMessage: "Approver Level"
            }
        },
        NAME: {
            ATTESTATIONS: {
                id: "NAME.ATTESTATIONS",
                defaultMessage: "Account Name"
            }
        },
        APPROVERTYPE: {
            ATTESTATIONS: {
                id: "APPROVERTYPE.ATTESTATIONS",
                defaultMessage: "Approver Type"
            }
        },
        APPROVERVALUE: {
            ATTESTATIONS: {
                id: "APPROVERVALUE.ATTESTATIONS",
                defaultMessage: "Approver Value"
            }
        },
        LASTREVIEWEDDATE: {
            ATTESTATIONS: {
                id: "LASTREVIEWEDDATE.ATTESTATIONS",
                defaultMessage: "Last Review Date"
            }
        },
        LASTREVIEWEDBY: {
            ATTESTATIONS: {
                id: "LASTREVIEWEDBY.ATTESTATIONS",
                defaultMessage: "Last Reviewed By"
            }
        },
        RE_DESCRIPTION: {
            ATTESTATIONS: {
                id: "RE_DESCRIPTION.ATTESTATIONS",
                defaultMessage: "Description"
            }
        },
        RISK: {
            ATTESTATIONS: {
                id: "RISK.ATTESTATIONS",
                defaultMessage: "Risk"
            }
        },
        Endpoint_LASTREVIEWEDCAMPAIGNNAME: {
            ATTESTATIONS: {
                id: "Endpoint_LASTREVIEWEDCAMPAIGNNAME.ATTESTATIONS",
                defaultMessage: "Last Reviewed Campaign"
            }
        },
        Ent_LASTREVIEWEDCAMPAIGNNAME: {
            ATTESTATIONS: {
                id: "Ent_LASTREVIEWEDCAMPAIGNNAME.ATTESTATIONS",
                defaultMessage: "Last Reviewed Campaign"
            }
        },
        EntitlementType_LASTREVIEWEDCAMPAIGNNAME: {
            ATTESTATIONS: {
                id: "EntitlementType_LASTREVIEWEDCAMPAIGNNAME.ATTESTATIONS",
                defaultMessage: "Last Reviewed Campaign"
            }
        },
        Role_LASTREVIEWEDCAMPAIGNNAME: {
            ATTESTATIONS: {
                id: "Role_LASTREVIEWEDCAMPAIGNNAME.ATTESTATIONS",
                defaultMessage: "Last Reviewed Campaign"
            }
        },
        Ent_LASTREVIEWEDDATE: {
            ATTESTATIONS: {
                id: "Ent_LASTREVIEWEDDATE.ATTESTATIONS",
                defaultMessage: "Last reviewed Date"
            }
        },
        Ent_LASTREVIEWEDBY: {
            ATTESTATIONS: {
                id: "Ent_LASTREVIEWEDBY.ATTESTATIONS",
                defaultMessage: "Last Reviewed By"
            }
        },
        Ent_PRIORITY: {
            ATTESTATIONS: {
                id: "Ent_PRIORITY.ATTESTATIONS",
                defaultMessage: "Entitlement Priority"
            }
        },
        ELEMENTNAME: {
            ATTESTATIONS: {
                id: "ELEMENTNAME.ATTESTATIONS",
                defaultMessage: "Element Name"
            }
        },
        CERTIFICATIONSTATUS: {
            ATTESTATIONS: {
                id: "CERTIFICATIONSTATUS.ATTESTATIONS",
                defaultMessage: "Certification Status"
            }
        },
        CERTIFIERNAME: {
            ATTESTATIONS: {
                id: "CERTIFIERNAME.ATTESTATIONS",
                defaultMessage: "Certifier Name"
            }
        },
        Account_NEWOWNER: {
            ATTESTATIONS: {
                id: "Account_NEWOWNER.ATTESTATIONS",
                defaultMessage: "Account New Owner"
            }
        },
        Account_OLDOWNER: {
            ATTESTATIONS: {
                id: "Account_OLDOWNER.ATTESTATIONS",
                defaultMessage: "Account Old Owner"
            }
        },
        Ent_OLDENTITLEMENTOWNER: {
            ATTESTATIONS: {
                id: "Ent_OLDENTITLEMENTOWNER.ATTESTATIONS",
                defaultMessage: "Entitlement Old Owner"
            }
        },
        User_CREATEDATE: {
            ATTESTATIONS: {
                id: "User_CREATEDATE.ATTESTATIONS",
                defaultMessage: "User Create Date"
            }
        },
        totalAccounts: {
            ATTESTATIONS: {
                id: "totalAccounts.ATTESTATIONS",
                defaultMessage: "Total Accounts"
            }
        },
        extendedendDate: {
            ATTESTATIONS: {
                id: "extendedendDate.ATTESTATIONS",
                defaultMessage: "Extended End Date"
            }
        },
        updateuser: {
            ATTESTATIONS: {
                id: "updateuser.ATTESTATIONS",
                defaultMessage: "Update User"
            }
        },
        certified: {
            ATTESTATIONS: {
                id: "certified.ATTESTATIONS",
                defaultMessage: "Status"
            }
        },
        CERT_USERKEY: {
            ATTESTATIONS: {
                id: "CERT_USERKEY.ATTESTATIONS",
                defaultMessage: "Certification User Key"
            }
        },
        DISPLAYNAME: {
            ATTESTATIONS: {
                id: "DISPLAYNAME.ATTESTATIONS",
                defaultMessage: "User Display Name"
            }
        },
        USERKEY: {
            ATTESTATIONS: {
                id: "USERKEY.ATTESTATIONS",
                defaultMessage: "User Key"
            }
        },
        TERMDATE: {
            ATTESTATIONS: {
                id: "TERMDATE.ATTESTATIONS",
                defaultMessage: "User Term Date"
            }
        },
        FIRSTNAME: {
            ATTESTATIONS: {
                id: "FIRSTNAME.ATTESTATIONS",
                defaultMessage: "User First Name"
            }
        },
        TOTALACCOUNTS: {
            ATTESTATIONS: {
                id: "TOTALACCOUNTS.ATTESTATIONS",
                defaultMessage: "Total Accounts"
            }
        },
        AUDITTRAIL: {
            ATTESTATIONS: {
                id: "AUDITTRAIL.ATTESTATIONS",
                defaultMessage: "History"
            }
        },
        UPDATEUSER: {
            ATTESTATIONS: {
                id: "UPDATEUSER.ATTESTATIONS",
                defaultMessage: "Update User"
            }
        },
        LASTNAME: {
            ATTESTATIONS: {
                id: "LASTNAME.ATTESTATIONS",
                defaultMessage: "User Last Name"
            }
        },
        MIDDLENAME: {
            ATTESTATIONS: {
                id: "MIDDLENAME.ATTESTATIONS",
                defaultMessage: "User Middle Name"
            }
        },
        STREET: {
            ATTESTATIONS: {
                id: "STREET.ATTESTATIONS",
                defaultMessage: "User Street"
            }
        },
        CITY: {
            ATTESTATIONS: {
                id: "CITY.ATTESTATIONS",
                defaultMessage: "User City"
            }
        },
        EMAIL: {
            ATTESTATIONS: {
                id: "EMAIL.ATTESTATIONS",
                defaultMessage: "User Email"
            }
        },
        STATUSKEY: {
            ATTESTATIONS: {
                id: "STATUSKEY.ATTESTATIONS",
                defaultMessage: "User Status"
            }
        },
        STARTDATE: {
            ATTESTATIONS: {
                id: "STARTDATE.ATTESTATIONS",
                defaultMessage: "User Start Date"
            }
        },
        ENDDATE: {
            ATTESTATIONS: {
                id: "ENDDATE.ATTESTATIONS",
                defaultMessage: "User End Date"
            }
        },
        MANAGER: {
            ATTESTATIONS: {
                id: "MANAGER.ATTESTATIONS",
                defaultMessage: "User Manager"
            }
        },
        PASSWORD: {
            ATTESTATIONS: {
                id: "PASSWORD.ATTESTATIONS",
                defaultMessage: "User Password"
            }
        },
        ENABLED: {
            ATTESTATIONS: {
                id: "ENABLED.ATTESTATIONS",
                defaultMessage: "User Enabled"
            }
        },
        LOCATION: {
            ATTESTATIONS: {
                id: "LOCATION.ATTESTATIONS",
                defaultMessage: "User Location"
            }
        },
        JOBCODE: {
            ATTESTATIONS: {
                id: "JOBCODE.ATTESTATIONS",
                defaultMessage: "User Job Code"
            }
        },
        JOBDESCRIPTION: {
            ATTESTATIONS: {
                id: "JOBDESCRIPTION.ATTESTATIONS",
                defaultMessage: "User Job Description"
            }
        },
        EMPLOYEETYPE: {
            ATTESTATIONS: {
                id: "EMPLOYEETYPE.ATTESTATIONS",
                defaultMessage: "User Employee Type"
            }
        },
        SYSTEMUSERNAME: {
            ATTESTATIONS: {
                id: "SYSTEMUSERNAME.ATTESTATIONS",
                defaultMessage: "User System Username"
            }
        },
        DEPARTMENTNUMBER: {
            ATTESTATIONS: {
                id: "DEPARTMENTNUMBER.ATTESTATIONS",
                defaultMessage: "User Department Number"
            }
        },
        TITLE: {
            ATTESTATIONS: {
                id: "TITLE.ATTESTATIONS",
                defaultMessage: "User Title"
            }
        },
        STATE: {
            ATTESTATIONS: {
                id: "STATE.ATTESTATIONS",
                defaultMessage: "User State"
            }
        },
        COMPANYNAME: {
            ATTESTATIONS: {
                id: "COMPANYNAME.ATTESTATIONS",
                defaultMessage: "User Company Name"
            }
        },
        COSTCENTER: {
            ATTESTATIONS: {
                id: "COSTCENTER.ATTESTATIONS",
                defaultMessage: "User Cost Centre"
            }
        },
        DEPARTMENTNAME: {
            ATTESTATIONS: {
                id: "DEPARTMENTNAME.ATTESTATIONS",
                defaultMessage: "User Department Name"
            }
        },
        EMPLOYEECLASS: {
            ATTESTATIONS: {
                id: "EMPLOYEECLASS.ATTESTATIONS",
                defaultMessage: "User Employee Class"
            }
        },
        ENTITY: {
            ATTESTATIONS: {
                id: "ENTITY.ATTESTATIONS",
                defaultMessage: "User Entity"
            }
        },
        JOBCODEDESC: {
            ATTESTATIONS: {
                id: "JOBCODEDESC.ATTESTATIONS",
                defaultMessage: "User Job Code Description"
            }
        },
        LOCATIONDESC: {
            ATTESTATIONS: {
                id: "LOCATIONDESC.ATTESTATIONS",
                defaultMessage: "User Location Description"
            }
        },
        LOCATIONNUMBER: {
            ATTESTATIONS: {
                id: "LOCATIONNUMBER.ATTESTATIONS",
                defaultMessage: "User Location Number"
            }
        },
        SITEID: {
            ATTESTATIONS: {
                id: "SITEID.ATTESTATIONS",
                defaultMessage: "User Site"
            }
        },
        ORGUNITID: {
            ATTESTATIONS: {
                id: "ORGUNITID.ATTESTATIONS",
                defaultMessage: "User Organization Unit"
            }
        },
        REGION: {
            ATTESTATIONS: {
                id: "REGION.ATTESTATIONS",
                defaultMessage: "User Region"
            }
        },
        REGIONCODE: {
            ATTESTATIONS: {
                id: "REGIONCODE.ATTESTATIONS",
                defaultMessage: "User Region Code"
            }
        },
        OWNER: {
            ATTESTATIONS: {
                id: "OWNER.ATTESTATIONS",
                defaultMessage: "User Owner"
            }
        },
        EMPLOYEEID: {
            ATTESTATIONS: {
                id: "EMPLOYEEID.ATTESTATIONS",
                defaultMessage: "User Employee"
            }
        },
        LASTSYNCDATE: {
            ATTESTATIONS: {
                id: "LASTSYNCDATE.ATTESTATIONS",
                defaultMessage: "User Last Sync Date"
            }
        },
        PHONENUMBER: {
            ATTESTATIONS: {
                id: "PHONENUMBER.ATTESTATIONS",
                defaultMessage: "User Phone Number"
            }
        },
        COUNTRY: {
            ATTESTATIONS: {
                id: "COUNTRY.ATTESTATIONS",
                defaultMessage: "User Country"
            }
        },
        ACCOUNTEXPIRED: {
            ATTESTATIONS: {
                id: "ACCOUNTEXPIRED.ATTESTATIONS",
                defaultMessage: "User Account Expired"
            }
        },
        ACCOUNTLOCKED: {
            ATTESTATIONS: {
                id: "ACCOUNTLOCKED.ATTESTATIONS",
                defaultMessage: "User Account Locked"
            }
        },
        PASSWORDEXPIRED: {
            ATTESTATIONS: {
                id: "PASSWORDEXPIRED.ATTESTATIONS",
                defaultMessage: "User Password Expired"
            }
        },
        JOB_FUNCTION: {
            ATTESTATIONS: {
                id: "JOB_FUNCTION.ATTESTATIONS",
                defaultMessage: "User Job Function"
            }
        },
        DONOTDISTURBDELEGATE: {
            ATTESTATIONS: {
                id: "DONOTDISTURBDELEGATE.ATTESTATIONS",
                defaultMessage: "User Do Not Disturb Delegate"
            }
        },
        CUSTOMPROPERTY1: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY1.ATTESTATIONS",
                defaultMessage: "User Custom Property 1"
            }
        },
        CUSTOMPROPERTY2: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY2.ATTESTATIONS",
                defaultMessage: "User Custom Property 2"
            }
        },
        CUSTOMPROPERTY3: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY3.ATTESTATIONS",
                defaultMessage: "User Custom Property 3"
            }
        },
        CUSTOMPROPERTY4: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY4.ATTESTATIONS",
                defaultMessage: "User Custom Property 4"
            }
        },
        CUSTOMPROPERTY5: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY5.ATTESTATIONS",
                defaultMessage: "User Custom Property 5"
            }
        },
        CUSTOMPROPERTY6: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY6.ATTESTATIONS",
                defaultMessage: "User Custom Property 6"
            }
        },
        CUSTOMPROPERTY7: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY7.ATTESTATIONS",
                defaultMessage: "User Custom Property 7"
            }
        },
        CUSTOMPROPERTY8: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY8.ATTESTATIONS",
                defaultMessage: "User Custom Property 8"
            }
        },
        CUSTOMPROPERTY9: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY9.ATTESTATIONS",
                defaultMessage: "User Custom Property 9"
            }
        },
        CUSTOMPROPERTY10: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY10.ATTESTATIONS",
                defaultMessage: "User Custom Property 10"
            }
        },
        CUSTOMPROPERTY11: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY11.ATTESTATIONS",
                defaultMessage: "User Custom Property 11"
            }
        },
        CUSTOMPROPERTY12: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY12.ATTESTATIONS",
                defaultMessage: "User Custom Property 12"
            }
        },
        CUSTOMPROPERTY13: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY13.ATTESTATIONS",
                defaultMessage: "User Custom Property 13"
            }
        },
        CUSTOMPROPERTY14: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY14.ATTESTATIONS",
                defaultMessage: "User Custom Property 14"
            }
        },
        CUSTOMPROPERTY15: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY15.ATTESTATIONS",
                defaultMessage: "User Custom Property 15"
            }
        },
        CUSTOMPROPERTY16: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY16.ATTESTATIONS",
                defaultMessage: "User Custom Property 16"
            }
        },
        CUSTOMPROPERTY17: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY17.ATTESTATIONS",
                defaultMessage: "User Custom Property 17"
            }
        },
        CUSTOMPROPERTY18: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY18.ATTESTATIONS",
                defaultMessage: "User Custom Property 18"
            }
        },
        CUSTOMPROPERTY19: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY19.ATTESTATIONS",
                defaultMessage: "User Custom Property 19"
            }
        },
        CUSTOMPROPERTY20: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY20.ATTESTATIONS",
                defaultMessage: "User Custom Property 20"
            }
        },
        CUSTOMPROPERTY21: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY21.ATTESTATIONS",
                defaultMessage: "User Custom Property 21"
            }
        },
        CUSTOMPROPERTY22: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY22.ATTESTATIONS",
                defaultMessage: "User Custom Property 22"
            }
        },
        CUSTOMPROPERTY23: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY23.ATTESTATIONS",
                defaultMessage: "User Custom Property 23"
            }
        },
        CUSTOMPROPERTY24: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY24.ATTESTATIONS",
                defaultMessage: "User Custom Property 24"
            }
        },
        CUSTOMPROPERTY25: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY25.ATTESTATIONS",
                defaultMessage: "User Custom Property 25"
            }
        },
        CUSTOMPROPERTY26: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY26.ATTESTATIONS",
                defaultMessage: "User Custom Property 26"
            }
        },
        CUSTOMPROPERTY27: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY27.ATTESTATIONS",
                defaultMessage: "User Custom Property 27"
            }
        },
        CUSTOMPROPERTY28: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY28.ATTESTATIONS",
                defaultMessage: "User Custom Property 28"
            }
        },
        CUSTOMPROPERTY29: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY29.ATTESTATIONS",
                defaultMessage: "User Custom Property 29"
            }
        },
        CUSTOMPROPERTY30: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY30.ATTESTATIONS",
                defaultMessage: "User Custom Property 30"
            }
        },
        CUSTOMPROPERTY31: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY31.ATTESTATIONS",
                defaultMessage: "User Custom Property 31"
            }
        },
        CUSTOMPROPERTY32: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY32.ATTESTATIONS",
                defaultMessage: "User Custom Property 32"
            }
        },
        CUSTOMPROPERTY33: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY33.ATTESTATIONS",
                defaultMessage: "User Custom Property 33"
            }
        },
        CUSTOMPROPERTY34: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY34.ATTESTATIONS",
                defaultMessage: "User Custom Property 34"
            }
        },
        CUSTOMPROPERTY35: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY35.ATTESTATIONS",
                defaultMessage: "User Custom Property 35"
            }
        },
        CUSTOMPROPERTY36: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY36.ATTESTATIONS",
                defaultMessage: "User Custom Property 36"
            }
        },
        CUSTOMPROPERTY37: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY37.ATTESTATIONS",
                defaultMessage: "User Custom Property 37"
            }
        },
        CUSTOMPROPERTY38: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY38.ATTESTATIONS",
                defaultMessage: "User Custom Property 38"
            }
        },
        CUSTOMPROPERTY39: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY39.ATTESTATIONS",
                defaultMessage: "User Custom Property 39"
            }
        },
        CUSTOMPROPERTY40: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY40.ATTESTATIONS",
                defaultMessage: "User Custom Property 40"
            }
        },
        CUSTOMPROPERTY41: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY41.ATTESTATIONS",
                defaultMessage: "User Custom Property 41"
            }
        },
        CUSTOMPROPERTY42: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY42.ATTESTATIONS",
                defaultMessage: "User Custom Property 42"
            }
        },
        CUSTOMPROPERTY43: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY43.ATTESTATIONS",
                defaultMessage: "User Custom Property 43"
            }
        },
        CUSTOMPROPERTY44: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY44.ATTESTATIONS",
                defaultMessage: "User Custom Property 44"
            }
        },
        CUSTOMPROPERTY45: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY45.ATTESTATIONS",
                defaultMessage: "User Custom Property 45"
            }
        },
        CUSTOMPROPERTY46: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY46.ATTESTATIONS",
                defaultMessage: "User Custom Property 46"
            }
        },
        CUSTOMPROPERTY47: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY47.ATTESTATIONS",
                defaultMessage: "User Custom Property 47"
            }
        },
        CUSTOMPROPERTY48: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY48.ATTESTATIONS",
                defaultMessage: "User Custom Property 48"
            }
        },
        CUSTOMPROPERTY49: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY49.ATTESTATIONS",
                defaultMessage: "User Custom Property 49"
            }
        },
        CUSTOMPROPERTY50: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY50.ATTESTATIONS",
                defaultMessage: "User Custom Property 50"
            }
        },
        CUSTOMPROPERTY51: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY51.ATTESTATIONS",
                defaultMessage: "User Custom Property 51"
            }
        },
        CUSTOMPROPERTY52: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY52.ATTESTATIONS",
                defaultMessage: "User Custom Property 52"
            }
        },
        CUSTOMPROPERTY53: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY53.ATTESTATIONS",
                defaultMessage: "User Custom Property 53"
            }
        },
        CUSTOMPROPERTY54: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY54.ATTESTATIONS",
                defaultMessage: "User Custom Property 54"
            }
        },
        CUSTOMPROPERTY55: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY55.ATTESTATIONS",
                defaultMessage: "User Custom Property 55"
            }
        },
        CUSTOMPROPERTY56: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY56.ATTESTATIONS",
                defaultMessage: "User Custom Property 56"
            }
        },
        CUSTOMPROPERTY57: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY57.ATTESTATIONS",
                defaultMessage: "User Custom Property 57"
            }
        },
        CUSTOMPROPERTY58: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY58.ATTESTATIONS",
                defaultMessage: "User Custom Property 58"
            }
        },
        CUSTOMPROPERTY59: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY59.ATTESTATIONS",
                defaultMessage: "User Custom Property 59"
            }
        },
        CUSTOMPROPERTY60: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY60.ATTESTATIONS",
                defaultMessage: "User Custom Property 60"
            }
        },
        CUSTOMPROPERTY61: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY61.ATTESTATIONS",
                defaultMessage: "User Custom Property 61"
            }
        },
        CUSTOMPROPERTY62: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY62.ATTESTATIONS",
                defaultMessage: "User Custom Property 62"
            }
        },
        CUSTOMPROPERTY63: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY63.ATTESTATIONS",
                defaultMessage: "User Custom Property 63"
            }
        },
        CUSTOMPROPERTY64: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY64.ATTESTATIONS",
                defaultMessage: "User Custom Property 64"
            }
        },
        CUSTOMPROPERTY65: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY65.ATTESTATIONS",
                defaultMessage: "User Custom Property 65"
            }
        },
        RISKSCORE: {
            ATTESTATIONS: {
                id: "RISKSCORE.ATTESTATIONS",
                defaultMessage: "User Risk Score"
            }
        },
        EXTENDEDENDDATE: {
            ATTESTATIONS: {
                id: "EXTENDEDENDDATE.ATTESTATIONS",
                defaultMessage: "User Extended Date"
            }
        },
        LASTCERTIFIEDDATE: {
            ATTESTATIONS: {
                id: "LASTCERTIFIEDDATE.ATTESTATIONS",
                defaultMessage: "Last Certified Date"
            }
        },
        CREATEDATE: {
            ATTESTATIONS: {
                id: "CREATEDATE.ATTESTATIONS",
                defaultMessage: "User Create Date"
            }
        },
        CREATEDBY: {
            ATTESTATIONS: {
                id: "CREATEDBY.ATTESTATIONS",
                defaultMessage: "created By"
            }
        },
        SECONDARYPHONE: {
            ATTESTATIONS: {
                id: "SECONDARYPHONE.ATTESTATIONS",
                defaultMessage: "User Secondary Phone"
            }
        },
        SECONDARYEMAIL: {
            ATTESTATIONS: {
                id: "SECONDARYEMAIL.ATTESTATIONS",
                defaultMessage: "User Secondary Email"
            }
        },
        PREFEREDFIRSTNAME: {
            ATTESTATIONS: {
                id: "PREFEREDFIRSTNAME.ATTESTATIONS",
                defaultMessage: "User Prefered First Name"
            }
        },
        LEAVESTATUS: {
            ATTESTATIONS: {
                id: "LEAVESTATUS.ATTESTATIONS",
                defaultMessage: "User Leave Status"
            }
        },
        OLDVALUE: {
            ATTESTATIONS: {
                id: "OLDVALUE.ATTESTATIONS",
                defaultMessage: "Old Value"
            }
        },
        NEWVALUE: {
            ATTESTATIONS: {
                id: "NEWVALUE.ATTESTATIONS",
                defaultMessage: "New Value"
            }
        },
        FIELDNAME: {
            ATTESTATIONS: {
                id: "FIELDNAME.ATTESTATIONS",
                defaultMessage: "Field Name"
            }
        },
        MODIFIEDON: {
            ATTESTATIONS: {
                id: "MODIFIEDON.ATTESTATIONS",
                defaultMessage: "Modified On"
            }
        },
        User_USERCOMMENTS: {
            ATTESTATIONS: {
                id: "User_USERCOMMENTS.ATTESTATIONS",
                defaultMessage: "User Comments"
            }
        },
        User_CERTCOMMENTS: {
            ATTESTATIONS: {
                id: "User_CERTCOMMENTS.ATTESTATIONS",
                defaultMessage: "Comments"
            }
        },
        Account_CUSTOMPROPERTY57: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY57.ATTESTATIONS",
                defaultMessage: "Account Custom Property 57"
            }
        },
        Account_CUSTOMPROPERTY58: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY58.ATTESTATIONS",
                defaultMessage: "Account Custom Property 58"
            }
        },
        Account_CUSTOMPROPERTY59: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY59.ATTESTATIONS",
                defaultMessage: "Account Custom Property 59"
            }
        },
        Account_CUSTOMPROPERTY60: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY60.ATTESTATIONS",
                defaultMessage: "Account Custom Property 60"
            }
        },
        ACTN: {
            ATTESTATIONS: {
                id: "ACTN.ATTESTATIONS",
                defaultMessage: "ACTION"
            }
        },
        ENTSTATUS: {
            ATTESTATIONS: {
                id: "ENTSTATUS.ATTESTATIONS",
                defaultMessage: "Entitlement Status"
            }
        },
        ACCOUNTCERTFIED: {
            ATTESTATIONS: {
                id: "ACCOUNTCERTFIED.ATTESTATIONS",
                defaultMessage: "Status"
            }
        },
        ENT2CERTIFIED: {
            ATTESTATIONS: {
                id: "ENT2CERTIFIED.ATTESTATIONS",
                defaultMessage: "Status"
            }
        },
        ENTDISPLAYNAME: {
            ATTESTATIONS: {
                id: "ENTDISPLAYNAME.ATTESTATIONS",
                defaultMessage: "Entitlement Display Name"
            }
        },
        ENTCERTIFIED: {
            ATTESTATIONS: {
                id: "ENTCERTIFIED.ATTESTATIONS",
                defaultMessage: "Status"
            }
        },
        Ent_SODFLAG: {
            ATTESTATIONS: {
                id: "Ent_SODFLAG.ATTESTATIONS",
                defaultMessage: "Entitlement SOD Flag"
            }
        },
        Ent2_SODFLAG: {
            ATTESTATIONS: {
                id: "Ent2_SODFLAG.ATTESTATIONS",
                defaultMessage: "Entitlement SOD Flag"
            }
        },
        Ent2_CERT_ENTITLEMEnt2_VALUEKEY: {
            ATTESTATIONS: {
                id: "Ent2_CERT_ENTITLEMEnt2_VALUEKEY.ATTESTATIONS",
                defaultMessage: "Certification Entitlement Value Key"
            }
        },
        Ent2_ENTITLEMEnt2_VALUEKEY: {
            ATTESTATIONS: {
                id: "Ent2_ENTITLEMEnt2_VALUEKEY.ATTESTATIONS",
                defaultMessage: "Entitlement Value Key"
            }
        },
        Ent2_ENTITLEMEnt2_VALUE: {
            ATTESTATIONS: {
                id: "Ent2_ENTITLEMEnt2_VALUE.ATTESTATIONS",
                defaultMessage: "Entitlement Value"
            }
        },
        Ent2_ENTITLEMENTTYPEKEY: {
            ATTESTATIONS: {
                id: "Ent2_ENTITLEMENTTYPEKEY.ATTESTATIONS",
                defaultMessage: "Entitlement Type Key"
            }
        },
        Ent2_CUSTOMPROPERTY1: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY1.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 1"
            }
        },
        Ent2_CUSTOMPROPERTY2: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY2.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 2"
            }
        },
        Ent2_CUSTOMPROPERTY3: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY3.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 3"
            }
        },
        Ent2_CUSTOMPROPERTY4: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY4.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 4"
            }
        },
        Ent2_CUSTOMPROPERTY5: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY5.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 5"
            }
        },
        Ent2_CUSTOMPROPERTY6: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY6.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 6"
            }
        },
        Ent2_CUSTOMPROPERTY7: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY7.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 7"
            }
        },
        Ent2_CUSTOMPROPERTY8: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY8.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 8"
            }
        },
        Ent2_CUSTOMPROPERTY9: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY9.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 9"
            }
        },
        Ent2_CUSTOMPROPERTY10: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY10.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 10"
            }
        },
        Ent2_CUSTOMPROPERTY11: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY11.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 11"
            }
        },
        Ent2_CUSTOMPROPERTY12: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY12.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 12"
            }
        },
        Ent2_CUSTOMPROPERTY13: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY13.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 13"
            }
        },
        Ent2_CUSTOMPROPERTY14: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY14.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 14"
            }
        },
        Ent2_CUSTOMPROPERTY15: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY15.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 15"
            }
        },
        Ent2_CUSTOMPROPERTY16: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY16.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 16"
            }
        },
        Ent2_CUSTOMPROPERTY17: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY17.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 17"
            }
        },
        Ent2_CUSTOMPROPERTY18: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY18.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 18"
            }
        },
        Ent2_CUSTOMPROPERTY19: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY19.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 19"
            }
        },
        Ent2_CUSTOMPROPERTY20: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY20.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 20"
            }
        },
        Ent2_CUSTOMPROPERTY21: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY21.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 21"
            }
        },
        Ent2_CUSTOMPROPERTY22: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY22.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 22"
            }
        },
        Ent2_CUSTOMPROPERTY23: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY23.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 23"
            }
        },
        Ent2_CUSTOMPROPERTY24: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY24.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 24"
            }
        },
        Ent2_CUSTOMPROPERTY25: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY25.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 25"
            }
        },
        Ent2_CUSTOMPROPERTY26: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY26.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 26"
            }
        },
        Ent2_CUSTOMPROPERTY27: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY27.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 27"
            }
        },
        Ent2_CUSTOMPROPERTY28: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY28.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 28"
            }
        },
        Ent2_CUSTOMPROPERTY29: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY29.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 29"
            }
        },
        Ent2_CUSTOMPROPERTY30: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY30.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 30"
            }
        },
        Ent2_CUSTOMPROPERTY31: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY31.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 31"
            }
        },
        Ent2_CUSTOMPROPERTY32: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY32.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 32"
            }
        },
        Ent2_CUSTOMPROPERTY33: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY33.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 33"
            }
        },
        Ent2_CUSTOMPROPERTY34: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY34.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 34"
            }
        },
        Ent2_CUSTOMPROPERTY35: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY35.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 35"
            }
        },
        Ent2_CUSTOMPROPERTY36: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY36.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 36"
            }
        },
        Ent2_CUSTOMPROPERTY37: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY37.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 37"
            }
        },
        Ent2_CUSTOMPROPERTY38: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY38.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 38"
            }
        },
        Ent2_CUSTOMPROPERTY39: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY39.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 39"
            }
        },
        Ent2_CUSTOMPROPERTY40: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY40.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 40"
            }
        },
        Ent2_DESCRIPTION: {
            ATTESTATIONS: {
                id: "Ent2_DESCRIPTION.ATTESTATIONS",
                defaultMessage: "Entitlement Description"
            }
        },
        Ent2_ENTITLEMENT_GLOSSARY: {
            ATTESTATIONS: {
                id: "Ent2_ENTITLEMENT_GLOSSARY.ATTESTATIONS",
                defaultMessage: "Entitlement Glossary"
            }
        },
        Ent2_STATUS: {
            ATTESTATIONS: {
                id: "Ent2_STATUS.ATTESTATIONS",
                defaultMessage: "Entitlement Status"
            }
        },
        Ent2_UPDATEUSER: {
            ATTESTATIONS: {
                id: "Ent2_UPDATEUSER.ATTESTATIONS",
                defaultMessage: "Entitlement Update User"
            }
        },
        Ent2_RISK: {
            ATTESTATIONS: {
                id: "Ent2_RISK.ATTESTATIONS",
                defaultMessage: "Entitlement Risk"
            }
        },
        Ent2_SOX_CRITICAL: {
            ATTESTATIONS: {
                id: "Ent2_SOX_CRITICAL.ATTESTATIONS",
                defaultMessage: "Entitlement SOX Critical"
            }
        },
        Ent2_SOXCRITICAL: {
            ATTESTATIONS: {
                id: "Ent2_SOXCRITICAL.ATTESTATIONS",
                defaultMessage: "Entitlement SOX Critical"
            }
        },
        Ent2_SYS_CRITICAL: {
            ATTESTATIONS: {
                id: "Ent2_SYS_CRITICAL.ATTESTATIONS",
                defaultMessage: "Entitlement Sys Critical"
            }
        },
        Ent2_SYSCRITICAL: {
            ATTESTATIONS: {
                id: "Ent2_SYSCRITICAL.ATTESTATIONS",
                defaultMessage: "Entitlement Sys Critical"
            }
        },
        Ent2_ORPHAN: {
            ATTESTATIONS: {
                id: "Ent2_ORPHAN.ATTESTATIONS",
                defaultMessage: "Entitlement Orphan"
            }
        },
        Ent2_UPDATEDATE: {
            ATTESTATIONS: {
                id: "Ent2_UPDATEDATE.ATTESTATIONS",
                defaultMessage: "Entitlement Update Date"
            }
        },
        Ent2_SAVLEVEL: {
            ATTESTATIONS: {
                id: "Ent2_SAVLEVEL.ATTESTATIONS",
                defaultMessage: "Entitlement SAV Level"
            }
        },
        Ent2_LEVEL: {
            ATTESTATIONS: {
                id: "Ent2_LEVEL.ATTESTATIONS",
                defaultMessage: "Entitlement SAV Level"
            }
        },
        Ent2_PRIVILEGED: {
            ATTESTATIONS: {
                id: "Ent2_PRIVILEGED.ATTESTATIONS",
                defaultMessage: "Entitlement Privileged"
            }
        },
        Ent2_PRIVILIGED: {
            ATTESTATIONS: {
                id: "Ent2_PRIVILIGED.ATTESTATIONS",
                defaultMessage: "Entitlement Privileged"
            }
        },
        Ent2_CONFIDENTIALITY: {
            ATTESTATIONS: {
                id: "Ent2_CONFIDENTIALITY.ATTESTATIONS",
                defaultMessage: "Entitlement Confidentiality"
            }
        },
        Ent2_SOD: {
            ATTESTATIONS: {
                id: "Ent2_SOD.ATTESTATIONS",
                defaultMessage: "Entitlement SOD"
            }
        },
        Ent2_DISPLAYNAME: {
            ATTESTATIONS: {
                id: "Ent2_DISPLAYNAME.ATTESTATIONS",
                defaultMessage: "Entitlement Display Name"
            }
        },
        Ent2_ENTITLEMENTID: {
            ATTESTATIONS: {
                id: "Ent2_ENTITLEMENTID.ATTESTATIONS",
                defaultMessage: "Entitlement ID"
            }
        },
        Ent2_PROGRAM: {
            ATTESTATIONS: {
                id: "Ent2_PROGRAM.ATTESTATIONS",
                defaultMessage: "Entitlement Program"
            }
        },
        Ent2_MODULE: {
            ATTESTATIONS: {
                id: "Ent2_MODULE.ATTESTATIONS",
                defaultMessage: "Entitlement Module"
            }
        },
        Ent2_ACCESS: {
            ATTESTATIONS: {
                id: "Ent2_ACCESS.ATTESTATIONS",
                defaultMessage: "Entitlement Access"
            }
        },
        Ent2_SCHEMANAME: {
            ATTESTATIONS: {
                id: "Ent2_SCHEMANAME.ATTESTATIONS",
                defaultMessage: "Entitlement Schema Name"
            }
        },
        Ent2_ENTCLASS: {
            ATTESTATIONS: {
                id: "Ent2_ENTCLASS.ATTESTATIONS",
                defaultMessage: "Entitlement Classification"
            }
        },
        Ent2_LASTSCANDATE: {
            ATTESTATIONS: {
                id: "Ent2_LASTSCANDATE.ATTESTATIONS",
                defaultMessage: "Entitlement Last Scan Date"
            }
        },
        Ent2_ENTITLEMGLOSSARY: {
            ATTESTATIONS: {
                id: "Ent2_ENTITLEMGLOSSARY.ATTESTATIONS",
                defaultMessage: "Entitlement Glossary"
            }
        },
        Ent2_JOBID: {
            ATTESTATIONS: {
                id: "Ent2_JOBID.ATTESTATIONS",
                defaultMessage: "Entitlement Job ID"
            }
        },
        Ent2_LASTREVIEWEDDATE: {
            ATTESTATIONS: {
                id: "Ent2_LASTREVIEWEDDATE.ATTESTATIONS",
                defaultMessage: "Last reviewed Date"
            }
        },
        Ent2_LASTREVIEWEDBY: {
            ATTESTATIONS: {
                id: "Ent2_LASTREVIEWEDBY.ATTESTATIONS",
                defaultMessage: "Last Reviewed By"
            }
        },
        Ent2_LASTREVIEWEDCAMPAIGNNAME: {
            ATTESTATIONS: {
                id: "Ent2_LASTREVIEWEDCAMPAIGNNAME.ATTESTATIONS",
                defaultMessage: "Last Reviewed Campaign"
            }
        },
        User_NEWMANAGER: {
            ATTESTATIONS: {
                id: "User_NEWMANAGER.ATTESTATIONS",
                defaultMessage: "User New Manager"
            }
        },
        USERCOUNT: {
            ATTESTATIONS: {
                id: "USERCOUNT.ATTESTATIONS",
                defaultMessage: "Accounts"
            }
        },
        CHILDCOUNT: {
            ATTESTATIONS: {
                id: "CHILDCOUNT.ATTESTATIONS",
                defaultMessage: "Child Entitlements"
            }
        },
        ENTCOMMENTS: {
            ATTESTATIONS: {
                id: "ENTCOMMENTS.ATTESTATIONS",
                defaultMessage: "Comments"
            }
        },
        ACCCOMMENT: {
            ATTESTATIONS: {
                id: "ACCCOMMENT.ATTESTATIONS",
                defaultMessage: "Comments"
            }
        },
        ACC_AUDIT_TRAIL: {
            ATTESTATIONS: {
                id: "ACC_AUDIT_TRAIL.ATTESTATIONS",
                defaultMessage: "History"
            }
        },
        ENT2COMMENTS: {
            ATTESTATIONS: {
                id: "ENT2COMMENTS.ATTESTATIONS",
                defaultMessage: "Comments"
            }
        },
        ENT2_AUDIT_TRAIL: {
            ATTESTATIONS: {
                id: "ENT2_AUDIT_TRAIL.ATTESTATIONS",
                defaultMessage: "History"
            }
        },
        ENT2NAME: {
            ATTESTATIONS: {
                id: "ENT2NAME.ATTESTATIONS",
                defaultMessage: "Child Entitlement"
            }
        },
        ENTTYPE: {
            ATTESTATIONS: {
                id: "ENTTYPE.ATTESTATIONS",
                defaultMessage: "Entitlement Type"
            }
        },
        User_ENTSODRISKS: {
            ATTESTATIONS: {
                id: "User_ENTSODRISKS.ATTESTATIONS",
                defaultMessage: "SOD Risks"
            }
        },
        SODRISKCOUNT: {
            ATTESTATIONS: {
                id: "SODRISKCOUNT.ATTESTATIONS",
                defaultMessage: "SOD Risks"
            }
        },
        Account_TOTALUSAGE: {
            ATTESTATIONS: {
                id: "Account_TOTALUSAGE.ATTESTATIONS",
                defaultMessage: "Total Usage"
            }
        },
        Account_UPDATEUSER: {
            ATTESTATIONS: {
                id: "Account_UPDATEUSER.ATTESTATIONS",
                defaultMessage: "Account Update User"
            }
        },
        Account_LASTCERTIFIEDACTION: {
            ATTESTATIONS: {
                id: "Account_LASTCERTIFIEDACTION.ATTESTATIONS",
                defaultMessage: "Last Certified Action"
            }
        },
        Account_LASTCERTIFIEDCOMMENT: {
            ATTESTATIONS: {
                id: "Account_LASTCERTIFIEDCOMMENT.ATTESTATIONS",
                defaultMessage: "Last Certified Comment"
            }
        },
        Role_NEWROLEOWNER: {
            ATTESTATIONS: {
                id: "Role_NEWROLEOWNER.ATTESTATIONS",
                defaultMessage: "New Role Owner"
            }
        },
        Role_OLDROLEOWNER: {
            ATTESTATIONS: {
                id: "Role_OLDROLEOWNER.ATTESTATIONS",
                defaultMessage: "Old Role Owner"
            }
        },
        User_USERSOURCE: {
            ATTESTATIONS: {
                id: "User_USERSOURCE.ATTESTATIONS",
                defaultMessage: "User Source"
            }
        },
        User_SOURCELASTLOGINDATE: {
            ATTESTATIONS: {
                id: "User_SOURCELASTLOGINDATE.ATTESTATIONS",
                defaultMessage: "Source Last Login Date"
            }
        },
        SOURCELASTLOGINDATE: {
            ATTESTATIONS: {
                id: "SOURCELASTLOGINDATE.ATTESTATIONS",
                defaultMessage: "Source Last Login Date"
            }
        },
        User_JRMRULES: {
            ATTESTATIONS: {
                id: "User_JRMRULES.ATTESTATIONS",
                defaultMessage: "Outlier Analysis"
            }
        },
        JSON_JRMRULESAVAILABLE: {
            ATTESTATIONS: {
                id: "JSON_JRMRULESAVAILABLE.ATTESTATIONS",
                defaultMessage: "Outlier Analysis"
            }
        },
        CUSTOMER: {
            ATTESTATIONS: {
                id: "CUSTOMER.ATTESTATIONS",
                defaultMessage: "User Customer"
            }
        },
        Ent_ENDPOINT: {
            ATTESTATIONS: {
                id: "Ent_ENDPOINT.ATTESTATIONS",
                defaultMessage: "Endpoint Name"
            }
        },
        Ent_ENTTYPE: {
            ATTESTATIONS: {
                id: "Ent_ENTTYPE.ATTESTATIONS",
                defaultMessage: "Entitlement Type"
            }
        },
        User_ENTDISPLAYNAME: {
            ATTESTATIONS: {
                id: "User_ENTDISPLAYNAME.ATTESTATIONS",
                defaultMessage: "Entitlement Display Name"
            }
        },
        User_ENDPOINT: {
            ATTESTATIONS: {
                id: "User_ENDPOINT.ATTESTATIONS",
                defaultMessage: "Endpoint Name"
            }
        },
        User_ENTTYPE: {
            ATTESTATIONS: {
                id: "User_ENTTYPE.ATTESTATIONS",
                defaultMessage: "Entitlement Type"
            }
        },
        Ent2_ENDPOINT: {
            ATTESTATIONS: {
                id: "Ent2_ENDPOINT.ATTESTATIONS",
                defaultMessage: "Endpoint Name"
            }
        },
        Ent2_ENTTYPE: {
            ATTESTATIONS: {
                id: "Ent2_ENTTYPE.ATTESTATIONS",
                defaultMessage: "Entitlement Type"
            }
        },
        NoActionRequired: {
            ATTESTATIONS: {
                id: "NoActionRequired.v2.label.ATTESTATIONS",
                defaultMessage: "No Action Required"
            }
        },
        "No Action Required": {
            ATTESTATIONS: {
                id: "NoActionRequired.v2.label.ATTESTATIONS",
                defaultMessage: "No Action Required"
            }
        },
        Done: {
            ATTESTATIONS: {
                id: "Done.v2.label.ATTESTATIONS",
                defaultMessage: "Done"
            }
        },
        Progress: {
            ATTESTATIONS: {
                id: "Progress.v2.label.ATTESTATIONS",
                defaultMessage: "Progress"
            }
        },
        EndDateChanged: {
            ATTESTATIONS: {
                id: "EndDateChanged.v2.label.ATTESTATIONS",
                defaultMessage: "End Date Changed"
            }
        },
        "End Date Changed": {
            ATTESTATIONS: {
                id: "EndDateChanged.v2.label.ATTESTATIONS",
                defaultMessage: "End Date Changed"
            }
        },
        Total: {
            ATTESTATIONS: {
                id: "Total.v2.label.ATTESTATIONS",
                defaultMessage: "Total"
            }
        },
        Approved: {
            ATTESTATIONS: {
                id: "Approved.v2.label.ATTESTATIONS",
                defaultMessage: "Approved"
            }
        },
        ManagerConfirmed: {
            ATTESTATIONS: {
                id: "ManagerConfirmed.v2.label.ATTESTATIONS",
                defaultMessage: "Manager Confirmed"
            }
        },
        "Manager Confirmed": {
            ATTESTATIONS: {
                id: "ManagerConfirmed.v2.label.ATTESTATIONS",
                defaultMessage: "Manager Confirmed"
            }
        },
        Rejected: {
            ATTESTATIONS: {
                id: "Rejected.v2.label.ATTESTATIONS",
                defaultMessage: "Rejected"
            }
        },
        Terminated: {
            ATTESTATIONS: {
                id: "Terminated.v2.label.ATTESTATIONS",
                defaultMessage: "Terminated"
            }
        },
        Pending: {
            ATTESTATIONS: {
                id: "Pending.v2.label.ATTESTATIONS",
                defaultMessage: "Pending"
            }
        },
        Account: {
            ATTESTATIONS: {
                id: "Account.v2.label.ATTESTATIONS",
                defaultMessage: "Account"
            }
        },
        Entitlement: {
            ATTESTATIONS: {
                id: "Entitlement.v2.label.ATTESTATIONS",
                defaultMessage: "Entitlement"
            }
        },
        Role: {
            ATTESTATIONS: {
                id: "Role.v2.label.ATTESTATIONS",
                defaultMessage: "Role"
            }
        },
        User: {
            ATTESTATIONS: {
                id: "User.v2.label.ATTESTATIONS",
                defaultMessage: "User"
            }
        },
        "Not Confirmed By Manager": {
            ATTESTATIONS: {
                id: "NotConfirmedByManager.v2.label.ATTESTATIONS",
                defaultMessage: "Not Confirmed By Manager"
            }
        },
        "Conditionally Certified": {
            ATTESTATIONS: {
                id: "ConditionallyCertified.v2.label.ATTESTATIONS",
                defaultMessage: "Conditionally Certified"
            }
        }
    }
};


function $e7628c995f405891$export$695b5822e913940f() {
    return window.envConfig || {};
}
const $e7628c995f405891$export$63087e5d2dd3ce07 = (ref, position)=>{
    if (ref.current && typeof ref.current === "object") ref.current.scroll({
        top: position,
        behavior: "smooth"
    });
};
const $e7628c995f405891$export$9ca4f3ab69295cac = (actions)=>{
    if (!actions) return false;
    const trackerActions = Object.keys(actions);
    const flag = Boolean(trackerActions.length > 0 && trackerActions?.some((key)=>{
        if (actions[key].shouldBeRemoved) return true;
        return false;
    }));
    return flag;
};
const $e7628c995f405891$export$8824054d4a42eac8 = (nodes)=>{
    const tempObj = [];
    nodes.forEach((node)=>{
        tempObj.push({
            ...node,
            children: []
        });
        if (node?.children && node?.children?.length > 0) tempObj.push(...$e7628c995f405891$export$8824054d4a42eac8(node?.children));
    });
    return tempObj;
};
// TODO: Remove later when not needed
// const sampleData = [
//   {
//     tile: 'user1',
//     tracker: {
//       id: 'ascwe',
//       level: 0,
//     },
//     children: [
//       {
//         tile: 'acc11',
//         tracker: {
//           id: 'iquye',
//           level: 1,
//         },
//         children: [
//           {
//             tile: 'ent111',
//             tracker: {
//               id: 'ehuiw',
//               level: 2,
//             },
//           },
//           {
//             tile: 'ent112',
//             tracker: {
//               id: 'ihacs',
//               level: 2,
//             },
//           },
//           {
//             tile: 'ent113',
//             tracker: {
//               id: 'wibuv',
//               level: 2,
//             },
//           },
//         ],
//       },
//       {
//         tile: 'role11',
//         tracker: {
//           id: 'amcxw',
//           level: 1,
//         },
//       },
//     ],
//   },
//   {
//     tile: 'user2',
//     tracker: {
//       id: 'nkjan',
//       level: 0,
//     },
//     children: [
//       {
//         tile: 'acc21',
//         tracker: {
//           id: 'ojasc',
//           level: 1,
//         },
//         children: [
//           {
//             tile: 'ent211',
//             tracker: {
//               id: 'woein',
//               level: 2,
//             },
//           },
//           {
//             tile: 'ent212',
//             tracker: {
//               id: 'widsa',
//               level: 2,
//             },
//           },
//         ],
//       },
//       {
//         tile: 'role21',
//         tracker: {
//           id: 'sodja',
//           level: 1,
//         },
//       },
//       {
//         tile: 'acc22',
//         tracker: {
//           id: 'qoanc',
//           level: 1,
//         },
//         children: [
//           {
//             tile: 'ent221',
//             tracker: {
//               id: 'wiued',
//               level: 2,
//             },
//           },
//           {
//             tile: 'ent222',
//             tracker: {
//               id: 'ncouw',
//               level: 2,
//             },
//           },
//           {
//             tile: 'ent223',
//             tracker: {
//               id: 'woien',
//               level: 2,
//             },
//           },
//           {
//             tile: 'ent224',
//             tracker: {
//               id: 'oiwjc',
//               level: 2,
//             },
//           },
//           {
//             tile: 'ent225',
//             tracker: {
//               id: 'wodiv',
//               level: 2,
//             },
//           },
//         ],
//       },
//       {
//         tile: 'acc23',
//         tracker: {
//           id: 'cwuvc',
//           level: 1,
//         },
//       },
//     ],
//   },
//   {
//     tile: 'user3',
//     tracker: {
//       id: 'ibcaj',
//       level: 0,
//     },
//   },
// ];
const $e7628c995f405891$var$HIERARCHY_KINDS = {
    parent: "parent",
    children: "children"
};
const $e7628c995f405891$export$66d087305585c751 = (nodes, targetNodeId, find = "parent")=>{
    if (!Object.values($e7628c995f405891$var$HIERARCHY_KINDS).includes(find)) return [];
    const tempNodes = Array.isArray(nodes) ? nodes : [
        nodes
    ];
    const nodesList = $e7628c995f405891$export$8824054d4a42eac8(tempNodes);
    const flattenedListLength = nodesList?.length;
    if (flattenedListLength === 0 || flattenedListLength === 1) return [];
    const targetNode = nodesList.find((node)=>node?.tracker?.id === targetNodeId);
    if (!targetNode) return [];
    const targetNodeLevel = targetNode?.tracker?.level;
    if (find === $e7628c995f405891$var$HIERARCHY_KINDS.parent) {
        if (targetNodeLevel === 0) return [];
        const flattenedList = nodesList.reverse();
        let hasLockedTargetNode = false;
        let currentParentLevel = targetNodeLevel - 1;
        const parentList = [];
        for(let i = 0; i < flattenedListLength; i += 1){
            if (!hasLockedTargetNode && flattenedList[i]?.tracker?.id === targetNodeId) hasLockedTargetNode = true;
            if (hasLockedTargetNode && flattenedList[i]?.tracker?.level === currentParentLevel) {
                parentList.push({
                    parent: targetNodeLevel - currentParentLevel,
                    ...flattenedList[i]?.tracker
                });
                currentParentLevel -= 1;
            }
            if (currentParentLevel < 0 || parentList.length === targetNodeLevel) return parentList;
        }
        return parentList;
    }
    if (find === $e7628c995f405891$var$HIERARCHY_KINDS.children) {
        const flattenedList = nodesList;
        let hasLockedTargetNode = false;
        let childrenCount = 1;
        const childrenList = [];
        for(let i = 0; i < flattenedListLength; i += 1){
            if (!hasLockedTargetNode && flattenedList[i]?.tracker?.id === targetNodeId) hasLockedTargetNode = true;
            if (hasLockedTargetNode && flattenedList[i]?.tracker?.level > targetNodeLevel) {
                childrenList.push({
                    children: childrenCount,
                    ...flattenedList[i]?.tracker
                });
                childrenCount += 1;
            }
            if (flattenedList[i]?.tracker?.level === targetNodeLevel && flattenedList[i]?.tracker?.id !== targetNodeId) return childrenList;
        }
        return childrenList;
    }
    return [];
};
const $e7628c995f405891$export$7cad4c9063025e24 = (name)=>(0, $135adfecc1ed8f07$export$9f3245bec405e186).certs[name]?.ATTESTATIONS || (0, $135adfecc1ed8f07$export$9f3245bec405e186).certs.DEFAULT.ATTESTATIONS;


const $d6d78fc758ee4148$export$f3d779ad78275d3b = "CERTDETAILS/SET_CERT_DETAILS_LISTS";
const $d6d78fc758ee4148$export$740ea107ca859e41 = "CERTDETAILS/SET_CERT_DETAILS_CERT_KEY";
const $d6d78fc758ee4148$export$f0d808954e0679c6 = "CERTDETAILS/CERT_DETAILS_LISTS_LOADING";
const $d6d78fc758ee4148$export$be9207d1796cf80 = "CERTDETAILS/CERT_DETAILS_LISTS_ERROR";
const $d6d78fc758ee4148$export$855d326a33362542 = "CERTDETAILS/SET_CERT_DETAILS_VIEW_COLUMNS_LIST";
const $d6d78fc758ee4148$export$f8b68a93cd1396c = "CERTDETAILS/SET_CERT_DETAILS_VIEW_ROWS_LIST";
const $d6d78fc758ee4148$export$7ce0be7ec08b7bd9 = "CERTDETAILS/SET_CERT_DETAILS_VIEW_CAMPAIGN_KEY";
const $d6d78fc758ee4148$export$9f85bed13d6d6867 = "CERTDETAILS/SET_CERT_DETAILS_COLUMN_PICKER_LIST";
const $d6d78fc758ee4148$export$3b55c5d9f617705a = "CERTDETAILS/CERT_DETAILS_COL_PICKER_LOADING";
const $d6d78fc758ee4148$export$20c37c78e4076fd7 = "CERTDETAILS/CERT_DETAILS_SIDE_PANEL_VISIBLE";
const $d6d78fc758ee4148$export$dd33a29cc9f55309 = "CERTDETAILS/CERT_DETAILS_TRIGGER_FROM_SEARCH";
const $d6d78fc758ee4148$export$e560b62bb0ef76ae = "CERTDETAILS/CERT_DETAILS_VIEW_LOADING";
const $d6d78fc758ee4148$export$903196cd760f40e2 = "CERTDETAILS/CERT_DETAILS_TRIGGER_FROM_SEARCH_OR_FILTER";
const $d6d78fc758ee4148$export$d954cd82d0ab56d0 = "CERTDETAILS/SET_CERT_FILTERS";
const $d6d78fc758ee4148$export$41e9b850f4b31bd = "CERTDETAILS/SET_CERT_TABS";
const $d6d78fc758ee4148$export$af468c26aae4b8fa = "CERTDETAILS/SET_ROWS_FILTERS";
const $d6d78fc758ee4148$export$9d483e8c06e94386 = "CERTDETAILS/SET_COLS_FILTERS";
const $d6d78fc758ee4148$export$8c4d8141d3ba5d38 = "CERTDETAILS/ACTIVE_ADVANCED_FILTERS";
const $d6d78fc758ee4148$export$2444563004f47e89 = "ERR_CANCELED";
const $d6d78fc758ee4148$export$b493d788e1fd3b9a = 10000;
const $d6d78fc758ee4148$export$bfbc2f51126156c = "CERTDETAILS/CERTS_RECORDS_COUNT";
const $d6d78fc758ee4148$export$3f218b7834ef2f49 = "CERTDETAILS/CERT_DETAILS_COLUMNS_TO_SHOW";
const $d6d78fc758ee4148$export$8a89d25d4ad8783e = "CERTDETAILS/SET_CLEAR_FILTERS_BTN_STATUS";
const $d6d78fc758ee4148$export$12cd07f9e71f98b = "CERTDETAILS/SET_CLEAR_SEARCH_BTN_STATUS";
const $d6d78fc758ee4148$export$1aaf381820aaad35 = "CERTDETAILS/CERT_DETAILS_VIEW_API_ERROR";
const $d6d78fc758ee4148$export$dd0462c52301fb4d = "CERTDETAILS/SET_CERT_DETAILS_VIEW_CERT_NAME";
const $d6d78fc758ee4148$export$5e310ea02d328fb1 = "CERTDETAILS/SET_CERT_DETAILS_VIEW_CERT_START_DATE";
const $d6d78fc758ee4148$export$51750fb5a6bddff5 = "CERTDETAILS/SET_CERT_DETAILS_VIEW_CERT_AUDITOR";
const $d6d78fc758ee4148$export$9a3ca9b6c1caafdf = "CERTDETAILS/SET_SIDE_PANEL_BODY_LOADING";
const $d6d78fc758ee4148$export$1b7cff865d967245 = "CERTDETAILS/SET_SIDE_PANEL_ERROR";
const $d6d78fc758ee4148$export$44cea83c7eb86289 = "CERTDETAILS/SET_SIDE_PANEL_SUMMARY_ENTITLEMENTS";
const $d6d78fc758ee4148$export$a252b37c42fd39c0 = "CERTDETAILS/SET_SIDE_PANEL_HISTORY2_ENTITLEMENTS";
const $d6d78fc758ee4148$export$46e200503484c25f = "CERTDETAILS/SET_SIDE_PANEL_SOD_ENTITLEMENTS";
const $d6d78fc758ee4148$export$a71fe6648e4ae608 = "CERTDETAILS/SET_SIDE_PANEL_PRIVILEGES_ENTITLEMENTS";
const $d6d78fc758ee4148$export$842ba02ccf54b42b = "CERTDETAILS/SET_SIDE_PANEL_CHILDREN_ENTITLEMENTS";
const $d6d78fc758ee4148$export$b98808434921fbb1 = "CERTDETAILS/SET_SIDE_PANEL_SUMMARY_ACCOUNTS";
const $d6d78fc758ee4148$export$7f0539351068ca18 = "CERTDETAILS/SET_SIDE_PANEL_HISTORY2_ACCOUNTS";
const $d6d78fc758ee4148$export$a7a89423fc1f2d99 = "CERTDETAILS/SET_SIDE_PANEL_SUMMARY_USERS";
const $d6d78fc758ee4148$export$e6ae9922b78d19ee = "CERTDETAILS/SET_SIDE_PANEL_HISTORY2_USERS";
const $d6d78fc758ee4148$export$85fb16097b911 = "CERTDETAILS/SET_SIDE_PANEL_SUMMARY_ROLES";
const $d6d78fc758ee4148$export$b0fdc72ce6a50d97 = "CERTDETAILS/SET_SIDE_PANEL_HISTORY2_ROLES";
const $d6d78fc758ee4148$export$940b9d07f90752d = "CERTDETAILS/SET_SIDE_PANEL_ENTITLEMENT_ROLES";
const $d6d78fc758ee4148$export$d4c8fbbc4fca0999 = "CERTDETAILS/SET_SIDE_PANEL_CHILDREN_ROLES";
const $d6d78fc758ee4148$export$95aee1eca5275acc = "CERTDETAILS/SIDE_PANEL_INITIAL_LOAD";
const $d6d78fc758ee4148$export$2e6684ed5543ad11 = "CERTDETAILS/SIDE_PANEL_LOAD_MORE_FLAG";
const $d6d78fc758ee4148$export$e87c818aed68e8cb = "CERTDETAILS/SET_OPEN_STATUS_AND_ARSTASKKEY_FOR_ARS_MODAL";
const $d6d78fc758ee4148$export$7a8caab59b607807 = "CERTDETAILS/SET_LOADING_FOR_ARS_MODAL";
const $d6d78fc758ee4148$export$8671c3354e9690ea = "CERTDETAILS/SET_ERROR_FOR_ARS_MODAL";
const $d6d78fc758ee4148$export$dcc76e3383a21811 = "CERTDETAILS/SET_DATA_FOR_ARS_MODAL";
const $d6d78fc758ee4148$export$b0c18ac3058b419e = "CERTDETAILS/SET_SHOW_BULK_SELECT_CHEKBOX";
const $d6d78fc758ee4148$export$bfbc1bdccfb4abf5 = "CERTDETAILS/SET_CHECK_FOR_BULK_CHEKBOX";
const $d6d78fc758ee4148$export$69729db10395ff90 = "CERTDETAILS/SET_INDETERMINATE_FOR_BULK_CHEKBOX";
const $d6d78fc758ee4148$export$768f00e6b30d478 = "CERTDETAILS/SET_BULK_FOOTER_SHOW";
const $d6d78fc758ee4148$export$2d1f20523798a1b7 = "CERTDETAILS/SET_BULK_FOOTER_DATA";
const $d6d78fc758ee4148$export$60473f3971dee5df = "CERTDETAILS/SET_DISABLE_FOR_BULK_SELECT_ALL";
const $d6d78fc758ee4148$export$2890f4c8d2907863 = "CERTDETAILS/SET_SUBMIT_FOR_BULK_SELECT_ALL";
const $d6d78fc758ee4148$export$42cd2e4c8af9ab41 = "CERTDETAILS/SET_ATLEAST_ONE_IS_SELECTED";
const $d6d78fc758ee4148$export$98054ce8e1cd6185 = "CERTDETAILS/SET_BULK_ACTIONS_ALERT";
const $d6d78fc758ee4148$export$8cf310caad6b6ea7 = "CERTDETAILS/SET_BULK_ACTIONS_SELECTED_ITEMS_LIST";
const $d6d78fc758ee4148$export$afe1eb1cba0072ef = "CERTDETAILS/SET_BULK_ACTIONS_ACTION_BY_SELECT_ALL";
const $d6d78fc758ee4148$export$c19826a63dd39ec7 = "CERTDETAILS/SET_BULK_ACTIONS_ISSUBMITTING";
const $d6d78fc758ee4148$export$1d889ec5a0bd35b5 = "CERTDETAILS/REVIEW_AND_SUBMIT_LOADING";
const $d6d78fc758ee4148$export$32524a0d8ac0b191 = "CERTDETAILS/REVIEW_AND_SUBMIT_ERROR";
const $d6d78fc758ee4148$export$6375a4b78a6ebe = "CERTDETAILS/REVIEW_AND_SUBMIT_CONFIG";
const $d6d78fc758ee4148$export$8fa9055a97f67430 = "CERTDETAILS/REVIEW_AND_SUBMIT_BTN_SUBMIT_PRESS";
const $d6d78fc758ee4148$export$b1c80b328234b28e = "CERTDETAILS/REVIEW_AND_SUBMIT_STEP_1_DATA";
const $d6d78fc758ee4148$export$1b59f0ddd56aa357 = "CERTDETAILS/SET_REVIEW_AND_SUBMIT_BTN_DISPLAY";
const $d6d78fc758ee4148$export$8b461e828675fe2 = "CERTDETAILS/POST_TAB_COUNTS_ERROR";
const $d6d78fc758ee4148$export$bcfd799e4df08939 = "CERTDETAILS/POST_TAB_COUNTS_LOADING";
const $d6d78fc758ee4148$export$b61e16101d4e3f64 = "CERTDETAILS/POST_TAB_COUNTS_SUCCESS";
const $d6d78fc758ee4148$export$b77c91b145bf9647 = "SET_PROGRESS_BREAKDOWN_DETAILS";
const $d6d78fc758ee4148$export$5296abadcbacb235 = "SET_PROGRESS_BREAKDOWN_DETAILS_LOADING";
const $d6d78fc758ee4148$export$569cf9037aa74da = "SET_PROGRESS_BREAKDOWN_DETAILS_ERROR";
const $d6d78fc758ee4148$export$e7b0a9aed86b0918 = "SET_DYNAMIC_SORT_FILTER_DETAILS";
const $d6d78fc758ee4148$export$8810396661da9a69 = "RESET_DYNAMIC_SORT_FILTER_DETAILS";
const $d6d78fc758ee4148$export$87218027c7ad9093 = "SET_ENABLE_INDIVIDUAL_COMMENTS";
const $d6d78fc758ee4148$export$8ca82b86b34f725b = "SET_ACTION_LOADING";
const $d6d78fc758ee4148$export$b3c7c737b53ea33e = "SET_ACTION_SUCCESS";
const $d6d78fc758ee4148$export$3564fc123aed043c = "SET_ACTION_RESET";
const $d6d78fc758ee4148$export$5755ae8e491f730 = "SET_ACTION_ERROR";
const $d6d78fc758ee4148$export$a8aa77f63d5aad19 = "SET_CERT_DETAILS_TERMINATE_COMMENTS";
const $d6d78fc758ee4148$export$f7b4124f0c0fddd2 = "SET_CERT_DETAILS_TERMINATE_CONFIG_MAP";
const $d6d78fc758ee4148$export$64b8a5600bac3cf7 = "SET_ACTION_SUCCESS_TERMINATE";
const $d6d78fc758ee4148$export$1bdde0917053ab5d = "SET_USERS_LIST";
const $d6d78fc758ee4148$export$3454dc93d4b256c8 = "SET_FETCH_USER_LIST_LOADING";
const $d6d78fc758ee4148$export$3d55f922eb0f4b = "SET_FETCH_USER_LIST_ERROR";
const $d6d78fc758ee4148$export$dd6b8d2bd42778be = "SET_REASSIGN_CONFIG";
const $d6d78fc758ee4148$export$6eb1d8263e7e2d01 = "SET_IS_REASSIGN_WARN_MSG_OPENED";
const $d6d78fc758ee4148$export$7fbc63266c535cea = "SET_IS_REASSIGN_POPOVER_MSG";
const $d6d78fc758ee4148$export$4f8e3fc5251d1e82 = "GET_SAVI_COMPANION_STATUS";
const $d6d78fc758ee4148$export$df3ba5c051a876de = "GET_SAVI_COMPANION_STATUS_LOAD";
const $d6d78fc758ee4148$export$4009fb2303280d3a = "GET_SAVI_COMPANION_STATUS_SUCCESS";
const $d6d78fc758ee4148$export$9b4357356da505fc = "GET_SAVI_COMPANION_STATUS_FAILURE";
const $d6d78fc758ee4148$export$7511d3817c55117f = "APPLY_SAVI_COMPANION_ACTIONS";
const $d6d78fc758ee4148$export$a0f86ea1258b795c = "APPLY_SAVI_COMPANION_ACTIONS_LOAD";
const $d6d78fc758ee4148$export$b021d9c474ee48de = "APPLY_SAVI_COMPANION_ACTIONS_SUCCESS";
const $d6d78fc758ee4148$export$7e0741aad82ab94b = "APPLY_SAVI_COMPANION_ACTIONS_FAILURE";
const $d6d78fc758ee4148$export$1e4b8a34c93a7dd0 = "SET_IS_SAVI_COMPANION_ENABLED";


const $d623f23401a154f0$var$cookies = new (0, $hopDi$Cookies)();
const $d623f23401a154f0$var$reviewAndSubmitESignatureLoginCredentialsField = "userName";
let $d623f23401a154f0$var$cancelTokenForCertDetailsData;
let $d623f23401a154f0$var$cancelTokenForClearCertsFilter;
let $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForUsers;
let $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForUsers;
let $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForRoles;
let $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForRoles;
let $d623f23401a154f0$var$cancelTokenForSidePanelBodyChildForRoles;
let $d623f23401a154f0$var$cancelTokenForSidePanelBodyEntitlementForRoles;
let $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForAccounts;
let $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForAccounts;
let $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForEntitlements;
let $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForEntitlements;
let $d623f23401a154f0$var$cancelTokenForSidePanelBodySodForEntitlements;
let $d623f23401a154f0$var$cancelTokenForSidePanelBodyPrivilegesForEntitlements;
let $d623f23401a154f0$var$cancelTokenForSidePanelBodyChildForEntitlements;
let $d623f23401a154f0$var$cancelTokenForAccessRequestHistory;
const $d623f23401a154f0$var$tabMapping = {
    [(0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49)]: "todo",
    [(0, $d44c789d5b60f9bf$export$807a0bc890800408)]: "done",
    [(0, $d44c789d5b60f9bf$export$d5eea126dff5a615)]: "all",
    [(0, $d44c789d5b60f9bf$export$b2766b46106d3053)]: "consulted"
};
const $d623f23401a154f0$var$ALLOWED_CERTIFICATION_STATUS_FOR_REVIEW_AND_SUBMIT = [
    0,
    1,
    2
];
const $d623f23401a154f0$export$1a246502936ad896 = (certKey)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$740ea107ca859e41),
            payload: certKey
        });
    };
const $d623f23401a154f0$export$ebe6b5ce6ed9ef39 = (isVisible)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$20c37c78e4076fd7),
            payload: isVisible
        });
    };
const $d623f23401a154f0$export$877a3b3409060dd6 = (filters)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$8c4d8141d3ba5d38),
            payload: {
                results: filters
            }
        });
    };
const $d623f23401a154f0$export$86d11b633a5d59e6 = (status)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$8a89d25d4ad8783e),
            payload: status
        });
    };
const $d623f23401a154f0$export$661e1772dd5a4141 = (status)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$12cd07f9e71f98b),
            payload: status
        });
    };
const $d623f23401a154f0$export$a7b1b02371ce779a = (trigger)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$903196cd760f40e2),
            payload: trigger
        });
    };
const $d623f23401a154f0$export$e9c5cd8aea0cabc7 = (tabs)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$41e9b850f4b31bd),
            payload: {
                results: tabs
            }
        });
    };
const $d623f23401a154f0$export$afd1b438af1720fe = (certKey, isFirstTime = false)=>async (dispatch, getState)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const body = {
            certkey: certKey
        };
        if (isFirstTime) body.fetchAllCount = "true";
        const { tabs: tabs } = getState().certifications;
        const allTab = tabs?.tabData?.find((item)=>item.key === (0, $d44c789d5b60f9bf$export$d5eea126dff5a615));
        dispatch({
            type: (0, $d6d78fc758ee4148$export$bcfd799e4df08939)
        });
        try {
            const { data: data } = await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/getTabCount`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body
            });
            // Map API response to the corresponding count based on the tab
            const consultedCount = data[`${$d623f23401a154f0$var$tabMapping[0, $d44c789d5b60f9bf$export$b2766b46106d3053]}Count`];
            const doneCount = data[`${$d623f23401a154f0$var$tabMapping[0, $d44c789d5b60f9bf$export$807a0bc890800408]}Count`];
            dispatch({
                type: (0, $d6d78fc758ee4148$export$b61e16101d4e3f64),
                payload: {
                    certKey: certKey,
                    tab: (0, $d44c789d5b60f9bf$export$b2766b46106d3053),
                    count: consultedCount
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$b61e16101d4e3f64),
                payload: {
                    certKey: certKey,
                    tab: (0, $d44c789d5b60f9bf$export$807a0bc890800408),
                    count: doneCount
                }
            });
            if (isFirstTime) {
                const allCount = data[`${$d623f23401a154f0$var$tabMapping[0, $d44c789d5b60f9bf$export$d5eea126dff5a615]}Count`];
                dispatch({
                    type: (0, $d6d78fc758ee4148$export$b61e16101d4e3f64),
                    payload: {
                        certKey: certKey,
                        tab: (0, $d44c789d5b60f9bf$export$d5eea126dff5a615),
                        count: allCount
                    }
                });
                dispatch({
                    type: (0, $d6d78fc758ee4148$export$b61e16101d4e3f64),
                    payload: {
                        certKey: certKey,
                        tab: (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49),
                        count: allCount - doneCount - consultedCount
                    }
                });
            } else dispatch({
                type: (0, $d6d78fc758ee4148$export$b61e16101d4e3f64),
                payload: {
                    certKey: certKey,
                    tab: (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49),
                    count: allTab.count - doneCount - consultedCount
                }
            });
        } catch (error) {
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1aaf381820aaad35),
                payload: {
                    isError: true
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$8b461e828675fe2),
                payload: {
                    error: error.message
                }
            });
        }
    };
const $d623f23401a154f0$export$d290070680bebdf9 = (rowsFilters)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$af468c26aae4b8fa),
            payload: {
                results: rowsFilters
            }
        });
    };
const $d623f23401a154f0$export$b551d76884371ba3 = (colsFilters)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$9d483e8c06e94386),
            payload: {
                results: colsFilters
            }
        });
    };
const $d623f23401a154f0$export$44dea541cc9e89ed = (colToShow)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$3f218b7834ef2f49),
            payload: colToShow
        });
    };
const $d623f23401a154f0$export$61e757f80085daf4 = (status)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$9a3ca9b6c1caafdf),
            payload: status
        });
    };
const $d623f23401a154f0$export$eb61ad48998e2c20 = (status)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$1d889ec5a0bd35b5),
            payload: status
        });
    };
const $d623f23401a154f0$export$dadc0bb56f5e8946 = (status)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$8fa9055a97f67430),
            payload: status
        });
    };
const $d623f23401a154f0$export$fad033acbe739b9c = (certKey, columnNames, max, offset, searchText = "")=>async (dispatch, getState)=>{
        const { isLoading: isLoading, tabs: tabs, dynamicSortFilter: dynamicSortFilter } = getState().certifications;
        const { tabData: tabData } = tabs;
        // Get the active tab key
        const activeTabKey = tabData?.find((tab)=>tab.isActive).key;
        const activeTab = $d623f23401a154f0$var$tabMapping[activeTabKey] || "all";
        const { sortByColumn: sortByColumn, sortDirection: sortDirection } = dynamicSortFilter;
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const body = {
            certkey: certKey,
            max: `${max}`,
            offset: `${offset}`,
            requestOrigin: "UI",
            sSearch: `${searchText}`,
            columnsToShow: columnNames,
            tab: activeTab
        };
        if (sortByColumn && sortDirection) {
            body.columnNameToSort = sortByColumn;
            body.order = sortDirection;
        }
        if (!isLoading) dispatch({
            type: (0, $d6d78fc758ee4148$export$f0d808954e0679c6),
            payload: true
        });
        dispatch({
            type: (0, $d6d78fc758ee4148$export$be9207d1796cf80),
            payload: {
                isError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForCertDetailsData !== "undefined") $d623f23401a154f0$var$cancelTokenForCertDetailsData.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForCertDetailsData = (0, $hopDi$axios).CancelToken.source();
            const { data: data } = await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/items`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body,
                cancelToken: $d623f23401a154f0$var$cancelTokenForCertDetailsData.token,
                timeout: (0, $d6d78fc758ee4148$export$b493d788e1fd3b9a)
            });
            const { results: results, total: total } = data;
            dispatch({
                type: (0, $d6d78fc758ee4148$export$f3d779ad78275d3b),
                payload: {
                    results: results,
                    total: total,
                    searchText: searchText,
                    error: null
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$f0d808954e0679c6),
                payload: false
            });
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) {
                dispatch({
                    type: (0, $d6d78fc758ee4148$export$f3d779ad78275d3b),
                    payload: {
                        results: null,
                        error: "Data Fetch Error"
                    }
                });
                dispatch({
                    type: (0, $d6d78fc758ee4148$export$f0d808954e0679c6),
                    payload: false
                });
            }
            dispatch({
                type: (0, $d6d78fc758ee4148$export$be9207d1796cf80),
                payload: {
                    isError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
        }
    };
const $d623f23401a154f0$export$889bd3e7f249bccd = (certKey)=>async (dispatch)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const body = {
            certkey: certKey
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$e560b62bb0ef76ae),
            payload: true
        });
        dispatch({
            type: (0, $d6d78fc758ee4148$export$1aaf381820aaad35),
            payload: {
                isError: false,
                error: null
            }
        });
        try {
            const { data: data } = await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/items/view`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body
            });
            const { certificationStatus: certificationStatus, consulteeLoggedIn: consulteeLoggedIn, defaultReassigneeName: defaultReassigneeName, enableloginSignature: enableloginSignature, objectsToBeIncluded: objectsToBeIncluded, columnList: columnList, campaignKey: campaignKey, certification_name: certification_name, configMap: configMap, noOfTries: noOfTries, enableIndividualCommentsForUsers: enableIndividualCommentsForUsers, enableIndividualCommentsForAccountEntitlementRoles: enableIndividualCommentsForAccountEntitlementRoles, role_AuditorLoggedIn: role_AuditorLoggedIn, enableReassignUser: enableReassignUser, defaultReassignee: defaultReassignee, enableReassignStep2: enableReassignStep2, campaignMap: campaignMap, savi_enabled: savi_enabled } = data;
            const shouldShowReviewAndSubmitButton = Boolean(!role_AuditorLoggedIn && ($d623f23401a154f0$var$ALLOWED_CERTIFICATION_STATUS_FOR_REVIEW_AND_SUBMIT.includes(Number(certificationStatus)) || configMap?.hasValidAccess));
            // config for reassign user
            const reassignConfig = {
                enableReassignUser: enableReassignUser,
                enableReassignStep2: enableReassignStep2,
                defaultReassignee: defaultReassignee || configMap.defaultReassignee,
                defaultReassigneeName: defaultReassigneeName,
                enableIndividualCommentsForAccountEntitlementRoles: enableIndividualCommentsForAccountEntitlementRoles,
                enableIndividualCommentsForUsers: enableIndividualCommentsForUsers,
                showReassignPopup: configMap.SHOWREASSIGNPOPUP
            };
            dispatch({
                type: (0, $d6d78fc758ee4148$export$dd6b8d2bd42778be),
                payload: reassignConfig
            });
            // TODO: need to check If we need columnList
            dispatch({
                type: (0, $d6d78fc758ee4148$export$f8b68a93cd1396c),
                payload: {
                    rowsList: objectsToBeIncluded
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$855d326a33362542),
                payload: {
                    columnList: columnList
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$7ce0be7ec08b7bd9),
                payload: {
                    campaignKey: campaignKey
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$5e310ea02d328fb1),
                payload: {
                    certification_start_date: campaignMap?.startDate
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$dd0462c52301fb4d),
                payload: {
                    certification_name: certification_name
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$f7b4124f0c0fddd2),
                payload: {
                    configMap: configMap
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$51750fb5a6bddff5),
                payload: {
                    isAuditor: role_AuditorLoggedIn || false
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$a8aa77f63d5aad19),
                payload: {
                    enableIndividualCommentsForUsers: enableIndividualCommentsForUsers
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$6375a4b78a6ebe),
                payload: {
                    certificationStatus: Number(certificationStatus),
                    hasValidAccess: Boolean(configMap?.hasValidAccess),
                    primaryCertifier: !consulteeLoggedIn,
                    primaryCertifierName: defaultReassigneeName,
                    withESignature: Boolean(Number(configMap.ENABLE_ESIGNATURE) || Number(enableloginSignature)),
                    userAttribute: configMap.USERATTRIBUTE_ESIGNATURE || $d623f23401a154f0$var$reviewAndSubmitESignatureLoginCredentialsField,
                    enableloginSignature: enableloginSignature,
                    noOfTries: noOfTries
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$87218027c7ad9093),
                payload: {
                    enableIndividualCommentsForUsers: enableIndividualCommentsForUsers,
                    enableIndividualCommentsForAccountEntitlementRoles: enableIndividualCommentsForAccountEntitlementRoles
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1b59f0ddd56aa357),
                payload: Boolean(shouldShowReviewAndSubmitButton)
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1e4b8a34c93a7dd0),
                payload: savi_enabled === "1"
            });
        } catch (error) {
            dispatch({
                type: (0, $d6d78fc758ee4148$export$855d326a33362542),
                payload: {
                    columnList: null
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$7ce0be7ec08b7bd9),
                payload: {
                    campaignKey: null
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1aaf381820aaad35),
                payload: {
                    isError: true
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$dd0462c52301fb4d),
                payload: {
                    certification_name: null
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$5e310ea02d328fb1),
                payload: {
                    certification_start_date: null
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$f7b4124f0c0fddd2),
                payload: {
                    configMap: null
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$a8aa77f63d5aad19),
                payload: {
                    enableIndividualCommentsForUsers: null
                }
            });
        } finally{
            dispatch({
                type: (0, $d6d78fc758ee4148$export$e560b62bb0ef76ae),
                payload: false
            });
        }
    };
const $d623f23401a154f0$export$7f8f83f9a8bce93a = (campaignKey)=>async (dispatch)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const body = {
            campaignKey: campaignKey
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$3b55c5d9f617705a),
            payload: true
        });
        dispatch({
            type: (0, $d6d78fc758ee4148$export$be9207d1796cf80),
            payload: false
        });
        try {
            const { data: data } = await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/fetchColumnsPickerList`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body,
                timeout: (0, $d6d78fc758ee4148$export$b493d788e1fd3b9a)
            });
            const { resultsList: resultsList } = data;
            dispatch({
                type: (0, $d6d78fc758ee4148$export$9f85bed13d6d6867),
                payload: resultsList
            });
        } catch (error) {
            dispatch({
                type: (0, $d6d78fc758ee4148$export$855d326a33362542),
                payload: {
                    columnList: null
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$3b55c5d9f617705a),
                payload: false
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$be9207d1796cf80),
                payload: {
                    isError: true,
                    error: "Failed to fetch columns"
                }
            });
        } finally{
            dispatch({
                type: (0, $d6d78fc758ee4148$export$3b55c5d9f617705a),
                payload: false
            });
        }
    };
const $d623f23401a154f0$export$4d715bff11887d61 = (certKey)=>async (dispatch, getState)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const { columnNames: columnNames } = getState().certifications;
        const body = {
            certkey: certKey,
            filterColumns: columnNames
        };
        try {
            const { data: data } = await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/items/filters`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body
            });
            const { valueCountMap: valueCountMap, messageKeys: messageKeys } = data;
            dispatch({
                type: (0, $d6d78fc758ee4148$export$be9207d1796cf80),
                payload: {
                    isError: false,
                    error: null
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$d954cd82d0ab56d0),
                payload: {
                    results: {
                        valueCountMap: valueCountMap,
                        messageKeys: messageKeys
                    }
                }
            });
        } catch (error) {
            dispatch({
                type: (0, $d6d78fc758ee4148$export$d954cd82d0ab56d0),
                payload: {
                    results: null
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$be9207d1796cf80),
                payload: {
                    isError: true,
                    error: "Failed to fetch filter data"
                }
            });
        }
    };
const $d623f23401a154f0$export$1f0b8da065fa133a = (filterKey, filterValue, isChecked)=>async (dispatch, getState)=>{
        const { isLoading: isLoading, certKey: certKey } = getState().certifications;
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const body = {
            fieldname: filterKey,
            value: filterValue,
            checked: isChecked ? "1" : "0",
            certkey: certKey
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$903196cd760f40e2),
            payload: true
        });
        if (!isLoading) dispatch({
            type: (0, $d6d78fc758ee4148$export$f0d808954e0679c6),
            payload: true
        });
        dispatch({
            type: (0, $d6d78fc758ee4148$export$be9207d1796cf80),
            payload: {
                isError: false,
                error: null
            }
        });
        try {
            const response = await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/updatefilter`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body,
                timeout: (0, $d6d78fc758ee4148$export$b493d788e1fd3b9a)
            });
            if (response.status === 200) return true;
            throw Error("No 200 response from server");
        } catch (error) {
            dispatch({
                type: (0, $d6d78fc758ee4148$export$be9207d1796cf80),
                payload: {
                    isError: true,
                    error: "Failed to update filter"
                }
            });
        }
    };
const $d623f23401a154f0$export$5ef35f45efc10503 = ()=>async (dispatch, getState)=>{
        const { isLoading: isLoading } = getState().certifications;
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const body = {
            clearFilter: "true"
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$903196cd760f40e2),
            payload: true
        });
        if (!isLoading) dispatch({
            type: (0, $d6d78fc758ee4148$export$f0d808954e0679c6),
            payload: true
        });
        dispatch({
            type: (0, $d6d78fc758ee4148$export$be9207d1796cf80),
            payload: {
                isError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForClearCertsFilter !== "undefined") $d623f23401a154f0$var$cancelTokenForClearCertsFilter.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForClearCertsFilter = (0, $hopDi$axios).CancelToken.source();
            const { status: status } = await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/updatefilter`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body,
                cancelToken: $d623f23401a154f0$var$cancelTokenForClearCertsFilter.token,
                timeout: (0, $d6d78fc758ee4148$export$b493d788e1fd3b9a)
            });
            if (status === 200) return true;
            throw Error("No 200 response from server");
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$f0d808954e0679c6),
                payload: false
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$be9207d1796cf80),
                payload: {
                    isError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Failed to clear filter" : "Data Fetch Error"
                }
            });
        }
    };
const $d623f23401a154f0$export$965ea1a49a0c67d1 = (eid, certkey, cert_entitlement_valuekey)=>async (dispatch)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const body = {
            eid: eid,
            certkey: certkey,
            cert_entitlement_valuekey: cert_entitlement_valuekey
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
            payload: {
                isSidePanelError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForEntitlements !== "undefined") $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForEntitlements.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForEntitlements = (0, $hopDi$axios).CancelToken.source();
            const { data: data } = await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/entitlementSummary`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body,
                cancelToken: $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForEntitlements.token,
                timeout: (0, $d6d78fc758ee4148$export$b493d788e1fd3b9a)
            });
            const { response: response } = data;
            dispatch({
                type: (0, $d6d78fc758ee4148$export$44cea83c7eb86289),
                payload: {
                    results: response,
                    error: null
                }
            });
            return 0, $d60257e8dc27bf16$export$bde14d5a1cbdb371;
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$44cea83c7eb86289),
                payload: {
                    results: null,
                    error: "Data Fetch Error"
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$46991d3da34782bf = (certkey, cert_entitlement_valuekey, cert_userkey, cert_accountkey, cert_rolekey)=>async (dispatch)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const body = {
            certkey: certkey,
            cert_entitlement_valuekey: cert_entitlement_valuekey,
            cert_userkey: cert_userkey,
            cert_accountkey: cert_accountkey,
            cert_rolekey: cert_rolekey
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
            payload: {
                isSidePanelError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForEntitlements !== "undefined") $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForEntitlements.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForEntitlements = (0, $hopDi$axios).CancelToken.source();
            const { data: data } = await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/items/auditHistory`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body,
                cancelToken: $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForEntitlements.token,
                timeout: (0, $d6d78fc758ee4148$export$b493d788e1fd3b9a)
            });
            const { response: response } = data;
            dispatch({
                type: (0, $d6d78fc758ee4148$export$a252b37c42fd39c0),
                payload: {
                    results: typeof response === "object" && Array.isArray(response) ? response?.map((item, index)=>({
                            ...item,
                            index: index
                        })) : null,
                    error: null
                }
            });
            if (typeof response === "string") dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: true,
                    error: response
                }
            });
            return 0, $d60257e8dc27bf16$export$9b67fda1e37e6e63;
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$a252b37c42fd39c0),
                payload: {
                    results: null,
                    error: "Data Fetch Error"
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$83557c31dc95212a = (cert_entitlement_valuekey, cert_accountkey, offset, max)=>async (dispatch)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const body = {
            cert_entitlement_valuekey: cert_entitlement_valuekey,
            cert_accountkey: cert_accountkey,
            offset: offset,
            max: max
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
            payload: {
                isSidePanelError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForSidePanelBodyPrivilegesForEntitlements !== "undefined") $d623f23401a154f0$var$cancelTokenForSidePanelBodyPrivilegesForEntitlements.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForSidePanelBodyPrivilegesForEntitlements = (0, $hopDi$axios).CancelToken.source();
            const { data: data } = await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/items/entitlementPrivileges`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body,
                cancelToken: $d623f23401a154f0$var$cancelTokenForSidePanelBodyPrivilegesForEntitlements.token,
                timeout: (0, $d6d78fc758ee4148$export$b493d788e1fd3b9a)
            });
            const { response: response } = data;
            dispatch({
                type: (0, $d6d78fc758ee4148$export$a71fe6648e4ae608),
                payload: {
                    results: typeof response === "object" ? response : null,
                    error: null
                }
            });
            return 0, $d60257e8dc27bf16$export$a06b6c2be556dac8;
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$a71fe6648e4ae608),
                payload: {
                    results: null,
                    error: "Data Fetch Error"
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$1fbc321c679e35cc = (certkey, cert_entitlement_valuekey, cert_accountkey, offset, max, searchKey = "", loadMoreStatus = (0, $d6d78fc758ee4148$export$95aee1eca5275acc))=>async (dispatch)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const body = {
            certkey: certkey,
            cert_entitlement_valuekey: cert_entitlement_valuekey,
            cert_accountkey: cert_accountkey,
            offset: offset,
            max: max,
            searchKey: searchKey
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
            payload: {
                isSidePanelError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForSidePanelBodySodForEntitlements !== "undefined") $d623f23401a154f0$var$cancelTokenForSidePanelBodySodForEntitlements.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForSidePanelBodySodForEntitlements = (0, $hopDi$axios).CancelToken.source();
            const { data: data } = await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/items/entitlementSOD`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body,
                cancelToken: $d623f23401a154f0$var$cancelTokenForSidePanelBodySodForEntitlements.token,
                timeout: (0, $d6d78fc758ee4148$export$b493d788e1fd3b9a)
            });
            const { response: response } = data;
            if (loadMoreStatus === (0, $d6d78fc758ee4148$export$95aee1eca5275acc)) dispatch({
                type: (0, $d6d78fc758ee4148$export$46e200503484c25f),
                loadMoreStatus: loadMoreStatus,
                payload: {
                    results: {
                        ...response,
                        risks: response?.risks.map((item, index)=>({
                                ...item,
                                index: `${offset}-${index}`
                            }))
                    },
                    error: null
                }
            });
            if (loadMoreStatus === (0, $d6d78fc758ee4148$export$2e6684ed5543ad11)) dispatch({
                type: (0, $d6d78fc758ee4148$export$46e200503484c25f),
                loadMoreStatus: loadMoreStatus,
                payload: {
                    results: response?.risks.map((item, index)=>({
                            ...item,
                            index: `${offset}-${index}`
                        }))
                }
            });
            return 0, $d60257e8dc27bf16$export$8f78881bb4058858;
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$46e200503484c25f),
                payload: {
                    results: null,
                    error: "Data Fetch Error"
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$f8b073a05f313ac0 = (cert_entitlement_valuekey, offset, max, loadMoreStatus = (0, $d6d78fc758ee4148$export$95aee1eca5275acc))=>async (dispatch)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const body = {
            cert_entitlement_valuekey: cert_entitlement_valuekey,
            offset: offset,
            max: max
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
            payload: {
                isSidePanelError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForSidePanelBodyChildForEntitlements !== "undefined") $d623f23401a154f0$var$cancelTokenForSidePanelBodyChildForEntitlements.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForSidePanelBodyChildForEntitlements = (0, $hopDi$axios).CancelToken.source();
            const { data: data } = await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/items/childEntitlements`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body,
                cancelToken: $d623f23401a154f0$var$cancelTokenForSidePanelBodyChildForEntitlements.token,
                timeout: (0, $d6d78fc758ee4148$export$b493d788e1fd3b9a)
            });
            const { response: response } = data;
            if (loadMoreStatus === (0, $d6d78fc758ee4148$export$95aee1eca5275acc)) dispatch({
                type: (0, $d6d78fc758ee4148$export$842ba02ccf54b42b),
                loadMoreStatus: loadMoreStatus,
                payload: {
                    results: {
                        ...response,
                        childEntList: response?.childEntList.map((item, index)=>({
                                ...item,
                                index: `${offset}-${index}`
                            }))
                    },
                    error: null
                }
            });
            if (loadMoreStatus === (0, $d6d78fc758ee4148$export$2e6684ed5543ad11)) dispatch({
                type: (0, $d6d78fc758ee4148$export$842ba02ccf54b42b),
                loadMoreStatus: loadMoreStatus,
                payload: {
                    results: response?.childEntList.map((item, index)=>({
                            ...item,
                            index: `${offset}-${index}`
                        }))
                }
            });
            return 0, $d60257e8dc27bf16$export$51f82826650bc3c3;
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$842ba02ccf54b42b),
                payload: {
                    results: null,
                    error: "Data Fetch Error"
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$b903631ea95845bc = (eid, certKey)=>async (dispatch)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const body = {
            eid: eid,
            certkey: certKey
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
            payload: {
                isSidePanelError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForAccounts !== "undefined") $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForAccounts.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForAccounts = (0, $hopDi$axios).CancelToken.source();
            const { data: data } = await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/items/accountSummary`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body,
                cancelToken: $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForAccounts.token,
                timeout: (0, $d6d78fc758ee4148$export$b493d788e1fd3b9a)
            });
            const { response: response } = data;
            dispatch({
                type: (0, $d6d78fc758ee4148$export$b98808434921fbb1),
                payload: {
                    results: response,
                    error: null
                }
            });
            return 0, $d60257e8dc27bf16$export$bde14d5a1cbdb371;
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$b98808434921fbb1),
                payload: {
                    results: null,
                    error: "Data Fetch Error"
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$188b24a44048ab8 = (certkey, cert_entitlement_valuekey, cert_userkey, cert_accountkey)=>async (dispatch)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const body = {
            certkey: certkey,
            cert_entitlement_valuekey: cert_entitlement_valuekey,
            cert_userkey: cert_userkey,
            cert_accountkey: cert_accountkey
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
            payload: {
                isSidePanelError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForAccounts !== "undefined") $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForAccounts.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForAccounts = (0, $hopDi$axios).CancelToken.source();
            const { data: data } = await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/items/auditHistory`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body,
                cancelToken: $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForAccounts.token,
                timeout: (0, $d6d78fc758ee4148$export$b493d788e1fd3b9a)
            });
            const { response: response } = data;
            dispatch({
                type: (0, $d6d78fc758ee4148$export$7f0539351068ca18),
                payload: {
                    results: typeof response === "object" && Array.isArray(response) ? response?.map((item, index)=>({
                            ...item,
                            index: index
                        })) : null,
                    error: null
                }
            });
            if (typeof response === "string") dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: true,
                    error: response
                }
            });
            return 0, $d60257e8dc27bf16$export$9b67fda1e37e6e63;
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$7f0539351068ca18),
                payload: {
                    results: null,
                    error: "Data Fetch Error"
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$d5a553b80e9461bd = (eid, certkey, cert_userkey)=>async (dispatch)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const body = {
            eid: eid || "",
            certkey: certkey,
            cert_userkey: cert_userkey
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
            payload: {
                isSidePanelError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForUsers !== "undefined") $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForUsers.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForUsers = (0, $hopDi$axios).CancelToken.source();
            const { data: data } = await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/items/userSummary`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body,
                cancelToken: $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForUsers.token,
                timeout: (0, $d6d78fc758ee4148$export$b493d788e1fd3b9a)
            });
            const { response: response } = data;
            dispatch({
                type: (0, $d6d78fc758ee4148$export$a7a89423fc1f2d99),
                payload: {
                    results: response,
                    error: null
                }
            });
            return 0, $d60257e8dc27bf16$export$bde14d5a1cbdb371;
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$a7a89423fc1f2d99),
                payload: {
                    results: null,
                    error: "Data Fetch Error"
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$ac08493018d65897 = (certkey, cert_entitlement_valuekey, cert_userkey)=>async (dispatch)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const body = {
            certkey: certkey,
            cert_entitlement_valuekey: cert_entitlement_valuekey,
            cert_userkey: cert_userkey
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
            payload: {
                isSidePanelError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForUsers !== "undefined") $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForUsers.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForUsers = (0, $hopDi$axios).CancelToken.source();
            const { data: data } = await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/items/auditHistory`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body,
                cancelToken: $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForUsers.token,
                timeout: (0, $d6d78fc758ee4148$export$b493d788e1fd3b9a)
            });
            const { response: response } = data;
            dispatch({
                type: (0, $d6d78fc758ee4148$export$e6ae9922b78d19ee),
                payload: {
                    results: typeof response === "object" && Array.isArray(response) ? response?.map((item, index)=>({
                            ...item,
                            index: index
                        })) : null,
                    error: null
                }
            });
            if (typeof response === "string") dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: true,
                    error: response
                }
            });
            return 0, $d60257e8dc27bf16$export$9b67fda1e37e6e63;
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$e6ae9922b78d19ee),
                payload: {
                    results: null,
                    error: "Data Fetch Error"
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$d2ad049199ba44f6 = (eid, certkey, cert_rolekey)=>async (dispatch)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const body = {
            eid: eid,
            certkey: certkey,
            cert_rolekey: cert_rolekey
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
            payload: {
                isSidePanelError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForRoles !== "undefined") $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForRoles.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForRoles = (0, $hopDi$axios).CancelToken.source();
            const { data: data } = await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/items/roleSummary`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body,
                cancelToken: $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForRoles.token,
                timeout: (0, $d6d78fc758ee4148$export$b493d788e1fd3b9a)
            });
            const { response: response } = data;
            dispatch({
                type: (0, $d6d78fc758ee4148$export$85fb16097b911),
                payload: {
                    results: response,
                    error: null
                }
            });
            return 0, $d60257e8dc27bf16$export$bde14d5a1cbdb371;
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$85fb16097b911),
                payload: {
                    results: null,
                    error: "Data Fetch Error"
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$8ea25d5aa1748f67 = (certkey, cert_entitlement_valuekey, cert_userkey, cert_rolekey)=>async (dispatch)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const body = {
            certkey: certkey,
            cert_entitlement_valuekey: cert_entitlement_valuekey,
            cert_userkey: cert_userkey,
            cert_rolekey: cert_rolekey
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
            payload: {
                isSidePanelError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForRoles !== "undefined") $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForRoles.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForRoles = (0, $hopDi$axios).CancelToken.source();
            const { data: data } = await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/items/auditHistory`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body,
                cancelToken: $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForRoles.token,
                timeout: (0, $d6d78fc758ee4148$export$b493d788e1fd3b9a)
            });
            const { response: response } = data;
            dispatch({
                type: (0, $d6d78fc758ee4148$export$b0fdc72ce6a50d97),
                payload: {
                    results: typeof response === "object" && Array.isArray(response) ? response?.map((item, index)=>({
                            ...item,
                            index: index
                        })) : null,
                    error: null
                }
            });
            if (typeof response === "string") dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: true,
                    error: response
                }
            });
            return 0, $d60257e8dc27bf16$export$9b67fda1e37e6e63;
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$b0fdc72ce6a50d97),
                payload: {
                    results: null,
                    error: "Data Fetch Error"
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$5410f6e40c605c13 = (cert_rolekey, offset, max, loadMoreStatus = (0, $d6d78fc758ee4148$export$95aee1eca5275acc))=>async (dispatch)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const body = {
            cert_rolekey: cert_rolekey,
            offset: offset,
            max: max
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
            payload: {
                isSidePanelError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForSidePanelBodyEntitlementForRoles !== "undefined") $d623f23401a154f0$var$cancelTokenForSidePanelBodyEntitlementForRoles.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForSidePanelBodyEntitlementForRoles = (0, $hopDi$axios).CancelToken.source();
            const { data: data } = await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/items/roleEntitlements`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body,
                cancelToken: $d623f23401a154f0$var$cancelTokenForSidePanelBodyEntitlementForRoles.token,
                timeout: (0, $d6d78fc758ee4148$export$b493d788e1fd3b9a)
            });
            const { response: response } = data;
            if (loadMoreStatus === (0, $d6d78fc758ee4148$export$95aee1eca5275acc)) dispatch({
                type: (0, $d6d78fc758ee4148$export$940b9d07f90752d),
                loadMoreStatus: loadMoreStatus,
                payload: {
                    results: {
                        ...response,
                        roleEntList: response?.roleEntList.map((item, index)=>({
                                ...item,
                                index: `${offset}-${index}`
                            }))
                    },
                    error: null
                }
            });
            if (loadMoreStatus === (0, $d6d78fc758ee4148$export$2e6684ed5543ad11)) dispatch({
                type: (0, $d6d78fc758ee4148$export$940b9d07f90752d),
                loadMoreStatus: loadMoreStatus,
                payload: {
                    results: response?.roleEntList.map((item, index)=>({
                            ...item,
                            index: `${offset}-${index}`
                        }))
                }
            });
            return 0, $d60257e8dc27bf16$export$6cc684447a8d7b17;
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$940b9d07f90752d),
                payload: {
                    results: null,
                    error: "Data Fetch Error"
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$d602a5e5a48fdf7d = (cert_rolekey, offset, max, loadMoreStatus = (0, $d6d78fc758ee4148$export$95aee1eca5275acc))=>async (dispatch)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const body = {
            cert_rolekey: cert_rolekey,
            offset: offset,
            max: max
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
            payload: {
                isSidePanelError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForSidePanelBodyChildForRoles !== "undefined") $d623f23401a154f0$var$cancelTokenForSidePanelBodyChildForRoles.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForSidePanelBodyChildForRoles = (0, $hopDi$axios).CancelToken.source();
            const { data: data } = await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/items/childRoles`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body,
                cancelToken: $d623f23401a154f0$var$cancelTokenForSidePanelBodyChildForRoles.token,
                timeout: (0, $d6d78fc758ee4148$export$b493d788e1fd3b9a)
            });
            const { response: response } = data;
            if (loadMoreStatus === (0, $d6d78fc758ee4148$export$95aee1eca5275acc)) dispatch({
                type: (0, $d6d78fc758ee4148$export$d4c8fbbc4fca0999),
                loadMoreStatus: loadMoreStatus,
                payload: {
                    results: {
                        ...response,
                        childRoleList: response?.childRoleList.map((item, index)=>({
                                ...item,
                                index: `${offset}-${index}`
                            }))
                    },
                    error: null
                }
            });
            if (loadMoreStatus === (0, $d6d78fc758ee4148$export$2e6684ed5543ad11)) dispatch({
                type: (0, $d6d78fc758ee4148$export$d4c8fbbc4fca0999),
                loadMoreStatus: loadMoreStatus,
                payload: {
                    results: response?.childRoleList.map((item, index)=>({
                            ...item,
                            index: `${offset}-${index}`
                        }))
                }
            });
            return 0, $d60257e8dc27bf16$export$51f82826650bc3c3;
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$d4c8fbbc4fca0999),
                payload: {
                    results: null,
                    error: "Data Fetch Error"
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$886e16c80cfe3a1a = (certkey, group_by)=>async (dispatch, getState)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const { isLoadingReviewAndSubmit: isLoadingReviewAndSubmit } = getState().certifications;
        const body = {
            certkey: certkey,
            group_by: group_by
        };
        if (!isLoadingReviewAndSubmit) dispatch({
            type: (0, $d6d78fc758ee4148$export$1d889ec5a0bd35b5),
            payload: true
        });
        dispatch({
            type: (0, $d6d78fc758ee4148$export$32524a0d8ac0b191),
            payload: {
                isError: false,
                error: null
            }
        });
        try {
            const { data: data } = await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/lockSummary`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body,
                timeout: (0, $d6d78fc758ee4148$export$b493d788e1fd3b9a)
            });
            const { response: response, Summary: Summary } = data;
            dispatch({
                type: (0, $d6d78fc758ee4148$export$b1c80b328234b28e),
                payload: {
                    results: {
                        [group_by]: response === "Success" ? Summary : null
                    },
                    error: "null"
                }
            });
            return 0, $d6d78fc758ee4148$export$b1c80b328234b28e;
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$b1c80b328234b28e),
                payload: {
                    results: {},
                    error: "Data Fetch Error"
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$32524a0d8ac0b191),
                payload: {
                    isError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$776ef17d04a202bf = (certkey, eSignatureLogin, noOfTries, payload)=>async (dispatch, getState)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const { isSubmittingReviewAndSubmit: isSubmittingReviewAndSubmit } = getState().certifications;
        const body = {
            certkey: certkey,
            eSignatureLogin: eSignatureLogin,
            noOfTries: noOfTries,
            ...payload
        };
        if (!isSubmittingReviewAndSubmit) dispatch({
            type: (0, $d6d78fc758ee4148$export$8fa9055a97f67430),
            payload: true
        });
        try {
            const { data: data } = await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/validateESignature`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body,
                timeout: (0, $d6d78fc758ee4148$export$b493d788e1fd3b9a)
            });
            const { response: response, validateESignature: validateESignatureStatus } = data;
            if (validateESignatureStatus === undefined || validateESignatureStatus === null || !validateESignatureStatus) throw response;
            return response;
        } catch (error) {
            if ((0, $hopDi$axios).isAxiosError(error) && error.response) throw Error("Not able to verify due to a network issue. Please refresh or try again later.");
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$6bd0ceb6f0238e0a = (certkey, lockComments)=>async (dispatch, getState)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const { isSubmittingReviewAndSubmit: isSubmittingReviewAndSubmit } = getState().certifications;
        const body = {
            certkey: certkey,
            lockComments: lockComments,
            requestOrigin: "UI"
        };
        if (!isSubmittingReviewAndSubmit) dispatch({
            type: (0, $d6d78fc758ee4148$export$8fa9055a97f67430),
            payload: true
        });
        try {
            const { data: data } = await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/lock`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body,
                timeout: (0, $d6d78fc758ee4148$export$b493d788e1fd3b9a)
            });
            const { response: response, lockSuccessfull: lockSuccessfull } = data;
            if (lockSuccessfull === undefined || lockSuccessfull === null || !lockSuccessfull) throw response;
            return response;
        } catch (error) {
            if ((0, $hopDi$axios).isAxiosError(error) && error.response) throw Error("Not able to verify due to a network issue. Please refresh or try again later.");
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$f75c1d1e7da3ca60 = (certkey)=>async (dispatch, getState)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const { isSubmittingReviewAndSubmit: isSubmittingReviewAndSubmit } = getState().certifications;
        const body = {
            certkey: certkey,
            requestOrigin: "UI"
        };
        if (!isSubmittingReviewAndSubmit) dispatch({
            type: (0, $d6d78fc758ee4148$export$8fa9055a97f67430),
            payload: true
        });
        try {
            const { data: data } = await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/completeConsult`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body,
                timeout: (0, $d6d78fc758ee4148$export$b493d788e1fd3b9a)
            });
            const { consultComplete: consultComplete } = data;
            if (consultComplete === undefined || consultComplete === null || !consultComplete) throw Error("Unable to complete this certification at the moment");
            return "Success";
        } catch (error) {
            if ((0, $hopDi$axios).isAxiosError(error) && error.response) throw Error("Not able to verify due to a network issue. Please refresh or try again later.");
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$d5c4a54b97b3960a = (status)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$bfbc1bdccfb4abf5),
            payload: status
        });
    };
const $d623f23401a154f0$export$889241fc0afda8a9 = (status)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$69729db10395ff90),
            payload: status
        });
    };
const $d623f23401a154f0$export$2af49e179df91659 = (status)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$768f00e6b30d478),
            payload: status
        });
    };
const $d623f23401a154f0$export$ebeb2bd8ecd91be9 = (state)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$42cd2e4c8af9ab41),
            payload: state
        });
    };
const $d623f23401a154f0$export$4012debfa64c5cbf = (isAlert, alertText)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$98054ce8e1cd6185),
            payload: {
                isAlert: isAlert,
                alertText: alertText
            }
        });
    };
const $d623f23401a154f0$export$bb9465329a3d3cad = (data)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$2d1f20523798a1b7),
            payload: data
        });
    };
const $d623f23401a154f0$export$3078bd98bc0c9194 = (list)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$8cf310caad6b6ea7),
            payload: list
        });
    };
const $d623f23401a154f0$export$1a295a970dce82de = (state)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$afe1eb1cba0072ef),
            payload: state
        });
    };
const $d623f23401a154f0$export$c594ad0cf83b2327 = (certkey, clear = false)=>async (dispatch)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const body = {
            certkey: certkey,
            requestOrigin: "UI"
        };
        if (clear) body.clrAll = "1";
        dispatch({
            type: (0, $d6d78fc758ee4148$export$60473f3971dee5df),
            payload: true
        });
        dispatch({
            type: (0, $d6d78fc758ee4148$export$2890f4c8d2907863),
            payload: true
        });
        try {
            const { data: data } = await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/items/selectAll`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body,
                timeout: (0, $d6d78fc758ee4148$export$b493d788e1fd3b9a)
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$2d1f20523798a1b7),
                payload: data
            });
        } catch (error) {
            if ((0, $hopDi$axios).isAxiosError(error) && error.response) throw Error("Not able to verify due to a network issue. Please refresh or try again later.");
            throw Error("Action Failed. Not able to perform this action.");
        } finally{
            dispatch({
                type: (0, $d6d78fc758ee4148$export$60473f3971dee5df),
                payload: false
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$2890f4c8d2907863),
                payload: false
            });
        }
    };
const $d623f23401a154f0$export$5b43dc99ee28ff0f = (certkey, eid, checked)=>async (dispatch)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const body = {
            certkey: certkey,
            eid: eid,
            checked: checked ? "1" : "0",
            requestOrigin: "UI"
        };
        try {
            const { data: data } = await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/items/addRemoveFromSession`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body,
                timeout: (0, $d6d78fc758ee4148$export$b493d788e1fd3b9a)
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$2d1f20523798a1b7),
                payload: data
            });
            return data;
        } catch (error) {
            if ((0, $hopDi$axios).isAxiosError(error) && error.response) throw Error("Not able to verify due to a network issue. Please refresh or try again later.");
            throw Error("Action Failed. Not able to perform this action.");
        }
    };
const $d623f23401a154f0$export$88c9ed9fe84131c = (certkey, status, comments, payload)=>async (dispatch, getState)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const body = {
            certkey: certkey,
            status: status,
            comments: comments,
            bulkOperation: "1",
            ...payload
        };
        const { bulkAction: bulkAction } = getState().certifications;
        if (!bulkAction?.isSubmittingAction) dispatch({
            type: (0, $d6d78fc758ee4148$export$c19826a63dd39ec7),
            payload: true
        });
        try {
            const { data: data } = await (0, $hopDi$axios)({
                url: `${ECM_URL}/certifications/v2/items/bulkUpdate`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body,
                timeout: (0, $d6d78fc758ee4148$export$b493d788e1fd3b9a)
            });
            return data;
        } catch (error) {
            if ((0, $hopDi$axios).isAxiosError(error) && error.response) throw Error("Not able to verify due to a network issue. Please refresh or try again later.");
            throw Error("Action Failed. Not able to perform this action.");
        } finally{
            dispatch({
                type: (0, $d6d78fc758ee4148$export$c19826a63dd39ec7),
                payload: false
            });
        }
    };
const $d623f23401a154f0$export$6905b0d830e88406 = (state, arsTaskKeys)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$e87c818aed68e8cb),
            payload: {
                isOpen: state,
                arsTaskKeys: arsTaskKeys
            }
        });
        if (!state) setTimeout(()=>{
            dispatch({
                type: (0, $d6d78fc758ee4148$export$7a8caab59b607807),
                payload: true
            });
        }, [
            500
        ]);
    };
const $d623f23401a154f0$export$fee47e6aac44de0e = (state)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$7a8caab59b607807),
            payload: state
        });
    };
const $d623f23401a154f0$export$c45c025fc9b885f7 = (certkey, type, payload)=>async (dispatch, getState)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const { accessRequestHistory: accessRequestHistory } = getState().certifications;
        const body = {
            certkey: certkey,
            ...payload
        };
        if (!accessRequestHistory?.isLoading) dispatch({
            type: (0, $d6d78fc758ee4148$export$7a8caab59b607807),
            payload: true
        });
        dispatch({
            type: (0, $d6d78fc758ee4148$export$8671c3354e9690ea),
            payload: {
                isError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForAccessRequestHistory !== "undefined") $d623f23401a154f0$var$cancelTokenForAccessRequestHistory.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForAccessRequestHistory = (0, $hopDi$axios).CancelToken.source();
            const { data: data } = await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/items/${type}`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body,
                cancelToken: $d623f23401a154f0$var$cancelTokenForAccessRequestHistory.token,
                timeout: (0, $d6d78fc758ee4148$export$b493d788e1fd3b9a)
            });
            const { response: response } = data;
            dispatch({
                type: (0, $d6d78fc758ee4148$export$7a8caab59b607807),
                payload: false
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$dcc76e3383a21811),
                payload: response
            });
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$dcc76e3383a21811),
                payload: null
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$8671c3354e9690ea),
                payload: {
                    isError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
        } finally{
            dispatch({
                type: (0, $d6d78fc758ee4148$export$7a8caab59b607807),
                payload: false
            });
        }
    };
// Action Button API Calls
// TODO: Try this flexible Not so DRY version when SOD env comes back or I get fresh CR key to test.
const $d623f23401a154f0$var$performCertificationAction = async (dispatch, actionData, defaultComments)=>{
    const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
    let body = null;
    if (actionData?.accountKey) body = {
        certkey: actionData.certKey,
        cert_userkey: actionData.userKey,
        cert_entitlement_valuekey: actionData.entValueKey,
        cert_accountkey: actionData.accountKey,
        cert_rolekey: actionData.certRoleKey,
        status: `${actionData.status}`,
        comments: actionData.comment || defaultComments
    };
    else body = {
        certkey: actionData.certKey,
        cert_userkey: actionData.userKey,
        cert_entitlement_valuekey: actionData.entValueKey,
        cert_rolekey: actionData.certRoleKey,
        status: `${actionData.status}`,
        comments: actionData.comment || defaultComments
    };
    dispatch({
        type: (0, $d6d78fc758ee4148$export$8ca82b86b34f725b)
    });
    try {
        await (0, $hopDi$axios)({
            url: `${ECM_URL}/api/certifications/v2/items/approve`,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
            },
            data: body
        });
        setTimeout(()=>{
            dispatch({
                type: (0, $d6d78fc758ee4148$export$3564fc123aed043c)
            });
        }, 2000);
        dispatch({
            type: (0, $d6d78fc758ee4148$export$b3c7c737b53ea33e)
        });
        return {
            isSuccess: true,
            isLoading: false
        };
    } catch (error) {
        dispatch({
            type: (0, $d6d78fc758ee4148$export$5755ae8e491f730),
            payload: {
                error: error.message
            }
        });
        (0, $hopDi$Logger).error("Error: ", Error(error.message));
    }
};
const $d623f23401a154f0$export$348853d7c8cab35b = (actionData)=>async (dispatch)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const body = {
            certkey: actionData.certKey,
            cert_userkey: actionData.userKey,
            status: `${actionData.status}`,
            comments: actionData.comments
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$8ca82b86b34f725b)
        });
        try {
            await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/items/revoke`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body
            });
            setTimeout(()=>{
                dispatch({
                    type: (0, $d6d78fc758ee4148$export$3564fc123aed043c)
                });
            }, 2000);
            dispatch({
                type: (0, $d6d78fc758ee4148$export$b3c7c737b53ea33e)
            });
            return {
                isSuccess: true,
                isLoading: false
            };
        } catch (error) {
            dispatch({
                type: (0, $d6d78fc758ee4148$export$5755ae8e491f730),
                payload: {
                    error: error.message
                }
            });
        }
    };
const $d623f23401a154f0$export$9f62cbf6b3b94af9 = (actionData)=>async (dispatch)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const body = {
            certkey: actionData.certKey,
            cert_userkey: actionData.userKey,
            certified: actionData.certified,
            comments: actionData.comments,
            status: `${actionData.status}`
        };
        if (!actionData?.accountKey) body.extendedEndDate = actionData?.extendedEndDate;
        else body.cert_accountkey = actionData?.accountKey;
        if (actionData?.entValueKey) {
            body.requestOrigin = "UI";
            body.cert_entitlement_valuekey = actionData?.entValueKey;
            body.enddate = actionData?.extendedEndDate;
        }
        if (actionData?.certRoleKey) body.cert_rolekey = actionData?.certRoleKey;
        dispatch({
            type: (0, $d6d78fc758ee4148$export$8ca82b86b34f725b)
        });
        try {
            await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/items/approve`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body
            });
            setTimeout(()=>{
                dispatch({
                    type: (0, $d6d78fc758ee4148$export$3564fc123aed043c)
                });
            }, 2000);
            dispatch({
                type: (0, $d6d78fc758ee4148$export$b3c7c737b53ea33e)
            });
            return {
                isSuccess: true,
                isLoading: false
            };
        } catch (error) {
            dispatch({
                type: (0, $d6d78fc758ee4148$export$5755ae8e491f730),
                payload: {
                    error: error?.response?.data?.response || error.message
                }
            });
        }
    };
const $d623f23401a154f0$export$8a3b1d82a4510306 = (actionData)=>async (dispatch)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const body = {
            eid: "9XkNdo4B3jXy1GcEFDOF",
            certified: "3",
            cert_accountkey: actionData.accountKey,
            certkey: actionData.certKey,
            cert_userkey: actionData.userKey,
            cert_entitlement_valuekey: actionData.entValueKey,
            comments: actionData.comments,
            status: `${actionData.status}`
        };
        if (actionData?.certRoleKey) body.cert_rolekey = actionData?.certRoleKey;
        dispatch({
            type: (0, $d6d78fc758ee4148$export$8ca82b86b34f725b)
        });
        try {
            await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/items/reject`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body
            });
            setTimeout(()=>{
                dispatch({
                    type: (0, $d6d78fc758ee4148$export$3564fc123aed043c)
                });
            }, 2000);
            dispatch({
                type: (0, $d6d78fc758ee4148$export$b3c7c737b53ea33e)
            });
            return {
                isSuccess: true,
                isLoading: false
            };
        } catch (error) {
            dispatch({
                type: (0, $d6d78fc758ee4148$export$5755ae8e491f730),
                payload: {
                    error: error.message
                }
            });
        }
    };
const $d623f23401a154f0$export$e77519515695c9c7 = (actionData)=>async (dispatch)=>$d623f23401a154f0$var$performCertificationAction(dispatch, actionData, "Approve User");
const $d623f23401a154f0$export$70cd670b72ffe020 = (actionData)=>async (dispatch)=>$d623f23401a154f0$var$performCertificationAction(dispatch, actionData, "Approve");
const $d623f23401a154f0$export$6e5b0daaf8d927e4 = (certKey, groupByType, initialLoad)=>async (dispatch)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const body = {
            certkey: certKey,
            group_by: groupByType
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$5296abadcbacb235),
            payload: true
        });
        try {
            const { data: data } = await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/items/fetchCertificationProgress`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$b77c91b145bf9647),
                payload: {
                    groupByType: groupByType,
                    data: data
                }
            });
        } catch (error) {
            dispatch({
                type: (0, $d6d78fc758ee4148$export$569cf9037aa74da),
                payload: {
                    error: error.message,
                    initialLoad: initialLoad
                }
            });
        // throw Error(error);
        } finally{
            dispatch({
                type: (0, $d6d78fc758ee4148$export$5296abadcbacb235),
                payload: false
            });
        }
    };
const $d623f23401a154f0$export$aa7b16fe4622cebe = (columnName, sortDirection)=>async (dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$e7b0a9aed86b0918),
            payload: {
                columnName: columnName,
                sortDirection: sortDirection
            }
        });
    };
const $d623f23401a154f0$export$683be6298bff3717 = ()=>async (dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$8810396661da9a69)
        });
    };
const $d623f23401a154f0$export$348ff7906afdfd12 = (certKey)=>async (dispatch)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const body = {
            certkey: certKey,
            offset: "0",
            max: "100"
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$3454dc93d4b256c8),
            payload: true
        });
        try {
            const { data: data } = await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/fetchUserList`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1bdde0917053ab5d),
                payload: {
                    data: data.resultsList
                }
            });
        } catch (error) {
            dispatch({
                type: (0, $d6d78fc758ee4148$export$3d55f922eb0f4b),
                payload: {
                    error: error.message
                }
            });
            (0, $hopDi$Logger).error("Error: ", Error(error.message));
        // throw Error(error);
        } finally{
            dispatch({
                type: (0, $d6d78fc758ee4148$export$3454dc93d4b256c8),
                payload: false
            });
        }
    };
const $d623f23401a154f0$export$29d12c975855399 = (actionData, actionKind)=>async (dispatch)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const body = actionData;
        dispatch({
            type: (0, $d6d78fc758ee4148$export$8ca82b86b34f725b),
            payload: actionKind
        });
        try {
            await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/items/reassign`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$b3c7c737b53ea33e)
            });
            setTimeout(()=>{
                dispatch({
                    type: (0, $d6d78fc758ee4148$export$3564fc123aed043c)
                });
            }, 2000);
            return {
                isSuccess: true,
                isLoading: false
            };
        } catch (error) {
            let errorMsg = "";
            if (error?.response?.data?.response) errorMsg = error.response.data.response;
            else errorMsg = error.message;
            setTimeout(()=>{
                dispatch({
                    type: (0, $d6d78fc758ee4148$export$3564fc123aed043c)
                });
            }, 2000);
            dispatch({
                type: (0, $d6d78fc758ee4148$export$5755ae8e491f730),
                payload: {
                    error: errorMsg
                }
            });
        }
    };
const $d623f23401a154f0$export$627e0e03ed6c2927 = (actionData, actionKind)=>async (dispatch)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const body = actionData;
        dispatch({
            type: (0, $d6d78fc758ee4148$export$8ca82b86b34f725b),
            payload: actionKind
        });
        try {
            await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/items/approve`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$b3c7c737b53ea33e)
            });
            setTimeout(()=>{
                dispatch({
                    type: (0, $d6d78fc758ee4148$export$3564fc123aed043c)
                });
            }, 2000);
            return {
                isSuccess: true,
                isLoading: false
            };
        } catch (error) {
            let errorMsg = "";
            if (error?.response?.data?.response) errorMsg = error.response.data.response;
            else errorMsg = error.message;
            setTimeout(()=>{
                dispatch({
                    type: (0, $d6d78fc758ee4148$export$3564fc123aed043c)
                });
            }, 2000);
            dispatch({
                type: (0, $d6d78fc758ee4148$export$5755ae8e491f730),
                payload: {
                    error: errorMsg
                }
            });
        }
    };
const $d623f23401a154f0$export$3f4330c48a705a7a = (actionData, actionKind)=>async (dispatch)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const body = actionData;
        dispatch({
            type: (0, $d6d78fc758ee4148$export$8ca82b86b34f725b),
            payload: actionKind
        });
        try {
            await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/items/consult`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$b3c7c737b53ea33e)
            });
            setTimeout(()=>{
                dispatch({
                    type: (0, $d6d78fc758ee4148$export$3564fc123aed043c)
                });
            }, 2000);
            return {
                isSuccess: true,
                isLoading: false
            };
        } catch (error) {
            let errorMsg = "";
            if (error?.response?.data?.response) errorMsg = error.response.data.response;
            else errorMsg = error.message;
            setTimeout(()=>{
                dispatch({
                    type: (0, $d6d78fc758ee4148$export$3564fc123aed043c)
                });
            }, 2000);
            dispatch({
                type: (0, $d6d78fc758ee4148$export$5755ae8e491f730),
                payload: {
                    error: errorMsg
                }
            });
        }
    };
const $d623f23401a154f0$export$9bbc436a94e70d04 = (actionData, actionKind)=>async (dispatch)=>{
        const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
        const body = actionData;
        dispatch({
            type: (0, $d6d78fc758ee4148$export$8ca82b86b34f725b),
            payload: actionKind
        });
        try {
            await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/items/approve`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: body
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$b3c7c737b53ea33e)
            });
            setTimeout(()=>{
                dispatch({
                    type: (0, $d6d78fc758ee4148$export$3564fc123aed043c)
                });
            }, 2000);
            return {
                isSuccess: true,
                isLoading: false
            };
        } catch (error) {
            let errorMsg = "";
            if (error?.response?.data?.response) errorMsg = error.response.data.response;
            else errorMsg = error.message;
            setTimeout(()=>{
                dispatch({
                    type: (0, $d6d78fc758ee4148$export$3564fc123aed043c)
                });
            }, 2000);
            dispatch({
                type: (0, $d6d78fc758ee4148$export$5755ae8e491f730),
                payload: {
                    error: errorMsg
                }
            });
        }
    };
const $d623f23401a154f0$export$f4f9bb309d2b8abf = (certkey, postFailureAction, retryAction)=>async (dispatch)=>{
        try {
            // Set loading status to true
            dispatch({
                type: (0, $d6d78fc758ee4148$export$df3ba5c051a876de),
                payload: true
            });
            const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
            const { data: data } = await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/saviStatus`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: {
                    certkey: certkey,
                    signal: "TRUST_SCORE"
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$4009fb2303280d3a),
                payload: data
            });
        } catch (err) {
            postFailureAction({
                title: "There was a problem loading Smart Decisions.",
                retryAction: retryAction
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$9b4357356da505fc),
                payload: false
            });
        }
    };
const $d623f23401a154f0$export$257ace57b4563d30 = (payload, config)=>async (dispatch)=>{
        const { columnNames: columnNames, max: max, offset: offset, postSuccessAction: postSuccessAction, postFailureAction: postFailureAction } = config;
        try {
            dispatch({
                type: (0, $d6d78fc758ee4148$export$a0f86ea1258b795c),
                payload: true
            });
            const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
            const { approve_overwrite: approve_overwrite, reject_overwrite: reject_overwrite, savi_approve: savi_approve, savi_reject: savi_reject } = payload;
            await (0, $hopDi$axios)({
                url: `${ECM_URL}/api/certifications/v2/applySaviActions`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${$d623f23401a154f0$var$cookies.get("access_token")}`
                },
                data: {
                    ...payload,
                    approve_overwrite: `${approve_overwrite}`,
                    reject_overwrite: `${reject_overwrite}`,
                    savi_approve: `${savi_approve}`,
                    savi_reject: `${savi_reject}`
                }
            });
            dispatch($d623f23401a154f0$export$fad033acbe739b9c(payload.certkey, columnNames, max, offset));
            postSuccessAction(false);
            dispatch({
                type: (0, $d6d78fc758ee4148$export$b021d9c474ee48de),
                payload: payload
            });
        } catch (err) {
            postFailureAction({
                title: "There was a problem loading Smart Decisions.",
                retryAction: config.retryAction
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$7e0741aad82ab94b),
                payload: false
            });
        }
    };












const $e4cfe974853390b2$export$aeca2bf7951e0a69 = 10;
const $e4cfe974853390b2$export$780e9b8451ecceec = {
    landing: /*#__PURE__*/ (0, $hopDi$jsxs)("span", {
        children: [
            "Hi, I\u2019m ",
            /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                className: "Savi-highlight",
                children: "Savi"
            }),
            ", your AI Companion",
            " "
        ]
    }),
    normal: /*#__PURE__*/ (0, $hopDi$jsx)("span", {
        className: "Savi-highlight",
        children: "Savi"
    })
};
const $e4cfe974853390b2$export$2ea9789638c50423 = [
    {
        id: "smart_decisions",
        label: "Make Smart Decisions for You",
        description: "I'll recommend decisions based on multiple trust and risk factors and you can review the reasons and change the decisions before you submit.",
        iconKind: "SaviSmartDecisions",
        isRecommended: true,
        tabIndex: -1
    },
    {
        id: "own_review",
        label: "Review on Your Own",
        description: "Go ahead and conduct your certification review without intelligence-based assistance.",
        iconKind: "SaviOwnReview",
        isRecommended: false,
        tabIndex: 0
    }
];
const $e4cfe974853390b2$export$66437e1fecf15ebb = {
    savi_approve: {
        label: "Approve",
        description: "Includes items identified as High Peer Match Score, Approved in Saviynt, Low Risk Entitlements and Birthright Access Origins.",
        iconKind: "SaviSmartApprove",
        totalKey: "savi_total_approve",
        actionTakenKey: "savi_approved",
        manuallyReviewedMessageKeys: [
            {
                actionTakenKey: "manually_revoked",
                actionTakenLabel: "rejected"
            },
            {
                actionTakenKey: "manually_enddate",
                actionTakenLabel: "changed end date on"
            }
        ],
        manuallyReviewedActionConfirmation: "approvals",
        applyActionKey: "savi_approve",
        applyOverwriteKey: "approve_overwrite"
    },
    savi_revoke: {
        label: "Reject",
        description: "Includes items with Low Peer Match, Unused Accounts, Access Conflicts (SoD)",
        iconKind: "SaviSmartReject",
        totalKey: "savi_total_revoke",
        actionTakenKey: "savi_revoked",
        manuallyReviewedMessageKeys: [
            {
                actionTakenKey: "manually_approved",
                actionTakenLabel: "approved"
            },
            {
                actionTakenKey: "manually_enddate",
                actionTakenLabel: "changed end date on"
            }
        ],
        manuallyReviewedActionConfirmation: "rejections",
        applyActionKey: "savi_reject",
        applyOverwriteKey: "reject_overwrite"
    }
};



const $e40ef6d119a5d30a$var$cookies = new (0, $hopDi$Cookies)();
const $e40ef6d119a5d30a$var$SaviCompanionTitle = ({ kind: kind })=>(0, $e4cfe974853390b2$export$780e9b8451ecceec)[kind];
function $e40ef6d119a5d30a$var$SaviCompanionLandingBody({ onGotItClick: onGotItClick }) {
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "Savi-Landing-Body",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                children: "Introducing Savi: An AI companion to assess, quantify, and prioritize Identity Security related Trusts effectively. Enhance your organization's security posture with our flexible and scalable Trust intelligence."
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "Landing-buttons-wrapper",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                    type: "button",
                    kind: "filled",
                    size: "large",
                    className: "Landing-buttons",
                    onClick: onGotItClick,
                    children: "Got it"
                })
            })
        ]
    });
}
function $e40ef6d119a5d30a$var$QuestionHeader({ isOptionSelected: isOptionSelected, minimiseReason: minimiseReason, title: title, setIsOptionSelected: setIsOptionSelected }) {
    return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
        className: "Question-Header-Wrapper-Minimised",
        children: isOptionSelected ? /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: "Question-Header-Wrapper",
            role: "button",
            tabIndex: -1,
            onClick: ()=>setIsOptionSelected(!isOptionSelected),
            onKeyDown: ()=>setIsOptionSelected(!isOptionSelected),
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "SaviCompanionDark",
                    size: "medium"
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "Minimised",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    kind: "body2",
                                    className: "Question-Header",
                                    children: title
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    kind: "body1",
                                    className: "Question-Header Question-Header-Reason",
                                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Color), {
                                        color: "navy-900",
                                        children: minimiseReason
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "Edit",
                            size: "medium",
                            color: "navy-900"
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: `Question-Header-Wrapper ${minimiseReason ? " Question-Header-Wrapper-Minimised" : ""}`,
            role: "button",
            tabIndex: 0,
            onClick: ()=>minimiseReason && setIsOptionSelected && setIsOptionSelected(!isOptionSelected),
            onKeyDown: ()=>minimiseReason && setIsOptionSelected && setIsOptionSelected(!isOptionSelected),
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "SaviCompanionDark",
                    size: "medium"
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "h3",
                    className: "Question-Header",
                    children: title
                })
            ]
        })
    });
}
function $e40ef6d119a5d30a$var$SaviStaticOption({ id: id, label: label, description: description, iconKind: iconKind, chipLabel: chipLabel, onClick: onClick, tabIndex: tabIndex }) {
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "SmartReview-Wrapper",
        role: "button",
        onClick: ()=>onClick(id, label),
        tabIndex: tabIndex,
        onKeyDown: ()=>onClick(id, label),
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "SmartDecision-Icon",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: iconKind,
                    size: "large"
                })
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                children: [
                    chipLabel && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Chip), {
                        label: chipLabel,
                        kind: "subtleFilled",
                        color: "info"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "h3",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Color), {
                            color: "navy-900",
                            children: label
                        })
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body2",
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "SmartDecision-Icon",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "ArrowRight",
                    color: "indigo-700",
                    size: "medium"
                })
            })
        ]
    });
}
function $e40ef6d119a5d30a$var$SaviPopover({ id: id, children: children, isPopoverOpen: isPopoverOpen, openPopover: openPopover, setSmartSelectedOption: setSmartSelectedOption, manuallyReviewedDetails: manuallyReviewedDetails, setShowKeepDecisionText: setShowKeepDecisionText, disablePopup: disablePopup }) {
    const onButtonClick = (overwriteFlag)=>{
        openPopover(false, true);
        setSmartSelectedOption(id, 1, overwriteFlag);
        if (!overwriteFlag) setShowKeepDecisionText(true);
    };
    const overlayBgClasses = (0, $hopDi$classnames)(isPopoverOpen ? `Savi-Popover-background Savi-Popover-background--isOpen` : `DisplayNone`);
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: overlayBgClasses
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                tag: "div",
                className: "SaviCompanion-contextWrapper",
                children: !disablePopup ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Popover), {
                    placement: "right",
                    trigger: children,
                    popoverContent: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                        className: "flexContainer",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "h3",
                                children: manuallyReviewedDetails.title
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body2",
                                children: manuallyReviewedDetails.description
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                                className: "flexWrapper",
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                                        type: "button",
                                        kind: "ghost",
                                        size: "medium",
                                        onClick: ()=>onButtonClick(1),
                                        children: "Overwrite"
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                                        type: "button",
                                        kind: "filled",
                                        size: "medium",
                                        onClick: ()=>onButtonClick(0),
                                        children: "Keep Your Decisions"
                                    })
                                ]
                            })
                        ]
                    }),
                    isOpen: isPopoverOpen,
                    setIsOpen: openPopover
                }) : children
            })
        ]
    });
}
function $e40ef6d119a5d30a$var$SaviDynamicOption({ id: id, label: label, description: description, iconKind: iconKind, onClick: onClick, tabIndex: tabIndex, isManuallyReviewedItemsPresent: isManuallyReviewedItemsPresent, setSmartSelectedOption: setSmartSelectedOption, manuallyReviewedDetails: manuallyReviewedDetails, isSaviActionsApplied: isSaviActionsApplied }) {
    const [isChecked, setIsChecked] = (0, $hopDi$useState)(false);
    const [isPopoverOpen, setIsPopoverOpen] = (0, $hopDi$useState)(false);
    const [showKeepDecisionText, setShowKeepDecisionText] = (0, $hopDi$useState)(false);
    const [showSaviActionsApplied, setShowSaviActionsApplied] = (0, $hopDi$useState)(isSaviActionsApplied);
    const onOptionClick = ()=>{
        setIsChecked(!isChecked);
        onClick(id, !isChecked, isManuallyReviewedItemsPresent);
        setShowKeepDecisionText(false);
    };
    const openPopover = (open, isButtonClicked)=>{
        let localIsChecked = isChecked;
        if (!open && !(isButtonClicked === true)) {
            localIsChecked = false;
            setIsChecked(localIsChecked);
        }
        setIsPopoverOpen(open && !localIsChecked);
    };
    const onCancelSaviActions = ()=>{
        setShowSaviActionsApplied(false);
        setSmartSelectedOption(id, 0);
        return false;
    };
    return /*#__PURE__*/ (0, $hopDi$jsx)($e40ef6d119a5d30a$var$SaviPopover, {
        id: id,
        isPopoverOpen: isManuallyReviewedItemsPresent ? isPopoverOpen : false,
        openPopover: openPopover,
        setSmartSelectedOption: setSmartSelectedOption,
        manuallyReviewedDetails: manuallyReviewedDetails,
        setShowKeepDecisionText: setShowKeepDecisionText,
        disablePopup: showSaviActionsApplied,
        children: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: "SmartReview-Wrapper",
            role: "button",
            onClick: !showSaviActionsApplied && onOptionClick,
            tabIndex: tabIndex,
            onKeyDown: !showSaviActionsApplied && onOptionClick,
            children: [
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                            className: "SmartDecision-Icon",
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                    kind: iconKind,
                                    size: "xLarge"
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                                    className: "DisplayFlex-Column",
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "h3",
                                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Color), {
                                                color: "navy-900",
                                                children: label
                                            })
                                        }),
                                        showKeepDecisionText && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body2",
                                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Color), {
                                                color: "navy-900",
                                                children: manuallyReviewedDetails.overwriteDecision
                                            })
                                        })
                                    ]
                                }),
                                showSaviActionsApplied && /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                    className: "Applied-Savi",
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                            kind: "CheckCircleOutline",
                                            size: "xSmall"
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body3",
                                            children: "Applied"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body2",
                                children: description
                            })
                        }),
                        showSaviActionsApplied && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                            className: "Cancel-Smart-Approvals",
                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                                type: "button",
                                kind: "subtle",
                                size: "large",
                                onClick: onCancelSaviActions,
                                children: "Cancel Smart Approvals"
                            })
                        })
                    ]
                }),
                !showSaviActionsApplied && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "SmartDecision-Icon",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                        kind: "base",
                        size: "medium",
                        isChecked: isChecked,
                        onChange: onOptionClick
                    })
                })
            ]
        }, id)
    });
}
function $e40ef6d119a5d30a$var$Divider() {
    return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
        className: "Savi-Companion-Divider"
    });
}
function $e40ef6d119a5d30a$var$SmartReview({ title: title, children: children, isOptionSelected: isOptionSelected, selectedOption: selectedOption, setIsOptionSelected: setIsOptionSelected }) {
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "SaviCompanionBody-Wrapper",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)($e40ef6d119a5d30a$var$QuestionHeader, {
                isOptionSelected: isOptionSelected,
                minimiseReason: selectedOption,
                title: title,
                setIsOptionSelected: setIsOptionSelected
            }),
            !isOptionSelected && children
        ]
    });
}
function $e40ef6d119a5d30a$var$LoaderComponent({ text: text }) {
    return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
        className: "Savi-Companion-Loader-Wrapper",
        children: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: "Savi-Companion-Loader-Body",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "body2",
                    className: "Savi-Companion-Loader-Text",
                    children: text
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                    className: "Savi-Companion-Loader-Setting",
                    kind: "loop",
                    format: "inline",
                    color: "brand",
                    size: "large"
                })
            ]
        })
    });
}
function $e40ef6d119a5d30a$var$ErrorComponent({ errorText: errorText, retryAction: retryAction }) {
    return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
        className: "Savi-Companion-Loader-Wrapper",
        children: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: "Savi-Companion-Loader-Body",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "AlertText",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "AlertCriticalOutline",
                            color: "critical-500",
                            size: "small"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "body2",
                            className: "Savi-Companion-Error-Text",
                            children: errorText
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                    onClick: retryAction,
                    kind: "ghost",
                    size: "medium",
                    rightIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "Retry",
                        size: "small"
                    }),
                    children: "Retry"
                })
            ]
        })
    });
}
function $e40ef6d119a5d30a$var$NothingToShow() {
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "Savi-Companion-Loader-Wrapper",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "NothingToShow",
                    size: "large"
                })
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                kind: "body2",
                className: "Savi-Companion-Loader-Text",
                children: "You are all caught up! Nothing to see here."
            })
        ]
    });
}
function $e40ef6d119a5d30a$var$SaviCompanionBody({ setSelectedSmartReviewOptions: setSelectedSmartReviewOptions, selectedSmartReviewOptions: selectedSmartReviewOptions, isLoading: isLoading, isSaviActionsTaken: isSaviActionsTaken, smartReviewOptions: smartReviewOptions, setShowSaviCompanion: setShowSaviCompanion, isApplyActionLoading: isApplyActionLoading, errorDetails: errorDetails }) {
    const [isOptionSelected, setIsOptionSelected] = (0, $hopDi$useState)(false);
    const [selectedOption, setSelectedOption] = (0, $hopDi$useState)("");
    const [isDynamicOptionSelected, setIsDynamicOptionSelected] = (0, $hopDi$useState)(false);
    const [dynamicSelectedOption, setDynamicSelectedOption] = (0, $hopDi$useState)([]);
    (0, $hopDi$useEffect)(()=>{
        if (smartReviewOptions.length > 0) {
            const dynamicOptions = [];
            smartReviewOptions.map((item)=>dynamicOptions.push(item.label));
            setDynamicSelectedOption(dynamicOptions);
        }
    }, [
        smartReviewOptions
    ]);
    const onOptionSelected = (id, reason)=>{
        if (id === "smart_decisions") {
            setIsOptionSelected(true);
            setSelectedOption(reason);
        } else setShowSaviCompanion(false);
    };
    const setSmartSelectedOption = (itemKey, value, overwriteFlag)=>{
        const optionKey = (0, $e4cfe974853390b2$export$66437e1fecf15ebb)[itemKey].applyActionKey;
        const overwriteOptionKey = (0, $e4cfe974853390b2$export$66437e1fecf15ebb)[itemKey].applyOverwriteKey;
        const { [optionKey]: selectedItem } = selectedSmartReviewOptions;
        const selectedOptions = {
            ...selectedSmartReviewOptions
        };
        if (selectedItem) {
            delete selectedOptions[optionKey];
            delete selectedOptions[overwriteOptionKey];
        } else {
            selectedOptions[optionKey] = value;
            selectedOptions[overwriteOptionKey] = overwriteFlag;
        }
        setSelectedSmartReviewOptions(selectedOptions);
    };
    const onDynamicOptionClick = (itemKey, isChecked, isManuallyReviewedItemsPresent)=>{
        if (!isChecked || !isManuallyReviewedItemsPresent) setSmartSelectedOption(itemKey, 1);
    };
    const dynamicActionsBody = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                !isSaviActionsTaken ? /*#__PURE__*/ (0, $hopDi$jsx)($e40ef6d119a5d30a$var$SmartReview, {
                    title: "How can I help with your certification?",
                    isOptionSelected: isOptionSelected,
                    selectedOption: selectedOption,
                    setIsOptionSelected: setIsOptionSelected,
                    children: /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "Options-Wrapper",
                        children: (0, $e4cfe974853390b2$export$2ea9789638c50423).map(({ id: id, label: label, description: description, iconKind: iconKind, isRecommended: isRecommended, tabIndex: tabIndex }, index)=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsx)($e40ef6d119a5d30a$var$SaviStaticOption, {
                                        id: id,
                                        label: label,
                                        description: description,
                                        iconKind: iconKind,
                                        onClick: onOptionSelected,
                                        tabIndex: tabIndex,
                                        chipLabel: isRecommended ? "Recommended" : null
                                    }),
                                    index < (0, $e4cfe974853390b2$export$2ea9789638c50423).length - 1 && /*#__PURE__*/ (0, $hopDi$jsx)($e40ef6d119a5d30a$var$Divider, {})
                                ]
                            }))
                    })
                }) : null,
                (selectedOption || isSaviActionsTaken) && /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                    children: isApplyActionLoading ? /*#__PURE__*/ (0, $hopDi$jsx)($e40ef6d119a5d30a$var$LoaderComponent, {
                        text: "Thank you for your patience! I am working on getting smart decisions together for you."
                    }) : /*#__PURE__*/ (0, $hopDi$jsx)($e40ef6d119a5d30a$var$SmartReview, {
                        title: "What decisions can I make for you?",
                        isOptionSelected: isDynamicOptionSelected,
                        selectedOption: dynamicSelectedOption.join(", "),
                        setIsOptionSelected: setIsDynamicOptionSelected,
                        children: /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                            className: "Options-Wrapper",
                            children: smartReviewOptions.map(({ id: id, label: label, description: description, iconKind: iconKind, isManuallyReviewedItemsPresent: isManuallyReviewedItemsPresent, manuallyReviewedDetails: manuallyReviewedDetails, isSaviActionsApplied: isSaviActionsApplied })=>/*#__PURE__*/ (0, $hopDi$jsx)($e40ef6d119a5d30a$var$SaviDynamicOption, {
                                    id: id,
                                    label: label,
                                    description: description,
                                    iconKind: iconKind,
                                    onClick: onDynamicOptionClick,
                                    isManuallyReviewedItemsPresent: isManuallyReviewedItemsPresent,
                                    setSmartSelectedOption: setSmartSelectedOption,
                                    manuallyReviewedDetails: manuallyReviewedDetails,
                                    isSaviActionsApplied: isSaviActionsApplied
                                }))
                        })
                    })
                })
            ]
        });
    if (errorDetails && errorDetails.title) return /*#__PURE__*/ (0, $hopDi$jsx)($e40ef6d119a5d30a$var$ErrorComponent, {
        errorText: errorDetails.title,
        retryAction: errorDetails.retryAction
    });
    if (isLoading) return /*#__PURE__*/ (0, $hopDi$jsx)($e40ef6d119a5d30a$var$LoaderComponent, {
        text: "Thank you for your patience! I am working on getting smart decisions together for you."
    });
    if (smartReviewOptions.length === 0) return /*#__PURE__*/ (0, $hopDi$jsx)($e40ef6d119a5d30a$var$NothingToShow, {});
    return dynamicActionsBody();
}
const $e40ef6d119a5d30a$var$getDescriptionFromManuallyReviewedItems = (smartActionDetails, config)=>{
    const actionArray = [];
    config.manuallyReviewedMessageKeys.map((item)=>{
        const actionCount = smartActionDetails[item.actionTakenKey];
        if (actionCount > 0) actionArray.push(`${item.actionTakenLabel} ${actionCount} item${actionCount > 1 ? "s" : ""}`);
        return item;
    });
    return `You've ${actionArray.join(", and ")} that I will smart ${config.label.toLowerCase()}.
  Would you like to maintain your decisions or would you like me to overwrite your decisions with smart ${config.manuallyReviewedActionConfirmation}?`;
};
const $e40ef6d119a5d30a$var$processSmartActionDetails = (smartActionDetails)=>{
    const newSmartReviewOptions = [];
    let saviActionTakenCount = 0;
    Object.keys(smartActionDetails).map((item)=>{
        const config = (0, $e4cfe974853390b2$export$66437e1fecf15ebb)[item];
        const manuallyReviewedTotal = smartActionDetails[item].manually_approved + smartActionDetails[item].manually_revoked + smartActionDetails[item].manually_enddate;
        const totalSmartActionsCount = smartActionDetails[item][config.totalKey] || 0;
        if (totalSmartActionsCount > 0) newSmartReviewOptions.push({
            id: item,
            label: `Smart ${config.label} ${smartActionDetails[item][config.totalKey]} Items`,
            description: config.description,
            iconKind: config.iconKind,
            isManuallyReviewedItemsPresent: manuallyReviewedTotal > 0,
            isSaviActionsApplied: smartActionDetails[item][config.actionTakenKey] > 0,
            manuallyReviewedDetails: {
                title: `You have manually reviewed ${manuallyReviewedTotal} item${manuallyReviewedTotal > 1 ? "s" : ""}`,
                description: $e40ef6d119a5d30a$var$getDescriptionFromManuallyReviewedItems(smartActionDetails[item], config),
                overwriteDecision: `Keep Your ${manuallyReviewedTotal} Decision${manuallyReviewedTotal > 1 ? "s" : ""}`
            }
        });
        saviActionTakenCount += smartActionDetails[item][config.actionTakenKey];
        return item;
    });
    return {
        newSmartReviewOptions: newSmartReviewOptions,
        saviActionTakenCount: saviActionTakenCount
    };
};
function $e40ef6d119a5d30a$var$SaviCompanion({ certKey: certKey, setShowSaviCompanion: setShowSaviCompanion }) {
    const [isProceedWithSavi, setIsProceedWithSavi] = (0, $hopDi$useState)(false);
    const [smartReviewOptions, setSmartReviewOptions] = (0, $hopDi$useState)([]);
    const [selectedSmartReviewOptions, setSelectedSmartReviewOptions] = (0, $hopDi$useState)({});
    const [isSaviActionsTaken, setIsSaviActionsTaken] = (0, $hopDi$useState)(false);
    const showIntroLocal = $e40ef6d119a5d30a$var$cookies.get("show_savi_intro");
    const [showSaviCompanionIntro, setShowSaviCompanionIntro] = (0, $hopDi$useState)(!showIntroLocal || showIntroLocal === "1");
    const [errorDetails, setErrorDetails] = (0, $hopDi$useState)({});
    const dispatch = (0, $hopDi$useDispatch)();
    const { saviCompanionDetails: { statusDetails: statusDetails, showIntro: showIntro, isApplyActionLoading: isApplyActionLoading }, columnNames: columnNames } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const getSaviStatus = ()=>{
        dispatch((0, $d623f23401a154f0$export$f4f9bb309d2b8abf)(certKey, setErrorDetails, getSaviStatus));
    };
    (0, $hopDi$useEffect)(getSaviStatus, []);
    (0, $hopDi$useEffect)(()=>{
        if (statusDetails && statusDetails.smartActionDetails) {
            const { smartActionDetails: smartActionDetails } = statusDetails;
            const { newSmartReviewOptions: newSmartReviewOptions, saviActionTakenCount: saviActionTakenCount } = $e40ef6d119a5d30a$var$processSmartActionDetails(smartActionDetails);
            setSmartReviewOptions(newSmartReviewOptions);
            setIsSaviActionsTaken(saviActionTakenCount > 0);
            setIsProceedWithSavi(saviActionTakenCount > 0);
        }
    }, [
        statusDetails
    ]);
    const onApplySaviActions = ()=>{
        dispatch((0, $d623f23401a154f0$export$257ace57b4563d30)({
            certkey: certKey,
            signal: "TRUST_SCORE",
            ...selectedSmartReviewOptions
        }, {
            columnNames: columnNames,
            max: (0, $e4cfe974853390b2$export$aeca2bf7951e0a69),
            offset: 0,
            postSuccessAction: setShowSaviCompanion,
            postFailureAction: setErrorDetails,
            retryAction: onApplySaviActions
        }));
        setSelectedSmartReviewOptions({});
    };
    const onGotItClicked = ()=>{
        setIsProceedWithSavi(true);
        setShowSaviCompanionIntro(false);
        $e40ef6d119a5d30a$var$cookies.set("show_savi_intro", "0");
    };
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
        kind: "default",
        onClose: ()=>setShowSaviCompanion(false),
        className: `Savi-Companion-Modal SaviCompanion-Main${isProceedWithSavi}`,
        isOpen: true,
        headerIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
            kind: "SaviCompanion",
            size: "large"
        }),
        title: /*#__PURE__*/ (0, $hopDi$jsx)($e40ef6d119a5d30a$var$SaviCompanionTitle, {
            kind: !showSaviCompanionIntro ? "normal" : "landing"
        }),
        contentBody: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                showSaviCompanionIntro && /*#__PURE__*/ (0, $hopDi$jsx)($e40ef6d119a5d30a$var$SaviCompanionLandingBody, {
                    onGotItClick: onGotItClicked
                }),
                (!showIntro || isProceedWithSavi) && /*#__PURE__*/ (0, $hopDi$jsx)($e40ef6d119a5d30a$var$SaviCompanionBody, {
                    setSelectedSmartReviewOptions: setSelectedSmartReviewOptions,
                    selectedSmartReviewOptions: selectedSmartReviewOptions,
                    isLoading: statusDetails.loading,
                    isSaviActionsTaken: isSaviActionsTaken,
                    smartReviewOptions: smartReviewOptions,
                    setShowSaviCompanion: setShowSaviCompanion,
                    isApplyActionLoading: isApplyActionLoading,
                    errorDetails: errorDetails
                })
            ]
        }),
        FooterActionBarComp: Object.keys(selectedSmartReviewOptions).length > 0 ? /*#__PURE__*/ (0, $hopDi$jsx)("div", {
            className: "SaviCompanion-Footer",
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                type: "button",
                kind: "filled",
                size: "large",
                onClick: onApplySaviActions,
                children: isSaviActionsTaken ? "Apply" : "See Results"
            })
        }) : null
    }, "saviCompanionModal");
}
$e40ef6d119a5d30a$var$SaviCompanion.propTypes = {
    certKey: (0, $hopDi$proptypes).number.isRequired,
    setShowSaviCompanion: (0, $hopDi$proptypes).func.isRequired
};
var // SaviCompanion.defaultProps = {};
$e40ef6d119a5d30a$export$2e2bcd8739ae039 = $e40ef6d119a5d30a$var$SaviCompanion;


/* eslint-disable react/jsx-curly-spacing */ /* eslint-disable no-unused-vars */ /* eslint-disable jsx-a11y/anchor-is-valid */ 





/* eslint-disable react/jsx-curly-spacing */ 




function $1c4893cc536d206e$var$AdvancedFilterButton({ filters: filters, showFilterBar: showFilterBar, setShowFilterBar: setShowFilterBar, showBadgeOnFilterButton: showBadgeOnFilterButton }) {
    const { isLoading: isLoading, tabs: tabs } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const activeTabCount = tabs?.tabData?.find((tab)=>tab.isActive)?.count;
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonSelect), {
        label: "Filter",
        onClick: ()=>{
            if (filters.length > 0) setShowFilterBar((prev)=>!prev);
        },
        isOpen: showFilterBar,
        size: "medium",
        prefixIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
            kind: "Filter",
            color: "neutral-600",
            size: "smallMedium"
        }),
        BadgeComp: showBadgeOnFilterButton ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Badge), {
            kind: "dot",
            color: "primary",
            size: "small"
        }) : null,
        isDisabled: filters.length === 0 || activeTabCount === 0 || isLoading
    });
}
$1c4893cc536d206e$var$AdvancedFilterButton.propTypes = {
    filters: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({})).isRequired,
    showFilterBar: (0, $hopDi$proptypes).bool.isRequired,
    setShowFilterBar: (0, $hopDi$proptypes).func.isRequired,
    showBadgeOnFilterButton: (0, $hopDi$proptypes).bool.isRequired
};
var $1c4893cc536d206e$export$2e2bcd8739ae039 = $1c4893cc536d206e$var$AdvancedFilterButton;


/* eslint-disable react/jsx-curly-spacing */ /* eslint-disable no-shadow */ 






const $52fa6d0b886d7882$var$useClickOutside = (ref, onClickOutside)=>{
    (0, $hopDi$useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (ref.current && typeof ref.current === "object" && !ref.current.contains(event.target)) onClickOutside();
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        ref,
        onClickOutside
    ]);
};
var $52fa6d0b886d7882$export$2e2bcd8739ae039 = $52fa6d0b886d7882$var$useClickOutside;




/* eslint-disable react/jsx-curly-spacing */ /* eslint-disable no-shadow */ 



const $36b8d1366c64b9c7$export$f46d66ac5a9e4045 = 6;
const $36b8d1366c64b9c7$export$7774877bdb857c73 = 200;
const $36b8d1366c64b9c7$export$b71a7e05ee124e8e = 3;
const $36b8d1366c64b9c7$export$1f43468d1110fd7b = $36b8d1366c64b9c7$export$f46d66ac5a9e4045 - 1; // In design it is set to 6, allowing to configure atleast one filter
const $36b8d1366c64b9c7$export$aac7f63bb7ed27e = 300;
const $36b8d1366c64b9c7$export$cfb9e92ff3cd43f4 = 10;
const $36b8d1366c64b9c7$export$4e1772f042a16d95 = "unchanged";
const $36b8d1366c64b9c7$export$435b46f4233ebe34 = "Added_Filter";
const $36b8d1366c64b9c7$export$35d42548e97bb61f = "Removed_Filter";


/* eslint-disable no-restricted-syntax */ 


const $809c6fe4b590ebad$export$1bae5911fd45fa82 = (state, updatedState)=>{
    if (state.length === updatedState.length) return {
        state: (0, $36b8d1366c64b9c7$export$4e1772f042a16d95),
        filter: null
    };
    if (state.length > updatedState.length) return {
        state: (0, $36b8d1366c64b9c7$export$35d42548e97bb61f),
        filter: state.filter((item1)=>!updatedState.some((item2)=>item2.key === item1.key && item2.value === item1.value))
    };
    return {
        state: (0, $36b8d1366c64b9c7$export$435b46f4233ebe34),
        filter: updatedState.filter((item1)=>!state.some((item2)=>item2.key === item1.key && item2.value === item1.value))
    };
};
const $809c6fe4b590ebad$var$reCreateFilterOptions = (options)=>{
    const tempOptions = [];
    // eslint-disable-next-line no-restricted-syntax
    for(const key in options)if (Object.prototype.hasOwnProperty.call(options, key)) tempOptions.push({
        label: `${key.trim() === "" ? "Blank" : key}`,
        value: `${key}`,
        isChecked: false
    });
    return tempOptions;
};
const $809c6fe4b590ebad$export$92b9437c5afd872a = (filters, intl)=>{
    const { valueCountMap: valueCountMap } = filters;
    const COUNT_OF_FIXED_FILTERS = Math.min((0, $36b8d1366c64b9c7$export$1f43468d1110fd7b), (0, $36b8d1366c64b9c7$export$b71a7e05ee124e8e));
    let count = 0;
    const tempFilters = [];
    for(const key in valueCountMap)if (Object.prototype.hasOwnProperty.call(valueCountMap, key)) {
        const options = $809c6fe4b590ebad$var$reCreateFilterOptions(valueCountMap[key]);
        // Adding only when filter has atleast one option
        if (options.length > 0) {
            tempFilters.push({
                key: `${key}`,
                label: `${(0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(key)) || key}`,
                isActive: count < COUNT_OF_FIXED_FILTERS,
                isDefault: count < COUNT_OF_FIXED_FILTERS && false,
                options: options
            });
            count += 1;
        }
    }
    return tempFilters;
};
const $809c6fe4b590ebad$export$d2ea28e46364c0c8 = (filters)=>filters.filter((filter)=>filter.isActive === true).length;


function $e755bfdd37ca2612$var$AddFilterDropdown({ showFilterBar: showFilterBar, isDropDownMenuOpen: isDropDownMenuOpen, headingDescription: headingDescription, placeholder: placeholder, filters: filters, setFilters: setFilters, dropdownMenuPositionToRight: dropdownMenuPositionToRight, filterListWrapRef: filterListWrapRef, handleRemoveFilter: handleRemoveFilter }) {
    const [searchText, setSearchText] = (0, $hopDi$useState)("");
    const [isVisible, setIsVisible] = (0, $hopDi$useState)(true);
    const onClose = ()=>{
        setIsVisible(false);
    };
    const enableFilter = (filterKey)=>{
        if ((0, $809c6fe4b590ebad$export$d2ea28e46364c0c8)(filters) >= (0, $36b8d1366c64b9c7$export$f46d66ac5a9e4045)) {
            setIsVisible(true);
            return;
        }
        setFilters((filters)=>filters.map((filter)=>{
                if (filter.key === filterKey) return {
                    ...filter,
                    isActive: !filter.isActive
                };
                return filter;
            }));
    };
    const disableFilter = (filterKey)=>{
        handleRemoveFilter(filterKey);
        setIsVisible(false);
    };
    const addFilterDropDownStyles = dropdownMenuPositionToRight ? {
        right: "0"
    } : {
        left: "0"
    };
    const addFilterDropDownListStyles = {
        maxHeight: isVisible ? "21rem" : "24rem"
    };
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: isDropDownMenuOpen && showFilterBar ? "AddFilterDropdown-dropDown--isActive" : "AddFilterDropdown-dropDown--isDisabled",
        style: addFilterDropDownStyles,
        children: [
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "AddFilterDropdown-dropDownHeadingDescription",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body3",
                        children: headingDescription
                    }),
                    (0, $809c6fe4b590ebad$export$d2ea28e46364c0c8)(filters) >= (0, $36b8d1366c64b9c7$export$f46d66ac5a9e4045) && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InlineMessage), {
                        kind: "background",
                        size: "small",
                        text: "You\u2019ve reached maximum number of filter sets allowed. Remove existing ones to add more.",
                        colorTheme: "info",
                        leftIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "Info"
                        }),
                        isVisible: isVisible,
                        onDismiss: onClose,
                        isDismissible: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "AddFilterDropdown-dropDownSearchBar",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InputField), {
                    name: "basic",
                    placeholder: placeholder,
                    kind: "search",
                    size: "small",
                    prefixIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "search",
                        color: "neutral-700",
                        size: "smallMedium"
                    }),
                    value: searchText,
                    setValue: setSearchText,
                    tabIndex: 0
                })
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "AddFilterDropdown-dropDownFilterList",
                style: addFilterDropDownListStyles,
                ref: filterListWrapRef,
                children: filters?.filter((filter)=>!filter?.isDefault && filter.label.toLowerCase().indexOf(searchText.toLowerCase()) !== -1)?.sort((a, b)=>b.isActive - a.isActive || a.label.toLowerCase().localeCompare(b.label.toLowerCase()))?.map((filter)=>/*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "AddFilterDropdown-dropDownFilterListItems",
                        children: filter?.isActive ? /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                            className: "AddFilterDropdown-dropDownFilterListItemsWrapper",
                            onClick: ()=>{
                                disableFilter(filter?.key);
                            },
                            onKeyUp: ()=>{},
                            role: "button",
                            tabIndex: 0,
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                    className: "AddFilterDropdown-dropDownFilterListItemsCustomButtom--isEnabled",
                                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                                        size: "small",
                                        kind: "bold",
                                        isSelected: true,
                                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                            kind: "Remove"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    kind: "body2-bold",
                                    className: "AddFilterDropdown-dropDownFilterListItemsCustomButtomText--isEnabled",
                                    children: filter?.label
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                            className: "AddFilterDropdown-dropDownFilterListItemsWrapper",
                            onClick: ()=>{
                                enableFilter(filter?.key);
                            },
                            onKeyUp: ()=>{},
                            role: "button",
                            tabIndex: 0,
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                    className: "AddFilterDropdown-dropDownFilterListItemsCustomButtom--isDisabled",
                                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                                        size: "small",
                                        kind: "outlinedSecondary",
                                        isDisabled: false,
                                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                            kind: "Add"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    kind: "body2",
                                    className: "AddFilterDropdown-dropDownFilterListItemsCustomButtomText--isDisabled",
                                    children: filter?.label
                                })
                            ]
                        })
                    }, filter?.key))
            })
        ]
    });
}
$e755bfdd37ca2612$var$AddFilterDropdown.propTypes = {
    showFilterBar: (0, $hopDi$proptypes).bool.isRequired,
    isDropDownMenuOpen: (0, $hopDi$proptypes).bool.isRequired,
    headingDescription: (0, $hopDi$proptypes).string,
    placeholder: (0, $hopDi$proptypes).string,
    filters: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({
        label: (0, $hopDi$proptypes).string.isRequired,
        key: (0, $hopDi$proptypes).string.isRequired,
        isActive: (0, $hopDi$proptypes).bool,
        options: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({
            label: (0, $hopDi$proptypes).string.isRequired,
            value: (0, $hopDi$proptypes).string.isRequired
        }))
    })).isRequired,
    setFilters: (0, $hopDi$proptypes).func.isRequired,
    dropdownMenuPositionToRight: (0, $hopDi$proptypes).bool,
    filterListWrapRef: (0, $hopDi$proptypes).shape({}).isRequired,
    handleRemoveFilter: (0, $hopDi$proptypes).func.isRequired
};
$e755bfdd37ca2612$var$AddFilterDropdown.defaultProps = {
    headingDescription: "",
    placeholder: "",
    dropdownMenuPositionToRight: false
};
var $e755bfdd37ca2612$export$2e2bcd8739ae039 = $e755bfdd37ca2612$var$AddFilterDropdown;





function $9080a8ca19badea3$var$AdvancedFilters({ setShowBadgeOnFilterButton: setShowBadgeOnFilterButton, showFilterBar: showFilterBar, areControlsVisible: areControlsVisible, filters: filters, setFilters: setFilters, appliedFilters: appliedFilters, setAppliedFilters: setAppliedFilters }) {
    const intl = (0, $hopDi$useIntl)();
    const dispatch = (0, $hopDi$useDispatch)();
    const { bulkAction: bulkAction, certKey: certKey, certsFilters: certsFilters, searchText: searchText, columnNames: columnNames, triggerClearBtnForFilters: triggerClearBtnForFilters } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const [isDropDownMenuOpen, setIsDropDownMenuOpen] = (0, $hopDi$useState)(false);
    const [dropdownMenuPositionToRight, setDropDownMenuPositionToRight] = (0, $hopDi$useState)(true);
    const [isClearBtnDisabled, setIsClearBtnDisabled] = (0, $hopDi$useState)(false);
    const dropDownWrapperRef = (0, $hopDi$useRef)("menu");
    const filterBarRef = (0, $hopDi$useRef)("filterBar");
    const filterListWrapRef = (0, $hopDi$useRef)("filterListWrap");
    (0, $52fa6d0b886d7882$export$2e2bcd8739ae039)(dropDownWrapperRef, ()=>{
        (0, $e7628c995f405891$export$63087e5d2dd3ce07)(filterListWrapRef, 0);
        setIsDropDownMenuOpen(false);
    });
    (0, $hopDi$useEffect)(()=>{
        if (certKey && columnNames) dispatch((0, $d623f23401a154f0$export$4d715bff11887d61)(certKey));
    }, [
        certKey,
        columnNames
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (certsFilters) {
            const sanitizedFilters = (0, $809c6fe4b590ebad$export$92b9437c5afd872a)(certsFilters, intl);
            setFilters(sanitizedFilters);
        }
    }, [
        certsFilters
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (Math.abs(filterBarRef.current.offsetLeft - dropDownWrapperRef.current.offsetLeft) < (0, $36b8d1366c64b9c7$export$aac7f63bb7ed27e)) setDropDownMenuPositionToRight(false);
        else setDropDownMenuPositionToRight(true);
    }, [
        filters
    ]);
    (0, $hopDi$useEffect)(()=>{
        const handleResize = ()=>{
            if (Math.abs(filterBarRef.current.offsetLeft - dropDownWrapperRef.current.offsetLeft) < (0, $36b8d1366c64b9c7$export$aac7f63bb7ed27e)) setDropDownMenuPositionToRight(false);
            else setDropDownMenuPositionToRight(true);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    const handleFilterUpdate = (filterToUpdate, filters, modifiedFilters, appliedFilters, updatedAppliedFilters)=>{
        if (bulkAction?.isChecked || bulkAction?.isIndeterminate) {
            dispatch((0, $d623f23401a154f0$export$1a295a970dce82de)(true));
            dispatch((0, $d623f23401a154f0$export$c594ad0cf83b2327)(certKey, true)).then(()=>{
                dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(false));
                dispatch((0, $d623f23401a154f0$export$889241fc0afda8a9)(false));
            }).catch((error)=>{
                dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(true, error.message));
            });
        }
        const tempFilters = filters;
        const tempAppliedFilters = appliedFilters;
        if (filterToUpdate.state !== (0, $36b8d1366c64b9c7$export$4e1772f042a16d95)) {
            setIsClearBtnDisabled(true);
            setFilters(modifiedFilters);
            setAppliedFilters(updatedAppliedFilters);
            if (filterToUpdate?.filter.length > 1) {
                const promiseToRemoveFilters = [];
                for(let i = 0; i < filterToUpdate.filter.length; i += 1)promiseToRemoveFilters.push(dispatch((0, $d623f23401a154f0$export$1f0b8da065fa133a)(filterToUpdate?.filter[i].key, filterToUpdate?.filter[i].value, filterToUpdate.state === (0, $36b8d1366c64b9c7$export$435b46f4233ebe34))));
                Promise.all(promiseToRemoveFilters).then((responses)=>{
                    const combinedResponse = responses.every((response)=>response === true);
                    if (combinedResponse) dispatch((0, $d623f23401a154f0$export$fad033acbe739b9c)(certKey, columnNames, (0, $36b8d1366c64b9c7$export$cfb9e92ff3cd43f4), 0, searchText));
                    else {
                        setFilters(tempFilters);
                        setAppliedFilters(tempAppliedFilters);
                    }
                }).catch(()=>{
                    setFilters(tempFilters);
                    setAppliedFilters(tempAppliedFilters);
                }).finally(()=>{
                    setIsClearBtnDisabled(false);
                });
            } else dispatch((0, $d623f23401a154f0$export$1f0b8da065fa133a)(filterToUpdate?.filter[0].key, filterToUpdate?.filter[0].value, filterToUpdate.state === (0, $36b8d1366c64b9c7$export$435b46f4233ebe34))).then((response)=>{
                if (response) dispatch((0, $d623f23401a154f0$export$fad033acbe739b9c)(certKey, columnNames, (0, $36b8d1366c64b9c7$export$cfb9e92ff3cd43f4), 0, searchText));
                else {
                    setFilters(tempFilters);
                    setAppliedFilters(tempAppliedFilters);
                }
            }).catch(()=>{
                setFilters(tempFilters);
                setAppliedFilters(tempAppliedFilters);
            }).finally(()=>{
                setIsClearBtnDisabled(false);
            });
        }
    };
    (0, $hopDi$useEffect)(()=>{
        dispatch((0, $d623f23401a154f0$export$877a3b3409060dd6)(appliedFilters));
        if (appliedFilters.length > 0) setShowBadgeOnFilterButton(true);
        else setShowBadgeOnFilterButton(false);
    }, [
        appliedFilters
    ]);
    const handleMultiMenuChange = (filterKey, selectedOptions)=>{
        const updatedAppliedFilters = [];
        const modifiedFilters = filters.map((filter)=>{
            if (filter.key === filterKey) return {
                ...filter,
                options: filter.options.map((option)=>({
                        ...option,
                        isChecked: selectedOptions.some((selectedOption)=>selectedOption.value === option.value)
                    }))
            };
            return filter;
        });
        modifiedFilters.forEach((filter)=>{
            const _selectedOptions = filter.options.filter((option)=>option.isChecked === true).map((option)=>({
                    key: filter.key,
                    ...option
                }));
            updatedAppliedFilters.push(..._selectedOptions);
        });
        const filterToUpdate = (0, $809c6fe4b590ebad$export$1bae5911fd45fa82)(appliedFilters, updatedAppliedFilters);
        handleFilterUpdate(filterToUpdate, filters, modifiedFilters, appliedFilters, updatedAppliedFilters);
    };
    const handleRemoveFilter = (filterKey)=>{
        const updatedAppliedFilters = [];
        const modifiedFilters = filters.map((filter)=>{
            if (filter.key === filterKey) return {
                ...filter,
                options: filter.options.map((option)=>({
                        ...option,
                        isChecked: false
                    }))
            };
            return filter;
        });
        modifiedFilters.forEach((filter)=>{
            const _selectedOptions = filter.options.filter((option)=>option.isChecked === true).map((option)=>({
                    key: filter.key,
                    ...option
                }));
            updatedAppliedFilters.push(..._selectedOptions);
        });
        const filterToUpdate = (0, $809c6fe4b590ebad$export$1bae5911fd45fa82)(appliedFilters, updatedAppliedFilters);
        handleFilterUpdate(filterToUpdate, filters, modifiedFilters, appliedFilters, updatedAppliedFilters);
        setFilters((filters)=>filters.map((filter)=>{
                if (filter.key === filterKey) return {
                    ...filter,
                    isActive: !filter.isActive || filter.isDefault
                };
                return filter;
            }));
        setAppliedFilters((filters)=>filters.filter((filter)=>filter.key !== filterKey && filter.isDefault !== true));
    };
    const resetFilters = ()=>{
        setIsClearBtnDisabled(true);
        dispatch((0, $d623f23401a154f0$export$5ef35f45efc10503)()).then((response)=>{
            if (response && certKey) {
                dispatch((0, $d623f23401a154f0$export$fad033acbe739b9c)(certKey, columnNames, (0, $36b8d1366c64b9c7$export$cfb9e92ff3cd43f4), 0, searchText));
                setFilters((filters)=>filters.map((filter)=>({
                            ...filter,
                            options: filter.options.map((option)=>({
                                    ...option,
                                    isChecked: false
                                }))
                        })));
                setShowBadgeOnFilterButton(false);
                setAppliedFilters([]);
            }
        }).finally(()=>{
            setIsClearBtnDisabled(false);
        });
    };
    (0, $hopDi$useEffect)(()=>{
        if (!isClearBtnDisabled && triggerClearBtnForFilters) {
            resetFilters();
            dispatch((0, $d623f23401a154f0$export$86d11b633a5d59e6)(false));
        }
    }, [
        triggerClearBtnForFilters
    ]);
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: showFilterBar && areControlsVisible ? "AdvancedFilters-filterBar--isActive" : "AdvancedFilters-filterBar--isDisabled",
        ref: filterBarRef,
        children: [
            filters?.map((filter)=>filter.isActive && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MenuMulti), {
                    className: "AdvancedFilters-filterBarMenuItem",
                    options: filter.options,
                    label: filter.label,
                    onChange: (selectedOptions)=>{
                        handleMultiMenuChange(filter.key, selectedOptions);
                    },
                    trigger: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonSelect), {
                        kind: "pill",
                        label: ""
                    }),
                    minOptionsForFooter: 1,
                    minOptionsForSearch: 1,
                    sortOnCheck: true,
                    headerText: "Applied to: // WIP",
                    // TODO: Need grouping from the backend
                    headerTextConfigs: {
                        headerTextClassName: "AdvancedFilters-filterBarMenuItemHeaderText",
                        splitOnToken: true,
                        token: ":",
                        preTokenClassName: "AdvancedFilters-filterBarMenuItemHeaderTextPreToken",
                        postTokenClassName: "AdvancedFilters-filterBarMenuItemHeaderTextPostToken"
                    },
                    footerLink1Text: "Remove Filter",
                    onFooterLink1Click: ()=>handleRemoveFilter(filter.key)
                }, filter.key)),
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                ref: dropDownWrapperRef,
                className: "AdvancedFilters-filterBarDropDownWrap",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                        size: "medium",
                        kind: "outlinedNeutral",
                        isSelected: isDropDownMenuOpen,
                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "add",
                            color: "neutral-1000"
                        }),
                        onClick: ()=>{
                            (0, $e7628c995f405891$export$63087e5d2dd3ce07)(filterListWrapRef, 0);
                            setIsDropDownMenuOpen(!isDropDownMenuOpen);
                        }
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $e755bfdd37ca2612$export$2e2bcd8739ae039), {
                        showFilterBar: showFilterBar,
                        isDropDownMenuOpen: isDropDownMenuOpen,
                        headingDescription: "Add or Remove Filters",
                        placeholder: "Search",
                        filters: filters,
                        setFilters: setFilters,
                        appliedFilters: appliedFilters,
                        setAppliedFilters: setAppliedFilters,
                        dropdownMenuPositionToRight: dropdownMenuPositionToRight,
                        filterListWrapRef: filterListWrapRef,
                        handleRemoveFilter: handleRemoveFilter
                    })
                ]
            }),
            appliedFilters.length > 0 && // eslint-disable-next-line jsx-a11y/anchor-is-valid
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Link), {
                text: "Clear",
                kind: "button",
                onClick: resetFilters,
                isDisabled: isClearBtnDisabled
            })
        ]
    });
}
$9080a8ca19badea3$var$AdvancedFilters.propTypes = {
    setShowBadgeOnFilterButton: (0, $hopDi$proptypes).func.isRequired,
    showFilterBar: (0, $hopDi$proptypes).bool.isRequired,
    areControlsVisible: (0, $hopDi$proptypes).bool.isRequired,
    filters: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({})).isRequired,
    setFilters: (0, $hopDi$proptypes).func.isRequired,
    appliedFilters: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({})).isRequired,
    setAppliedFilters: (0, $hopDi$proptypes).func.isRequired
};
var $9080a8ca19badea3$export$2e2bcd8739ae039 = $9080a8ca19badea3$var$AdvancedFilters;




/* eslint-disable react/jsx-wrap-multilines */ /* eslint-disable react/jsx-curly-spacing */ 






function $f875ecc3d42fa49d$var$CertsControlTabs() {
    const [tempTabs, setTempTabs] = (0, $hopDi$useState)([]);
    const [activeTab, setActiveTab] = (0, $hopDi$useState)("");
    // const [referenceCounts, setReferenceCounts] = useState({});
    // const [flashTab, setFlashTab] = useState({});
    const dispatch = (0, $hopDi$useDispatch)();
    const { certKey: certKey, bulkAction: bulkAction, tabs: tabs, reviewAndSubmit: { primaryCertifier: primaryCertifier } } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const { tabData: tabData } = tabs;
    (0, $hopDi$useEffect)(()=>{
        if (tabData) {
            const newTabs = tabData.map((tab)=>({
                    ...tab,
                    isActive: tab.key === activeTab
                }));
            setTempTabs(newTabs);
            setActiveTab(tabData.find((tab)=>tab.isActive)?.key || tabData[0]?.key);
        // TODO: This needs to be figure out later
        // tabData.forEach((tab) => {
        //   // Check if reference count exists and count has changed
        //   if (
        //     referenceCounts[tab.key] !== undefined &&
        //     referenceCounts[tab.key] !== tab.count
        //   ) {
        //     setFlashTab((prev) => ({ ...prev, [tab.key]: true }));
        //     setTimeout(() => {
        //       setFlashTab((prev) => ({ ...prev, [tab.key]: false }));
        //     }, 500);
        //     // Update reference count after flashing
        //     setReferenceCounts((prev) => ({ ...prev, [tab.key]: tab.count }));
        //   } else if (referenceCounts[tab.key] === undefined) {
        //     // Initialize reference count for this tab
        //     setReferenceCounts((prev) => ({ ...prev, [tab.key]: tab.count }));
        //   }
        // });
        }
    }, [
        tabData,
        primaryCertifier
    ]);
    const handleChange = (key)=>{
        if (bulkAction?.isChecked || bulkAction?.isIndeterminate) {
            dispatch((0, $d623f23401a154f0$export$1a295a970dce82de)(true));
            dispatch((0, $d623f23401a154f0$export$c594ad0cf83b2327)(certKey, true)).then(()=>{
                dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(false));
                dispatch((0, $d623f23401a154f0$export$889241fc0afda8a9)(false));
            }).catch((error)=>{
                dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(true, error.message));
            });
        }
        setActiveTab(key);
        dispatch((0, $d623f23401a154f0$export$e9c5cd8aea0cabc7)(tabData.map((tab)=>({
                ...tab,
                isActive: tab.key === key,
                isHighlighted: false
            }))));
        dispatch((0, $d623f23401a154f0$export$ebe6b5ce6ed9ef39)(false));
        dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(false));
        dispatch((0, $d623f23401a154f0$export$889241fc0afda8a9)(false));
    };
    const getTooltipText = (key)=>{
        switch(key){
            case 0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49:
                return "Items waiting to be approved or rejected";
            case 0, $d44c789d5b60f9bf$export$807a0bc890800408:
                return "Items that have been approved or rejected";
            case 0, $d44c789d5b60f9bf$export$d5eea126dff5a615:
                return "All items included in the certification";
            case 0, $d44c789d5b60f9bf$export$b2766b46106d3053:
                return "Items that have been sent for consultation";
            default:
                return "Default Tooltip Text";
        }
    };
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabGroup), {
        value: activeTab,
        onChange: handleChange,
        children: tempTabs?.filter((tab)=>{
            // INFO: Cannot use filter inside useState as it will rewrite reducer state
            if (tab.key === (0, $d44c789d5b60f9bf$export$b2766b46106d3053)) return primaryCertifier && tab.count !== 0;
            return true;
        })?.map((tab)=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                label: `${tab.label} (${tab.count})`,
                value: tab.key,
                tooltipProps: {
                    text: getTooltipText(tab.key) || "",
                    maxWidth: "18rem",
                    isRequired: {}
                },
                // className={`${
                //   flashTab[tab.key] ? 'CertsControlTabs-tabItem--isTabFlash' : ''
                // } ${
                //   tab.isHighlighted ? 'CertsControlTabs-tabItem--isHighlighted' : ''
                // }`}
                className: `${tab?.isHighlighted ? "CertsControlTabs-tabItem--isHighlighted" : ""}`
            }, tab.key))
    });
}
var $f875ecc3d42fa49d$export$2e2bcd8739ae039 = $f875ecc3d42fa49d$var$CertsControlTabs;



var $b8f7c55addb0e434$export$2e2bcd8739ae039 = (0, $f875ecc3d42fa49d$export$2e2bcd8739ae039);


/* eslint-disable guard-for-in */ /* eslint-disable no-restricted-syntax */ 






/* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable react/jsx-props-no-spreading */ 







/* eslint-disable react/jsx-curly-spacing */ 






const $6d218ab9b83faef2$export$e12a4cadfc09074e = "-4";
const $6d218ab9b83faef2$export$addbd3a73cd831b8 = "-2";
const $6d218ab9b83faef2$export$2fdde2b3b0357dd1 = "0";
const $6d218ab9b83faef2$export$b5f0f72f5619891f = ">0";
const $6d218ab9b83faef2$export$e99ca72b1ac3fcd6 = "users";
const $6d218ab9b83faef2$export$33e5df6437060fe4 = "roles";
const $6d218ab9b83faef2$export$67904de277d10d08 = "accounts";
const $6d218ab9b83faef2$export$28401dcfd55adaaa = "entitlements";
const $6d218ab9b83faef2$export$6a2b1149d9dd6e5f = [
    {
        label: "User",
        value: $6d218ab9b83faef2$export$e12a4cadfc09074e,
        isParent: false,
        isChecked: true,
        isDisabled: false,
        isLast: false,
        options: [
            {
                label: "Role",
                value: $6d218ab9b83faef2$export$addbd3a73cd831b8,
                isParent: false,
                isChecked: true,
                isDisabled: false,
                isLast: false,
                options: []
            },
            {
                label: "Account",
                value: $6d218ab9b83faef2$export$2fdde2b3b0357dd1,
                isParent: false,
                isChecked: true,
                isDisabled: false,
                isLast: false,
                options: [
                    {
                        label: "Entitlement",
                        value: $6d218ab9b83faef2$export$b5f0f72f5619891f,
                        isParent: false,
                        isChecked: true,
                        isDisabled: false,
                        isLast: false,
                        options: []
                    }
                ]
            }
        ]
    }
];


/* eslint-disable no-console */ /* eslint-disable jsx-a11y/label-has-associated-control */ 



/* eslint-disable no-param-reassign */ 
const $c647e77118d4a3ed$export$a2b4ad410285e3a3 = (filterTree)=>{
    let count = 0;
    const tempFilterTree = JSON.parse(JSON.stringify(filterTree));
    const getCount = (tree)=>{
        for(let i = 0; i < tree.length; i += 1){
            tree[i].count = count;
            count += 1;
            if (tree[i].options.length > 0) getCount(tree[i].options);
        }
    };
    getCount(tempFilterTree);
    return tempFilterTree;
};
const $c647e77118d4a3ed$export$c33ee69d36354d25 = (arr)=>{
    const tempArr = [];
    for(let i = 0; i < arr.length; i += 1){
        if (arr[i].isDisabled === false) tempArr.push(arr[i].value);
        if (arr[i].options.length !== 0) tempArr.push(...$c647e77118d4a3ed$export$c33ee69d36354d25(arr[i].options));
    }
    return tempArr;
};
const $c647e77118d4a3ed$export$81d81b51abd59a55 = (arr)=>{
    const tempArr = [];
    for(let i = 0; i < arr.length; i += 1){
        if (arr[i].isChecked === true && arr[i].isDisabled === false) tempArr.push(arr[i].value);
        if (arr[i].options.length !== 0) tempArr.push(...$c647e77118d4a3ed$export$81d81b51abd59a55(arr[i].options));
    }
    return tempArr;
};
const $c647e77118d4a3ed$export$397227221b180a45 = (filterTree, viewRowsList)=>{
    const tempTree = JSON.parse(JSON.stringify(filterTree));
    const reMapIsDisabled = (tree)=>{
        tree.forEach((obj)=>{
            if (obj.value === (0, $6d218ab9b83faef2$export$e12a4cadfc09074e) && !viewRowsList.includes((0, $6d218ab9b83faef2$export$e99ca72b1ac3fcd6))) obj.isDisabled = true;
            if (obj.value === (0, $6d218ab9b83faef2$export$addbd3a73cd831b8) && !viewRowsList.includes((0, $6d218ab9b83faef2$export$33e5df6437060fe4))) obj.isDisabled = true;
            if (obj.value === (0, $6d218ab9b83faef2$export$2fdde2b3b0357dd1) && !viewRowsList.includes((0, $6d218ab9b83faef2$export$67904de277d10d08))) obj.isDisabled = true;
            if (obj.value === (0, $6d218ab9b83faef2$export$b5f0f72f5619891f) && !viewRowsList.includes((0, $6d218ab9b83faef2$export$28401dcfd55adaaa))) obj.isDisabled = true;
            if (obj.options.length > 0) reMapIsDisabled(obj.options);
        });
    };
    reMapIsDisabled(tempTree);
    const reCreateHierarchy = (tree)=>{
        const _tempTree = [];
        tree.forEach((obj)=>{
            if (!obj.isDisabled) _tempTree.push({
                ...obj,
                options: (obj?.options && obj.options.length) > 0 ? reCreateHierarchy(obj.options) : []
            });
            else if (obj.options && obj.options.length > 0) _tempTree.push(...reCreateHierarchy(obj.options));
        });
        return _tempTree;
    };
    const reMapIsParent = (tree)=>{
        tree.forEach((obj)=>{
            obj.isParent = true;
        });
    };
    const hierarchyTree = reCreateHierarchy(tempTree);
    reMapIsParent(hierarchyTree);
    return hierarchyTree;
};
const $c647e77118d4a3ed$export$64491fac9a125e2c = (filters)=>{
    let count = 0;
    const _getCountOfAvailableFilters = (_filters)=>{
        _filters.forEach((filter)=>{
            if (filter.isDisabled === false) count += 1;
            if (filter?.options?.length > 0) _getCountOfAvailableFilters(filter.options);
        });
    };
    _getCountOfAvailableFilters(filters);
    return count;
};
const $c647e77118d4a3ed$export$12cb800f03e426ca = (filterTree)=>{
    const tempTree = JSON.parse(JSON.stringify(filterTree));
    const resetFilter = (tree)=>{
        const _tempTree = [];
        tree.forEach((obj)=>{
            _tempTree.push({
                ...obj,
                isChecked: true,
                options: (obj?.options && obj.options.length) > 0 ? resetFilter(obj.options) : []
            });
        });
        return _tempTree;
    };
    return resetFilter(tempTree);
};


function $6e598230156851b9$var$RowsFilter({ filters: filters, appliedRowFilters: appliedRowFilters, setAppliedRowFilters: setAppliedRowFilters, level: level }) {
    const filtersWithCount = (0, $c647e77118d4a3ed$export$a2b4ad410285e3a3)(filters);
    const [nestedFilters, setNestedFilters] = (0, $hopDi$useState)(filtersWithCount);
    (0, $hopDi$useEffect)(()=>{
        setNestedFilters((0, $c647e77118d4a3ed$export$a2b4ad410285e3a3)(filters));
    }, [
        filters
    ]);
    const handleToggle = (filterValue)=>{
        if (appliedRowFilters.includes(filterValue)) {
            if (appliedRowFilters.length === 1) {
                console.warn("Atleast one filter is required");
                return;
            }
            setAppliedRowFilters((prev)=>prev.filter((item)=>item !== filterValue));
        } else setAppliedRowFilters([
            ...appliedRowFilters,
            filterValue
        ]);
        setNestedFilters((prev)=>prev.map((filter)=>{
                if (filter.value === filterValue) return {
                    ...filter,
                    isChecked: !filter.isChecked
                };
                return filter;
            }));
    };
    (0, $hopDi$useEffect)(()=>{
        if (appliedRowFilters?.length === 1) setNestedFilters((prev)=>prev.map((filter)=>({
                    ...filter,
                    isLast: filter.value === appliedRowFilters[0]
                })));
        if (appliedRowFilters?.length > 1) setNestedFilters((prev)=>prev.map((filter)=>({
                    ...filter,
                    isLast: false
                })));
    }, [
        appliedRowFilters
    ]);
    return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
        className: "RowsFilter-filterList",
        children: nestedFilters?.map((filter)=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$react).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsxs)("label", {
                        className: "RowsFilter-filterListItem",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "RowsFilter-filterListItemWrapper",
                                style: {
                                    transform: `translateX(-${level * 1.125}rem)`,
                                    width: `calc(100% + ${level * 1.125 + 0.875}rem)`
                                }
                            }),
                            !filter?.isParent && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "RowsFilter-filterListItemConnectors--top",
                                style: {
                                    height: `${(filter.count + 1) * 2.375}rem`
                                }
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "RowsFilter-filterListItemCheckboxParent",
                                children: /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                    className: "RowsFilter-filterListItemCheckboxChild",
                                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                                        name: filter?.value,
                                        kind: "base",
                                        showHoverEffect: false,
                                        dataTestId: "checkbox-no-hovereffect",
                                        isChecked: filter?.isChecked || filter?.isDisabled,
                                        onChange: ()=>handleToggle(filter?.value),
                                        isDisabled: filter?.isDisabled || filter?.isLast
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)("p", {
                                className: "RowsFilter-filterListItemTextBox",
                                children: filter?.label
                            })
                        ]
                    }, filter?.value),
                    filter?.options.length > 0 && /*#__PURE__*/ (0, $hopDi$jsx)($6e598230156851b9$var$RowsFilter, {
                        filters: filter?.options,
                        appliedRowFilters: appliedRowFilters,
                        setAppliedRowFilters: setAppliedRowFilters,
                        level: level + 1
                    })
                ]
            }, filter?.value))
    });
}
$6e598230156851b9$var$RowsFilter.propTypes = {
    filters: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({
        label: (0, $hopDi$proptypes).string.isRequired,
        value: (0, $hopDi$proptypes).string.isRequired,
        isChecked: (0, $hopDi$proptypes).bool.isRequired,
        isParent: (0, $hopDi$proptypes).bool,
        options: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({
            label: (0, $hopDi$proptypes).string,
            value: (0, $hopDi$proptypes).string,
            isChecked: (0, $hopDi$proptypes).bool.isRequired
        }))
    })).isRequired,
    appliedRowFilters: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string).isRequired,
    setAppliedRowFilters: (0, $hopDi$proptypes).func.isRequired,
    level: (0, $hopDi$proptypes).number.isRequired
};
var $6e598230156851b9$export$2e2bcd8739ae039 = $6e598230156851b9$var$RowsFilter;




function $c1aab06b4e147060$var$RowFilterButton({ showRowFilter: showRowFilter, setShowRowFilter: setShowRowFilter, showbadgeOnRowButton: showbadgeOnRowButton, setShowbadgeOnRowButton: setShowbadgeOnRowButton, rowFilters: rowFilters, setRowFilters: setRowFilters, appliedRowFilters: appliedRowFilters, setAppliedRowFilters: setAppliedRowFilters }) {
    const dispatch = (0, $hopDi$useDispatch)();
    const { isLoading: isLoading, tabs: tabs, viewRowsList: viewRowsList } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const activeTabCount = tabs?.tabData?.find((tab)=>tab.isActive)?.count;
    const dropDownWrapperRef = (0, $hopDi$useRef)("menu");
    const shouldShowRowFilterBtn = Boolean(viewRowsList && viewRowsList?.length > 1);
    (0, $52fa6d0b886d7882$export$2e2bcd8739ae039)(dropDownWrapperRef, ()=>{
        setShowRowFilter(false);
    });
    const shouldShowBadgeOnRowButton = (filters)=>{
        const activeFiltersForRows = (0, $c647e77118d4a3ed$export$c33ee69d36354d25)(rowFilters);
        return activeFiltersForRows.length !== filters.length && filters.length !== 0;
    };
    (0, $hopDi$useEffect)(()=>{
        if (viewRowsList && viewRowsList?.length > 0) {
            const tempRowsTree = (0, $c647e77118d4a3ed$export$397227221b180a45)((0, $6d218ab9b83faef2$export$6a2b1149d9dd6e5f), viewRowsList);
            setRowFilters(tempRowsTree);
            setAppliedRowFilters((0, $c647e77118d4a3ed$export$81d81b51abd59a55)(tempRowsTree));
        } else {
            setRowFilters((0, $6d218ab9b83faef2$export$6a2b1149d9dd6e5f));
            setAppliedRowFilters((0, $c647e77118d4a3ed$export$81d81b51abd59a55)((0, $6d218ab9b83faef2$export$6a2b1149d9dd6e5f)));
        }
    }, [
        viewRowsList
    ]);
    (0, $hopDi$useEffect)(()=>{
        dispatch((0, $d623f23401a154f0$export$d290070680bebdf9)(appliedRowFilters));
        setShowbadgeOnRowButton(shouldShowBadgeOnRowButton(appliedRowFilters));
    }, [
        appliedRowFilters
    ]);
    return shouldShowRowFilterBtn && /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "RowFilterButton",
        ref: dropDownWrapperRef,
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonSelect), {
                label: "Rows",
                onClick: ()=>{
                    if (activeTabCount > 0) setShowRowFilter((prev)=>!prev);
                },
                isOpen: showRowFilter,
                size: "medium",
                prefixIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "Hierarchy",
                    color: "neutral-600",
                    size: "smallMedium"
                }),
                BadgeComp: showbadgeOnRowButton ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Badge), {
                    kind: "dot",
                    color: "primary",
                    size: "small"
                }) : null,
                isDisabled: activeTabCount === 0 || isLoading
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: showRowFilter ? "RowsFilter-dropDown--active" : "RowsFilter-dropDown--disabled",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $6e598230156851b9$export$2e2bcd8739ae039), {
                    filters: rowFilters,
                    appliedRowFilters: appliedRowFilters,
                    setAppliedRowFilters: setAppliedRowFilters,
                    level: 0
                })
            })
        ]
    });
}
$c1aab06b4e147060$var$RowFilterButton.propTypes = {
    showRowFilter: (0, $hopDi$proptypes).bool.isRequired,
    setShowRowFilter: (0, $hopDi$proptypes).func.isRequired,
    showbadgeOnRowButton: (0, $hopDi$proptypes).bool.isRequired,
    setShowbadgeOnRowButton: (0, $hopDi$proptypes).func.isRequired,
    rowFilters: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({})).isRequired,
    setRowFilters: (0, $hopDi$proptypes).func.isRequired,
    appliedRowFilters: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string).isRequired,
    setAppliedRowFilters: (0, $hopDi$proptypes).func.isRequired
};
var $c1aab06b4e147060$export$2e2bcd8739ae039 = $c1aab06b4e147060$var$RowFilterButton;



var $49b471e64a4eb65c$export$2e2bcd8739ae039 = (0, $c1aab06b4e147060$export$2e2bcd8739ae039);


const $a23cd229b9113926$export$7774877bdb857c73 = 200;
const $a23cd229b9113926$export$ad084766e7fbe946 = 5;
const $a23cd229b9113926$export$be14771196440103 = {
    count: 0
};
const $a23cd229b9113926$export$c2fd574cc3b8c823 = "User";
const $a23cd229b9113926$export$c97501b522a7bf89 = "Role";
const $a23cd229b9113926$export$eeb9092565ce426a = "Account";
const $a23cd229b9113926$export$7d1f9b2b2a057886 = "Entitlement";
const $a23cd229b9113926$export$128908aadf8e4646 = [
    $a23cd229b9113926$export$c2fd574cc3b8c823,
    $a23cd229b9113926$export$eeb9092565ce426a,
    $a23cd229b9113926$export$7d1f9b2b2a057886,
    $a23cd229b9113926$export$c97501b522a7bf89
];
const $a23cd229b9113926$export$50fc35c85d3a3c9d = "User_DISPLAYNAME";
const $a23cd229b9113926$export$1772b047bb5ee9a = "Role_DISPLAYNAME";
const $a23cd229b9113926$export$e7e5437fabb30374 = "Account_DISPLAYNAME";
const $a23cd229b9113926$export$1b550718072cac3f = "Ent_DISPLAYNAME";
const $a23cd229b9113926$export$3d372a4d90e6e43c = [
    `${$a23cd229b9113926$export$c2fd574cc3b8c823.toUpperCase()}-${$a23cd229b9113926$export$50fc35c85d3a3c9d}`,
    `${$a23cd229b9113926$export$eeb9092565ce426a.toUpperCase()}-${$a23cd229b9113926$export$e7e5437fabb30374}`,
    `${$a23cd229b9113926$export$7d1f9b2b2a057886.toUpperCase()}-${$a23cd229b9113926$export$1b550718072cac3f}`,
    `${$a23cd229b9113926$export$c97501b522a7bf89.toUpperCase()}-${$a23cd229b9113926$export$1772b047bb5ee9a}`
];


/* eslint-disable guard-for-in */ /* eslint-disable no-restricted-syntax */ 
const $5ed7a2f47bdaa9df$export$ed9a82d791c0007b = (obj)=>{
    const checkedOptions = {};
    obj.forEach((filter)=>{
        checkedOptions[filter.value] = [];
        filter.options.forEach((option)=>{
            if (option.isChecked === true) checkedOptions[filter.value].push(option.value);
        });
    });
    return checkedOptions;
};
const $5ed7a2f47bdaa9df$var$reCreateColOptions = (options, key)=>{
    const tempOptions = [];
    for(const optionKey in options)tempOptions.push({
        label: `${options[optionKey]}`,
        value: `${key}-${optionKey}`,
        isChecked: true
    });
    return tempOptions;
};
const $5ed7a2f47bdaa9df$export$c219b8879429123c = (filters, allowedFilters = [])=>{
    const tempColFilters = [];
    for(const key in filters)if (Object.prototype.hasOwnProperty.call(filters, key)) {
        let isDisabled = false;
        const options = $5ed7a2f47bdaa9df$var$reCreateColOptions(filters[key], key.toUpperCase());
        if (key === (0, $a23cd229b9113926$export$c2fd574cc3b8c823) && !allowedFilters.includes((0, $6d218ab9b83faef2$export$e99ca72b1ac3fcd6))) isDisabled = true;
        if (key === (0, $a23cd229b9113926$export$c97501b522a7bf89) && !allowedFilters.includes((0, $6d218ab9b83faef2$export$33e5df6437060fe4))) isDisabled = true;
        if (key === (0, $a23cd229b9113926$export$eeb9092565ce426a) && !allowedFilters.includes((0, $6d218ab9b83faef2$export$67904de277d10d08))) isDisabled = true;
        if (key === (0, $a23cd229b9113926$export$7d1f9b2b2a057886) && !allowedFilters.includes((0, $6d218ab9b83faef2$export$28401dcfd55adaaa))) isDisabled = true;
        tempColFilters.push({
            label: `${key}`,
            value: `${key.toUpperCase()}`,
            isDisabled: isDisabled,
            options: options
        });
    }
    return tempColFilters.sort((a, b)=>(0, $a23cd229b9113926$export$128908aadf8e4646).indexOf(a.label) - (0, $a23cd229b9113926$export$128908aadf8e4646).indexOf(b.label));
};


function $1b64cfc1069de672$var$ColumnsFilter({ showColFilter: showColFilter, colFilters: colFilters, setColFilters: setColFilters, setAppliedColFilters: setAppliedColFilters }) {
    const activeFilterTab = colFilters.find((filter)=>!filter.isDisabled);
    const intl = (0, $hopDi$useIntl)();
    const [activeTab, setActiveTab] = (0, $hopDi$useState)(activeFilterTab?.value ? activeFilterTab?.value : "0");
    const dropDownBodyRef = (0, $hopDi$useRef)("dropDownBody");
    (0, $hopDi$useEffect)(()=>{
        setTimeout(()=>{
            (0, $e7628c995f405891$export$63087e5d2dd3ce07)(dropDownBodyRef, 0);
            setActiveTab(activeFilterTab?.value ? activeFilterTab?.value : "0");
        }, (0, $a23cd229b9113926$export$7774877bdb857c73));
    }, [
        showColFilter
    ]);
    const handleActiveTab = (value)=>{
        if (value) {
            (0, $e7628c995f405891$export$63087e5d2dd3ce07)(dropDownBodyRef, 0);
            setActiveTab(value);
        }
    };
    const handleChange = (optionValue)=>{
        const modifiedFilters = colFilters.map((filter)=>{
            const modifiedFilter = {
                ...filter,
                options: filter.options.map((option)=>{
                    if (option.value === optionValue) return {
                        ...option,
                        isChecked: !option.isChecked
                    };
                    return option;
                }).sort((a, b)=>b.isChecked - a.isChecked)
            };
            return modifiedFilter;
        });
        setColFilters(modifiedFilters);
        (0, $a23cd229b9113926$export$be14771196440103).count += 1;
        setAppliedColFilters((0, $5ed7a2f47bdaa9df$export$ed9a82d791c0007b)(modifiedFilters));
    };
    const reOrderColFilterList = (srcIndex, destIndex, parentFilter)=>{
        const reOrderedList = colFilters.map((filter)=>{
            if (filter.value === parentFilter) {
                const tempOptions = filter.options.filter((indexOption)=>!(0, $a23cd229b9113926$export$3d372a4d90e6e43c).includes(indexOption.value));
                const removedOption = tempOptions.splice(srcIndex, 1);
                const modifiedOptions = [
                    ...filter.options.filter((indexOption)=>(0, $a23cd229b9113926$export$3d372a4d90e6e43c).includes(indexOption.value)),
                    ...tempOptions.slice(0, destIndex),
                    ...removedOption,
                    ...tempOptions.slice(destIndex)
                ];
                return {
                    ...filter,
                    options: modifiedOptions.sort((a, b)=>b.isChecked - a.isChecked)
                };
            }
            return filter;
        });
        setColFilters(reOrderedList);
        (0, $a23cd229b9113926$export$be14771196440103).count += 1;
        setAppliedColFilters((0, $5ed7a2f47bdaa9df$export$ed9a82d791c0007b)(reOrderedList));
    };
    const onDragEnd = (result)=>{
        if (!result.destination) return;
        reOrderColFilterList(result.source.index, result.destination.index, result.destination.droppableId);
    };
    const renderNoticeText = ()=>/*#__PURE__*/ (0, $hopDi$jsx)("div", {
            className: "ColumnsFilter-dropDownBodyNote",
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                kind: "body2",
                children: "The number of visible attributes depends on the size of your browser and screen. Any attributes not shown are visible in the detailed view."
            })
        });
    const renderTabGroups = ()=>{
        const validTabsCount = colFilters?.reduce((acc, item)=>!item.isDisabled ? acc + 1 : acc, [
            0
        ]);
        return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabGroup), {
            value: activeTab,
            onChange: handleActiveTab,
            className: "ColumnsFilter-dropdownTabGroup",
            children: colFilters?.map((tab)=>{
                if (!tab.isDisabled) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                    className: validTabsCount >= 3 ? "ColumnsFilter-dropdownTabGroupTabItems" : "",
                    label: tab.label,
                    value: tab.value
                }, tab.value);
                return /*#__PURE__*/ (0, $hopDi$jsx)("span", {}, tab.value);
            })
        });
    };
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$DragDropContext), {
        onDragEnd: onDragEnd,
        children: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: showColFilter ? "ColumnsFilter-dropDown--active" : "ColumnsFilter-dropDown--disabled",
            children: [
                renderTabGroups(),
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    ref: dropDownBodyRef,
                    className: "ColumnsFilter-dropDownBody",
                    children: [
                        renderNoticeText(),
                        /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                            className: "ColumnsFilter-dropDownBodyFilterList",
                            children: colFilters?.map((tab)=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
                                    value: activeTab,
                                    tabValue: tab?.value,
                                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Droppable), {
                                        droppableId: tab?.value,
                                        children: (droppableProvider, snapshot)=>{
                                            const style = snapshot.isDraggingOver ? {
                                                pointerEvents: "none"
                                            } : {};
                                            return /*#__PURE__*/ (0, $hopDi$createElement)("div", {
                                                ...droppableProvider.droppableProps,
                                                ref: droppableProvider.innerRef,
                                                className: "ColumnsFilter-dropDownBodyFilterListContainer",
                                                key: tab?.value,
                                                style: style,
                                                children: [
                                                    tab?.options?.filter((indexOption)=>!(0, $a23cd229b9113926$export$3d372a4d90e6e43c).includes(indexOption?.value)).map((option, index)=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Draggable), {
                                                            draggableId: `${option?.value}`,
                                                            index: index,
                                                            children: (draggableProvider)=>/*#__PURE__*/ (0, $hopDi$createElement)("div", {
                                                                    ref: draggableProvider.innerRef,
                                                                    ...draggableProvider.draggableProps,
                                                                    key: option?.value,
                                                                    className: "ColumnsFilter-dropDownBodyFilterListContainerSubItems",
                                                                    children: [
                                                                        option?.isChecked ? /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                                                                                    className: "ColumnsFilter-dropDownBodyFilterListContainerSubItemsDraggerToolTip",
                                                                                    children: "Drag to Reorder"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                                                                    ...draggableProvider.dragHandleProps,
                                                                                    className: "ColumnsFilter-dropDownBodyFilterListContainerSubItemsDragger",
                                                                                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                                                                        kind: "DoubleKebabVertical",
                                                                                        color: "neutral-1000",
                                                                                        size: "smallMedium"
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }) : /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                                                            ...draggableProvider.dragHandleProps,
                                                                            className: "ColumnsFilter-dropDownBodyFilterListContainerSubItemsDraggerFiller",
                                                                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                                                                kind: "DoubleKebabVertical",
                                                                                color: "neutral-1000",
                                                                                size: "smallMedium"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $hopDi$jsxs)("label", {
                                                                            className: "ColumnsFilter-dropDownBodyFilterListContainerSubItemsCheckBox",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                                                                                    name: option?.value,
                                                                                    kind: "base",
                                                                                    showHoverEffect: false,
                                                                                    dataTestId: "checkbox-no-hovereffect",
                                                                                    isChecked: option?.isChecked,
                                                                                    onChange: ()=>handleChange(option?.value)
                                                                                }),
                                                                                /*#__PURE__*/ (0, $hopDi$jsx)("p", {
                                                                                    className: "ColumnsFilter-dropDownBodyFilterListContainerSubItemsCheckBoxText",
                                                                                    children: (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(option?.label?.split(".")[0]))
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                        }, option?.value)),
                                                    droppableProvider.placeholder
                                                ]
                                            });
                                        }
                                    }, tab?.value)
                                }, tab?.value))
                        })
                    ]
                })
            ]
        })
    });
}
$1b64cfc1069de672$var$ColumnsFilter.propTypes = {
    showColFilter: (0, $hopDi$proptypes).bool.isRequired,
    colFilters: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({
        label: (0, $hopDi$proptypes).string.isRequired,
        value: (0, $hopDi$proptypes).string.isRequired,
        options: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({
            label: (0, $hopDi$proptypes).string,
            value: (0, $hopDi$proptypes).string,
            isChecked: (0, $hopDi$proptypes).bool.isRequired
        }))
    })),
    setColFilters: (0, $hopDi$proptypes).func.isRequired,
    setAppliedColFilters: (0, $hopDi$proptypes).func.isRequired
};
$1b64cfc1069de672$var$ColumnsFilter.defaultProps = {
    colFilters: []
};
var $1b64cfc1069de672$export$2e2bcd8739ae039 = $1b64cfc1069de672$var$ColumnsFilter;





function $69c872152dbdd062$var$ColumnFilterButton({ showColFilter: showColFilter, setShowColFilter: setShowColFilter, showbadgeOnColButton: showbadgeOnColButton, setShowbadgeOnColButton: setShowbadgeOnColButton, colFilters: colFilters, setColFilters: setColFilters, appliedColFilters: appliedColFilters, setAppliedColFilters: setAppliedColFilters }) {
    const dispatch = (0, $hopDi$useDispatch)();
    const { isLoading: isLoading, columnPickerList: columnPickerList, viewRowsList: viewRowsList, tabs: tabs } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const activeTabCount = tabs?.tabData?.find((tab)=>tab.isActive)?.count;
    const dropDownWrapperRef = (0, $hopDi$useRef)("menu");
    (0, $hopDi$useEffect)(()=>{
        if (columnPickerList && viewRowsList) {
            const tempColFilters = (0, $5ed7a2f47bdaa9df$export$c219b8879429123c)(columnPickerList, viewRowsList);
            setColFilters(tempColFilters);
            setAppliedColFilters((0, $5ed7a2f47bdaa9df$export$ed9a82d791c0007b)(tempColFilters));
        }
    }, [
        columnPickerList,
        viewRowsList
    ]);
    (0, $hopDi$useEffect)(()=>{
        dispatch((0, $d623f23401a154f0$export$b551d76884371ba3)(appliedColFilters));
        setShowbadgeOnColButton((0, $a23cd229b9113926$export$be14771196440103).count > 0);
    }, [
        appliedColFilters
    ]);
    (0, $52fa6d0b886d7882$export$2e2bcd8739ae039)(dropDownWrapperRef, ()=>{
        setShowColFilter(false);
    });
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "ColumnFilterButton",
        ref: dropDownWrapperRef,
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonSelect), {
                label: "Columns",
                onClick: ()=>{
                    if (colFilters?.length > 0) setShowColFilter((prev)=>!prev);
                },
                isOpen: showColFilter,
                size: "medium",
                prefixIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "VisibilityOn",
                    color: "neutral-600",
                    size: "smallMedium"
                }),
                BadgeComp: showbadgeOnColButton ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Badge), {
                    kind: "dot",
                    color: "primary",
                    size: "small"
                }) : null,
                isDisabled: colFilters?.length === 0 || activeTabCount === 0 || isLoading
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $1b64cfc1069de672$export$2e2bcd8739ae039), {
                showColFilter: showColFilter,
                colFilters: colFilters,
                setColFilters: setColFilters,
                setAppliedColFilters: setAppliedColFilters
            })
        ]
    });
}
$69c872152dbdd062$var$ColumnFilterButton.propTypes = {
    showColFilter: (0, $hopDi$proptypes).bool.isRequired,
    setShowColFilter: (0, $hopDi$proptypes).func.isRequired,
    showbadgeOnColButton: (0, $hopDi$proptypes).bool.isRequired,
    setShowbadgeOnColButton: (0, $hopDi$proptypes).func.isRequired,
    colFilters: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({})).isRequired,
    setColFilters: (0, $hopDi$proptypes).func.isRequired,
    appliedColFilters: (0, $hopDi$proptypes).shape({}),
    setAppliedColFilters: (0, $hopDi$proptypes).func.isRequired
};
$69c872152dbdd062$var$ColumnFilterButton.defaultProps = {
    appliedColFilters: {}
};
var $69c872152dbdd062$export$2e2bcd8739ae039 = $69c872152dbdd062$var$ColumnFilterButton;



var $1364363abc6281cb$export$2e2bcd8739ae039 = (0, $69c872152dbdd062$export$2e2bcd8739ae039);


/* eslint-disable no-param-reassign */ /* eslint-disable no-unused-vars */ 











// eslint-disable-next-line import/prefer-default-export
const $93b356efe95f7cab$export$3fd9cf1e436e0f28 = (data)=>{
    let parentInfo = [];
    data?.forEach((ele)=>{
        if (ele.isParent) parentInfo.push(ele.label);
        else if (ele.options && ele.options?.length > 0) {
            const info = $93b356efe95f7cab$export$3fd9cf1e436e0f28(ele.options);
            parentInfo = [
                ...info,
                ...parentInfo
            ];
        }
    });
    return parentInfo;
};
const $93b356efe95f7cab$export$c2010b7d24abd870 = (label)=>label.split(".")[0];
const $93b356efe95f7cab$export$6289ca747cabdbcb = (list, option)=>{
    if (option) {
        const index = list.findIndex((obj)=>obj.label === option.label);
        if (index > -1) {
            list.splice(index, 1);
            list.unshift(option);
        }
    }
    return list;
};
const $93b356efe95f7cab$export$ad4c9ce976c36d4d = (string)=>{
    const pattern = /\b(?:date|Date)\b/;
    return pattern.test(string);
};


function $1173b64c5f93fe2b$var$SortDropdown({ searchDescription: searchDescription, placeholder: placeholder, searchText: searchText, setSearchText: setSearchText, className: className, isRightIcon: isRightIcon, filteredSortList: filteredSortList, selectedOption: selectedOption, handleOptionSelect: handleOptionSelect, disableSearch: disableSearch }) {
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: `Dynamic-dropdown ${className}`,
        children: [
            !disableSearch && /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)("p", {
                        className: "search-description",
                        children: searchDescription
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "SortSearchBar",
                        "data-test-id": "searchbar",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InputField), {
                            name: "basic",
                            placeholder: placeholder,
                            label: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "label",
                                htmlFor: "Label",
                                children: "Label"
                            }),
                            kind: "search",
                            size: "small",
                            prefixIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: "search",
                                color: "neutral-700",
                                size: "smallMedium"
                            }),
                            value: searchText,
                            setValue: setSearchText,
                            tabIndex: 0
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "Dynamic-sortlistWrap",
                children: (0, $93b356efe95f7cab$export$6289ca747cabdbcb)(filteredSortList, selectedOption).map((option)=>/*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: `MenuItem ${option.isDisabled ? "MenuItem--isDisabled" : ""} ${selectedOption && selectedOption.value === option.value ? "MenuItem--isChecked" : ""}`,
                        onClick: ()=>handleOptionSelect(option, true),
                        onKeyUp: ()=>{},
                        role: "button",
                        tabIndex: "0",
                        children: selectedOption && selectedOption.value === option.value ? /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    kind: "body2-bold",
                                    children: option.label
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                    kind: "Check",
                                    color: "navy-900",
                                    size: "medium"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    kind: "body2",
                                    children: option.label
                                }),
                                isRightIcon && !selectedOption ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                    kind: "ChevronRight",
                                    color: "navy-900",
                                    size: "xSmall"
                                }) : null
                            ]
                        })
                    }, option.value))
            })
        ]
    });
}
$1173b64c5f93fe2b$var$SortDropdown.propTypes = {
    searchDescription: (0, $hopDi$proptypes).string.isRequired,
    placeholder: (0, $hopDi$proptypes).string.isRequired,
    searchText: (0, $hopDi$proptypes).string.isRequired,
    setSearchText: (0, $hopDi$proptypes).func.isRequired,
    className: (0, $hopDi$proptypes).string,
    filteredSortList: (0, $hopDi$proptypes).arrayOf().isRequired,
    selectedOption: (0, $hopDi$proptypes).shape({
        value: (0, $hopDi$proptypes).string
    }),
    handleOptionSelect: (0, $hopDi$proptypes).func.isRequired,
    disableSearch: (0, $hopDi$proptypes).bool,
    isRightIcon: (0, $hopDi$proptypes).bool
};
$1173b64c5f93fe2b$var$SortDropdown.defaultProps = {
    className: "",
    selectedOption: null,
    disableSearch: false,
    isRightIcon: false
};
var $1173b64c5f93fe2b$export$2e2bcd8739ae039 = $1173b64c5f93fe2b$var$SortDropdown;




const $06d8bdc0aa76c00b$var$SORT_OPTIONS = [
    {
        label: "A to Z",
        value: "asc",
        isDisabled: false,
        isChecked: true
    },
    {
        label: "Z to A",
        value: "desc",
        isDisabled: false,
        isChecked: false
    }
];
const $06d8bdc0aa76c00b$var$SORT_DATE_OPTIONS = [
    {
        label: "Ascending",
        value: "asc",
        isDisabled: false,
        isChecked: true
    },
    {
        label: "Descending",
        value: "desc",
        isDisabled: false,
        isChecked: false
    }
];
function $06d8bdc0aa76c00b$var$DynamicSort({ rowFilters: rowFilters, colFilters: colFilters, handleSort: handleSort, areControlsVisible: areControlsVisible, resetDynamicSort: resetDynamicSort }) {
    const [sortList, setSortList] = (0, $hopDi$useState)([]);
    const [selectedOption, setSelectedOption] = (0, $hopDi$useState)(null);
    const [sortDirection, setSortDirection] = (0, $hopDi$useState)([]);
    const [selectedSortDirection, setSelectedSortDirection] = (0, $hopDi$useState)(null);
    const [isOpen, setIsOpen] = (0, $hopDi$useState)(false);
    const [isOpenLevel2, setIsOpenLevel2] = (0, $hopDi$useState)(false);
    const [isSortSelection, setIsSortSelection] = (0, $hopDi$useState)(false);
    const [isSortOptionsOpen, setIsSortOptionsOpen] = (0, $hopDi$useState)(false);
    const [searchText, setSearchText] = (0, $hopDi$useState)("");
    const dropdownRef = (0, $hopDi$useRef)(null);
    const intl = (0, $hopDi$useIntl)();
    const { isLoading: isLoading, tabs: tabs } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const activeTabCount = tabs?.tabData?.find((tab)=>tab.isActive)?.count;
    (0, $hopDi$useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
                setIsOpenLevel2(false);
                setIsSortOptionsOpen(false);
                setIsSortSelection(false);
            }
        };
        setSortDirection($06d8bdc0aa76c00b$var$SORT_OPTIONS);
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    (0, $hopDi$useEffect)(()=>{
        if (rowFilters.length > 0 && colFilters.length > 0) {
            const parentInfo = (0, $93b356efe95f7cab$export$3fd9cf1e436e0f28)(rowFilters);
            let filteredDynamicSortData = [];
            colFilters.forEach((ele)=>{
                if (parentInfo.includes(ele.label)) {
                    const colOptions = JSON.parse(JSON.stringify(ele.options));
                    filteredDynamicSortData = [
                        ...filteredDynamicSortData,
                        ...colOptions
                    ];
                }
            });
            const data = filteredDynamicSortData.map((ele)=>{
                ele.coulmnName = (0, $93b356efe95f7cab$export$c2010b7d24abd870)(ele.label);
                ele.label = (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)((0, $93b356efe95f7cab$export$c2010b7d24abd870)(ele.label)));
                ele.isChecked = false;
                return ele;
            });
            setSortList(data);
        }
    }, [
        rowFilters,
        colFilters
    ]);
    // Close app menus on scroll down
    (0, $hopDi$useEffect)(()=>{
        if (!areControlsVisible) {
            setIsOpen(false);
            setIsOpenLevel2(false);
            setIsSortOptionsOpen(false);
        }
    }, [
        areControlsVisible
    ]);
    const handleSortAction = ()=>{
        if (handleSort) handleSort(selectedOption, sortDirection);
    };
    const handleOptionSelect = (option, initial)=>{
        if (selectedOption?.label === option.label) {
            setSelectedOption(null);
            setIsOpen(false);
            setIsOpenLevel2(false);
            setIsSortOptionsOpen(false);
            resetDynamicSort();
            // reset dynamic sort
            return;
        }
        setSelectedOption(option);
        if (initial) {
            const sortOptions = (0, $93b356efe95f7cab$export$ad4c9ce976c36d4d)(option.label) ? $06d8bdc0aa76c00b$var$SORT_DATE_OPTIONS : $06d8bdc0aa76c00b$var$SORT_OPTIONS;
            setSortDirection(sortOptions);
            setSelectedSortDirection(sortOptions[0]);
        }
        setIsOpen(false);
        setIsOpenLevel2(false);
        setIsSortOptionsOpen(true);
    };
    const handleSortDirectionSelect = (direction)=>{
        setSortDirection((currentOptions)=>currentOptions.map((option)=>({
                    ...option,
                    isChecked: option.value === direction.value
                })));
        setSelectedSortDirection(direction);
        setIsSortSelection(false);
    };
    const handleClearSort = ()=>{
        setSortList([]);
        setSelectedOption(null);
        setIsOpen(false);
        setIsOpenLevel2(false);
        setIsSortOptionsOpen(false);
        setSearchText("");
    };
    const handleCloseSort = ()=>{
        setIsOpen(false);
        setIsSortOptionsOpen(false);
    // resetDynamicSort(); need to check and handle the reset sort
    };
    const filteredSortList = sortList.filter((option)=>option.label.toLowerCase().includes(searchText.toLowerCase()));
    const handleSortDropdown = ()=>{
        setIsOpenLevel2(false);
        if (!selectedOption) setIsOpen(!isOpen);
        else setIsSortOptionsOpen(!isSortOptionsOpen);
    };
    const handleSortDropdownLevel2 = ()=>{
        setIsOpenLevel2(!isOpenLevel2);
    };
    const handleIsSortOption = ()=>{
        setIsSortSelection(!isSortSelection);
    };
    (0, $hopDi$useEffect)(()=>{
        if (selectedOption !== null) handleSortAction();
    }, [
        selectedOption,
        sortDirection
    ]);
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "DynamicSort-sort",
        ref: dropdownRef,
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "DynamicSort-sortTriggerWrap",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonSelect), {
                    className: `${selectedOption !== null && "CertificationDetails-header-sort-btn--isSelected"} CertificationDetails-header-sort-btn`,
                    kind: "icon",
                    size: "medium",
                    isOpen: isOpen,
                    onClick: ()=>handleSortDropdown(),
                    prefixIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "Sort"
                    }),
                    BadgeComp: selectedOption !== null ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Badge), {
                        kind: "dot",
                        color: "primary",
                        size: "small"
                    }) : null,
                    isDisabled: activeTabCount === 0 || isLoading
                })
            }),
            isOpen && !selectedOption && /*#__PURE__*/ (0, $hopDi$jsx)((0, $1173b64c5f93fe2b$export$2e2bcd8739ae039), {
                searchDescription: "Select an attribute to sort by.",
                placeholder: "Search attributes",
                searchText: searchText,
                setSearchText: setSearchText,
                className: "a",
                isRightIcon: true,
                filteredSortList: filteredSortList,
                selectedOption: selectedOption,
                handleOptionSelect: handleOptionSelect
            }),
            selectedOption && isSortOptionsOpen && /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "Dynamic-dropdown sort-options-wrap",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                        className: "selected-options-trigger",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonSelect), {
                            type: "button",
                            dataTestId: "menu-trigger",
                            "aria-pressed": isOpenLevel2,
                            label: selectedOption?.label,
                            onClick: handleSortDropdownLevel2,
                            isOpen: isOpenLevel2,
                            isDisabled: activeTabCount === 0 || isLoading
                        })
                    }),
                    isOpenLevel2 && /*#__PURE__*/ (0, $hopDi$jsx)((0, $1173b64c5f93fe2b$export$2e2bcd8739ae039), {
                        placeholder: "Search attributes",
                        searchText: searchText,
                        setSearchText: setSearchText,
                        className: "sort-option-second-level",
                        filteredSortList: filteredSortList,
                        selectedOption: selectedOption,
                        handleOptionSelect: handleOptionSelect
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                        className: "selected-options-trigger",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonSelect), {
                            type: "button",
                            dataTestId: "menu-trigger",
                            "aria-pressed": isSortSelection,
                            label: selectedSortDirection?.label,
                            onClick: handleIsSortOption,
                            isOpen: isSortSelection,
                            isDisabled: activeTabCount === 0 || isLoading
                        })
                    }),
                    isSortSelection && /*#__PURE__*/ (0, $hopDi$jsx)((0, $1173b64c5f93fe2b$export$2e2bcd8739ae039), {
                        className: "DynamicSort-direction",
                        filteredSortList: sortDirection,
                        selectedOption: selectedSortDirection,
                        handleOptionSelect: handleSortDirectionSelect,
                        disableSearch: true
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                        className: "sort-clear",
                        onClick: handleCloseSort,
                        onKeyUp: ()=>{},
                        role: "button",
                        tabIndex: "0",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "close",
                            color: "neutral-700",
                            size: "xSmall"
                        })
                    })
                ]
            })
        ]
    });
}
$06d8bdc0aa76c00b$var$DynamicSort.propTypes = {
    rowFilters: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({})),
    colFilters: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({})),
    handleSort: (0, $hopDi$proptypes).func,
    resetDynamicSort: (0, $hopDi$proptypes).func,
    areControlsVisible: (0, $hopDi$proptypes).bool.isRequired
};
$06d8bdc0aa76c00b$var$DynamicSort.defaultProps = {
    rowFilters: [],
    colFilters: [],
    handleSort: ()=>{},
    resetDynamicSort: ()=>{}
};
var $06d8bdc0aa76c00b$export$2e2bcd8739ae039 = $06d8bdc0aa76c00b$var$DynamicSort;


var $96bbb2b8ad24fb0a$export$2e2bcd8739ae039 = (0, $06d8bdc0aa76c00b$export$2e2bcd8739ae039);










const $453466c718bc17f4$var$useDebounceForFunctions = (callback, delay)=>{
    const timeoutRef = (0, $hopDi$useRef)(null);
    (0, $hopDi$useEffect)(()=>()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }, []);
    const debouncedCallback = (...args)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(()=>{
            callback(...args);
        }, delay);
    };
    return debouncedCallback;
};
var $453466c718bc17f4$export$2e2bcd8739ae039 = $453466c718bc17f4$var$useDebounceForFunctions;



const $9f3c1cff4e3f9748$export$d5aa959239db7309 = 300;
const $9f3c1cff4e3f9748$export$cfb9e92ff3cd43f4 = 10;
const $9f3c1cff4e3f9748$export$b5f64487a8d6dc20 = 10;



function $4f962dfae72a3bd3$var$SearchBar() {
    const dispatch = (0, $hopDi$useDispatch)();
    const { bulkAction: bulkAction, certKey: certKey, columnNames: columnNames, isLoading: isLoading, triggerClearBtnForSearch: triggerClearBtnForSearch, tabs: tabs } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const activeTabCount = tabs?.tabData?.find((tab)=>tab.isActive)?.count;
    const [searchQuery, setSearchQuery] = (0, $hopDi$useState)("");
    const [isExpanded, setIsExpanded] = (0, $hopDi$useState)(false);
    const searchBarRef = (0, $hopDi$useRef)(null);
    const inputRef = (0, $hopDi$useRef)(null);
    const searchBoxClass = (0, $hopDi$classnames)(isExpanded ? "SearchBar--expanded" : "SearchBar--collapsed", (activeTabCount === 0 || isLoading) && "SearchBar--isDisabled");
    (0, $52fa6d0b886d7882$export$2e2bcd8739ae039)(searchBarRef, ()=>{
        if (searchQuery.trim() === "") setIsExpanded(false);
    });
    const enableInputField = ()=>{
        inputRef.current.focus();
    };
    (0, $hopDi$useEffect)(()=>{
        if (isExpanded && activeTabCount !== 0) enableInputField();
    }, [
        isExpanded
    ]);
    const handleToggleExpand = ()=>{
        if (!isExpanded && activeTabCount !== 0 && !isLoading) setIsExpanded(true);
    };
    // TODO: Give a timeframe for 1 min if Enter key is pressed for the same search query
    const handleSearch = (0, $453466c718bc17f4$export$2e2bcd8739ae039)(()=>{
        if (bulkAction?.isChecked || bulkAction?.isIndeterminate) {
            dispatch((0, $d623f23401a154f0$export$1a295a970dce82de)(true));
            dispatch((0, $d623f23401a154f0$export$c594ad0cf83b2327)(certKey, true)).then(()=>{
                dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(false));
                dispatch((0, $d623f23401a154f0$export$889241fc0afda8a9)(false));
            }).catch((error)=>{
                dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(true, error.message));
            });
        }
        if (certKey && (searchQuery.trim().length === 0 || searchQuery.trim().length > 3)) {
            dispatch((0, $d623f23401a154f0$export$a7b1b02371ce779a)(true));
            dispatch((0, $d623f23401a154f0$export$fad033acbe739b9c)(certKey, columnNames, (0, $9f3c1cff4e3f9748$export$cfb9e92ff3cd43f4), 0, searchQuery.trim()));
        }
    }, (0, $9f3c1cff4e3f9748$export$d5aa959239db7309));
    const handleChange = (event)=>{
        setSearchQuery(event.target.value);
    };
    const resetSearch = ()=>{
        dispatch((0, $d623f23401a154f0$export$a7b1b02371ce779a)(true));
        dispatch((0, $d623f23401a154f0$export$fad033acbe739b9c)(certKey, columnNames, (0, $9f3c1cff4e3f9748$export$cfb9e92ff3cd43f4), 0, "")).then(()=>{
            setSearchQuery("");
        });
        dispatch((0, $d623f23401a154f0$export$661e1772dd5a4141)(false));
        setIsExpanded(false);
    };
    const handleSearchBoxClose = ()=>{
        if (searchQuery.trim().length !== 0) {
            resetSearch();
            return;
        }
        setSearchQuery("");
        setIsExpanded(false);
    };
    (0, $hopDi$useEffect)(()=>{
        if (triggerClearBtnForSearch) resetSearch();
    }, [
        triggerClearBtnForSearch
    ]);
    const handleKeyPress = (event)=>{
        if (event.key === "Enter") handleSearch();
    };
    return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
        ref: searchBarRef,
        children: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: searchBoxClass,
            onKeyDown: ()=>{},
            role: "button",
            tabIndex: 0,
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                    className: `SearchBar-searchIcon ${activeTabCount === 0 || isLoading ? "SearchBar-searchIcon--isDisabled" : ""}`,
                    onClick: handleToggleExpand,
                    onKeyDown: ()=>{},
                    role: "button",
                    tabIndex: 0,
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "search",
                        color: "neutral-1000",
                        size: "smallMedium"
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    "aria-hidden": "true",
                    className: "SearchBar-inputField",
                    onClick: enableInputField,
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                            className: "SearchBar-inputFieldPlaceholder",
                            children: searchQuery.trim().length === 0 && "Search by name, account, application, etc."
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)("input", {
                            ref: inputRef,
                            type: "text",
                            name: "search",
                            value: searchQuery,
                            onChange: handleChange,
                            onClick: handleToggleExpand,
                            onKeyDown: handleKeyPress,
                            autoComplete: "off"
                        })
                    ]
                }),
                isExpanded && /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                    className: "Searchbar-closeButton",
                    onClick: handleSearchBoxClose,
                    onKeyDown: ()=>{},
                    role: "button",
                    tabIndex: 0,
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "close",
                        color: "gray-400",
                        size: "smallMedium"
                    })
                })
            ]
        })
    });
}
var $4f962dfae72a3bd3$export$2e2bcd8739ae039 = $4f962dfae72a3bd3$var$SearchBar;


var $941d0d32536ce9e0$export$2e2bcd8739ae039 = (0, $4f962dfae72a3bd3$export$2e2bcd8739ae039);





const $5630dd438c9b44f6$export$aeca2bf7951e0a69 = 10;
const $5630dd438c9b44f6$export$3231e969238304f3 = 0;



function $7166cd89a2c7c0dc$var$CertsControlsGroup({ areControlsVisible: areControlsVisible, showFilterBar: showFilterBar, setShowFilterBar: setShowFilterBar, setShowSaviCompanion: setShowSaviCompanion, isSaviEnabled: isSaviEnabled }) {
    const { isLoading: isLoading, bulkAction: bulkAction, certKey: certKey, columnNames: columnNames, shouldShowReviewAndSubmitButton: shouldShowReviewAndSubmitButton, tabs: tabs } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const activeTab = tabs?.tabData?.find((tab)=>tab.isActive);
    // For filter bar
    const [showBadgeOnFilterButton, setShowBadgeOnFilterButton] = (0, $hopDi$useState)(false);
    const [appliedFilters, setAppliedFilters] = (0, $hopDi$useState)([]);
    const [filters, setFilters] = (0, $hopDi$useState)([]);
    // For row filter
    const [showbadgeOnRowButton, setShowbadgeOnRowButton] = (0, $hopDi$useState)(false);
    const [showRowFilter, setShowRowFilter] = (0, $hopDi$useState)(false);
    const [rowFilters, setRowFilters] = (0, $hopDi$useState)([]);
    const [appliedRowFilters, setAppliedRowFilters] = (0, $hopDi$useState)([]);
    // For column filter
    const [showbadgeOnColButton, setShowbadgeOnColButton] = (0, $hopDi$useState)(false);
    const [showColFilter, setShowColFilter] = (0, $hopDi$useState)(false);
    const [colFilters, setColFilters] = (0, $hopDi$useState)([]);
    const [appliedColFilters, setAppliedColFilters] = (0, $hopDi$useState)({});
    // For Select All
    const dispatch = (0, $hopDi$useDispatch)();
    const isSelectAllVisable = Boolean(bulkAction?.showBulkSelectCheckBox && activeTab?.count > 0 && shouldShowReviewAndSubmitButton);
    // Update Tab Counts on Mount
    (0, $hopDi$useEffect)(()=>{
        if (certKey) dispatch((0, $d623f23401a154f0$export$afd1b438af1720fe)(certKey, true));
    }, [
        certKey
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (!areControlsVisible) {
            setShowRowFilter(false);
            setShowColFilter(false);
        }
    }, [
        areControlsVisible
    ]);
    const headerClasses = (0, $hopDi$classnames)("CertsControlsGroup", areControlsVisible ? "CertsControlsGroup--isVisible" : "CertsControlsGroup--isHidden", showFilterBar && "CertsControlsGroup--isFilterBar");
    const selectAllClasses = (0, $hopDi$classnames)("CertsControlsGroup-selectAll", isSelectAllVisable && "CertsControlsGroup-selectAll--isSelectAllVisable");
    const handleBulkChange = ()=>{
        dispatch((0, $d623f23401a154f0$export$1a295a970dce82de)(true));
        if (bulkAction?.isIndeterminate) {
            const prevBulkCheckStatus = bulkAction?.isChecked;
            const prevBulkIndeterminateStatus = bulkAction?.isIndeterminate;
            dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(true));
            dispatch((0, $d623f23401a154f0$export$889241fc0afda8a9)(false));
            dispatch((0, $d623f23401a154f0$export$c594ad0cf83b2327)(certKey)).then(()=>{
                dispatch((0, $d623f23401a154f0$export$2af49e179df91659)(true));
            }).catch((error)=>{
                dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(true, error.message));
                dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(prevBulkCheckStatus));
                dispatch((0, $d623f23401a154f0$export$889241fc0afda8a9)(prevBulkIndeterminateStatus));
            });
            return;
        }
        const prevBulkCheckStatus = bulkAction?.isChecked;
        if (prevBulkCheckStatus) {
            dispatch((0, $d623f23401a154f0$export$c594ad0cf83b2327)(certKey, prevBulkCheckStatus)).then(()=>{
                dispatch((0, $d623f23401a154f0$export$2af49e179df91659)(false));
                dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(!prevBulkCheckStatus));
            }).catch((error)=>{
                dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(true, error.message));
                dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(prevBulkCheckStatus));
            });
            return;
        }
        dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(!prevBulkCheckStatus));
        dispatch((0, $d623f23401a154f0$export$c594ad0cf83b2327)(certKey, prevBulkCheckStatus)).then(()=>{
            dispatch((0, $d623f23401a154f0$export$2af49e179df91659)(true));
        }).catch((error)=>{
            dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(true, error));
            dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(prevBulkCheckStatus));
        });
    };
    const resetSort = ()=>{
        dispatch((0, $d623f23401a154f0$export$683be6298bff3717)());
        dispatch((0, $d623f23401a154f0$export$fad033acbe739b9c)(certKey, columnNames, (0, $5630dd438c9b44f6$export$aeca2bf7951e0a69), (0, $5630dd438c9b44f6$export$3231e969238304f3)));
    };
    const handleDynamicSort = (selectedOption, sortDirection)=>{
        if (selectedOption) {
            const sortValue = sortDirection.find((ele)=>ele.isChecked);
            dispatch((0, $d623f23401a154f0$export$aa7b16fe4622cebe)(selectedOption.coulmnName, sortValue?.value || "asc"));
        }
    };
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
        tag: "section",
        className: headerClasses,
        dataTestId: "cert-controls-group",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$AlertBanner), {
                colorTheme: "Critical",
                title: bulkAction?.alert?.alertText || "",
                description: "",
                isColonVisible: false,
                shouldAutoDismiss: true,
                shouldAnimate: true,
                isVisible: bulkAction?.alert?.isAlert,
                onCancel: ()=>dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(false, ""))
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                tag: "div",
                className: "CertsControlsGroup-tabsAndControls",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $b8f7c55addb0e434$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                        tag: "div",
                        className: "CertsControlsGroup-controls",
                        children: [
                            isSaviEnabled && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "Savi-Companion-Button",
                                role: "button",
                                tabIndex: 0,
                                onKeyDown: ()=>setShowSaviCompanion(true),
                                onClick: ()=>setShowSaviCompanion(true),
                                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                    kind: "SaviCompanion",
                                    size: "medium"
                                })
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $941d0d32536ce9e0$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $96bbb2b8ad24fb0a$export$2e2bcd8739ae039), {
                                areControlsVisible: areControlsVisible,
                                rowFilters: rowFilters,
                                colFilters: colFilters,
                                handleSort: handleDynamicSort,
                                resetDynamicSort: resetSort
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $1c4893cc536d206e$export$2e2bcd8739ae039), {
                                filters: filters,
                                showFilterBar: showFilterBar,
                                setShowFilterBar: setShowFilterBar,
                                showBadgeOnFilterButton: showBadgeOnFilterButton
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $49b471e64a4eb65c$export$2e2bcd8739ae039), {
                                showRowFilter: showRowFilter,
                                setShowRowFilter: setShowRowFilter,
                                showbadgeOnRowButton: showbadgeOnRowButton,
                                setShowbadgeOnRowButton: setShowbadgeOnRowButton,
                                rowFilters: rowFilters,
                                setRowFilters: setRowFilters,
                                appliedRowFilters: appliedRowFilters,
                                setAppliedRowFilters: setAppliedRowFilters
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $1364363abc6281cb$export$2e2bcd8739ae039), {
                                showColFilter: showColFilter,
                                setShowColFilter: setShowColFilter,
                                showbadgeOnColButton: showbadgeOnColButton,
                                setShowbadgeOnColButton: setShowbadgeOnColButton,
                                colFilters: colFilters,
                                setColFilters: setColFilters,
                                appliedColFilters: appliedColFilters,
                                setAppliedColFilters: setAppliedColFilters
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                tag: "div",
                className: "CertsControlsGroup-advancedFilters",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $9080a8ca19badea3$export$2e2bcd8739ae039), {
                    setShowBadgeOnFilterButton: setShowBadgeOnFilterButton,
                    showFilterBar: showFilterBar,
                    areControlsVisible: areControlsVisible,
                    filters: filters,
                    setFilters: setFilters,
                    appliedFilters: appliedFilters,
                    setAppliedFilters: setAppliedFilters
                })
            }),
            isSelectAllVisable && /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                tag: "div",
                className: selectAllClasses,
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                        name: "simpleText",
                        kind: "simpleText",
                        dataTestId: "simpleText",
                        isChecked: bulkAction?.isChecked,
                        isDisabled: bulkAction?.isDisabled || bulkAction?.isSubmittingAction || isLoading,
                        isIndeterminate: bulkAction?.isIndeterminate,
                        onChange: handleBulkChange,
                        label: `Select All (${activeTab?.count})`,
                        textPosition: "after",
                        showHoverEffect: true
                    }),
                    bulkAction?.isSelecting && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                        kind: "loop",
                        format: "inline",
                        color: "brand",
                        size: "small"
                    })
                ]
            })
        ]
    });
}
$7166cd89a2c7c0dc$var$CertsControlsGroup.propTypes = {
    areControlsVisible: (0, $hopDi$proptypes).bool.isRequired,
    showFilterBar: (0, $hopDi$proptypes).bool.isRequired,
    setShowFilterBar: (0, $hopDi$proptypes).func.isRequired,
    setShowSaviCompanion: (0, $hopDi$proptypes).func.isRequired,
    isSaviEnabled: (0, $hopDi$proptypes).bool.isRequired
};
$7166cd89a2c7c0dc$var$CertsControlsGroup.defaultProps = {};
var $7166cd89a2c7c0dc$export$2e2bcd8739ae039 = $7166cd89a2c7c0dc$var$CertsControlsGroup;


var $2c4c83dadce0c268$export$2e2bcd8739ae039 = (0, $7166cd89a2c7c0dc$export$2e2bcd8739ae039);


/* eslint-disable object-curly-newline */ /* eslint-disable indent */ 










/* eslint-disable no-nested-ternary */ 




/* eslint-disable react/prop-types */ 



function $3102c9244ab5724c$var$ARSAccordian({ children: children }) {
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
        className: "ARSAccordian",
        children: children
    });
}
var $3102c9244ab5724c$export$2e2bcd8739ae039 = $3102c9244ab5724c$var$ARSAccordian;


var $2ba3f665d96bbbd7$export$2e2bcd8739ae039 = (0, $3102c9244ab5724c$export$2e2bcd8739ae039);








const $7bd7e40dc3e83f06$var$KINDS = {
    fill: "fill",
    outline: "outline",
    none: "none"
};
const $7bd7e40dc3e83f06$var$ICONS = {
    check: "check",
    reject: "reject"
};
function $7bd7e40dc3e83f06$var$ARSTimeLine1({ kind: kind, head: head, tail: tail, iconKind: iconKind }) {
    const iconClass = (0, $hopDi$classnames)("ARSTimeLine1-icon", head === $7bd7e40dc3e83f06$var$KINDS.fill ? "ARSTimeLine1-icon--fill" : "ARSTimeLine1-icon--outline", kind === "critical" && "ARSTimeLine1-icon--critical");
    const lineClass = (0, $hopDi$classnames)("ARSTimeLine1-line", tail === $7bd7e40dc3e83f06$var$KINDS.fill ? "ARSTimeLine1-line--fill" : "ARSTimeLine1-line--outline", tail === $7bd7e40dc3e83f06$var$KINDS.none && "ARSTimeLine1-line--none", kind === "critical" && "ARSTimeLine1-line--critical");
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "ARSTimeLine1",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: iconClass,
                children: head === $7bd7e40dc3e83f06$var$KINDS.fill && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: iconKind === $7bd7e40dc3e83f06$var$ICONS.reject ? "Reject" : "check",
                    color: "neutral-000",
                    size: "xxSmall"
                })
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: lineClass,
                children: tail === $7bd7e40dc3e83f06$var$KINDS.outline && [
                    ...Array(10).keys()
                ].map((key)=>/*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: `ARSTimeLine1-lineChild--outline ${kind === "critical" ? "ARSTimeLine1-lineChild--critical" : ""}`
                    }, key))
            })
        ]
    });
}
$7bd7e40dc3e83f06$var$ARSTimeLine1.propTypes = {
    kind: (0, $hopDi$proptypes).string,
    head: (0, $hopDi$proptypes).oneOf(Object.values($7bd7e40dc3e83f06$var$KINDS)),
    tail: (0, $hopDi$proptypes).oneOf(Object.values($7bd7e40dc3e83f06$var$KINDS)),
    iconKind: (0, $hopDi$proptypes).oneOf(Object.values($7bd7e40dc3e83f06$var$ICONS))
};
$7bd7e40dc3e83f06$var$ARSTimeLine1.defaultProps = {
    kind: "info",
    head: $7bd7e40dc3e83f06$var$KINDS.fill,
    tail: $7bd7e40dc3e83f06$var$KINDS.fill,
    iconKind: $7bd7e40dc3e83f06$var$ICONS.check
};
var $7bd7e40dc3e83f06$export$2e2bcd8739ae039 = $7bd7e40dc3e83f06$var$ARSTimeLine1;


var $e582458c460eb485$export$2e2bcd8739ae039 = (0, $7bd7e40dc3e83f06$export$2e2bcd8739ae039);







const $c83a8b4a6e7d5ed7$var$KINDS = {
    fill: "fill",
    outline: "outline",
    none: "none"
};
function $c83a8b4a6e7d5ed7$var$ARSTimeLine2({ kind: kind, head: head, tail: tail, isActive: isActive }) {
    const iconClass = (0, $hopDi$classnames)("ARSTimeLine2-icon", isActive && kind !== "critical" && "ARSTimeLine2-icon--active", head === $c83a8b4a6e7d5ed7$var$KINDS.fill ? "ARSTimeLine2-icon--fill" : "ARSTimeLine2-icon--outline", kind === "critical" && head === $c83a8b4a6e7d5ed7$var$KINDS.fill && "ARSTimeLine2-icon--critical");
    const lineClass = (0, $hopDi$classnames)("ARSTimeLine2-line", tail === $c83a8b4a6e7d5ed7$var$KINDS.fill ? "ARSTimeLine2-line--fill" : "ARSTimeLine2-line--outline", tail === $c83a8b4a6e7d5ed7$var$KINDS.none && "ARSTimeLine2-line--none", kind === "critical" && tail === $c83a8b4a6e7d5ed7$var$KINDS.fill && "ARSTimeLine2-line--critical");
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "ARSTimeLine2",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: iconClass
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: lineClass,
                children: tail === $c83a8b4a6e7d5ed7$var$KINDS.outline && [
                    ...Array(10).keys()
                ].map((key)=>/*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: `ARSTimeLine2-lineChild--outline ${kind === "critical" ? "ARSTimeLine2-lineChild--critical" : ""}`
                    }, key))
            })
        ]
    });
}
$c83a8b4a6e7d5ed7$var$ARSTimeLine2.propTypes = {
    kind: (0, $hopDi$proptypes).string,
    head: (0, $hopDi$proptypes).oneOf(Object.values($c83a8b4a6e7d5ed7$var$KINDS)),
    tail: (0, $hopDi$proptypes).oneOf(Object.values($c83a8b4a6e7d5ed7$var$KINDS)),
    isActive: (0, $hopDi$proptypes).bool
};
$c83a8b4a6e7d5ed7$var$ARSTimeLine2.defaultProps = {
    kind: "info",
    head: $c83a8b4a6e7d5ed7$var$KINDS.fill,
    tail: $c83a8b4a6e7d5ed7$var$KINDS.fill,
    isActive: false
};
var $c83a8b4a6e7d5ed7$export$2e2bcd8739ae039 = $c83a8b4a6e7d5ed7$var$ARSTimeLine2;


var $188ad2d2e99eecee$export$2e2bcd8739ae039 = (0, $c83a8b4a6e7d5ed7$export$2e2bcd8739ae039);


const $883fa4dd903b96ab$export$fd41194cca4d2bb5 = "certs_access_request_history_button_id";
const $883fa4dd903b96ab$export$d9266982e2bf3d17 = "ACCESSTHROUGH";
const $883fa4dd903b96ab$export$21b23db9600618c1 = "getRoleRequestHistory";
const $883fa4dd903b96ab$export$2e3672dd0afb4dec = "getAccountRequestHistory";
const $883fa4dd903b96ab$export$34655c42ce8db75a = "getEntitlementRequestHistory";
const $883fa4dd903b96ab$export$3f6c2199b3c5b3b8 = "Role";
const $883fa4dd903b96ab$export$7e10a96f60b56a22 = "Account";
const $883fa4dd903b96ab$export$b7454c9538e36d35 = "Entitlement";
const $883fa4dd903b96ab$export$8c93dbb2d9701e4f = {
    USER: "-4",
    ROLE: "-2",
    ACCOUNT: "0",
    ENTITLEMENT: 1
};
const $883fa4dd903b96ab$export$cee3e3cda81aad2c = {
    accordian: false,
    sections: [
        {
            key: "arsRequestSectionLabelKey",
            value: "arsRequestSectionLabelValue",
            map: "arsRequestMap",
            state: "fill"
        }
    ]
};
const $883fa4dd903b96ab$export$75a9ca8f615b4303 = {
    accordian: true,
    sections: [
        {
            key: "accessApproverSectionLabelKey",
            value: "accessApproverSectionLabelValue",
            header: [
                "reviewMethod"
            ],
            subSections: [
                {
                    key: "accessApproversSectionLabelKey",
                    value: "accessApproversSectionLabelValue",
                    map: "accessApprovers"
                }
            ],
            state: "fill"
        }
    ]
};
const $883fa4dd903b96ab$export$5791b00ae7c7ea93 = {
    accordian: true,
    sections: [
        {
            key: "arsTaskSectionLabelKey",
            value: "arsTaskSectionLabeValue",
            map: "arsTaskList",
            subtitle: "arsTaskLabel",
            headers: [
                "taskId",
                "parentTaskId",
                "taskCreateDate",
                "taskUpdateDate",
                "taskOwner"
            ],
            state: "fill"
        }
    ]
};


function $83ece9e91695c16b$var$AccessRequestHistoryBody({ isError: isError, isLoading: isLoading, data: data, closeAccessRequestHistoryModal: closeAccessRequestHistoryModal, reTriggerAccessRequestHistoryModal: reTriggerAccessRequestHistoryModal }) {
    const { messages: messages } = (0, $hopDi$useSelector)((state)=>state?.user);
    const hasDataAvailable = Boolean(data?.requestHistoryFound && !isLoading);
    const firstTile = hasDataAvailable && (0, $883fa4dd903b96ab$export$cee3e3cda81aad2c).sections.find((section)=>Object.prototype.hasOwnProperty.call(data, section.key));
    const secondTile = hasDataAvailable && (0, $883fa4dd903b96ab$export$75a9ca8f615b4303).sections.find((section)=>Object.prototype.hasOwnProperty.call(data, section.key));
    const thirdTile = hasDataAvailable && (0, $883fa4dd903b96ab$export$5791b00ae7c7ea93).sections.find((section)=>Object.prototype.hasOwnProperty.call(data, section.key));
    const renderFirstTile = ()=>{
        if (!firstTile) return null;
        const shouldShowtail = Boolean(secondTile);
        const { key: sectionKey, value: sectionValue, map: sectionMap, state: state } = firstTile;
        const mapperObj = Object.keys(data?.[sectionMap]);
        const shouldShowMapper = Boolean(mapperObj?.length > 0);
        return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $2ba3f665d96bbbd7$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $e582458c460eb485$export$2e2bcd8739ae039), {
                    tail: shouldShowtail ? state : "none"
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    tag: "div",
                    className: "AccessRequestHistoryBody-accordianBox",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "h3",
                            className: "AccessRequestHistoryBody-accordianBoxTitle",
                            children: messages?.[data?.[sectionKey]] || data?.[sectionValue] || ""
                        }),
                        shouldShowMapper && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                            tag: "div",
                            className: "AccessRequestHistoryBody-accordianBoxBody",
                            children: mapperObj?.map((key)=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                                    tag: "div",
                                    className: "AccessRequestHistoryBody-accordianBoxBodyTile",
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body3",
                                            children: key
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body2",
                                            className: "AccessRequestHistoryBody-accordianBoxBodyHighlighted",
                                            children: data?.[sectionMap][key]
                                        })
                                    ]
                                }, key))
                        })
                    ]
                })
            ]
        }, sectionKey);
    };
    const renderSecondTile = ()=>{
        if (!secondTile) return null;
        const shouldShowtail = Boolean(thirdTile);
        const { key: sectionKey, value: sectionValue, state: state } = secondTile;
        const redTextClass = sectionKey.toLowerCase().includes("reject");
        return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $2ba3f665d96bbbd7$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $e582458c460eb485$export$2e2bcd8739ae039), {
                    tail: shouldShowtail ? state : "none",
                    iconKind: redTextClass ? "reject" : "check"
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    tag: "div",
                    className: "AccessRequestHistoryBody-accordianBox",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "h3",
                            className: `AccessRequestHistoryBody-accordianBoxTitle ${redTextClass ? "redtext" : ""}`,
                            children: messages?.[data?.[sectionKey]] || data?.[sectionValue] || ""
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                            tag: "div",
                            className: "AccessRequestHistoryBody-accordianBoxBody",
                            children: secondTile.header.map((key)=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                                    tag: "div",
                                    className: "AccessRequestHistoryBody-accordianBoxBodyTile",
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body3",
                                            children: key
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body2",
                                            className: "AccessRequestHistoryBody-accordianBoxBodyHighlighted",
                                            children: data?.[key]
                                        })
                                    ]
                                }, key))
                        })
                    ]
                })
            ]
        }, sectionKey);
    };
    const renderThirdTile = ()=>{
        if (!thirdTile) return null;
        const shouldShowtail = false;
        const { key: sectionKey, value: sectionValue, map: sectionMap, headers: sectionHeaders, subtitle: sectionSubtitle, state: state } = thirdTile;
        const redTextClass = sectionKey.toLowerCase().includes("reject");
        const mapperObj = data?.[sectionMap];
        const shouldShowMapper = Boolean(mapperObj?.length > 0);
        return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $2ba3f665d96bbbd7$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $e582458c460eb485$export$2e2bcd8739ae039), {
                    tail: shouldShowtail ? state : "none",
                    iconKind: redTextClass ? "reject" : "check"
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    tag: "div",
                    className: "AccessRequestHistoryBody-accordianBox",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "h3",
                            className: `AccessRequestHistoryBody-accordianBoxTitle ${redTextClass ? "redtext" : ""}`,
                            children: messages?.[data?.[sectionKey]] || data?.[sectionValue] || ""
                        }),
                        shouldShowMapper && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                            tag: "div",
                            className: "AccessRequestHistoryBody-accordianBoxBody--thirdTile",
                            children: mapperObj?.map((item, index)=>{
                                const totalTileCount = mapperObj.length;
                                const isLastTile = totalTileCount - 1 === index;
                                const hasReject = item?.taskLabel.toLowerCase().includes("reject");
                                const hasPending = item?.taskLabel.toLowerCase().includes("pending");
                                const hasReview = item?.taskLabel.toLowerCase().includes("review");
                                const hasProgress = item?.taskLabel.toLowerCase().includes("progress");
                                let nextHasPending;
                                if (index + 1 < totalTileCount) nextHasPending = mapperObj[index + 1]?.taskLabel.toLowerCase().includes("pending");
                                return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                                    tag: "div",
                                    className: "AccessRequestHistoryBody-accordianBoxBodyWrapper--thirdTile",
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $188ad2d2e99eecee$export$2e2bcd8739ae039), {
                                            kind: hasReject ? "critical" : "info",
                                            head: hasPending ? "outilne" : "fill",
                                            tail: isLastTile ? "none" : nextHasPending ? "outline" : "fill",
                                            isActive: hasReview || hasProgress
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                                            tag: "div",
                                            children: [
                                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                                    kind: "h3",
                                                    children: `${item?.[sectionSubtitle]}`
                                                }),
                                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                                                    tag: "div",
                                                    className: "AccessRequestHistoryBody-accordianBoxBodyTile--thirdTile",
                                                    children: Object.keys(item).filter((key)=>sectionHeaders.includes(key)).map((key)=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$react).Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0, $hopDi$jsxs)("span", {
                                                                    className: "AccessRequestHistoryModalSubTitle-textBoxKey",
                                                                    children: [
                                                                        `${key}:`,
                                                                        "\xa0"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                                                                    className: "AccessRequestHistoryModalSubTitle-textBoxValue",
                                                                    children: item[key]
                                                                }),
                                                                /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                                                                    className: "AccessRequestHistoryModalSubTitle-textBoxTerminate"
                                                                })
                                                            ]
                                                        }, `${item.taskId}-${key}`))
                                                })
                                            ]
                                        })
                                    ]
                                }, item.taskId);
                            })
                        })
                    ]
                })
            ]
        }, sectionKey);
    };
    const renderArsModalBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            className: "AccessRequestHistoryBody-wrapper",
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                kind: "dots",
                format: "inline",
                color: "brand",
                size: "large",
                className: "AccessRequestHistoryBody-loader"
            })
        });
        if (isError) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            className: "AccessRequestHistoryBody-wrapper",
            children: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "ReviewAndSubmitModal-bodyError",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "h2",
                        children: "Couldn't Load"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body2",
                        children: "The History didn't load properly due to a network issue. Please refresh or try again later."
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "ReviewAndSubmitModal-bodyErrorButtons",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                                type: "button",
                                kind: "filled",
                                onClick: reTriggerAccessRequestHistoryModal,
                                size: "medium",
                                children: "Refresh"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                                type: "button",
                                kind: "ghost",
                                size: "medium",
                                onClick: closeAccessRequestHistoryModal,
                                children: "Close"
                            })
                        ]
                    })
                ]
            })
        });
        if (hasDataAvailable) return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
            tag: "div",
            className: "AccessRequestHistoryBody-wrapper",
            children: [
                renderFirstTile(),
                renderSecondTile(),
                renderThirdTile()
            ]
        });
        return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            tag: "div",
            className: "AccessRequestHistoryBody-wrapper",
            children: /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                className: "AccessRequestHistoryBody-NoDataAvailable",
                children: "No actions or comments have been recorded for this certification yet."
            })
        });
    };
    return renderArsModalBody();
}
$83ece9e91695c16b$var$AccessRequestHistoryBody.propTypes = {
    isError: (0, $hopDi$proptypes).bool.isRequired,
    isLoading: (0, $hopDi$proptypes).bool.isRequired,
    data: (0, $hopDi$proptypes).shape({
        requestHistoryFound: (0, $hopDi$proptypes).bool
    }),
    closeAccessRequestHistoryModal: (0, $hopDi$proptypes).func.isRequired,
    reTriggerAccessRequestHistoryModal: (0, $hopDi$proptypes).func.isRequired
};
$83ece9e91695c16b$var$AccessRequestHistoryBody.defaultProps = {
    data: null
};
var $83ece9e91695c16b$export$2e2bcd8739ae039 = $83ece9e91695c16b$var$AccessRequestHistoryBody;


/* eslint-disable jsx-a11y/anchor-is-valid */ 





function $ea42dd75a8569c98$var$AccessRequestHistorySubTitle({ isError: isError, isLoading: isLoading, data: data }) {
    const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
    const hasContentForSubtitles = Boolean(Object?.keys(data)?.length > 0 && !isError);
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
        tag: "div",
        className: "AccessRequestHistoryModalSubTitle",
        children: [
            isLoading && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                kind: "dots",
                format: "inline",
                color: "brand",
                size: "small"
            }),
            !isLoading && hasContentForSubtitles && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "AccessRequestHistoryModalSubTitle-text",
                children: Object.keys(data)?.map((key)=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$react).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsxs)("span", {
                                className: "AccessRequestHistoryModalSubTitle-textBoxKey",
                                children: [
                                    `${key}:`,
                                    "\xa0"
                                ]
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                                className: "AccessRequestHistoryModalSubTitle-textBoxValue",
                                children: data[key]
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                                className: "AccessRequestHistoryModalSubTitle-textBoxTerminate"
                            })
                        ]
                    }, key))
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Link), {
                url: `${ECM_URL}/jbpmworkflowmanagement/showmyhistoryrequests`,
                text: "View Request History",
                color: "brand",
                size: "large",
                suffixIconKind: "Jump"
            })
        ]
    });
}
$ea42dd75a8569c98$var$AccessRequestHistorySubTitle.propTypes = {
    isError: (0, $hopDi$proptypes).bool.isRequired,
    isLoading: (0, $hopDi$proptypes).bool.isRequired,
    data: (0, $hopDi$proptypes).shape({})
};
$ea42dd75a8569c98$var$AccessRequestHistorySubTitle.defaultProps = {
    data: null
};
var $ea42dd75a8569c98$export$2e2bcd8739ae039 = $ea42dd75a8569c98$var$AccessRequestHistorySubTitle;




const $9824ba98b0b6cbde$export$32f471889249712e = (nodeData)=>{
    const certsKeyValue = nodeData?.CERT_ENTITLEMENT_VALUEKEY;
    if (certsKeyValue === (0, $883fa4dd903b96ab$export$8c93dbb2d9701e4f).ROLE) return 0, $883fa4dd903b96ab$export$3f6c2199b3c5b3b8;
    if (certsKeyValue === (0, $883fa4dd903b96ab$export$8c93dbb2d9701e4f).ACCOUNT) return 0, $883fa4dd903b96ab$export$7e10a96f60b56a22;
    return 0, $883fa4dd903b96ab$export$b7454c9538e36d35;
};
var $9824ba98b0b6cbde$export$2e2bcd8739ae039 = $9824ba98b0b6cbde$export$32f471889249712e;



function $0b9d8820b93e64c2$var$AccessRequestHistory() {
    const dispatch = (0, $hopDi$useDispatch)();
    const { certKey: certKey, accessRequestHistory: accessRequestHistory } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const { messages: messages } = (0, $hopDi$useSelector)((state)=>state?.user);
    const [isError, setIsError] = (0, $hopDi$useState)(false);
    const [isLoading, setIsLoading] = (0, $hopDi$useState)(false);
    const modalTitle = messages?.[accessRequestHistory?.arsData?.requestAccessHistoryHeaderLabelKey] || accessRequestHistory?.arsData?.requestAccessHistoryHeaderLabelValue || "Access Request History";
    (0, $hopDi$useEffect)(()=>{
        setIsLoading(accessRequestHistory.isLoading);
    }, [
        accessRequestHistory.isLoading
    ]);
    (0, $hopDi$useEffect)(()=>{
        setIsError(accessRequestHistory.isError);
    }, [
        accessRequestHistory.isError
    ]);
    const callApiForArs = ()=>{
        const arsKind = (0, $9824ba98b0b6cbde$export$32f471889249712e)(accessRequestHistory?.arsTaskKeys);
        if (arsKind === (0, $883fa4dd903b96ab$export$3f6c2199b3c5b3b8)) {
            const payload = {
                cert_rolekey: accessRequestHistory?.arsTaskKeys?.CERT_ROLEKEY,
                cert_userkey: accessRequestHistory?.arsTaskKeys?.CERT_USERKEY
            };
            dispatch((0, $d623f23401a154f0$export$c45c025fc9b885f7)(certKey, (0, $883fa4dd903b96ab$export$21b23db9600618c1), payload));
        }
        if (arsKind === (0, $883fa4dd903b96ab$export$7e10a96f60b56a22)) {
            const payload = {
                cert_accountkey: accessRequestHistory?.arsTaskKeys?.CERT_ACCOUNTKEY,
                cert_userkey: accessRequestHistory?.arsTaskKeys?.CERT_USERKEY
            };
            dispatch((0, $d623f23401a154f0$export$c45c025fc9b885f7)(certKey, (0, $883fa4dd903b96ab$export$2e3672dd0afb4dec), payload));
        }
        if (arsKind === (0, $883fa4dd903b96ab$export$b7454c9538e36d35)) {
            const payload = {
                arstaskkey: accessRequestHistory?.arsTaskKeys?.CERT_ENTITLEMENT_VALUEKEY
            };
            dispatch((0, $d623f23401a154f0$export$c45c025fc9b885f7)(certKey, (0, $883fa4dd903b96ab$export$34655c42ce8db75a), payload));
        }
    };
    (0, $hopDi$useEffect)(()=>{
        if (accessRequestHistory?.isOpen && accessRequestHistory?.isLoading) callApiForArs();
    }, [
        accessRequestHistory.isOpen,
        accessRequestHistory?.isLoading
    ]);
    const closeAccessRequestHistoryModal = ()=>{
        dispatch((0, $d623f23401a154f0$export$6905b0d830e88406)(false, null));
    };
    const reTriggerAccessRequestHistoryModal = ()=>{
        dispatch((0, $d623f23401a154f0$export$fee47e6aac44de0e)(true));
    };
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
        className: "AccessRequestHistoryModal",
        onClose: closeAccessRequestHistoryModal,
        isOpen: accessRequestHistory?.isOpen,
        title: modalTitle,
        subtitle: /*#__PURE__*/ (0, $hopDi$jsx)((0, $ea42dd75a8569c98$export$2e2bcd8739ae039), {
            isError: isError,
            isLoading: isLoading,
            data: accessRequestHistory?.arsData?.requestAccessAttributeMap || {}
        }),
        contentBody: /*#__PURE__*/ (0, $hopDi$jsx)((0, $83ece9e91695c16b$export$2e2bcd8739ae039), {
            isError: isError,
            isLoading: isLoading,
            data: accessRequestHistory?.arsData,
            closeAccessRequestHistoryModal: closeAccessRequestHistoryModal,
            reTriggerAccessRequestHistoryModal: reTriggerAccessRequestHistoryModal
        })
    });
}
var $0b9d8820b93e64c2$export$2e2bcd8739ae039 = $0b9d8820b93e64c2$var$AccessRequestHistory;







function $6be8371a7cd99dfd$var$AccessRequestHistoryButton() {
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
        tag: "div",
        id: (0, $883fa4dd903b96ab$export$fd41194cca4d2bb5),
        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
            kind: "body2-bold",
            className: "AccessRequestHistoryBtn",
            children: "Access Request"
        })
    });
}
var $6be8371a7cd99dfd$export$2e2bcd8739ae039 = $6be8371a7cd99dfd$var$AccessRequestHistoryButton;



var $2b016bbacf604946$export$2e2bcd8739ae039 = (0, $0b9d8820b93e64c2$export$2e2bcd8739ae039);


/* eslint-disable no-unused-vars */ /* eslint-disable indent */ /* eslint-disable react/jsx-wrap-multilines */ /* eslint-disable react/jsx-curly-spacing */ /* eslint-disable react/jsx-no-useless-fragment */ /* eslint-disable react/jsx-curly-spacing */ /* eslint-disable no-unused-vars */ /* eslint-disable no-nested-ternary */ 







const $ddbc2f861c0388ff$export$3e7926703ac20a93 = {
    ACCESSTHROUGH: (0, $hopDi$proptypes).string,
    AUDIT_TRAIL: (0, $hopDi$proptypes).string,
    CERTIFIED: (0, $hopDi$proptypes).oneOfType([
        (0, $hopDi$proptypes).number,
        (0, $hopDi$proptypes).string
    ]),
    CERT_ACCOUNTKEY: (0, $hopDi$proptypes).string,
    CERT_ENTITLEMENT_VALUEKEY: (0, $hopDi$proptypes).string,
    CERT_ROLEKEY: (0, $hopDi$proptypes).string,
    CERT_USERKEY: (0, $hopDi$proptypes).string,
    COMMENTS: (0, $hopDi$proptypes).string,
    ENDPOINT: (0, $hopDi$proptypes).string,
    ENTITLEMENTTYPE: (0, $hopDi$proptypes).string,
    ENTITLEMENT_VALUE: (0, $hopDi$proptypes).string,
    Ent_DESCRIPTION: (0, $hopDi$proptypes).string,
    Ent_DISPLAYNAME: (0, $hopDi$proptypes).string,
    Ent_ENTITLEMENT_GLOSSARY: (0, $hopDi$proptypes).string,
    Ent_PRIVILIGED: (0, $hopDi$proptypes).string,
    LASTCERTIFIED: (0, $hopDi$proptypes).string,
    LASTCERTIFIEDCAMPAIGNNAME: (0, $hopDi$proptypes).string,
    LASTCERTIFIEDUSER: (0, $hopDi$proptypes).oneOfType([
        (0, $hopDi$proptypes).number,
        (0, $hopDi$proptypes).string
    ]),
    availableAction: (0, $hopDi$proptypes).shape({
        approve: (0, $hopDi$proptypes).string,
        conditionalCertifiy: (0, $hopDi$proptypes).string,
        consult: (0, $hopDi$proptypes).string,
        reassign: (0, $hopDi$proptypes).string,
        reject: (0, $hopDi$proptypes).string
    }),
    enableAction: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string),
    id: (0, $hopDi$proptypes).string,
    isConsulted: (0, $hopDi$proptypes).bool,
    tracker: (0, $hopDi$proptypes).shape({
        actions: (0, $hopDi$proptypes).objectOf((0, $hopDi$proptypes).shape({
            isSelected: (0, $hopDi$proptypes).bool,
            isLoading: (0, $hopDi$proptypes).bool
        })),
        id: (0, $hopDi$proptypes).string,
        isChecked: (0, $hopDi$proptypes).bool,
        isConnected: (0, $hopDi$proptypes).bool,
        level: (0, $hopDi$proptypes).number
    })
};
const $ddbc2f861c0388ff$export$f9baae1e9d6bf8f = {
    certKey: (0, $hopDi$proptypes).string,
    userKey: (0, $hopDi$proptypes).string,
    status: (0, $hopDi$proptypes).string
};
const $ddbc2f861c0388ff$export$79819249befb86e5 = {
    defaultReassignee: (0, $hopDi$proptypes).string,
    defaultReassigneeName: (0, $hopDi$proptypes).string,
    enableIndividualCommentsForAccountEntitlementRoles: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string),
    enableIndividualCommentsForUsers: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string),
    enableReassignStep2: (0, $hopDi$proptypes).string,
    enableReassignUser: (0, $hopDi$proptypes).string,
    showReassignPopup: (0, $hopDi$proptypes).string
};







const $bae22e791544392c$export$63eb49a941fbc2c6 = 2;
const $bae22e791544392c$export$dbb53ef7e43d7f45 = 10; // To provide buffer boxes if we have less number of keys available
const $bae22e791544392c$export$6b1c20b2e2de9059 = {
    USER: (0, $a23cd229b9113926$export$c2fd574cc3b8c823),
    ROLE: (0, $a23cd229b9113926$export$c97501b522a7bf89),
    ACCOUNT: (0, $a23cd229b9113926$export$eeb9092565ce426a),
    ENTITLEMENT: (0, $a23cd229b9113926$export$7d1f9b2b2a057886)
};
const $bae22e791544392c$export$994f7af6d0b36256 = {
    USER: "-4",
    ROLE: "-2",
    ACCOUNT: "0",
    ENTITLEMENT: 1
};
const $bae22e791544392c$export$237a15c17615452d = {
    LEVEL_0: {
        NO_CONTROLS: 64,
        CONTROLS_VISIBLE: 164,
        SIDEPANEL_ADVANCED_CONTROLS: 204
    },
    LEVEL_1: {
        NO_CONTROLS: 128,
        CONTROLS_VISIBLE: 228,
        SIDEPANEL_ADVANCED_CONTROLS: 268
    },
    LEVEL_2: {
        NO_CONTROLS: 192,
        CONTROLS_VISIBLE: 292,
        SIDEPANEL_ADVANCED_CONTROLS: 332
    }
};



/* eslint-disable react/prop-types */ /* eslint-disable no-use-before-define */ /* eslint-disable react/jsx-no-useless-fragment */ /* eslint-disable react/jsx-curly-spacing */ /* eslint-disable no-unused-vars */ 





var $5a97dceba7e1a33b$exports = {};
$5a97dceba7e1a33b$exports = JSON.parse('{"v":"5.10.2","fr":60,"ip":0,"op":137,"w":56,"h":56,"nm":"Loop-Inline","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Load-Ellipse_Blue 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[1]},{"t":136,"s":[361]}],"ix":10},"p":{"a":0,"k":[28,28,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[50,50],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.4],"y":[1]},"o":{"x":[0.24],"y":[0]},"t":76,"s":[1]},{"t":136,"s":[99]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.76],"y":[1]},"o":{"x":[0.6],"y":[0]},"t":0,"s":[0]},{"t":60,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.145098045468,0.29411765933,0.525490224361,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0}],"markers":[]}');




/* eslint-disable import/prefer-default-export */ const $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0 = {
    USER: "User",
    ACCOUNT: "Account",
    ROLE: "Role",
    ENTITLEMENT: "Entitlement"
};


/* eslint-disable react/jsx-curly-spacing */ /* eslint-disable react/jsx-wrap-multilines */ 



/* eslint-disable react/jsx-curly-spacing */ 




const $0d23168c4a68b98d$var$CHIP_DATA_MODEL = (0, $hopDi$proptypes).shape({
    id: (0, $hopDi$proptypes).number.isRequired,
    label: (0, $hopDi$proptypes).string.isRequired,
    isSelected: (0, $hopDi$proptypes).bool.isRequired
});
function $0d23168c4a68b98d$var$CertsCommentInputField({ chipData: chipData, setChipData: setChipData, inputChanged: // initialChipData,
inputChanged, setInputChanged: setInputChanged, isCritical: isCritical, setIsCritical: setIsCritical, commentValue: commentValue, setCommentValue: setCommentValue }) {
    (0, $hopDi$useEffect)(()=>{
        const hasAngleBrackets = /<|>/.test(commentValue);
        if (hasAngleBrackets) setIsCritical(true);
        if (inputChanged) {
            setChipData(chipData.map((chip)=>({
                    ...chip,
                    isSelected: false
                })));
            setInputChanged(false);
        }
    }, [
        commentValue
    ]);
    const isCommentNotValid = Boolean(isCritical || commentValue?.replace(/[<>]/g, "")?.trim()?.length < 3);
    //! Do not delete this is good code to be used after beta
    // const handleChipSelection = (selectedChip) => {
    //   if (selectedChip.isSelected) {
    //     setChipData(initialChipData);
    //     setCommentValue('');
    //   } else {
    //     setChipData(
    //       chipData.map((chip) => ({
    //         ...chip,
    //         isSelected: chip.id === selectedChip.id,
    //       }))
    //     );
    //     setCommentValue(selectedChip.label);
    //     setInputChanged(false);
    //   }
    // };
    const handleInputChange = (e)=>{
        setCommentValue(e.target.value);
        setInputChanged(true);
    };
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
        tag: "div",
        className: "CertsCommentInputField-commentSection",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                tag: "div",
                className: "CertsCommentInputField-label",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                        tag: "div",
                        className: "CertsCommentInputField-Asterisk--isRequired",
                        children: isCommentNotValid && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                            tag: "div",
                            className: `CertsCommentInputField-Asterisk--${isCritical ? "isCritical" : "isWarning"}`,
                            children: "*"
                        })
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "label",
                        htmlFor: "CertsCommentInputFieldMultiline",
                        children: "Comments"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                tag: "div",
                className: "CertsCommentInputField-inputField",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InputField), {
                    name: "CertsCommentInputFieldMultiline",
                    kind: "multiline",
                    placeholder: "Provide a reason for your decision",
                    value: commentValue,
                    setValue: setCommentValue,
                    onChange: handleInputChange,
                    isCritical: isCritical,
                    setIsCritical: setIsCritical,
                    textAreaMaxHeight: "20rem",
                    CriticalHelperText: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InlineMessage), {
                        kind: "missingRequiredField",
                        size: "small"
                    })
                })
            })
        ]
    });
}
$0d23168c4a68b98d$var$CertsCommentInputField.propTypes = {
    chipData: (0, $hopDi$proptypes).arrayOf($0d23168c4a68b98d$var$CHIP_DATA_MODEL).isRequired,
    setChipData: (0, $hopDi$proptypes).func.isRequired,
    // initialChipData: PropTypes.arrayOf(CHIP_DATA_MODEL).isRequired,
    inputChanged: (0, $hopDi$proptypes).bool.isRequired,
    setInputChanged: (0, $hopDi$proptypes).func.isRequired,
    isCritical: (0, $hopDi$proptypes).bool.isRequired,
    setIsCritical: (0, $hopDi$proptypes).func.isRequired,
    commentValue: (0, $hopDi$proptypes).string.isRequired,
    setCommentValue: (0, $hopDi$proptypes).func.isRequired
};
$0d23168c4a68b98d$var$CertsCommentInputField.defaultProps = {};
var $0d23168c4a68b98d$export$2e2bcd8739ae039 = $0d23168c4a68b98d$var$CertsCommentInputField;


const $20281fe09bc700a8$export$994f7af6d0b36256 = {
    USER: "-4",
    ROLE: "-2",
    ACCOUNT: "0",
    ENTITLEMENT: 1
};
const $20281fe09bc700a8$export$758743ec42a300f1 = {
    TILE: "detailsTile",
    FOOTER: "sidePanelFooter"
};
const $20281fe09bc700a8$export$3f43cf8434698562 = {
    APPROVE: "approve",
    REJECT: "reject",
    TERMINATE: "terminated",
    REASSIGN: "reassign",
    CONSULT: "consult",
    WORKS_FOR_ME: "worksForMe",
    DOES_NOT_WORK_FOR_ME: "doesNotWorksForMe",
    EXTEND_END_DATE: "extendEndDate",
    CONDITIONAL_CERTIFIY: "conditionalCertifiy"
};
const $20281fe09bc700a8$export$506bde9fe967e89b = {
    CHECK: "Check",
    EXTEND_END_DATE: "ExtendEndDate",
    CONSULT: "Consult",
    APPROVE: "approve",
    REJECT: "reject",
    TERMINATE: "terminate",
    REASSIGN_USER: "reassignUser",
    REASSIGN_ITEM: "reassignItem",
    CONFIRM_MANAGER: "confirmManager",
    CHANGE_END_DATE: "changeEndDate",
    CONSULT_WITH_PEERS: "consultWithPeers"
};
const $20281fe09bc700a8$export$6bf521f24032eb49 = {
    NO_ACTION: -1,
    RESET: 0,
    WORKS_FOR_ME: 2,
    APPROVE: 2,
    REVOKED: 3,
    TERMINATED: 4,
    CONDITIONAL_CERTIFIY: 5,
    EXTEND_END_DATE: 6
};
const $20281fe09bc700a8$export$523985e6ca7aa3bf = {
    TITLE: "Terminate User and Access?",
    DESC: "Do you want to terminate this user and revoke all their access? Termination won\u2019t be fulfilled right away. It\u2019ll take effect after you finish your review and submit.",
    NOTE: "If you don\u2019t submit by the due date, termination will occur automatically at that time.",
    PLACEHOLDER: "Provide a reason for your decision",
    PRIMARYBUTTON: "Terminate",
    SECONDARYBUTTON: "Cancel"
};
const $20281fe09bc700a8$export$170ce1a49c989948 = {
    TITLE: "Reject this ",
    DESC: "Access won\u2018t be removed right away. It\u2019ll take effect after you finish your review and submit.",
    NOTE: "If you don\u2019t submit by the due date, access will be removed automatically at that time.",
    PRIMARYBUTTON: "Reject",
    SECONDARYBUTTON: "Got it",
    CANCELBUTTON: "Cancel",
    COMMENTS_CHIPS: []
};
const $20281fe09bc700a8$export$80dc2c0ddeaedcb2 = {
    DOES_NOT_WORK_FOR_ME: "DOES NOT WORK FOR ME",
    WORKS_FOR_ME: "WORKS FOR ME",
    NORESPONSE: "NORESPONSE",
    TERMINATED: "TERMINATED",
    REASSIGN: "RE-ASSIGN",
    EXTEND_END_DATE: "EXTEND_END_DATE"
};
const $20281fe09bc700a8$export$69894cdd9841cdfb = {
    APPROVE: "YES",
    REJECT: "NO",
    NORESPONSE: "NORESPONSE",
    REASSIGN: "RE-ASSIGN",
    REASSIGNSTEP2: "REASSIGNSTEP2"
};


/* eslint-disable import/prefer-default-export */ 
const $3cd234bd4f1cf26a$export$3edeae7c90cf2ca0 = (actionKind)=>{
    switch(actionKind){
        case (0, $20281fe09bc700a8$export$3f43cf8434698562).APPROVE:
            return "Approve";
        case (0, $20281fe09bc700a8$export$3f43cf8434698562).REJECT:
            return "Reject";
        case (0, $20281fe09bc700a8$export$3f43cf8434698562).TERMINATE:
            return "Terminated";
        case (0, $20281fe09bc700a8$export$3f43cf8434698562).REASSIGN:
            return "Reassign";
        case (0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT:
            return "Consult";
        case (0, $20281fe09bc700a8$export$3f43cf8434698562).WORKS_FOR_ME:
            return "Confirm Manager";
        case (0, $20281fe09bc700a8$export$3f43cf8434698562).DOES_NOT_WORK_FOR_ME:
            return "Reassign";
        case (0, $20281fe09bc700a8$export$3f43cf8434698562).EXTEND_END_DATE:
            return "Extend End Date";
        case (0, $20281fe09bc700a8$export$3f43cf8434698562).CONDITIONAL_CERTIFIY:
            return "Certify Conditionally";
        default:
            return "Unformatted Action";
    }
};



const $8c613cbc0666ae78$var$initialChipData = [
    {
        id: 1,
        label: "Lorem ipsum",
        isSelected: false
    },
    {
        id: 2,
        label: "Lorem ipsum",
        isSelected: false
    }
];
function $8c613cbc0666ae78$var$CertsActionPopover({ actionKind: actionKind, isCommentPopoverOpen: isCommentPopoverOpen, setIsCommentPopoverOpen: setIsCommentPopoverOpen, placement: placement, trigger: trigger, onSubmit: onSubmit }) {
    const [isCritical, setIsCritical] = (0, $hopDi$useState)(false);
    const [commentValue, setCommentValue] = (0, $hopDi$useState)("");
    const [inputChanged, setInputChanged] = (0, $hopDi$useState)(false);
    const [chipData, setChipData] = (0, $hopDi$useState)($8c613cbc0666ae78$var$initialChipData);
    // Reset on close
    (0, $hopDi$useEffect)(()=>{
        if (!isCommentPopoverOpen) {
            setIsCritical(false);
            setCommentValue("");
            setInputChanged(false);
            setChipData($8c613cbc0666ae78$var$initialChipData);
        }
    }, [
        isCommentPopoverOpen
    ]);
    const isCommentNotValid = Boolean(isCritical || commentValue?.replace(/[<>]/g, "")?.trim()?.length < 3);
    const handleCommentSubmit = ()=>{
        if (isCommentNotValid) return setIsCritical(true);
        setIsCommentPopoverOpen(false);
        return onSubmit(commentValue);
    };
    const getPopoverContent = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
            className: "CertsActionPopover",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $0d23168c4a68b98d$export$2e2bcd8739ae039), {
                    chipData: chipData,
                    setChipData: setChipData,
                    initialChipData: $8c613cbc0666ae78$var$initialChipData,
                    inputChanged: inputChanged,
                    setInputChanged: setInputChanged,
                    isCritical: isCritical,
                    setIsCritical: setIsCritical,
                    commentValue: commentValue,
                    setCommentValue: setCommentValue
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    tag: "div",
                    className: "CertsActionPopover-controls",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: "ghost",
                            onClick: ()=>setIsCommentPopoverOpen(false),
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: !isCommentNotValid ? "filled" : "outlined",
                            onClick: handleCommentSubmit,
                            children: (0, $3cd234bd4f1cf26a$export$3edeae7c90cf2ca0)(actionKind)
                        })
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
        tag: "div",
        className: "CertsActionPopover-contextWrapper",
        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Popover), {
            placement: placement,
            trigger: trigger,
            popoverContent: getPopoverContent(),
            isOpen: isCommentPopoverOpen,
            setIsOpen: setIsCommentPopoverOpen
        })
    });
}
$8c613cbc0666ae78$var$CertsActionPopover.defaultProps = {
    actionKind: null
};
$8c613cbc0666ae78$var$CertsActionPopover.propTypes = {
    actionKind: (0, $hopDi$proptypes).oneOf(Object.values((0, $20281fe09bc700a8$export$3f43cf8434698562))),
    isCommentPopoverOpen: (0, $hopDi$proptypes).bool.isRequired,
    setIsCommentPopoverOpen: (0, $hopDi$proptypes).func.isRequired,
    placement: (0, $hopDi$proptypes).string.isRequired,
    trigger: (0, $hopDi$proptypes).element.isRequired,
    onSubmit: (0, $hopDi$proptypes).func.isRequired
};
var $8c613cbc0666ae78$export$2e2bcd8739ae039 = $8c613cbc0666ae78$var$CertsActionPopover;


/* eslint-disable no-unused-vars */ /* eslint-disable react/jsx-curly-spacing */ /* eslint-disable react/jsx-wrap-multilines */ 





function $315ae4957e308cf1$var$CertsReassignPopover({ actionKind: actionKind, isReassignPopoverOpen: isReassignPopoverOpen, setIsReassignPopoverOpen: setIsReassignPopoverOpen, placement: placement, trigger: trigger, onSubmit: onSubmit }) {
    // Reset on close
    (0, $hopDi$useEffect)(()=>{}, [
        isReassignPopoverOpen
    ]);
    const handleCommentSubmit = ()=>{
        setIsReassignPopoverOpen(false);
        return onSubmit();
    };
    const getPopoverContent = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
            className: "CertsReassignPopover",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "body1",
                    className: "CertsReassignPopover-note",
                    children: "By reassigning this user, their associated items will be included. Any approvals or rejections will be cleared upon reassignment."
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    tag: "div",
                    className: "CertsReassignPopover-controls",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: "ghost",
                            onClick: ()=>setIsReassignPopoverOpen(false),
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: "filled",
                            onClick: handleCommentSubmit,
                            children: "Got it"
                        })
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
        tag: "div",
        className: "CertsReassignPopover-contextWrapper",
        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Popover), {
            placement: placement,
            trigger: trigger,
            popoverContent: getPopoverContent(),
            isOpen: isReassignPopoverOpen,
            setIsOpen: setIsReassignPopoverOpen
        })
    });
}
$315ae4957e308cf1$var$CertsReassignPopover.defaultProps = {
    actionKind: null
};
$315ae4957e308cf1$var$CertsReassignPopover.propTypes = {
    actionKind: (0, $hopDi$proptypes).oneOf(Object.values((0, $20281fe09bc700a8$export$3f43cf8434698562))),
    isReassignPopoverOpen: (0, $hopDi$proptypes).bool.isRequired,
    setIsReassignPopoverOpen: (0, $hopDi$proptypes).func.isRequired,
    placement: (0, $hopDi$proptypes).string.isRequired,
    trigger: (0, $hopDi$proptypes).element.isRequired,
    onSubmit: (0, $hopDi$proptypes).func.isRequired
};
var $315ae4957e308cf1$export$2e2bcd8739ae039 = $315ae4957e308cf1$var$CertsReassignPopover;











// Arguments should passed in order as their namespace
const $f1b5fcb177039d2c$export$89d08ff8f2f5d795 = (current, target)=>{
    if (current === null || target === null) return "";
    if (current === target) return "";
    if (current.length - target.length === 1) return target;
    for(let i = 0; i < target.length; i += 1){
        if (current[i] !== target[i]) return target[i] || "";
    }
    return "";
};
var $f1b5fcb177039d2c$export$2e2bcd8739ae039 = $f1b5fcb177039d2c$export$89d08ff8f2f5d795;



/*
 * Name: CertsModalCommentBox
 * Accepts:
 *    defaultComments: [] (Array of pre defined comment)
 *    showAlert: boolean (Show the critical messsage when set to true, only when input box is empty)
 *    onChange: fn (function which receives the text from the input box)
 */ function $b3efe2b33729b6d5$var$CertsModalCommentBox({ defaultComments: defaultComments, showAlert: showAlert, onChange: onChange, clearModal: clearModal, className: className }) {
    const [predefComments, setPredefComments] = (0, $hopDi$useState)([]);
    const [commentDescription, setCommentDescription] = (0, $hopDi$useState)("");
    const [isCommentApplied, setIsCommentApplied] = (0, $hopDi$useState)(false);
    const CertsModalCommentBoxClasses = (0, $hopDi$classnames)("CertsModalCommentBox-wrapper", className);
    (0, $hopDi$useEffect)(()=>{
        setCommentDescription("");
    }, [
        clearModal
    ]);
    (0, $hopDi$useEffect)(()=>{
        setPredefComments(defaultComments?.map((comment, index)=>({
                text: comment,
                isChecked: false,
                index: index + 1
            })));
    }, [
        defaultComments
    ]);
    const shouldShowChipsForSignature = Boolean(predefComments.length > 0);
    const shouldShowAlertForCommentForSignature = Boolean(showAlert && commentDescription?.trim().length === 0);
    (0, $hopDi$useEffect)(()=>{
        onChange(commentDescription);
    }, [
        commentDescription
    ]);
    const handleCommentClickForSignature = (id)=>{
        const tempPreDefComments = predefComments.map((comment)=>{
            if (comment.index === id) return {
                ...comment,
                isChecked: !comment.isChecked
            };
            return {
                ...comment,
                isChecked: false
            };
        });
        const isActiveComment = tempPreDefComments.some((comment)=>comment.isChecked);
        const tempCommentDescription = tempPreDefComments.find((item)=>item.index === id)?.text;
        setPredefComments(tempPreDefComments);
        setIsCommentApplied(isActiveComment);
        setCommentDescription(isActiveComment ? tempCommentDescription : "");
    };
    const handleSignatureComment = (text)=>{
        const newdescription = isCommentApplied ? (0, $f1b5fcb177039d2c$export$89d08ff8f2f5d795)(commentDescription, text) : text;
        setCommentDescription(newdescription);
        setPredefComments(isCommentApplied ? predefComments.map((comment)=>({
                ...comment,
                isChecked: false
            })) : predefComments);
        setIsCommentApplied(false);
    };
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
        tag: "div",
        className: CertsModalCommentBoxClasses,
        children: [
            shouldShowChipsForSignature && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                tag: "div",
                className: "CertsModalCommentBox-comments",
                children: predefComments?.map((item)=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Chip), {
                        kind: item.isChecked ? "boldFilled" : "outlined",
                        label: item.text,
                        isSelected: item.isChecked,
                        color: "brandSecondary",
                        rightIcon: item.isChecked ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "Close"
                        }) : null,
                        onClick: ()=>handleCommentClickForSignature(item.index)
                    }, item.index))
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                tag: "div",
                className: `CertsModalCommentBox-inputBox ${shouldShowChipsForSignature ? "" : "noCommentsPresent"}`,
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InputField), {
                    name: "basic",
                    placeholder: "Provide a reason for your decision",
                    label: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "label",
                        htmlFor: "Required",
                        children: "Comments"
                    }),
                    value: commentDescription,
                    setValue: handleSignatureComment,
                    kind: "multiline",
                    isRequired: true,
                    minRequiredChars: 3,
                    isCritical: shouldShowAlertForCommentForSignature,
                    CriticalHelperText: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InlineMessage), {
                        kind: "missingRequiredField",
                        size: "small"
                    })
                })
            })
        ]
    });
}
$b3efe2b33729b6d5$var$CertsModalCommentBox.propTypes = {
    defaultComments: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string),
    showAlert: (0, $hopDi$proptypes).bool.isRequired,
    onChange: (0, $hopDi$proptypes).func,
    clearModal: (0, $hopDi$proptypes).bool,
    className: (0, $hopDi$proptypes).string
};
$b3efe2b33729b6d5$var$CertsModalCommentBox.defaultProps = {
    defaultComments: [],
    onChange: ()=>{},
    clearModal: true,
    className: ""
};
var $b3efe2b33729b6d5$export$2e2bcd8739ae039 = $b3efe2b33729b6d5$var$CertsModalCommentBox;



function $70f14337b6a0828d$var$CertsChangeEndDate({ handleClick: handleClick, handleCancel: handleCancel, getCurrentEndDate: getCurrentEndDate, isChangeEndDateError: isChangeEndDateError, setIsChangeEndDateError: setIsChangeEndDateError, allowedChangeExtendDate: allowedChangeExtendDate, isLoading: isLoading, certificationStartDate: certificationStartDate, errorMessage: errorMessage }) {
    const [isOpen, setIsOpen] = (0, $hopDi$useState)(true);
    const [isCritical, setIsCritical] = (0, $hopDi$useState)(false);
    const initialChipData = [];
    let checkMinDate = (0, $hopDi$moment)(new Date()).isAfter((0, $hopDi$moment)(certificationStartDate), "day");
    checkMinDate = checkMinDate ? new Date() : certificationStartDate;
    const [commentValue, setCommentValue] = (0, $hopDi$useState)("");
    const [startDate1, setStartDate1] = (0, $hopDi$useState)(checkMinDate);
    const [isDateCritical, setIsDateCritical] = (0, $hopDi$useState)(false);
    const [getAllowedChangeExtendDates, setAllowedChangeExtendDates] = (0, $hopDi$useState)(checkMinDate);
    const isCommentValid = Boolean(isCritical || commentValue?.replace(/[<>]/g, "")?.trim()?.length < 3);
    (0, $hopDi$useEffect)(()=>{
        if (allowedChangeExtendDate && allowedChangeExtendDate.length > 0) {
            const minDateForDatePicker = (0, $hopDi$moment)(certificationStartDate).add(Number(allowedChangeExtendDate) - 1 || 5, "days");
            setAllowedChangeExtendDates(minDateForDatePicker.toDate());
        } else setAllowedChangeExtendDates(null);
    }, []);
    const handleSave = ()=>{
        if (!startDate1) setIsDateCritical(!isDateCritical);
        if (isCommentValid) setIsCritical(!isCritical);
        if (startDate1 && !isCommentValid) {
            let currentDate = startDate1;
            const dd = currentDate.getDate();
            const mm = currentDate.getMonth() + 1;
            const yyyy = currentDate.getFullYear();
            currentDate = `${mm < 10 ? `0${mm}` : mm}-${dd < 10 ? `0${dd}` : dd}-${yyyy}`;
            handleClick(currentDate, commentValue);
        }
    };
    const handleCommentText = (text)=>{
        setCommentValue(text);
    };
    const handleClose = ()=>{
        setIsOpen(false);
        setIsChangeEndDateError();
        handleCancel();
    };
    const getChangeEndDateModal = ()=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
            onClose: ()=>handleClose(),
            className: "Certs-ChangeEndDate-Modal-wrapper",
            isOpen: isOpen,
            title: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "Certs-ChangeEndDate-Modal-TitleWrapper",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "ExtendEndDate",
                        color: "neutral-1000",
                        size: "large"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "Certs-ChangeEndDate-Modal-commentsTitle",
                        children: "Change End Date"
                    })
                ]
            }),
            subtitle: /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "Certs-ChangeEndDate-Modal-commentsDesc",
                children: "The end date won't be changed until you finish the review and submit."
            }),
            contentBody: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$AlertBanner), {
                        colorTheme: "Critical",
                        title: "Error",
                        description: errorMessage,
                        isVisible: isChangeEndDateError,
                        onCancel: setIsChangeEndDateError,
                        isColonVisible: true,
                        isFloating: true,
                        shouldAutoDismiss: true,
                        autoDismissDelay: 5000
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "Certs-ChangeEndDate-CommonMargin-Container",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "h3",
                                children: "Current End Date"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                component: "p",
                                variant: "body3",
                                color: "textPrimary",
                                className: "Certs-ChangeEndDate-Title",
                                children: getCurrentEndDate
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$DateAndTimePicker), {
                        className: "Certs-ChangeEndDate-CommonMargin-Container",
                        kind: "dateStart",
                        label: "New End Date",
                        isRequired: true,
                        isCritical: isDateCritical,
                        setIsCritical: setIsDateCritical,
                        CriticalHelperText: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InlineMessage), {
                            text: "Please select a new end date.",
                            colorTheme: "critical",
                            size: "small",
                            leftIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: "AlertCritical",
                                color: "critical-700"
                            })
                        }),
                        startDate: startDate1,
                        setStartDate: setStartDate1,
                        minDate: checkMinDate,
                        maxDate: getAllowedChangeExtendDates
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $b3efe2b33729b6d5$export$2e2bcd8739ae039), {
                        defaultComments: initialChipData,
                        showAlert: isCritical,
                        onChange: handleCommentText
                    })
                ]
            }),
            FooterActionBarComp: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$FooterActionBar), {
                className: "ModalPage-footer",
                size: "large",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {}),
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "Certs-ChangeEndDate-buttonWrapper",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                                type: "button",
                                kind: "ghost",
                                isDisabled: isLoading,
                                size: "medium",
                                onClick: ()=>{
                                    setIsOpen(false);
                                    handleCancel();
                                },
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                                className: "Certs-ChangeEndDate-saveButton",
                                type: "button",
                                kind: "outlined",
                                isDisabled: isLoading,
                                size: "medium",
                                onClick: ()=>handleSave(),
                                children: "Save"
                            })
                        ]
                    })
                ]
            })
        });
    return /*#__PURE__*/ (0, $hopDi$jsx)("section", {
        children: getChangeEndDateModal()
    });
}
var $70f14337b6a0828d$export$2e2bcd8739ae039 = $70f14337b6a0828d$var$CertsChangeEndDate;


var $2b983767f0657a26$export$2e2bcd8739ae039 = (0, $70f14337b6a0828d$export$2e2bcd8739ae039);


/* eslint-disable react/prop-types */ /* eslint-disable no-empty-pattern */ 





/* eslint-disable guard-for-in */ /* eslint-disable indent */ 

const $4c1aa6449628783a$export$c40b9342a19db0b6 = (tileNodeData)=>{
    const certsKeyValue = tileNodeData?.CERT_ENTITLEMENT_VALUEKEY;
    if (certsKeyValue === (0, $bae22e791544392c$export$994f7af6d0b36256).USER) return (0, $bae22e791544392c$export$6b1c20b2e2de9059).USER;
    if (certsKeyValue === (0, $bae22e791544392c$export$994f7af6d0b36256).ROLE) return (0, $bae22e791544392c$export$6b1c20b2e2de9059).ROLE;
    if (certsKeyValue === (0, $bae22e791544392c$export$994f7af6d0b36256).ACCOUNT) return (0, $bae22e791544392c$export$6b1c20b2e2de9059).ACCOUNT;
    return (0, $bae22e791544392c$export$6b1c20b2e2de9059).ENTITLEMENT;
};
const $4c1aa6449628783a$export$18b54358355494a = (certsKind)=>{
    if (certsKind === (0, $bae22e791544392c$export$6b1c20b2e2de9059).USER) return 0, $a23cd229b9113926$export$50fc35c85d3a3c9d;
    if (certsKind === (0, $bae22e791544392c$export$6b1c20b2e2de9059).ACCOUNT) return 0, $a23cd229b9113926$export$e7e5437fabb30374;
    if (certsKind === (0, $bae22e791544392c$export$6b1c20b2e2de9059).ENTITLEMENT) return 0, $a23cd229b9113926$export$1b550718072cac3f;
    if (certsKind === (0, $bae22e791544392c$export$6b1c20b2e2de9059).ROLE) return 0, $a23cd229b9113926$export$1772b047bb5ee9a;
    return null;
};
const $4c1aa6449628783a$export$f87a1650caa3642b = (prev)=>prev.map((item)=>({
            ...item,
            tracker: {
                ...item.tracker,
                isConnected: false
            },
            children: item?.children?.length > 0 ? $4c1aa6449628783a$export$f87a1650caa3642b(item.children) : []
        }));
const $4c1aa6449628783a$export$86c6573c35d84094 = (previousTiles, targetId, targetLevel)=>{
    // First, disable connection status for all tiles except for the targeted one
    const modifiedTiles = $4c1aa6449628783a$export$f87a1650caa3642b(previousTiles).map((tile)=>{
        if (tile.tracker.level === targetLevel) {
            // Enable connection only if the current tile matches the target ID
            const isConnected = tile.tracker.id === targetId;
            return {
                ...tile,
                tracker: {
                    ...tile.tracker,
                    isConnected: isConnected
                }
            };
        }
        // If not on the target level, recursively adjust the connection status of children
        return {
            ...tile,
            tracker: {
                ...tile.tracker,
                isConnected: false
            },
            children: tile.children ? $4c1aa6449628783a$export$86c6573c35d84094(tile.children, targetId, targetLevel) : []
        };
    });
    return modifiedTiles;
};
const $4c1aa6449628783a$export$e946959053026eab = (children, targetStatus)=>children.map((child)=>({
            ...child,
            tracker: {
                ...child.tracker,
                isChecked: targetStatus || child.tracker.isChecked,
                isIndeterminate: false
            },
            children: child?.children?.length > 0 ? $4c1aa6449628783a$export$e946959053026eab(child.children, targetStatus) : []
        }));
const $4c1aa6449628783a$export$489fa64af1a46e4 = (nodes)=>{
    const flattenedList = (0, $e7628c995f405891$export$8824054d4a42eac8)(nodes);
    return flattenedList.map((node)=>node?.tracker?.isChecked || node?.tracker?.isIndeterminate);
};
const $4c1aa6449628783a$export$e6436fb982b2017f = (prev)=>prev.map((item)=>{
        const hasChildren = item?.children?.length > 0;
        if (!hasChildren) return item;
        // first is parent status
        const childrenStatus = $4c1aa6449628783a$export$489fa64af1a46e4(item?.children);
        // const isAllChildrenChecked = !childrenStatus.some(
        //   (value) => value === false
        // );
        const hasAtleastOneChildChecked = childrenStatus.some((value)=>value === true);
        // if (isAllChildrenChecked) {
        //   return {
        //     ...item,
        //     tracker: {
        //       ...item.tracker,
        //       isIndeterminate: !item?.tracker?.isChecked,
        //     },
        //     children: hasChildren ? markParentBasedOnChildren(item.children) : [],
        //   };
        // }
        if (hasAtleastOneChildChecked) return {
            ...item,
            tracker: {
                ...item.tracker,
                isIndeterminate: !item?.tracker?.isChecked
            },
            children: hasChildren ? $4c1aa6449628783a$export$e6436fb982b2017f(item.children) : []
        };
        return {
            ...item,
            tracker: {
                ...item.tracker,
                isIndeterminate: false
            },
            children: hasChildren ? $4c1aa6449628783a$export$e6436fb982b2017f(item.children) : []
        };
    });
const $4c1aa6449628783a$export$57d225e2d2f6fa1f = (actions)=>{
    if (!actions) return false;
    const trackerActions = Object.keys(actions);
    const flag = Boolean(trackerActions.length > 0 && trackerActions?.some((key)=>{
        if (actions[key].isLoading) return true;
        return false;
    }));
    return flag;
};




const $271c8dec800e3a4d$export$46f21910265caffc = "User_DISPLAYNAME";
const $271c8dec800e3a4d$export$b21a97077b446a0c = "Account_DISPLAYNAME";
const $271c8dec800e3a4d$export$ef258f55852583b5 = "Role_DISPLAYNAME";
const $271c8dec800e3a4d$export$8e9b5a553c0ae9b2 = "Ent_DISPLAYNAME";


/* eslint-disable react/prop-types */ /* eslint-disable no-unused-vars */ /* eslint-disable react/button-has-type */ 


/* eslint-disable no-param-reassign */ // eslint-disable-next-line import/prefer-default-export
const $8ef29c07b3459fed$export$b978961550c58af1 = (firstName, lastName)=>`${firstName} ${lastName} (${firstName[0].toLowerCase()}${lastName.toLowerCase()})`;
const $8ef29c07b3459fed$export$843ad9807fe4b13f = (list)=>list.map((ele)=>{
        ele.value = ele.id.toString();
        ele.label = `${$8ef29c07b3459fed$export$b978961550c58af1(ele.username, ele.lastname)} . ${ele.email}`;
        ele.isChecked = false;
        return ele;
    });


function $56a81ce622cfab5e$var$DropdownSelect({ onSelect: onSelect, list: list, defaultReassignee: defaultReassignee, defaultAssigneName: defaultAssigneName, className: className }) {
    const [usersList, setUsersList] = (0, $hopDi$useState)([]);
    (0, $hopDi$useEffect)(()=>{
        const userList = [];
        if (defaultReassignee !== "" && defaultAssigneName !== "") {
            const defaultCertifier = {};
            defaultCertifier.value = defaultReassignee;
            defaultCertifier.label = `${defaultAssigneName} - default certifier`;
            defaultCertifier.isChecked = false;
            userList.push(defaultCertifier);
        }
        if (userList.length > 0) {
            const mergedArray = userList.concat((0, $8ef29c07b3459fed$export$843ad9807fe4b13f)(list));
            setUsersList(mergedArray);
        } else setUsersList((0, $8ef29c07b3459fed$export$843ad9807fe4b13f)(list));
    }, [
        list
    ]);
    const handleChange = (selectedOption)=>{
        // create a new array with updated options
        setUsersList((currentOptions)=>currentOptions.map((option)=>({
                    ...option,
                    isChecked: option.value === selectedOption.value
                })));
        onSelect(selectedOption);
    };
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
        className: `anyWidthPositionRelative ${className}`,
        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MenuInput), {
            options: usersList,
            onChange: handleChange,
            placeholder: "Select a known or default certifier"
        })
    });
}
var $56a81ce622cfab5e$export$2e2bcd8739ae039 = $56a81ce622cfab5e$var$DropdownSelect;



/* eslint-disable react/prop-types */ /* eslint-disable no-unused-vars */ /* eslint-disable no-empty-pattern */ 





function $3000c97704c797ef$var$CertsConsultWarnModal({ isConsultWarnModalOpen: isConsultWarnModalOpen, handleClose: handleClose, handleWarnModal: handleWarnModal, isActionLoading: isActionLoading, errorMessage: errorMessage }) {
    const [isOpen, setIsOpen] = (0, $hopDi$useState)(false);
    const [isChecked, setIsChecked] = (0, $hopDi$useState)(false);
    const [isVisible, setIsVisible] = (0, $hopDi$useState)(false);
    const onCancel = ()=>setIsVisible(false);
    const dispatch = (0, $hopDi$useDispatch)();
    (0, $hopDi$useEffect)(()=>{
        setIsOpen(isConsultWarnModalOpen);
    }, [
        isConsultWarnModalOpen
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (errorMessage) setIsVisible(true);
        else if (isVisible) setIsVisible(false);
    }, [
        errorMessage
    ]);
    const getConsultWarnModal = ()=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
            kind: "warning",
            className: "CertsConsultWarnModal",
            alertTitle: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    "Consultation Is Pending",
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$AlertBanner), {
                        colorTheme: "Critical",
                        title: "Error",
                        description: errorMessage,
                        isVisible: isVisible,
                        onCancel: onCancel,
                        isColonVisible: true,
                        isFloating: true,
                        shouldAutoDismiss: true,
                        autoDismissDelay: 4000
                    })
                ]
            }),
            alertSubtitle: "A consultation with First Last (username) is pending and can\u2019t be canceled. Do you want to request a new consultation with another user anyway?",
            onClose: ()=>{
                // close modal
                handleClose();
            },
            isOpen: isOpen,
            primaryButton: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                        name: "checkbox0",
                        kind: "text",
                        dataTestId: "checkbox0",
                        isChecked: isChecked,
                        onChange: (event)=>{
                            setIsChecked(event.target.checked);
                            dispatch({
                                type: (0, $d6d78fc758ee4148$export$6eb1d8263e7e2d01)
                            });
                        },
                        label: "Don\u2019t show this again for this certification",
                        textPosition: "after"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        type: "button",
                        kind: "outlined",
                        size: "medium",
                        isDisabled: isActionLoading,
                        rightIcon: isActionLoading ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                            kind: "loop",
                            format: "inline",
                            color: "brand"
                        }) : null,
                        onClick: (e)=>{
                            handleWarnModal(e, true);
                        },
                        children: "Make Decision"
                    })
                ]
            }),
            secondaryButton: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                type: "button",
                kind: "ghost",
                size: "medium",
                onClick: handleClose,
                isDisabled: isActionLoading,
                children: "Cancel"
            })
        });
    return /*#__PURE__*/ (0, $hopDi$jsx)("section", {
        children: getConsultWarnModal()
    });
}
var $3000c97704c797ef$export$2e2bcd8739ae039 = $3000c97704c797ef$var$CertsConsultWarnModal;



function $7f3598ff04b0c7dc$var$CertsConsultModal({ isConsultModalOpen: isConsultModalOpen, setIsConsultModalOpen: setIsConsultModalOpen, consultModalDetails: consultModalDetails, nodeData: nodeData, isCommentRequired: isCommentRequired, onSubmit: onSubmit }) {
    const [isOpen, setIsOpen] = (0, $hopDi$useState)(false);
    const { usersListDetails: usersListDetails, certKey: certKey, reassignConfigMap: reassignConfigMap, isWarnModalConsultShown: isWarnModalConsultShown, action: { isActionSuccess: isActionSuccess, errorMessage: errorMessage, isActionError: isActionError, isActionLoading: isActionLoading } } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const { list: list } = usersListDetails;
    const [isIncludeAssociateChecked, setIsIncludedAssociateChecked] = (0, $hopDi$useState)(false);
    const [selectedUser, setSelectedUser] = (0, $hopDi$useState)(null);
    const [isConsultWarnModalOpen, setIsConsultWarnModalOpen] = (0, $hopDi$useState)(false);
    const [isVisible, setIsVisible] = (0, $hopDi$useState)(false);
    const onCancel = ()=>setIsVisible(false);
    const dropdownClassName = (0, $hopDi$classnames)("CertsConsultModal-dropdown");
    const [commentsDetails, setCommentDetails] = (0, $hopDi$useState)({
        commentDescription: "",
        predefComments: [],
        isCommentApplied: false,
        showAlert: false
    });
    const dispatch = (0, $hopDi$useDispatch)();
    const isCertsKindUser = nodeData?.CERT_ENTITLEMENT_VALUEKEY === (0, $20281fe09bc700a8$export$994f7af6d0b36256).USER;
    (0, $hopDi$useEffect)(()=>{
        setIsOpen(isConsultModalOpen);
    }, [
        isConsultModalOpen
    ]);
    (0, $hopDi$useEffect)(()=>{
        dispatch((0, $d623f23401a154f0$export$348ff7906afdfd12)(certKey));
    }, []);
    (0, $hopDi$useEffect)(()=>{
        setIsVisible(isActionError);
    }, [
        isActionError
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (isActionSuccess) {
            setIsConsultModalOpen(false);
            if (isConsultWarnModalOpen) setIsConsultWarnModalOpen(false);
        }
    }, [
        isActionSuccess
    ]);
    const handleCommentDescription = (text)=>{
        setCommentDetails({
            ...commentsDetails,
            commentDescription: text,
            showAlert: text.length === 0 ? commentsDetails.showAlert : false
        });
    };
    const handleSubmit = (e, isFromWarnModal = false)=>{
        const modalInfo = {
            isIncludeAssociateChecked: isIncludeAssociateChecked,
            selectedUser: selectedUser,
            certKey: certKey,
            commentValue: commentsDetails.commentDescription
        };
        if (!selectedUser) {
            // show alert to select certifier
            setIsVisible(true);
            setTimeout(()=>{
                onCancel();
            }, 1500);
            return;
        }
        // hanlde comments validation
        if (commentsDetails.commentDescription?.replace(/[<>]/g, "")?.trim()?.length < 3) {
            setCommentDetails({
                ...commentsDetails,
                showAlert: true
            });
            return;
        }
        if (isWarnModalConsultShown || isFromWarnModal) // call api directly from here
        onSubmit(modalInfo);
        else setIsConsultWarnModalOpen(true);
    };
    /** to enable handle submit button */ const isBtnEnabled = ()=>{
        if (isActionLoading) return false;
        // selected user and comments validation
        if (isCommentRequired && commentsDetails?.commentDescription?.replace(/[<>]/g, "")?.trim()?.length > 3 && selectedUser) return true;
        // skip certifier and comment validation
        if (isCommentRequired && commentsDetails?.commentDescription?.replace(/[<>]/g, "")?.trim()?.length > 3) return true;
        return false;
    };
    /** to get lineitem display name */ const getSelectedLineItemName = (lineItemType)=>{
        let name = "";
        switch(lineItemType){
            case (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).USER:
                name = nodeData[0, $271c8dec800e3a4d$export$46f21910265caffc];
                break;
            case (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).ACCOUNT:
                name = nodeData[0, $271c8dec800e3a4d$export$b21a97077b446a0c];
                break;
            case (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).ROLE:
                name = nodeData[0, $271c8dec800e3a4d$export$ef258f55852583b5];
                break;
            case (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).ENTITLEMENT:
                name = nodeData[0, $271c8dec800e3a4d$export$8e9b5a553c0ae9b2];
                break;
            default:
                break;
        }
        return name;
    };
    const getReassignModal = ()=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
            onClose: ()=>{
                setIsOpen(false);
                setIsConsultModalOpen();
            },
            className: "CertsConsultModal-wrapper",
            isOpen: isOpen,
            title: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "CertsConsultModal-headerInfo",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "Consult",
                        color: "neutral-1000",
                        size: "large"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "h1",
                        className: "CertsConsultModal-title",
                        children: "Consult with Peers"
                    })
                ]
            }),
            subtitle: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                className: "CertsConsultModal-subtitle",
                kind: "body2",
                children: ` Invite another user in your organization to review your certification items and advise on appropriate actions.`
            }),
            contentBody: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "CertsConsultModal-container",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "CertsConsultModal-containerHeader",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$AlertBanner), {
                                className: "consultCertifier-selectionWarn",
                                colorTheme: "Critical",
                                title: "Error",
                                description: errorMessage,
                                isVisible: isVisible,
                                onCancel: onCancel,
                                autoDismissDelay: 4000
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "h4",
                                className: "CertsConsultModal-containerTitle",
                                children: "Items to Consult"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                className: "CertsConsultModal-container-userDetails",
                                children: [
                                    isCertsKindUser ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Avatar), {
                                        size: "small"
                                    }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                        kind: (0, $4c1aa6449628783a$export$c40b9342a19db0b6)(nodeData),
                                        color: "navy-900",
                                        size: "smallMedium"
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                        kind: "h4",
                                        className: "CertsConsultModal-container-userDetailsName",
                                        children: getSelectedLineItemName(consultModalDetails?.lineItemKind)
                                    })
                                ]
                            }),
                            consultModalDetails?.isIncludeAssociatedEnt && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "CertsConsultModal-includeCheckbox",
                                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                                    name: "checkbox2",
                                    kind: "text",
                                    dataTestId: "checkbox2",
                                    isChecked: isIncludeAssociateChecked,
                                    onChange: (event)=>{
                                        setIsIncludedAssociateChecked(event.target.checked);
                                    },
                                    label: consultModalDetails?.isIncludeAsscLabel,
                                    labelPosition: "before"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "CertsConsultModal-containerCertifierSelection",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "CertsConsultModal-DropdownAsterisk",
                                children: "*"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "h4",
                                className: "CertsConsultModal-container-certifier",
                                children: "I want to consult with"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $56a81ce622cfab5e$export$2e2bcd8739ae039), {
                                list: list,
                                className: dropdownClassName,
                                defaultReassignee: reassignConfigMap?.defaultReassignee,
                                defaultAssigneName: reassignConfigMap?.defaultReassigneeName,
                                onSelect: (user)=>{
                                    setSelectedUser(user);
                                }
                            })
                        ]
                    }),
                    isCommentRequired && /*#__PURE__*/ (0, $hopDi$jsx)((0, $b3efe2b33729b6d5$export$2e2bcd8739ae039), {
                        defaultComments: commentsDetails?.predefComments,
                        showAlert: commentsDetails.showAlert,
                        onChange: handleCommentDescription,
                        className: "CertsConsultModal-comments"
                    })
                ]
            }),
            FooterActionBarComp: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$FooterActionBar), {
                className: "CertsConsultModal-footer",
                size: "large",
                children: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "CertsConsultModal-actionButtons",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: "ghost",
                            size: "medium",
                            isDisabled: isActionLoading,
                            onClick: ()=>{
                                setIsConsultModalOpen(false);
                            },
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            className: "CertsConsultModal-submitButton",
                            type: "button",
                            kind: isBtnEnabled() ? "filled" : "outlined",
                            size: "medium",
                            onClick: handleSubmit,
                            rightIcon: isActionLoading ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                                kind: "loop",
                                format: "inline",
                                color: "brand"
                            }) : null,
                            isDisabled: !isBtnEnabled(),
                            children: "Submit"
                        })
                    ]
                })
            })
        });
    return /*#__PURE__*/ (0, $hopDi$jsxs)("section", {
        children: [
            !isConsultWarnModalOpen && getReassignModal(),
            isConsultWarnModalOpen && /*#__PURE__*/ (0, $hopDi$jsx)((0, $3000c97704c797ef$export$2e2bcd8739ae039), {
                isConsultWarnModalOpen: isConsultWarnModalOpen,
                isActionLoading: isActionLoading,
                handleClose: ()=>{
                    setIsConsultWarnModalOpen(false);
                    setIsConsultModalOpen(false);
                },
                errorMessage: errorMessage,
                handleWarnModal: handleSubmit
            })
        ]
    });
}
var $7f3598ff04b0c7dc$export$2e2bcd8739ae039 = $7f3598ff04b0c7dc$var$CertsConsultModal;





/* eslint-disable react/prop-types */ /* eslint-disable no-empty-pattern */ 









/* eslint-disable react/prop-types */ /* eslint-disable no-unused-vars */ /* eslint-disable no-empty-pattern */ 





function $e2c36875a8ec4133$var$CertsReassignWarnModal({ isReassignWarnModalOpen: isReassignWarnModalOpen, handleClose: handleClose, handleWarnModal: handleWarnModal, isActionLoading: isActionLoading, errorMessage: errorMessage }) {
    const [isOpen, setIsOpen] = (0, $hopDi$useState)(false);
    const [isChecked, setIsChecked] = (0, $hopDi$useState)(false);
    const [isVisible, setIsVisible] = (0, $hopDi$useState)(false);
    const onCancel = ()=>setIsVisible(false);
    const dispatch = (0, $hopDi$useDispatch)();
    (0, $hopDi$useEffect)(()=>{
        setIsOpen(isReassignWarnModalOpen);
    }, [
        isReassignWarnModalOpen
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (errorMessage) setIsVisible(true);
        else if (isVisible) setIsVisible(false);
    }, [
        errorMessage
    ]);
    const getReassignWarnModal = ()=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
            kind: "warning",
            className: "CertsReassignWarnModal",
            alertTitle: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    "Reassignment Can\u2019t Be Undone",
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$AlertBanner), {
                        colorTheme: "Critical",
                        title: "Error",
                        description: errorMessage,
                        isVisible: isVisible,
                        onCancel: onCancel,
                        isColonVisible: true,
                        isFloating: true,
                        shouldAutoDismiss: true,
                        autoDismissDelay: 4000
                    })
                ]
            }),
            alertSubtitle: "When you reassign one of your certification items to another certifier, it\u2019ll be removed from your list and can\u2019t be retracted. Do you want to reassign this item?",
            onClose: ()=>{
                // close modal
                handleClose();
            },
            isOpen: isOpen,
            primaryButton: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                        name: "checkbox0",
                        kind: "text",
                        dataTestId: "checkbox0",
                        isChecked: isChecked,
                        onChange: (event)=>{
                            setIsChecked(event.target.checked);
                            dispatch({
                                type: (0, $d6d78fc758ee4148$export$6eb1d8263e7e2d01)
                            });
                        },
                        label: "Don\u2019t show this message again",
                        textPosition: "after"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        type: "button",
                        kind: "outlined",
                        size: "medium",
                        isDisabled: isActionLoading,
                        rightIcon: isActionLoading ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                            kind: "loop",
                            format: "inline",
                            color: "brand"
                        }) : null,
                        onClick: (e)=>{
                            handleWarnModal(e, true);
                        },
                        children: "Reassign"
                    })
                ]
            }),
            secondaryButton: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                type: "button",
                kind: "ghost",
                size: "medium",
                onClick: handleClose,
                isDisabled: isActionLoading,
                children: "Cancel"
            })
        });
    return /*#__PURE__*/ (0, $hopDi$jsx)("section", {
        children: getReassignWarnModal()
    });
}
var $e2c36875a8ec4133$export$2e2bcd8739ae039 = $e2c36875a8ec4133$var$CertsReassignWarnModal;





function $7de18020df34e39a$var$CertsReassignModal({ isReassignModalOpen: isReassignModalOpen, setIsReassignModalOpen: setIsReassignModalOpen, reassignModalDetails: reassignModalDetails, nodeData: nodeData, isCommentRequired: isCommentRequired, onSubmit: onSubmit }) {
    const [isOpen, setIsOpen] = (0, $hopDi$useState)(false);
    const { usersListDetails: usersListDetails, certKey: certKey, reassignConfigMap: reassignConfigMap, isWarnModalReassignShown: isWarnModalReassignShown, action: { isActionSuccess: isActionSuccess, errorMessage: errorMessage, isActionError: isActionError, isActionLoading: isActionLoading } } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const { list: list } = usersListDetails;
    const [isSkipCertifierChecked, setIsSkipCertifierChecked] = (0, $hopDi$useState)(false);
    const [isIncludeAssociateChecked, setIsIncludedAssociateChecked] = (0, $hopDi$useState)(false);
    const [selectedUser, setSelectedUser] = (0, $hopDi$useState)(null);
    const [isReassignWarnModalOpen, setIsReassignWarnModalOpen] = (0, $hopDi$useState)(false);
    const [isVisible, setIsVisible] = (0, $hopDi$useState)(false);
    const onCancel = ()=>setIsVisible(false);
    const dropdownClassName = (0, $hopDi$classnames)("CertsReassignModal-dropdown", isSkipCertifierChecked && `selection--disabled`);
    const [commentsDetails, setCommentDetails] = (0, $hopDi$useState)({
        commentDescription: "",
        predefComments: [],
        isCommentApplied: false,
        showAlert: false
    });
    const dispatch = (0, $hopDi$useDispatch)();
    const isCertsKindUser = nodeData?.CERT_ENTITLEMENT_VALUEKEY === (0, $20281fe09bc700a8$export$994f7af6d0b36256).USER;
    (0, $hopDi$useEffect)(()=>{
        setIsOpen(isReassignModalOpen);
    }, [
        isReassignModalOpen
    ]);
    (0, $hopDi$useEffect)(()=>{
        dispatch((0, $d623f23401a154f0$export$348ff7906afdfd12)(certKey));
    }, []);
    (0, $hopDi$useEffect)(()=>{
        setIsVisible(isActionError);
    }, [
        isActionError
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (isActionSuccess) {
            setIsReassignModalOpen(false);
            if (isReassignWarnModalOpen) setIsReassignWarnModalOpen(false);
        }
    }, [
        isActionSuccess
    ]);
    const handleCommentDescription = (text)=>{
        setCommentDetails({
            ...commentsDetails,
            commentDescription: text,
            showAlert: text.length === 0 ? commentsDetails.showAlert : false
        });
    };
    const handleSubmit = (e, isFromWarnModal = false)=>{
        const modalInfo = {
            isSkipCertifierChecked: isSkipCertifierChecked,
            isIncludeAssociateChecked: isIncludeAssociateChecked,
            selectedUser: selectedUser,
            certKey: certKey,
            commentValue: commentsDetails.commentDescription
        };
        if (!isSkipCertifierChecked && !selectedUser) {
            // show alert to select certifier
            setIsVisible(true);
            setTimeout(()=>{
                onCancel();
            }, 1500);
            return;
        }
        // hanlde comments validation
        if (commentsDetails.commentDescription?.replace(/[<>]/g, "")?.trim()?.length < 3 && !isSkipCertifierChecked) {
            setCommentDetails({
                ...commentsDetails,
                showAlert: true
            });
            return;
        }
        if (isWarnModalReassignShown || isFromWarnModal) // call api directly from here
        onSubmit(modalInfo);
        else setIsReassignWarnModalOpen(true);
    };
    /** to enable handle submit button */ const isBtnEnabled = ()=>{
        if (isActionLoading) return false;
        // selected user and comments validation
        if (isCommentRequired && commentsDetails?.commentDescription?.replace(/[<>]/g, "")?.trim()?.length > 3 && !isSkipCertifierChecked && selectedUser) return true;
        // skip certifier and comment validation
        if (isCommentRequired && commentsDetails?.commentDescription?.replace(/[<>]/g, "")?.trim()?.length > 3 && isSkipCertifierChecked) return true;
        return false;
    };
    /** to get lineitem display name */ const getSelectedLineItemName = (lineItemType)=>{
        let name = "";
        switch(lineItemType){
            case (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).USER:
                name = nodeData[0, $271c8dec800e3a4d$export$46f21910265caffc];
                break;
            case (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).ACCOUNT:
                name = nodeData[0, $271c8dec800e3a4d$export$b21a97077b446a0c];
                break;
            case (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).ROLE:
                name = nodeData[0, $271c8dec800e3a4d$export$ef258f55852583b5];
                break;
            case (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).ENTITLEMENT:
                name = nodeData[0, $271c8dec800e3a4d$export$8e9b5a553c0ae9b2];
                break;
            default:
                break;
        }
        return name;
    };
    const getReassignModal = ()=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
            onClose: ()=>{
                setIsOpen(false);
                setIsReassignModalOpen();
            },
            className: "CertsReassignModal-wrapper",
            isOpen: isOpen,
            title: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "CertsReassignModal-headerInfo",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "Reassign",
                        color: "neutral-1000",
                        size: "large"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Typography), {
                        kind: "h1",
                        className: "CertsReassignModal-title",
                        children: [
                            " ",
                            "Reassign"
                        ]
                    })
                ]
            }),
            subtitle: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                className: "CertsReassignModal-subtitle",
                kind: "body2",
                children: ` Assign the ${reassignModalDetails?.lineItemKind} and their associated items to another certifier, and
          provide a reason. Any approvals or rejections will be cleared upon
          reassignment.`
            }),
            contentBody: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "CertsReassignModal-container",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "CertsReassignModal-containerHeader",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$AlertBanner), {
                                className: "reassignCertifier-selectionWarn",
                                colorTheme: "Critical",
                                title: "Error",
                                description: errorMessage,
                                isVisible: isVisible,
                                onCancel: onCancel,
                                autoDismissDelay: 4000
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "h4",
                                className: "CertsReassignModal-containerTitle",
                                children: `Selected ${reassignModalDetails.lineItemKind}`
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                className: "CertsReassignModal-container-userDetails",
                                children: [
                                    isCertsKindUser ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Avatar), {
                                        size: "small"
                                    }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                        kind: (0, $4c1aa6449628783a$export$c40b9342a19db0b6)(nodeData),
                                        color: "navy-900",
                                        size: "smallMedium"
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                        kind: "h4",
                                        className: "CertsReassignModal-container-userDetailsName",
                                        children: getSelectedLineItemName(reassignModalDetails?.lineItemKind)
                                    })
                                ]
                            }),
                            reassignModalDetails?.isIncludeAssociatedEnt && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "CertsReassignModal-includeCheckbox",
                                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                                    name: "checkbox2",
                                    kind: "text",
                                    dataTestId: "checkbox2",
                                    isChecked: isIncludeAssociateChecked,
                                    onChange: (event)=>{
                                        setIsIncludedAssociateChecked(event.target.checked);
                                    },
                                    label: reassignModalDetails?.isIncludeAsscLabel,
                                    labelPosition: "before"
                                })
                            }),
                            reassignModalDetails?.isNoteRequired && /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                className: "CertsReassignModal-containerNote",
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                        kind: "Info",
                                        color: "indigo-800",
                                        className: "CertsReassignModal-containerNoteIcon"
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                        kind: "body3",
                                        className: "CertsReassignModal-containerNoteText",
                                        children: `Access items associated with this ${reassignModalDetails?.lineItemKind} are included.`
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "CertsReassignModal-containerCertifierSelection",
                        children: [
                            !isSkipCertifierChecked && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "CertsReassignModal-DropdownAsterisk",
                                children: "*"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "h4",
                                className: "CertsReassignModal-container-certifier",
                                children: "Select Certifier"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $56a81ce622cfab5e$export$2e2bcd8739ae039), {
                                list: list,
                                className: dropdownClassName,
                                defaultReassignee: reassignConfigMap?.defaultReassignee,
                                defaultAssigneName: reassignConfigMap?.defaultReassigneeName,
                                onSelect: (user)=>{
                                    setSelectedUser(user);
                                }
                            }),
                            reassignModalDetails?.isSkipReassignment && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                                className: "CertsReassignModal-skipReassignCheckbox",
                                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                                    name: "simpleText",
                                    kind: "simpleText",
                                    dataTestId: "simpleText",
                                    isDisabled: !!selectedUser?.value,
                                    isChecked: isSkipCertifierChecked,
                                    onChange: (event)=>{
                                        setIsSkipCertifierChecked(event.target.checked);
                                    },
                                    label: "Skip selecting certifier",
                                    textPosition: "after",
                                    showHoverEffect: true
                                })
                            })
                        ]
                    }),
                    isCommentRequired && /*#__PURE__*/ (0, $hopDi$jsx)((0, $b3efe2b33729b6d5$export$2e2bcd8739ae039), {
                        defaultComments: commentsDetails?.predefComments,
                        showAlert: commentsDetails.showAlert,
                        onChange: handleCommentDescription,
                        className: "CertsReassignModal-comments"
                    })
                ]
            }),
            FooterActionBarComp: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$FooterActionBar), {
                className: "CertsReassignModal-footer",
                size: "large",
                children: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "CertsReassignModal-actionButtons",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: "ghost",
                            size: "medium",
                            isDisabled: isActionLoading,
                            onClick: ()=>{
                                setIsReassignModalOpen(false);
                            },
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            className: "CertsReassignModal-submitButton",
                            type: "button",
                            kind: isBtnEnabled() ? "filled" : "ghost",
                            size: "medium",
                            onClick: handleSubmit,
                            rightIcon: isActionLoading ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                                kind: "loop",
                                format: "inline",
                                color: "brand"
                            }) : null,
                            isDisabled: !isBtnEnabled(),
                            children: "Submit"
                        })
                    ]
                })
            })
        });
    return /*#__PURE__*/ (0, $hopDi$jsxs)("section", {
        children: [
            !isReassignWarnModalOpen && getReassignModal(),
            isReassignWarnModalOpen && /*#__PURE__*/ (0, $hopDi$jsx)((0, $e2c36875a8ec4133$export$2e2bcd8739ae039), {
                isReassignWarnModalOpen: isReassignWarnModalOpen,
                isActionLoading: isActionLoading,
                handleClose: ()=>{
                    setIsReassignWarnModalOpen(false);
                    setIsReassignModalOpen(false);
                },
                errorMessage: errorMessage,
                handleWarnModal: handleSubmit
            })
        ]
    });
}
var $7de18020df34e39a$export$2e2bcd8739ae039 = $7de18020df34e39a$var$CertsReassignModal;





/* eslint-disable no-unused-vars */ /* eslint-disable react/jsx-curly-spacing */ /* eslint-disable react/jsx-wrap-multilines */ 








function $ce7e60e33da3b7cd$var$FieldSet({ fieldData: fieldData, type: type, isBlank: isBlank }) {
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: type === "compact" ? "FieldSet-fieldset--compact" : "FieldSet-fieldset",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                kind: "body3",
                className: "FieldSet-fieldsetLabel",
                children: fieldData.label
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                kind: "body2",
                className: isBlank ? "FieldSet-fieldsetValue--blank" : "FieldSet-fieldsetValue--filled",
                children: fieldData.value
            })
        ]
    });
}
$ce7e60e33da3b7cd$var$FieldSet.propTypes = {
    fieldData: (0, $hopDi$proptypes).shape({
        label: (0, $hopDi$proptypes).oneOf((0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string, (0, $hopDi$proptypes).number)),
        value: (0, $hopDi$proptypes).oneOf((0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string, (0, $hopDi$proptypes).number))
    }).isRequired,
    type: (0, $hopDi$proptypes).string,
    isBlank: (0, $hopDi$proptypes).bool
};
$ce7e60e33da3b7cd$var$FieldSet.defaultProps = {
    type: "",
    isBlank: false
};
var $ce7e60e33da3b7cd$export$2e2bcd8739ae039 = $ce7e60e33da3b7cd$var$FieldSet;


var $5d9478e6fefd4bf2$export$2e2bcd8739ae039 = (0, $ce7e60e33da3b7cd$export$2e2bcd8739ae039);





function $ee8b26c91bf27a5f$var$HLine() {
    return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
        className: "HLine"
    });
}
var $ee8b26c91bf27a5f$export$2e2bcd8739ae039 = $ee8b26c91bf27a5f$var$HLine;


var $030549388b36232f$export$2e2bcd8739ae039 = (0, $ee8b26c91bf27a5f$export$2e2bcd8739ae039);


/* eslint-disable react/prop-types */ 








const $38068f3c89a53550$export$b87f371cbc396fcf = {
    fill: "fill",
    outline: "outline"
};
const $38068f3c89a53550$export$60454f4d269823bb = {
    success: {
        icon: "success-700",
        fill: "#028329",
        outline: "#43A34D",
        overRideIconColor: false
    },
    critical: {
        icon: "critical-700",
        fill: "#CC1C10",
        outline: "#EF5955",
        overRideIconColor: false
    },
    normal: {
        icon: "navy-700",
        fill: "#254B86",
        outline: "#6888B5",
        overRideIconColor: false
    },
    sod: {
        icon: "neutral-000",
        fill: "#F6A91C",
        outline: "#F6A91C",
        overRideIconColor: false
    },
    sodFunctions: {
        icon: "warning-900",
        fill: "#FFF1D9",
        outline: "#5C3C00",
        overRideIconColor: true
    },
    list: {
        icon: "neutral-1000",
        fill: "#F2F4F8",
        outline: "#212328",
        overRideIconColor: true
    }
};



function $e96946baab6dc3a3$var$SpbTimeLine({ bgColor: bgColor, type: type, kind: kind, iconKind: iconKind, iconSize: iconSize, iconColor: iconColor, showTail: showTail, className: className }) {
    const DASHED_FILLER_BLOCK_COUNT = 10;
    const spbTimeLineClass = (0, $hopDi$classnames)("SpbTimeLine", className);
    const spbTimeLineIconClass = (0, $hopDi$classnames)("SpbTimeLine-icon", iconSize === "xxxSmall" ? "SpbTimeLine-icon--small" : "SpbTimeLine-icon--large");
    const iconStyle = {
        backgroundColor: type === (0, $38068f3c89a53550$export$b87f371cbc396fcf).fill ? bgColor || (0, $38068f3c89a53550$export$60454f4d269823bb)[kind].fill : "white",
        border: type === (0, $38068f3c89a53550$export$b87f371cbc396fcf).outline ? `1px solid ${bgColor || (0, $38068f3c89a53550$export$60454f4d269823bb)[kind].outline}` : "none"
    };
    const renderSpbTimeLineTail = ()=>{
        if (showTail && type === (0, $38068f3c89a53550$export$b87f371cbc396fcf).fill) return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
            className: "SpbTimeLine-tail--normal"
        });
        if (showTail && type === (0, $38068f3c89a53550$export$b87f371cbc396fcf).outline) return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
            className: "SpbTimeLine-tail--dashed",
            children: [
                ...Array(DASHED_FILLER_BLOCK_COUNT).keys()
            ].map((key)=>/*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "SpbTimeLine-tailDashedBlocks"
                }, key))
        });
        return /*#__PURE__*/ (0, $hopDi$jsx)("span", {});
    };
    const iconColorValue = iconColor || (type === (0, $38068f3c89a53550$export$b87f371cbc396fcf).fill && !(0, $38068f3c89a53550$export$60454f4d269823bb)[kind].overRideIconColor ? "neutral-000" : (0, $38068f3c89a53550$export$60454f4d269823bb)[kind].icon);
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: spbTimeLineClass,
        children: [
            renderSpbTimeLineTail(),
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                style: iconStyle,
                className: spbTimeLineIconClass,
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: iconKind,
                    size: iconSize,
                    color: iconColorValue
                })
            })
        ]
    });
}
$e96946baab6dc3a3$var$SpbTimeLine.propTypes = {
    bgColor: (0, $hopDi$proptypes).string,
    type: (0, $hopDi$proptypes).oneOf(Object.values((0, $38068f3c89a53550$export$b87f371cbc396fcf))),
    kind: (0, $hopDi$proptypes).oneOf(Object.keys((0, $38068f3c89a53550$export$60454f4d269823bb))),
    iconKind: (0, $hopDi$proptypes).string.isRequired,
    iconSize: (0, $hopDi$proptypes).string,
    iconColor: (0, $hopDi$proptypes).string,
    showTail: (0, $hopDi$proptypes).bool,
    className: (0, $hopDi$proptypes).string
};
$e96946baab6dc3a3$var$SpbTimeLine.defaultProps = {
    bgColor: null,
    type: (0, $38068f3c89a53550$export$b87f371cbc396fcf).fill,
    kind: "normal",
    iconSize: "xSmall",
    iconColor: null,
    showTail: true,
    className: ""
};
var $e96946baab6dc3a3$export$2e2bcd8739ae039 = $e96946baab6dc3a3$var$SpbTimeLine;


var $596ca118e64bea36$export$2e2bcd8739ae039 = (0, $e96946baab6dc3a3$export$2e2bcd8739ae039);



const $6324724ae4ae52e1$var$PAD = {
    sod: "sod",
    privileges: "privileges"
};
function $6324724ae4ae52e1$var$SimpleAccordion({ title: title, children: children, isInitialOpen: isInitialOpen, iconKind: iconKind = "Entitlement", kind: kind, pad: pad }) {
    const [isOpen, setIsOpen] = (0, $hopDi$useState)(isInitialOpen);
    const toggleAccordion = ()=>{
        setIsOpen(!isOpen);
    };
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: pad === $6324724ae4ae52e1$var$PAD.privileges ? "SimpleAccordion--privileges" : "SimpleAccordion--sod",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "SimpleAccordion-header",
                onClick: toggleAccordion,
                onKeyUp: ()=>{},
                role: "button",
                tabIndex: 0,
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "SimpleAccordion-headerTitle",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $596ca118e64bea36$export$2e2bcd8739ae039), {
                                iconKind: iconKind,
                                kind: kind,
                                type: "fill",
                                showTail: false
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "h4",
                                className: isOpen ? "SimpleAccordion-headerTitleText--expanded" : "SimpleAccordion-headerTitleText--closed",
                                children: title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: isOpen ? "SimpleAccordion-headerIcon--open" : "SimpleAccordion-headerIcon--closed",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "ChevronDown",
                            size: "small",
                            color: "neutral-800"
                        })
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "SimpleAccordion-body",
                children: children
            })
        ]
    });
}
$6324724ae4ae52e1$var$SimpleAccordion.propTypes = {
    title: (0, $hopDi$proptypes).string.isRequired,
    children: (0, $hopDi$proptypes).node.isRequired,
    iconKind: (0, $hopDi$proptypes).string,
    kind: (0, $hopDi$proptypes).string,
    isInitialOpen: (0, $hopDi$proptypes).bool,
    pad: (0, $hopDi$proptypes).oneOf(Object.values($6324724ae4ae52e1$var$PAD))
};
$6324724ae4ae52e1$var$SimpleAccordion.defaultProps = {
    iconKind: "Entitlement",
    kind: "list",
    isInitialOpen: false,
    pad: $6324724ae4ae52e1$var$PAD.sod
};
var $6324724ae4ae52e1$export$2e2bcd8739ae039 = $6324724ae4ae52e1$var$SimpleAccordion;


var $b291d00926535dc7$export$2e2bcd8739ae039 = (0, $6324724ae4ae52e1$export$2e2bcd8739ae039);








function $a7a9aa6df366a012$var$SODItem({ sodItem: sodItem }) {
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "SODItem",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $596ca118e64bea36$export$2e2bcd8739ae039), {
                iconKind: "JobFunctions",
                type: "fill",
                kind: "sodFunctions",
                showTail: false
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)("span", {
                className: "SODItem-details",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body2",
                        className: "SODItem-detailsTitle",
                        children: sodItem.label
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body3",
                        className: "SODItem-detailsDescription",
                        children: sodItem.description
                    })
                ]
            })
        ]
    });
}
$a7a9aa6df366a012$var$SODItem.propTypes = {
    sodItem: (0, $hopDi$proptypes).shape({
        label: (0, $hopDi$proptypes).string,
        description: (0, $hopDi$proptypes).string
    }).isRequired,
    label: (0, $hopDi$proptypes).string
};
$a7a9aa6df366a012$var$SODItem.defaultProps = {
    label: ""
};
var $a7a9aa6df366a012$export$2e2bcd8739ae039 = $a7a9aa6df366a012$var$SODItem;


var $55f6aa546a60d23d$export$2e2bcd8739ae039 = (0, $a7a9aa6df366a012$export$2e2bcd8739ae039);






var $1d9c427fd8513765$export$2e2bcd8739ae039 = (0, $20281fe09bc700a8$export$170ce1a49c989948);




function $55a45c22e6a9ad42$var$CertsRejectAction({ autoRevoke: autoRevoke, commentStatus: commentStatus, handleClick: handleClick, isLoading: isLoading, getTypeActEntRole: getTypeActEntRole, placement: placement, trigger: trigger, isRejectPopoverOpen: isRejectPopoverOpen, setIsRejectPopoverOpen: setIsRejectPopoverOpen }) {
    const [isCritical, setIsCritical] = (0, $hopDi$useState)(false);
    const [commentValue, setCommentValue] = (0, $hopDi$useState)("");
    const isCommentValid = Boolean(isCritical || commentValue?.replace(/[<>]/g, "")?.trim()?.length < 3);
    const checkComments = ()=>{
        if (isCommentValid) setIsCritical(!isCritical);
        else handleClick(commentValue);
    };
    const handleCommentText = (text)=>{
        setCommentValue(text);
    };
    const withRequiredComments = (check)=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
            className: "CertsActionPopover Certs-Reject-Popover-commentsWrap",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "Certs-Reject-Action-header-wrap",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "RejectHelp"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Typography), {
                            className: "Certs-Reject-Popover-commentsTitle",
                            kind: "label",
                            children: [
                                (0, $1d9c427fd8513765$export$2e2bcd8739ae039).TITLE,
                                ` ${getTypeActEntRole}?`
                            ]
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                            size: "medium",
                            isDisabled: isLoading,
                            kind: "ghost",
                            tabIndex: -1,
                            icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: "close",
                                color: "neutral-1000",
                                size: "smallMedium"
                            }),
                            onClick: ()=>setIsRejectPopoverOpen(false)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $b3efe2b33729b6d5$export$2e2bcd8739ae039), {
                    defaultComments: (0, $1d9c427fd8513765$export$2e2bcd8739ae039).COMMENTS_CHIPS,
                    showAlert: isCritical,
                    onChange: handleCommentText,
                    className: "Certs-Reject-Popover-commentsBoxWrap"
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    tag: "div",
                    className: "CertsActionPopover-controls",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: "ghost",
                            isDisabled: isLoading,
                            onClick: ()=>setIsRejectPopoverOpen(false),
                            children: (0, $1d9c427fd8513765$export$2e2bcd8739ae039).CANCELBUTTON
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            isDisabled: isLoading,
                            kind: !isCommentValid ? "filled" : "outlined",
                            onClick: ()=>checkComments(),
                            children: (0, $1d9c427fd8513765$export$2e2bcd8739ae039).PRIMARYBUTTON
                        })
                    ]
                })
            ]
        });
    const withAutoRevoke = (check)=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
            className: "CertsRejectActionPopover",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    variant: "h3",
                    className: "Certs-Reject-Popover-desc",
                    children: (0, $1d9c427fd8513765$export$2e2bcd8739ae039).DESC
                }),
                check && /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "Certs-Reject-Popover-NoteWrapper Certs-Reject-Popover-note",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)("b", {
                            className: "Certs-Reject-Popover-NoteText",
                            children: "Important: "
                        }),
                        (0, $1d9c427fd8513765$export$2e2bcd8739ae039).NOTE
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    tag: "div",
                    className: "CertsActionPopover-controls",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: "ghost",
                            isDisabled: isLoading,
                            onClick: ()=>setIsRejectPopoverOpen(false),
                            children: (0, $1d9c427fd8513765$export$2e2bcd8739ae039).CANCELBUTTON
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            isDisabled: isLoading,
                            type: "button",
                            kind: "filled",
                            onClick: ()=>handleClick(""),
                            children: (0, $1d9c427fd8513765$export$2e2bcd8739ae039).SECONDARYBUTTON
                        })
                    ]
                })
            ]
        });
    const getRejectActionPopover = ()=>// TODO: Don't delete this code, might need in the future
        // if (autoRevoke) {
        //   return commentStatus ? withRequiredComments(true) : withAutoRevoke(true);
        // }
        // return commentStatus ? withRequiredComments(false) : withAutoRevoke(false);
        commentStatus ? withRequiredComments(true) : withRequiredComments(false);
    const getContent = ()=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            tag: "div",
            className: "CertsActionPopover-contextWrapper",
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Popover), {
                placement: placement,
                trigger: trigger,
                popoverContent: getRejectActionPopover(),
                isOpen: isRejectPopoverOpen,
                setIsOpen: setIsRejectPopoverOpen
            })
        });
    return isRejectPopoverOpen && /*#__PURE__*/ (0, $hopDi$jsx)("section", {
        className: "Certs-Reject-Action-Popover-wrapper",
        children: getContent()
    });
}
var $55a45c22e6a9ad42$export$2e2bcd8739ae039 = $55a45c22e6a9ad42$var$CertsRejectAction;


var $813c5abc50980873$export$2e2bcd8739ae039 = (0, $55a45c22e6a9ad42$export$2e2bcd8739ae039);








const $2c1dfa662a05ff16$var$TextMapping = {
    [(0, $20281fe09bc700a8$export$3f43cf8434698562).APPROVE]: {
        title: "Reasons for Smart Approval",
        buttonText: "Cancel Approval",
        iconKind: "CheckCircleOutline"
    },
    [(0, $20281fe09bc700a8$export$3f43cf8434698562).REJECT]: {
        title: "Reasons for Smart Rejection",
        buttonText: "Cancel Rejection",
        iconKind: "AlertCriticalOutline",
        color: "critical-500"
    }
};
function $2c1dfa662a05ff16$var$CertsSaviActionPopover({ kind: kind, handleClick: handleClick, onClose: onClose, isOpen: isOpen, trigger: trigger, placement: placement, saviRespondedReason: saviRespondedReason }) {
    // TODO: API integration pending
    const getPopoverContent = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
            className: "Savi-Companion-Action-Popover--ContentWrapper",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "Savi-Companion-Action-Popover--DisplayFlex",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "SaviCompanion",
                            size: "medium"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "h3",
                            children: $2c1dfa662a05ff16$var$TextMapping[kind].title
                        })
                    ]
                }),
                saviRespondedReason && saviRespondedReason.length > 0 ? saviRespondedReason.map((reason)=>/*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "Savi-Companion-Action-Popover--DisplayFlex Reasons",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                    kind: $2c1dfa662a05ff16$var$TextMapping[kind].iconKind,
                                    color: $2c1dfa662a05ff16$var$TextMapping[kind].color,
                                    size: "xSmall"
                                })
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body2",
                                children: reason
                            })
                        ]
                    })) : /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "Savi-Companion-Action-Popover--DisplayFlex Reasons",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body2",
                        children: "No data available"
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "Savi-Companion-Action-Popover--DisplayFlex Action-Button-Wrapper",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: "subtle",
                            size: "large",
                            onClick: ()=>handleClick(""),
                            children: $2c1dfa662a05ff16$var$TextMapping[kind].buttonText
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            className: "Action-Button--MarginLeft-Auto",
                            type: "button",
                            kind: "filled",
                            size: "large",
                            onClick: ()=>onClose(false),
                            children: "Got It"
                        })
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0, $hopDi$jsx)("section", {
        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            tag: "div",
            className: "CertsActionPopover-contextWrapper",
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Popover), {
                trigger: trigger,
                popoverContent: getPopoverContent(),
                isOpen: isOpen,
                setIsOpen: onClose,
                placement: placement
            })
        })
    });
}
var $2c1dfa662a05ff16$export$2e2bcd8739ae039 = $2c1dfa662a05ff16$var$CertsSaviActionPopover;


var $ac46cb6010681c0d$export$2e2bcd8739ae039 = (0, $2c1dfa662a05ff16$export$2e2bcd8739ae039);






var $13730356a2f65477$export$2e2bcd8739ae039 = (0, $20281fe09bc700a8$export$523985e6ca7aa3bf);



function $4bbca83a32795fb9$var$CertsTerminateModal({ autoRevoke: autoRevoke, commentStatus: commentStatus, handleClick: handleClick, handleCancel: handleCancel, isLoading: isLoading, isTerminateError: isTerminateError, setIsTerminateError: setIsTerminateError }) {
    const [isOpen, setIsOpen] = (0, $hopDi$useState)(true);
    const [isCritical, setIsCritical] = (0, $hopDi$useState)(false);
    const [inputValue, setInputValue] = (0, $hopDi$useState)("");
    const isCommentValid = Boolean(isCritical || inputValue?.replace(/[<>]/g, "")?.trim()?.length < 3);
    const checkComments = ()=>{
        if (isCommentValid) setIsCritical(true);
        else handleClick(inputValue);
    };
    const handleClose = ()=>{
        setIsOpen(false);
        setIsTerminateError(false);
        handleCancel();
    };
    const withoutAutoRevokeWithComments = ()=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
            className: "Certs-Terminate-Modal-wrapper CertsTerminateModal-withComments",
            onClose: ()=>handleClose(),
            isOpen: isOpen,
            title: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "Certs-Terminate-Modal-TitleWrapper",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "AlertWarningFilledSeparateColors",
                        className: `ModalIsland-alertContent-icon CertsTerminateModal-alertIcon${isLoading}` && "Certs-Terminate-Modal-isCrossIconDisabled"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "CertsTerminateModal-commentsTitle",
                        children: (0, $13730356a2f65477$export$2e2bcd8739ae039).TITLE
                    })
                ]
            }),
            subtitle: /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "CertsTerminateModal-commentsDescription",
                children: (0, $13730356a2f65477$export$2e2bcd8739ae039).DESC
            }),
            contentBody: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$AlertBanner), {
                        colorTheme: "Critical",
                        title: "Data Fetch Error",
                        description: "Terminate Action failed, please try again.",
                        isVisible: isTerminateError,
                        onCancel: ()=>setIsTerminateError(false),
                        isColonVisible: true,
                        isFloating: true,
                        shouldAutoDismiss: true,
                        autoDismissDelay: 4000
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InputField), {
                        name: "basic",
                        placeholder: (0, $13730356a2f65477$export$2e2bcd8739ae039).PLACEHOLDER,
                        label: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "label",
                            htmlFor: "Required",
                            children: "Comments"
                        }),
                        value: inputValue,
                        setValue: setInputValue,
                        kind: "multiline",
                        isCritical: isCritical,
                        setIsCritical: setIsCritical,
                        isRequired: true,
                        minRequiredChars: 3,
                        CriticalHelperText: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InlineMessage), {
                            kind: "missingRequiredField",
                            size: "small"
                        })
                    })
                ]
            }),
            FooterActionBarComp: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$FooterActionBar), {
                className: "ModalPage-footer",
                size: "large",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {}),
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "Certs-Terminate-Modal-TitleWrapper",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                                type: "button",
                                kind: "ghost",
                                size: "medium",
                                isDisabled: isLoading,
                                onClick: ()=>{
                                    setIsOpen(false);
                                    handleCancel();
                                },
                                children: (0, $13730356a2f65477$export$2e2bcd8739ae039).SECONDARYBUTTON
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                                type: "button",
                                kind: isLoading ? "filled" : "outlined",
                                size: "medium",
                                isDisabled: isLoading,
                                className: "CertsTerminateModal-terminateButton",
                                rightIcon: isLoading ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                                    kind: "loop",
                                    format: "inline",
                                    color: "brand"
                                }) : null,
                                onClick: ()=>checkComments(),
                                children: (0, $13730356a2f65477$export$2e2bcd8739ae039).PRIMARYBUTTON
                            })
                        ]
                    })
                ]
            })
        });
    const withAutoRevokeWithComments = ()=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
            className: "Certs-Terminate-Modal-wrapper CertsTerminateModal-withComments",
            onClose: ()=>handleClose(),
            isOpen: isOpen,
            title: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "Certs-Terminate-Modal-TitleWrapper",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "AlertCriticalFilledSeparateColors",
                        className: "ModalIsland-alertContent-icon CertsTerminateModal-alertIcon"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "CertsTerminateModal-commentsTitle",
                        children: (0, $13730356a2f65477$export$2e2bcd8739ae039).TITLE
                    })
                ]
            }),
            subtitle: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "CertsTerminateModal-commentsDescription",
                children: [
                    (0, $13730356a2f65477$export$2e2bcd8739ae039).DESC,
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "Certs-Terminate-Modal-NoteWrapper",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)("b", {
                                className: "Certs-Terminate-Modal-NoteText",
                                children: "Important: "
                            }),
                            (0, $13730356a2f65477$export$2e2bcd8739ae039).NOTE
                        ]
                    })
                ]
            }),
            contentBody: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$AlertBanner), {
                        colorTheme: "Critical",
                        title: "Data Fetch Error",
                        description: "Terminate Action failed, please try again.",
                        isVisible: isTerminateError,
                        onCancel: ()=>setIsTerminateError(false),
                        isColonVisible: true,
                        isFloating: true,
                        shouldAutoDismiss: true,
                        autoDismissDelay: 4000
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InputField), {
                        name: "basic",
                        placeholder: (0, $13730356a2f65477$export$2e2bcd8739ae039).PLACEHOLDER,
                        label: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "label",
                            htmlFor: "Required",
                            children: "Comments"
                        }),
                        value: inputValue,
                        setValue: setInputValue,
                        kind: "multiline",
                        isRequired: true,
                        minRequiredChars: 3,
                        isCritical: isCritical,
                        setIsCritical: setIsCritical,
                        CriticalHelperText: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InlineMessage), {
                            kind: "missingRequiredField",
                            size: "small"
                        })
                    })
                ]
            }),
            FooterActionBarComp: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$FooterActionBar), {
                className: "ModalPage-footer",
                size: "large",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {}),
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "Certs-Terminate-Modal-TitleWrapper",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                                type: "button",
                                kind: "ghost",
                                size: "medium",
                                onClick: ()=>{
                                    setIsOpen(false);
                                    handleCancel();
                                },
                                children: (0, $13730356a2f65477$export$2e2bcd8739ae039).SECONDARYBUTTON
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                                type: "button",
                                kind: isLoading ? "filled" : "outlined",
                                size: "medium",
                                isDisabled: isLoading,
                                className: "CertsTerminateModal-button",
                                rightIcon: isLoading ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                                    kind: "loop",
                                    format: "inline",
                                    color: "brand"
                                }) : null,
                                onClick: ()=>checkComments(),
                                children: (0, $13730356a2f65477$export$2e2bcd8739ae039).PRIMARYBUTTON
                            })
                        ]
                    })
                ]
            })
        });
    const withoutAutoRevokeNoComments = ()=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
            className: "Certs-Terminate-Modal-wrapper",
            kind: "warning",
            alertTitle: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$AlertBanner), {
                        colorTheme: "Critical",
                        title: "Data Fetch Error",
                        description: "Please try again.",
                        isVisible: isTerminateError,
                        onCancel: ()=>setIsTerminateError(false),
                        isColonVisible: true,
                        isFloating: true,
                        shouldAutoDismiss: true,
                        autoDismissDelay: 4000
                    }),
                    (0, $13730356a2f65477$export$2e2bcd8739ae039).TITLE
                ]
            }),
            alertSubtitle: (0, $13730356a2f65477$export$2e2bcd8739ae039).DESC,
            onClose: ()=>handleClose(),
            isOpen: isOpen,
            primaryButton: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                type: "button",
                kind: isLoading ? "filled" : "outlined",
                size: "medium",
                isDisabled: isLoading,
                rightIcon: isLoading ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                    kind: "loop",
                    format: "inline",
                    color: "brand"
                }) : null,
                onClick: ()=>handleClick("Terminate User"),
                children: (0, $13730356a2f65477$export$2e2bcd8739ae039).PRIMARYBUTTON
            }),
            secondaryButton: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                type: "button",
                kind: "ghost",
                size: "medium",
                onClick: ()=>{
                    setIsOpen(false);
                    handleCancel();
                },
                children: (0, $13730356a2f65477$export$2e2bcd8739ae039).SECONDARYBUTTON
            })
        });
    const withAutoRevokeNoComments = ()=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
            className: "Certs-Terminate-Modal-wrapper",
            kind: "critical",
            alertTitle: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$AlertBanner), {
                        colorTheme: "Critical",
                        title: "Data Fetch Error",
                        description: "Please try again.",
                        isVisible: isTerminateError,
                        onCancel: ()=>setIsTerminateError(false),
                        isColonVisible: true,
                        isFloating: true,
                        shouldAutoDismiss: true,
                        autoDismissDelay: 4000
                    }),
                    (0, $13730356a2f65477$export$2e2bcd8739ae039).TITLE
                ]
            }),
            alertSubtitle: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                children: [
                    (0, $13730356a2f65477$export$2e2bcd8739ae039).DESC,
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "Certs-Terminate-Modal-NoteWrapper",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)("b", {
                                className: "Certs-Terminate-Modal-NoteText",
                                children: "Important: "
                            }),
                            (0, $13730356a2f65477$export$2e2bcd8739ae039).NOTE
                        ]
                    })
                ]
            }),
            onClose: ()=>handleClose(),
            isOpen: isOpen,
            primaryButton: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                type: "button",
                kind: isLoading ? "filled" : "outlined",
                size: "medium",
                isDisabled: isLoading,
                className: "CertsTerminateModal-button",
                rightIcon: isLoading ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                    kind: "loop",
                    format: "inline",
                    color: "brand"
                }) : null,
                onClick: ()=>handleClick("Terminate User"),
                children: (0, $13730356a2f65477$export$2e2bcd8739ae039).PRIMARYBUTTON
            }),
            secondaryButton: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                type: "button",
                kind: "ghost",
                size: "medium",
                onClick: ()=>{
                    setIsOpen(false);
                    handleCancel();
                },
                children: (0, $13730356a2f65477$export$2e2bcd8739ae039).SECONDARYBUTTON
            })
        });
    const getModalContent = ()=>{
        if (autoRevoke) return commentStatus ? withAutoRevokeWithComments() : withAutoRevokeNoComments();
        return commentStatus ? withoutAutoRevokeWithComments() : withoutAutoRevokeNoComments();
    };
    return /*#__PURE__*/ (0, $hopDi$jsx)("section", {
        children: getModalContent()
    });
}
var $4bbca83a32795fb9$export$2e2bcd8739ae039 = $4bbca83a32795fb9$var$CertsTerminateModal;


var $e5ef58c6194a06e4$export$2e2bcd8739ae039 = (0, $4bbca83a32795fb9$export$2e2bcd8739ae039);



/* eslint-disable import/prefer-default-export */ const $687791ac9134434b$export$a49393e96e2bf605 = (config)=>{
    if (config.enableReassignUser === "1" || config.SHOWREASSIGNPOPUP === "1") return true;
    return false;
};
const $687791ac9134434b$export$a5f2d48f68b29e88 = (config)=>{
    if (config.enableReassignUser === "0" && config.showReassignPopup === "0") return true;
    return false;
};



const $57da59531dca7c37$var$defaultTooltipProps = {
    text: "",
    maxWidth: "12rem",
    placement: "bottom"
};
function $57da59531dca7c37$var$CertsActionButton({ id: id, setIsActionPopoverOpen: setIsActionPopoverOpen, kind: kind, groupKind: groupKind, tabIndex: tabIndex, isDisabled: isDisabled, isSelected: isSelected, isLoading: isLoading, isDecisionMade: isDecisionMade, isCommentRequired: isCommentRequired, isHidden: isHidden, onClick: onClick, isToolTipDisabled: isToolTipDisabled, tooltipProperties: tooltipProperties, dataTheme: dataTheme, dataTestId: dataTestId, getViewApiConfigmap: getViewApiConfigmap, extendEndDateDaysLimit: extendEndDateDaysLimit, nodeData: nodeData, isActionSuccess: isActionSuccess, isActionError: isActionError, getTypeActEntRole: getTypeActEntRole, isSidePanelVisible: isSidePanelVisible, reassignConfigMap: reassignConfigMap, getFirstTimeReject: getFirstTimeReject, certificationStartDate: certificationStartDate, isActionErrorMessage: isActionErrorMessage, conditionalCertifyDaysLimit: conditionalCertifyDaysLimit, isPopoverUserReassignMsgShown: isPopoverUserReassignMsgShown, setReassignUserPopoverMsg: setReassignUserPopoverMsg, isSaviResponded: isSaviResponded, saviRespondedReason: saviRespondedReason }) {
    const [isCommentPopoverOpen, setIsCommentPopoverOpen] = (0, $hopDi$useState)(false);
    const [isReassignPopoverOpen, setIsReassignPopoverOpen] = (0, $hopDi$useState)(false);
    const [isRejectPopoverOpen, setIsRejectPopoverOpen] = (0, $hopDi$useState)(false);
    const [checkTerminateClick, setIsCheckTerminateClick] = (0, $hopDi$useState)(false);
    const [getIsTerminateError, setIsTerminateError] = (0, $hopDi$useState)(false);
    const [isExtendEndDateClick, setIsExtendEndDateClick] = (0, $hopDi$useState)(false);
    const [getIsExtendEndDateError, setIsExtendEndDateError] = (0, $hopDi$useState)(false);
    const [isConditionalCertifyClick, setIsConditionalCertifyClick] = (0, $hopDi$useState)(false);
    const [getIsConditionalCertifyError, setIsConditionalCertifyError] = (0, $hopDi$useState)(false);
    const [getCurrentDate, setCurrentDate] = (0, $hopDi$useState)(false);
    const [getIsRejectError, setIsRejectError] = (0, $hopDi$useState)(false);
    const [isSaviApprovePopoverOpen, setIsSaviApprovePopoverOpen] = (0, $hopDi$useState)(false);
    const [isSaviRejectPopoverOpen, setIsSaviRejectPopoverOpen] = (0, $hopDi$useState)(false);
    (0, $hopDi$useEffect)(()=>{
        // changing the current date format from yyyy-mm-dd to mm/dd/yyyy format
        if (nodeData?.User_ENDDATE && nodeData?.User_ENDDATE?.length > 0) {
            let getDate = nodeData?.User_ENDDATE?.split(" ")[0]?.split("-");
            getDate = `${getDate[1]}/${getDate[2]}/${getDate[0]}`;
            setCurrentDate(getDate);
        } else setCurrentDate("Not Provided");
    }, []);
    const [isReassignModalOpen, setIsReassignModalOpen] = (0, $hopDi$useState)(false);
    const [reassignModalDetails, setReassignModalDetails] = (0, $hopDi$useState)(null);
    const [isConsultModalOpen, setIsConsultModalOpen] = (0, $hopDi$useState)(false);
    const [consultModalDetails, setconsultModalDetails] = (0, $hopDi$useState)(null);
    const { APPROVE: APPROVE, REJECT: REJECT, TERMINATE: TERMINATE, REASSIGN: REASSIGN, CONSULT: CONSULT, WORKS_FOR_ME: WORKS_FOR_ME, DOES_NOT_WORK_FOR_ME: DOES_NOT_WORK_FOR_ME, EXTEND_END_DATE: EXTEND_END_DATE, CONDITIONAL_CERTIFIY: CONDITIONAL_CERTIFIY } = (0, $20281fe09bc700a8$export$3f43cf8434698562);
    const isDisabledException = ()=>{
        switch(kind){
            case REASSIGN:
            case WORKS_FOR_ME:
            case DOES_NOT_WORK_FOR_ME:
                return true;
            default:
                return false;
        }
    };
    const isTileGroup = groupKind === (0, $20281fe09bc700a8$export$758743ec42a300f1).TILE && kind !== TERMINATE && kind !== EXTEND_END_DATE && // Eliminating Terminate and Extend End Date Action for Modal creation
    kind !== REJECT && // Eliminating Reject Action for Popover creation
    kind !== DOES_NOT_WORK_FOR_ME && // Eliminating Reassign action for user
    kind !== REASSIGN && // Eliminating Reassign action for Account, Role, Entitilement
    kind !== CONDITIONAL_CERTIFIY; // Eliminating Conditional Certify Action for Modal creation
    const isConfirmManagerOrApproveTileAndCommentRequired = (kind === WORKS_FOR_ME || kind === APPROVE && groupKind === (0, $20281fe09bc700a8$export$758743ec42a300f1).TILE) && isCommentRequired;
    const isReassignUser = kind === DOES_NOT_WORK_FOR_ME;
    const ActionButtonTooltipClasses = (0, $hopDi$classnames)("CertsActionButton-tooltip", isHidden && "CertsActionButton-tooltip--isHidden", isToolTipDisabled && "CertsActionButton-tooltip--shouldNotRender");
    const ActionButtonClasses = (0, $hopDi$classnames)("CertsActionButton", `CertsActionButton-${kind}`, isDisabledException() && "CertsActionButton--isDisabledException", isDisabled && "CertsActionButton--isDisabled", isSelected && "CertsActionButton--isSelected", isLoading && "CertsActionButton--isLoading", isDecisionMade && "CertsActionButton--isDecisionMade", isHidden && "CertsActionButton--isHidden");
    // Merge provided tooltipProperties with defaults
    const mergedTooltipProperties = {
        ...$57da59531dca7c37$var$defaultTooltipProps,
        ...tooltipProperties
    };
    const getPopoverPlacement = ()=>{
        if (groupKind === (0, $20281fe09bc700a8$export$758743ec42a300f1).FOOTER) return "top";
        return "left-start";
    };
    const getIconKind = ()=>{
        switch(kind){
            case APPROVE:
                return (0, $20281fe09bc700a8$export$506bde9fe967e89b).CHECK;
            case REJECT:
                return (0, $20281fe09bc700a8$export$506bde9fe967e89b).REJECT;
            case TERMINATE:
                return (0, $20281fe09bc700a8$export$506bde9fe967e89b).TERMINATE;
            case DOES_NOT_WORK_FOR_ME:
                return (0, $20281fe09bc700a8$export$506bde9fe967e89b).REASSIGN_USER;
            case REASSIGN:
                return (0, $20281fe09bc700a8$export$506bde9fe967e89b).REASSIGN_ITEM;
            case WORKS_FOR_ME:
                return (0, $20281fe09bc700a8$export$506bde9fe967e89b).CONFIRM_MANAGER;
            case EXTEND_END_DATE:
            case CONDITIONAL_CERTIFIY:
                return (0, $20281fe09bc700a8$export$506bde9fe967e89b).EXTEND_END_DATE;
            case CONSULT:
                return (0, $20281fe09bc700a8$export$506bde9fe967e89b).CONSULT;
            default:
                return (0, $20281fe09bc700a8$export$506bde9fe967e89b).CHECK;
        }
    };
    // Update the to let tile know to increase the z-index
    (0, $hopDi$useEffect)(()=>{
        if (isTileGroup) setIsActionPopoverOpen(isCommentPopoverOpen);
    }, [
        isCommentPopoverOpen
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (groupKind === (0, $20281fe09bc700a8$export$758743ec42a300f1).TILE && kind === REJECT) setIsActionPopoverOpen(isRejectPopoverOpen);
    }, [
        isRejectPopoverOpen
    ]);
    const getBorderIcon = ()=>{
        if (isSelected && isDecisionMade) return "CertsActionBtnSelectedBorderDash";
        return "CertsActionBtnSelectedBorderSolid";
    };
    (0, $hopDi$useEffect)(()=>{
        // Handling Error Banners on top of the Modals/Popovers based on Success or Error Action
        if (isActionSuccess) {
            if (kind === TERMINATE) {
                setIsCheckTerminateClick(false);
                setIsTerminateError(false);
            }
            if (kind === EXTEND_END_DATE) {
                setIsExtendEndDateClick(false);
                setIsExtendEndDateError(false);
            }
            if (kind === REJECT) {
                setIsRejectPopoverOpen(false);
                setIsRejectError(false);
            }
            if (kind === CONDITIONAL_CERTIFIY) {
                setIsConditionalCertifyClick(false);
                setIsConditionalCertifyError(false);
            }
            if (kind === APPROVE) setIsSaviApprovePopoverOpen(false);
        }
        if (isActionError) {
            if (kind === TERMINATE) setIsTerminateError(true);
            if (kind === EXTEND_END_DATE) setIsExtendEndDateError(true);
            if (kind === REJECT) setIsRejectError(true);
            if (kind === CONDITIONAL_CERTIFIY) setIsConditionalCertifyError(true);
        }
    }, [
        isActionSuccess,
        isActionError
    ]);
    const handleActionClick = ()=>{
        // // Set to open popover if required instead (handled isOpen set in CertsActionPopover)
        if (isCommentRequired && !isSelected && isTileGroup) return;
        // Handling Terminate Modal Ui events
        if (kind === TERMINATE) {
            if (!isSelected) {
                setIsCheckTerminateClick(true);
                setIsTerminateError(false);
                return;
            }
            setIsCheckTerminateClick(false);
            onClick();
            return;
        }
        // Handling Extend End Date Modal Ui events
        if (kind === EXTEND_END_DATE) {
            if (!isSelected) {
                setIsExtendEndDateClick(true);
                setIsExtendEndDateError(false);
                return;
            }
            setIsExtendEndDateClick(false);
            onClick();
            return;
        }
        // Handling Reject Popover Ui events
        if (kind === REJECT) {
            if (!isSelected && !isSidePanelVisible && isCommentRequired) {
                if (getFirstTimeReject || isCommentRequired) {
                    setIsRejectPopoverOpen(true);
                    setIsRejectError(false);
                    return;
                }
            }
            if (isSaviResponded) {
                setIsSaviRejectPopoverOpen(true);
                return;
            }
            setIsRejectPopoverOpen(false);
            onClick();
            return;
        }
        // Handling Conditional Certify Modal Ui events
        if (kind === CONDITIONAL_CERTIFIY) {
            if (!isSelected) {
                setIsConditionalCertifyClick(true);
                setIsConditionalCertifyError(false);
                return;
            }
            setIsConditionalCertifyClick(false);
            onClick();
            return;
        }
        if (kind === DOES_NOT_WORK_FOR_ME) {
            if (!isSelected) {
                if (isCommentRequired && isPopoverUserReassignMsgShown) {
                    handleReassignModal();
                    return;
                }
                // when Reassign modal and comments is not required
                if (!isCommentRequired) onClick();
                return;
            }
            onClick();
            return;
        }
        if (kind === REASSIGN) {
            if (!isSelected) {
                handleReassignModal();
                return;
            }
            onClick();
            return;
        }
        // don't open any modal for reassign user until first popover accepted by user
        if (kind === DOES_NOT_WORK_FOR_ME && !isPopoverUserReassignMsgShown) return;
        if (kind === CONSULT) {
            if (!isSelected) {
                handleConsultModal();
                return;
            }
            onClick();
            return;
        }
        if (kind === APPROVE) {
            if (isSaviResponded) {
                setIsSaviApprovePopoverOpen(true);
                return;
            }
        }
        onClick();
    };
    const handleReassignModal = ()=>{
        const details = {
            isSkipReassignment: false,
            isIncludeAssociatedEnt: nodeData?.showConsultOrReassignAssociatedFlag ? nodeData?.showConsultOrReassignAssociatedFlag : false,
            isNoteRequired: false,
            isIncludeAsscLabel: ""
        };
        switch(nodeData?.CERT_ENTITLEMENT_VALUEKEY){
            case (0, $20281fe09bc700a8$export$994f7af6d0b36256).USER:
                if (reassignConfigMap.defaultReassignee !== "") details.isSkipReassignment = false;
                else details.isSkipReassignment = true;
                details.isNoteRequired = true;
                details.lineItemKind = (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).USER;
                break;
            case (0, $20281fe09bc700a8$export$994f7af6d0b36256).ACCOUNT:
                details.isIncludeAsscLabel = "Include Associated Entitlements";
                details.lineItemKind = (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).ACCOUNT;
                break;
            case (0, $20281fe09bc700a8$export$994f7af6d0b36256).ROLE:
                details.lineItemKind = (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).ROLE;
                details.isIncludeAssociatedEnt = false; // no need checkbox for role lineitem
                break;
            case (0, $20281fe09bc700a8$export$994f7af6d0b36256).ENTITLEMENT:
            default:
                details.isIncludeAsscLabel = "Include Associated Entitlements";
                if ((0, $20281fe09bc700a8$export$994f7af6d0b36256).ENTITLEMENT >= 0) details.lineItemKind = (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).ENTITLEMENT;
                break;
        }
        setIsReassignModalOpen(true);
        setReassignModalDetails(details);
    };
    const handleConsultModal = ()=>{
        const details = {
            isIncludeAssociatedEnt: nodeData?.showConsultOrReassignAssociatedFlag ? nodeData?.showConsultOrReassignAssociatedFlag : false,
            isIncludeAsscLabel: ""
        };
        switch(nodeData?.CERT_ENTITLEMENT_VALUEKEY){
            case (0, $20281fe09bc700a8$export$994f7af6d0b36256).USER:
                details.isIncludeAsscLabel = "Include Associated Items (Accounts and Entitlements)";
                details.lineItemKind = (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).USER;
                break;
            case (0, $20281fe09bc700a8$export$994f7af6d0b36256).ACCOUNT:
                details.isIncludeAsscLabel = "Include Associated Items (Users and Entitlements)";
                details.lineItemKind = (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).ACCOUNT;
                break;
            case (0, $20281fe09bc700a8$export$994f7af6d0b36256).ROLE:
                details.lineItemKind = (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).ROLE;
                details.isIncludeAssociatedEnt = false; // no need checkbox for role lineitem
                break;
            case (0, $20281fe09bc700a8$export$994f7af6d0b36256).ENTITLEMENT:
            default:
                details.isIncludeAsscLabel = "Include Associated Items (Users and Accounts)";
                if ((0, $20281fe09bc700a8$export$994f7af6d0b36256).ENTITLEMENT >= 0) details.lineItemKind = (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).ENTITLEMENT;
                break;
        }
        setIsConsultModalOpen(true);
        setconsultModalDetails(details);
    };
    const handleCommentSubmit = (commentPopperValue)=>{
        if (isCommentRequired && !isSelected) onClick(commentPopperValue);
    };
    const handleReassignSubmit = (reassignPayload)=>{
        // set first time notify message
        // handle popover and modal api call
        onClick(reassignPayload);
    };
    const handleConsultSubmit = (consultPayload)=>{
        onClick(consultPayload);
    };
    const ActionButtonTrigger = /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
        children: [
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$ButtonCore), {
                id: id,
                dataTheme: dataTheme,
                tabIndex: tabIndex,
                onClick: handleActionClick,
                isDisabled: isDisabled,
                className: ActionButtonClasses,
                dataTestId: dataTestId,
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                        className: "CertsActionButton-inner",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: getIconKind()
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                                className: "CertsActionButton-overlay"
                            })
                        ]
                    }),
                    isSelected && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        className: "CertsActionButton-borderIcon",
                        kind: getBorderIcon()
                    }),
                    isLoading && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$lottiereact), {
                        className: "CertsActionButton-borderLoading",
                        animationData: (0, (/*@__PURE__*/$parcel$interopDefault($5a97dceba7e1a33b$exports)))
                    })
                ]
            }),
            kind === TERMINATE && checkTerminateClick && /*#__PURE__*/ (0, $hopDi$jsx)((0, $e5ef58c6194a06e4$export$2e2bcd8739ae039), {
                autoRevoke: getViewApiConfigmap?.LOCKTASKEXPIRE === "1",
                commentStatus: isCommentRequired,
                handleClick: onClick,
                handleCancel: ()=>setIsCheckTerminateClick(false),
                isLoading: isLoading,
                isTerminateError: getIsTerminateError,
                setIsTerminateError: ()=>setIsTerminateError(false)
            }),
            kind === EXTEND_END_DATE && isExtendEndDateClick && /*#__PURE__*/ (0, $hopDi$jsx)((0, $2b983767f0657a26$export$2e2bcd8739ae039), {
                handleClick: onClick,
                handleCancel: ()=>setIsExtendEndDateClick(false),
                getCurrentEndDate: getCurrentDate,
                isChangeEndDateError: getIsExtendEndDateError,
                setIsChangeEndDateError: ()=>setIsExtendEndDateError(false),
                allowedChangeExtendDate: extendEndDateDaysLimit,
                isLoading: isLoading,
                certificationStartDate: new Date(certificationStartDate),
                errorMessage: isActionErrorMessage
            }),
            kind === CONDITIONAL_CERTIFIY && isConditionalCertifyClick && /*#__PURE__*/ (0, $hopDi$jsx)((0, $2b983767f0657a26$export$2e2bcd8739ae039), {
                handleClick: onClick,
                handleCancel: ()=>setIsConditionalCertifyClick(false),
                getCurrentEndDate: getCurrentDate,
                isChangeEndDateError: getIsConditionalCertifyError,
                setIsChangeEndDateError: ()=>setIsConditionalCertifyError(false),
                allowedChangeExtendDate: conditionalCertifyDaysLimit,
                isLoading: isLoading,
                certificationStartDate: new Date(certificationStartDate),
                errorMessage: isActionErrorMessage
            }),
            (kind === DOES_NOT_WORK_FOR_ME || kind === REASSIGN) && isReassignModalOpen && /*#__PURE__*/ (0, $hopDi$jsx)((0, $7de18020df34e39a$export$2e2bcd8739ae039), {
                isReassignModalOpen: isReassignModalOpen,
                setIsReassignModalOpen: ()=>{
                    setIsReassignModalOpen(false);
                },
                onSubmit: handleReassignSubmit,
                isCommentRequired: true,
                reassignModalDetails: reassignModalDetails,
                nodeData: nodeData
            }),
            kind === CONSULT && isConsultModalOpen && /*#__PURE__*/ (0, $hopDi$jsx)((0, $7f3598ff04b0c7dc$export$2e2bcd8739ae039), {
                isConsultModalOpen: isConsultModalOpen,
                setIsConsultModalOpen: ()=>{
                    setIsConsultModalOpen(false);
                },
                onSubmit: handleConsultSubmit,
                isCommentRequired: true,
                consultModalDetails: consultModalDetails,
                nodeData: nodeData
            })
        ]
    });
    const ActionButtonWithToolTip = /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Tooltip), {
        className: ActionButtonTooltipClasses,
        openDelay: mergedTooltipProperties.openDelay,
        text: mergedTooltipProperties.text,
        maxWidth: mergedTooltipProperties.maxWidth,
        placement: !isCommentPopoverOpen || !isReassignPopoverOpen || !isRejectPopoverOpen ? mergedTooltipProperties.placement : "right",
        offset: 8,
        trigger: ActionButtonTrigger
    });
    if (isSaviRejectPopoverOpen) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $ac46cb6010681c0d$export$2e2bcd8739ae039), {
        kind: REJECT,
        handleClick: onClick,
        onClose: setIsSaviRejectPopoverOpen,
        isOpen: isSaviRejectPopoverOpen,
        trigger: ActionButtonWithToolTip,
        placement: getPopoverPlacement(),
        saviRespondedReason: saviRespondedReason
    });
    if (isSaviApprovePopoverOpen) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $ac46cb6010681c0d$export$2e2bcd8739ae039), {
        kind: APPROVE,
        handleClick: onClick,
        onClose: setIsSaviApprovePopoverOpen,
        isOpen: isSaviApprovePopoverOpen,
        trigger: ActionButtonWithToolTip,
        placement: getPopoverPlacement(),
        saviRespondedReason: saviRespondedReason
    });
    if (isConfirmManagerOrApproveTileAndCommentRequired && !isSidePanelVisible) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $8c613cbc0666ae78$export$2e2bcd8739ae039), {
        actionKind: kind,
        isCommentPopoverOpen: isCommentPopoverOpen,
        setIsCommentPopoverOpen: isSelected ? ()=>{} : setIsCommentPopoverOpen,
        placement: getPopoverPlacement(),
        trigger: ActionButtonWithToolTip,
        onSubmit: handleCommentSubmit
    });
    // enable the popover when reassign and show reassign , comments if not required  popover is false
    if (isReassignUser && isCommentRequired && (0, $687791ac9134434b$export$a49393e96e2bf605)(reassignConfigMap) && !isPopoverUserReassignMsgShown) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $315ae4957e308cf1$export$2e2bcd8739ae039), {
        actionKind: kind,
        isReassignPopoverOpen: isReassignPopoverOpen,
        setIsReassignPopoverOpen: isSelected ? ()=>{} : setIsReassignPopoverOpen,
        placement: getPopoverPlacement(),
        trigger: ActionButtonWithToolTip,
        onSubmit: ()=>{
            if (isReassignPopoverOpen) setIsReassignPopoverOpen(false);
            setReassignUserPopoverMsg();
            handleReassignModal();
        }
    });
    if (isReassignUser && (0, $687791ac9134434b$export$a5f2d48f68b29e88)(reassignConfigMap) && isCommentRequired) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Fragment), {
        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $8c613cbc0666ae78$export$2e2bcd8739ae039), {
            actionKind: kind,
            isCommentPopoverOpen: isCommentPopoverOpen,
            setIsCommentPopoverOpen: isSelected ? ()=>{} : setIsCommentPopoverOpen,
            placement: getPopoverPlacement(),
            trigger: ActionButtonWithToolTip,
            onSubmit: (commentPopperValue)=>{
                const modalInfo = {
                    commentValue: commentPopperValue
                };
                handleReassignSubmit(modalInfo);
            }
        })
    });
    if (isRejectPopoverOpen && isCommentRequired && !getIsRejectError && !isSidePanelVisible) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $813c5abc50980873$export$2e2bcd8739ae039), {
        autoRevoke: getViewApiConfigmap?.LOCKTASKEXPIRE === "1",
        commentStatus: isCommentRequired,
        handleClick: onClick,
        isLoading: isLoading,
        getTypeActEntRole: getTypeActEntRole,
        placement: getPopoverPlacement(),
        trigger: ActionButtonWithToolTip,
        isRejectPopoverOpen: isRejectPopoverOpen,
        setIsRejectPopoverOpen: isSelected ? ()=>{} : setIsRejectPopoverOpen
    });
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Fragment), {
        children: ActionButtonWithToolTip
    });
}
$57da59531dca7c37$var$CertsActionButton.defaultProps = {
    id: null,
    setIsActionPopoverOpen: ()=>{},
    tabIndex: 0,
    isDisabled: false,
    isSelected: false,
    isLoading: false,
    isDecisionMade: false,
    isCommentRequired: false,
    isToolTipDisabled: false,
    tooltipProperties: $57da59531dca7c37$var$defaultTooltipProps,
    dataTheme: null,
    dataTestId: null,
    reassignConfigMap: {
        defaultReassignee: "",
        defaultReassigneeName: "",
        enableIndividualCommentsForAccountEntitlementRoles: [],
        enableIndividualCommentsForUsers: [],
        enableReassignStep2: "0",
        enableReassignUser: "0",
        showReassignPopup: "0"
    },
    isActionSuccess: false,
    isActionError: false,
    isPopoverUserReassignMsgShown: false,
    setReassignUserPopoverMsg: ()=>{},
    isSaviResponded: false,
    saviRespondedReason: []
};
$57da59531dca7c37$var$CertsActionButton.propTypes = {
    id: (0, $hopDi$proptypes).string,
    setIsActionPopoverOpen: (0, $hopDi$proptypes).func,
    kind: (0, $hopDi$proptypes).oneOf(Object.values((0, $20281fe09bc700a8$export$3f43cf8434698562))).isRequired,
    groupKind: (0, $hopDi$proptypes).oneOf(Object.values((0, $20281fe09bc700a8$export$758743ec42a300f1))).isRequired,
    tabIndex: (0, $hopDi$proptypes).number,
    isDisabled: (0, $hopDi$proptypes).bool,
    isSelected: (0, $hopDi$proptypes).bool,
    isLoading: (0, $hopDi$proptypes).bool,
    isDecisionMade: (0, $hopDi$proptypes).bool,
    isCommentRequired: (0, $hopDi$proptypes).bool,
    isHidden: (0, $hopDi$proptypes).bool.isRequired,
    onClick: (0, $hopDi$proptypes).func.isRequired,
    isToolTipDisabled: (0, $hopDi$proptypes).bool,
    tooltipProperties: (0, $hopDi$proptypes).shape({
        text: (0, $hopDi$proptypes).string,
        openDelay: (0, $hopDi$proptypes).number,
        maxWidth: (0, $hopDi$proptypes).string,
        placement: (0, $hopDi$proptypes).string
    }),
    dataTheme: (0, $hopDi$proptypes).oneOf(Object.values((0, $135adfecc1ed8f07$export$49390a4605a2336a))),
    dataTestId: (0, $hopDi$proptypes).string,
    nodeData: (0, $hopDi$proptypes).shape((0, $ddbc2f861c0388ff$export$3e7926703ac20a93)).isRequired,
    isActionSuccess: (0, $hopDi$proptypes).bool,
    isActionError: (0, $hopDi$proptypes).bool,
    reassignConfigMap: (0, $hopDi$proptypes).shape((0, $ddbc2f861c0388ff$export$79819249befb86e5)),
    isPopoverUserReassignMsgShown: (0, $hopDi$proptypes).bool,
    setReassignUserPopoverMsg: (0, $hopDi$proptypes).func,
    isSaviResponded: (0, $hopDi$proptypes).bool,
    saviRespondedReason: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string)
};
var $57da59531dca7c37$export$2e2bcd8739ae039 = $57da59531dca7c37$var$CertsActionButton;


/* eslint-disable react/jsx-curly-spacing */ /* eslint-disable react/jsx-wrap-multilines */ 








const $94e77a9d2fb3d728$var$initialChipData = [
    {
        id: 1,
        label: "Lorem ipsum",
        isSelected: false
    },
    {
        id: 2,
        label: "Lorem ipsum",
        isSelected: false
    }
];
function $94e77a9d2fb3d728$var$CertsSidePanelCommentDrawer({ isSidePanelCommentDrawerOpen: isSidePanelCommentDrawerOpen, setIsSidePanelCommentDrawerOpen: setIsSidePanelCommentDrawerOpen, drawerActionKind: drawerActionKind, onSubmit: onSubmit, getTypeActEntRole: getTypeActEntRole }) {
    const [isCritical, setIsCritical] = (0, $hopDi$useState)(false);
    const [commentValue, setCommentValue] = (0, $hopDi$useState)("");
    const [inputChanged, setInputChanged] = (0, $hopDi$useState)(false);
    const [chipData, setChipData] = (0, $hopDi$useState)($94e77a9d2fb3d728$var$initialChipData);
    const sidePanelCommentDrawerClasses = (0, $hopDi$classnames)("CertsSidePanelCommentDrawer-contextWrapper", isSidePanelCommentDrawerOpen && (drawerActionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).WORKS_FOR_ME || drawerActionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).APPROVE || drawerActionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).REJECT) && "CertsSidePanelCommentDrawer-contextWrapper--isOpen");
    // Reset on close
    (0, $hopDi$useEffect)(()=>{
        if (!isSidePanelCommentDrawerOpen) {
            setIsCritical(false);
            setCommentValue("");
            setInputChanged(false);
            setChipData($94e77a9d2fb3d728$var$initialChipData);
        }
    }, [
        isSidePanelCommentDrawerOpen
    ]);
    const isCommentNotValid = Boolean(isCritical || commentValue?.replace(/[<>]/g, "")?.trim()?.length < 3);
    const handleCommentSubmit = ()=>{
        if (isCommentNotValid) return setIsCritical(true);
        return onSubmit(commentValue);
    };
    const getPopoverContent = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
            className: "CertsSidePanelCommentDrawer",
            children: [
                drawerActionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).REJECT && /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "Certs-Reject-Action-header-wrap",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "RejectHelp"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Typography), {
                            className: "Certs-Reject-Popover-commentsTitle",
                            kind: "label",
                            children: [
                                (0, $20281fe09bc700a8$export$170ce1a49c989948).TITLE,
                                ` ${getTypeActEntRole}?`
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $0d23168c4a68b98d$export$2e2bcd8739ae039), {
                            chipData: chipData,
                            setChipData: setChipData,
                            initialChipData: $94e77a9d2fb3d728$var$initialChipData,
                            inputChanged: inputChanged,
                            setInputChanged: setInputChanged,
                            isCritical: isCritical,
                            setIsCritical: setIsCritical,
                            commentValue: commentValue,
                            setCommentValue: setCommentValue
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                            tag: "div",
                            className: "CertsSidePanelCommentDrawer-controls",
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                                    type: "button",
                                    kind: "ghost",
                                    onClick: ()=>setIsSidePanelCommentDrawerOpen(false),
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                                    type: "button",
                                    kind: !isCommentNotValid ? "filled" : "outlined",
                                    onClick: ()=>handleCommentSubmit(),
                                    children: (0, $3cd234bd4f1cf26a$export$3edeae7c90cf2ca0)(drawerActionKind)
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
        tag: "div",
        className: sidePanelCommentDrawerClasses,
        children: getPopoverContent()
    });
}
$94e77a9d2fb3d728$var$CertsSidePanelCommentDrawer.defaultProps = {
    drawerActionKind: null
};
$94e77a9d2fb3d728$var$CertsSidePanelCommentDrawer.propTypes = {
    isSidePanelCommentDrawerOpen: (0, $hopDi$proptypes).bool.isRequired,
    setIsSidePanelCommentDrawerOpen: (0, $hopDi$proptypes).func.isRequired,
    drawerActionKind: (0, $hopDi$proptypes).oneOf(Object.values((0, $20281fe09bc700a8$export$3f43cf8434698562))),
    onSubmit: (0, $hopDi$proptypes).func.isRequired,
    getTypeActEntRole: (0, $hopDi$proptypes).func.isRequired
};
var $94e77a9d2fb3d728$export$2e2bcd8739ae039 = $94e77a9d2fb3d728$var$CertsSidePanelCommentDrawer;



/* eslint-disable indent */ // export const trackActionSelect = (
//   prev,
//   actionKind,
//   status,
//   trackerId,
//   sidePanelAction,
//   shouldBeRemovedFlag
// ) => {
//   if (sidePanelAction) sidePanelAction();
//   return prev.map((item) => {
//     const actions = item.tracker?.actions || {};
//     const currentAction = actions[actionKind] || {};
//   return {
//     ...item,
//     tracker: {
//       ...item.tracker,
//       actions: {
//         ...actions,
//         [actionKind]: {
//           isLoading: false,
//           isSelected:
//             item.tracker.id === trackerId ? status : currentAction.isSelected,
//           shouldBeRemoved:
//             item.tracker.id === trackerId && item?.children?.length === 0
//               ? shouldBeRemovedFlag
//               : currentAction.shouldBeRemoved,
//         },
//       },
//     },
//     children:
//       item.children?.length > 0
//         ? trackActionSelect(
//             item.children,
//             actionKind,
//             status,
//             trackerId,
//             sidePanelAction,
//             shouldBeRemovedFlag
//           )
//         : [],
//   };
// });
// };
const $878df4c3ccf5afc4$export$9d3a58655199f101 = (prev, actionKind, status, trackerId, sidePanelAction, shouldBeRemovedFlag, shouldSwitchSidePanel, jumpToSameLevel)=>{
    if (sidePanelAction && shouldSwitchSidePanel) sidePanelAction(jumpToSameLevel);
    if (shouldBeRemovedFlag) return prev.reduce((arr, item)=>{
        if (item?.tracker?.id !== trackerId) arr.push({
            ...item,
            children: item.children?.length > 0 ? $878df4c3ccf5afc4$export$9d3a58655199f101(item.children, actionKind, status, trackerId, sidePanelAction, shouldBeRemovedFlag, shouldSwitchSidePanel, jumpToSameLevel) : []
        });
        return arr;
    }, []);
    return prev.map((item)=>{
        const actions = item.tracker?.actions || {};
        const currentAction = actions[actionKind] || {};
        return {
            ...item,
            tracker: {
                ...item.tracker,
                actions: {
                    ...actions,
                    [actionKind]: {
                        isLoading: false,
                        isSelected: item.tracker.id === trackerId ? status : currentAction.isSelected,
                        shouldBeRemoved: item.tracker.id === trackerId && item?.children?.length === 0 ? shouldBeRemovedFlag : currentAction.shouldBeRemoved
                    }
                }
            },
            children: item.children?.length > 0 ? $878df4c3ccf5afc4$export$9d3a58655199f101(item.children, actionKind, status, trackerId, sidePanelAction, shouldBeRemovedFlag, shouldSwitchSidePanel, jumpToSameLevel) : []
        };
    });
};
const $878df4c3ccf5afc4$export$31db7a6341ffeb48 = (prev, actionKind, status, trackerId)=>prev.map((item)=>{
        const actions = item.tracker?.actions || {};
        const currentAction = actions[actionKind] || {};
        return {
            ...item,
            tracker: {
                ...item.tracker,
                actions: {
                    ...actions,
                    [actionKind]: {
                        ...currentAction,
                        isLoading: item.tracker.id === trackerId ? status : currentAction.isLoading
                    }
                }
            },
            children: item.children?.length > 0 ? $878df4c3ccf5afc4$export$31db7a6341ffeb48(item.children, actionKind, status, trackerId) : []
        };
    });
const $878df4c3ccf5afc4$export$808adcb2ea9678fa = (prev, actionKind, status, trackerId)=>prev.map((item)=>{
        const actions = item.tracker?.actions || {};
        const currentAction = actions[actionKind] || {};
        return {
            ...item,
            tracker: {
                ...item.tracker,
                actions: {
                    ...actions,
                    [actionKind]: {
                        ...currentAction,
                        isDisabled: item.tracker.id === trackerId ? status : currentAction.isDisabled
                    }
                }
            },
            children: item.children?.length > 0 ? $878df4c3ccf5afc4$export$31db7a6341ffeb48(item.children, actionKind, status, trackerId) : []
        };
    });
const $878df4c3ccf5afc4$export$8c4788c97556a02f = (nodeData, actionName)=>{
    // Check if the action exists, if not return null for all properties
    const action = nodeData?.tracker?.actions?.[actionName];
    if (!action) return {
        isSelected: null,
        isLoading: null,
        isDisabled: null,
        shouldBeRemoved: null
    };
    // If the action exists, return its properties
    return {
        isSelected: action.isSelected,
        isLoading: action.isLoading,
        isDisabled: action.isDisabled,
        shouldBeRemoved: action.shouldBeRemoved
    };
};



const $f7cd7b23cff7a54f$var$TOOLTIP_DELAY_IN_MS_TILE = 1000;
const $f7cd7b23cff7a54f$var$TOOLTIP_DELAY_IN_MS_SIDEPANEL = 0;
const $f7cd7b23cff7a54f$var$MIN_BUTTONS_FOR_KABOB = 3;
function $f7cd7b23cff7a54f$var$CertsActionButtonsGroup({ kind: kind, nodeData: nodeData, handleSidePanelAction: handleSidePanelAction, isGroupDisabled: isGroupDisabled, groupTooltipText: groupTooltipText, isActionGroupExpanded: isActionGroupExpanded, setIsActionGroupExpanded: setIsActionGroupExpanded, setIsActionPopoverOpen: setIsActionPopoverOpen, setMergedLists: // ----- Utilities -----
setMergedLists, dataTestId: dataTestId, isSaviResponded: isSaviResponded, saviRespondedReason: saviRespondedReason }) {
    // Side panel action comments
    const [isSidePanelCommentDrawerOpen, setIsSidePanelCommentDrawerOpen] = (0, $hopDi$useState)(false);
    const [drawerActionKind, setDrawerActionKind] = (0, $hopDi$useState)(null);
    const dispatch = (0, $hopDi$useDispatch)();
    // fetching redux store values for action items
    const { certKey: certKey, enableComments: enableComments, configMap: getViewApiConfigmap, reassignConfigMap: reassignConfigMap, action: { isActionSuccess: isActionSuccess, isActionError: isActionError, errorMessage: isActionErrorMessage }, isSidePanelVisible: isSidePanelVisible, certificationStartDate: certificationStartDate, progressBreakdowndetails: progressBreakdowndetails, tabs: tabs, isPopoverUserReassignMsgShown: isPopoverUserReassignMsgShown } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const { tabData: tabData } = tabs;
    const { users: enableCommentsUsers, accEntRole: enableCommentsAccEntRole } = enableComments;
    const { byDecisionDetails: byDecisionDetails } = progressBreakdowndetails;
    const getFirstTimeReject = !(byDecisionDetails?.Summary && byDecisionDetails?.Summary?.Rejected);
    const activeTab = tabData?.find((tab)=>tab?.isActive);
    // fetching each line item values from /items api
    const accountKey = nodeData?.CERT_ACCOUNTKEY;
    const userKey = nodeData?.CERT_USERKEY;
    const entValueKey = nodeData?.CERT_ENTITLEMENT_VALUEKEY;
    const trackerId = nodeData?.tracker?.id;
    const level = nodeData?.tracker?.level;
    const actionButtonsMap = nodeData?.availableAction && Object.keys(nodeData?.availableAction);
    const disableButtonsMap = nodeData?.enableAction;
    const isDetailsGroup = kind === (0, $20281fe09bc700a8$export$758743ec42a300f1).TILE;
    const isFooterGroup = kind === (0, $20281fe09bc700a8$export$758743ec42a300f1).FOOTER;
    const getTypeActEntRole = ()=>{
        if (entValueKey === (0, $bae22e791544392c$export$994f7af6d0b36256).ROLE) return (0, $bae22e791544392c$export$6b1c20b2e2de9059).ROLE;
        if (entValueKey === (0, $bae22e791544392c$export$994f7af6d0b36256).ACCOUNT) return (0, $bae22e791544392c$export$6b1c20b2e2de9059).ACCOUNT;
        return (0, $bae22e791544392c$export$6b1c20b2e2de9059).ENTITLEMENT;
    };
    // Destructure Action States using helper function
    // Approve (Account, Ent, Role {Based on CERT_ENTITLEMENT_VALUEKEY})
    const { isSelected: isApprove, isLoading: isApproveLoading, isDisabled: isApproveDisabled, shouldBeRemoved: isApproveRemove } = (0, $878df4c3ccf5afc4$export$8c4788c97556a02f)(nodeData, "approve");
    // Reject
    const { isSelected: isReject, isLoading: isRejectLoading, isDisabled: isRejectDisabled, shouldBeRemoved: isRejectRemove } = (0, $878df4c3ccf5afc4$export$8c4788c97556a02f)(nodeData, "reject");
    // Terminated
    const { isSelected: isTerminate, isLoading: isTerminateLoading, isDisabled: isTerminateDisabled, shouldBeRemoved: isTerminateRemove } = (0, $878df4c3ccf5afc4$export$8c4788c97556a02f)(nodeData, "terminated");
    // Reassign
    const { isSelected: isReassign, isLoading: isReassignLoading, isDisabled: isReassignDisabled, shouldBeRemoved: isReassignRemove } = (0, $878df4c3ccf5afc4$export$8c4788c97556a02f)(nodeData, "reassign");
    // Consult
    const { isSelected: isConsult, isLoading: isConsultLoading, isDisabled: isConsultDisabled, shouldBeRemoved: isConsultRemove } = (0, $878df4c3ccf5afc4$export$8c4788c97556a02f)(nodeData, "consult");
    // Approve User (WorksForMe)
    const { isSelected: isWorksForMe, isLoading: isWorksForMeLoading, isDisabled: isWorksForMeDisabled, shouldBeRemoved: isWorksForMeRemove } = (0, $878df4c3ccf5afc4$export$8c4788c97556a02f)(nodeData, "worksForMe");
    // Reject User (DoesNotWorksForMe)
    const { isSelected: isDoesNotWorksForMe, isLoading: isDoesNotWorksForMeLoading, isDisabled: isDoesNotWorksForMeDisabled, shouldBeRemoved: isDoesNotWorksForMeRemove } = (0, $878df4c3ccf5afc4$export$8c4788c97556a02f)(nodeData, "doesNotWorksForMe");
    // Extend End Date
    const { isSelected: isExtendEndDate, isLoading: isExtendEndDateLoading, isDisabled: isExtendEndDateDisabled, shouldBeRemoved: isExtendEndDateRemove } = (0, $878df4c3ccf5afc4$export$8c4788c97556a02f)(nodeData, "extendEndDate");
    // Conditional Certifiy
    const { isSelected: isConditionalCertifiy, isLoading: isConditionalCertifiyLoading, isDisabled: isConditionalCertifiyDisabled, shouldBeRemoved: isConditionalCertifyRemove } = (0, $878df4c3ccf5afc4$export$8c4788c97556a02f)(nodeData, "conditionalCertifiy");
    // Use these to set the tracker state of your actions
    const setIsActionLoading = (actionKind, isLoading)=>setMergedLists((prev)=>(0, $878df4c3ccf5afc4$export$31db7a6341ffeb48)(prev, actionKind, isLoading, trackerId));
    const setIsActionSelected = (actionKind, isSelected, shouldBeRemovedFlag, shouldSwitchSidePanel, jumpToSameLevel)=>{
        setMergedLists((prev)=>(0, $878df4c3ccf5afc4$export$9d3a58655199f101)(prev, actionKind, isSelected, trackerId, kind === (0, $20281fe09bc700a8$export$758743ec42a300f1).FOOTER ? handleSidePanelAction : ()=>{}, shouldBeRemovedFlag, shouldSwitchSidePanel, jumpToSameLevel));
    };
    const dispatchActionHandler = (actionKind, status, dispatchFunc, payload)=>{
        // Set Loading onClick
        setIsActionLoading(actionKind, true);
        dispatch(dispatchFunc(payload, actionKind)).then((response)=>{
            const currentState = !(status === null || status === undefined || status === false);
            const disabledHighlight = tabData.map((tab)=>({
                    ...tab,
                    isHighlighted: false
                }));
            dispatch((0, $d623f23401a154f0$export$e9c5cd8aea0cabc7)(disabledHighlight));
            setIsActionLoading(actionKind, false);
            if (response.isSuccess) {
                let tabToHighLight = "";
                if (activeTab.key === (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49) && !currentState) tabToHighLight = (0, $d44c789d5b60f9bf$export$807a0bc890800408);
                if (activeTab.key === (0, $d44c789d5b60f9bf$export$807a0bc890800408) && currentState) tabToHighLight = (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49);
                const isHighlightedTab = tabData.map((tab)=>({
                        ...tab,
                        isHighlighted: tab.key === tabToHighLight
                    }));
                setTimeout(()=>{
                    dispatch((0, $d623f23401a154f0$export$e9c5cd8aea0cabc7)(isHighlightedTab));
                }, 100);
                const flags = {
                    shouldBeRemovedFlag: false,
                    shouldSwitchSidePanel: false,
                    jumpToSameLevel: true
                };
                if (actionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).DOES_NOT_WORK_FOR_ME || actionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).REASSIGN) {
                    if (activeTab.key === (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49) && !currentState || activeTab.key === (0, $d44c789d5b60f9bf$export$807a0bc890800408) && currentState) {
                        flags.shouldBeRemovedFlag = !!payload?.assignee;
                        flags.shouldSwitchSidePanel = true;
                    }
                    if (activeTab.key === (0, $d44c789d5b60f9bf$export$d5eea126dff5a615) && currentState) {
                        flags.shouldBeRemovedFlag = !!payload?.assignee;
                        flags.shouldSwitchSidePanel = false;
                        flags.jumpToSameLevel = false;
                    }
                    if (activeTab.key === (0, $d44c789d5b60f9bf$export$d5eea126dff5a615) && !currentState) {
                        flags.shouldBeRemovedFlag = !!payload?.assignee;
                        flags.shouldSwitchSidePanel = true;
                        flags.jumpToSameLevel = false;
                    }
                } else {
                    // START: Enter logic based on action here @padmavati, @vishnu, @shaurabh, @jacob
                    if (actionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).REJECT || actionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).TERMINATE || actionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT) {
                        if (activeTab.key === (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49) && !currentState || activeTab.key === (0, $d44c789d5b60f9bf$export$807a0bc890800408) && currentState) {
                            flags.shouldBeRemovedFlag = true;
                            flags.shouldSwitchSidePanel = true;
                        }
                    }
                    // END: Enter logic based on action here @padmavati, @vishnu, @shaurabh, @jacob
                    if (activeTab.key === (0, $d44c789d5b60f9bf$export$d5eea126dff5a615) && currentState) {
                        flags.shouldBeRemovedFlag = false;
                        flags.shouldSwitchSidePanel = false;
                        flags.jumpToSameLevel = false;
                    }
                    if (activeTab.key === (0, $d44c789d5b60f9bf$export$d5eea126dff5a615) && !currentState) {
                        flags.shouldBeRemovedFlag = false;
                        flags.shouldSwitchSidePanel = true;
                        flags.jumpToSameLevel = false;
                    }
                }
                // if (!flags.jumpToSameLevel) {
                //   flags.shouldBeRemovedFlag = false;
                //   flags.shouldSwitchSidePanel = false; // MSG: true or false based on your requirements
                // }
                setIsActionSelected(actionKind, !status, flags.shouldBeRemovedFlag, flags.shouldSwitchSidePanel, flags.jumpToSameLevel);
            }
        }).catch(()=>{
            setIsActionLoading(actionKind, false);
            setIsActionSelected(actionKind, status, false, false);
        });
    };
    const actionButtonWrapperClasses = (0, $hopDi$classnames)("CertsActionButtonsGroup-wrapper", `CertsActionButtonsGroup-wrapper--${level}`, isActionGroupExpanded && "CertsActionButtonsGroup-wrapper--isExpanded");
    const actionButtonGroupClasses = (0, $hopDi$classnames)("CertsActionButtonsGroup", actionButtonsMap?.length && `CertsActionButtonsGroup--length${actionButtonsMap.length}`);
    const kindClasses = (0, $hopDi$classnames)(isDetailsGroup && "CertsActionButtonsGroup-actionsOnly", isFooterGroup && "CertsActionButtonsGroup-sidePanelFooter");
    // Reset drawerActionKind
    (0, $hopDi$useEffect)(()=>{
        if (!isSidePanelCommentDrawerOpen) setDrawerActionKind(null);
    }, [
        isSidePanelCommentDrawerOpen
    ]);
    // TODO: Consider combining (handleApprove && handleWorksForMe) based on DRY code
    // Functions completed
    const handleApprove = (commentValue)=>{
        const isCommentRequired = enableCommentsAccEntRole.includes((0, $20281fe09bc700a8$export$69894cdd9841cdfb).APPROVE);
        const approvePayload = {
            certKey: certKey,
            userKey: userKey,
            entValueKey: entValueKey,
            accountKey: nodeData?.CERT_ACCOUNTKEY,
            status: isApprove ? (0, $20281fe09bc700a8$export$6bf521f24032eb49).RESET : (0, $20281fe09bc700a8$export$6bf521f24032eb49).APPROVE,
            certRoleKey: nodeData?.CERT_ROLEKEY,
            comment: commentValue
        };
        const dispatchApprove = ()=>dispatchActionHandler((0, $20281fe09bc700a8$export$3f43cf8434698562).APPROVE, isApprove, (0, $d623f23401a154f0$export$70cd670b72ffe020), approvePayload);
        // Tile on click
        if (isDetailsGroup) dispatchApprove();
        // Footer on click
        if (isFooterGroup) {
            if (!isApprove && isCommentRequired) {
                setIsSidePanelCommentDrawerOpen(!isSidePanelCommentDrawerOpen);
                setDrawerActionKind((0, $20281fe09bc700a8$export$3f43cf8434698562).APPROVE);
            }
            if (commentValue?.length >= 3) dispatchApprove();
            // Reset in footer
            if (!isCommentRequired || isCommentRequired && isApprove) dispatchApprove();
        }
    };
    // Handling Works For Me api dispatch actions
    const handleWorksForMe = (commentValue)=>{
        const isCommentRequired = enableCommentsUsers.includes((0, $20281fe09bc700a8$export$80dc2c0ddeaedcb2).WORKS_FOR_ME);
        const approveUserPayload = {
            certKey: certKey,
            userKey: userKey,
            entValueKey: entValueKey,
            status: isWorksForMe ? (0, $20281fe09bc700a8$export$6bf521f24032eb49).RESET : (0, $20281fe09bc700a8$export$6bf521f24032eb49).WORKS_FOR_ME,
            comment: commentValue
        };
        const dispatchWorksForMe = ()=>dispatchActionHandler((0, $20281fe09bc700a8$export$3f43cf8434698562).WORKS_FOR_ME, isWorksForMe, (0, $d623f23401a154f0$export$e77519515695c9c7), approveUserPayload);
        // Tile on click
        if (isDetailsGroup) dispatchWorksForMe();
        // Footer on click
        if (isFooterGroup) {
            if (!isWorksForMe && isCommentRequired) {
                setIsSidePanelCommentDrawerOpen(!isSidePanelCommentDrawerOpen);
                setDrawerActionKind((0, $20281fe09bc700a8$export$3f43cf8434698562).WORKS_FOR_ME);
            }
            if (commentValue?.length >= 3) dispatchWorksForMe();
            // Reset in footer
            if (!isCommentRequired || isCommentRequired && isWorksForMe) dispatchWorksForMe();
        }
    };
    // Handling Terminate api dispatch actions
    const handleTerminate = (commentValue)=>{
        const isCommentRequired = enableCommentsUsers.includes((0, $20281fe09bc700a8$export$80dc2c0ddeaedcb2).TERMINATED);
        const payload = {
            certKey: certKey,
            userKey: userKey,
            status: isTerminate ? (0, $20281fe09bc700a8$export$6bf521f24032eb49).RESET : (0, $20281fe09bc700a8$export$6bf521f24032eb49).TERMINATED,
            comments: commentValue && commentValue.length > 0 ? commentValue : "Terminate User"
        };
        const dispatchTerminate = ()=>dispatchActionHandler((0, $20281fe09bc700a8$export$3f43cf8434698562).TERMINATE, isTerminate, (0, $d623f23401a154f0$export$348853d7c8cab35b), payload);
        // Tile on click
        if (isDetailsGroup) dispatchTerminate();
        // Footer on click
        if (isFooterGroup) {
            if (!isTerminate) {
                setIsSidePanelCommentDrawerOpen(!isSidePanelCommentDrawerOpen);
                setDrawerActionKind((0, $20281fe09bc700a8$export$3f43cf8434698562).TERMINATE);
            }
            if (commentValue?.length >= 3) {
                dispatchTerminate();
                return;
            }
            // Reset in footer
            if (!isCommentRequired || isCommentRequired && isTerminate) dispatchTerminate();
        }
    };
    // Handling Change End Date api dispatch actions for User
    const handleExtendEndDate = (getDate, commentValue)=>{
        const isCommentRequired = enableCommentsUsers.includes((0, $20281fe09bc700a8$export$80dc2c0ddeaedcb2).EXTEND_END_DATE);
        let currentDate = new Date();
        const dd = currentDate.getDate();
        const mm = currentDate.getMonth() + 1;
        const yyyy = currentDate.getFullYear();
        currentDate = `${mm < 10 ? `0${mm}` : mm}-${dd < 10 ? `0${dd}` : dd}-${yyyy}`;
        const payload = {
            certKey: certKey,
            userKey: userKey,
            certified: "2",
            status: isExtendEndDate ? (0, $20281fe09bc700a8$export$6bf521f24032eb49).RESET : (0, $20281fe09bc700a8$export$6bf521f24032eb49).WORKS_FOR_ME,
            extendedEndDate: getDate && getDate.length > 0 ? getDate : currentDate,
            comments: commentValue && commentValue.length > 0 ? commentValue : "Extend user end date again"
        };
        const dispatchExtendEndDate = ()=>dispatchActionHandler((0, $20281fe09bc700a8$export$3f43cf8434698562).EXTEND_END_DATE, isExtendEndDate, (0, $d623f23401a154f0$export$9f62cbf6b3b94af9), payload);
        // Tile on click
        if (isDetailsGroup) dispatchExtendEndDate();
        // Footer on click
        if (isFooterGroup) {
            if (!isExtendEndDate) {
                setIsSidePanelCommentDrawerOpen(!isSidePanelCommentDrawerOpen);
                setDrawerActionKind((0, $20281fe09bc700a8$export$3f43cf8434698562).EXTEND_END_DATE);
            }
            if (commentValue?.length >= 3) {
                dispatchExtendEndDate();
                return;
            }
            // Reset in footer
            if (!isCommentRequired || isCommentRequired && isExtendEndDate) dispatchExtendEndDate();
        }
    };
    // Handling Reject Action api dispatch actions
    const handleRejectAction = (commentValue)=>{
        const isCommentRequired = enableCommentsAccEntRole.includes((0, $20281fe09bc700a8$export$69894cdd9841cdfb).REJECT);
        let payload;
        if (entValueKey === "-2") payload = {
            certKey: certKey,
            userKey: userKey,
            entValueKey: entValueKey,
            certRoleKey: nodeData?.CERT_ROLEKEY,
            status: isReject ? (0, $20281fe09bc700a8$export$6bf521f24032eb49).RESET : (0, $20281fe09bc700a8$export$6bf521f24032eb49).REVOKED,
            comments: commentValue && commentValue.length > 0 ? commentValue : "Reject User"
        };
        else payload = {
            accountKey: accountKey,
            certKey: certKey,
            userKey: userKey,
            entValueKey: entValueKey,
            status: isReject ? (0, $20281fe09bc700a8$export$6bf521f24032eb49).RESET : (0, $20281fe09bc700a8$export$6bf521f24032eb49).REVOKED,
            comments: commentValue && commentValue.length > 0 ? commentValue : "Reject User"
        };
        const dispatchReject = ()=>dispatchActionHandler((0, $20281fe09bc700a8$export$3f43cf8434698562).REJECT, isReject, (0, $d623f23401a154f0$export$8a3b1d82a4510306), payload);
        // Tile on click
        if (isDetailsGroup) dispatchReject();
        // Footer on click
        if (isFooterGroup) {
            if (!isReject) {
                setIsSidePanelCommentDrawerOpen(!isSidePanelCommentDrawerOpen);
                setDrawerActionKind((0, $20281fe09bc700a8$export$3f43cf8434698562).REJECT);
            }
            if (commentValue?.length >= 3) {
                dispatchReject();
                return;
            }
            // Reset in footer
            if (!isCommentRequired || isCommentRequired && isReject) dispatchReject();
        }
    };
    // Placeholder  Funcitons Below
    const handleReassign = (reassignPayload)=>{
        const payload = {
            certkey: certKey,
            cert_userkey: nodeData.CERT_USERKEY,
            cert_entitlement_valuekey: nodeData.CERT_ENTITLEMENT_VALUEKEY,
            requestOrigin: "UI"
        };
        if (reassignPayload?.commentValue) payload.comments = reassignPayload?.commentValue;
        if (reassignPayload?.selectedUser && reassignPayload.selectedUser?.value !== reassignConfigMap.defaultReassignee && !reassignPayload?.isSkipCertifierChecked) payload.assignee = reassignPayload?.selectedUser?.value;
        switch(nodeData?.CERT_ENTITLEMENT_VALUEKEY){
            case (0, $bae22e791544392c$export$994f7af6d0b36256).ACCOUNT:
            case (0, $bae22e791544392c$export$994f7af6d0b36256).ROLE:
                payload.cert_rolekey = nodeData.CERT_ROLEKEY;
                if (reassignPayload?.isIncludeAssociateChecked) payload.reassignAssociated = reassignPayload.isIncludeAssociateChecked.toString();
                if (nodeData.CERT_ACCOUNTKEY) payload.cert_accountkey = nodeData.CERT_ACCOUNTKEY;
                break;
            case (0, $bae22e791544392c$export$994f7af6d0b36256).ENTITLEMENT:
            default:
                if ((0, $bae22e791544392c$export$994f7af6d0b36256).ENTITLEMENT >= 0) {
                    if (reassignPayload?.isIncludeAssociateChecked) payload.reassignAssociated = reassignPayload.isIncludeAssociateChecked.toString();
                }
                if (nodeData.CERT_ACCOUNTKEY) payload.cert_accountkey = nodeData.CERT_ACCOUNTKEY;
                break;
        }
        const dispatchReassign = ()=>dispatchActionHandler((0, $20281fe09bc700a8$export$3f43cf8434698562).REASSIGN, isReassign, isReassign ? (0, $d623f23401a154f0$export$627e0e03ed6c2927) : (0, $d623f23401a154f0$export$29d12c975855399), payload);
        // Tile on click
        if (isDetailsGroup) dispatchReassign();
        // Footer on click
        if (isFooterGroup) {
            setIsSidePanelCommentDrawerOpen(!isSidePanelCommentDrawerOpen);
            setDrawerActionKind((0, $20281fe09bc700a8$export$3f43cf8434698562).REASSIGN);
            dispatchReassign();
        }
    };
    // Handling Change End Date api dispatch actions for Account,Entitlement and Role
    const handleConditionalCertifiy = (getDate, comment)=>{
        const commentValue = comment && comment.length > 0 ? comment : "Extend end date again";
        let currentDate = new Date();
        const dd = currentDate.getDate();
        const mm = currentDate.getMonth() + 1;
        const yyyy = currentDate.getFullYear();
        currentDate = `${mm < 10 ? `0${mm}` : mm}-${dd < 10 ? `0${dd}` : dd}-${yyyy}`;
        let payload;
        if (entValueKey <= 0) payload = {
            accountKey: accountKey,
            certKey: certKey,
            userKey: userKey,
            entValueKey: entValueKey,
            certRoleKey: nodeData?.CERT_ROLEKEY,
            status: isConditionalCertifiy ? (0, $20281fe09bc700a8$export$6bf521f24032eb49).RESET : (0, $20281fe09bc700a8$export$6bf521f24032eb49).CONDITIONAL_CERTIFIY,
            extendedEndDate: getDate && getDate.length > 0 ? getDate : currentDate,
            comments: commentValue
        };
        else payload = {
            accountKey: accountKey,
            certKey: certKey,
            userKey: userKey,
            entValueKey: entValueKey,
            status: isConditionalCertifiy ? (0, $20281fe09bc700a8$export$6bf521f24032eb49).RESET : (0, $20281fe09bc700a8$export$6bf521f24032eb49).CONDITIONAL_CERTIFIY,
            extendedEndDate: getDate && getDate.length > 0 ? getDate : currentDate,
            comments: commentValue
        };
        const dispatchConditionalCertify = ()=>dispatchActionHandler((0, $20281fe09bc700a8$export$3f43cf8434698562).CONDITIONAL_CERTIFIY, isConditionalCertifiy, (0, $d623f23401a154f0$export$9f62cbf6b3b94af9), payload);
        // Tile on click
        if (isDetailsGroup) dispatchConditionalCertify();
        // Footer on click
        if (isFooterGroup) {
            if (!isConditionalCertifiy) {
                setIsSidePanelCommentDrawerOpen(!isSidePanelCommentDrawerOpen);
                setDrawerActionKind((0, $20281fe09bc700a8$export$3f43cf8434698562).CONDITIONAL_CERTIFIY);
            }
            if (commentValue?.length >= 3) dispatchConditionalCertify();
        }
    };
    const handleConsultWithPeers = (consultPayload)=>{
        const payload = {
            eid: nodeData.id,
            certkey: certKey,
            cert_userkey: nodeData.CERT_USERKEY,
            cert_entitlement_valuekey: nodeData.CERT_ENTITLEMENT_VALUEKEY,
            requestOrigin: "UI"
        };
        if (consultPayload?.commentValue) payload.comments = consultPayload?.commentValue;
        if (consultPayload?.selectedUser && consultPayload.selectedUser?.value !== consultPayload.defaultReassignee && !consultPayload?.isSkipCertifierChecked) payload.assignee = consultPayload?.selectedUser?.value;
        switch(nodeData?.CERT_ENTITLEMENT_VALUEKEY){
            case (0, $bae22e791544392c$export$994f7af6d0b36256).USER:
                break;
            case (0, $bae22e791544392c$export$994f7af6d0b36256).ACCOUNT:
            case (0, $bae22e791544392c$export$994f7af6d0b36256).ROLE:
                if (nodeData?.CERT_ENTITLEMENT_VALUEKEY === (0, $bae22e791544392c$export$994f7af6d0b36256).ROLE) payload.cert_rolekey = nodeData.CERT_ROLEKEY; // not required in account level
                if (consultPayload?.isIncludeAssociateChecked) payload.reassignAssociated = consultPayload.isIncludeAssociateChecked.toString();
                if (nodeData?.CERT_ACCOUNTKEY) payload.cert_accountkey = nodeData.CERT_ACCOUNTKEY;
                break;
            case (0, $bae22e791544392c$export$994f7af6d0b36256).ENTITLEMENT:
            default:
                if ((0, $bae22e791544392c$export$994f7af6d0b36256).ENTITLEMENT >= 0) {
                    if (consultPayload?.isIncludeAssociateChecked) payload.reassignAssociated = consultPayload.isIncludeAssociateChecked.toString();
                }
                if (nodeData.CERT_ACCOUNTKEY) payload.cert_accountkey = nodeData.CERT_ACCOUNTKEY;
                break;
        }
        const dispatchConsult = ()=>dispatchActionHandler((0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT, isConsult, (0, $d623f23401a154f0$export$3f4330c48a705a7a), payload);
        // Tile on click
        if (isDetailsGroup) dispatchConsult();
        // Footer on click
        if (isFooterGroup) {
            setIsSidePanelCommentDrawerOpen(!isSidePanelCommentDrawerOpen);
            setDrawerActionKind((0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT);
            dispatchConsult();
        }
    };
    const handleDoesNotWorksForMe = (reassignPayload)=>{
        // console.log("handle Reassign user payload", reassignPayload, nodeData);
        const payload = {
            certkey: certKey,
            cert_userkey: nodeData.CERT_USERKEY,
            cert_entitlement_valuekey: nodeData.CERT_ENTITLEMENT_VALUEKEY,
            comments: reassignPayload?.commentValue
        };
        //  When resetting the reassign for user lineitem
        if (isDoesNotWorksForMe) {
            payload.status = "0";
            payload.comments = reassignPayload?.commentValue ? reassignPayload?.commentValue : "Reassign";
        }
        if (reassignPayload?.selectedUser && reassignPayload.selectedUser?.value !== reassignConfigMap.defaultReassignee && !reassignPayload?.isSkipCertifierChecked) payload.assignee = reassignPayload?.selectedUser?.value;
        else if (reassignPayload?.isSkipCertifierChecked) // when skip certifier is checked for user lineitem
        payload.status = (0, $20281fe09bc700a8$export$6bf521f24032eb49).REVOKED;
        const dispatchReassignDoesNotWorkForMe = ()=>dispatchActionHandler((0, $20281fe09bc700a8$export$3f43cf8434698562).DOES_NOT_WORK_FOR_ME, isDoesNotWorksForMe, isDoesNotWorksForMe ? (0, $d623f23401a154f0$export$627e0e03ed6c2927) : (0, $d623f23401a154f0$export$29d12c975855399), payload);
        // Tile on click
        if (isDetailsGroup) dispatchReassignDoesNotWorkForMe();
        // Footer on click
        if (isFooterGroup) {
            setIsSidePanelCommentDrawerOpen(!isSidePanelCommentDrawerOpen);
            setDrawerActionKind((0, $20281fe09bc700a8$export$3f43cf8434698562).DOES_NOT_WORK_FOR_ME);
            dispatchReassignDoesNotWorkForMe();
        }
    };
    // const handleConditionalCertifiy = () => Logger.log('WIP Action Button');
    // const handleDoesNotWorksForMe = () => Logger.log('WIP Action Button');
    const tooltipPostion = isDetailsGroup ? "left" : "top";
    const tooltipDelay = isDetailsGroup ? $f7cd7b23cff7a54f$var$TOOLTIP_DELAY_IN_MS_TILE : $f7cd7b23cff7a54f$var$TOOLTIP_DELAY_IN_MS_SIDEPANEL;
    const getTooltipText = (defaultText, isDisabled)=>{
        if (groupTooltipText) return groupTooltipText;
        if (isDisabled) return "";
        return defaultText;
    };
    const setReassignUserPopoverMsg = ()=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$7fbc63266c535cea)
        });
    };
    const actionButtons = {
        approve: {
            id: (0, $20281fe09bc700a8$export$3f43cf8434698562).APPROVE,
            kind: (0, $20281fe09bc700a8$export$3f43cf8434698562).APPROVE,
            onClick: handleApprove,
            isSelected: isApprove,
            isLoading: isApproveLoading,
            isDisabled: isApproveDisabled,
            shouldBeRemoved: isApproveRemove,
            tooltipProperties: {
                openDelay: tooltipDelay,
                placement: tooltipPostion,
                text: getTooltipText(isApprove ? "Cancel Approval" : "Approve", isApproveDisabled)
            }
        },
        reject: {
            id: (0, $20281fe09bc700a8$export$3f43cf8434698562).REJECT,
            kind: (0, $20281fe09bc700a8$export$3f43cf8434698562).REJECT,
            onClick: handleRejectAction,
            isSelected: isReject,
            isLoading: isRejectLoading,
            isDisabled: isRejectDisabled,
            shouldBeRemoved: isRejectRemove,
            tooltipProperties: {
                openDelay: tooltipDelay,
                placement: tooltipPostion,
                text: getTooltipText(isReject ? "Cancel Rejection" : "Reject", isRejectDisabled)
            }
        },
        terminated: {
            id: (0, $20281fe09bc700a8$export$3f43cf8434698562).TERMINATE,
            kind: (0, $20281fe09bc700a8$export$3f43cf8434698562).TERMINATE,
            onClick: handleTerminate,
            isSelected: isTerminate,
            isLoading: isTerminateLoading,
            isDisabled: isTerminateDisabled,
            shouldBeRemoved: isTerminateRemove,
            tooltipProperties: {
                openDelay: tooltipDelay,
                placement: tooltipPostion,
                text: getTooltipText(isTerminate ? "Cancel Termination" : "Terminate", isTerminateDisabled)
            }
        },
        reassign: {
            id: (0, $20281fe09bc700a8$export$3f43cf8434698562).REASSIGN,
            kind: (0, $20281fe09bc700a8$export$3f43cf8434698562).REASSIGN,
            onClick: handleReassign,
            isSelected: isReassign,
            isLoading: isReassignLoading,
            isDisabled: isReassignDisabled,
            shouldBeRemoved: isReassignRemove,
            tooltipProperties: {
                openDelay: tooltipDelay,
                placement: tooltipPostion,
                text: getTooltipText("Reassign", isReassignDisabled)
            }
        },
        consult: {
            id: (0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT,
            kind: (0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT,
            onClick: handleConsultWithPeers,
            isSelected: isConsult,
            isLoading: isConsultLoading,
            isDisabled: isConsultDisabled,
            shouldBeRemoved: isConsultRemove,
            tooltipProperties: {
                openDelay: tooltipDelay,
                placement: tooltipPostion,
                text: getTooltipText("Consult with Peers", isConsultDisabled)
            }
        },
        worksForMe: {
            id: (0, $20281fe09bc700a8$export$3f43cf8434698562).WORKS_FOR_ME,
            kind: (0, $20281fe09bc700a8$export$3f43cf8434698562).WORKS_FOR_ME,
            onClick: handleWorksForMe,
            isSelected: isWorksForMe,
            isLoading: isWorksForMeLoading,
            isDisabled: isWorksForMeDisabled,
            shouldBeRemoved: isWorksForMeRemove,
            tooltipProperties: {
                openDelay: tooltipDelay,
                placement: tooltipPostion,
                text: getTooltipText(isWorksForMe ? "Cancel Manager Confirmation" : "Confirm Manager", isWorksForMeDisabled)
            }
        },
        doesNotWorksForMe: {
            id: (0, $20281fe09bc700a8$export$3f43cf8434698562).DOES_NOT_WORK_FOR_ME,
            kind: (0, $20281fe09bc700a8$export$3f43cf8434698562).DOES_NOT_WORK_FOR_ME,
            onClick: handleDoesNotWorksForMe,
            isSelected: isDoesNotWorksForMe,
            isLoading: isDoesNotWorksForMeLoading,
            isDisabled: isDoesNotWorksForMeDisabled,
            shouldBeRemoved: isDoesNotWorksForMeRemove,
            tooltipProperties: {
                openDelay: tooltipDelay,
                placement: tooltipPostion,
                text: getTooltipText("Does Not Works For Me", isDoesNotWorksForMeDisabled)
            }
        },
        extendEndDate: {
            id: (0, $20281fe09bc700a8$export$3f43cf8434698562).EXTEND_END_DATE,
            kind: (0, $20281fe09bc700a8$export$3f43cf8434698562).EXTEND_END_DATE,
            onClick: handleExtendEndDate,
            isSelected: isExtendEndDate,
            isLoading: isExtendEndDateLoading,
            isDisabled: isExtendEndDateDisabled,
            shouldBeRemoved: isExtendEndDateRemove,
            tooltipProperties: {
                openDelay: tooltipDelay,
                placement: tooltipPostion,
                text: getTooltipText(isExtendEndDate ? "Cancel End Date Change" : "Change End Date", isExtendEndDateDisabled)
            }
        },
        conditionalCertifiy: {
            id: (0, $20281fe09bc700a8$export$3f43cf8434698562).CONDITIONAL_CERTIFIY,
            kind: (0, $20281fe09bc700a8$export$3f43cf8434698562).CONDITIONAL_CERTIFIY,
            onClick: handleConditionalCertifiy,
            isSelected: isConditionalCertifiy,
            isLoading: isConditionalCertifiyLoading,
            isDisabled: isConditionalCertifiyDisabled,
            shouldBeRemoved: isConditionalCertifyRemove,
            tooltipProperties: {
                openDelay: tooltipDelay,
                placement: tooltipPostion,
                text: getTooltipText(isConditionalCertifiy ? "Cancel End Date Change" : "Change End Date", isConditionalCertifiyDisabled)
            }
        }
    };
    const handleSubmitFunctions = {
        [(0, $20281fe09bc700a8$export$3f43cf8434698562).APPROVE]: handleApprove,
        [(0, $20281fe09bc700a8$export$3f43cf8434698562).REJECT]: handleRejectAction,
        [(0, $20281fe09bc700a8$export$3f43cf8434698562).TERMINATE]: handleTerminate,
        [(0, $20281fe09bc700a8$export$3f43cf8434698562).REASSIGN]: handleReassign,
        [(0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT]: handleConsultWithPeers,
        [(0, $20281fe09bc700a8$export$3f43cf8434698562).WORKS_FOR_ME]: handleWorksForMe,
        [(0, $20281fe09bc700a8$export$3f43cf8434698562).DOES_NOT_WORK_FOR_ME]: handleDoesNotWorksForMe,
        [(0, $20281fe09bc700a8$export$3f43cf8434698562).EXTEND_END_DATE]: handleExtendEndDate,
        [(0, $20281fe09bc700a8$export$3f43cf8434698562).CONDITIONAL_CERTIFIY]: handleConditionalCertifiy
    };
    const getReusableActionsMap = ()=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            tag: "div",
            className: kindClasses,
            dataTestId: dataTestId,
            children: actionButtonsMap && actionButtonsMap?.length > 0 && actionButtonsMap?.map((buttonKey, index)=>{
                const buttonConfig = actionButtons[buttonKey];
                const isNotTabbable = index >= $f7cd7b23cff7a54f$var$MIN_BUTTONS_FOR_KABOB && !isActionGroupExpanded;
                const getIsCommentRequired = ()=>{
                    // User
                    if ((0, $bae22e791544392c$export$994f7af6d0b36256).USER === entValueKey && (0, $20281fe09bc700a8$export$3f43cf8434698562).WORKS_FOR_ME === buttonConfig.id) return enableCommentsUsers.includes((0, $20281fe09bc700a8$export$80dc2c0ddeaedcb2).WORKS_FOR_ME);
                    if ((0, $bae22e791544392c$export$994f7af6d0b36256).USER === entValueKey && (0, $20281fe09bc700a8$export$3f43cf8434698562).DOES_NOT_WORK_FOR_ME === buttonConfig.id) return enableCommentsUsers.includes((0, $20281fe09bc700a8$export$80dc2c0ddeaedcb2).DOES_NOT_WORK_FOR_ME);
                    // Acounts, Entitilements, Roles
                    if ((0, $bae22e791544392c$export$994f7af6d0b36256).USER !== entValueKey && (0, $20281fe09bc700a8$export$3f43cf8434698562).APPROVE === buttonConfig.id) return enableCommentsAccEntRole.includes((0, $20281fe09bc700a8$export$69894cdd9841cdfb).APPROVE);
                    if ((0, $bae22e791544392c$export$994f7af6d0b36256).USER === entValueKey && (0, $20281fe09bc700a8$export$3f43cf8434698562).TERMINATE === buttonConfig.id) return enableCommentsUsers.includes((0, $20281fe09bc700a8$export$80dc2c0ddeaedcb2).TERMINATED);
                    if ((0, $bae22e791544392c$export$994f7af6d0b36256).USER !== entValueKey && (0, $20281fe09bc700a8$export$3f43cf8434698562).REASSIGN === buttonConfig.id) return enableCommentsAccEntRole.includes((0, $20281fe09bc700a8$export$80dc2c0ddeaedcb2).REASSIGN);
                    if ((0, $bae22e791544392c$export$994f7af6d0b36256).USER === entValueKey && (0, $20281fe09bc700a8$export$3f43cf8434698562).EXTEND_END_DATE === buttonConfig.id) return enableCommentsUsers.includes((0, $20281fe09bc700a8$export$80dc2c0ddeaedcb2).EXTEND_END_DATE);
                    if ((0, $bae22e791544392c$export$994f7af6d0b36256).USER !== entValueKey && (0, $20281fe09bc700a8$export$3f43cf8434698562).REJECT === buttonConfig.id) return enableCommentsAccEntRole.includes((0, $20281fe09bc700a8$export$69894cdd9841cdfb).REJECT);
                    return false;
                };
                if (!buttonConfig) {
                    (0, $hopDi$Logger).warn(`No configuration found for button: ${buttonKey}`);
                    return null;
                }
                const { id: id, kind: actionkind, onClick: onClick, isSelected: isSelected, isLoading: isLoading, isDisabled: isDisabled, shouldBeRemoved: shouldBeRemoved, tooltipProperties: tooltipProperties } = buttonConfig;
                return /*#__PURE__*/ (0, $hopDi$jsx)((0, $57da59531dca7c37$export$2e2bcd8739ae039), {
                    id: id,
                    setIsActionPopoverOpen: setIsActionPopoverOpen,
                    kind: actionkind,
                    groupKind: kind,
                    onClick: onClick,
                    isSelected: isSelected,
                    isLoading: isLoading,
                    isDisabled: isDisabled || isGroupDisabled || !disableButtonsMap?.join(",")?.includes(id) || disableButtonsMap?.length === 0 && actionButtonsMap?.join(",")?.includes(id),
                    isToolTipDisabled: shouldBeRemoved,
                    tooltipProperties: tooltipProperties,
                    tabIndex: isDetailsGroup && isNotTabbable ? -1 : 0,
                    isCommentRequired: getIsCommentRequired(),
                    isHidden: isDetailsGroup && isNotTabbable,
                    getViewApiConfigmap: getViewApiConfigmap,
                    extendEndDateDaysLimit: getViewApiConfigmap?.ExtendEndDateDaysLimit && getViewApiConfigmap?.ExtendEndDateDaysLimit?.length > 0 ? getViewApiConfigmap?.ExtendEndDateDaysLimit : "",
                    nodeData: nodeData,
                    isActionSuccess: isActionSuccess,
                    isActionError: isActionError,
                    isActionErrorMessage: isActionErrorMessage,
                    userKey: userKey,
                    getTypeActEntRole: getTypeActEntRole(),
                    isSidePanelVisible: isSidePanelVisible,
                    reassignConfigMap: reassignConfigMap,
                    getFirstTimeReject: getFirstTimeReject,
                    certificationStartDate: certificationStartDate?.split(" ")[0],
                    conditionalCertifyDaysLimit: getViewApiConfigmap?.ConditionallyCertifyInDaysLimit && getViewApiConfigmap?.ConditionallyCertifyInDaysLimit?.length > 0 ? getViewApiConfigmap?.ConditionallyCertifyInDaysLimit : "",
                    isPopoverUserReassignMsgShown: isPopoverUserReassignMsgShown,
                    setReassignUserPopoverMsg: setReassignUserPopoverMsg,
                    isSaviResponded: isSaviResponded,
                    saviRespondedReason: saviRespondedReason
                }, id);
            })
        });
    if (isFooterGroup) return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
        tag: "div",
        className: "CertsActionButtonsGroup-footerGroup",
        children: [
            getReusableActionsMap(),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $94e77a9d2fb3d728$export$2e2bcd8739ae039), {
                isSidePanelCommentDrawerOpen: isSidePanelCommentDrawerOpen,
                setIsSidePanelCommentDrawerOpen: setIsSidePanelCommentDrawerOpen,
                drawerActionKind: drawerActionKind,
                onSubmit: handleSubmitFunctions[drawerActionKind] || (()=>{}),
                getTypeActEntRole: getTypeActEntRole()
            })
        ]
    });
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
        tag: "div",
        className: actionButtonWrapperClasses,
        children: [
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                tag: "div",
                className: actionButtonGroupClasses,
                children: [
                    getReusableActionsMap(),
                    actionButtonsMap && actionButtonsMap?.length > 0 && actionButtonsMap?.length > $f7cd7b23cff7a54f$var$MIN_BUTTONS_FOR_KABOB && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                        kind: "ghost",
                        size: "small",
                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: isActionGroupExpanded ? "ExpandRight" : "MoreVertical"
                        }),
                        onClick: ()=>setIsActionGroupExpanded(!isActionGroupExpanded)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                className: "CertsActionButtonsGroup-overlay"
            })
        ]
    });
}
$f7cd7b23cff7a54f$var$CertsActionButtonsGroup.defaultProps = {
    handleSidePanelAction: ()=>{},
    groupTooltipText: null,
    isActionGroupExpanded: null,
    setIsActionGroupExpanded: ()=>{},
    setIsActionPopoverOpen: ()=>{},
    // Unit testing
    dataTestId: null,
    saviRespondedReason: []
};
$f7cd7b23cff7a54f$var$CertsActionButtonsGroup.propTypes = {
    kind: (0, $hopDi$proptypes).oneOf(Object.values((0, $20281fe09bc700a8$export$758743ec42a300f1))).isRequired,
    isGroupDisabled: (0, $hopDi$proptypes).bool.isRequired,
    nodeData: (0, $hopDi$proptypes).shape((0, $ddbc2f861c0388ff$export$3e7926703ac20a93)).isRequired,
    handleSidePanelAction: (0, $hopDi$proptypes).func,
    groupTooltipText: (0, $hopDi$proptypes).string,
    isActionGroupExpanded: (0, $hopDi$proptypes).bool,
    setIsActionGroupExpanded: (0, $hopDi$proptypes).func,
    setIsActionPopoverOpen: (0, $hopDi$proptypes).func,
    // ----- Utilities -----
    setMergedLists: (0, $hopDi$proptypes).func.isRequired,
    dataTestId: (0, $hopDi$proptypes).string,
    isSaviResponded: (0, $hopDi$proptypes).bool.isRequired,
    saviRespondedReason: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string)
};
var $f7cd7b23cff7a54f$export$2e2bcd8739ae039 = $f7cd7b23cff7a54f$var$CertsActionButtonsGroup;




var $2ee72dee6e5b726b$export$2e2bcd8739ae039 = (0, $f7cd7b23cff7a54f$export$2e2bcd8739ae039);








/* eslint-disable react/jsx-curly-spacing */ /* eslint-disable react/jsx-curly-newline */ /* eslint-disable indent */ 












/* eslint-disable no-unused-vars */ 




const $60e28faa4cf9b9fa$export$a1d1a2dbce5ef265 = {
    warning: "warning",
    success: "success",
    critical: "critical"
};
const $60e28faa4cf9b9fa$export$93499b93a6aaed41 = {
    outlined: "outlined",
    plain: "plain"
};
const $60e28faa4cf9b9fa$export$57732b6846a8df7c = {
    small: "small",
    regular: "regular"
};
const $60e28faa4cf9b9fa$export$77f67d0acb1506cb = {
    width: 75,
    height: 75,
    baseSpanInDegree: 250,
    strokeWidth: 7
};
const $60e28faa4cf9b9fa$export$eec0d2dd696ca943 = {
    width: 50,
    height: 50,
    baseSpanInDegree: 200,
    strokeWidth: 5
};
const $60e28faa4cf9b9fa$export$1630b5343357e8b5 = {
    [$60e28faa4cf9b9fa$export$57732b6846a8df7c.small]: $60e28faa4cf9b9fa$export$eec0d2dd696ca943,
    [$60e28faa4cf9b9fa$export$57732b6846a8df7c.regular]: $60e28faa4cf9b9fa$export$77f67d0acb1506cb
};


const $4631ad19de1cc617$export$8ffc5d9dc47527cf = (cX, cY, rad, angleInDegrees)=>{
    const angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
    return {
        x: cX + rad * Math.cos(angleInRadians),
        y: cY + rad * Math.sin(angleInRadians)
    };
};
const $4631ad19de1cc617$export$419276ee4f979de5 = (x, y, rad, startAngle, endAngle)=>{
    const start = $4631ad19de1cc617$export$8ffc5d9dc47527cf(x, y, rad, endAngle);
    const end = $4631ad19de1cc617$export$8ffc5d9dc47527cf(x, y, rad, startAngle);
    const path = [
        `M ${start.x} ${start.y}`,
        `A ${rad} ${rad} 0 ${endAngle - startAngle <= 180 ? "0" : "1"} 0 ${end.x} ${end.y}`
    ].join(" ");
    return path;
};



function $9c7747fdd807b112$var$RiskScore({ kind: kind, size: size, value: value, label: label, chipKind: chipKind, className: className }) {
    const [svgDimensions, setSvgDimensions] = (0, $hopDi$useState)((0, $60e28faa4cf9b9fa$export$1630b5343357e8b5)[size]);
    const [percentage, setPercentage] = (0, $hopDi$useState)(value ? Math.min(100, Math.max(0, value)) : 40);
    const progressStatsIconIndicator = (0, $hopDi$classnames)("RiskScore-progressStatsIconIndicator", `RiskScore-progressStatsIconIndicator--${kind}`, className);
    const progressStatsNumberColor = (0, $hopDi$classnames)(`RiskScore-progressStatsNumberColor--${kind}`);
    const progressStatsLabelColor = (0, $hopDi$classnames)(`RiskScore-progressLabel--${kind}`);
    return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
        className: `RiskScore--${size}`,
        children: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: "RiskScore-wrapper",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "RiskScore-progressStats",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                            className: "RiskScore-progressStatsIcon",
                            children: /*#__PURE__*/ (0, $hopDi$jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: svgDimensions.width,
                                height: svgDimensions.height,
                                viewBox: `0 0 ${svgDimensions.width} ${svgDimensions.height}`,
                                fill: "none",
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsx)("path", {
                                        d: (0, $4631ad19de1cc617$export$419276ee4f979de5)(parseInt(svgDimensions.width / 2, 10), parseInt(svgDimensions.height / 2, 10), parseInt(svgDimensions.width / 2 - svgDimensions.strokeWidth, 10), -parseInt(svgDimensions.baseSpanInDegree / 2, 10), parseInt(svgDimensions.baseSpanInDegree / 2, 10)),
                                        fill: "none",
                                        stroke: "#EBECF2",
                                        strokeWidth: svgDimensions.strokeWidth,
                                        strokeLinecap: "round"
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)("path", {
                                        className: progressStatsIconIndicator,
                                        d: (0, $4631ad19de1cc617$export$419276ee4f979de5)(parseInt(svgDimensions.width / 2, 10), parseInt(svgDimensions.height / 2, 10), parseInt(svgDimensions.width / 2 - svgDimensions.strokeWidth, 10), -parseInt(svgDimensions.baseSpanInDegree / 2, 10), -parseInt(svgDimensions.baseSpanInDegree / 2, 10) + percentage / 100 * svgDimensions.baseSpanInDegree),
                                        fill: "none",
                                        stroke: "#028329",
                                        strokeWidth: svgDimensions.strokeWidth,
                                        strokeLinecap: "round"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                            className: "RiskScore-progressStatsNumber",
                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: size === (0, $60e28faa4cf9b9fa$export$57732b6846a8df7c).regular ? "h2" : "body2",
                                className: progressStatsNumberColor,
                                children: percentage
                            })
                        })
                    ]
                }),
                size === (0, $60e28faa4cf9b9fa$export$57732b6846a8df7c).small && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "RiskScore-progressChip--small",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body3",
                        className: progressStatsLabelColor,
                        children: label
                    })
                }),
                size === (0, $60e28faa4cf9b9fa$export$57732b6846a8df7c).regular && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "RiskScore-progressChip--regular",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Chip), {
                        kind: chipKind,
                        label: label,
                        size: "small",
                        color: kind
                    })
                })
            ]
        })
    });
}
$9c7747fdd807b112$var$RiskScore.propTypes = {
    kind: (0, $hopDi$proptypes).oneOf(Object.values((0, $60e28faa4cf9b9fa$export$a1d1a2dbce5ef265))),
    size: (0, $hopDi$proptypes).oneOf(Object.values((0, $60e28faa4cf9b9fa$export$57732b6846a8df7c))),
    value: (0, $hopDi$proptypes).number,
    label: (0, $hopDi$proptypes).string,
    chipKind: (0, $hopDi$proptypes).oneOf(Object.values((0, $60e28faa4cf9b9fa$export$93499b93a6aaed41))),
    className: (0, $hopDi$proptypes).string
};
$9c7747fdd807b112$var$RiskScore.defaultProps = {
    kind: (0, $60e28faa4cf9b9fa$export$a1d1a2dbce5ef265).success,
    size: (0, $60e28faa4cf9b9fa$export$57732b6846a8df7c).small,
    value: 40,
    label: "None",
    chipKind: (0, $60e28faa4cf9b9fa$export$93499b93a6aaed41).outlined,
    className: null
};
var $9c7747fdd807b112$export$2e2bcd8739ae039 = $9c7747fdd807b112$var$RiskScore;


var $d890b5a3788f0783$export$2e2bcd8739ae039 = (0, $9c7747fdd807b112$export$2e2bcd8739ae039);





function $cdc016b7003fff2a$var$Tile({ data: data, level: level, handleSidePanel: handleSidePanel, nodeData: nodeData, setMergedLists: setMergedLists }) {
    const intl = (0, $hopDi$useIntl)();
    const dispatch = (0, $hopDi$useDispatch)();
    // isExpanded
    const [isCheckingIntoSession, setIsCheckingIntoSession] = (0, $hopDi$useState)(false);
    const [isActionGroupExpanded, setIsActionGroupExpanded] = (0, $hopDi$useState)(false);
    const [isStuck, setIsStuck] = (0, $hopDi$useState)(false);
    const [isActionPopoverOpen, setIsActionPopoverOpen] = (0, $hopDi$useState)("");
    const tileRef = (0, $hopDi$useRef)(null);
    const { certKey: certKey, isLoading: isLoading, bulkAction: bulkAction, isAuditor: isAuditor, isSidePanelVisible: isSidePanelVisible, shouldShowReviewAndSubmitButton: shouldShowReviewAndSubmitButton } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    // Tile Scoped Variables
    const isCheckboxVisible = Boolean(isCheckingIntoSession || nodeData?.tracker?.isChecked || nodeData?.tracker?.isIndeterminate || bulkAction?.atleastOneIsSelected);
    const isTileSidepanelSelected = nodeData?.tracker?.isConnected;
    const certsKind = (0, $4c1aa6449628783a$export$c40b9342a19db0b6)(nodeData);
    const fixedColKey = (0, $4c1aa6449628783a$export$18b54358355494a)(certsKind);
    const shouldBeRemovedFlag = (0, $e7628c995f405891$export$9ca4f3ab69295cac)(nodeData?.tracker?.actions);
    const actionButtonsMap = nodeData?.availableAction && Object.keys(nodeData?.availableAction);
    const trackerId = nodeData?.tracker?.id;
    const shouldDisableWhileCallingActionApis = (0, $4c1aa6449628783a$export$57d225e2d2f6fa1f)(nodeData?.tracker?.actions);
    const shouldDisableActionBtns = Boolean(bulkAction?.atleastOneIsSelected || bulkAction?.isChecked || bulkAction?.isDisabled || bulkAction?.isSubmittingAction || isCheckingIntoSession || shouldBeRemovedFlag || shouldDisableWhileCallingActionApis || isAuditor);
    const shouldShowGroupToolTip = Boolean(bulkAction?.atleastOneIsSelected || bulkAction?.isChecked || bulkAction?.isDisabled && !bulkAction?.isSubmittingAction);
    const isSaviResponded = Boolean(nodeData?.savi_responded && nodeData?.savi_responded === "1");
    let saviRespondedReason = [];
    if (isSaviResponded && nodeData?.savi_reason && nodeData?.savi_reason.length > 0) saviRespondedReason = nodeData?.savi_reason;
    // Conditional Classes
    const tileClasses = (0, $hopDi$classnames)("Tile", `Tile--${level}`, isSidePanelVisible && "Tile--isSidePanelVisible", isTileSidepanelSelected && "Tile--isTileSidepanelSelected", isStuck && "Tile--isStuck", isActionPopoverOpen && "Tile--isActionPopoverOpen", shouldBeRemovedFlag && "Tile--disablePointerEvents", isSaviResponded && "Tile--DashedBorder");
    const leftHoverSideClasses = (0, $hopDi$classnames)("Tile-leftHoverSide", `Tile-leftHoverSide--${level}`, nodeData?.tracker?.isConnected && "Tile-leftHoverSide--isSidePanelOpen");
    // Within Hover Area
    const tileCheckHoverDisplayBtn = (0, $hopDi$classnames)("Tile-checkboxHoverDisplay", bulkAction?.isDisabled && "Tile-checkboxHoverDisplay--disabled");
    const tileCheckboxClasses = (0, $hopDi$classnames)("Tile-checkbox", isCheckboxVisible && "Tile-checkbox--isCheckboxVisible");
    const tileCheckboxIconClasses = (0, $hopDi$classnames)("Tile-checkboxIcon", isCheckboxVisible && "Tile-checkboxIcon--isCheckboxVisible");
    const actionButtonGroupClasses = (0, $hopDi$classnames)("Tile-actionButtonGroup", isActionGroupExpanded && "Tile-actionButtonGroup--isExpanded", actionButtonsMap?.length && `Tile-actionButtonGroup--length${actionButtonsMap.length}`);
    (0, $hopDi$useEffect)(()=>{
        const certsDetailsList = document.getElementById("certsDetailsList");
        const checkPosition = ()=>{
            const stickyContainer = tileRef.current;
            if (!stickyContainer) return;
            const containerTop = stickyContainer.getBoundingClientRect().top;
            setIsStuck(false);
            // Define the conditions for each tile type
            const conditionsTile0 = [
                (0, $bae22e791544392c$export$237a15c17615452d).LEVEL_0.NO_CONTROLS,
                (0, $bae22e791544392c$export$237a15c17615452d).LEVEL_0.CONTROLS_VISIBLE,
                (0, $bae22e791544392c$export$237a15c17615452d).LEVEL_0.SIDEPANEL_ADVANCED_CONTROLS
            ];
            const conditionsTile1 = [
                (0, $bae22e791544392c$export$237a15c17615452d).LEVEL_1.NO_CONTROLS,
                (0, $bae22e791544392c$export$237a15c17615452d).LEVEL_1.CONTROLS_VISIBLE,
                (0, $bae22e791544392c$export$237a15c17615452d).LEVEL_1.SIDEPANEL_ADVANCED_CONTROLS
            ];
            const conditionsTile2 = [
                (0, $bae22e791544392c$export$237a15c17615452d).LEVEL_2.NO_CONTROLS,
                (0, $bae22e791544392c$export$237a15c17615452d).LEVEL_2.CONTROLS_VISIBLE,
                (0, $bae22e791544392c$export$237a15c17615452d).LEVEL_2.SIDEPANEL_ADVANCED_CONTROLS
            ];
            // Check for Tile--0
            if (stickyContainer.classList.contains("Tile--0") && conditionsTile0.includes(containerTop)) setIsStuck(true);
            // Check for Tile--1
            if (stickyContainer.classList.contains("Tile--1") && (containerTop <= conditionsTile1[0] || conditionsTile1.includes(containerTop))) setIsStuck(true);
            // Check for Tile--1
            if (stickyContainer.classList.contains("Tile--2") && (containerTop <= conditionsTile2[0] || conditionsTile2.includes(containerTop))) setIsStuck(true);
        };
        certsDetailsList.addEventListener("scroll", checkPosition);
        return ()=>{
            certsDetailsList.removeEventListener("scroll", checkPosition);
        };
    }, []);
    (0, $hopDi$useEffect)(()=>{
        if (isSidePanelVisible === false) setMergedLists((prev)=>(0, $4c1aa6449628783a$export$f87a1650caa3642b)(prev));
    }, [
        isSidePanelVisible
    ]);
    const handleSidePanelOpening = (0, $hopDi$useCallback)((id, connectedBarLevel)=>{
        handleSidePanel();
        setMergedLists((prevMergedLists)=>(0, $4c1aa6449628783a$export$86c6573c35d84094)(prevMergedLists, id, connectedBarLevel));
    }, [
        data
    ]);
    const handleTileClick = (e)=>{
        if (!shouldBeRemovedFlag) {
            if (e?.target?.parentNode?.id === (0, $883fa4dd903b96ab$export$fd41194cca4d2bb5)) {
                const payload = {
                    CERT_USERKEY: nodeData?.CERT_USERKEY,
                    CERT_ROLEKEY: nodeData?.CERT_ROLEKEY,
                    CERT_ACCOUNTKEY: nodeData?.CERT_ACCOUNTKEY,
                    CERT_ENTITLEMENT_VALUEKEY: nodeData?.CERT_ENTITLEMENT_VALUEKEY
                };
                dispatch((0, $d623f23401a154f0$export$6905b0d830e88406)(true, payload));
                return;
            }
            handleSidePanelOpening(trackerId, nodeData.tracker.level);
        }
    };
    const handleKeyDownTile = (e)=>{
        if (e.key === "Enter") {
            e.preventDefault();
            handleTileClick();
        }
    };
    const handleTileCheck = (0, $hopDi$useCallback)((prev, id, tileLevel)=>{
        const prevMergedLists = prev.map((item)=>{
            if (id === null || tileLevel === null) return item;
            if (item.tracker.level !== tileLevel) return {
                ...item,
                children: item?.children?.length > 0 ? handleTileCheck(item.children, id, tileLevel) : []
            };
            if (item.tracker.id === id) return {
                ...item,
                tracker: {
                    ...item.tracker,
                    isChecked: !item.tracker.isChecked,
                    isIndeterminate: false
                }
            };
            return item;
        });
        return (0, $4c1aa6449628783a$export$e6436fb982b2017f)(prevMergedLists);
    // return prevMergedLists;
    }, [
        setMergedLists
    ]);
    const handleCheckboxChange = (id, checkBoxLevel, currentStatus)=>{
        dispatch((0, $d623f23401a154f0$export$ebe6b5ce6ed9ef39)(false));
        setIsCheckingIntoSession(true);
        dispatch((0, $d623f23401a154f0$export$5b43dc99ee28ff0f)(certKey, nodeData?.id, !currentStatus)).then(()=>{
            setMergedLists((prevMergedLists)=>handleTileCheck(prevMergedLists, id, checkBoxLevel));
            dispatch((0, $d623f23401a154f0$export$2af49e179df91659)(true));
            if (currentStatus && bulkAction?.isChecked && !bulkAction?.isIndeterminate) dispatch((0, $d623f23401a154f0$export$889241fc0afda8a9)(true));
        // if (bulkAction?.bulkActionFooterData !== null) {
        //   const tempBulkFooterStats = bulkAction?.bulkActionFooterData;
        //   if (currentStatus) {
        //     if (certsKind === COL_FILTER_HEADER_USER) {
        //       tempBulkFooterStats[BULK_ACTION_OBJ_USERS] -= 1;
        //       tempBulkFooterStats[BULK_ACTION_OBJ_TOTAL] -= 1;
        //     }
        //     if (certsKind === COL_FILTER_HEADER_ACCOUNT) {
        //       tempBulkFooterStats[BULK_ACTION_OBJ_ACCOUNT] -= 1;
        //       tempBulkFooterStats[BULK_ACTION_OBJ_TOTAL] -= 1;
        //     }
        //     if (certsKind === COL_FILTER_HEADER_ROLE) {
        //       tempBulkFooterStats[BULK_ACTION_OBJ_ROLES] -= 1;
        //       tempBulkFooterStats[BULK_ACTION_OBJ_TOTAL] -= 1;
        //     }
        //     if (certsKind === COL_FILTER_HEADER_ENTITLEMENT) {
        //       tempBulkFooterStats[BULK_ACTION_OBJ_ENTITLEMENTS] -= 1;
        //       tempBulkFooterStats[BULK_ACTION_OBJ_TOTAL] -= 1;
        //     }
        //   } else {
        //     if (certsKind === COL_FILTER_HEADER_USER) {
        //       tempBulkFooterStats[BULK_ACTION_OBJ_USERS] += 1;
        //       tempBulkFooterStats[BULK_ACTION_OBJ_TOTAL] += 1;
        //     }
        //     if (certsKind === COL_FILTER_HEADER_ACCOUNT) {
        //       tempBulkFooterStats[BULK_ACTION_OBJ_ACCOUNT] += 1;
        //       tempBulkFooterStats[BULK_ACTION_OBJ_TOTAL] += 1;
        //     }
        //     if (certsKind === COL_FILTER_HEADER_ROLE) {
        //       tempBulkFooterStats[BULK_ACTION_OBJ_ROLES] += 1;
        //       tempBulkFooterStats[BULK_ACTION_OBJ_TOTAL] += 1;
        //     }
        //     if (certsKind === COL_FILTER_HEADER_ENTITLEMENT) {
        //       tempBulkFooterStats[BULK_ACTION_OBJ_ENTITLEMENTS] += 1;
        //       tempBulkFooterStats[BULK_ACTION_OBJ_TOTAL] += 1;
        //     }
        //   }
        //   dispatch(setBulkActionFooterData(tempBulkFooterStats));
        // }
        }).catch((error)=>{
            dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(true, error.message));
        }).finally(()=>{
            setIsCheckingIntoSession(false);
        });
    };
    (0, $hopDi$useEffect)(()=>{
        setMergedLists((prevMergedLists)=>(0, $4c1aa6449628783a$export$e6436fb982b2017f)(prevMergedLists));
    }, []);
    const handleCheckboxHoverDisplay = ()=>{
        const isCertsKindUser = nodeData?.CERT_ENTITLEMENT_VALUEKEY === (0, $bae22e791544392c$export$994f7af6d0b36256).USER;
        const shouldDisableTileCheckBoxes = Boolean(bulkAction?.isDisabled || bulkAction?.isSubmittingAction || !shouldShowReviewAndSubmitButton || isLoading);
        return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                    tag: "div",
                    className: tileCheckboxClasses,
                    children: !isCheckingIntoSession ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                        name: "checkbox-no-hovereffect",
                        kind: "base",
                        showHoverEffect: true,
                        shouldStopCorePropagation: true,
                        dataTestId: "checkbox-no-hovereffect",
                        isChecked: nodeData?.tracker?.isChecked,
                        isDisabled: shouldDisableTileCheckBoxes,
                        isIndeterminate: nodeData?.tracker?.isIndeterminate,
                        hasBackground: false,
                        onChange: ()=>handleCheckboxChange(trackerId, nodeData?.tracker?.level, nodeData?.tracker?.isChecked)
                    }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                        kind: "loop",
                        format: "inline",
                        color: "brand",
                        size: "small"
                    })
                }),
                isCertsKindUser ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Avatar), {
                    size: "small",
                    className: tileCheckboxIconClasses
                }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: (0, $4c1aa6449628783a$export$c40b9342a19db0b6)(),
                    color: "navy-900",
                    size: "smallMedium",
                    className: tileCheckboxIconClasses
                })
            ]
        });
    };
    const getTitleColData = ()=>{
        const isNoValue = data[fixedColKey] === null || data[fixedColKey] === undefined || data?.[fixedColKey]?.trim()?.length === 0;
        const titleValueClasses = (0, $hopDi$classnames)(isNoValue && "Tile-titleValue--isNoValue");
        const titleValue = isNoValue ? "Not Provided" : data[fixedColKey];
        return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "body3",
                    children: (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(fixedColKey))
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "h3",
                    className: titleValueClasses,
                    children: titleValue
                })
            ]
        });
    };
    const getAttributeColData = ()=>{
        let tempFilledColsCount = 0;
        const dataKeysWithOutFixedCol = Object.keys(data)?.filter((key)=>key !== fixedColKey);
        if (!dataKeysWithOutFixedCol || dataKeysWithOutFixedCol?.length === 0) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            tag: "div",
            className: "Tile-attribute"
        });
        return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                dataKeysWithOutFixedCol?.map((key, index)=>{
                    const isNoValue = data[key] === null || data[key] === undefined || typeof data[key] === "object" || typeof data[key] === "string" && data?.[key]?.trim()?.length === 0;
                    const attributeValue = isNoValue ? "Not Provided" : data?.[key];
                    const attributeValueClasses = (0, $hopDi$classnames)(isNoValue && "Tile-attributeValue--isNoValue");
                    tempFilledColsCount = index;
                    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                        tag: "div",
                        className: "Tile-attribute",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body3",
                                children: (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(key))
                            }),
                            key === (0, $883fa4dd903b96ab$export$d9266982e2bf3d17) ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $6be8371a7cd99dfd$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body2",
                                className: attributeValueClasses,
                                children: attributeValue
                            })
                        ]
                    }, key);
                }),
                [
                    ...Array(Math.max(0, (0, $bae22e791544392c$export$dbb53ef7e43d7f45) - tempFilledColsCount + 1)).keys()
                ].map((key)=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                        tag: "div",
                        className: "Tile-attribute"
                    }, key))
            ]
        });
    };
    // TODO: Remove this in future
    const sampleStatusForRisk = [
        {
            state: "warning",
            count: 47,
            label: "//WIP//"
        },
        {
            state: "success",
            count: 18,
            label: "//WIP//"
        },
        {
            state: "critical",
            count: 94,
            label: "//WIP//"
        }
    ];
    const randomStatus = sampleStatusForRisk[Math.floor(Math.random() * sampleStatusForRisk.length)];
    const checkForActions = actionButtonsMap && actionButtonsMap.length > 0;
    return /*#__PURE__*/ (0, $hopDi$jsxs)("section", {
        ref: tileRef,
        className: tileClasses,
        "data-testid": `cert-details-list-level-${level}`,
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                tag: "div",
                className: tileCheckHoverDisplayBtn,
                children: handleCheckboxHoverDisplay()
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                tabIndex: 0,
                role: "button",
                onClick: handleTileClick,
                onKeyDown: (e)=>handleKeyDownTile(e),
                className: leftHoverSideClasses,
                "aria-label": "Click to open side panel",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                        tag: "div",
                        className: "Tile-titleCol",
                        children: getTitleColData()
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                        tag: "div",
                        className: "Tile-attributeCols",
                        children: getAttributeColData()
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                        tag: "div",
                        className: "Tile-trustScore",
                        children: nodeData.JRMRULES && (certsKind === (0, $a23cd229b9113926$export$7d1f9b2b2a057886) || certsKind === (0, $a23cd229b9113926$export$c97501b522a7bf89)) ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $d890b5a3788f0783$export$2e2bcd8739ae039), {
                            kind: randomStatus.state,
                            size: "small",
                            value: randomStatus.count,
                            label: randomStatus.label
                        }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                            tag: "div",
                            className: "Tile-placeholderScore--blank"
                        })
                    })
                ]
            }),
            !isSidePanelVisible && checkForActions && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                tag: "div",
                className: actionButtonGroupClasses,
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $2ee72dee6e5b726b$export$2e2bcd8739ae039), {
                    kind: (0, $20281fe09bc700a8$export$758743ec42a300f1).TILE,
                    nodeData: nodeData,
                    isActionGroupExpanded: isActionGroupExpanded,
                    setIsActionGroupExpanded: setIsActionGroupExpanded,
                    setIsActionPopoverOpen: setIsActionPopoverOpen,
                    setMergedLists: setMergedLists,
                    groupTooltipText: shouldShowGroupToolTip ? "Options for multiple-item selections are available in the toolbar below." : null,
                    isGroupDisabled: shouldDisableActionBtns || shouldBeRemovedFlag || shouldDisableWhileCallingActionApis,
                    isSaviResponded: isSaviResponded,
                    saviRespondedReason: saviRespondedReason
                })
            }),
            !shouldBeRemovedFlag && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                tag: "span",
                className: "Tile-overlay"
            })
        ]
    });
}
$cdc016b7003fff2a$var$Tile.propTypes = {
    data: (0, $hopDi$proptypes).shape({}),
    level: (0, $hopDi$proptypes).number.isRequired,
    handleSidePanel: (0, $hopDi$proptypes).func.isRequired,
    nodeData: (0, $hopDi$proptypes).shape((0, $ddbc2f861c0388ff$export$3e7926703ac20a93)).isRequired,
    setMergedLists: (0, $hopDi$proptypes).func.isRequired
};
$cdc016b7003fff2a$var$Tile.defaultProps = {
    data: {}
};
var $cdc016b7003fff2a$export$2e2bcd8739ae039 = $cdc016b7003fff2a$var$Tile;


var $e7ccc98e1a551e3a$export$2e2bcd8739ae039 = (0, $cdc016b7003fff2a$export$2e2bcd8739ae039);






const $076fc4f0a29566cf$export$3a17aa4bbe26c437 = (obj, mapper)=>{
    const filteredObj = {};
    // Determine category based on CERT_ENTITLEMENT_VALUEKEY
    let category;
    if (obj.CERT_ENTITLEMENT_VALUEKEY === "0") category = (0, $a23cd229b9113926$export$eeb9092565ce426a);
    else if (parseInt(obj.CERT_ENTITLEMENT_VALUEKEY, 10) > 0) category = (0, $a23cd229b9113926$export$7d1f9b2b2a057886);
    else if (obj.CERT_ENTITLEMENT_VALUEKEY === "-4") category = (0, $a23cd229b9113926$export$c2fd574cc3b8c823);
    else if (obj.CERT_ENTITLEMENT_VALUEKEY === "-2") category = (0, $a23cd229b9113926$export$c97501b522a7bf89);
    if (category) {
        const allowedAttributes = mapper[category.toUpperCase()];
        allowedAttributes?.forEach((attr)=>{
            const realAttr = attr?.split("-")[1];
            if (Object.prototype.hasOwnProperty.call(obj, realAttr)) filteredObj[realAttr] = obj[realAttr];
        });
    }
    return filteredObj;
};
const $076fc4f0a29566cf$var$heightPerTile = 4.0625; // per tile height in rem
const $076fc4f0a29566cf$var$extraSpaceIfChildren = 2; // padding with gap in rem
const $076fc4f0a29566cf$export$6291ba5c2270c680 = (node)=>{
    let height = 0;
    const shouldBeRemovedFlag = (0, $e7628c995f405891$export$9ca4f3ab69295cac)(node?.tracker?.actions);
    if (!shouldBeRemovedFlag || node.tracker?.length === 0) {
        height += $076fc4f0a29566cf$var$heightPerTile;
        const childrenCount = node?.children?.length;
        if (childrenCount > 0) {
            height += $076fc4f0a29566cf$var$extraSpaceIfChildren;
            node.children.forEach((item)=>{
                height += $076fc4f0a29566cf$export$6291ba5c2270c680(item);
            });
        }
    } else if (node?.tracker?.level !== 0) height += 0.375; // height when card is collapsed in rem
    return height;
};



function $9fe3bef4cc10ee7d$var$Cards({ data: data, level: level, handleSidePanel: handleSidePanel, isSidePanelOpen: isSidePanelOpen, setMergedLists: setMergedLists }) {
    const [colsToShow, setColsToShow] = (0, $hopDi$useState)({});
    const { colsFilters: colsFilters } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const cardsClasses = (0, $hopDi$classnames)("Cards", `Cards--${level}`, isSidePanelOpen && "Cards--sidebarOpen");
    const getTreeClasses = (node, treeIndex)=>{
        const isLevelZero = level === 0;
        const isLevelOne = level === 1;
        const isTreeIndexZero = treeIndex === 0;
        const isTreeIndexEnd = treeIndex === data.length - 1;
        const isEnt = node.CERT_ENTITLEMENT_VALUEKEY <= 0;
        const hasNodeChildren = node?.children?.length > 0;
        const isTopTile = isTreeIndexZero && !isLevelZero;
        const isBottomTile = isTreeIndexEnd && !isLevelZero;
        const hasEntChild = isLevelOne && isEnt && hasNodeChildren;
        return (0, $hopDi$classnames)("Cards-tree", `Cards-tree--${level}`, `Cards-treeIndex--${treeIndex}`, isTopTile && "Cards-tree--isTopTile", isBottomTile && "Cards-tree--isBottomTile", hasEntChild ? "Cards-tree--hasEntChild" : "Cards-tree--hasNoChildren", false);
    };
    const removeChildren = (node)=>{
        const rowData = JSON.parse(JSON.stringify(node));
        delete rowData?.children;
        return rowData;
    };
    (0, $hopDi$useEffect)(()=>{
        if (colsFilters) setColsToShow(colsFilters);
    }, [
        colsFilters
    ]);
    const getNodeDataToView = (nodeData)=>{
        let output = {};
        output = (0, $076fc4f0a29566cf$export$3a17aa4bbe26c437)(nodeData, colsToShow);
        return output;
    };
    if (!data) return null;
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
        tag: "div",
        className: cardsClasses,
        children: data?.map((node, index)=>{
            const nodeData = removeChildren(node);
            const filteredNodeData = getNodeDataToView(nodeData);
            return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: getTreeClasses(node, index),
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $e7ccc98e1a551e3a$export$2e2bcd8739ae039), {
                        data: filteredNodeData,
                        nodeData: nodeData,
                        level: level,
                        handleSidePanel: ()=>handleSidePanel(nodeData),
                        setMergedLists: setMergedLists
                    }),
                    node?.children?.length !== 0 && /*#__PURE__*/ (0, $hopDi$jsx)($9fe3bef4cc10ee7d$var$Cards, {
                        data: node?.children || [],
                        level: level + 1,
                        handleSidePanel: handleSidePanel,
                        setMergedLists: setMergedLists
                    })
                ]
            }, node?.tracker?.id);
        })
    });
}
$9fe3bef4cc10ee7d$var$Cards.propTypes = {
    data: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({})).isRequired,
    level: (0, $hopDi$proptypes).number,
    handleSidePanel: (0, $hopDi$proptypes).func.isRequired,
    isSidePanelOpen: (0, $hopDi$proptypes).bool,
    setMergedLists: (0, $hopDi$proptypes).func.isRequired
};
$9fe3bef4cc10ee7d$var$Cards.defaultProps = {
    level: 0,
    isSidePanelOpen: false
};
var $9fe3bef4cc10ee7d$export$2e2bcd8739ae039 = $9fe3bef4cc10ee7d$var$Cards;


var $691dbffebbf06698$export$2e2bcd8739ae039 = (0, $9fe3bef4cc10ee7d$export$2e2bcd8739ae039);


/* eslint-disable react/jsx-wrap-multilines */ /* eslint-disable react/jsx-curly-spacing */ 




function $c37cf970f91ce261$var$CertDetailsError() {
    const history = (0, $hopDi$useHistory)();
    const [isOpen, setIsOpen] = (0, $hopDi$useState)(true);
    const onRefreshClick = ()=>{
        window.location.reload();
    };
    const onBackClick = ()=>{
        history.goBack();
    };
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
        className: "CertDetailsError",
        kind: "critical",
        alertTitle: "Could not Load Page",
        alertSubtitle: "This page of the certification did not load properly due to a network issue. Please refresh or try again later.",
        onClose: ()=>setIsOpen(false),
        isOpen: isOpen,
        primaryButton: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
            type: "button",
            kind: "filled",
            isEnabled: true,
            size: "medium",
            onClick: onRefreshClick,
            children: "Refresh"
        }),
        secondaryButton: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
            type: "button",
            kind: "ghost",
            size: "medium",
            onClick: onBackClick,
            children: "Go Back"
        })
    });
}
var $c37cf970f91ce261$export$2e2bcd8739ae039 = $c37cf970f91ce261$var$CertDetailsError;


var $87d4d732106452cd$export$2e2bcd8739ae039 = (0, $c37cf970f91ce261$export$2e2bcd8739ae039);




/* eslint-disable react/jsx-wrap-multilines */ /* eslint-disable react/jsx-curly-spacing */ 







/* eslint-disable no-console */ 






/* eslint-disable jsx-a11y/anchor-is-valid */ 









const $6702cb469143c6c9$export$29ae9ca85e0eb4a7 = 10;
const $6702cb469143c6c9$export$8a2c144908a2b8f5 = "fulfilled";
const $6702cb469143c6c9$export$14624c6c73370169 = 1;
const $6702cb469143c6c9$export$1c70425da51939b3 = {
    Medium: "warning",
    High: "critical",
    Critical: "critical"
};


const $0ae5e08f8dc713fb$export$5e1742ecfe78b9a7 = {
    "MM/dd/yyyy HH:mm:ss": {
        ipFormat: "MM/DD/yyyy HH:mm:ss",
        opFormat: "DD-MMM-YYYY, hh:mm A"
    },
    "MM/dd/yy": {
        ipFormat: "MM/DD/YY",
        opFormat: "DD-MMM-YYYY, YYYY"
    }
};
const $0ae5e08f8dc713fb$export$2de30e2a30eba22b = {
    reassigned: {
        icon: "ReassignUser",
        iconColor: "navy-900",
        heading: "Reassigned",
        date: "Resigned On",
        user: "Reassigned By",
        other: "Comments"
    },
    consulted: {
        icon: "Consult",
        iconColor: "green-900",
        heading: "Consulted",
        date: "Consulted On",
        user: "Consulted By",
        other: "Comments"
    },
    conditionallyCertified: {
        icon: "Consult",
        iconColor: "success-900",
        heading: "Certified",
        date: "Certified On",
        user: "Certified By",
        other: "Comments"
    },
    rejected: {
        icon: "Reject",
        iconColor: "warning-900",
        heading: "Rejected",
        date: "Rejected On",
        user: "Rejected By",
        other: "Comments"
    },
    approved: {
        icon: "CheckCircleOutline",
        iconColor: "success-900",
        heading: "Approved",
        date: "Approved On",
        user: "Approved By",
        other: "Comments"
    },
    worksForMe: {
        icon: "CheckCircleOutline",
        iconColor: "warning-700",
        heading: "Works For Me",
        date: "Approved On",
        user: "Approved By",
        other: "Comments"
    },
    cancelled: {
        icon: "CheckCircleOutline",
        iconColor: "warning-700",
        heading: "Reset",
        date: "Approved On",
        user: "Approved By",
        other: "Comments"
    },
    default: {
        icon: "CheckCircleOutline",
        iconColor: "warning-700",
        heading: "NOT_PROVIDED",
        date: "Approved On",
        user: "Approved By",
        other: "Comments"
    }
};


const $15388cfdc531d880$export$419658dfa295d7 = (tab)=>{
    switch(tab){
        case 0, $d60257e8dc27bf16$export$9b67fda1e37e6e63:
            return "No actions or comments have been recorded for this certification yet.";
        case 0, $d60257e8dc27bf16$export$bde14d5a1cbdb371:
            return "There's no summary available for this user.";
        default:
            return "";
    }
};
const $15388cfdc531d880$export$ba58c0596871524 = (tab)=>{
    switch(tab){
        case 0, $d60257e8dc27bf16$export$9b67fda1e37e6e63:
            return "The History tab didn't load properly due to a network issue. Please refresh or try again later.";
        case 0, $d60257e8dc27bf16$export$bde14d5a1cbdb371:
            return "The Summary tab didn't load properly due to a network issue. Please refresh or try again later.";
        case 0, $d60257e8dc27bf16$export$8f78881bb4058858:
            return "The Access Conflicts tab didn't load properly due to a network issue. Please refresh or try again later.";
        case 0, $d60257e8dc27bf16$export$a06b6c2be556dac8:
            return "The Privilege tab didn't load properly due to a network issue. Please refresh or try again later.";
        case 0, $d60257e8dc27bf16$export$51f82826650bc3c3:
            return "The Child Entitlements tab didn't load properly due to a network issue. Please refresh or try again later.";
        case 0, $d60257e8dc27bf16$export$ed0bf72b1f4a9681:
            return "The Dependent Entitlements tab didn't load properly due to a network issue. Please refresh or try again later.";
        case 0, $d60257e8dc27bf16$export$6cc684447a8d7b17:
            return "The Child Roles tab didn't load properly due to a network issue. Please refresh or try again later.";
        default:
            return "";
    }
};


function $b9063d77adf48209$var$CertsSidePanelBodyError({ tab: tab, retrigggerApisForError: retrigggerApisForError, handleCloseSidePanel: handleCloseSidePanel }) {
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "CertsSidePanelBody-tabContent--isError",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                kind: "h2",
                children: "Couldn't Load"
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                kind: "body2",
                className: "CertsSidePanelBody-tabContentDescription--isError",
                children: (0, $15388cfdc531d880$export$ba58c0596871524)(tab)
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                type: "button",
                kind: "outlined",
                isEnabled: true,
                onClick: retrigggerApisForError,
                className: "CertsSidePanelBody-tabContentRefreshBtn--isError",
                size: "small",
                children: "Refresh"
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                type: "button",
                kind: "ghost",
                size: "small",
                onClick: handleCloseSidePanel,
                children: "Close"
            })
        ]
    });
}
$b9063d77adf48209$var$CertsSidePanelBodyError.propTypes = {
    tab: (0, $hopDi$proptypes).string,
    retrigggerApisForError: (0, $hopDi$proptypes).func.isRequired,
    handleCloseSidePanel: (0, $hopDi$proptypes).func.isRequired
};
$b9063d77adf48209$var$CertsSidePanelBodyError.defaultProps = {
    tab: ""
};
var $b9063d77adf48209$export$2e2bcd8739ae039 = $b9063d77adf48209$var$CertsSidePanelBodyError;


var $8198211ef3cd686e$export$2e2bcd8739ae039 = (0, $b9063d77adf48209$export$2e2bcd8739ae039);


/* eslint-disable import/no-extraneous-dependencies */ 








const $3dba689dd3c247a4$var$DATA = {
    type: (0, $hopDi$proptypes).oneOf([
        (0, $d60257e8dc27bf16$export$1cc98074061c90d2),
        (0, $d60257e8dc27bf16$export$153ab95c08227093),
        (0, $d60257e8dc27bf16$export$7d6712c2cb8377b2),
        (0, $d60257e8dc27bf16$export$be9a3074cb3ae0c7)
    ]),
    Ent_PRIVILIGED: (0, $hopDi$proptypes).string,
    Ent_ENTITLEMENT_GLOSSARY: (0, $hopDi$proptypes).string,
    COMMENTS: (0, $hopDi$proptypes).string,
    CERT_USERKEY: (0, $hopDi$proptypes).string,
    CERT_ACCOUNTKEY: (0, $hopDi$proptypes).string,
    CERTIFIED: (0, $hopDi$proptypes).number,
    enableAction: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string),
    availableAction: (0, $hopDi$proptypes).shape({
        approve: (0, $hopDi$proptypes).string,
        conditionalCertifiy: (0, $hopDi$proptypes).string,
        consult: (0, $hopDi$proptypes).string,
        reassign: (0, $hopDi$proptypes).string,
        reject: (0, $hopDi$proptypes).string
    }),
    ENTITLEMENTTYPE: (0, $hopDi$proptypes).string,
    id: (0, $hopDi$proptypes).string,
    ENTITLEMENT_VALUE: (0, $hopDi$proptypes).string,
    CERT_ROLEKEY: (0, $hopDi$proptypes).string,
    LASTCERTIFIED: (0, $hopDi$proptypes).string,
    isConsulted: (0, $hopDi$proptypes).bool,
    AUDIT_TRAIL: (0, $hopDi$proptypes).string,
    ACCESSTHROUGH: (0, $hopDi$proptypes).string,
    Ent_DESCRIPTION: (0, $hopDi$proptypes).string,
    Ent_DISPLAYNAME: (0, $hopDi$proptypes).string,
    LASTCERTIFIEDUSER: (0, $hopDi$proptypes).oneOfType([
        (0, $hopDi$proptypes).string,
        (0, $hopDi$proptypes).number
    ]),
    LASTCERTIFIEDCAMPAIGNNAME: (0, $hopDi$proptypes).string,
    ENDPOINT: (0, $hopDi$proptypes).string,
    CERT_ENTITLEMENT_VALUEKEY: (0, $hopDi$proptypes).string,
    tracker: (0, $hopDi$proptypes).shape({
        actions: (0, $hopDi$proptypes).objectOf((0, $hopDi$proptypes).shape({
            isSelected: (0, $hopDi$proptypes).bool,
            isLoading: (0, $hopDi$proptypes).bool
        })),
        id: (0, $hopDi$proptypes).string,
        isChecked: (0, $hopDi$proptypes).bool,
        isConnected: (0, $hopDi$proptypes).bool,
        level: (0, $hopDi$proptypes).number
    })
};
var $3dba689dd3c247a4$export$2e2bcd8739ae039 = $3dba689dd3c247a4$var$DATA;


var $708c26a04684b266$export$2e2bcd8739ae039 = (0, $3dba689dd3c247a4$export$2e2bcd8739ae039);


var $a514f7ada4c4e300$export$2e2bcd8739ae039 = (0, $708c26a04684b266$export$2e2bcd8739ae039);



function $2561d5c287a89532$var$CertsSidePanelBodyHistory({ data: data, isLoadingHistory: isLoadingHistory }) {
    // TODO: Remove this in future
    const sampleHistory = [
        "fill",
        "outline"
    ];
    const randomState = sampleHistory[Math.floor(Math.random() * sampleHistory.length)];
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
        children: [
            isLoadingHistory && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                className: "SidePanelView-loader",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                    kind: "dots",
                    format: "inline",
                    color: "info",
                    size: "medium"
                })
            }),
            !isLoadingHistory && data?.sidePanel?.history?.audit?.length === 0 && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                kind: "body2",
                className: "CertsSidePanelBody-tabContentTimeLineBlock--noData",
                children: (0, $15388cfdc531d880$export$419658dfa295d7)((0, $d60257e8dc27bf16$export$9b67fda1e37e6e63))
            }),
            !isLoadingHistory && data?.sidePanel?.history?.audit?.length > 0 && /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body3",
                        className: "CertsSidePanelBody-tabContentDescription",
                        children: "Review the actions taken and comments made by certifiers during the current certification."
                    }),
                    data?.sidePanel?.history?.audit?.map((item, index)=>/*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                            className: "CertsSidePanelBody-tabContentTimeLineBlock",
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $596ca118e64bea36$export$2e2bcd8739ae039), {
                                    iconKind: (0, $0ae5e08f8dc713fb$export$2de30e2a30eba22b)[item.action]?.icon || (0, $0ae5e08f8dc713fb$export$2de30e2a30eba22b)?.default?.icon,
                                    type: randomState,
                                    kind: "normal",
                                    showTail: index !== data.sidePanel.history.audit.length - 1
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                    className: "CertsSidePanelBody-tabContentTimeLineBlockBody",
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body1-bold",
                                            className: "CertsSidePanelBody-tabContentTimeLineBlockBodyTitle",
                                            children: item?.actionMessage || item.action || (0, $0ae5e08f8dc713fb$export$2de30e2a30eba22b)?.default?.heading
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $5d9478e6fefd4bf2$export$2e2bcd8739ae039), {
                                            type: "compact",
                                            fieldData: {
                                                label: (0, $0ae5e08f8dc713fb$export$2de30e2a30eba22b)[item.action]?.date || (0, $0ae5e08f8dc713fb$export$2de30e2a30eba22b)?.default?.date,
                                                value: item.actionDate ? (0, $hopDi$moment).utc(item.actionDate, (0, $0ae5e08f8dc713fb$export$5e1742ecfe78b9a7)[item.actionDateFormat].ipFormat).local().format((0, $0ae5e08f8dc713fb$export$5e1742ecfe78b9a7)[item.actionDateFormat].opFormat) : ""
                                            }
                                        }, `${item.index}-1`),
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $5d9478e6fefd4bf2$export$2e2bcd8739ae039), {
                                            type: "compact",
                                            fieldData: {
                                                label: (0, $0ae5e08f8dc713fb$export$2de30e2a30eba22b)[item.action]?.user || (0, $0ae5e08f8dc713fb$export$2de30e2a30eba22b)?.default?.user,
                                                value: item.actionUser
                                            }
                                        }, `${item.index}-2`),
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $5d9478e6fefd4bf2$export$2e2bcd8739ae039), {
                                            type: "compact",
                                            fieldData: {
                                                label: (0, $0ae5e08f8dc713fb$export$2de30e2a30eba22b)[item.action]?.other || (0, $0ae5e08f8dc713fb$export$2de30e2a30eba22b)?.default?.other,
                                                value: item.comment
                                            }
                                        }, `${item.index}-3`)
                                    ]
                                })
                            ]
                        }, item.index))
                ]
            })
        ]
    });
}
$2561d5c287a89532$var$CertsSidePanelBodyHistory.propTypes = {
    data: (0, $hopDi$proptypes).shape((0, $a514f7ada4c4e300$export$2e2bcd8739ae039)).isRequired,
    isLoadingHistory: (0, $hopDi$proptypes).bool.isRequired
};
var $2561d5c287a89532$export$2e2bcd8739ae039 = $2561d5c287a89532$var$CertsSidePanelBodyHistory;


var $e52ca6c769e8713d$export$2e2bcd8739ae039 = (0, $2561d5c287a89532$export$2e2bcd8739ae039);














function $6c26eb59a53ecceb$var$CertsSidePanelBodySummary({ data: data }) {
    const intl = (0, $hopDi$useIntl)();
    const dispatch = (0, $hopDi$useDispatch)();
    const handleARSModalForSidePanel = ()=>{
        dispatch((0, $d623f23401a154f0$export$6905b0d830e88406)(true, data));
    };
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "CertsSidePanelBody-tabContentSummaryAttributes",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                kind: "h4",
                children: "Attributes"
            }),
            Object.keys(data?.sidePanel?.summary).filter((key)=>typeof data?.sidePanel?.summary[key] !== "object" || data?.sidePanel?.summary[key] === null).map((key)=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $5d9478e6fefd4bf2$export$2e2bcd8739ae039), {
                    fieldData: {
                        label: (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(key)),
                        value: key === (0, $883fa4dd903b96ab$export$d9266982e2bf3d17) ? /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                            onClick: handleARSModalForSidePanel,
                            onKeyDown: ()=>{},
                            role: "button",
                            tabIndex: "0",
                            className: "AccessRequestHistoryBtn-sidePanelMode",
                            children: "Access Request"
                        }) : data?.sidePanel?.summary[key] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)("NOT_PROVIDED"))
                    },
                    isBlank: !data.sidePanel?.summary[key]
                }, key))
        ]
    });
}
$6c26eb59a53ecceb$var$CertsSidePanelBodySummary.propTypes = {
    data: (0, $hopDi$proptypes).shape((0, $a514f7ada4c4e300$export$2e2bcd8739ae039))
};
$6c26eb59a53ecceb$var$CertsSidePanelBodySummary.defaultProps = {
    data: null
};
var $6c26eb59a53ecceb$export$2e2bcd8739ae039 = $6c26eb59a53ecceb$var$CertsSidePanelBodySummary;


var $f628408145ad5bcd$export$2e2bcd8739ae039 = (0, $6c26eb59a53ecceb$export$2e2bcd8739ae039);







function $11c20874684f0ab9$var$CertsSidePanelAccounts({ dataTestId: dataTestId, className: className, data: data, activeTab: activeTab, setActiveTab: setActiveTab, isLoadingHistory: isLoadingHistory, retrigggerApisForError: retrigggerApisForError, handleCloseSidePanel: handleCloseSidePanel }) {
    const classes = (0, $hopDi$classnames)("CertsSidePanelBody", className);
    const [showHistory, setShowHistory] = (0, $hopDi$useState)(false);
    (0, $hopDi$useEffect)(()=>{
        setShowHistory(activeTab === (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63));
    }, [
        activeTab
    ]);
    const handleTabChange = (value)=>{
        setActiveTab(value);
    };
    const renderHistoryContent = ()=>{
        if (showHistory) {
            if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$9b67fda1e37e6e63]) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
                className: "CertsSidePanelBody-tabContent--history",
                value: activeTab,
                tabValue: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $e52ca6c769e8713d$export$2e2bcd8739ae039), {
                    data: data,
                    isLoadingHistory: isLoadingHistory
                })
            });
            return /*#__PURE__*/ (0, $hopDi$jsx)((0, $8198211ef3cd686e$export$2e2bcd8739ae039), {
                tab: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
                retrigggerApisForError: retrigggerApisForError,
                handleCloseSidePanel: handleCloseSidePanel
            });
        }
        return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
            className: "CertsSidePanelBody-tabContent--history",
            value: activeTab,
            tabValue: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
            children: /*#__PURE__*/ (0, $hopDi$jsx)("div", {})
        });
    };
    const shouldShowSidePanelSummaryForAccounts = Boolean(data?.sidePanel?.summary && data?.sidePanel?.status[0, $d60257e8dc27bf16$export$bde14d5a1cbdb371]);
    return /*#__PURE__*/ (0, $hopDi$jsxs)("section", {
        className: classes,
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabGroup), {
                value: activeTab,
                onChange: handleTabChange,
                className: "CertsSidePanelBody-tabGroup",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                        label: "Summary",
                        value: (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371),
                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "Document",
                            size: "medium",
                            color: "neutral-1000"
                        }),
                        size: "medium"
                    }, (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371)),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                        label: "History",
                        value: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "RequestHistory",
                            size: "medium",
                            color: "neutral-1000"
                        }),
                        size: "medium"
                    }, (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63)),
                    /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                        className: "CertsSidePanelBody-tabGroupEmpty"
                    }, (0, $d60257e8dc27bf16$export$d66151c7af00715f))
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
                className: "CertsSidePanelBody-tabContent--summary",
                value: activeTab,
                tabValue: (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371),
                children: shouldShowSidePanelSummaryForAccounts ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $f628408145ad5bcd$export$2e2bcd8739ae039), {
                    data: data
                }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $8198211ef3cd686e$export$2e2bcd8739ae039), {
                    tab: (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371),
                    retrigggerApisForError: retrigggerApisForError,
                    handleCloseSidePanel: handleCloseSidePanel
                })
            }),
            renderHistoryContent()
        ]
    });
}
$11c20874684f0ab9$var$CertsSidePanelAccounts.propTypes = {
    dataTestId: (0, $hopDi$proptypes).string,
    className: (0, $hopDi$proptypes).string,
    data: (0, $hopDi$proptypes).shape((0, $708c26a04684b266$export$2e2bcd8739ae039)).isRequired,
    activeTab: (0, $hopDi$proptypes).string.isRequired,
    setActiveTab: (0, $hopDi$proptypes).func.isRequired,
    isLoadingHistory: (0, $hopDi$proptypes).bool.isRequired,
    retrigggerApisForError: (0, $hopDi$proptypes).func,
    handleCloseSidePanel: (0, $hopDi$proptypes).func
};
$11c20874684f0ab9$var$CertsSidePanelAccounts.defaultProps = {
    dataTestId: null,
    className: null,
    retrigggerApisForError: ()=>{},
    handleCloseSidePanel: ()=>{}
};
var $11c20874684f0ab9$export$2e2bcd8739ae039 = $11c20874684f0ab9$var$CertsSidePanelAccounts;


var $3ddf9bde0f45f198$export$2e2bcd8739ae039 = (0, $11c20874684f0ab9$export$2e2bcd8739ae039);


/* eslint-disable no-console */ /* eslint-disable jsx-a11y/anchor-is-valid */ 













function $497631ad0623d8a8$var$CertsSidePanelEntitlements({ dataTestId: dataTestId, className: className, data: data, activeTab: activeTab, setActiveTab: setActiveTab, isLoadingHistory: isLoadingHistory, retrigggerApisForError: retrigggerApisForError, handleCloseSidePanel: handleCloseSidePanel }) {
    const dispatch = (0, $hopDi$useDispatch)();
    const { certKey: certKey } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const classes = (0, $hopDi$classnames)("CertsSidePanelBody", className);
    const [showHistory, setShowHistory] = (0, $hopDi$useState)(false);
    const [isLoadingMoreData, setIsLoadingMoreData] = (0, $hopDi$useState)(false);
    const [viewMore, setViewMore] = (0, $hopDi$useState)({
        [(0, $d60257e8dc27bf16$export$a06b6c2be556dac8)]: {
            currentOffset: 0
        },
        [(0, $d60257e8dc27bf16$export$8f78881bb4058858)]: {
            currentOffset: 0
        },
        [(0, $d60257e8dc27bf16$export$51f82826650bc3c3)]: {
            currentOffset: 0
        }
    });
    const [childrenSearchForEnts, setChildrenSearchForEnts] = (0, $hopDi$useState)("");
    const [entitlementMenu, setEntitlementMenu] = (0, $hopDi$useState)([]);
    const [isEntMenuOpen, setIsEntMenuOpen] = (0, $hopDi$useState)(false);
    const callApiForLoadBtn = (tab)=>{
        setIsLoadingMoreData(true);
        switch(tab){
            case 0, $d60257e8dc27bf16$export$8f78881bb4058858:
                dispatch((0, $d623f23401a154f0$export$1fbc321c679e35cc)(certKey, data.CERT_ENTITLEMENT_VALUEKEY, data.CERT_ACCOUNTKEY, String(viewMore[0, $d60257e8dc27bf16$export$8f78881bb4058858].currentOffset + (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)), String((0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)), "", (0, $d6d78fc758ee4148$export$2e6684ed5543ad11))).then(()=>{
                    setViewMore((prevViewMore)=>({
                            ...prevViewMore,
                            [tab]: {
                                currentOffset: prevViewMore[tab].currentOffset + (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)
                            }
                        }));
                    setIsLoadingMoreData(false);
                }).catch(()=>{
                    setIsLoadingMoreData(false);
                });
                break;
            case 0, $d60257e8dc27bf16$export$51f82826650bc3c3:
                dispatch((0, $d623f23401a154f0$export$f8b073a05f313ac0)(data.CERT_ENTITLEMENT_VALUEKEY, String(viewMore[0, $d60257e8dc27bf16$export$51f82826650bc3c3].currentOffset + (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)), String((0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)), (0, $d6d78fc758ee4148$export$2e6684ed5543ad11))).then(()=>{
                    setViewMore((prevViewMore)=>({
                            ...prevViewMore,
                            [tab]: {
                                currentOffset: prevViewMore[tab].currentOffset + (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)
                            }
                        }));
                    setIsLoadingMoreData(false);
                }).catch(()=>{
                    setIsLoadingMoreData(false);
                });
                break;
            default:
                break;
        }
    };
    (0, $hopDi$useEffect)(()=>{
        setChildrenSearchForEnts("");
        setIsEntMenuOpen(false);
        setShowHistory(activeTab === (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63));
    }, [
        activeTab
    ]);
    const handleTabChange = (value)=>{
        setActiveTab(value);
    };
    const renderHistoryContent = ()=>{
        if (showHistory) {
            if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$9b67fda1e37e6e63]) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
                className: "CertsSidePanelBody-tabContent--history",
                value: activeTab,
                tabValue: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $e52ca6c769e8713d$export$2e2bcd8739ae039), {
                    data: data,
                    isLoadingHistory: isLoadingHistory
                })
            });
            return /*#__PURE__*/ (0, $hopDi$jsx)((0, $8198211ef3cd686e$export$2e2bcd8739ae039), {
                tab: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
                retrigggerApisForError: retrigggerApisForError,
                handleCloseSidePanel: handleCloseSidePanel
            });
        }
        return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
            className: "CertsSidePanelBody-tabContent--history",
            value: activeTab,
            tabValue: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
            children: /*#__PURE__*/ (0, $hopDi$jsx)("div", {})
        });
    };
    const renderSodTab = ()=>{
        if (data) {
            if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$8f78881bb4058858]) {
                if (data?.sidePanel?.sod?.totalRisks > 0) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                    label: "Conflicts",
                    value: (0, $d60257e8dc27bf16$export$8f78881bb4058858),
                    icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "Entitlement",
                        size: "medium",
                        color: "neutral-1000"
                    }),
                    size: "medium"
                }, (0, $d60257e8dc27bf16$export$8f78881bb4058858));
                return /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                    className: "CertsSidePanelBody-tabGroupEmpty",
                    value: (0, $d60257e8dc27bf16$export$8f78881bb4058858)
                }, (0, $d60257e8dc27bf16$export$8f78881bb4058858));
            }
            return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                label: "Conflicts",
                value: (0, $d60257e8dc27bf16$export$8f78881bb4058858),
                icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "Entitlement",
                    size: "medium",
                    color: "neutral-1000"
                }),
                size: "medium"
            }, (0, $d60257e8dc27bf16$export$8f78881bb4058858));
        }
        return /*#__PURE__*/ (0, $hopDi$jsx)("span", {
            className: "CertsSidePanelBody-tabGroupEmpty",
            value: (0, $d60257e8dc27bf16$export$8f78881bb4058858)
        }, (0, $d60257e8dc27bf16$export$8f78881bb4058858));
    };
    const renderPrivilegesTab = ()=>{
        if (data) {
            if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$a06b6c2be556dac8]) {
                if (data?.sidePanel?.privileges?.totalPrivileges > 0) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                    label: "Privilege",
                    value: (0, $d60257e8dc27bf16$export$a06b6c2be556dac8),
                    icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "PrivilgedAccess",
                        size: "medium",
                        color: "neutral-1000"
                    }),
                    size: "medium"
                }, (0, $d60257e8dc27bf16$export$a06b6c2be556dac8));
                return /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                    className: "CertsSidePanelBody-tabGroupEmpty",
                    value: (0, $d60257e8dc27bf16$export$a06b6c2be556dac8)
                }, (0, $d60257e8dc27bf16$export$a06b6c2be556dac8));
            }
            return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                label: "Privilege",
                value: (0, $d60257e8dc27bf16$export$a06b6c2be556dac8),
                icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "PrivilgedAccess",
                    size: "medium",
                    color: "neutral-1000"
                }),
                size: "medium"
            }, (0, $d60257e8dc27bf16$export$a06b6c2be556dac8));
        }
        return /*#__PURE__*/ (0, $hopDi$jsx)("span", {
            className: "CertsSidePanelBody-tabGroupEmpty",
            value: (0, $d60257e8dc27bf16$export$a06b6c2be556dac8)
        }, (0, $d60257e8dc27bf16$export$a06b6c2be556dac8));
    };
    const renderChildrenTabForEnts = ()=>{
        if (data) {
            if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$51f82826650bc3c3]) {
                if (data?.sidePanel?.children?.totalChildEnt > 0) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                    label: "Children",
                    value: (0, $d60257e8dc27bf16$export$51f82826650bc3c3),
                    icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "Entitlement",
                        size: "medium",
                        color: "neutral-1000"
                    }),
                    size: "medium"
                }, (0, $d60257e8dc27bf16$export$51f82826650bc3c3));
                return /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                    className: "CertsSidePanelBody-tabGroupEmpty",
                    value: (0, $d60257e8dc27bf16$export$51f82826650bc3c3)
                }, (0, $d60257e8dc27bf16$export$51f82826650bc3c3));
            }
            return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                label: "Children",
                value: (0, $d60257e8dc27bf16$export$51f82826650bc3c3),
                icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "Entitlement",
                    size: "medium",
                    color: "neutral-1000"
                }),
                size: "medium"
            }, (0, $d60257e8dc27bf16$export$51f82826650bc3c3));
        }
        return /*#__PURE__*/ (0, $hopDi$jsx)("span", {
            className: "CertsSidePanelBody-tabGroupEmpty",
            value: (0, $d60257e8dc27bf16$export$51f82826650bc3c3)
        }, (0, $d60257e8dc27bf16$export$51f82826650bc3c3));
    };
    const entValidTabsForMenu = ()=>data?.sidePanel?.unFixedTabs?.filter((tab)=>{
            if (tab === (0, $d60257e8dc27bf16$export$8f78881bb4058858)) {
                if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$8f78881bb4058858] && data?.sidePanel?.sod?.totalRisks > 0) return true;
                if (!data?.sidePanel?.status[0, $d60257e8dc27bf16$export$8f78881bb4058858]) return true;
            }
            if (tab === (0, $d60257e8dc27bf16$export$a06b6c2be556dac8)) {
                if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$a06b6c2be556dac8] && data?.sidePanel?.privileges?.totalPrivileges > 0) return true;
                if (!data?.sidePanel?.status[0, $d60257e8dc27bf16$export$a06b6c2be556dac8]) return true;
            }
            if (tab === (0, $d60257e8dc27bf16$export$51f82826650bc3c3)) {
                if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$51f82826650bc3c3] && data?.sidePanel?.children?.totalChildEnt > 0) return true;
                if (!data?.sidePanel?.status[0, $d60257e8dc27bf16$export$51f82826650bc3c3]) return true;
            }
            return false;
        });
    const handleEntMenuChange = (optionValue)=>{
        setEntitlementMenu([
            optionValue,
            ...entValidTabsForMenu().filter((option)=>option !== optionValue)
        ]);
        setActiveTab(optionValue);
        setIsEntMenuOpen(false);
    };
    const renderMenuForEntitlement = ()=>{
        const tempMenu = [];
        if (data) {
            if (entitlementMenu.length >= 1 && entitlementMenu[0] === (0, $d60257e8dc27bf16$export$8f78881bb4058858)) tempMenu.push(renderSodTab());
            if (entitlementMenu.length >= 1 && entitlementMenu[0] === (0, $d60257e8dc27bf16$export$a06b6c2be556dac8)) tempMenu.push(renderPrivilegesTab());
            if (entitlementMenu.length >= 1 && entitlementMenu[0] === (0, $d60257e8dc27bf16$export$51f82826650bc3c3)) tempMenu.push(renderChildrenTabForEnts());
            if (entitlementMenu.length > 1) tempMenu.push(/*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                onClick: ()=>setIsEntMenuOpen((prev)=>!prev),
                onKeyUp: ()=>{},
                role: "button",
                tabIndex: 0,
                className: "CertsSidePanelBody-tabEntMenu",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "CertsSidePanelBody-tabEntMenuHeading",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                                className: "CertsSidePanelBody-tabEntMenuHeadingText",
                                children: "Menu"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: "ChevronDownSmall",
                                color: "neutral-1000"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: isEntMenuOpen ? "CertsSidePanelBody-tabEntMenuDropDown--expanded" : "CertsSidePanelBody-tabEntMenuDropDown--hidden",
                        children: entitlementMenu.slice(1, entitlementMenu.length).map((item)=>/*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                onClick: ()=>handleEntMenuChange(item),
                                onKeyUp: ()=>{},
                                role: "button",
                                tabIndex: 0,
                                className: "CertsSidePanelBody-tabEntMenuDropDownListItem",
                                children: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                    className: "CertsSidePanelBody-tabEntMenuDropDownListItemContainer",
                                    children: [
                                        item === (0, $d60257e8dc27bf16$export$8f78881bb4058858) && /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                                    kind: "SOD",
                                                    size: "medium",
                                                    color: "neutral-1000"
                                                }),
                                                /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                                                    className: "CertsSidePanelBody-tabEntMenuDropDownListItemContainerSpan",
                                                    children: "Conflicts"
                                                })
                                            ]
                                        }),
                                        item === (0, $d60257e8dc27bf16$export$a06b6c2be556dac8) && /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                                    kind: "PrivilgedAccess",
                                                    size: "medium",
                                                    color: "neutral-1000"
                                                }),
                                                /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                                                    className: "CertsSidePanelBody-tabEntMenuDropDownListItemContainerSpan",
                                                    children: "Privilege"
                                                })
                                            ]
                                        }),
                                        item === (0, $d60257e8dc27bf16$export$51f82826650bc3c3) && /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                                    kind: "Entitlement",
                                                    size: "medium",
                                                    color: "neutral-1000"
                                                }),
                                                /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                                                    className: "CertsSidePanelBody-tabEntMenuDropDownListItemContainerSpan",
                                                    children: "Children"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, item))
                    })
                ]
            }, (0, $d60257e8dc27bf16$export$d66151c7af00715f)));
        }
        return tempMenu;
    };
    const renderSodContent = ()=>{
        if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$8f78881bb4058858]) {
            if (data?.sidePanel?.sod?.totalRisks > 0) return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabContent), {
                className: "CertsSidePanelBody-tabContent--sod",
                value: activeTab,
                tabValue: (0, $d60257e8dc27bf16$export$8f78881bb4058858),
                children: [
                    data?.sidePanel?.sod?.risks?.map((risk, index)=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $b291d00926535dc7$export$2e2bcd8739ae039), {
                            title: risk.riskcode,
                            iconKind: "SOD",
                            kind: "sod",
                            isInitialOpen: index < (0, $6702cb469143c6c9$export$14624c6c73370169),
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                    className: "CertsSidePanelBody-tabContentSodRisk",
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body3",
                                            className: "CertsSidePanelBody-tabContentSodRiskText",
                                            children: "Risk Priority"
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                            className: "CertsSidePanelBody-tabContentSodRiskButton",
                                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Chip), {
                                                kind: "subtleFilled",
                                                label: risk.risk_priority || "",
                                                color: (0, $6702cb469143c6c9$export$1c70425da51939b3)[risk.risk_priority] || ""
                                            })
                                        })
                                    ]
                                }, `${risk.index}-1`),
                                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                    className: "CertsSidePanelBody-tabContentSodFuncGroup",
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body3",
                                            className: "CertsSidePanelBody-tabContentSodFuncGroupTitle",
                                            children: "Conflicting Job Functions"
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                            className: "CertsSidePanelBody-tabContentSodFuncGroupBody",
                                            children: [
                                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $55f6aa546a60d23d$export$2e2bcd8739ae039), {
                                                    sodItem: {
                                                        label: risk.function1_name,
                                                        description: risk.function1_description
                                                    }
                                                }, `${risk.index}-2-1`),
                                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $55f6aa546a60d23d$export$2e2bcd8739ae039), {
                                                    sodItem: {
                                                        label: risk.function2_name,
                                                        description: risk.function2_description
                                                    }
                                                }, `${risk.index}-2-2`)
                                            ]
                                        })
                                    ]
                                }, `${risk.index}-2`),
                                index !== data.sidePanel.sod.risks.length - 1 && /*#__PURE__*/ (0, $hopDi$jsx)((0, $030549388b36232f$export$2e2bcd8739ae039), {})
                            ]
                        }, risk.index)),
                    data?.sidePanel?.sod?.totalRisks > (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7) && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "CertsSidePanelBody-tabContentLoadBtn",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: "subtle",
                            size: "medium",
                            isDisabled: viewMore[0, $d60257e8dc27bf16$export$8f78881bb4058858].currentOffset + (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7) > data?.sidePanel?.sod?.totalRisks || isLoadingMoreData,
                            onClick: ()=>callApiForLoadBtn((0, $d60257e8dc27bf16$export$8f78881bb4058858)),
                            children: "Load More"
                        })
                    })
                ]
            });
            return /*#__PURE__*/ (0, $hopDi$jsx)("span", {});
        }
        return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
            className: "CertsSidePanelBody-tabContent",
            value: activeTab,
            tabValue: (0, $d60257e8dc27bf16$export$8f78881bb4058858),
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $8198211ef3cd686e$export$2e2bcd8739ae039), {
                tab: (0, $d60257e8dc27bf16$export$8f78881bb4058858),
                retrigggerApisForError: retrigggerApisForError,
                handleCloseSidePanel: handleCloseSidePanel
            })
        });
    };
    const renderPrivilegesContent = ()=>{
        if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$a06b6c2be556dac8]) {
            if (data?.sidePanel?.privileges?.totalPrivileges > 0) return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabContent), {
                className: "CertsSidePanelBody-tabContent-privileges",
                value: activeTab,
                tabValue: (0, $d60257e8dc27bf16$export$a06b6c2be556dac8),
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $b291d00926535dc7$export$2e2bcd8739ae039), {
                        title: "Allow Action",
                        iconKind: "PrivilgedAccess",
                        isInitialOpen: true,
                        pad: "privileges",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)("ul", {
                            className: "CertsSidePanelBody-tabContentPrivilegesList",
                            children: data?.sidePanel?.privileges?.privileges?.map((item)=>/*#__PURE__*/ (0, $hopDi$jsx)("li", {
                                    className: "CertsSidePanelBody-tabContentPrivilegesListItem",
                                    children: item.attributeName
                                }, item.attributeName))
                        })
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $030549388b36232f$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $b291d00926535dc7$export$2e2bcd8739ae039), {
                        title: "Permissions",
                        iconKind: "PrivilgedAccess",
                        isInitialOpen: true,
                        pad: "privileges",
                        children: /*#__PURE__*/ (0, $hopDi$jsxs)("ul", {
                            className: "CertsSidePanelBody-tabContentPrivilegesList",
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)("li", {
                                    className: "CertsSidePanelBody-tabContentPrivilegesListItem",
                                    children: "Read"
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)("li", {
                                    className: "CertsSidePanelBody-tabContentPrivilegesListItem",
                                    children: "Write"
                                })
                            ]
                        })
                    })
                ]
            });
            return /*#__PURE__*/ (0, $hopDi$jsx)("span", {});
        }
        return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
            className: "CertsSidePanelBody-tabContent",
            value: activeTab,
            tabValue: (0, $d60257e8dc27bf16$export$a06b6c2be556dac8),
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $8198211ef3cd686e$export$2e2bcd8739ae039), {
                tab: (0, $d60257e8dc27bf16$export$a06b6c2be556dac8),
                retrigggerApisForError: retrigggerApisForError,
                handleCloseSidePanel: handleCloseSidePanel
            })
        });
    };
    const renderChildrenContentForEntitlements = ()=>{
        if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$51f82826650bc3c3]) {
            if (data?.sidePanel?.children?.totalChildEnt > 0) return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabContent), {
                className: "CertsSidePanelBody-tabContent--child",
                value: activeTab,
                tabValue: (0, $d60257e8dc27bf16$export$51f82826650bc3c3),
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "CertsSidePanelBody-tabContentChildDescription",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "body3",
                            children: "Child entitlements are subsets of access and permissions that correlate to a parent entitlement. These aren't always revoked when a parent entitlement is revoked."
                        })
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InputField), {
                        name: "basic",
                        kind: "search",
                        placeholder: "Search by Entitlement Name",
                        prefixIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "search",
                            color: "neutral-600",
                            size: "smallMedium"
                        }),
                        value: childrenSearchForEnts,
                        setValue: setChildrenSearchForEnts
                    }),
                    data?.sidePanel?.children?.childEntList.filter((child)=>`${child?.entitlement_value}`.toLowerCase().indexOf(childrenSearchForEnts.toLowerCase()) !== -1).map((child, index)=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $b291d00926535dc7$export$2e2bcd8739ae039), {
                            title: child.entitlement_value,
                            iconKind: "Entitlement",
                            isInitialOpen: index < (0, $6702cb469143c6c9$export$14624c6c73370169),
                            children: [
                                Object.keys(child).filter((node)=>node !== "entitlement_value" && node !== "index").map((node)=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $5d9478e6fefd4bf2$export$2e2bcd8739ae039), {
                                        fieldData: {
                                            label: node,
                                            value: child[node] || node
                                        }
                                    }, `${child.index}-${node}`)),
                                index !== data.sidePanel.children.childEntList.length - 1 && /*#__PURE__*/ (0, $hopDi$jsx)((0, $030549388b36232f$export$2e2bcd8739ae039), {})
                            ]
                        }, child.index)),
                    data?.sidePanel?.children?.totalChildEnt > (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7) && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "CertsSidePanelBody-tabContentLoadBtn",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: "subtle",
                            size: "medium",
                            isDisabled: viewMore[0, $d60257e8dc27bf16$export$51f82826650bc3c3].currentOffset + (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7) > data?.sidePanel?.children?.totalChildEnt || isLoadingMoreData,
                            onClick: ()=>callApiForLoadBtn((0, $d60257e8dc27bf16$export$51f82826650bc3c3)),
                            children: "Load More"
                        })
                    })
                ]
            });
            return /*#__PURE__*/ (0, $hopDi$jsx)("span", {});
        }
        return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
            className: "CertsSidePanelBody-tabContent",
            value: activeTab,
            tabValue: (0, $d60257e8dc27bf16$export$51f82826650bc3c3),
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $8198211ef3cd686e$export$2e2bcd8739ae039), {
                tab: (0, $d60257e8dc27bf16$export$51f82826650bc3c3),
                retrigggerApisForError: retrigggerApisForError,
                handleCloseSidePanel: handleCloseSidePanel
            })
        });
    };
    (0, $hopDi$useEffect)(()=>{
        if (data) setEntitlementMenu(entValidTabsForMenu());
    }, [
        data
    ]);
    const shouldShowJRMRles = Boolean(data?.sidePanel?.summary?.JRMRULES);
    const shouldShowSidePanelSummaryForEntitlement = Boolean(data?.sidePanel?.summary && data?.sidePanel?.status[0, $d60257e8dc27bf16$export$bde14d5a1cbdb371]);
    return /*#__PURE__*/ (0, $hopDi$jsxs)("section", {
        className: classes,
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabGroup), {
                value: activeTab,
                onChange: handleTabChange,
                className: "CertsSidePanelBody-tabGroup",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                        label: "Summary",
                        value: (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371),
                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "Document",
                            size: "medium",
                            color: "neutral-1000"
                        }),
                        size: "medium"
                    }, (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371)),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                        label: "History",
                        value: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "RequestHistory",
                            size: "medium",
                            color: "neutral-1000"
                        }),
                        size: "medium"
                    }, (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63)),
                    renderMenuForEntitlement(),
                    /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                        className: "CertsSidePanelBody-tabGroupEmpty",
                        value: (0, $d60257e8dc27bf16$export$8f78881bb4058858)
                    }, (0, $d60257e8dc27bf16$export$8f78881bb4058858))
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabContent), {
                className: "CertsSidePanelBody-tabContent--summary",
                value: activeTab,
                tabValue: (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371),
                children: [
                    shouldShowJRMRles && shouldShowSidePanelSummaryForEntitlement && /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                className: "CertsSidePanelBody-tabContentSummaryShorts",
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                        className: ".CertsSidePanelBody-tabContentSummaryShortsStatus",
                                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "h4",
                                            children: "Risk"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                        className: "CertsSidePanelBody-tabContentSummaryShortsRisk",
                                        children: [
                                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $d890b5a3788f0783$export$2e2bcd8739ae039), {
                                                kind: "success",
                                                size: "regular",
                                                value: 10,
                                                label: `${data?.sidePanel?.summary?.RISK}`
                                            }),
                                            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                                className: "CertsSidePanelBody-tabContentSummaryShortsRiskList",
                                                children: [
                                                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                                        className: "CertsSidePanelBody-tabContentSummaryShortsRiskListItem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                                                kind: "CheckCircleOutline",
                                                                size: "medium",
                                                                color: "success-800"
                                                            }),
                                                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                                                kind: "body2",
                                                                className: "CertsSidePanelBody-tabContentSummaryShortsRiskListItemText",
                                                                children: "98% of the user's peers have access"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                                        className: "CertsSidePanelBody-tabContentSummaryShortsRiskListItem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                                                kind: "CheckCircleOutline",
                                                                size: "medium",
                                                                color: "success-800"
                                                            }),
                                                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                                                kind: "body2",
                                                                className: "CertsSidePanelBody-tabContentSummaryShortsRiskListItemText",
                                                                children: "Certified in past 6 months"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                                        className: "CertsSidePanelBody-tabContentSummaryShortsRiskListItem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                                                kind: "AlertCriticalOutline",
                                                                size: "medium",
                                                                color: "critical-800"
                                                            }),
                                                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                                                kind: "body2",
                                                                className: "CertsSidePanelBody-tabContentSummaryShortsRiskListItemText",
                                                                children: "Inactive for 60 days"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $030549388b36232f$export$2e2bcd8739ae039), {})
                        ]
                    }),
                    shouldShowSidePanelSummaryForEntitlement ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $f628408145ad5bcd$export$2e2bcd8739ae039), {
                        data: data
                    }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $8198211ef3cd686e$export$2e2bcd8739ae039), {
                        tab: (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371),
                        retrigggerApisForError: retrigggerApisForError,
                        handleCloseSidePanel: handleCloseSidePanel
                    })
                ]
            }),
            renderHistoryContent(),
            renderSodContent(),
            renderPrivilegesContent(),
            renderChildrenContentForEntitlements()
        ]
    });
}
$497631ad0623d8a8$var$CertsSidePanelEntitlements.propTypes = {
    dataTestId: (0, $hopDi$proptypes).string,
    className: (0, $hopDi$proptypes).string,
    data: (0, $hopDi$proptypes).shape((0, $708c26a04684b266$export$2e2bcd8739ae039)).isRequired,
    activeTab: (0, $hopDi$proptypes).string.isRequired,
    setActiveTab: (0, $hopDi$proptypes).func.isRequired,
    isLoadingHistory: (0, $hopDi$proptypes).bool.isRequired,
    retrigggerApisForError: (0, $hopDi$proptypes).func,
    handleCloseSidePanel: (0, $hopDi$proptypes).func
};
$497631ad0623d8a8$var$CertsSidePanelEntitlements.defaultProps = {
    dataTestId: null,
    className: null,
    retrigggerApisForError: ()=>{},
    handleCloseSidePanel: ()=>{}
};
var $497631ad0623d8a8$export$2e2bcd8739ae039 = $497631ad0623d8a8$var$CertsSidePanelEntitlements;


var $ce19cd0e10f2ccd9$export$2e2bcd8739ae039 = (0, $497631ad0623d8a8$export$2e2bcd8739ae039);


/* eslint-disable no-console */ /* eslint-disable jsx-a11y/anchor-is-valid */ 













function $43c5162f45fcf3ad$var$CertsSidePanelRoles({ dataTestId: dataTestId, className: className, data: data, activeTab: activeTab, setActiveTab: setActiveTab, isLoadingHistory: isLoadingHistory, retrigggerApisForError: retrigggerApisForError, handleCloseSidePanel: handleCloseSidePanel }) {
    const dispatch = (0, $hopDi$useDispatch)();
    const classes = (0, $hopDi$classnames)("CertsSidePanelBody", className);
    const [showHistory, setShowHistory] = (0, $hopDi$useState)(false);
    const [isLoadingMoreData, setIsLoadingMoreData] = (0, $hopDi$useState)(false);
    const [viewMore, setViewMore] = (0, $hopDi$useState)({
        [(0, $d60257e8dc27bf16$export$6cc684447a8d7b17)]: {
            currentOffset: 0
        },
        [(0, $d60257e8dc27bf16$export$51f82826650bc3c3)]: {
            currentOffset: 0
        }
    });
    const [entitlementSearchForRoles, setEntitlementSearchForRoles] = (0, $hopDi$useState)("");
    const [childrenSearchForRoles, setChildrenSearchForRoles] = (0, $hopDi$useState)("");
    const callApiForLoadBtn = (tab)=>{
        setIsLoadingMoreData(true);
        switch(tab){
            case 0, $d60257e8dc27bf16$export$6cc684447a8d7b17:
                dispatch((0, $d623f23401a154f0$export$5410f6e40c605c13)(data.CERT_ROLEKEY, String(viewMore[0, $d60257e8dc27bf16$export$6cc684447a8d7b17].currentOffset + (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)), String((0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)), (0, $d6d78fc758ee4148$export$2e6684ed5543ad11))).then(()=>{
                    setViewMore((prevViewMore)=>({
                            ...prevViewMore,
                            [tab]: {
                                currentOffset: prevViewMore[tab].currentOffset + (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)
                            }
                        }));
                    setIsLoadingMoreData(false);
                }).catch(()=>{
                    setIsLoadingMoreData(false);
                });
                break;
            case 0, $d60257e8dc27bf16$export$51f82826650bc3c3:
                dispatch((0, $d623f23401a154f0$export$d602a5e5a48fdf7d)(data.CERT_ROLEKEY, String(viewMore[0, $d60257e8dc27bf16$export$51f82826650bc3c3].currentOffset + (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)), String((0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)), (0, $d6d78fc758ee4148$export$2e6684ed5543ad11))).then(()=>{
                    setViewMore((prevViewMore)=>({
                            ...prevViewMore,
                            [tab]: {
                                currentOffset: prevViewMore[tab].currentOffset + (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)
                            }
                        }));
                    setIsLoadingMoreData(false);
                }).catch(()=>{
                    setIsLoadingMoreData(false);
                });
                break;
            default:
                break;
        }
    };
    (0, $hopDi$useEffect)(()=>{
        setEntitlementSearchForRoles("");
        setChildrenSearchForRoles("");
        setShowHistory(activeTab === (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63));
    }, [
        activeTab
    ]);
    const handleTabChange = (value)=>{
        setActiveTab(value);
    };
    const renderHistoryContent = ()=>{
        if (showHistory) {
            if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$9b67fda1e37e6e63]) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
                className: "CertsSidePanelBody-tabContent--history",
                value: activeTab,
                tabValue: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $e52ca6c769e8713d$export$2e2bcd8739ae039), {
                    data: data,
                    isLoadingHistory: isLoadingHistory
                })
            });
            return /*#__PURE__*/ (0, $hopDi$jsx)((0, $8198211ef3cd686e$export$2e2bcd8739ae039), {
                tab: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
                retrigggerApisForError: retrigggerApisForError,
                handleCloseSidePanel: handleCloseSidePanel
            });
        }
        return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
            className: "CertsSidePanelBody-tabContent--history",
            value: activeTab,
            tabValue: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
            children: /*#__PURE__*/ (0, $hopDi$jsx)("div", {})
        });
    };
    const renderEntitlementTab = ()=>{
        if (data) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
            label: "Entitlement",
            value: (0, $d60257e8dc27bf16$export$6cc684447a8d7b17),
            icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                kind: "Entitlement",
                size: "medium",
                color: "neutral-1000"
            }),
            size: "medium"
        }, (0, $d60257e8dc27bf16$export$6cc684447a8d7b17));
        return /*#__PURE__*/ (0, $hopDi$jsx)("span", {
            className: "CertsSidePanelBody-tabGroupEmpty",
            value: (0, $d60257e8dc27bf16$export$6cc684447a8d7b17)
        }, (0, $d60257e8dc27bf16$export$6cc684447a8d7b17));
    };
    const renderChildrenTabForRoles = ()=>{
        if (data) {
            if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$51f82826650bc3c3]) {
                if (data?.sidePanel?.children?.totalChildRole > 0) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                    label: "Children",
                    value: (0, $d60257e8dc27bf16$export$51f82826650bc3c3),
                    icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "Entitlement",
                        size: "medium",
                        color: "neutral-1000"
                    }),
                    size: "medium"
                }, (0, $d60257e8dc27bf16$export$51f82826650bc3c3));
                return /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                    className: "CertsSidePanelBody-tabGroupEmpty"
                });
            }
            return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                label: "Children",
                value: (0, $d60257e8dc27bf16$export$51f82826650bc3c3),
                icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "Entitlement",
                    size: "medium",
                    color: "neutral-1000"
                }),
                size: "medium"
            });
        }
        return /*#__PURE__*/ (0, $hopDi$jsx)("span", {
            className: "CertsSidePanelBody-tabGroupEmpty"
        });
    };
    const renderEntitlementContentForRoles = ()=>{
        if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$6cc684447a8d7b17]) {
            if (data?.sidePanel?.entitlements?.totalEnt > 0) return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabContent), {
                className: "CertsSidePanelBody-tabContent--entitlement",
                value: activeTab,
                tabValue: (0, $d60257e8dc27bf16$export$6cc684447a8d7b17),
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "CertsSidePanelBody-tabContentEntitlementSearch",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InputField), {
                            name: "basic",
                            kind: "search",
                            placeholder: "Search by Entitlement Name",
                            prefixIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: "search",
                                color: "neutral-600",
                                size: "smallMedium"
                            }),
                            value: entitlementSearchForRoles,
                            setValue: setEntitlementSearchForRoles
                        })
                    }),
                    data?.sidePanel?.entitlements?.roleEntList.filter((child)=>`${child.entitlement_value}`.toLowerCase().indexOf(entitlementSearchForRoles.toLowerCase()) !== -1).map((child, index)=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $b291d00926535dc7$export$2e2bcd8739ae039), {
                            title: child.entitlement_value,
                            iconKind: "Entitlement",
                            isInitialOpen: index < (0, $6702cb469143c6c9$export$14624c6c73370169),
                            children: [
                                Object.keys(child).filter((node)=>node !== "entitlement_value" && node !== "index").map((node)=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $5d9478e6fefd4bf2$export$2e2bcd8739ae039), {
                                        fieldData: {
                                            label: node,
                                            value: child[node] || node
                                        }
                                    }, `${child.index}-${node}`)),
                                index !== data.sidePanel.entitlements.roleEntList.length - 1 && /*#__PURE__*/ (0, $hopDi$jsx)((0, $030549388b36232f$export$2e2bcd8739ae039), {})
                            ]
                        }, child.index)),
                    data?.sidePanel?.entitlements?.totalEnt > (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7) && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "CertsSidePanelBody-tabContentLoadBtn",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: "subtle",
                            size: "medium",
                            isDisabled: viewMore[0, $d60257e8dc27bf16$export$6cc684447a8d7b17].currentOffset + (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7) > data?.sidePanel?.entitlements?.totalEnt || isLoadingMoreData,
                            onClick: ()=>callApiForLoadBtn((0, $d60257e8dc27bf16$export$6cc684447a8d7b17)),
                            children: "Load More"
                        })
                    })
                ]
            });
            return /*#__PURE__*/ (0, $hopDi$jsx)("span", {});
        }
        return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
            className: "CertsSidePanelBody-tabContent",
            value: activeTab,
            tabValue: (0, $d60257e8dc27bf16$export$6cc684447a8d7b17),
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $8198211ef3cd686e$export$2e2bcd8739ae039), {
                tab: (0, $d60257e8dc27bf16$export$6cc684447a8d7b17),
                retrigggerApisForError: retrigggerApisForError,
                handleCloseSidePanel: handleCloseSidePanel
            })
        });
    };
    const renderChildrenContentForRoles = ()=>{
        if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$51f82826650bc3c3]) {
            if (data?.sidePanel?.children?.totalChildRole > 0) return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabContent), {
                className: "CertsSidePanelBody-tabContent--child",
                value: activeTab,
                tabValue: (0, $d60257e8dc27bf16$export$51f82826650bc3c3),
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body3",
                        className: "CertsSidePanelBody-tabContentChildDescriptionGap",
                        children: `${"Text for gap"}`
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InputField), {
                        name: "basic",
                        kind: "search",
                        placeholder: "Search by Entitlement Name",
                        prefixIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "search",
                            color: "neutral-600",
                            size: "smallMedium"
                        }),
                        value: childrenSearchForRoles,
                        setValue: setChildrenSearchForRoles
                    }),
                    data?.sidePanel?.children?.childRoleList.filter((child)=>`$${child.displayname}`.toLowerCase().indexOf(childrenSearchForRoles.toLowerCase()) !== -1).map((child, index)=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $b291d00926535dc7$export$2e2bcd8739ae039), {
                            title: child.displayname || "",
                            iconKind: "Entitlement",
                            isInitialOpen: index < (0, $6702cb469143c6c9$export$14624c6c73370169),
                            children: [
                                Object.keys(child).filter((node)=>node !== "displayname" && node !== "index").map((node)=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $5d9478e6fefd4bf2$export$2e2bcd8739ae039), {
                                        fieldData: {
                                            label: node,
                                            value: child[node] || node
                                        }
                                    }, `${child.index}-${node}`)),
                                index !== data.sidePanel.children.childRoleList.length - 1 && /*#__PURE__*/ (0, $hopDi$jsx)((0, $030549388b36232f$export$2e2bcd8739ae039), {})
                            ]
                        }, child.index)),
                    data?.sidePanel?.children?.totalChildRole > (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7) && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "CertsSidePanelBody-tabContentLoadBtn",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: "subtle",
                            size: "medium",
                            isDisabled: viewMore[0, $d60257e8dc27bf16$export$51f82826650bc3c3].currentOffset + (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7) > data?.sidePanel?.children?.totalChildRole || isLoadingMoreData,
                            onClick: ()=>callApiForLoadBtn((0, $d60257e8dc27bf16$export$51f82826650bc3c3)),
                            children: "Load More"
                        })
                    })
                ]
            });
            return /*#__PURE__*/ (0, $hopDi$jsx)("span", {});
        }
        return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
            className: "CertsSidePanelBody-tabContent",
            value: activeTab,
            tabValue: (0, $d60257e8dc27bf16$export$51f82826650bc3c3),
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $8198211ef3cd686e$export$2e2bcd8739ae039), {
                tab: (0, $d60257e8dc27bf16$export$51f82826650bc3c3),
                retrigggerApisForError: retrigggerApisForError,
                handleCloseSidePanel: handleCloseSidePanel
            })
        });
    };
    const shouldShowSidePanelSummaryForRoles = Boolean(data?.sidePanel?.summary && data?.sidePanel?.status[0, $d60257e8dc27bf16$export$bde14d5a1cbdb371]);
    const shouldShowJRMRules = Boolean(data?.sidePanel?.summary?.JRMRULES);
    return /*#__PURE__*/ (0, $hopDi$jsxs)("section", {
        className: classes,
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabGroup), {
                value: activeTab,
                onChange: handleTabChange,
                className: "CertsSidePanelBody-tabGroup",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                        label: "Summary",
                        value: (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371),
                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "Document",
                            size: "medium",
                            color: "neutral-1000"
                        }),
                        size: "medium"
                    }, (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371)),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                        label: "History",
                        value: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "RequestHistory",
                            size: "medium",
                            color: "neutral-1000"
                        }),
                        size: "medium"
                    }, (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63)),
                    renderEntitlementTab(),
                    renderChildrenTabForRoles()
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabContent), {
                className: "CertsSidePanelBody-tabContent--summary",
                value: activeTab,
                tabValue: (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371),
                children: [
                    shouldShowJRMRules && shouldShowSidePanelSummaryForRoles && /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                className: "CertsSidePanelBody-tabContentSummaryShorts",
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                        className: ".CertsSidePanelBody-tabContentSummaryShortsStatus",
                                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "h4",
                                            children: "Risk"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                        className: "CertsSidePanelBody-tabContentSummaryShortsRisk",
                                        children: [
                                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                                className: "CertsSidePanelBody-tabContentSummaryShortsRiskScore",
                                                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $d890b5a3788f0783$export$2e2bcd8739ae039), {
                                                    kind: "success",
                                                    size: "regular",
                                                    value: 10,
                                                    label: `${data?.sidePanel?.summary?.RISK}`
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                                className: "CertsSidePanelBody-tabContentSummaryShortsRiskList",
                                                children: [
                                                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                                        className: "CertsSidePanelBody-tabContentSummaryShortsRiskListItem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                                                kind: "CheckCircleOutline",
                                                                size: "medium",
                                                                color: "success-800"
                                                            }),
                                                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                                                kind: "body2",
                                                                className: "CertsSidePanelBody-tabContentSummaryShortsRiskListItemText",
                                                                children: "98% of the user's peers have access"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                                        className: "CertsSidePanelBody-tabContentSummaryShortsRiskListItem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                                                kind: "CheckCircleOutline",
                                                                size: "medium",
                                                                color: "success-800"
                                                            }),
                                                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                                                kind: "body2",
                                                                className: "CertsSidePanelBody-tabContentSummaryShortsRiskListItemText",
                                                                children: "Certified in past 6 months"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                                        className: "CertsSidePanelBody-tabContentSummaryShortsRiskListItem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                                                kind: "AlertCriticalOutline",
                                                                size: "medium",
                                                                color: "critical-800"
                                                            }),
                                                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                                                kind: "body2",
                                                                className: "CertsSidePanelBody-tabContentSummaryShortsRiskListItemText",
                                                                children: "Inactive for 60 days"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $030549388b36232f$export$2e2bcd8739ae039), {})
                        ]
                    }),
                    shouldShowSidePanelSummaryForRoles ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $f628408145ad5bcd$export$2e2bcd8739ae039), {
                        data: data
                    }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $8198211ef3cd686e$export$2e2bcd8739ae039), {
                        tab: (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371),
                        retrigggerApisForError: retrigggerApisForError,
                        handleCloseSidePanel: handleCloseSidePanel
                    })
                ]
            }),
            renderHistoryContent(),
            renderEntitlementContentForRoles(),
            renderChildrenContentForRoles()
        ]
    });
}
$43c5162f45fcf3ad$var$CertsSidePanelRoles.propTypes = {
    dataTestId: (0, $hopDi$proptypes).string,
    className: (0, $hopDi$proptypes).string,
    data: (0, $hopDi$proptypes).shape((0, $708c26a04684b266$export$2e2bcd8739ae039)).isRequired,
    activeTab: (0, $hopDi$proptypes).string.isRequired,
    setActiveTab: (0, $hopDi$proptypes).func.isRequired,
    isLoadingHistory: (0, $hopDi$proptypes).bool.isRequired,
    retrigggerApisForError: (0, $hopDi$proptypes).func,
    handleCloseSidePanel: (0, $hopDi$proptypes).func
};
$43c5162f45fcf3ad$var$CertsSidePanelRoles.defaultProps = {
    dataTestId: null,
    className: null,
    retrigggerApisForError: ()=>{},
    handleCloseSidePanel: ()=>{}
};
var $43c5162f45fcf3ad$export$2e2bcd8739ae039 = $43c5162f45fcf3ad$var$CertsSidePanelRoles;


var $5de156f3e0748d5b$export$2e2bcd8739ae039 = (0, $43c5162f45fcf3ad$export$2e2bcd8739ae039);











function $91ffcbef557bd0e8$var$CertsSidePanelUsers({ dataTestId: dataTestId, className: className, data: data, activeTab: activeTab, setActiveTab: setActiveTab, isLoadingHistory: isLoadingHistory, retrigggerApisForError: retrigggerApisForError, handleCloseSidePanel: handleCloseSidePanel }) {
    const classes = (0, $hopDi$classnames)("CertsSidePanelBody", className);
    const [showHistory, setShowHistory] = (0, $hopDi$useState)(false);
    (0, $hopDi$useEffect)(()=>{
        setShowHistory(activeTab === (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63));
    }, [
        activeTab
    ]);
    const handleTabChange = (value)=>{
        setActiveTab(value);
    };
    const renderHistoryContent = ()=>{
        if (showHistory) {
            if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$9b67fda1e37e6e63]) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
                className: "CertsSidePanelBody-tabContent--history",
                value: activeTab,
                tabValue: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $e52ca6c769e8713d$export$2e2bcd8739ae039), {
                    data: data,
                    isLoadingHistory: isLoadingHistory
                })
            });
            return /*#__PURE__*/ (0, $hopDi$jsx)((0, $8198211ef3cd686e$export$2e2bcd8739ae039), {
                tab: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
                retrigggerApisForError: retrigggerApisForError,
                handleCloseSidePanel: handleCloseSidePanel
            });
        }
        return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
            className: "CertsSidePanelBody-tabContent--history",
            value: activeTab,
            tabValue: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
            children: /*#__PURE__*/ (0, $hopDi$jsx)("div", {})
        });
    };
    const shouldShowSidePanelSummaryForUsers = Boolean(data?.sidePanel?.summary && data?.sidePanel?.status[0, $d60257e8dc27bf16$export$bde14d5a1cbdb371]);
    return /*#__PURE__*/ (0, $hopDi$jsxs)("section", {
        className: classes,
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabGroup), {
                value: activeTab,
                onChange: handleTabChange,
                className: "CertsSidePanelBody-tabGroup",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                        label: "Summary",
                        value: (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371),
                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "Document",
                            size: "medium",
                            color: "neutral-1000"
                        }),
                        size: "medium"
                    }, (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371)),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                        label: "History",
                        value: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "RequestHistory",
                            size: "medium",
                            color: "neutral-1000"
                        }),
                        size: "medium"
                    }, (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63)),
                    /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                        className: "CertsSidePanelBody-tabGroupEmpty"
                    }, `${(0, $d60257e8dc27bf16$export$bde14d5a1cbdb371)}-1`)
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
                className: "CertsSidePanelBody-tabContent--summary",
                value: activeTab,
                tabValue: (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371),
                children: shouldShowSidePanelSummaryForUsers ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $f628408145ad5bcd$export$2e2bcd8739ae039), {
                    data: data
                }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $8198211ef3cd686e$export$2e2bcd8739ae039), {
                    tab: (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371),
                    retrigggerApisForError: retrigggerApisForError,
                    handleCloseSidePanel: handleCloseSidePanel
                })
            }),
            renderHistoryContent()
        ]
    });
}
$91ffcbef557bd0e8$var$CertsSidePanelUsers.propTypes = {
    dataTestId: (0, $hopDi$proptypes).string,
    className: (0, $hopDi$proptypes).string,
    data: (0, $hopDi$proptypes).shape((0, $708c26a04684b266$export$2e2bcd8739ae039)).isRequired,
    activeTab: (0, $hopDi$proptypes).string.isRequired,
    setActiveTab: (0, $hopDi$proptypes).func.isRequired,
    isLoadingHistory: (0, $hopDi$proptypes).bool.isRequired,
    retrigggerApisForError: (0, $hopDi$proptypes).func,
    handleCloseSidePanel: (0, $hopDi$proptypes).func
};
$91ffcbef557bd0e8$var$CertsSidePanelUsers.defaultProps = {
    dataTestId: null,
    className: null,
    retrigggerApisForError: ()=>{},
    handleCloseSidePanel: ()=>{}
};
var $91ffcbef557bd0e8$export$2e2bcd8739ae039 = $91ffcbef557bd0e8$var$CertsSidePanelUsers;


var $a907449f3dde7b07$export$2e2bcd8739ae039 = (0, $91ffcbef557bd0e8$export$2e2bcd8739ae039);




function $56256445b185fcc5$var$CertsSidePanelBody({ data: data, dataTestId: dataTestId, className: className, handleCloseSidePanel: handleCloseSidePanel }) {
    const dispatch = (0, $hopDi$useDispatch)();
    const { certKey: certKey, isSidePanelLoading: isSidePanelLoading, sidePanelUsers: sidePanelUsers, sidePanelRoles: sidePanelRoles, sidePanelAccounts: sidePanelAccounts, sidePanelEntitlements: sidePanelEntitlements } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const classes = (0, $hopDi$classnames)("SidePanelView", className);
    const [activeTab, setActiveTab] = (0, $hopDi$useState)((0, $d60257e8dc27bf16$export$bde14d5a1cbdb371));
    const [isLoading, setIsLoading] = (0, $hopDi$useState)(false);
    const [isLoadingHistory, setIsLoadingHistory] = (0, $hopDi$useState)(false);
    const [users, setUsers] = (0, $hopDi$useState)({
        ...data,
        sidePanel: {
            status: {
                [(0, $d60257e8dc27bf16$export$bde14d5a1cbdb371)]: false,
                [(0, $d60257e8dc27bf16$export$9b67fda1e37e6e63)]: false
            }
        }
    });
    const [roles, setRoles] = (0, $hopDi$useState)({
        ...data,
        sidePanel: {
            status: {
                [(0, $d60257e8dc27bf16$export$bde14d5a1cbdb371)]: false,
                [(0, $d60257e8dc27bf16$export$9b67fda1e37e6e63)]: false,
                [(0, $d60257e8dc27bf16$export$6cc684447a8d7b17)]: false,
                [(0, $d60257e8dc27bf16$export$51f82826650bc3c3)]: false
            }
        }
    });
    const [accounts, setAccounts] = (0, $hopDi$useState)({
        ...data,
        sidePanel: {
            status: {
                [(0, $d60257e8dc27bf16$export$bde14d5a1cbdb371)]: false,
                [(0, $d60257e8dc27bf16$export$9b67fda1e37e6e63)]: false
            }
        }
    });
    const [entitlements, setEntitlements] = (0, $hopDi$useState)({
        ...data,
        sidePanel: {
            unFixedTabs: [
                (0, $d60257e8dc27bf16$export$8f78881bb4058858),
                (0, $d60257e8dc27bf16$export$a06b6c2be556dac8),
                (0, $d60257e8dc27bf16$export$51f82826650bc3c3)
            ],
            status: {
                [(0, $d60257e8dc27bf16$export$bde14d5a1cbdb371)]: false,
                [(0, $d60257e8dc27bf16$export$9b67fda1e37e6e63)]: false,
                [(0, $d60257e8dc27bf16$export$8f78881bb4058858)]: false,
                [(0, $d60257e8dc27bf16$export$a06b6c2be556dac8)]: false,
                [(0, $d60257e8dc27bf16$export$51f82826650bc3c3)]: false,
                [(0, $d60257e8dc27bf16$export$ed0bf72b1f4a9681)]: false
            }
        }
    });
    const promisesForSidePanel = [];
    const callApiForHistory = ()=>{
        setIsLoadingHistory(true);
        switch(data?.type){
            case 0, $d60257e8dc27bf16$export$1cc98074061c90d2:
                promisesForSidePanel.push(dispatch((0, $d623f23401a154f0$export$ac08493018d65897)(certKey, data.CERT_ENTITLEMENT_VALUEKEY, data.CERT_USERKEY)));
                Promise.allSettled(promisesForSidePanel).then((responses)=>{
                    const statusToExtend = {};
                    responses.forEach((response)=>{
                        if (response.status === (0, $6702cb469143c6c9$export$8a2c144908a2b8f5)) statusToExtend[response.value] = true;
                    });
                    setUsers((prev)=>({
                            ...prev,
                            sidePanel: {
                                ...prev.sidePanel,
                                status: {
                                    ...prev.sidePanel.status,
                                    ...statusToExtend
                                }
                            }
                        }));
                }).finally(()=>{
                    setIsLoadingHistory(false);
                    promisesForSidePanel.length = 0;
                });
                break;
            case 0, $d60257e8dc27bf16$export$7d6712c2cb8377b2:
                promisesForSidePanel.push(dispatch((0, $d623f23401a154f0$export$8ea25d5aa1748f67)(certKey, data.CERT_ENTITLEMENT_VALUEKEY, data.CERT_USERKEY, data.CERT_ROLEKEY)));
                Promise.allSettled(promisesForSidePanel).then((responses)=>{
                    const statusToExtend = {};
                    responses.forEach((response)=>{
                        if (response.status === (0, $6702cb469143c6c9$export$8a2c144908a2b8f5)) statusToExtend[response.value] = true;
                    });
                    setRoles((prev)=>({
                            ...prev,
                            sidePanel: {
                                ...prev.sidePanel,
                                status: {
                                    ...prev.sidePanel.status,
                                    ...statusToExtend
                                }
                            }
                        }));
                }).finally(()=>{
                    setIsLoadingHistory(false);
                    promisesForSidePanel.length = 0;
                });
                break;
            case 0, $d60257e8dc27bf16$export$153ab95c08227093:
                promisesForSidePanel.push(dispatch((0, $d623f23401a154f0$export$188b24a44048ab8)(certKey, data.CERT_ENTITLEMENT_VALUEKEY, data.CERT_USERKEY, data.CERT_ACCOUNTKEY)));
                Promise.allSettled(promisesForSidePanel).then((responses)=>{
                    const statusToExtend = {};
                    responses.forEach((response)=>{
                        if (response.status === (0, $6702cb469143c6c9$export$8a2c144908a2b8f5)) statusToExtend[response.value] = true;
                    });
                    setAccounts((prev)=>({
                            ...prev,
                            sidePanel: {
                                ...prev.sidePanel,
                                status: {
                                    ...prev.sidePanel.status,
                                    ...statusToExtend
                                }
                            }
                        }));
                }).finally(()=>{
                    setIsLoadingHistory(false);
                    promisesForSidePanel.length = 0;
                });
                break;
            case 0, $d60257e8dc27bf16$export$be9a3074cb3ae0c7:
                promisesForSidePanel.push(dispatch((0, $d623f23401a154f0$export$46991d3da34782bf)(certKey, data.CERT_ENTITLEMENT_VALUEKEY, data.CERT_USERKEY, data.CERT_ACCOUNTKEY, data.CERT_ROLEKEY)));
                Promise.allSettled(promisesForSidePanel).then((responses)=>{
                    const statusToExtend = {};
                    responses.forEach((response)=>{
                        if (response.status === (0, $6702cb469143c6c9$export$8a2c144908a2b8f5)) statusToExtend[response.value] = true;
                    });
                    setEntitlements((prev)=>({
                            ...prev,
                            sidePanel: {
                                ...prev.sidePanel,
                                status: {
                                    ...prev.sidePanel.status,
                                    ...statusToExtend
                                }
                            }
                        }));
                }).finally(()=>{
                    setIsLoadingHistory(false);
                    promisesForSidePanel.length = 0;
                });
                break;
            default:
                break;
        }
    };
    const callApiByType = ()=>{
        switch(data?.type){
            case 0, $d60257e8dc27bf16$export$1cc98074061c90d2:
                promisesForSidePanel.push(dispatch((0, $d623f23401a154f0$export$d5a553b80e9461bd)(data.id, certKey, data.CERT_USERKEY)), dispatch((0, $d623f23401a154f0$export$ac08493018d65897)(certKey, data.CERT_ENTITLEMENT_VALUEKEY, data.CERT_USERKEY, data.CERT_ACCOUNTKEY)));
                Promise.allSettled(promisesForSidePanel).then((responses)=>{
                    if (!responses.some((response)=>response.status === (0, $6702cb469143c6c9$export$8a2c144908a2b8f5))) throw new Error({
                        status: false
                    });
                    const statusToExtend = {};
                    responses.forEach((response)=>{
                        if (response.status === (0, $6702cb469143c6c9$export$8a2c144908a2b8f5)) statusToExtend[response.value] = true;
                    });
                    setUsers((prev)=>({
                            ...prev,
                            sidePanel: {
                                ...prev.sidePanel,
                                status: {
                                    ...prev.sidePanel.status,
                                    ...statusToExtend
                                }
                            }
                        }));
                }).catch(()=>{
                    const statusToExtend = {};
                    Object.keys(users?.sidePanel.status).forEach((key)=>{
                        statusToExtend[key] = false;
                    });
                    setUsers((prev)=>({
                            ...prev,
                            sidePanel: {
                                ...prev.sidePanel,
                                status: {
                                    ...prev.sidePanel.status,
                                    ...statusToExtend
                                }
                            }
                        }));
                }).finally(()=>{
                    setIsLoading(false);
                    setActiveTab((0, $d60257e8dc27bf16$export$bde14d5a1cbdb371));
                    promisesForSidePanel.length = 0;
                });
                break;
            case 0, $d60257e8dc27bf16$export$7d6712c2cb8377b2:
                promisesForSidePanel.push(dispatch((0, $d623f23401a154f0$export$d2ad049199ba44f6)(data.id, certKey, data.CERT_ROLEKEY)), dispatch((0, $d623f23401a154f0$export$8ea25d5aa1748f67)(certKey, data.CERT_ENTITLEMENT_VALUEKEY, data.CERT_USERKEY, data.CERT_ROLEKEY)), dispatch((0, $d623f23401a154f0$export$5410f6e40c605c13)(data.CERT_ROLEKEY, "0", String((0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)))), dispatch((0, $d623f23401a154f0$export$d602a5e5a48fdf7d)(data.CERT_ROLEKEY, "0", String((0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)))));
                Promise.allSettled(promisesForSidePanel).then((responses)=>{
                    if (!responses.some((response)=>response.status === (0, $6702cb469143c6c9$export$8a2c144908a2b8f5))) throw new Error({
                        status: false
                    });
                    const statusToExtend = {};
                    responses.forEach((response)=>{
                        if (response.status === (0, $6702cb469143c6c9$export$8a2c144908a2b8f5)) statusToExtend[response.value] = true;
                    });
                    setRoles((prev)=>({
                            ...prev,
                            sidePanel: {
                                ...prev.sidePanel,
                                status: {
                                    ...prev.sidePanel.status,
                                    ...statusToExtend
                                }
                            }
                        }));
                }).catch(()=>{
                    const statusToExtend = {};
                    Object.keys(roles?.sidePanel.status).forEach((key)=>{
                        statusToExtend[key] = false;
                    });
                    setRoles((prev)=>({
                            ...prev,
                            sidePanel: {
                                ...prev.sidePanel,
                                status: {
                                    ...prev.sidePanel.status,
                                    ...statusToExtend
                                }
                            }
                        }));
                }).finally(()=>{
                    setIsLoading(false);
                    setActiveTab((0, $d60257e8dc27bf16$export$bde14d5a1cbdb371));
                    promisesForSidePanel.length = 0;
                });
                break;
            case 0, $d60257e8dc27bf16$export$153ab95c08227093:
                dispatch((0, $d623f23401a154f0$export$61e757f80085daf4)(true));
                promisesForSidePanel.push(dispatch((0, $d623f23401a154f0$export$b903631ea95845bc)(data.id, certKey)), dispatch((0, $d623f23401a154f0$export$188b24a44048ab8)(certKey, data.CERT_ENTITLEMENT_VALUEKEY, data.CERT_USERKEY, data.CERT_ACCOUNTKEY)));
                Promise.allSettled(promisesForSidePanel).then((responses)=>{
                    if (!responses.some((response)=>response.status === (0, $6702cb469143c6c9$export$8a2c144908a2b8f5))) throw new Error({
                        status: false
                    });
                    const statusToExtend = {};
                    responses.forEach((response)=>{
                        if (response.status === (0, $6702cb469143c6c9$export$8a2c144908a2b8f5)) statusToExtend[response.value] = true;
                    });
                    setAccounts((prev)=>({
                            ...prev,
                            sidePanel: {
                                ...prev.sidePanel,
                                status: {
                                    ...prev.sidePanel.status,
                                    ...statusToExtend
                                }
                            }
                        }));
                }).catch(()=>{
                    const statusToExtend = {};
                    Object.keys(accounts?.sidePanel.status).forEach((key)=>{
                        statusToExtend[key] = false;
                    });
                    setAccounts((prev)=>({
                            ...prev,
                            sidePanel: {
                                ...prev.sidePanel,
                                status: {
                                    ...prev.sidePanel.status,
                                    ...statusToExtend
                                }
                            }
                        }));
                }).finally(()=>{
                    setIsLoading(false);
                    setActiveTab((0, $d60257e8dc27bf16$export$bde14d5a1cbdb371));
                    promisesForSidePanel.length = 0;
                });
                break;
            case 0, $d60257e8dc27bf16$export$be9a3074cb3ae0c7:
                dispatch((0, $d623f23401a154f0$export$61e757f80085daf4)(true));
                promisesForSidePanel.push(dispatch((0, $d623f23401a154f0$export$965ea1a49a0c67d1)(data.id, certKey, data.CERT_ENTITLEMENT_VALUEKEY)), dispatch((0, $d623f23401a154f0$export$46991d3da34782bf)(certKey, data.CERT_ENTITLEMENT_VALUEKEY, data.CERT_USERKEY, data.CERT_ACCOUNTKEY, data.CERT_ROLEKEY)), dispatch((0, $d623f23401a154f0$export$83557c31dc95212a)(data.CERT_ENTITLEMENT_VALUEKEY, data.CERT_ACCOUNTKEY, "0", String((0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)))), dispatch((0, $d623f23401a154f0$export$1fbc321c679e35cc)(certKey, data.CERT_ENTITLEMENT_VALUEKEY, data.CERT_ACCOUNTKEY, "0", String((0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)), "")), dispatch((0, $d623f23401a154f0$export$f8b073a05f313ac0)(data.CERT_ENTITLEMENT_VALUEKEY, "0", String((0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)))));
                Promise.allSettled(promisesForSidePanel).then((responses)=>{
                    if (!responses.some((response)=>response.status === (0, $6702cb469143c6c9$export$8a2c144908a2b8f5))) throw new Error({
                        status: false
                    });
                    const statusToExtend = {};
                    responses.forEach((response)=>{
                        if (response.status === (0, $6702cb469143c6c9$export$8a2c144908a2b8f5)) statusToExtend[response.value] = true;
                    });
                    setEntitlements((prev)=>({
                            ...prev,
                            sidePanel: {
                                ...prev.sidePanel,
                                status: {
                                    ...prev.sidePanel.status,
                                    ...statusToExtend
                                }
                            }
                        }));
                }).catch(()=>{
                    const statusToExtend = {};
                    Object.keys(entitlements?.sidePanel.status).forEach((key)=>{
                        statusToExtend[key] = false;
                    });
                    setEntitlements((prev)=>({
                            ...prev,
                            sidePanel: {
                                ...prev.sidePanel,
                                status: {
                                    ...prev.sidePanel.status,
                                    ...statusToExtend
                                }
                            }
                        }));
                }).finally(()=>{
                    setIsLoading(false);
                    setActiveTab((0, $d60257e8dc27bf16$export$bde14d5a1cbdb371));
                    promisesForSidePanel.length = 0;
                });
                break;
            default:
                break;
        }
    };
    (0, $hopDi$useEffect)(()=>{
        setUsers((prev)=>({
                ...prev,
                sidePanel: {
                    ...prev.sidePanel,
                    ...sidePanelUsers
                }
            }));
    }, [
        sidePanelUsers
    ]);
    (0, $hopDi$useEffect)(()=>{
        setRoles((prev)=>({
                ...prev,
                sidePanel: {
                    ...prev.sidePanel,
                    ...sidePanelRoles
                }
            }));
    }, [
        sidePanelRoles
    ]);
    (0, $hopDi$useEffect)(()=>{
        setAccounts((prev)=>({
                ...prev,
                sidePanel: {
                    ...prev.sidePanel,
                    ...sidePanelAccounts
                }
            }));
    }, [
        sidePanelAccounts
    ]);
    (0, $hopDi$useEffect)(()=>{
        setEntitlements((prev)=>({
                ...prev,
                sidePanel: {
                    ...prev.sidePanel,
                    ...sidePanelEntitlements
                }
            }));
    }, [
        sidePanelEntitlements
    ]);
    (0, $hopDi$useEffect)(()=>{
        setIsLoading(isSidePanelLoading);
    }, [
        isSidePanelLoading
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (data && certKey) {
            setIsLoading(true);
            setActiveTab((0, $d60257e8dc27bf16$export$bde14d5a1cbdb371));
            setUsers({
                ...data,
                sidePanel: {
                    status: {
                        [(0, $d60257e8dc27bf16$export$bde14d5a1cbdb371)]: false,
                        [(0, $d60257e8dc27bf16$export$9b67fda1e37e6e63)]: false
                    }
                }
            });
            setRoles({
                ...data,
                sidePanel: {
                    status: {
                        [(0, $d60257e8dc27bf16$export$bde14d5a1cbdb371)]: false,
                        [(0, $d60257e8dc27bf16$export$9b67fda1e37e6e63)]: false,
                        [(0, $d60257e8dc27bf16$export$6cc684447a8d7b17)]: false,
                        [(0, $d60257e8dc27bf16$export$51f82826650bc3c3)]: false
                    }
                }
            });
            setAccounts({
                ...data,
                sidePanel: {
                    status: {
                        [(0, $d60257e8dc27bf16$export$bde14d5a1cbdb371)]: false,
                        [(0, $d60257e8dc27bf16$export$9b67fda1e37e6e63)]: false
                    }
                }
            });
            setEntitlements({
                ...data,
                sidePanel: {
                    unFixedTabs: [
                        (0, $d60257e8dc27bf16$export$8f78881bb4058858),
                        (0, $d60257e8dc27bf16$export$a06b6c2be556dac8),
                        (0, $d60257e8dc27bf16$export$51f82826650bc3c3)
                    ],
                    status: {
                        [(0, $d60257e8dc27bf16$export$bde14d5a1cbdb371)]: false,
                        [(0, $d60257e8dc27bf16$export$9b67fda1e37e6e63)]: false,
                        [(0, $d60257e8dc27bf16$export$8f78881bb4058858)]: false,
                        [(0, $d60257e8dc27bf16$export$a06b6c2be556dac8)]: false,
                        [(0, $d60257e8dc27bf16$export$51f82826650bc3c3)]: false,
                        [(0, $d60257e8dc27bf16$export$ed0bf72b1f4a9681)]: false
                    }
                }
            });
            callApiByType();
        }
    }, [
        certKey,
        data
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (activeTab === (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63)) callApiForHistory();
    }, [
        activeTab
    ]);
    const retrigggerApisForError = ()=>{
        setIsLoading(true);
        callApiByType();
    };
    const renderSidePanelView = ()=>{
        switch(data?.type){
            case 0, $d60257e8dc27bf16$export$1cc98074061c90d2:
                return /*#__PURE__*/ (0, $hopDi$jsx)((0, $a907449f3dde7b07$export$2e2bcd8739ae039), {
                    activeTab: activeTab,
                    setActiveTab: setActiveTab,
                    data: users,
                    isLoadingHistory: isLoadingHistory,
                    retrigggerApisForError: retrigggerApisForError,
                    handleCloseSidePanel: handleCloseSidePanel
                });
            case 0, $d60257e8dc27bf16$export$7d6712c2cb8377b2:
                return /*#__PURE__*/ (0, $hopDi$jsx)((0, $5de156f3e0748d5b$export$2e2bcd8739ae039), {
                    activeTab: activeTab,
                    setActiveTab: setActiveTab,
                    data: roles,
                    isLoadingHistory: isLoadingHistory,
                    retrigggerApisForError: retrigggerApisForError,
                    handleCloseSidePanel: handleCloseSidePanel
                });
            case 0, $d60257e8dc27bf16$export$153ab95c08227093:
                return /*#__PURE__*/ (0, $hopDi$jsx)((0, $3ddf9bde0f45f198$export$2e2bcd8739ae039), {
                    activeTab: activeTab,
                    setActiveTab: setActiveTab,
                    data: accounts,
                    isLoadingHistory: isLoadingHistory,
                    retrigggerApisForError: retrigggerApisForError,
                    handleCloseSidePanel: handleCloseSidePanel
                });
            case 0, $d60257e8dc27bf16$export$be9a3074cb3ae0c7:
                return /*#__PURE__*/ (0, $hopDi$jsx)((0, $ce19cd0e10f2ccd9$export$2e2bcd8739ae039), {
                    activeTab: activeTab,
                    setActiveTab: setActiveTab,
                    data: entitlements,
                    isLoadingHistory: isLoadingHistory,
                    retrigggerApisForError: retrigggerApisForError,
                    handleCloseSidePanel: handleCloseSidePanel
                });
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0, $hopDi$jsx)("aside", {
        className: classes,
        "data-test-id": dataTestId,
        children: isLoading ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            className: "SidePanelView-loader",
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                kind: "dots",
                format: "inline",
                color: "info",
                size: "medium"
            })
        }) : renderSidePanelView()
    });
}
$56256445b185fcc5$var$CertsSidePanelBody.propTypes = {
    data: (0, $hopDi$proptypes).shape((0, $708c26a04684b266$export$2e2bcd8739ae039)).isRequired,
    dataTestId: (0, $hopDi$proptypes).string,
    className: (0, $hopDi$proptypes).string,
    handleCloseSidePanel: (0, $hopDi$proptypes).func.isRequired
};
$56256445b185fcc5$var$CertsSidePanelBody.defaultProps = {
    dataTestId: null,
    className: null
};
var $56256445b185fcc5$export$2e2bcd8739ae039 = $56256445b185fcc5$var$CertsSidePanelBody;


var $e87eca063f13fc28$export$2e2bcd8739ae039 = (0, $56256445b185fcc5$export$2e2bcd8739ae039);












function $0a5df443e4be28d9$var$CertsSidePanelFooter({ nodeData: nodeData, handleSidePanelAction: handleSidePanelAction, setMergedLists: setMergedLists, dataTestId: dataTestId, className: className }) {
    const { bulkAction: bulkAction } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const sidePanelFooterClasses = (0, $hopDi$classnames)("CertsSidePanelFooter", className);
    const checkForActions = nodeData?.availableAction && Object.keys(nodeData?.availableAction).length > 0;
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
        tag: "section",
        className: sidePanelFooterClasses,
        "data-testid": dataTestId,
        children: checkForActions && /*#__PURE__*/ (0, $hopDi$jsx)((0, $f7cd7b23cff7a54f$export$2e2bcd8739ae039), {
            kind: (0, $20281fe09bc700a8$export$758743ec42a300f1).FOOTER,
            nodeData: nodeData || {},
            handleSidePanelAction: handleSidePanelAction,
            setIsActionGroupExpanded: ()=>{},
            setMergedLists: setMergedLists,
            groupTooltipText: bulkAction?.atleastOneIsSelected || bulkAction?.isChecked ? "Options for multiple-item selections are available in the toolbar on left." : null,
            isGroupDisabled: bulkAction?.atleastOneIsSelected || bulkAction?.isChecked
        })
    });
}
$0a5df443e4be28d9$var$CertsSidePanelFooter.propTypes = {
    nodeData: (0, $hopDi$proptypes).shape((0, $ddbc2f861c0388ff$export$3e7926703ac20a93)),
    handleSidePanelAction: (0, $hopDi$proptypes).func.isRequired,
    setMergedLists: (0, $hopDi$proptypes).func.isRequired,
    className: (0, $hopDi$proptypes).string,
    dataTestId: (0, $hopDi$proptypes).string
};
$0a5df443e4be28d9$var$CertsSidePanelFooter.defaultProps = {
    nodeData: null,
    className: null,
    dataTestId: null
};
var $0a5df443e4be28d9$export$2e2bcd8739ae039 = $0a5df443e4be28d9$var$CertsSidePanelFooter;


var $b69fc74405c20c63$export$2e2bcd8739ae039 = (0, $0a5df443e4be28d9$export$2e2bcd8739ae039);




const $9bf869d146a874af$export$42ad9f3c9ee8e12f = (key)=>{
    if (key === (0, $d60257e8dc27bf16$export$1cc98074061c90d2)) return {
        title: (0, $d60257e8dc27bf16$export$dc13af498303679),
        desc: (0, $d60257e8dc27bf16$export$76f2b9e2abf8cf0c)
    };
    if (key === (0, $d60257e8dc27bf16$export$7d6712c2cb8377b2)) return {
        title: (0, $d60257e8dc27bf16$export$669183101cc88fb6),
        desc: (0, $d60257e8dc27bf16$export$71193c4d5e3b3956)
    };
    if (key === (0, $d60257e8dc27bf16$export$153ab95c08227093)) return {
        title: (0, $d60257e8dc27bf16$export$843e8b0030038872),
        desc: (0, $d60257e8dc27bf16$export$c0a9d10def3a6309)
    };
    if (key === (0, $d60257e8dc27bf16$export$be9a3074cb3ae0c7)) return {
        title: (0, $d60257e8dc27bf16$export$9dee3ced165b51d1),
        desc: (0, $d60257e8dc27bf16$export$6940d0d32ae129a1)
    };
    return {};
};
const $9bf869d146a874af$export$33914de34c28be6c = (type)=>{
    switch(type){
        case 0, $d60257e8dc27bf16$export$1cc98074061c90d2:
            return "user";
        case 0, $d60257e8dc27bf16$export$7d6712c2cb8377b2:
            return "role";
        case 0, $d60257e8dc27bf16$export$153ab95c08227093:
            return "certsaccount";
        case 0, $d60257e8dc27bf16$export$be9a3074cb3ae0c7:
            return "entitlement";
        default:
            return 0, $d60257e8dc27bf16$export$7219e4813ca4abf0;
    }
};
var $9bf869d146a874af$export$2e2bcd8739ae039 = {
    getKeysForSidePanelHeader: $9bf869d146a874af$export$42ad9f3c9ee8e12f,
    setIcon: $9bf869d146a874af$export$33914de34c28be6c
};



function $d5379df310c40957$var$CertsSidePanel({ data: data, nodeData: nodeData, handleSidePanelAction: handleSidePanelAction, isOpen: isOpen, setMergedLists: setMergedLists, dataTestId: dataTestId, className: className }) {
    const dispatch = (0, $hopDi$useDispatch)();
    const classes = (0, $hopDi$classnames)("CertsSidePanel", className);
    const headerObj = (0, $9bf869d146a874af$export$42ad9f3c9ee8e12f)(data?.type);
    const handleCloseSidePanel = ()=>{
        dispatch((0, $d623f23401a154f0$export$ebe6b5ce6ed9ef39)(false));
    };
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$SidePanel), {
        header: {
            title: data[headerObj?.title] || "",
            description: data[headerObj?.desc] || "",
            icon: (0, $9bf869d146a874af$export$33914de34c28be6c)(data?.type)
        },
        isOpen: isOpen,
        onClose: handleCloseSidePanel,
        className: classes,
        layout: /*#__PURE__*/ (0, $hopDi$jsx)((0, $e87eca063f13fc28$export$2e2bcd8739ae039), {
            data: data,
            handleCloseSidePanel: handleCloseSidePanel
        }),
        layoutClassName: "CertsSidePanel-layout",
        footer: /*#__PURE__*/ (0, $hopDi$jsx)((0, $b69fc74405c20c63$export$2e2bcd8739ae039), {
            nodeData: nodeData,
            handleSidePanelAction: handleSidePanelAction,
            setMergedLists: setMergedLists
        }),
        showCenterMessage: true,
        dataTestId: dataTestId
    });
}
$d5379df310c40957$var$CertsSidePanel.propTypes = {
    data: (0, $hopDi$proptypes).shape((0, $3dba689dd3c247a4$export$2e2bcd8739ae039)),
    nodeData: (0, $hopDi$proptypes).shape((0, $ddbc2f861c0388ff$export$3e7926703ac20a93)),
    handleSidePanelAction: (0, $hopDi$proptypes).func.isRequired,
    isOpen: (0, $hopDi$proptypes).bool,
    setMergedLists: (0, $hopDi$proptypes).func.isRequired,
    dataTestId: (0, $hopDi$proptypes).string,
    className: (0, $hopDi$proptypes).string
};
$d5379df310c40957$var$CertsSidePanel.defaultProps = {
    data: null,
    nodeData: null,
    isOpen: false,
    dataTestId: null,
    className: null
};
var $d5379df310c40957$export$2e2bcd8739ae039 = $d5379df310c40957$var$CertsSidePanel;



var $37b43aaf389f3f5d$export$2e2bcd8739ae039 = (0, $d5379df310c40957$export$2e2bcd8739ae039);


// /* eslint-disable no-unused-vars */





const $144e182e72703db5$var$KINDS = {
    warning: "warning",
    success: "success",
    critical: "critical",
    default: "default"
};
function $144e182e72703db5$var$LinearProgressBar({ value: value, kind: kind, showPointer: showPointer }) {
    const progressBarFillerColor = (0, $hopDi$classnames)(`LinearProgressBar-filler--${kind} ${showPointer && value < 100 ? "show-pointer" : "no-pointer"}`);
    return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
        className: "LinearProgressBar",
        children: /*#__PURE__*/ (0, $hopDi$jsx)("div", {
            className: progressBarFillerColor,
            style: {
                height: "100%",
                width: `${value}%`
            }
        })
    });
}
$144e182e72703db5$var$LinearProgressBar.propTypes = {
    value: (0, $hopDi$proptypes).number,
    kind: (0, $hopDi$proptypes).oneOf(Object.values($144e182e72703db5$var$KINDS)),
    showPointer: (0, $hopDi$proptypes).bool
};
$144e182e72703db5$var$LinearProgressBar.defaultProps = {
    value: 0,
    kind: "default",
    showPointer: false
};
var $144e182e72703db5$export$2e2bcd8739ae039 = $144e182e72703db5$var$LinearProgressBar;


var $f731ea5e88f23f43$export$2e2bcd8739ae039 = (0, $144e182e72703db5$export$2e2bcd8739ae039);











const $bf14b63763e2d183$export$4767a28fbd1026ef = "decision";
const $bf14b63763e2d183$export$14ae8ea77646ac77 = "type";
const $bf14b63763e2d183$export$eb22cfe55ebb02f = "1";
const $bf14b63763e2d183$export$2b8c69d2b22250ea = "2";
const $bf14b63763e2d183$export$aebb42912407fb2d = "Pending";
const $bf14b63763e2d183$export$71efb3495f6084f2 = "Done";
const $bf14b63763e2d183$export$e135c39ae3ebb92e = "Total";
const $bf14b63763e2d183$export$39f29f4125141985 = "Consulted";
const $bf14b63763e2d183$export$fbc5ebe2e580bf8b = "Progress";
const $bf14b63763e2d183$export$c4cfef2de2ef9e6a = {
    APPROVED: "Approved",
    DONE: "Done",
    MANAGER_CONFIRMED: "Manager Confirmed",
    MANAGER_NOT_CONFIRMED: "Not Confirmed By Manager",
    REVOKED: "Revoked",
    CONSULT: "Consult",
    CONDITIONALLY_CERTIFIED: "Conditionally Certified",
    REJECTED: "Rejected",
    PENDING: "Pending",
    END_DATE_CHANGED: "End Date Changed",
    NO_ACTION_REQUIRED: "NoActionRequired",
    TERMINATED: "Terminated",
    REASSIGN: "Reassign",
    ROLE: "Role",
    USER: "User",
    ENTITLEMENT: "Entitlement",
    ACCOUNT: "Account"
};







function $c898782d608477c1$var$DecisionLabel({ value: value, label: label, iconKind: iconKind, description: description }) {
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "DecisionLabel-item",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                kind: "body1",
                className: "DecisionLabel-itemCount",
                children: value
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                kind: iconKind,
                color: "navy-900",
                size: "small",
                className: "DecisionLabel-itemIcon"
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Typography), {
                kind: "body2",
                className: "DecisionLabel-itemLabel",
                children: [
                    label,
                    /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                        className: "DecisionLabel-notify",
                        children: description && description
                    })
                ]
            })
        ]
    });
}
$c898782d608477c1$var$DecisionLabel.propTypes = {
    value: (0, $hopDi$proptypes).number.isRequired,
    label: (0, $hopDi$proptypes).string.isRequired,
    iconKind: (0, $hopDi$proptypes).string.isRequired,
    description: (0, $hopDi$proptypes).string
};
$c898782d608477c1$var$DecisionLabel.defaultProps = {
    description: ""
};
var $c898782d608477c1$export$2e2bcd8739ae039 = $c898782d608477c1$var$DecisionLabel;












const $c3fd831cb38d6d24$export$6712e0f6cd0ea03 = (count, totalCount)=>{
    if (totalCount === 0) return "0%";
    return `(${Math.round(count * 100 / totalCount)}%)`;
};
const $c3fd831cb38d6d24$export$c3e0f520a0aee8fc = (count, totalCount)=>Math.round(count * 100 / totalCount);
const $c3fd831cb38d6d24$export$a8484eb76959731d = (labelStatus)=>{
    switch(labelStatus){
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).MANAGER_NOT_CONFIRMED:
            return "NotConfirmedByManager";
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).REVOKED:
            return "Revoked";
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).CONSULT:
            return "Consult";
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).ROLE:
            return "Role";
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).ACCOUNT:
            return "Account";
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).USER:
            return "UserNoBg";
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).ENTITLEMENT:
            return "Entitlement";
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).APPROVED:
            return "Check";
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).TERMINATED:
            return "Terminate";
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).NO_ACTION_REQUIRED:
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).REJECTED:
            return "Reject";
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).END_DATE_CHANGED:
            return "ExtendEndDate";
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).CONDITIONALLY_CERTIFIED:
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).PENDING:
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).REASSIGN:
            return "Reassign";
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).MANAGER_CONFIRMED:
        default:
            return "Manager";
    }
};
const $c3fd831cb38d6d24$export$83b788b1a3698c03 = (obj)=>Object.keys(obj).length === 0;
const $c3fd831cb38d6d24$export$af094ef85befd6db = {
    User: 0,
    Account: 1,
    Role: 2,
    Entitlement: 3
};
const $c3fd831cb38d6d24$export$20888ab678d31dc7 = (a, b)=>{
    const roleA = a[0];
    const roleB = b[0];
    return $c3fd831cb38d6d24$export$af094ef85befd6db[roleA] - $c3fd831cb38d6d24$export$af094ef85befd6db[roleB];
};
var $c3fd831cb38d6d24$export$2e2bcd8739ae039 = {
    getPercentage: $c3fd831cb38d6d24$export$6712e0f6cd0ea03,
    getIconKind: $c3fd831cb38d6d24$export$a8484eb76959731d,
    isEmptyObject: $c3fd831cb38d6d24$export$83b788b1a3698c03,
    customSortByType: $c3fd831cb38d6d24$export$20888ab678d31dc7
};




const $aff3e1b514240397$var$excludeProperties = [
    (0, $bf14b63763e2d183$export$71efb3495f6084f2),
    (0, $bf14b63763e2d183$export$aebb42912407fb2d),
    (0, $bf14b63763e2d183$export$fbc5ebe2e580bf8b),
    (0, $bf14b63763e2d183$export$e135c39ae3ebb92e)
];
function $aff3e1b514240397$var$ViewByDecision() {
    const dispatch = (0, $hopDi$useDispatch)();
    const intl = (0, $hopDi$useIntl)();
    const { certKey: certKey, progressBreakdowndetails: progressBreakdowndetails } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const { isLoading: isLoading, byDecisionDetails: byDecisionDetails, errorMessage: errorMessage } = progressBreakdowndetails;
    (0, $hopDi$useEffect)(()=>{
        if (certKey) dispatch((0, $d623f23401a154f0$export$6e5b0daaf8d927e4)(certKey, (0, $bf14b63763e2d183$export$4767a28fbd1026ef)));
    }, [
        certKey
    ]);
    const refreshProgressDataByDecision = ()=>{
        if (certKey) dispatch((0, $d623f23401a154f0$export$6e5b0daaf8d927e4)(certKey, (0, $bf14b63763e2d183$export$4767a28fbd1026ef)));
    };
    const showErrorMessage = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
            className: "ViewByDecision-progressFailure",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "body2-bold",
                    className: "ViewByDecision-errorMessage",
                    children: "Couldn't load decision progress breakdown data. Please refresh or try again later."
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                    type: "button",
                    kind: "filled",
                    size: "medium",
                    onClick: refreshProgressDataByDecision,
                    children: "Refresh"
                })
            ]
        });
    return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
        className: "ViewByDecision",
        children: isLoading ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            className: "ViewByDecision-loader",
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                kind: "dots",
                format: "inline",
                color: "brand",
                size: "small"
            })
        }) : /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                errorMessage && showErrorMessage(),
                byDecisionDetails?.Summary && !(0, $c3fd831cb38d6d24$export$83b788b1a3698c03)(byDecisionDetails?.Summary) ? /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                            className: "ViewByDecision-todoSection",
                            children: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                className: "ViewByDecision-todo",
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                        kind: "body1",
                                        className: "ViewByDecision-todoCount",
                                        children: byDecisionDetails.Summary[0, $bf14b63763e2d183$export$aebb42912407fb2d]
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                        kind: "body2-bold",
                                        className: "ViewByDecision-todoLabel",
                                        children: "To do"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                            className: "ViewByDecision-divider"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                            className: "ViewByDecision-doneSection",
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                    className: "ViewByDecision-done",
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body1",
                                            className: "ViewByDecision-doneCount",
                                            children: byDecisionDetails.Summary[0, $bf14b63763e2d183$export$71efb3495f6084f2]
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body2-bold",
                                            className: "ViewByDecision-doneLabel",
                                            children: "Done"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                    className: "ViewByDecision-doneItems",
                                    children: byDecisionDetails && Object.entries(byDecisionDetails.Summary).filter(([key])=>!$aff3e1b514240397$var$excludeProperties.includes(key)).map(([key, value])=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $c898782d608477c1$export$2e2bcd8739ae039), {
                                            value: value,
                                            iconKind: (0, $c3fd831cb38d6d24$export$a8484eb76959731d)(key),
                                            label: (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(key))
                                        }, key))
                                })
                            ]
                        }),
                        byDecisionDetails?.Summary[0, $bf14b63763e2d183$export$39f29f4125141985] && /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                    className: "ViewByDecision-divider"
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                    className: "ViewByDecision-consulted",
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body1",
                                            className: "ViewByDecision-consultedCount",
                                            children: byDecisionDetails.Summary[0, $bf14b63763e2d183$export$39f29f4125141985]
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body2-bold",
                                            className: "ViewByDecision-consultedLabel",
                                            children: "Consulted"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }) : !errorMessage && showErrorMessage()
            ]
        })
    });
}
var $aff3e1b514240397$export$2e2bcd8739ae039 = $aff3e1b514240397$var$ViewByDecision;











function $e7b279ebfe32fd45$var$TypeLabel({ count: count, totalCount: totalCount, label: label, iconKind: iconKind }) {
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "TypeLabel-item",
        children: [
            iconKind && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "icon",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: iconKind,
                    color: "navy-900",
                    size: "small",
                    className: "TypeLabel-itemIcon"
                })
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "TypeLabel-mainContent",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body2-bold",
                        className: "TypeLabel-itemLabel",
                        children: label
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $f731ea5e88f23f43$export$2e2bcd8739ae039), {
                        value: (0, $c3fd831cb38d6d24$export$c3e0f520a0aee8fc)(count, totalCount)
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "TypeLabel-progress",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body3",
                                className: "TypeLabel-progressNumber",
                                children: `${count} of ${totalCount}`
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body3",
                                className: "TypeLabel-progressPercentage",
                                children: (0, $c3fd831cb38d6d24$export$6712e0f6cd0ea03)(count, totalCount)
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body3-bold",
                                className: "TypeLabel-progressStatus",
                                children: "Done"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
$e7b279ebfe32fd45$var$TypeLabel.propTypes = {
    count: (0, $hopDi$proptypes).number.isRequired,
    totalCount: (0, $hopDi$proptypes).number.isRequired,
    label: (0, $hopDi$proptypes).string.isRequired,
    iconKind: (0, $hopDi$proptypes).string
};
$e7b279ebfe32fd45$var$TypeLabel.defaultProps = {
    iconKind: null
};
var $e7b279ebfe32fd45$export$2e2bcd8739ae039 = $e7b279ebfe32fd45$var$TypeLabel;


/* eslint-disable react/jsx-no-useless-fragment */ 











function $bf1a33cef097b883$var$ViewByType() {
    const dispatch = (0, $hopDi$useDispatch)();
    const intl = (0, $hopDi$useIntl)();
    const { certKey: certKey, progressBreakdowndetails: progressBreakdowndetails } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const { isLoading: isLoading, byTypeDetails: byTypeDetails, errorMessage: errorMessage } = progressBreakdowndetails;
    (0, $hopDi$useEffect)(()=>{
        if (certKey) dispatch((0, $d623f23401a154f0$export$6e5b0daaf8d927e4)(certKey, (0, $bf14b63763e2d183$export$14ae8ea77646ac77)));
    }, [
        certKey
    ]);
    const refreshProgressDataByType = ()=>{
        if (certKey) dispatch((0, $d623f23401a154f0$export$6e5b0daaf8d927e4)(certKey, (0, $bf14b63763e2d183$export$14ae8ea77646ac77)));
    };
    const showErrorMessage = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
            className: "ViewByType-progressFailure",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "body2-bold",
                    className: "ViewByType-errorMessage",
                    children: "Couldn't load type progress breakdown data. Please refresh or try again later."
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                    type: "button",
                    kind: "filled",
                    size: "medium",
                    onClick: refreshProgressDataByType,
                    children: "Refresh"
                })
            ]
        });
    return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
        className: "ViewByType",
        children: isLoading ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            className: "ViewByType-loader",
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                kind: "dots",
                format: "inline",
                color: "brand",
                size: "small"
            })
        }) : /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                errorMessage && showErrorMessage(),
                byTypeDetails?.Summary && !(0, $c3fd831cb38d6d24$export$83b788b1a3698c03)(byTypeDetails?.Summary) ? Object.entries(byTypeDetails.Summary)?.sort((0, $c3fd831cb38d6d24$export$20888ab678d31dc7)).map(([key, value])=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $e7b279ebfe32fd45$export$2e2bcd8739ae039), {
                        count: value[0, $bf14b63763e2d183$export$71efb3495f6084f2],
                        totalCount: value[0, $bf14b63763e2d183$export$e135c39ae3ebb92e],
                        iconKind: (0, $c3fd831cb38d6d24$export$a8484eb76959731d)(key),
                        label: (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(key))
                    }, key)) : !errorMessage && showErrorMessage()
            ]
        })
    });
}
var $bf1a33cef097b883$export$2e2bcd8739ae039 = $bf1a33cef097b883$var$ViewByType;






function $c9e15190d21f97b8$var$PopoverContent() {
    const [selection, setSelection] = (0, $hopDi$useState)(1);
    const { progressBreakdowndetails: progressBreakdowndetails } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const { byDecisionDetails: byDecisionDetails } = progressBreakdowndetails;
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "PopoverContent",
        children: [
            byDecisionDetails?.Summary && /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body2-bold",
                        className: "PopoverContent-progressInfoTitle",
                        children: "All Items"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $f731ea5e88f23f43$export$2e2bcd8739ae039), {
                        value: (0, $c3fd831cb38d6d24$export$c3e0f520a0aee8fc)(byDecisionDetails?.Summary[0, $bf14b63763e2d183$export$71efb3495f6084f2], byDecisionDetails?.Summary[0, $bf14b63763e2d183$export$e135c39ae3ebb92e])
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "PopoverContent-progressBreakdown",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body3",
                                className: "PopoverContent-progressBreakdownCount",
                                children: `${byDecisionDetails?.Summary[0, $bf14b63763e2d183$export$71efb3495f6084f2]} of ${byDecisionDetails?.Summary[0, $bf14b63763e2d183$export$e135c39ae3ebb92e]}`
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body3",
                                className: "PopoverContent-progressBreakdownPercentage",
                                children: (0, $c3fd831cb38d6d24$export$6712e0f6cd0ea03)(byDecisionDetails?.Summary[0, $bf14b63763e2d183$export$71efb3495f6084f2], byDecisionDetails?.Summary[0, $bf14b63763e2d183$export$e135c39ae3ebb92e])
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body3-bold",
                                className: "PopoverContent-progressBreakdownStatus",
                                children: "Done"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "PopoverContent-tabs",
                children: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$ToggleButtonGroup), {
                            selection: selection,
                            setSelection: setSelection,
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ToggleButton), {
                                    label: "By Decision"
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ToggleButton), {
                                    label: "By Type"
                                })
                            ]
                        }),
                        selection === 1 && /*#__PURE__*/ (0, $hopDi$jsx)((0, $aff3e1b514240397$export$2e2bcd8739ae039), {}),
                        selection === 2 && /*#__PURE__*/ (0, $hopDi$jsx)((0, $bf1a33cef097b883$export$2e2bcd8739ae039), {})
                    ]
                })
            })
        ]
    });
}
var $c9e15190d21f97b8$export$2e2bcd8739ae039 = $c9e15190d21f97b8$var$PopoverContent;



function $f22be45875ddd715$var$PopoverProgressBreakdown({ closePopover: closePopover }) {
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "PopoverProgressBreakdown",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "PopoverProgressBreakdown-close",
                onClick: closePopover,
                onKeyDown: ()=>{},
                tabIndex: "0",
                role: "button",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "Close",
                    color: "neutral-1000",
                    size: "small"
                })
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                kind: "h2",
                className: "PopoverProgressBreakdown-title",
                children: "Progress"
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $c9e15190d21f97b8$export$2e2bcd8739ae039), {})
        ]
    });
}
$f22be45875ddd715$var$PopoverProgressBreakdown.propTypes = {
    closePopover: (0, $hopDi$proptypes).func.isRequired
};
$f22be45875ddd715$var$PopoverProgressBreakdown.defaultProps = {};
var $f22be45875ddd715$export$2e2bcd8739ae039 = $f22be45875ddd715$var$PopoverProgressBreakdown;





var $aedec3a09ed0c484$export$2e2bcd8739ae039 = (0, $f22be45875ddd715$export$2e2bcd8739ae039);












const $7e937afea8da6d42$export$cc844e58ea5510e9 = 500;
const $7e937afea8da6d42$export$cfce94e2b700a1a1 = "decision";
const $7e937afea8da6d42$export$31c34eb4b50de0b6 = "type";
const $7e937afea8da6d42$export$df8f064ab2a7c09c = [
    $7e937afea8da6d42$export$cfce94e2b700a1a1,
    $7e937afea8da6d42$export$31c34eb4b50de0b6
];
const $7e937afea8da6d42$export$506d5022cff8f7df = "primary_certifier";
const $7e937afea8da6d42$export$842181aaa7a414ff = "secondary_certifier";
const $7e937afea8da6d42$export$e38f3fe6f8e2e1d5 = "review_and_submit_completed";
const $7e937afea8da6d42$export$5d9f356b4d4d5628 = "review_and_submit_not_completed";
const $7e937afea8da6d42$export$33413024a053a1ca = "review_and_submit_step_1";
const $7e937afea8da6d42$export$deab3fee8d04afb5 = "review_and_submit_step_2";
const $7e937afea8da6d42$export$4414b99fd5cdebbf = "review_and_submit_signature";
const $7e937afea8da6d42$export$c7ded6134c5259a8 = "review_and_submit_comment";
const $7e937afea8da6d42$export$73e83bf2b7e02467 = [
    "small",
    "medium",
    "large"
];
const $7e937afea8da6d42$export$f1e53f710478ceb4 = {
    [$7e937afea8da6d42$export$506d5022cff8f7df]: {
        [$7e937afea8da6d42$export$e38f3fe6f8e2e1d5]: {
            [$7e937afea8da6d42$export$c7ded6134c5259a8]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "Review and Submit Your Certification",
                [$7e937afea8da6d42$export$deab3fee8d04afb5]: "Review and Submit Your Certification"
            },
            [$7e937afea8da6d42$export$4414b99fd5cdebbf]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "Review and Submit Your Certification",
                [$7e937afea8da6d42$export$deab3fee8d04afb5]: "Review and Submit Your Certification"
            }
        },
        [$7e937afea8da6d42$export$5d9f356b4d4d5628]: {
            [$7e937afea8da6d42$export$c7ded6134c5259a8]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "Your Certification Is Incomplete"
            },
            [$7e937afea8da6d42$export$4414b99fd5cdebbf]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "Your Certification Is Incomplete"
            }
        }
    },
    [$7e937afea8da6d42$export$842181aaa7a414ff]: {
        [$7e937afea8da6d42$export$e38f3fe6f8e2e1d5]: {
            [$7e937afea8da6d42$export$c7ded6134c5259a8]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "Review and Submit Your Certification",
                [$7e937afea8da6d42$export$deab3fee8d04afb5]: "Review and Submit Your Certification"
            },
            [$7e937afea8da6d42$export$4414b99fd5cdebbf]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "Review and Submit Your Certification",
                [$7e937afea8da6d42$export$deab3fee8d04afb5]: "Review and Submit Your Certification"
            }
        },
        [$7e937afea8da6d42$export$5d9f356b4d4d5628]: {
            [$7e937afea8da6d42$export$c7ded6134c5259a8]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "Review and Submit Your Certification",
                [$7e937afea8da6d42$export$deab3fee8d04afb5]: "Review and Submit Your Certification"
            },
            [$7e937afea8da6d42$export$4414b99fd5cdebbf]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "Review and Submit Your Certification",
                [$7e937afea8da6d42$export$deab3fee8d04afb5]: "Review and Submit Your Certification"
            }
        }
    }
};
const $7e937afea8da6d42$export$5895c693c74b9cf4 = {
    [$7e937afea8da6d42$export$506d5022cff8f7df]: {
        [$7e937afea8da6d42$export$e38f3fe6f8e2e1d5]: {
            [$7e937afea8da6d42$export$c7ded6134c5259a8]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "Step 1 of 2",
                [$7e937afea8da6d42$export$deab3fee8d04afb5]: "Step 2 of 2"
            },
            [$7e937afea8da6d42$export$4414b99fd5cdebbf]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "Step 1 of 2",
                [$7e937afea8da6d42$export$deab3fee8d04afb5]: "Step 2 of 2"
            }
        },
        [$7e937afea8da6d42$export$5d9f356b4d4d5628]: {
            [$7e937afea8da6d42$export$c7ded6134c5259a8]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "You still have $$$ To-Do items that you must complete before your certification can be submitted",
                [$7e937afea8da6d42$export$deab3fee8d04afb5]: "You still have $$$ To-Do items that you must complete before your certification can be submitted"
            },
            [$7e937afea8da6d42$export$4414b99fd5cdebbf]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "You still have $$$ To-Do items that you must complete before your certification can be submitted",
                [$7e937afea8da6d42$export$deab3fee8d04afb5]: "You still have $$$ To-Do items that you must complete before your certification can be submitted"
            }
        }
    },
    [$7e937afea8da6d42$export$842181aaa7a414ff]: {
        [$7e937afea8da6d42$export$e38f3fe6f8e2e1d5]: {
            [$7e937afea8da6d42$export$c7ded6134c5259a8]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "Review the items you've certified, and send them to the primary certifier ($$$) who'll complete and submit the certification.",
                [$7e937afea8da6d42$export$deab3fee8d04afb5]: "Review the items you've certified, and send them to the primary certifier ($$$) who'll complete and submit the certification."
            },
            [$7e937afea8da6d42$export$4414b99fd5cdebbf]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "Review the items you've certified, and send them to the primary certifier ($$$) who'll complete and submit the certification.",
                [$7e937afea8da6d42$export$deab3fee8d04afb5]: "Review the items you've certified, and send them to the primary certifier ($$$) who'll complete and submit the certification."
            }
        },
        [$7e937afea8da6d42$export$5d9f356b4d4d5628]: {
            [$7e937afea8da6d42$export$c7ded6134c5259a8]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "Review the items you've certified, and send them to the primary certifier ($$$) who'll complete and submit the certification.",
                [$7e937afea8da6d42$export$deab3fee8d04afb5]: "Review the items you've certified, and send them to the primary certifier ($$$) who'll complete and submit the certification."
            },
            [$7e937afea8da6d42$export$4414b99fd5cdebbf]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "Review the items you've certified, and send them to the primary certifier ($$$) who'll complete and submit the certification.",
                [$7e937afea8da6d42$export$deab3fee8d04afb5]: "Review the items you've certified, and send them to the primary certifier ($$$) who'll complete and submit the certification."
            }
        }
    }
};



















const $c465f91860c9b0b1$export$86d760a8248fd97d = "Done";
const $c465f91860c9b0b1$export$7eb5fd7a28f937f3 = "Total";
const $c465f91860c9b0b1$export$75b3fab2883bdf8c = "Progress";
const $c465f91860c9b0b1$export$51ec0eec30d8f725 = "Pending";
const $c465f91860c9b0b1$export$b8e11e47a6aeff19 = {
    NoActionRequired: "ReassignItem",
    Done: "Check",
    Progress: "Check",
    Pending: "Consult",
    Approved: "Check",
    Rejected: "Reject",
    Total: "Reject",
    Terminated: "Terminate",
    Reassigned: "Reassign",
    "End Date Changed": "ExtendEndDate",
    "Not Confirmed By Manager": "NotConfirmedByManager",
    Revoked: "Revoked",
    Consult: "Consult",
    "Manager Confirmed": "ConfirmManager",
    "Conditionally Certified": "ExtendEndDate"
};
const $c465f91860c9b0b1$export$dfb085eaafffeece = {
    NoActionRequired: "No Action Required",
    Done: "Done",
    Progress: "Progress",
    Pending: "Pending",
    Approved: "Approved",
    Rejected: "Rejected",
    Total: "Total",
    Terminated: "Terminated",
    Reassigned: "Reassigned",
    "End Date Changed": "End Date Changed",
    "Not Confirmed By Manager": "Not Confirmed By Manager",
    "Manager Confirmed": "Manager Confirmed",
    "Conditionally Certified": "Conditionally Certified"
};
const $c465f91860c9b0b1$export$39a5b354431fba10 = {
    Role: "Role",
    Account: "Account",
    User: "UserNoBg",
    Entitlement: "Entitlement"
};
const $c465f91860c9b0b1$export$895acf55e792a35d = {
    User: "User",
    Account: "Account",
    Role: "Role",
    Entitlement: "Entitlement"
};



const $5242db288afcc49b$var$CONFIGDATA = {
    primaryCertifier: (0, $hopDi$proptypes).bool,
    isComplete: (0, $hopDi$proptypes).bool,
    withESignature: (0, $hopDi$proptypes).bool
};
var $5242db288afcc49b$export$2e2bcd8739ae039 = $5242db288afcc49b$var$CONFIGDATA;


var $0beb3fe990c568f7$export$2e2bcd8739ae039 = (0, $5242db288afcc49b$export$2e2bcd8739ae039);



function $61a6d08e636110b4$var$Step1({ isModalOpen: isModalOpen, firstStep: firstStep, configData: configData }) {
    const [selection, setSelection] = (0, $hopDi$useState)(1);
    const [step1DataByDecision, setStep1DataByDecision] = (0, $hopDi$useState)({});
    const [step1DataByType, setStep1DataByType] = (0, $hopDi$useState)({});
    const step1BodyWrapperRef = (0, $hopDi$useRef)("step1BodyWrapperRef");
    const shouldRenderDecisionList = Boolean(step1DataByDecision && Object.keys(step1DataByDecision).length > 0);
    const shouldRenderTypeList = Boolean(step1DataByType && Object.keys(step1DataByType).length > 0);
    const shouldShowNoDataForDecision = Boolean(configData?.todoTabCount === 0 && !shouldRenderDecisionList);
    const viewToDoListObjects = [
        (0, $c465f91860c9b0b1$export$51ec0eec30d8f725),
        (0, $c465f91860c9b0b1$export$75b3fab2883bdf8c),
        (0, $c465f91860c9b0b1$export$86d760a8248fd97d),
        (0, $c465f91860c9b0b1$export$7eb5fd7a28f937f3)
    ];
    (0, $hopDi$useEffect)(()=>{
        setTimeout(()=>{
            setSelection(1);
            (0, $e7628c995f405891$export$63087e5d2dd3ce07)(step1BodyWrapperRef, 0);
        }, (0, $7e937afea8da6d42$export$cc844e58ea5510e9));
    }, [
        firstStep,
        isModalOpen
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (configData) {
            setStep1DataByDecision(configData?.step1Data?.[0, $7e937afea8da6d42$export$cfce94e2b700a1a1]);
            setStep1DataByType(configData?.step1Data?.[0, $7e937afea8da6d42$export$31c34eb4b50de0b6]);
        }
    }, [
        configData
    ]);
    const reviewAndSubmitModalBodyStep1 = (0, $hopDi$classnames)("ReviewAndSubmitModal-bodyStep1Wrapper");
    const renderStep1Shorts = ()=>/*#__PURE__*/ (0, $hopDi$jsx)("div", {
            className: "ReviewAndSubmitModal-bodyStep1WrapperShorts",
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $e7b279ebfe32fd45$export$2e2bcd8739ae039), {
                count: step1DataByDecision?.[0, $c465f91860c9b0b1$export$86d760a8248fd97d] || 0,
                totalCount: step1DataByDecision?.[0, $c465f91860c9b0b1$export$7eb5fd7a28f937f3] || 0,
                label: "All Items"
            })
        });
    const renderStep1Stats = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: "ReviewAndSubmitModal-bodyStep1WrapperStats",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "body2-bold",
                    className: "ReviewAndSubmitModal-bodyStep1WrapperStatsTitle",
                    children: "Progress Details"
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    className: "ReviewAndSubmitModal-bodyStep1WrapperStatsDescription",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$ToggleButtonGroup), {
                            selection: selection,
                            setSelection: setSelection,
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ToggleButton), {
                                    label: "By Decision"
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ToggleButton), {
                                    label: "By Type"
                                })
                            ]
                        }),
                        !configData?.isComplete && /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                    className: "ReviewAndSubmitModal-bodyStep1WrapperStatsDescriptionIncomplete",
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body1",
                                            className: "ReviewAndSubmitModal-bodyStep1WrapperStatsDescriptionIncompleteText",
                                            children: `${configData?.todoTabCount}`
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body1",
                                            className: "ReviewAndSubmitModal-bodyStep1WrapperStatsDescriptionIncompleteText",
                                            children: "To Do"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                                    className: "ReviewAndSubmitModal-bodyStep1WrapperHLine"
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                    className: "ReviewAndSubmitModal-bodyStep1WrapperStatsDescriptionIncomplete",
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body1",
                                            className: "ReviewAndSubmitModal-bodyStep1WrapperStatsDescriptionIncompleteText",
                                            children: `${configData?.doneTabCount}`
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body1",
                                            className: "ReviewAndSubmitModal-bodyStep1WrapperStatsDescriptionIncompleteText",
                                            children: "Done"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                            className: "ReviewAndSubmitModal-bodyStep1WrapperStatsDescriptionList",
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                    className: selection === 1 ? "ReviewAndSubmitModal-bodyStep1WrapperStatsDescriptionDecisionList--visible" : "ReviewAndSubmitModal-bodyStep1WrapperStatsDescriptionDecisionList--hidden",
                                    children: [
                                        shouldRenderDecisionList && Object.keys(step1DataByDecision).filter((key)=>!viewToDoListObjects.includes(key)).map((key)=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $c898782d608477c1$export$2e2bcd8739ae039), {
                                                value: step1DataByDecision[key] || 0,
                                                iconKind: (0, $c465f91860c9b0b1$export$b8e11e47a6aeff19)[key] || "Terminate",
                                                label: (0, $c465f91860c9b0b1$export$dfb085eaafffeece)[key] || "Terminated"
                                            }, key)),
                                        shouldShowNoDataForDecision && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body2",
                                            className: "ReviewAndSubmitModal-bodyStep1WrapperStatsDescriptionListCategoryMessage",
                                            children: "Not able to show summary for this certification."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                    className: selection === 2 ? "ReviewAndSubmitModal-bodyStep1WrapperStatsDescriptionTypeList--visible" : "ReviewAndSubmitModal-bodyStep1WrapperStatsDescriptionTypeList--hidden",
                                    children: [
                                        shouldRenderTypeList && Object.keys((0, $c465f91860c9b0b1$export$895acf55e792a35d)).filter((key)=>Boolean(step1DataByType[key])).map((key)=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $e7b279ebfe32fd45$export$2e2bcd8739ae039), {
                                                count: step1DataByType?.[key]?.[0, $c465f91860c9b0b1$export$86d760a8248fd97d],
                                                totalCount: step1DataByType?.[key]?.[0, $c465f91860c9b0b1$export$7eb5fd7a28f937f3],
                                                label: (0, $c465f91860c9b0b1$export$895acf55e792a35d)?.[key] || "",
                                                iconKind: (0, $c465f91860c9b0b1$export$39a5b354431fba10)?.[key] || ""
                                            }, key)),
                                        !shouldRenderTypeList && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body2",
                                            className: "ReviewAndSubmitModal-bodyStep1WrapperStatsDescriptionListCategoryMessage",
                                            children: "Not able to show summary for this certification."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: reviewAndSubmitModalBodyStep1,
        ref: step1BodyWrapperRef,
        children: [
            renderStep1Shorts(),
            renderStep1Stats()
        ]
    });
}
$61a6d08e636110b4$var$Step1.propTypes = {
    isModalOpen: (0, $hopDi$proptypes).bool.isRequired,
    firstStep: (0, $hopDi$proptypes).bool.isRequired,
    configData: (0, $hopDi$proptypes).shape((0, $0beb3fe990c568f7$export$2e2bcd8739ae039))
};
$61a6d08e636110b4$var$Step1.defaultProps = {
    configData: {}
};
var $61a6d08e636110b4$export$2e2bcd8739ae039 = $61a6d08e636110b4$var$Step1;


var $328d7b406278ef5b$export$2e2bcd8739ae039 = (0, $61a6d08e636110b4$export$2e2bcd8739ae039);


/* eslint-disable import/no-extraneous-dependencies */ 









var $2515ed647c64b6ee$export$2e2bcd8739ae039 = (0, $b3efe2b33729b6d5$export$2e2bcd8739ae039);



const $a358fc339b0a2079$export$2c2d63fc3ac6387a = "Under the Electronic Signature in Global and National Commerce Act (E-sign), this agreement and all electronic executed documents related hereto are legally binding in the same manner as are hard copy documents executed by hand signature.";
const $a358fc339b0a2079$export$8704469cbf3a8b0d = "";
const $a358fc339b0a2079$export$785f226259a2f905 = "SIGNATURE_ALERT_COUNT_USERNAME";
const $a358fc339b0a2079$export$5fda98cb5df0734d = "SIGNATURE_ALERT_COUNT_SIGNATURE";
const $a358fc339b0a2079$export$9af400ad4180fd4d = "SIGNATURE_ALERT_COUNT_AGREE_BTN";
const $a358fc339b0a2079$export$478adefe39e62e49 = "SIGNATURE_ALERT_COUNT_COMMENT";
const $a358fc339b0a2079$export$b1002483f894c26c = "esign_password";
const $a358fc339b0a2079$export$22d97d682d25d08 = "esign_type";
const $a358fc339b0a2079$export$4c71c21203ea4bc = "esign_draw";
const $a358fc339b0a2079$export$488e307073e5295d = "esign_upload";



var $9694675c3ac08467$export$2e2bcd8739ae039 = (0, $5242db288afcc49b$export$2e2bcd8739ae039);


const $a3a59a656673dced$export$5a269d4abf2bd409 = (baseArray, key, condition)=>{
    const isPresentInBaseArray = baseArray.includes(key);
    if (isPresentInBaseArray && condition || !isPresentInBaseArray && !condition) return baseArray;
    if (isPresentInBaseArray && !condition) return baseArray.filter((item)=>item !== key);
    if (!isPresentInBaseArray && condition) return [
        ...baseArray,
        key
    ];
    return [];
};
const $a3a59a656673dced$export$47a328b4cabd57cc = (blob)=>new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });



function $006ec638c01b2b4e$var$Step2({ isModalOpen: isModalOpen, firstStep: firstStep, configData: configData, isAlertActive: isAlertActive, setIsAlertActive: setIsAlertActive, setDataForSubmitAction: setDataForSubmitAction }) {
    const intl = (0, $hopDi$useIntl)();
    const [isESignature, setIsESignature] = (0, $hopDi$useState)(false);
    const [isPrimaryCertifier, setIsPrimaryCertifier] = (0, $hopDi$useState)(true);
    const [step2CommentData, setStep2CommentData] = (0, $hopDi$useState)({
        commentDescription: "",
        predefComments: [],
        isCommentApplied: false,
        showAlert: false
    });
    const [step2SignatureData, setStep2SignatureData] = (0, $hopDi$useState)({
        userAttribute: "",
        enableloginSignature: "",
        noOfTries: "",
        predefComments: [],
        userAttributeValue: "",
        isAgreeChecked: false,
        commentDescription: "",
        isCommentApplied: false,
        eSignatureData: "",
        eSignatureTab: "",
        showAlert: false,
        alertFields: []
    });
    const step2BodyWrapperRef = (0, $hopDi$useRef)("step2BodyWrapperRef");
    const { uploadedFiles: uploadedFiles, handleFileSelect: handleFileSelect, handleFileDelete: handleFileDelete, handleFileReupload: handleFileReupload, reuploadFileName: reuploadFileName, hasAnyUploadErrors: hasAnyUploadErrors } = (0, $hopDi$useUploadFile)();
    const signaturePadDraw = (0, $hopDi$useRef)("signature_pad_draw");
    const shouldShowStep2ForComment = Boolean(isPrimaryCertifier && isESignature);
    const shouldShowAlertForUserNameForSignature = Boolean(step2SignatureData.showAlert && step2SignatureData.userAttributeValue?.trim().length === 0);
    const shouldShowAlertForESignatureData = Boolean(step2SignatureData.showAlert && step2SignatureData.eSignatureData?.trim().length === 0);
    const shouldDisabledClearBtnForESig = Boolean(step2SignatureData.eSignatureData?.trim().length === 0);
    const shouldShowAlertForTncForSignature = Boolean(step2SignatureData.showAlert && !step2SignatureData.isAgreeChecked);
    const shouldShowAlertForCommentForSignature = Boolean(step2SignatureData.showAlert && step2SignatureData.commentDescription?.length === 0);
    const reviewAndSubmitModalBodyStep2 = (0, $hopDi$classnames)("ReviewAndSubmitModal-bodyStep2Wrapper", isESignature && "ReviewAndSubmitModal-bodyStep2Wrapper--withESignature");
    (0, $hopDi$useEffect)(()=>{
        setTimeout(()=>{
            (0, $e7628c995f405891$export$63087e5d2dd3ce07)(step2BodyWrapperRef, 0);
        }, (0, $7e937afea8da6d42$export$cc844e58ea5510e9));
    }, [
        firstStep,
        isModalOpen
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (isModalOpen) {
            setStep2CommentData({
                ...step2CommentData,
                commentDescription: "",
                showAlert: false
            });
            setStep2SignatureData({
                ...step2SignatureData,
                userAttributeValue: "",
                eSignatureData: "",
                isAgreeChecked: false,
                commentDescription: "",
                eSignatureTab: step2SignatureData.enableloginSignature === "1" ? (0, $a358fc339b0a2079$export$b1002483f894c26c) : (0, $a358fc339b0a2079$export$22d97d682d25d08),
                showAlert: false,
                alertFields: []
            });
        }
    }, [
        isModalOpen
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (configData) {
            setIsESignature(configData?.withESignature);
            setIsPrimaryCertifier(configData?.primaryCertifier);
            setStep2CommentData((prev)=>({
                    ...prev,
                    predefComments: configData?.step2Data?.predefComments
                }));
            setStep2SignatureData((prev)=>({
                    ...prev,
                    enableloginSignature: configData?.enableloginSignature,
                    userAttribute: configData?.userAttribute,
                    noOfTries: configData?.noOfTries,
                    eSignatureTab: configData?.enableloginSignature === "1" ? (0, $a358fc339b0a2079$export$b1002483f894c26c) : (0, $a358fc339b0a2079$export$22d97d682d25d08),
                    predefComments: configData?.step2Data?.predefComments
                }));
        }
    }, [
        configData
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (isESignature && isAlertActive && isPrimaryCertifier) {
            const tempAlertFields = [];
            if (step2SignatureData.userAttributeValue.trim().length === 0) tempAlertFields.push((0, $a358fc339b0a2079$export$785f226259a2f905));
            if (step2SignatureData.eSignatureData.trim().length === 0) tempAlertFields.push((0, $a358fc339b0a2079$export$5fda98cb5df0734d));
            if (!step2SignatureData.isAgreeChecked) tempAlertFields.push((0, $a358fc339b0a2079$export$9af400ad4180fd4d));
            if (step2SignatureData.commentDescription.trim().length === 0) tempAlertFields.push((0, $a358fc339b0a2079$export$478adefe39e62e49));
            setStep2SignatureData({
                ...step2SignatureData,
                alertFields: tempAlertFields,
                showAlert: isAlertActive
            });
        }
        if ((!isESignature || !isPrimaryCertifier) && isAlertActive) {
            setIsAlertActive(false);
            setStep2CommentData({
                ...step2CommentData,
                showAlert: isAlertActive && step2CommentData.commentDescription.trim().length === 0
            });
        }
    }, [
        isAlertActive
    ]);
    (0, $hopDi$useEffect)(()=>{
        setDataForSubmitAction({
            isESignature: isESignature,
            isPrimaryCertifier: isPrimaryCertifier,
            step2CommentData: step2CommentData,
            step2SignatureData: step2SignatureData
        });
    }, [
        isESignature,
        step2CommentData,
        step2SignatureData
    ]);
    // Without Signature Functions
    const handleCommentDescription = (text)=>{
        setStep2CommentData({
            ...step2CommentData,
            commentDescription: text,
            showAlert: text.length === 0 ? step2CommentData.showAlert : false
        });
    };
    // With Signature functions
    const handleSignatureUserName = (text)=>{
        setStep2SignatureData({
            ...step2SignatureData,
            userAttributeValue: text,
            alertFields: (0, $a3a59a656673dced$export$5a269d4abf2bd409)(step2SignatureData.alertFields, (0, $a358fc339b0a2079$export$785f226259a2f905), text.trim().length === 0)
        });
    };
    // ESignature Box
    const [tabTypeData, setTabTypeData] = (0, $hopDi$useState)("");
    (0, $hopDi$useEffect)(()=>{
        if (typeof signaturePadDraw?.current === "object") signaturePadDraw?.current?.on();
        return ()=>{
            if (typeof signaturePadDraw?.current === "object") signaturePadDraw?.current?.off();
        };
    }, []);
    const handleSignatureESignTab = (tab)=>{
        setTabTypeData("");
        if (signaturePadDraw.current && typeof signaturePadDraw.current === "object" && typeof signaturePadDraw.current.clear !== "undefined") signaturePadDraw?.current?.clear();
        uploadedFiles.length = 0;
        setStep2SignatureData({
            ...step2SignatureData,
            eSignatureData: "",
            eSignatureTab: tab,
            alertFields: (0, $a3a59a656673dced$export$5a269d4abf2bd409)(step2SignatureData.alertFields, (0, $a358fc339b0a2079$export$5fda98cb5df0734d), true)
        });
    };
    const handleSignatureESignTypeAndPassword = (event)=>{
        setTabTypeData(event.target.value);
        setStep2SignatureData({
            ...step2SignatureData,
            eSignatureData: event.target.value,
            alertFields: (0, $a3a59a656673dced$export$5a269d4abf2bd409)(step2SignatureData.alertFields, (0, $a358fc339b0a2079$export$5fda98cb5df0734d), event.target.value.length === 0)
        });
    };
    const handleSignatureESignDrawOnBegin = ()=>{
        setStep2SignatureData({
            ...step2SignatureData,
            eSignatureData: "signature_started",
            alertFields: (0, $a3a59a656673dced$export$5a269d4abf2bd409)(step2SignatureData.alertFields, (0, $a358fc339b0a2079$export$5fda98cb5df0734d), false)
        });
    };
    const handleSignatureESignDrawOnEnd = ()=>{
        setStep2SignatureData({
            ...step2SignatureData,
            eSignatureData: signaturePadDraw?.current?.toDataURL("image/svg", 1.0),
            alertFields: (0, $a3a59a656673dced$export$5a269d4abf2bd409)(step2SignatureData.alertFields, (0, $a358fc339b0a2079$export$5fda98cb5df0734d), false)
        });
    };
    (0, $hopDi$useEffect)(()=>{
        const shouldSetData = Boolean(uploadedFiles.length > 0 && step2SignatureData.eSignatureTab === (0, $a358fc339b0a2079$export$488e307073e5295d) && !hasAnyUploadErrors);
        if (shouldSetData) (0, $a3a59a656673dced$export$47a328b4cabd57cc)(uploadedFiles[0].file).then((base64Text)=>{
            setStep2SignatureData({
                ...step2SignatureData,
                eSignatureData: base64Text,
                alertFields: (0, $a3a59a656673dced$export$5a269d4abf2bd409)(step2SignatureData.alertFields, (0, $a358fc339b0a2079$export$5fda98cb5df0734d), base64Text.trim().length === 0)
            });
        });
    }, [
        uploadedFiles
    ]);
    const handleSignatureClearBtn = ()=>{
        if (step2SignatureData.eSignatureTab === (0, $a358fc339b0a2079$export$22d97d682d25d08) || step2SignatureData.eSignatureTab === (0, $a358fc339b0a2079$export$b1002483f894c26c)) setTabTypeData("");
        if (step2SignatureData.eSignatureTab === (0, $a358fc339b0a2079$export$4c71c21203ea4bc)) signaturePadDraw?.current?.clear();
        if (step2SignatureData.eSignatureTab === (0, $a358fc339b0a2079$export$488e307073e5295d)) uploadedFiles.length = 0;
        setStep2SignatureData({
            ...step2SignatureData,
            eSignatureData: "",
            alertFields: (0, $a3a59a656673dced$export$5a269d4abf2bd409)(step2SignatureData.alertFields, (0, $a358fc339b0a2079$export$5fda98cb5df0734d), true)
        });
    };
    // Rest
    const handleAgreeCheckBox = ()=>{
        setStep2SignatureData({
            ...step2SignatureData,
            isAgreeChecked: !step2SignatureData.isAgreeChecked,
            alertFields: (0, $a3a59a656673dced$export$5a269d4abf2bd409)(step2SignatureData.alertFields, (0, $a358fc339b0a2079$export$9af400ad4180fd4d), step2SignatureData.isAgreeChecked)
        });
    };
    const handleSignatureComment = (text)=>{
        setStep2SignatureData({
            ...step2SignatureData,
            commentDescription: text,
            alertFields: (0, $a3a59a656673dced$export$5a269d4abf2bd409)(step2SignatureData.alertFields, (0, $a358fc339b0a2079$export$478adefe39e62e49), text?.length === 0)
        });
    };
    // Alert box function
    const handleAlertClose = ()=>{
        setIsAlertActive(false);
        if (isESignature && isPrimaryCertifier) setStep2SignatureData({
            ...step2SignatureData,
            showAlert: false,
            alertFields: []
        });
        if (!isESignature || !isPrimaryCertifier) setStep2CommentData({
            ...step2CommentData,
            showAlert: false
        });
    };
    const getAlertBoxTitle = ()=>shouldShowStep2ForComment ? `Required fields (${step2SignatureData.alertFields.length}) are missing. View` : "Required field is missing. View";
    const renderStep2WithOutSignature = ()=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $2515ed647c64b6ee$export$2e2bcd8739ae039), {
            defaultComments: step2CommentData?.predefComments,
            showAlert: step2CommentData.showAlert,
            onChange: handleCommentDescription
        });
    const renderTabsForStep2SignatureBox = ()=>{
        if (step2SignatureData.enableloginSignature === "1") return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabGroup), {
            className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabGroup",
            value: step2SignatureData.eSignatureTab,
            onChange: handleSignatureESignTab,
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                    className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabGroupSpacer--before"
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                    label: "Password",
                    value: (0, $a358fc339b0a2079$export$b1002483f894c26c),
                    icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "Password",
                        size: "medium",
                        color: "neutral-600"
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                    className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabGroupSpacer--after"
                })
            ]
        });
        if (step2SignatureData.enableloginSignature === "0") return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabGroup), {
            className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabGroup",
            value: step2SignatureData.eSignatureTab,
            onChange: handleSignatureESignTab,
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                    className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabGroupSpacer--before"
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                    label: "Type",
                    value: (0, $a358fc339b0a2079$export$22d97d682d25d08),
                    icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "KeyBoard",
                        size: "medium",
                        color: "neutral-600"
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                    label: "Draw",
                    value: (0, $a358fc339b0a2079$export$4c71c21203ea4bc),
                    icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "Edit",
                        size: "medium",
                        color: "neutral-600"
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                    label: "Upload",
                    value: (0, $a358fc339b0a2079$export$488e307073e5295d),
                    icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "ImageOutline",
                        size: "medium",
                        color: "neutral-600"
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                    className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabGroupSpacer--after"
                })
            ]
        });
        return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabGroup), {
            className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabGroup",
            value: step2SignatureData.eSignatureTab,
            onChange: handleSignatureESignTab,
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                    className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabGroupSpacer--before"
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                    label: "Type",
                    value: (0, $a358fc339b0a2079$export$22d97d682d25d08),
                    icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "KeyBoard",
                        size: "medium",
                        color: "neutral-600"
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                    className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabGroupSpacer--after"
                })
            ]
        });
    };
    const renderStep2WithSignature = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InputField), {
                    name: "basic",
                    placeholder: `Please enter ${(0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(step2SignatureData?.userAttribute?.split(".")[0]))} if applicable else enter N/A`,
                    label: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Typography), {
                        kind: "label",
                        htmlFor: "Critical",
                        children: [
                            "Enter",
                            " ",
                            (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(step2SignatureData?.userAttribute?.split(".")[0]))
                        ]
                    }),
                    value: step2SignatureData.userAttributeValue,
                    setValue: handleSignatureUserName,
                    kind: "singleline",
                    isRequired: true,
                    isCritical: shouldShowAlertForUserNameForSignature,
                    CriticalHelperText: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InlineMessage), {
                        kind: "missingRequiredField",
                        size: "small"
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "ReviewAndSubmitModal-bodyStep2WrapperSignatureESig",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                            className: "ReviewAndSubmitModal-bodyStep2WrapperSignatureESigBox",
                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InputField), {
                                name: "basic",
                                placeholder: "",
                                value: step2SignatureData.eSignatureData,
                                label: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    kind: "label",
                                    htmlFor: "Critical",
                                    children: "E-Signature"
                                }),
                                kind: "multiline",
                                isRequired: true,
                                isCritical: shouldShowAlertForESignatureData || step2SignatureData.eSignatureData === "",
                                CriticalHelperText: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InlineMessage), {
                                    text: "This required field is incomplete",
                                    colorTheme: "critical",
                                    size: "small",
                                    leftIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                        kind: "AlertCritical",
                                        color: "critical-700"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                            className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePad",
                            children: [
                                renderTabsForStep2SignatureBox(),
                                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabContent), {
                                    className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContent",
                                    value: step2SignatureData.eSignatureTab,
                                    tabValue: (0, $a358fc339b0a2079$export$b1002483f894c26c),
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                            className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContentBgText",
                                            children: "Type your password"
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)("input", {
                                            type: "password",
                                            maxLength: "32",
                                            value: tabTypeData,
                                            onChange: handleSignatureESignTypeAndPassword,
                                            className: `ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContentInput ${tabTypeData.length > 0 ? "filled" : ""}`
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabContent), {
                                    className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContent",
                                    value: step2SignatureData.eSignatureTab,
                                    tabValue: (0, $a358fc339b0a2079$export$22d97d682d25d08),
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                            className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContentBgText",
                                            children: "Type your name to sign"
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)("input", {
                                            type: "text",
                                            maxLength: "32",
                                            value: tabTypeData,
                                            onChange: handleSignatureESignTypeAndPassword,
                                            className: `ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContentInput ${tabTypeData.length > 0 ? "filled" : ""}`
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabContent), {
                                    className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContent",
                                    value: step2SignatureData.eSignatureTab,
                                    tabValue: (0, $a358fc339b0a2079$export$4c71c21203ea4bc),
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$reactsignaturecanvas), {
                                            ref: signaturePadDraw,
                                            onBegin: handleSignatureESignDrawOnBegin,
                                            onEnd: handleSignatureESignDrawOnEnd,
                                            canvasProps: {
                                                className: `ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContentDraw ${step2SignatureData.eSignatureData.length > 0 ? "hideBgText" : ""}`
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                            className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContentBgText",
                                            children: "Draw your signature"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
                                    className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContent",
                                    value: step2SignatureData.eSignatureTab,
                                    tabValue: (0, $a358fc339b0a2079$export$488e307073e5295d),
                                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Upload), {
                                        kind: "button",
                                        isMultiple: false,
                                        onFileSelect: handleFileSelect,
                                        onFileDelete: handleFileDelete,
                                        onFileReupload: handleFileReupload,
                                        uploadedFiles: uploadedFiles,
                                        acceptTypes: ".pdf,.png,.jpeg,.jpg",
                                        reuploadFileName: reuploadFileName,
                                        isMaxNumberUploaded: uploadedFiles.length === 1,
                                        isMaxTotalSizeReached: uploadedFiles.length === 1,
                                        maxFileSize: 10,
                                        maxTotalFileSize: 10,
                                        helperText: "",
                                        className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContentUpload"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            className: `ReviewAndSubmitModal-bodyStep2WrapperSignaturePadClearBtn ${shouldShowAlertForESignatureData ? "" : "noCommentsPresent"}`,
                            kind: shouldDisabledClearBtnForESig ? "filled" : "outlined",
                            isDisabled: shouldDisabledClearBtnForESig,
                            onClick: handleSignatureClearBtn,
                            size: "small",
                            children: "Clear"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "ReviewAndSubmitModal-bodyStep2WrapperSignatureTnC",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "label",
                            htmlFor: "Disabled",
                            children: "Terms and Conditions"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "body2",
                            className: "ReviewAndSubmitModal-bodyStep2WrapperSignatureTnCText",
                            children: (0, $a358fc339b0a2079$export$2c2d63fc3ac6387a)
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                            className: "ReviewAndSubmitModal-bodyStep2WrapperSignatureTnCCheckBox",
                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InputField), {
                                name: "Warning",
                                placeholder: "",
                                label: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                                    kind: "simpleText",
                                    isChecked: step2SignatureData.isAgreeChecked,
                                    onChange: handleAgreeCheckBox,
                                    label: "I agree",
                                    size: "small",
                                    textPosition: "after",
                                    showHoverEffect: true
                                }),
                                value: step2SignatureData.isAgreeChecked ? "TnC" : (0, $a358fc339b0a2079$export$8704469cbf3a8b0d),
                                kind: "singleline",
                                isRequired: true,
                                isCritical: shouldShowAlertForTncForSignature,
                                CriticalHelperText: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InlineMessage), {
                                    kind: "missingRequiredField",
                                    size: "small"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $2515ed647c64b6ee$export$2e2bcd8739ae039), {
                    defaultComments: step2SignatureData?.predefComments,
                    showAlert: shouldShowAlertForCommentForSignature,
                    onChange: handleSignatureComment
                })
            ]
        });
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: reviewAndSubmitModalBodyStep2,
        ref: step2BodyWrapperRef,
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "ReviewAndSubmitModal-bodyStep2WrapperAlertBox",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$AlertBanner), {
                    colorTheme: "Critical",
                    title: getAlertBoxTitle(),
                    description: "",
                    isColonVisible: false,
                    isVisible: shouldShowStep2ForComment ? step2SignatureData.showAlert && step2SignatureData.alertFields.length > 0 : step2CommentData.showAlert,
                    onCancel: handleAlertClose,
                    LinkComponent: isESignature ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "ArrowDown",
                        color: "neutral-000"
                    }) : null
                })
            }),
            shouldShowStep2ForComment ? renderStep2WithSignature() : renderStep2WithOutSignature()
        ]
    });
}
$006ec638c01b2b4e$var$Step2.propTypes = {
    isModalOpen: (0, $hopDi$proptypes).bool.isRequired,
    firstStep: (0, $hopDi$proptypes).bool.isRequired,
    configData: (0, $hopDi$proptypes).shape((0, $9694675c3ac08467$export$2e2bcd8739ae039)),
    isAlertActive: (0, $hopDi$proptypes).bool.isRequired,
    setIsAlertActive: (0, $hopDi$proptypes).func,
    setDataForSubmitAction: (0, $hopDi$proptypes).func
};
$006ec638c01b2b4e$var$Step2.defaultProps = {
    configData: {},
    setIsAlertActive: ()=>{},
    setDataForSubmitAction: ()=>{}
};
var $006ec638c01b2b4e$export$2e2bcd8739ae039 = $006ec638c01b2b4e$var$Step2;


var $9b03f6fc2c2722e1$export$2e2bcd8739ae039 = (0, $006ec638c01b2b4e$export$2e2bcd8739ae039);



function $03a3cae6b20059c5$var$ReviewAndSubmitBody({ firstStep: firstStep, isModalOpen: isModalOpen, isAlertActive: isAlertActive, setIsAlertActive: setIsAlertActive, setDataForSubmitAction: setDataForSubmitAction, retrigggerApisForError: retrigggerApisForError, closeReviewAndSubmitModal: closeReviewAndSubmitModal }) {
    const { isLoadingReviewAndSubmit: isLoadingReviewAndSubmit, reviewAndSubmit: reviewAndSubmit, reviewAndSubmitError: reviewAndSubmitError, tabs: tabs } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const todoTabCount = tabs?.tabData?.find((tab)=>tab.key === (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49))?.count;
    const doneTabCount = tabs?.tabData?.find((tab)=>tab.key === (0, $d44c789d5b60f9bf$export$807a0bc890800408))?.count;
    const [config, setConfig] = (0, $hopDi$useState)({});
    const hasToDoItemsCountAsZero = todoTabCount === 0;
    (0, $hopDi$useEffect)(()=>{
        if (reviewAndSubmit) setConfig({
            primaryCertifier: reviewAndSubmit?.primaryCertifier,
            isComplete: hasToDoItemsCountAsZero,
            withESignature: reviewAndSubmit?.withESignature,
            enableloginSignature: reviewAndSubmit?.enableloginSignature,
            todoTabCount: todoTabCount,
            doneTabCount: doneTabCount,
            step1Data: reviewAndSubmit?.step1Data,
            step2Data: reviewAndSubmit?.step2Data,
            userAttribute: reviewAndSubmit?.userAttribute,
            noOfTries: reviewAndSubmit?.noOfTries
        });
    }, [
        todoTabCount,
        reviewAndSubmit
    ]);
    const reviewAndSubmitModalBody = (0, $hopDi$classnames)("ReviewAndSubmitModal-body");
    const renderFailedApiUi = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: "ReviewAndSubmitModal-bodyError",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "h2",
                    children: "Couldn't Load"
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "body2",
                    children: "The Summary didn't load properly due to a network issue. Please refresh or try again later."
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "ReviewAndSubmitModal-bodyErrorButtons",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: "filled",
                            onClick: retrigggerApisForError,
                            size: "medium",
                            children: "Refresh"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: "ghost",
                            size: "medium",
                            onClick: closeReviewAndSubmitModal,
                            children: "Close"
                        })
                    ]
                })
            ]
        });
    const renderLoaderAndSteps = ()=>{
        if (isLoadingReviewAndSubmit) return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "ReviewAndSubmitModal-bodyLoader--loading",
                    children: reviewAndSubmitError ? renderFailedApiUi() : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                        kind: "dots",
                        format: "inline",
                        color: "info",
                        size: "medium"
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "ReviewAndSubmitModal-bodyStep1--loading",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $328d7b406278ef5b$export$2e2bcd8739ae039), {
                        isModalOpen: isModalOpen,
                        firstStep: firstStep,
                        configData: config
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "ReviewAndSubmitModal-bodyStep2--loading",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $9b03f6fc2c2722e1$export$2e2bcd8739ae039), {
                        isModalOpen: isModalOpen,
                        firstStep: firstStep,
                        configData: config,
                        isAlertActive: isAlertActive,
                        setIsAlertActive: setIsAlertActive,
                        setDataForSubmitAction: setDataForSubmitAction
                    })
                })
            ]
        });
        if (firstStep) return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "ReviewAndSubmitModal-bodyLoader--finished",
                    children: reviewAndSubmitError ? renderFailedApiUi() : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                        kind: "dots",
                        format: "inline",
                        color: "info",
                        size: "medium"
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "ReviewAndSubmitModal-bodyStep1--visible",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $328d7b406278ef5b$export$2e2bcd8739ae039), {
                        isModalOpen: isModalOpen,
                        firstStep: firstStep,
                        configData: config
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "ReviewAndSubmitModal-bodyStep2--hidden",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $9b03f6fc2c2722e1$export$2e2bcd8739ae039), {
                        isModalOpen: isModalOpen,
                        firstStep: firstStep,
                        configData: config,
                        isAlertActive: isAlertActive,
                        setIsAlertActive: setIsAlertActive,
                        setDataForSubmitAction: setDataForSubmitAction
                    })
                })
            ]
        });
        return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "ReviewAndSubmitModal-bodyLoader--hidden",
                    children: reviewAndSubmitError ? renderFailedApiUi() : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                        kind: "dots",
                        format: "inline",
                        color: "info",
                        size: "medium"
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "ReviewAndSubmitModal-bodyStep1--hidden",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $328d7b406278ef5b$export$2e2bcd8739ae039), {
                        isModalOpen: isModalOpen,
                        firstStep: firstStep,
                        configData: config
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "ReviewAndSubmitModal-bodyStep2--visible",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $9b03f6fc2c2722e1$export$2e2bcd8739ae039), {
                        isModalOpen: isModalOpen,
                        firstStep: firstStep,
                        configData: config,
                        isAlertActive: isAlertActive,
                        setIsAlertActive: setIsAlertActive,
                        setDataForSubmitAction: setDataForSubmitAction
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $hopDi$jsx)("section", {
        className: reviewAndSubmitModalBody,
        children: renderLoaderAndSteps()
    });
}
$03a3cae6b20059c5$var$ReviewAndSubmitBody.propTypes = {
    firstStep: (0, $hopDi$proptypes).bool.isRequired,
    isModalOpen: (0, $hopDi$proptypes).bool.isRequired,
    isAlertActive: (0, $hopDi$proptypes).bool.isRequired,
    setIsAlertActive: (0, $hopDi$proptypes).func,
    setDataForSubmitAction: (0, $hopDi$proptypes).func,
    retrigggerApisForError: (0, $hopDi$proptypes).func.isRequired,
    closeReviewAndSubmitModal: (0, $hopDi$proptypes).func.isRequired
};
$03a3cae6b20059c5$var$ReviewAndSubmitBody.defaultProps = {
    setIsAlertActive: ()=>{},
    setDataForSubmitAction: ()=>{}
};
var $03a3cae6b20059c5$export$2e2bcd8739ae039 = $03a3cae6b20059c5$var$ReviewAndSubmitBody;


var $935cccc08f9a7d44$export$2e2bcd8739ae039 = (0, $03a3cae6b20059c5$export$2e2bcd8739ae039);










const $3f56701b4fa5d690$export$6941e8c8ff049f2 = 1000;



function $1a04842bd1f406bd$var$ReviewAndSubmitFooter({ firstStep: firstStep, isModalOpen: isModalOpen, setFirstStep: setFirstStep, setIsAlertActive: setIsAlertActive, dataForSubmitAction: dataForSubmitAction, closeReviewAndSubmitModal: closeReviewAndSubmitModal }) {
    const dispatch = (0, $hopDi$useDispatch)();
    const { certKey: certKey, isLoadingReviewAndSubmit: isLoadingReviewAndSubmit, isSubmittingReviewAndSubmit: isSubmittingReviewAndSubmit, tabs: tabs, reviewAndSubmit: reviewAndSubmit, reviewAndSubmitError: reviewAndSubmitError, campaignKey: campaignKey } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const { tabData: tabData } = tabs;
    const todoTabCount = tabData?.find((tab)=>tab.key === (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49))?.count;
    const hasToDoItemsCountAsZero = todoTabCount === 0;
    const shouldDisableNextAndSubmitBtn = Boolean(isLoadingReviewAndSubmit || reviewAndSubmitError || isSubmittingReviewAndSubmit);
    const [config, setConfig] = (0, $hopDi$useState)();
    const [hasSubmittedCertification, setHasSubmittedCertification] = (0, $hopDi$useState)(false);
    const [alert, setAlert] = (0, $hopDi$useState)({
        theme: "Critical",
        isOpen: false,
        title: "",
        description: "",
        isColonVisible: false,
        autoDismiss: true
    });
    (0, $hopDi$useEffect)(()=>{
        if (tabData && reviewAndSubmit) setConfig({
            primaryCertifier: reviewAndSubmit?.primaryCertifier,
            isComplete: hasToDoItemsCountAsZero,
            withESignature: reviewAndSubmit?.withESignature
        });
    }, [
        tabs,
        todoTabCount,
        reviewAndSubmit
    ]);
    const reviewAndSubmitModalFooter = (0, $hopDi$classnames)("ReviewAndSubmitModal-footer");
    const lockSummary = (comments)=>{
        dispatch((0, $d623f23401a154f0$export$6bd0ceb6f0238e0a)(certKey, comments)).then(()=>{
            setAlert({
                ...alert,
                isOpen: true,
                theme: "Success",
                title: "Success",
                description: "Certification succesfully submitted",
                isColonVisible: true,
                autoDismiss: false
            });
            setHasSubmittedCertification(true);
            setTimeout(()=>{
                window.location.replace(`/ECM/certification/list?campaignKey=${campaignKey}&type=list`);
            }, (0, $3f56701b4fa5d690$export$6941e8c8ff049f2));
        }).catch((error)=>{
            dispatch((0, $d623f23401a154f0$export$dadc0bb56f5e8946)(false));
            setAlert({
                ...alert,
                isOpen: true,
                title: error.message
            });
        });
    };
    const handleSubmit = ()=>{
        if (dataForSubmitAction.isPrimaryCertifier && dataForSubmitAction.isESignature) {
            const { step2SignatureData: { userAttribute: userAttribute, enableloginSignature: enableloginSignature, noOfTries: noOfTries, userAttributeValue: userAttributeValue, isAgreeChecked: isAgreeChecked, commentDescription: commentDescription, eSignatureData: eSignatureData } } = dataForSubmitAction;
            const shouldEnableAlert = Boolean(userAttributeValue.length === 0 || eSignatureData.length === 0 || !isAgreeChecked || commentDescription.length === 0);
            const payload = {};
            if (Number(enableloginSignature)) {
                payload[userAttribute] = userAttributeValue;
                payload.userPassword = eSignatureData;
            } else {
                payload.fieldToVerify = userAttribute;
                payload.eSignValueToVerify = userAttributeValue;
                payload.signatureSvg = eSignatureData;
            }
            if (shouldEnableAlert) {
                setIsAlertActive(true);
                return;
            }
            dispatch((0, $d623f23401a154f0$export$776ef17d04a202bf)(certKey, enableloginSignature, noOfTries, payload)).then(()=>{
                lockSummary(commentDescription);
            }).catch((error)=>{
                dispatch((0, $d623f23401a154f0$export$dadc0bb56f5e8946)(false));
                setAlert({
                    ...alert,
                    isOpen: true,
                    title: error.message
                });
                setIsAlertActive(true);
            });
        }
        if (!dataForSubmitAction.isESignature) {
            const { step2CommentData: { commentDescription: commentDescription } } = dataForSubmitAction;
            if (commentDescription.length === 0) {
                setIsAlertActive(true);
                return;
            }
            lockSummary(commentDescription);
        }
    };
    const handleNextAndSubmitBtn = ()=>{
        if (firstStep) {
            setFirstStep(false);
            return;
        }
        handleSubmit();
    };
    const handleViewToDoListBtn = ()=>{
        const modifiedTabs = tabs.tabData.map((tab)=>({
                ...tab,
                isActive: tab.key === (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49),
                isHighlighted: false
            }));
        dispatch((0, $d623f23401a154f0$export$e9c5cd8aea0cabc7)(modifiedTabs));
        closeReviewAndSubmitModal();
    };
    const handleCompleteForConsultee = ()=>{
        dispatch((0, $d623f23401a154f0$export$f75c1d1e7da3ca60)(certKey)).then(()=>{
            setAlert({
                ...alert,
                isOpen: true,
                theme: "Success",
                title: "Success",
                description: "Certification succesfully submitted",
                isColonVisible: true,
                autoDismiss: false
            });
            setHasSubmittedCertification(true);
            setTimeout(()=>{
                window.location.replace(`/ECM/certification/list?campaignKey=${campaignKey}&type=list`);
            }, (0, $3f56701b4fa5d690$export$6941e8c8ff049f2));
        }).catch((error)=>{
            dispatch((0, $d623f23401a154f0$export$dadc0bb56f5e8946)(false));
            setAlert({
                ...alert,
                isOpen: true,
                title: error.message
            });
        });
    };
    const handleAlertClose = ()=>{
        setAlert({
            ...alert,
            isOpen: false,
            title: ""
        });
    };
    (0, $hopDi$useEffect)(()=>{
        if (!isModalOpen) handleAlertClose();
    }, [
        isModalOpen
    ]);
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$FooterActionBar), {
        className: reviewAndSubmitModalFooter,
        size: "large",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {}),
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "ReviewAndSubmitModal-footerButtonWrap",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$AlertBanner), {
                        colorTheme: alert.theme,
                        title: alert.title,
                        description: alert.description,
                        isVisible: alert.isOpen,
                        isColonVisible: alert.isColonVisible,
                        isFloating: true,
                        shouldAutoDismiss: alert.autoDismiss,
                        onCancel: handleAlertClose
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        type: "button",
                        kind: "ghost",
                        size: "medium",
                        onClick: closeReviewAndSubmitModal,
                        isDisabled: isSubmittingReviewAndSubmit,
                        children: "Cancel"
                    }),
                    config?.isComplete && config?.primaryCertifier && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        type: "button",
                        kind: firstStep || shouldDisableNextAndSubmitBtn ? "filled" : "outlined",
                        size: "medium",
                        isDisabled: shouldDisableNextAndSubmitBtn,
                        rightIcon: isSubmittingReviewAndSubmit && !hasSubmittedCertification ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                            kind: "loop",
                            format: "inline",
                            color: "brand",
                            size: "small"
                        }) : null,
                        onClick: handleNextAndSubmitBtn,
                        children: firstStep ? "Next" : "Submit"
                    }),
                    config?.isComplete && !config?.primaryCertifier && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        type: "button",
                        kind: shouldDisableNextAndSubmitBtn ? "fill" : "outlined",
                        size: "medium",
                        isDisabled: shouldDisableNextAndSubmitBtn,
                        rightIcon: isSubmittingReviewAndSubmit && !hasSubmittedCertification ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                            kind: "loop",
                            format: "inline",
                            color: "brand",
                            size: "small"
                        }) : null,
                        onClick: handleCompleteForConsultee,
                        children: "Complete"
                    }),
                    !config?.isComplete && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        type: "button",
                        kind: "filled",
                        size: "medium",
                        onClick: handleViewToDoListBtn,
                        children: "View To-Do List"
                    })
                ]
            })
        ]
    });
}
$1a04842bd1f406bd$var$ReviewAndSubmitFooter.propTypes = {
    isModalOpen: (0, $hopDi$proptypes).bool.isRequired,
    closeReviewAndSubmitModal: (0, $hopDi$proptypes).func.isRequired,
    firstStep: (0, $hopDi$proptypes).bool.isRequired,
    setFirstStep: (0, $hopDi$proptypes).func.isRequired,
    setIsAlertActive: (0, $hopDi$proptypes).func,
    dataForSubmitAction: (0, $hopDi$proptypes).shape({
        isPrimaryCertifier: (0, $hopDi$proptypes).bool,
        isESignature: (0, $hopDi$proptypes).bool,
        step2CommentData: (0, $hopDi$proptypes).shape({
            commentDescription: (0, $hopDi$proptypes).string
        }),
        step2SignatureData: (0, $hopDi$proptypes).shape({
            userAttribute: (0, $hopDi$proptypes).string,
            enableloginSignature: (0, $hopDi$proptypes).string,
            noOfTries: (0, $hopDi$proptypes).string,
            userAttributeValue: (0, $hopDi$proptypes).string,
            isAgreeChecked: (0, $hopDi$proptypes).bool,
            commentDescription: (0, $hopDi$proptypes).string,
            eSignatureData: (0, $hopDi$proptypes).string
        })
    })
};
$1a04842bd1f406bd$var$ReviewAndSubmitFooter.defaultProps = {
    setIsAlertActive: ()=>{},
    dataForSubmitAction: {}
};
var $1a04842bd1f406bd$export$2e2bcd8739ae039 = $1a04842bd1f406bd$var$ReviewAndSubmitFooter;


var $6c1c0736605a4af0$export$2e2bcd8739ae039 = (0, $1a04842bd1f406bd$export$2e2bcd8739ae039);












function $145c8a52f76220e5$var$ReviewAndSubmitHeader({ firstStep: firstStep, setFirstStep: setFirstStep }) {
    const { reviewAndSubmit: reviewAndSubmit, isSubmittingReviewAndSubmit: isSubmittingReviewAndSubmit, tabs: tabs } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const todoTabCount = tabs?.tabData?.find((tab)=>tab.key === (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49))?.count;
    const [config, setConfig] = (0, $hopDi$useState)();
    const hasToDoItemsCountAsZero = todoTabCount === 0;
    (0, $hopDi$useEffect)(()=>{
        if (reviewAndSubmit) setConfig({
            certifier: reviewAndSubmit.primaryCertifier ? (0, $7e937afea8da6d42$export$506d5022cff8f7df) : (0, $7e937afea8da6d42$export$842181aaa7a414ff),
            isComplete: hasToDoItemsCountAsZero ? (0, $7e937afea8da6d42$export$e38f3fe6f8e2e1d5) : (0, $7e937afea8da6d42$export$5d9f356b4d4d5628),
            withESignature: reviewAndSubmit.withESignature ? (0, $7e937afea8da6d42$export$4414b99fd5cdebbf) : (0, $7e937afea8da6d42$export$c7ded6134c5259a8),
            step: firstStep ? (0, $7e937afea8da6d42$export$33413024a053a1ca) : (0, $7e937afea8da6d42$export$deab3fee8d04afb5)
        });
    }, [
        todoTabCount,
        reviewAndSubmit,
        firstStep
    ]);
    const reviewAndSubmitModalHeader = (0, $hopDi$classnames)("ReviewAndSubmitModal-header");
    const title = (0, $7e937afea8da6d42$export$f1e53f710478ceb4)[config?.certifier]?.[config?.isComplete]?.[config?.withESignature]?.[config?.step];
    const goBack = ()=>{
        if (!isSubmittingReviewAndSubmit) setFirstStep(true);
    };
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: reviewAndSubmitModalHeader,
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: firstStep ? "ReviewAndSubmitModal-headerIcon--hidden" : "ReviewAndSubmitModal-headerIcon--visible",
                onClick: goBack,
                onKeyUp: ()=>{},
                role: "button",
                tabIndex: "0",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "ChevronLeft",
                    color: "neutral-1000"
                })
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "ReviewAndSubmitModal-headerTitle",
                children: title
            })
        ]
    });
}
$145c8a52f76220e5$var$ReviewAndSubmitHeader.propTypes = {
    firstStep: (0, $hopDi$proptypes).bool.isRequired,
    setFirstStep: (0, $hopDi$proptypes).func.isRequired
};
var $145c8a52f76220e5$export$2e2bcd8739ae039 = $145c8a52f76220e5$var$ReviewAndSubmitHeader;






function $377a8b1f118e2516$var$ReviewAndSubmitSubTitle({ firstStep: firstStep }) {
    const { reviewAndSubmit: reviewAndSubmit, tabs: tabs } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const todoTabCount = tabs?.tabData?.find((tab)=>tab.key === (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49))?.count;
    const hasToDoItemsCountAsZero = todoTabCount === 0;
    const [config, setConfig] = (0, $hopDi$useState)();
    (0, $hopDi$useEffect)(()=>{
        if (reviewAndSubmit) setConfig({
            certifier: reviewAndSubmit?.primaryCertifier ? (0, $7e937afea8da6d42$export$506d5022cff8f7df) : (0, $7e937afea8da6d42$export$842181aaa7a414ff),
            certifierName: reviewAndSubmit?.primaryCertifierName,
            isComplete: hasToDoItemsCountAsZero ? (0, $7e937afea8da6d42$export$e38f3fe6f8e2e1d5) : (0, $7e937afea8da6d42$export$5d9f356b4d4d5628),
            withESignature: reviewAndSubmit?.withESignature ? (0, $7e937afea8da6d42$export$4414b99fd5cdebbf) : (0, $7e937afea8da6d42$export$c7ded6134c5259a8),
            step: firstStep ? (0, $7e937afea8da6d42$export$33413024a053a1ca) : (0, $7e937afea8da6d42$export$deab3fee8d04afb5)
        });
    }, [
        todoTabCount,
        reviewAndSubmit,
        firstStep
    ]);
    if (config?.certifier === (0, $7e937afea8da6d42$export$842181aaa7a414ff)) return (0, $7e937afea8da6d42$export$5895c693c74b9cf4)[config?.certifier]?.[config?.isComplete]?.[config?.withESignature]?.[config?.step]?.replace("$$$", config?.certifierName);
    if (hasToDoItemsCountAsZero) return (0, $7e937afea8da6d42$export$5895c693c74b9cf4)[config?.certifier]?.[config?.isComplete]?.[config?.withESignature]?.[config?.step];
    return (0, $7e937afea8da6d42$export$5895c693c74b9cf4)[config?.certifier]?.[config?.isComplete]?.[config?.withESignature]?.[config?.step]?.replace("$$$", todoTabCount);
}
$377a8b1f118e2516$var$ReviewAndSubmitSubTitle.propTypes = {
    firstStep: (0, $hopDi$proptypes).bool.isRequired
};
var $377a8b1f118e2516$export$2e2bcd8739ae039 = $377a8b1f118e2516$var$ReviewAndSubmitSubTitle;





function $8aa367b1e45b40ec$var$ReviewAndSubmit({ buttonSize: buttonSize }) {
    const dispatch = (0, $hopDi$useDispatch)();
    const { isLoading: isLoading, bulkAction: bulkAction, certKey: certKey, isSubmittingReviewAndSubmit: isSubmittingReviewAndSubmit, shouldShowReviewAndSubmitButton: shouldShowReviewAndSubmitButton, tabs: tabs } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const todoTabCount = tabs?.tabData?.find((tab)=>tab.key === (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49))?.count;
    const [isModalOpen, setIsModalOpen] = (0, $hopDi$useState)(false);
    const [isDisabled, setIsDisabled] = (0, $hopDi$useState)(true);
    const [firstStep, setFirstStep] = (0, $hopDi$useState)(true);
    const [dataForSubmitAction, setDataForSubmitAction] = (0, $hopDi$useState)({});
    const [isAlertActive, setIsAlertActive] = (0, $hopDi$useState)(false);
    const hasToDoItemsCountAsZero = todoTabCount === 0;
    (0, $hopDi$useEffect)(()=>{
        if (certKey) setIsDisabled(false);
    }, [
        certKey,
        bulkAction
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (isLoading || bulkAction?.isChecked || bulkAction?.isDisabled || bulkAction?.isIndeterminate || bulkAction?.isSubmittingAction) setIsDisabled(true);
    }, [
        bulkAction,
        isLoading
    ]);
    const closeReviewAndSubmitModal = ()=>{
        if (!isSubmittingReviewAndSubmit) {
            setIsModalOpen(false);
            setTimeout(()=>{
                setFirstStep(true);
                dispatch((0, $d623f23401a154f0$export$eb61ad48998e2c20)(true));
            }, (0, $7e937afea8da6d42$export$cc844e58ea5510e9));
        }
    };
    const openReviewAndSubmitModal = ()=>{
        const promisesForStep1Data = [];
        // TODO: Disabling tab count api as tab count is getting refreshed after the action
        // promisesForStep1Data.push(dispatch(getTabCounts(certKey)));
        (0, $7e937afea8da6d42$export$df8f064ab2a7c09c).forEach((category)=>{
            promisesForStep1Data.push(dispatch((0, $d623f23401a154f0$export$886e16c80cfe3a1a)(certKey, category)));
        });
        Promise.all(promisesForStep1Data).then(()=>{
            dispatch((0, $d623f23401a154f0$export$eb61ad48998e2c20)(false));
            promisesForStep1Data.length = 0;
        }).catch(()=>{
            promisesForStep1Data.length = 0;
        });
        setIsModalOpen(true);
    };
    const reviewAndSubmitModal = (0, $hopDi$classnames)("ReviewAndSubmitModal");
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
        className: "ModalIslandBox",
        children: [
            shouldShowReviewAndSubmitButton && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                type: "button",
                kind: hasToDoItemsCountAsZero || isDisabled ? "filled" : "outlined",
                onClick: openReviewAndSubmitModal,
                size: buttonSize,
                isDisabled: isDisabled,
                children: "Review and Submit"
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
                className: reviewAndSubmitModal,
                onClose: closeReviewAndSubmitModal,
                isOpen: isModalOpen,
                title: /*#__PURE__*/ (0, $hopDi$jsx)((0, $145c8a52f76220e5$export$2e2bcd8739ae039), {
                    firstStep: firstStep,
                    setFirstStep: setFirstStep
                }),
                subtitle: /*#__PURE__*/ (0, $hopDi$jsx)((0, $377a8b1f118e2516$export$2e2bcd8739ae039), {
                    firstStep: firstStep
                }),
                contentBody: /*#__PURE__*/ (0, $hopDi$jsx)((0, $935cccc08f9a7d44$export$2e2bcd8739ae039), {
                    firstStep: firstStep,
                    isModalOpen: isModalOpen,
                    isAlertActive: isAlertActive,
                    setIsAlertActive: setIsAlertActive,
                    setDataForSubmitAction: setDataForSubmitAction,
                    retrigggerApisForError: openReviewAndSubmitModal,
                    closeReviewAndSubmitModal: closeReviewAndSubmitModal
                }),
                FooterActionBarComp: /*#__PURE__*/ (0, $hopDi$jsx)((0, $6c1c0736605a4af0$export$2e2bcd8739ae039), {
                    firstStep: firstStep,
                    isModalOpen: isModalOpen,
                    setFirstStep: setFirstStep,
                    setIsAlertActive: setIsAlertActive,
                    dataForSubmitAction: dataForSubmitAction,
                    closeReviewAndSubmitModal: closeReviewAndSubmitModal
                })
            })
        ]
    });
}
$8aa367b1e45b40ec$var$ReviewAndSubmit.propTypes = {
    buttonSize: (0, $hopDi$proptypes).oneOf((0, $7e937afea8da6d42$export$73e83bf2b7e02467))
};
$8aa367b1e45b40ec$var$ReviewAndSubmit.defaultProps = {
    buttonSize: "medium"
};
var $8aa367b1e45b40ec$export$2e2bcd8739ae039 = $8aa367b1e45b40ec$var$ReviewAndSubmit;


var $eb340908ccb18f38$export$2e2bcd8739ae039 = (0, $8aa367b1e45b40ec$export$2e2bcd8739ae039);





/* eslint-disable indent */ /* eslint-disable guard-for-in */ /* eslint-disable no-param-reassign */ /* eslint-disable no-restricted-syntax */ 



const $8ae07190c6a505ba$export$6abaf2f4454ce80f = "rowNotToShow";


const $31eefeb47866cab8$export$89bc22408028ff3d = (results, trackerObjBaseSettings = {}, level = 0)=>results.map((result)=>({
            ...result,
            tracker: result.tracker ? result.tracker : {
                id: (0, $hopDi$getRandomString)(),
                isChecked: false,
                isIndeterminate: false,
                isConnected: false,
                level: level,
                ...trackerObjBaseSettings
            },
            children: (result?.children && result.children.length) > 0 ? $31eefeb47866cab8$export$89bc22408028ff3d(result.children, trackerObjBaseSettings, level + 1) : []
        }));
const $31eefeb47866cab8$export$711a902d2e3a009f = (results)=>results.map((item)=>{
        const isUserAndStatusApproved = item?.CERTIFIED === (0, $20281fe09bc700a8$export$6bf521f24032eb49).WORKS_FOR_ME;
        const isAccountEntRoleAndStatusApproved = item?.CERTIFIED === (0, $20281fe09bc700a8$export$6bf521f24032eb49).APPROVE;
        const isTerminateUserSelected = item?.CERTIFIED === (0, $20281fe09bc700a8$export$6bf521f24032eb49).TERMINATED;
        const isExtendEndDateUserSelected = item?.CERTIFIED === (0, $20281fe09bc700a8$export$6bf521f24032eb49).EXTEND_END_DATE;
        const isConditionalCertifyUserSelected = item?.CERTIFIED === (0, $20281fe09bc700a8$export$6bf521f24032eb49).CONDITIONAL_CERTIFIY;
        const isRejectUserSelected = item?.CERTIFIED === (0, $20281fe09bc700a8$export$6bf521f24032eb49).REVOKED;
        const isReassignSelected = item?.CERTIFIED === (0, $20281fe09bc700a8$export$6bf521f24032eb49).REVOKED;
        const actionButtonPayload = {};
        if (isUserAndStatusApproved) actionButtonPayload[(0, $20281fe09bc700a8$export$3f43cf8434698562).WORKS_FOR_ME] = {
            isSelected: true,
            isLoading: false,
            isDisabled: false,
            shouldBeRemoved: false
        };
        if (isAccountEntRoleAndStatusApproved) actionButtonPayload[(0, $20281fe09bc700a8$export$3f43cf8434698562).APPROVE] = {
            isSelected: true,
            isLoading: false,
            isDisabled: false,
            shouldBeRemoved: false
        };
        if (isTerminateUserSelected) actionButtonPayload[(0, $20281fe09bc700a8$export$3f43cf8434698562).TERMINATE] = {
            isSelected: true,
            isLoading: false,
            isDisabled: false,
            shouldBeRemoved: false
        };
        if (isExtendEndDateUserSelected) actionButtonPayload[(0, $20281fe09bc700a8$export$3f43cf8434698562).EXTEND_END_DATE] = {
            isSelected: true,
            isLoading: false,
            isDisabled: false,
            shouldBeRemoved: false
        };
        if (isRejectUserSelected) actionButtonPayload[(0, $20281fe09bc700a8$export$3f43cf8434698562).REJECT] = {
            isSelected: true,
            isLoading: false,
            isDisabled: false,
            shouldBeRemoved: false
        };
        if (isConditionalCertifyUserSelected) actionButtonPayload[(0, $20281fe09bc700a8$export$3f43cf8434698562).CONDITIONAL_CERTIFIY] = {
            isSelected: true,
            isLoading: false,
            isDisabled: false,
            shouldBeRemoved: false
        };
        if (isReassignSelected) actionButtonPayload[(0, $20281fe09bc700a8$export$3f43cf8434698562).DOES_NOT_WORK_FOR_ME || (0, $20281fe09bc700a8$export$3f43cf8434698562).REASSIGN] = {
            isSelected: true,
            isLoading: false,
            isDisabled: false,
            shouldBeRemoved: false
        };
        return {
            ...item,
            tracker: {
                ...item.tracker,
                actions: {
                    ...actionButtonPayload,
                    ...item?.tracker?.actions
                }
            },
            children: item?.children && item?.children?.length > 0 ? $31eefeb47866cab8$export$711a902d2e3a009f(item.children) : []
        };
    });
const $31eefeb47866cab8$export$66f25c06ac11131c = (value)=>{
    if (value === "-4") return 0, $d60257e8dc27bf16$export$1cc98074061c90d2;
    if (value === "-2") return 0, $d60257e8dc27bf16$export$7d6712c2cb8377b2;
    if (value === "0") return 0, $d60257e8dc27bf16$export$153ab95c08227093;
    return 0, $d60257e8dc27bf16$export$be9a3074cb3ae0c7;
};
const $31eefeb47866cab8$var$branchesArray = [
    (0, $6d218ab9b83faef2$export$e12a4cadfc09074e),
    (0, $6d218ab9b83faef2$export$addbd3a73cd831b8),
    (0, $6d218ab9b83faef2$export$2fdde2b3b0357dd1),
    (0, $6d218ab9b83faef2$export$b5f0f72f5619891f)
];
const $31eefeb47866cab8$var$allowedBranches = {
    branches: [],
    checkBranches (branch) {
        if (this.branches.includes(branch) || branch > 0 && this.branches.includes((0, $6d218ab9b83faef2$export$b5f0f72f5619891f))) return true;
        return false;
    }
};
const $31eefeb47866cab8$export$5cf5ab282a6d1471 = (tree, key = (0, $8ae07190c6a505ba$export$6abaf2f4454ce80f))=>{
    const tempTree = [];
    tree.forEach((branch)=>{
        if (!branch[key] || branch[key] !== "0") tempTree.push({
            ...branch,
            children: (branch?.children && branch.children.length) > 0 ? $31eefeb47866cab8$export$5cf5ab282a6d1471(branch.children, key) : []
        });
        else if (branch?.children && branch.children.length > 0) tempTree.push(...$31eefeb47866cab8$export$5cf5ab282a6d1471(branch.children, key));
    });
    return tempTree;
};
const $31eefeb47866cab8$export$766f742d23cf4e66 = (results, updatedBranches = $31eefeb47866cab8$var$branchesArray, level = 0)=>{
    $31eefeb47866cab8$var$allowedBranches.branches = updatedBranches;
    const tempTree = [];
    results.forEach((obj)=>{
        if ($31eefeb47866cab8$var$allowedBranches.checkBranches(obj?.CERT_ENTITLEMENT_VALUEKEY)) {
            const temp = {
                ...obj,
                children: (obj?.children && obj.children.length) > 0 ? $31eefeb47866cab8$export$766f742d23cf4e66(obj.children, $31eefeb47866cab8$var$allowedBranches.branches, level + 1) : []
            };
            tempTree.push(temp);
        } else if (obj?.children && obj.children.length > 0) tempTree.push(...$31eefeb47866cab8$export$766f742d23cf4e66(obj.children, $31eefeb47866cab8$var$allowedBranches.branches));
    });
    return tempTree;
};
const $31eefeb47866cab8$export$180ffcd95abfdd08 = (columnPickerList)=>{
    let concatenatedString = "";
    for(const key in columnPickerList){
        const values = Object.keys(columnPickerList[key]);
        concatenatedString += `${values?.join(",")},`;
    }
    concatenatedString = concatenatedString?.slice(0, -1);
    return concatenatedString;
};
function $31eefeb47866cab8$var$mergeChildren(existingRecord, newChildren) {
    if (!existingRecord.children) existingRecord.children = [];
    if (!Array.isArray(newChildren)) newChildren = [];
    const existingChildrenMap = new Map(existingRecord.children.map((child)=>[
            child.CERT_ENTITLEMENT_VALUEKEY || child.CERT_ACCOUNTKEY || child.CERT_ROLEKEY,
            child
        ]));
    for (const child of newChildren){
        const childKey = child.CERT_ENTITLEMENT_VALUEKEY || child.CERT_ACCOUNTKEY || child.CERT_ROLEKEY;
        if (existingChildrenMap.has(childKey)) $31eefeb47866cab8$var$mergeChildren(existingChildrenMap.get(childKey), child.children || []);
        else existingRecord.children.push({
            ...child
        });
    }
}
function $31eefeb47866cab8$var$mergeRecords(records, mergedJson) {
    for (const record of records){
        const key = record.CERT_USERKEY || record.CERT_ACCOUNTKEY || record.CERT_ROLEKEY || record.CERT_ENTITLEMENT_VALUEKEY;
        if (!mergedJson[key]) mergedJson[key] = {
            ...record
        };
        else $31eefeb47866cab8$var$mergeChildren(mergedJson[key], record.children);
    }
}
const $31eefeb47866cab8$export$efe17290047eb682 = (input1, input2)=>{
    const mergedJson = {};
    // Merge input1 into mergedJson
    $31eefeb47866cab8$var$mergeRecords(input1, mergedJson);
    // Merge input2 into mergedJson
    $31eefeb47866cab8$var$mergeRecords(input2, mergedJson);
    return Object.values(mergedJson);
};



function $9dc2b5e278a56721$var$CertsDetailsList({ areControlsVisible: areControlsVisible, isMoreDataAvailable: isMoreDataAvailable, setIsMoreDataAvailable: setIsMoreDataAvailable, showFilterBar: showFilterBar, detailsListRef: detailsListRef }) {
    // Data
    const [listApiCallCount, setListApiCallCount] = (0, $hopDi$useState)(1);
    const [currentOffset, setCurrentOffset] = (0, $hopDi$useState)(0);
    const [sidePanelData, setSidePanelData] = (0, $hopDi$useState)(null);
    const [sidePanelNodeData, setSidePanelNodeData] = (0, $hopDi$useState)(null);
    // List Arrays
    const [mergedLists, setMergedLists] = (0, $hopDi$useState)([]);
    const [mergedListsAfterRowFilter, setMergedListsAfterRowFilter] = (0, $hopDi$useState)([]);
    const [prevActiveTab, setPrevActiveTab] = (0, $hopDi$useState)(null);
    const observerTarget = (0, $hopDi$useRef)(null);
    const dispatch = (0, $hopDi$useDispatch)();
    const { advancedFilters: advancedFilters, certDetailsLists: certDetailsLists, certKey: certKey, tabs: tabs, totalItems: totalItems, searchText: searchText, isSidePanelVisible: isSidePanelVisible, isTriggeredFromSearchOrFilter: isTriggeredFromSearchOrFilter, isLoading: isLoading, isError: isError, rowsFilters: rowsFilters, columnNames: columnNames, columnPickerList: columnPickerList, shouldShowReviewAndSubmitButton: shouldShowReviewAndSubmitButton, isViewApiError: isViewApiError, dynamicSortFilter: dynamicSortFilter, action: { isActionSuccess: isActionSuccess } } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const { showBulkSelectCheckBox: showBulkSelectCheckBox, isChecked: isBulkSelectChecked, actionBySelectAll: bulkActionBySelectAll, isIndeterminate: isBulkCheckSelectIndeterminate } = (0, $hopDi$useSelector)((state)=>state?.certifications?.bulkAction);
    const { tabData: tabData } = tabs;
    const activeTab = tabData.find((tab)=>tab.isActive);
    const hasActiveTabDetails = activeTab?.count > 0;
    const { sortDirection: sortDirection, sortByColumn: sortByColumn } = dynamicSortFilter;
    // States with Redux dependencies
    const [certsResults, setCertsResults] = (0, $hopDi$useState)(certDetailsLists);
    const detailsListClasses = (0, $hopDi$classnames)("CertsDetailsList", areControlsVisible && "CertsDetailsList--areControlsVisible", showFilterBar && "CertsDetailsList--showFilterBar", isLoading && "CertsDetailsList--isLoading", isMoreDataAvailable && "CertsDetailsList--isMoreDataAvailable");
    const isAnyError = Boolean(isError || isViewApiError);
    const hasNoCertsResultsToDisplay = Boolean(certsResults && !certsResults?.length);
    const hasNoAdvancedFiltersResults = Boolean(advancedFilters?.length > 0);
    const hasNoSearchResults = Boolean(searchText?.trim().length > 0);
    // TODO: Need to check if this needs to be configured
    const maximumResults = 10;
    // Tell the controls handler that the absolute bottom is attainable
    (0, $hopDi$useEffect)(()=>{
        if (listApiCallCount > 0 && currentOffset > totalItems) return setIsMoreDataAvailable(false);
        return setIsMoreDataAvailable(true);
    }, [
        listApiCallCount,
        currentOffset,
        totalItems
    ]);
    // TODO: Need to check the data here
    const formatSidePanelData = (nodeData)=>({
            type: (0, $31eefeb47866cab8$export$66f25c06ac11131c)(nodeData[0, $d60257e8dc27bf16$export$994f7af6d0b36256]),
            ...nodeData
        });
    const handleSidePanel = (0, $hopDi$useCallback)((nodeData)=>{
        dispatch((0, $d623f23401a154f0$export$ebe6b5ce6ed9ef39)(true));
        const formattedSidePanelData = formatSidePanelData(nodeData);
        setSidePanelData(formattedSidePanelData);
    });
    const findConnectedNode = (node)=>{
        if (node?.tracker?.isConnected) return node;
        return node?.children?.reduce((acc, child)=>acc || findConnectedNode(child), null);
    };
    (0, $hopDi$useEffect)(()=>{
        let connectedNode = null;
        const nodes = Array.isArray(mergedListsAfterRowFilter) ? mergedListsAfterRowFilter : [
            mergedListsAfterRowFilter
        ];
        nodes.some((node)=>{
            connectedNode = findConnectedNode(node);
            return !!connectedNode;
        });
        if (connectedNode) setSidePanelNodeData(connectedNode);
    }, [
        mergedListsAfterRowFilter
    ]);
    const findNextNode = (nodes, currentNodeId, jumpToSameLevel)=>{
        const flattenedList = (0, $e7628c995f405891$export$8824054d4a42eac8)(nodes);
        const currentNodeIndex = flattenedList.findIndex((node)=>node?.tracker?.id === currentNodeId);
        if (currentNodeIndex === -1) return null;
        if (currentNodeIndex === flattenedList.length - 1) return null;
        for(let i = currentNodeIndex + 1; i < flattenedList.length; i += 1){
            if (jumpToSameLevel) {
                if (flattenedList[currentNodeIndex]?.tracker?.level >= flattenedList[i]?.tracker?.level) return flattenedList[i];
            } else return flattenedList[i];
        }
        return null;
    };
    const updateIsConnected = (prev, nodeToUpdateId)=>{
        const data = prev.map((node)=>{
            if (node.tracker.id === nodeToUpdateId) return {
                ...node,
                tracker: {
                    ...node.tracker,
                    isConnected: true
                },
                children: node?.children?.length > 0 ? updateIsConnected(node?.children, nodeToUpdateId) : []
            };
            return {
                ...node,
                tracker: {
                    ...node.tracker,
                    isConnected: false
                },
                children: node?.children?.length > 0 ? updateIsConnected(node?.children, nodeToUpdateId) : []
            };
        });
        return data;
    };
    const handleSidePanelAction = (0, $hopDi$useCallback)((jumpToSameLevel)=>{
        if (isSidePanelVisible && sidePanelNodeData?.tracker?.id) {
            const nodes = Array.isArray(mergedListsAfterRowFilter) ? mergedListsAfterRowFilter : [
                mergedListsAfterRowFilter
            ];
            const currentNodeId = sidePanelNodeData?.tracker?.id;
            const nextNode = findNextNode(nodes, currentNodeId, jumpToSameLevel);
            if (nextNode) {
                // Format and update side panel data if different
                const formattedSidePanelData = formatSidePanelData(nextNode);
                if (sidePanelNodeData?.tracker?.id !== formattedSidePanelData?.tracker?.id) setSidePanelData(formattedSidePanelData);
                if (sidePanelNodeData?.tracker?.id !== formattedSidePanelData?.tracker?.id) setMergedLists((prev)=>updateIsConnected(prev, formattedSidePanelData?.tracker?.id));
                return;
            }
            dispatch((0, $d623f23401a154f0$export$ebe6b5ce6ed9ef39)(false));
        }
    });
    const mergeResponsesUI = (r1, r2)=>{
        const mergedResponse = isTriggeredFromSearchOrFilter ? (0, $31eefeb47866cab8$export$efe17290047eb682)([], r2) : (0, $31eefeb47866cab8$export$efe17290047eb682)(r1, r2);
        const responseAfterTrackerObj = (0, $31eefeb47866cab8$export$89bc22408028ff3d)(mergedResponse, {
            isChecked: isBulkSelectChecked || isBulkSelectChecked && isBulkCheckSelectIndeterminate
        });
        const responseAfterActionStatus = (0, $31eefeb47866cab8$export$711a902d2e3a009f)(responseAfterTrackerObj);
        setMergedLists(responseAfterActionStatus);
    };
    (0, $hopDi$useEffect)(()=>{
        setListApiCallCount(Math.ceil(totalItems / maximumResults));
    }, [
        totalItems,
        dispatch,
        activeTab.key
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (columnPickerList) {
            const columnNamesToShow = (0, $31eefeb47866cab8$export$180ffcd95abfdd08)(columnPickerList);
            dispatch((0, $d623f23401a154f0$export$44dea541cc9e89ed)(columnNamesToShow));
        }
    }, [
        columnPickerList,
        dispatch
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (certKey) {
            if (columnNames && typeof columnNames === "string") {
                dispatch((0, $d623f23401a154f0$export$a7b1b02371ce779a)(false));
                dispatch((0, $d623f23401a154f0$export$fad033acbe739b9c)(certKey, columnNames, maximumResults, currentOffset, searchText));
                setCurrentOffset((prevOffset)=>prevOffset + maximumResults);
                setListApiCallCount((prev)=>prev - 1);
            }
        }
    }, [
        certKey,
        columnNames,
        dispatch
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (isTriggeredFromSearchOrFilter && isLoading) {
            setCurrentOffset(maximumResults); // Already started from zero in search
            setMergedLists([]);
        }
    }, [
        isTriggeredFromSearchOrFilter,
        isLoading
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (activeTab.key !== prevActiveTab) {
            setCurrentOffset(0);
            setMergedLists([]);
        }
        setPrevActiveTab(activeTab.key);
        // Get the items API response for the current active tab
        if (certKey && columnNames && typeof columnNames === "string") {
            setCurrentOffset(maximumResults);
            dispatch((0, $d623f23401a154f0$export$fad033acbe739b9c)(certKey, columnNames, maximumResults, 0, searchText));
        }
    }, [
        activeTab?.key
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (certDetailsLists) {
            setCertsResults(certDetailsLists);
            mergeResponsesUI(mergedLists, certDetailsLists);
        }
    }, [
        certDetailsLists
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (sortByColumn && sortDirection) {
            dispatch((0, $d623f23401a154f0$export$a7b1b02371ce779a)(true));
            setListApiCallCount(Math.ceil(totalItems / maximumResults));
            dispatch((0, $d623f23401a154f0$export$fad033acbe739b9c)(certKey, columnNames, maximumResults, 0, searchText));
        }
    }, [
        sortByColumn,
        sortDirection
    ]);
    (0, $hopDi$useEffect)(()=>{
        setMergedListsAfterRowFilter((0, $31eefeb47866cab8$export$766f742d23cf4e66)((0, $31eefeb47866cab8$export$5cf5ab282a6d1471)(mergedLists), rowsFilters));
    }, [
        mergedLists,
        rowsFilters,
        dispatch
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (certKey && isActionSuccess) {
            if ((0, $20281fe09bc700a8$export$3f43cf8434698562).DOES_NOT_WORK_FOR_ME || (0, $20281fe09bc700a8$export$3f43cf8434698562).REASSIGN) dispatch((0, $d623f23401a154f0$export$afd1b438af1720fe)(certKey, true)); // only for Reassign action
            else dispatch((0, $d623f23401a154f0$export$afd1b438af1720fe)(certKey));
            dispatch((0, $d623f23401a154f0$export$6e5b0daaf8d927e4)(certKey, (0, $bf14b63763e2d183$export$4767a28fbd1026ef), true));
        }
    }, [
        isActionSuccess
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (isLoading) return;
        if (hasActiveTabDetails) {
            const observer = new IntersectionObserver((entries)=>{
                if (entries[0].isIntersecting) // console.log('API count', listApiCallCount, 'Offset', currentOffset);
                {
                    if (listApiCallCount > 0 && currentOffset < totalItems) {
                        dispatch((0, $d623f23401a154f0$export$a7b1b02371ce779a)(false));
                        if (currentOffset !== 0) dispatch((0, $d623f23401a154f0$export$fad033acbe739b9c)(certKey, columnNames, maximumResults, currentOffset, searchText));
                        setCurrentOffset((prevOffset)=>prevOffset + maximumResults);
                        setListApiCallCount((prev)=>prev - 1);
                    }
                }
            }, {
                threshold: 1
            });
            if (observerTarget.current) observer.observe(observerTarget.current);
            // eslint-disable-next-line consistent-return
            return ()=>{
                if (observerTarget.current) observer.unobserve(observerTarget.current);
            };
        }
    }, [
        observerTarget,
        isLoading,
        dispatch
    ]);
    const handleBulkActionCheck = (0, $hopDi$useCallback)((prev, flag)=>prev.map((item)=>({
                ...item,
                tracker: {
                    ...item.tracker,
                    isChecked: flag,
                    isIndeterminate: false
                },
                children: item?.children?.length > 0 ? handleBulkActionCheck(item.children, flag) : []
            })), []);
    (0, $hopDi$useEffect)(()=>{
        if (showBulkSelectCheckBox && !isBulkCheckSelectIndeterminate && bulkActionBySelectAll) {
            setMergedLists((prevMergedLists)=>handleBulkActionCheck(prevMergedLists, isBulkSelectChecked));
            dispatch((0, $d623f23401a154f0$export$1a295a970dce82de)(false));
            if (!isBulkSelectChecked) dispatch((0, $d623f23401a154f0$export$bb9465329a3d3cad)(null));
        }
    }, [
        isBulkSelectChecked,
        isBulkCheckSelectIndeterminate
    ]);
    (0, $hopDi$useEffect)(()=>{
        const flattenedList = (0, $e7628c995f405891$export$8824054d4a42eac8)(mergedLists);
        const listCheckMap = flattenedList.map((node)=>node?.tracker?.isChecked || node?.tracker?.isIndeterminate);
        const itemsCount = listCheckMap.length;
        const areAllItemsChecked = !listCheckMap.some((value)=>!value) && itemsCount > 0 && itemsCount >= activeTab?.count;
        const hasAtleastOneItemChecked = listCheckMap.some((value)=>value) && itemsCount > 0;
        if (itemsCount > 0) {
            const selctedItemsList = flattenedList.map((node)=>({
                    id: node?.tracker?.id,
                    isChecked: node?.tracker?.isChecked,
                    isIndeterminate: node?.tracker?.isIndeterminate,
                    level: node?.tracker?.level,
                    type: (0, $31eefeb47866cab8$export$66f25c06ac11131c)(node[0, $d60257e8dc27bf16$export$994f7af6d0b36256])
                })).filter((item)=>item?.isChecked || item?.isIndeterminate);
            dispatch((0, $d623f23401a154f0$export$3078bd98bc0c9194)(selctedItemsList));
        }
        if (!areAllItemsChecked && hasAtleastOneItemChecked && !isBulkSelectChecked) {
            dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(false));
            dispatch((0, $d623f23401a154f0$export$889241fc0afda8a9)(true));
            dispatch((0, $d623f23401a154f0$export$ebeb2bd8ecd91be9)(true));
            return;
        }
        if (!areAllItemsChecked && hasAtleastOneItemChecked && isBulkSelectChecked) {
            // dispatch(setIndeterminateForBulkAction(true));
            dispatch((0, $d623f23401a154f0$export$ebeb2bd8ecd91be9)(true));
            return;
        }
        if (areAllItemsChecked && hasAtleastOneItemChecked) {
            dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(true));
            dispatch((0, $d623f23401a154f0$export$889241fc0afda8a9)(false));
            dispatch((0, $d623f23401a154f0$export$ebeb2bd8ecd91be9)(false));
            return;
        }
        // if (!areAllItemsChecked && hasAtleastOneItemChecked) {
        //   dispatch(setCheckForBulkAction(false));
        //   dispatch(setAlteastOneIsSelected(true));
        // } else {
        //   dispatch(setAlteastOneIsSelected(false));
        // }
        // if (areAllItemsChecked && isBulkSelectChecked) {
        //   dispatch(setIndeterminateForBulkAction(false));
        //   return;
        // }
        // if (areAllItemsChecked && !isBulkSelectChecked) {
        //   dispatch(setCheckForBulkAction(true));
        //   dispatch(setIndeterminateForBulkAction(false));
        // }
        // if (hasAtleastOneItemChecked) {
        //   dispatch(setIndeterminateForBulkAction(true));
        //   return;
        // }
        dispatch((0, $d623f23401a154f0$export$2af49e179df91659)(false));
        dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(false));
        dispatch((0, $d623f23401a154f0$export$ebeb2bd8ecd91be9)(false));
        dispatch((0, $d623f23401a154f0$export$889241fc0afda8a9)(false));
    }, [
        mergedLists
    ]);
    const renderNoDataView = ({ title: title, body: body, buttonText: buttonText, buttonAction: buttonAction, isReadyToSubmit: isReadyToSubmit })=>{
        const getEmptyButton = ()=>{
            if (buttonText && buttonAction) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                type: "button",
                kind: "filled",
                size: "large",
                onClick: buttonAction,
                children: buttonText
            });
            if (isReadyToSubmit) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $eb340908ccb18f38$export$2e2bcd8739ae039), {
                buttonSize: "large"
            });
            return null;
        };
        return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            tag: "section",
            className: "CertificationDetails-emptyCenter",
            children: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                tag: "div",
                className: "CertificationDetails-emptyOrError",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "h1",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body2",
                        children: body
                    }),
                    getEmptyButton()
                ]
            })
        });
    };
    const getNoDataContent = ()=>{
        const isZeroToDoItems = !hasActiveTabDetails && activeTab.key === (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49);
        const isZeroDoneItems = !hasActiveTabDetails && activeTab.key === (0, $d44c789d5b60f9bf$export$807a0bc890800408);
        const isZeroConsultedItems = !hasActiveTabDetails && activeTab.key === (0, $d44c789d5b60f9bf$export$b2766b46106d3053);
        if (!isLoading && hasNoSearchResults && hasNoCertsResultsToDisplay) return renderNoDataView({
            title: "No Records Match Your Search",
            body: "If you can't see your items, try clearing your search or selecting a different view.",
            buttonText: "Clear Search",
            buttonAction: ()=>dispatch((0, $d623f23401a154f0$export$661e1772dd5a4141)(true)),
            isReadyToSubmit: false
        });
        if (!isLoading && hasNoAdvancedFiltersResults && hasNoCertsResultsToDisplay) {
            const filterTypeText = activeTab?.key === (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49) ? `To see your (${activeTab?.count}) remaining to-do items, make sure to clear the filters you applied.` : "If you can't see your items, try clearing your filters or selecting a different view.";
            return renderNoDataView({
                title: "Need to Clear Your Filters?",
                body: filterTypeText,
                buttonText: "Clear Filters",
                buttonAction: ()=>dispatch((0, $d623f23401a154f0$export$86d11b633a5d59e6)(true)),
                isReadyToSubmit: false
            });
        }
        if (!isLoading && isZeroToDoItems && shouldShowReviewAndSubmitButton) return renderNoDataView({
            title: "Your Certification Is Ready to Be Submitted",
            body: "Now that you've completed your certification, you can review a summary of the items you're certifying and submit your certification review.",
            buttonText: "",
            buttonAction: ()=>{},
            isReadyToSubmit: true
        });
        const makeTodoTabActive = tabData.map((tab)=>({
                ...tab,
                isActive: tab.key === (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49),
                isHighlighted: false
            }));
        if (!isLoading && isZeroDoneItems) return renderNoDataView({
            title: "No Items Certified Yet",
            body: "Once you start approving or rejecting items in your to-do list, they'll get placed here for you to review as you complete your certification. ",
            buttonText: "View To-Do List",
            buttonAction: ()=>dispatch((0, $d623f23401a154f0$export$e9c5cd8aea0cabc7)(makeTodoTabActive)),
            isReadyToSubmit: false
        });
        if (!isLoading && isZeroConsultedItems) return renderNoDataView({
            title: "No Items Moved To Consult Yet",
            body: "Once you start consulting items from your to-do list, they'll get placed here.",
            buttonText: "View To-Do List",
            buttonAction: ()=>dispatch((0, $d623f23401a154f0$export$e9c5cd8aea0cabc7)(makeTodoTabActive)),
            isReadyToSubmit: false
        });
        const makeAllTabActive = tabData.map((tab)=>({
                ...tab,
                isActive: tab.key === (0, $d44c789d5b60f9bf$export$d5eea126dff5a615),
                isHighlighted: false
            }));
        if (!isLoading && hasNoCertsResultsToDisplay) return renderNoDataView({
            title: "No Items Are Available To Show",
            body: "You do not have any items here. Go to All tab to view your items",
            buttonText: "View All List",
            buttonAction: ()=>dispatch((0, $d623f23401a154f0$export$e9c5cd8aea0cabc7)(makeAllTabActive)),
            isReadyToSubmit: false
        });
        return null;
    };
    if (isAnyError) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $87d4d732106452cd$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $hopDi$jsxs)("section", {
        id: "certsDetailsList",
        ref: detailsListRef,
        className: detailsListClasses,
        "data-testid": "cert-details",
        children: [
            getNoDataContent() || /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $691dbffebbf06698$export$2e2bcd8739ae039), {
                        data: mergedListsAfterRowFilter,
                        handleSidePanel: handleSidePanel,
                        isSidePanelOpen: isSidePanelVisible,
                        setMergedLists: setMergedLists
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $2b016bbacf604946$export$2e2bcd8739ae039), {}),
                    isSidePanelVisible && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                        tag: "aside",
                        className: "CertsDetailsList-sidePanel",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $37b43aaf389f3f5d$export$2e2bcd8739ae039), {
                            data: sidePanelData,
                            nodeData: sidePanelNodeData,
                            handleSidePanelAction: handleSidePanelAction,
                            isOpen: isSidePanelVisible,
                            setMergedLists: setMergedLists
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "CertsDetailsList-targetLoader",
                ref: observerTarget
            }),
            isLoading && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                tag: "div",
                className: `CertsDetailsList-loader--${isSidePanelVisible ? "sidePanelOpen" : "sidePanelClose"}`,
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                    kind: "loop",
                    format: "main",
                    color: "brand",
                    size: "large"
                })
            })
        ]
    });
}
$9dc2b5e278a56721$var$CertsDetailsList.propTypes = {
    areControlsVisible: (0, $hopDi$proptypes).bool.isRequired,
    isMoreDataAvailable: (0, $hopDi$proptypes).bool.isRequired,
    setIsMoreDataAvailable: (0, $hopDi$proptypes).func.isRequired,
    showFilterBar: (0, $hopDi$proptypes).bool.isRequired,
    detailsListRef: (0, $hopDi$proptypes).oneOfType([
        (0, $hopDi$proptypes).func,
        (0, $hopDi$proptypes).shape({
            current: (0, $hopDi$proptypes).instanceOf(Element)
        })
    ])
};
$9dc2b5e278a56721$var$CertsDetailsList.defaultProps = {
    detailsListRef: null
};
var $9dc2b5e278a56721$export$2e2bcd8739ae039 = $9dc2b5e278a56721$var$CertsDetailsList;


var $deb4d0ab4728ac1f$export$2e2bcd8739ae039 = (0, $9dc2b5e278a56721$export$2e2bcd8739ae039);


/* eslint-disable react/jsx-curly-spacing */ /* eslint-disable react/jsx-wrap-multilines */ 




/* eslint-disable no-restricted-syntax */ 













const $2bab42430c1fd2c9$export$57bdf52a09da8758 = {
    isOpen: (0, $hopDi$proptypes).bool.isRequired,
    showAlert: (0, $hopDi$proptypes).bool.isRequired,
    isSubmitting: (0, $hopDi$proptypes).bool.isRequired
};
const $2bab42430c1fd2c9$export$c7da98b22a0bd20d = {
    isOpen: (0, $hopDi$proptypes).bool.isRequired,
    showAlert: (0, $hopDi$proptypes).bool.isRequired,
    isSubmitting: (0, $hopDi$proptypes).bool.isRequired
};
const $2bab42430c1fd2c9$export$cd90448fa71b3fdb = {
    isOpen: (0, $hopDi$proptypes).bool.isRequired,
    showAlert: (0, $hopDi$proptypes).bool.isRequired,
    isSubmitting: (0, $hopDi$proptypes).bool.isRequired
};








function $cf387d9c2b519a60$var$BulkActionApproveBody({ bulkActionApprove: bulkActionApprove, setBulkActionApprove: setBulkActionApprove }) {
    const handleCommentDescription = (text)=>{
        setBulkActionApprove((prev)=>({
                ...prev,
                comment: text
            }));
    };
    const handleChange = ()=>{
        setBulkActionApprove((prev)=>({
                ...prev,
                isChecked: !prev.isChecked
            }));
    };
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "BulkActionApproveBody",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $2515ed647c64b6ee$export$2e2bcd8739ae039), {
                showAlert: bulkActionApprove?.showAlert && bulkActionApprove?.comment?.length === 0,
                onChange: handleCommentDescription,
                clearModal: bulkActionApprove?.isOpen
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "BulkActionApproveBody-checkBox",
                children: [
                    !bulkActionApprove?.isChecked && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "label",
                        className: `BulkActionApproveBody-checkBoxWarning ${bulkActionApprove?.showAlert ? "showAlert" : ""}`,
                        children: "*"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                        name: "checkbox0",
                        kind: "text",
                        dataTestId: "checkbox0",
                        isChecked: bulkActionApprove?.isChecked,
                        onChange: handleChange,
                        label: "I confirm I have reviewed all items",
                        textPosition: "after",
                        error: bulkActionApprove?.showAlert && !bulkActionApprove?.isChecked ? "This required field is incomplete" : ""
                    })
                ]
            })
        ]
    });
}
$cf387d9c2b519a60$var$BulkActionApproveBody.propTypes = {
    bulkActionApprove: (0, $hopDi$proptypes).shape((0, $2bab42430c1fd2c9$export$57bdf52a09da8758)).isRequired,
    setBulkActionApprove: (0, $hopDi$proptypes).func.isRequired
};
var $cf387d9c2b519a60$export$2e2bcd8739ae039 = $cf387d9c2b519a60$var$BulkActionApproveBody;







function $a56aba925750f6ca$var$BulkActionApproveFooter({ handleApprove: handleApprove, bulkActionApprove: bulkActionApprove, handleCloseBulkActionApprove: handleCloseBulkActionApprove, handleCloseBukActionApproveAlert: handleCloseBukActionApproveAlert }) {
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$FooterActionBar), {
        size: "large",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {}),
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "BulkActionApproveFooter-footerButtonWrap",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$AlertBanner), {
                        colorTheme: "Critical",
                        title: "Required fields are missing.",
                        description: "",
                        isVisible: bulkActionApprove?.showAlert && !bulkActionApprove?.isSubmitting,
                        isColonVisible: false,
                        isFloating: true,
                        position: {
                            type: "fixed",
                            top: "5.25rem",
                            left: "4rem"
                        },
                        onCancel: handleCloseBukActionApproveAlert
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        type: "button",
                        kind: "ghost",
                        size: "medium",
                        isDisabled: bulkActionApprove?.isSubmitting,
                        onClick: handleCloseBulkActionApprove,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        type: "button",
                        kind: bulkActionApprove?.isSubmitting ? "filled" : "outlined",
                        size: "medium",
                        onClick: ()=>handleApprove(bulkActionApprove?.id, bulkActionApprove?.status, bulkActionApprove?.comment),
                        isDisabled: bulkActionApprove?.isSubmitting,
                        rightIcon: bulkActionApprove?.isSubmitting ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                            kind: "loop",
                            format: "inline",
                            color: "brand",
                            size: "small"
                        }) : null,
                        children: "Approve All"
                    })
                ]
            })
        ]
    });
}
$a56aba925750f6ca$var$BulkActionApproveFooter.propTypes = {
    handleApprove: (0, $hopDi$proptypes).func.isRequired,
    bulkActionApprove: (0, $hopDi$proptypes).shape((0, $2bab42430c1fd2c9$export$57bdf52a09da8758)).isRequired,
    handleCloseBulkActionApprove: (0, $hopDi$proptypes).func.isRequired,
    handleCloseBukActionApproveAlert: (0, $hopDi$proptypes).func.isRequired
};
var $a56aba925750f6ca$export$2e2bcd8739ae039 = $a56aba925750f6ca$var$BulkActionApproveFooter;







const $f16755d1eb7f7f9c$export$273a483dd6b0bbbb = 1;
const $f16755d1eb7f7f9c$export$ae0d84fe956e4aa8 = (0, $d60257e8dc27bf16$export$1cc98074061c90d2);
const $f16755d1eb7f7f9c$export$6700f379dccd757a = (0, $d60257e8dc27bf16$export$7d6712c2cb8377b2);
const $f16755d1eb7f7f9c$export$9abc031b049cea07 = (0, $d60257e8dc27bf16$export$153ab95c08227093);
const $f16755d1eb7f7f9c$export$1cffb1b4d08ae4c4 = (0, $d60257e8dc27bf16$export$be9a3074cb3ae0c7);
const $f16755d1eb7f7f9c$export$d15bf6606d7c003f = "totalUsers";
const $f16755d1eb7f7f9c$export$44168e727381e009 = "totalRoles";
const $f16755d1eb7f7f9c$export$9e96d322d23986ea = "totalAccounts";
const $f16755d1eb7f7f9c$export$f543b652b7d38cdc = "totalEntitlements";
const $f16755d1eb7f7f9c$export$b09b44dc4d37afd9 = "totalSelectedItems";
const $f16755d1eb7f7f9c$export$50919f38e67a3d45 = {
    // COMPLETED
    CLEAR: {
        id: "bulkActionClearBtn",
        icon: "clear",
        status: "-1",
        objectsToTotal: []
    },
    // COMPLETED
    WORKS_FOR_ME: {
        id: "worksForMe",
        icon: "confirmManager",
        status: "2",
        objectsToTotal: [
            $f16755d1eb7f7f9c$export$d15bf6606d7c003f
        ]
    },
    DOES_NOT_WORK_FOR_ME: {
        id: "doesNotWorksForMe",
        icon: "reassignUser",
        status: "-1",
        objectsToTotal: [
            $f16755d1eb7f7f9c$export$d15bf6606d7c003f
        ]
    },
    // COMPLETED
    TERMINATE: {
        id: "terminated",
        icon: "terminate",
        status: "4",
        objectsToTotal: [
            $f16755d1eb7f7f9c$export$d15bf6606d7c003f
        ]
    },
    EXTEND_END_DATE: {
        id: "extendEndDate",
        icon: "ExtendEndDate",
        status: "-1",
        objectsToTotal: [
            $f16755d1eb7f7f9c$export$d15bf6606d7c003f
        ]
    },
    // COMPLETED
    APPROVE: {
        id: "approve",
        icon: "Check",
        status: "2",
        objectsToTotal: [
            $f16755d1eb7f7f9c$export$44168e727381e009,
            $f16755d1eb7f7f9c$export$9e96d322d23986ea,
            $f16755d1eb7f7f9c$export$f543b652b7d38cdc
        ]
    },
    // WORKING
    REJECT: {
        id: "reject",
        icon: "reject",
        status: "3",
        objectsToTotal: [
            $f16755d1eb7f7f9c$export$44168e727381e009,
            $f16755d1eb7f7f9c$export$9e96d322d23986ea,
            $f16755d1eb7f7f9c$export$f543b652b7d38cdc
        ]
    },
    CONDITIONAL_CERTIFIY: {
        id: "conditionalCertifiy",
        icon: "ExtendEndDate",
        status: "-1",
        objectsToTotal: [
            $f16755d1eb7f7f9c$export$44168e727381e009,
            $f16755d1eb7f7f9c$export$9e96d322d23986ea,
            $f16755d1eb7f7f9c$export$f543b652b7d38cdc
        ]
    },
    REASSIGN: {
        id: "reassign",
        icon: "reassignItem",
        status: "-1",
        objectsToTotal: [
            $f16755d1eb7f7f9c$export$44168e727381e009,
            $f16755d1eb7f7f9c$export$9e96d322d23986ea,
            $f16755d1eb7f7f9c$export$f543b652b7d38cdc
        ]
    },
    CONSULT: {
        id: "consult",
        icon: "Consult",
        status: "-1",
        objectsToTotal: [
            $f16755d1eb7f7f9c$export$d15bf6606d7c003f,
            $f16755d1eb7f7f9c$export$44168e727381e009,
            $f16755d1eb7f7f9c$export$9e96d322d23986ea,
            $f16755d1eb7f7f9c$export$f543b652b7d38cdc
        ]
    }
};
const $f16755d1eb7f7f9c$export$c4642c4b1af79efe = {
    worksForMe: "WORKS_FOR_ME",
    doesNotWorksForMe: "DOES_NOT_WORK_FOR_ME",
    terminated: "TERMINATE",
    extendEndDate: "EXTEND_END_DATE",
    approve: "APPROVE",
    reject: "REJECT",
    conditionalCertifiy: "CONDITIONAL_CERTIFIY",
    reassign: "REASSIGN",
    consult: "CONSULT"
};
const $f16755d1eb7f7f9c$export$c9eee0952850eb88 = {
    [$f16755d1eb7f7f9c$export$d15bf6606d7c003f]: "User",
    [$f16755d1eb7f7f9c$export$9e96d322d23986ea]: "Account",
    [$f16755d1eb7f7f9c$export$44168e727381e009]: "Role",
    [$f16755d1eb7f7f9c$export$f543b652b7d38cdc]: "Entitlement"
};




const $1e03c8deb9a1b92e$export$5c47774a6a5c72df = {
    worksForMe: "User",
    approve: "Item",
    getPrefix (key, count) {
        return `Approve ${count} ${this?.[key]}${count > 1 ? "s" : ""}?`;
    }
};
var $1e03c8deb9a1b92e$export$2e2bcd8739ae039 = $1e03c8deb9a1b92e$export$5c47774a6a5c72df;


function $aa030873af17fbf8$var$BulkActionApproveHeader({ id: id, bulkFooterStats: bulkFooterStats }) {
    const buttonKey = (0, $f16755d1eb7f7f9c$export$c4642c4b1af79efe)?.[id];
    const buttonObjectsForTotal = (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45)?.[buttonKey]?.objectsToTotal;
    const headerCount = buttonObjectsForTotal?.reduce((total, item)=>{
        if (bulkFooterStats[item]) return total + bulkFooterStats[item];
        return total;
    }, 0);
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "BulkActionApproveHeader",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "BulkActionApproveHeader-icon",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "AlertWarningFilledSeparateColors",
                    size: "large"
                })
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                kind: "h1",
                className: "BulkActionApproveHeader-title",
                children: (0, $1e03c8deb9a1b92e$export$5c47774a6a5c72df).getPrefix(id, headerCount)
            })
        ]
    });
}
$aa030873af17fbf8$var$BulkActionApproveHeader.propTypes = {
    id: (0, $hopDi$proptypes).string.isRequired,
    bulkFooterStats: (0, $hopDi$proptypes).shape({})
};
$aa030873af17fbf8$var$BulkActionApproveHeader.defaultProps = {
    bulkFooterStats: {}
};
var $aa030873af17fbf8$export$2e2bcd8739ae039 = $aa030873af17fbf8$var$BulkActionApproveHeader;




function $bf7e021a47dfa2f9$var$BulkActionApproveSubTitle({ id: id, bulkFooterStats: bulkFooterStats }) {
    const buttonKey = (0, $f16755d1eb7f7f9c$export$c4642c4b1af79efe)?.[id];
    const buttonObjectsForTotal = (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45)?.[buttonKey]?.objectsToTotal;
    const tempSubtitleText = buttonObjectsForTotal?.filter((key)=>bulkFooterStats[key] > 0).map((key)=>`${bulkFooterStats[key]} ${(0, $f16755d1eb7f7f9c$export$c9eee0952850eb88)[key]}${bulkFooterStats[key] > 1 ? "s" : ""}`);
    if (!tempSubtitleText) return "";
    if (tempSubtitleText?.length === 0) return "You've selected nothing.";
    if (tempSubtitleText?.length === 1) return `You've selected ${tempSubtitleText[0]}.`;
    const subtitle = tempSubtitleText.slice(0, tempSubtitleText.length - 1).join(", ");
    return `You've selected ${subtitle} and ${tempSubtitleText[tempSubtitleText.length - 1]}.`;
}
$bf7e021a47dfa2f9$var$BulkActionApproveSubTitle.propTypes = {
    id: (0, $hopDi$proptypes).string.isRequired,
    bulkFooterStats: (0, $hopDi$proptypes).shape({})
};
$bf7e021a47dfa2f9$var$BulkActionApproveSubTitle.defaultProps = {
    bulkFooterStats: {}
};
var $bf7e021a47dfa2f9$export$2e2bcd8739ae039 = $bf7e021a47dfa2f9$var$BulkActionApproveSubTitle;



function $3aac0425676c3923$var$BulkActionApprove({ bulkFooterStats: bulkFooterStats, bulkActionApprove: bulkActionApprove, setBulkActionApprove: setBulkActionApprove, handleApprove: handleApprove }) {
    const handleCloseBulkActionApprove = ()=>{
        setBulkActionApprove((prev)=>({
                ...prev,
                isOpen: false,
                isChecked: false,
                comment: ""
            }));
    };
    const handleCloseBukActionApproveAlert = ()=>{
        setBulkActionApprove((prev)=>({
                ...prev,
                showAlert: false
            }));
    };
    const bulkActionApproveModal = (0, $hopDi$classnames)("BulkActionApproveModal");
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
        className: bulkActionApproveModal,
        onClose: handleCloseBulkActionApprove,
        isOpen: bulkActionApprove?.isOpen,
        title: /*#__PURE__*/ (0, $hopDi$jsx)((0, $aa030873af17fbf8$export$2e2bcd8739ae039), {
            id: bulkActionApprove?.id,
            bulkFooterStats: bulkFooterStats
        }),
        subtitle: /*#__PURE__*/ (0, $hopDi$jsx)((0, $bf7e021a47dfa2f9$export$2e2bcd8739ae039), {
            id: bulkActionApprove?.id,
            bulkFooterStats: bulkFooterStats
        }),
        contentBody: /*#__PURE__*/ (0, $hopDi$jsx)((0, $cf387d9c2b519a60$export$2e2bcd8739ae039), {
            bulkActionApprove: bulkActionApprove,
            setBulkActionApprove: setBulkActionApprove
        }),
        FooterActionBarComp: /*#__PURE__*/ (0, $hopDi$jsx)((0, $a56aba925750f6ca$export$2e2bcd8739ae039), {
            handleApprove: handleApprove,
            bulkActionApprove: bulkActionApprove,
            handleCloseBulkActionApprove: handleCloseBulkActionApprove,
            handleCloseBukActionApproveAlert: handleCloseBukActionApproveAlert
        })
    });
}
$3aac0425676c3923$var$BulkActionApprove.propTypes = {
    bulkFooterStats: (0, $hopDi$proptypes).shape({}),
    bulkActionApprove: (0, $hopDi$proptypes).shape((0, $2bab42430c1fd2c9$export$57bdf52a09da8758)).isRequired,
    setBulkActionApprove: (0, $hopDi$proptypes).func.isRequired,
    handleApprove: (0, $hopDi$proptypes).func.isRequired
};
$3aac0425676c3923$var$BulkActionApprove.defaultProps = {
    bulkFooterStats: {}
};
var $3aac0425676c3923$export$2e2bcd8739ae039 = $3aac0425676c3923$var$BulkActionApprove;


var $25d7b062f5a92790$export$2e2bcd8739ae039 = (0, $3aac0425676c3923$export$2e2bcd8739ae039);










function $7d9154fe0d105f8c$var$BulkActionRejectSubTitle() {
    return /*#__PURE__*/ (0, $hopDi$jsx)("span", {
        children: "You've selected to reject a user without first certifying who they report to. Do you want to reassign the users and their associated items, or does the user need to be terminated?"
    });
}
var $7d9154fe0d105f8c$export$2e2bcd8739ae039 = $7d9154fe0d105f8c$var$BulkActionRejectSubTitle;



function $6a18b5a7bd9e1aa3$var$BulkActionReject({ bulkActionReject: // bulkFooterStats,
bulkActionReject, setBulkActionReject: setBulkActionReject, handleTerminate: handleTerminate }) {
    // const { bulkAction } = useSelector((state) => state?.certifications);
    const handleCloseBukActionReject = ()=>{
        setBulkActionReject((prev)=>({
                ...prev,
                isOpen: false,
                isChecked: false,
                comment: ""
            }));
    };
    // const handleCloseBukActionRejectAlert = () => {
    //   setBulkActionReject((prev) => ({
    //     ...prev,
    //     showAlert: false,
    //   }));
    // };
    const bulkActionRejectModal = (0, $hopDi$classnames)("BulkActionRejectModal");
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
        className: bulkActionRejectModal,
        kind: "warning",
        alertTitle: "Reassign or Terminate?",
        alertSubtitle: /*#__PURE__*/ (0, $hopDi$jsx)((0, $7d9154fe0d105f8c$export$2e2bcd8739ae039), {}),
        onClose: handleCloseBukActionReject,
        isOpen: bulkActionReject.isOpen,
        primaryButton: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
            type: "button",
            kind: "outlined",
            size: "medium",
            isEnabled: true,
            onClick: ()=>handleTerminate(bulkActionReject?.id, bulkActionReject?.status, bulkActionReject?.comment),
            children: "Terminate"
        }),
        secondaryButton: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
            type: "button",
            kind: "ghost",
            size: "medium",
            onClick: ()=>handleTerminate(bulkActionReject?.id, bulkActionReject?.status, bulkActionReject?.comment),
            children: "Reassign"
        })
    });
}
$6a18b5a7bd9e1aa3$var$BulkActionReject.propTypes = {
    bulkFooterStats: (0, $hopDi$proptypes).shape({}),
    bulkActionReject: (0, $hopDi$proptypes).shape((0, $2bab42430c1fd2c9$export$c7da98b22a0bd20d)).isRequired,
    setBulkActionReject: (0, $hopDi$proptypes).func.isRequired,
    handleTerminate: (0, $hopDi$proptypes).func.isRequired
};
$6a18b5a7bd9e1aa3$var$BulkActionReject.defaultProps = {
    bulkFooterStats: {}
};
var $6a18b5a7bd9e1aa3$export$2e2bcd8739ae039 = $6a18b5a7bd9e1aa3$var$BulkActionReject;


var $a0d9492c4344f44f$export$2e2bcd8739ae039 = (0, $6a18b5a7bd9e1aa3$export$2e2bcd8739ae039);




function $2c59e15aa57e4ffa$var$BulkActionFooter() {
    const dispatch = (0, $hopDi$useDispatch)();
    const { certKey: certKey, bulkAction: bulkAction } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const [showKebabActionBtns, setShowKebabActionBtns] = (0, $hopDi$useState)(false);
    const [bulkActionBtnsMap, setBulkActionBtnsMap] = (0, $hopDi$useState)([]);
    const [bulkFooterStats, setBulkFooterStats] = (0, $hopDi$useState)({});
    const [countForActionButtonsAsPerScreen, setCountForActionButtonsAsPerScreen] = (0, $hopDi$useState)((0, $f16755d1eb7f7f9c$export$273a483dd6b0bbbb));
    const [bulkActionApprove, setBulkActionApprove] = (0, $hopDi$useState)({
        id: "",
        isOpen: false,
        showAlert: false,
        isSubmitting: false,
        isChecked: false,
        comment: ""
    });
    const [bulkActionReject, setBulkActionReject] = (0, $hopDi$useState)({
        id: "",
        isOpen: false,
        showAlert: false,
        isSubmitting: false,
        isChecked: false,
        comment: ""
    });
    (0, $hopDi$useEffect)(()=>{
        const validBulkActions = new Set([]);
        if (bulkAction?.bulkActionFooterData?.enableAccountEntRoleActionList) bulkAction.bulkActionFooterData.enableAccountEntRoleActionList.forEach((action)=>validBulkActions.add(action));
        if (bulkAction?.bulkActionFooterData?.enableUserActionList) bulkAction.bulkActionFooterData.enableUserActionList.forEach((action)=>validBulkActions.add(action));
        setBulkActionBtnsMap(Array.from(validBulkActions));
        if (bulkAction?.bulkActionFooterData) {
            const tempBulkFooterStats = {};
            for(const key in 0, $f16755d1eb7f7f9c$export$c9eee0952850eb88)if (bulkAction?.bulkActionFooterData[key]) tempBulkFooterStats[key] = bulkAction?.bulkActionFooterData[key];
            setBulkFooterStats(tempBulkFooterStats);
            return;
        }
        // if (bulkAction?.bulkActionFooterData === null) {
        //   const tempBulkFooterStats = {};
        //   for (const key in BULK_ACTION_FOOTER_OBJECTS) {
        //     if (Object.hasOwn(BULK_ACTION_FOOTER_OBJECTS, key)) {
        //       const filteredSelectedItem = bulkAction?.selectedItemsMap?.filter(
        //         (item) =>
        //           item?.isChecked && item?.type === BULK_ACTION_FOOTER_OBJECTS[key]
        //       );
        //       tempBulkFooterStats[key] = filteredSelectedItem?.length;
        //     }
        //   }
        //   setBulkFooterStats(tempBulkFooterStats);
        //   return;
        // }
        // if (bulkAction?.isChecked && !bulkAction?.isIndeterminate) {
        //   const tempBulkFooterStats = {};
        //   for (const key in BULK_ACTION_FOOTER_OBJECTS) {
        //     if (bulkAction?.bulkActionFooterData[key]) {
        //       tempBulkFooterStats[key] = bulkAction?.bulkActionFooterData[key];
        //     }
        //   }
        //   setBulkFooterStats(tempBulkFooterStats);
        //   return;
        // }
        // if (bulkAction?.isChecked && bulkAction?.isIndeterminate) {
        //   const tempBulkFooterStats = {};
        //   for (const key in BULK_ACTION_FOOTER_OBJECTS) {
        //     if (bulkAction?.bulkActionFooterData[key]) {
        //       tempBulkFooterStats[key] = bulkAction?.bulkActionFooterData[key];
        //     }
        //   }
        //   setBulkFooterStats(tempBulkFooterStats);
        //   return;
        // }
        setCountForActionButtonsAsPerScreen(1);
    }, [
        bulkAction
    ]);
    (0, $hopDi$useEffect)(()=>{
        setBulkActionApprove((prev)=>({
                ...prev,
                isSubmitting: bulkAction?.isSubmittingAction
            }));
        setBulkActionReject((prev)=>({
                ...prev,
                isSubmitting: bulkAction?.isSubmittingAction
            }));
    }, [
        bulkAction?.isSubmittingAction
    ]);
    const dropUpWrapperForBulkActionKebab = (0, $hopDi$useRef)("dropUpWrapperForBulkActionKebab");
    (0, $52fa6d0b886d7882$export$2e2bcd8739ae039)(dropUpWrapperForBulkActionKebab, ()=>{
        setShowKebabActionBtns(false);
    });
    const resetBulkCheckBoxes = ()=>{
        dispatch((0, $d623f23401a154f0$export$1a295a970dce82de)(true));
        dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(false));
        dispatch((0, $d623f23401a154f0$export$889241fc0afda8a9)(false));
        dispatch((0, $d623f23401a154f0$export$ebeb2bd8ecd91be9)(false));
        dispatch((0, $d623f23401a154f0$export$2af49e179df91659)(false));
    };
    const resetTabAndItems = ()=>{
        dispatch((0, $d623f23401a154f0$export$afd1b438af1720fe)(certKey));
        dispatch((0, $d623f23401a154f0$export$661e1772dd5a4141)(true));
        dispatch((0, $d623f23401a154f0$export$86d11b633a5d59e6)(true));
        dispatch((0, $d623f23401a154f0$export$6e5b0daaf8d927e4)(certKey, (0, $bf14b63763e2d183$export$4767a28fbd1026ef), true));
    };
    const handleClear = ()=>{
        dispatch((0, $d623f23401a154f0$export$1a295a970dce82de)(true));
        dispatch((0, $d623f23401a154f0$export$c594ad0cf83b2327)(certKey, true)).then(()=>{
            dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(false));
            dispatch((0, $d623f23401a154f0$export$889241fc0afda8a9)(false));
        }).catch((error)=>{
            dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(true, error.message));
        });
    };
    // const handleWorksForMe = () => {}; // paired with handleApprove
    const handleDoesNotWorkForMe = ()=>{};
    const handleTerminate = (id, status, comment)=>{
        const payload = {
            // extendedDate: '',
            userAction: "1"
        };
        dispatch((0, $d623f23401a154f0$export$88c9ed9fe84131c)(certKey, status, comment, id === (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).TERMINATE.id ? payload : {})).then(()=>{
            resetBulkCheckBoxes();
            resetTabAndItems();
        }).catch((error)=>{
            dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(true, error.message));
        }).finally(()=>{
            setBulkActionReject({
                ...bulkActionApprove,
                isOpen: false,
                showAlert: false,
                isSubmitting: false,
                isChecked: false,
                comment: ""
            });
        // TODO: Confirm whether to reset all checkboxes
        // resetBulkCheckBoxes();
        });
    }; // paired with handleReject
    const handleExtendEndDate = ()=>{};
    // paired with handleWorksForMe
    const handleApprove = (id, status, comment)=>{
        if (bulkActionApprove.comment.length === 0 || !bulkActionApprove.isChecked) {
            setBulkActionApprove((prev)=>({
                    ...prev,
                    showAlert: true
                }));
            return;
        }
        const payload = {
            // extendedDate: '',
            userAction: "1"
        };
        dispatch((0, $d623f23401a154f0$export$88c9ed9fe84131c)(certKey, status, comment, id === (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).WORKS_FOR_ME.id ? payload : {})).then(()=>{
            resetBulkCheckBoxes();
            resetTabAndItems();
        }).catch((error)=>{
            dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(true, error.message));
        }).finally(()=>{
            setBulkActionApprove({
                ...bulkActionApprove,
                isOpen: false,
                showAlert: false,
                isSubmitting: false,
                isChecked: false,
                status: "2",
                comment: ""
            });
        // TODO: Confirm whether to reset all checkboxes
        // resetBulkCheckBoxes();
        });
    };
    // const handleReject = () => {};
    const handleConditionalyCertify = ()=>{};
    const handleReassign = ()=>{};
    const handleConsult = ()=>{};
    // Modals open
    const handleApproveModalOpen = (id, status)=>{
        setBulkActionApprove((prev)=>({
                ...prev,
                isOpen: !prev.isOpen,
                id: id,
                status: status
            }));
    };
    const handleRejectModalOpen = (id, status)=>{
        setBulkActionReject((prev)=>({
                ...prev,
                isOpen: !prev.isOpen,
                id: id,
                status: status
            }));
    };
    const bulkActionClearBtn = {
        id: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).CLEAR.id,
        icon: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).CLEAR.icon,
        status: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).CLEAR.status,
        objectsToTotal: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).CLEAR.objectsToTotal,
        kind: "ghost",
        text: "Clear Selection",
        popOverContent: "",
        onClick: handleClear
    };
    const bulkActionButtons = {
        worksForMe: {
            id: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).WORKS_FOR_ME.id,
            icon: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).WORKS_FOR_ME.icon,
            status: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).WORKS_FOR_ME.status,
            objectsToTotal: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).WORKS_FOR_ME.objectsToTotal,
            kind: "outlined",
            text: "Confirm Manager",
            popOverContent: "",
            onClick: handleApproveModalOpen
        },
        doesNotWorksForMe: {
            id: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).DOES_NOT_WORK_FOR_ME.id,
            icon: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).DOES_NOT_WORK_FOR_ME.icon,
            status: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).DOES_NOT_WORK_FOR_ME.status,
            objectsToTotal: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).DOES_NOT_WORK_FOR_ME.objectsToTotal,
            kind: "outlined",
            text: "DNWFM",
            popOverContent: "",
            onClick: handleDoesNotWorkForMe
        },
        terminated: {
            id: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).TERMINATE.id,
            icon: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).TERMINATE.icon,
            status: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).TERMINATE.status,
            objectsToTotal: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).TERMINATE.objectsToTotal,
            kind: "outlined",
            text: "Terminate",
            popOverContent: "",
            onClick: handleRejectModalOpen
        },
        extendEndDate: {
            id: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).EXTEND_END_DATE.id,
            icon: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).EXTEND_END_DATE.icon,
            status: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).EXTEND_END_DATE.status,
            objectsToTotal: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).EXTEND_END_DATE.objectsToTotal,
            kind: "outlined",
            text: "Extend End Date",
            popOverContent: "",
            onClick: handleExtendEndDate
        },
        approve: {
            id: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).APPROVE.id,
            icon: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).APPROVE.icon,
            status: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).APPROVE.status,
            objectsToTotal: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).APPROVE.objectsToTotal,
            kind: "outlined",
            text: "Approve",
            popOverContent: "",
            onClick: handleApproveModalOpen
        },
        reject: {
            id: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).REJECT.id,
            icon: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).REJECT.icon,
            status: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).REJECT.status,
            objectsToTotal: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).REJECT.objectsToTotal,
            kind: "outlined",
            text: "Reject",
            popOverContent: "",
            onClick: handleRejectModalOpen
        },
        conditionalCertifiy: {
            id: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).CONDITIONAL_CERTIFIY.id,
            icon: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).CONDITIONAL_CERTIFIY.icon,
            status: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).CONDITIONAL_CERTIFIY.status,
            objectsToTotal: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).CONDITIONAL_CERTIFIY.objectsToTotal,
            kind: "outlined",
            text: "CC",
            popOverContent: "",
            onClick: handleConditionalyCertify
        },
        reassign: {
            id: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).REASSIGN.id,
            icon: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).REASSIGN.icon,
            status: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).REASSIGN.status,
            objectsToTotal: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).REASSIGN.objectsToTotal,
            kind: "outlined",
            text: "Reassign",
            popOverContent: "",
            onClick: handleReassign
        },
        consult: {
            id: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).CONSULT.id,
            icon: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).CONSULT.icon,
            status: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).CONSULT.status,
            objectsToTotal: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).CONSULT.objectsToTotal,
            kind: "outlined",
            text: "Consult",
            popOverContent: "",
            onClick: handleConsult
        }
    };
    const renderBulkActionFooterInfoBox = ()=>{
        const bulkFooterStatsKeys = Object.keys(bulkFooterStats);
        const fullSelectedInfo = bulkFooterStatsKeys?.filter((key)=>bulkFooterStats[key] > 0)?.map((key)=>`${(0, $f16755d1eb7f7f9c$export$c9eee0952850eb88)[key]}${bulkFooterStats[key] > 1 ? "s" : ""} (${bulkFooterStats[key]})`).join(", ") || "You've selected nothing.";
        return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: "BulkActionFooter-infoBox",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "body1-bold",
                    className: "BulkActionFooter-infoBoxTitle",
                    children: "Selected:"
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "body1",
                    className: "BulkActionFooter-infoBoxDescription",
                    children: fullSelectedInfo
                })
            ]
        });
    };
    const renderBulkActionFooterActionBtns = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: "BulkActionFooter-btnBox",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                    type: "button",
                    kind: bulkActionClearBtn.kind,
                    size: "medium",
                    dataTheme: (0, $135adfecc1ed8f07$export$49390a4605a2336a).DARK,
                    onClick: bulkActionClearBtn.onClick,
                    className: "BulkActionFooter-btnBoxButton",
                    children: bulkActionClearBtn.text
                }, bulkActionClearBtn.id),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                    tag: "div",
                    className: "BulkActionFooter-btnBoxVariableBtns",
                    children: bulkActionBtnsMap.filter((_, index)=>index < countForActionButtonsAsPerScreen).map((key)=>{
                        const { id: id, status: status, kind: kind, text: text, popOverContent: popOverContent, objectsToTotal: objectsToTotal, onClick: onClickFunc } = bulkActionButtons[key];
                        const btnCount = objectsToTotal.reduce((total, item)=>{
                            if (bulkFooterStats[item]) return total + bulkFooterStats[item];
                            return total;
                        }, 0) || "0";
                        return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Button), {
                            type: "button",
                            kind: kind,
                            size: "medium",
                            dataTheme: (0, $135adfecc1ed8f07$export$49390a4605a2336a).DARK,
                            onClick: ()=>onClickFunc(id, status),
                            rightIcon: popOverContent.trim().length > 0 ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: "Info",
                                size: "smallMedium"
                            }) : null,
                            className: "BulkActionFooter-btnBoxButton",
                            children: [
                                `${text} (${btnCount})`,
                                popOverContent.trim().length > 0 && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                                    tag: "span",
                                    className: "BulkActionFooter-btnBoxButtonPopOver",
                                    children: popOverContent
                                })
                            ]
                        }, id);
                    })
                }),
                bulkActionBtnsMap.length > countForActionButtonsAsPerScreen && /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    tag: "div",
                    className: "BulkActionFooter-btnBoxMenu",
                    children: [
                        showKebabActionBtns && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                            className: "BulkActionFooter-btnBoxMenuDropUp",
                            ref: dropUpWrapperForBulkActionKebab,
                            children: bulkActionBtnsMap.filter((_, index)=>index >= countForActionButtonsAsPerScreen).map((key)=>{
                                const { id: id, status: status, icon: icon, text: text, objectsToTotal: objectsToTotal, onClick: onClickFunc } = bulkActionButtons[key];
                                const btnCount = objectsToTotal.reduce((total, item)=>{
                                    if (bulkFooterStats[item]) return total + bulkFooterStats[item];
                                    return total;
                                }, 0) || "0";
                                return /*#__PURE__*/ (0, $hopDi$jsxs)("span", {
                                    className: "BulkActionFooter-btnBoxMenuDropUpListItem",
                                    onClick: ()=>onClickFunc(id, status),
                                    onKeyDown: ()=>{},
                                    role: "button",
                                    tabIndex: "0",
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                            kind: icon,
                                            size: "smallMedium"
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body2",
                                            className: "BulkActionFooter-btnBoxMenuDropUpListItemText",
                                            children: `${text} (${btnCount})`
                                        })
                                    ]
                                }, id);
                            })
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                            size: "medium",
                            kind: "ghost",
                            className: "BulkActionFooter-btnBoxMenukebab",
                            onClick: ()=>setShowKebabActionBtns(!showKebabActionBtns),
                            icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: "KebabVertical",
                                color: "neutral-000",
                                size: "smallMedium"
                            })
                        })
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
        tag: "div",
        className: "BulkActionFooter-wrapper",
        children: [
            bulkAction?.showFooter && /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $25d7b062f5a92790$export$2e2bcd8739ae039), {
                        bulkFooterStats: bulkFooterStats,
                        bulkActionApprove: bulkActionApprove,
                        setBulkActionApprove: setBulkActionApprove,
                        handleApprove: handleApprove
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $a0d9492c4344f44f$export$2e2bcd8739ae039), {
                        bulkActionReject: bulkActionReject,
                        setBulkActionReject: setBulkActionReject,
                        handleTerminate: handleTerminate
                    })
                ]
            }),
            renderBulkActionFooterInfoBox(),
            renderBulkActionFooterActionBtns()
        ]
    });
}
var $2c59e15aa57e4ffa$export$2e2bcd8739ae039 = $2c59e15aa57e4ffa$var$BulkActionFooter;



var $8107c65abb1d6a90$export$2e2bcd8739ae039 = (0, $2c59e15aa57e4ffa$export$2e2bcd8739ae039);








function $bf993c45fc2d1cb4$var$CertsFooterActionBar() {
    const [isProgressBarOpen, setIsProgressBarOpen] = (0, $hopDi$useState)(false);
    const dispatch = (0, $hopDi$useDispatch)();
    const popoverRef = (0, $hopDi$useRef)(null);
    const { bulkAction: bulkAction, isSidePanelVisible: isSidePanelVisible, certKey: certKey, progressBreakdowndetails: progressBreakdowndetails, shouldShowReviewAndSubmitButton: shouldShowReviewAndSubmitButton, campaignKey: campaignKey } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const { isActionSuccess: isActionSuccess } = (0, $hopDi$useSelector)((state)=>state?.certifications?.action);
    const { byDecisionDetails: byDecisionDetails, errorMessage: errorMessage, initialLoadError: initialLoadError } = progressBreakdowndetails;
    const footerNotice = "Progress Saved";
    const footerClasses = (0, $hopDi$classnames)("CertsFooterActionBar", isSidePanelVisible && "CertsFooterActionBar--isSidePanelVisible");
    const footerPhase1 = (0, $hopDi$classnames)("CertsFooterActionBar-phases", bulkAction?.showFooter && "CertsFooterActionBar-phases1--isSidePanelVisible");
    const footerPhase2 = (0, $hopDi$classnames)("CertsFooterActionBar-phases", bulkAction?.showFooter && "CertsFooterActionBar-phases2--isSidePanelVisible");
    const progressMessageClasses = (0, $hopDi$classnames)("CertsFooterActionBar-progressMessage", isActionSuccess ? "CertsFooterActionBar-progressMessage--isVisible" : "CertsFooterActionBar-progressMessage--isHidden");
    (0, $52fa6d0b886d7882$export$2e2bcd8739ae039)(popoverRef, ()=>{
        setIsProgressBarOpen(false);
    });
    const fetchProgessBarData = ()=>{
        dispatch((0, $d623f23401a154f0$export$6e5b0daaf8d927e4)(certKey, (0, $bf14b63763e2d183$export$4767a28fbd1026ef), true));
    };
    const refreshProgressData = ()=>{
        if (certKey) fetchProgessBarData();
    };
    (0, $hopDi$useEffect)(()=>{
        if (certKey) fetchProgessBarData();
    }, [
        certKey
    ]);
    const onBackClick = ()=>{
        window.location.replace(`/ECM/certification/list?campaignKey=${campaignKey}&type=list`);
    };
    const handlePopOver = ()=>{
        if (!initialLoadError) setIsProgressBarOpen((prev)=>!prev);
    };
    const toggleHoverClass = (isHovered)=>{
        const progressBar = document.querySelector(".CertsFooterActionBar-progressBar");
        if (progressBar) {
            if (isHovered) progressBar.classList.add("CertsFooterActionBar-progressBar--isHovered");
            else progressBar.classList.remove("CertsFooterActionBar-progressBar--isHovered");
        }
    };
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
        tag: "footer",
        className: footerClasses,
        dataTestId: "cert-details",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                tag: "div",
                className: footerPhase1,
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        type: "button",
                        kind: "subtle",
                        size: "medium",
                        onClick: onBackClick,
                        children: "Back"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                        className: "CertsFooterActionBar-progressBar",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                            className: "CertsFooterActionBar-progress-content",
                            ref: popoverRef,
                            children: initialLoadError ? /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                                className: "CertsFooterActionBar-progressFailure",
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                        kind: "body2-bold",
                                        className: "CertsFooterActionBar-progressErrorMessage",
                                        children: "Error while loading porgress bar breakdown data."
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                                        size: "large",
                                        kind: "ghost",
                                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                            kind: "Refresh",
                                            size: "medium",
                                            color: "navy-900"
                                        }),
                                        onClick: refreshProgressData
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                                children: [
                                    isProgressBarOpen && /*#__PURE__*/ (0, $hopDi$jsx)((0, $aedec3a09ed0c484$export$2e2bcd8739ae039), {
                                        closePopover: handlePopOver
                                    }),
                                    byDecisionDetails?.Summary ? /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                                                kind: "body2",
                                                className: "CertsFooterActionBar-linearProgess",
                                                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $f731ea5e88f23f43$export$2e2bcd8739ae039), {
                                                    value: (0, $c3fd831cb38d6d24$export$c3e0f520a0aee8fc)(byDecisionDetails.Summary[0, $bf14b63763e2d183$export$71efb3495f6084f2], byDecisionDetails.Summary[0, $bf14b63763e2d183$export$e135c39ae3ebb92e])
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                                kind: "body2-bold",
                                                className: "CertsFooterActionBar-progressPercentage",
                                                children: `${byDecisionDetails.Summary[0, $bf14b63763e2d183$export$fbc5ebe2e580bf8b]}%`
                                            }),
                                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                                kind: "ChevronUpSmall",
                                                size: "medium",
                                                rotate: isProgressBarOpen ? "180" : null
                                            })
                                        ]
                                    }) : !errorMessage && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                                        kind: "dots",
                                        format: "inline",
                                        color: "brand",
                                        size: "medium"
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonCore), {
                                        onMouseEnter: ()=>toggleHoverClass(true),
                                        onMouseLeave: ()=>toggleHoverClass(false),
                                        onClick: handlePopOver,
                                        className: "CertsFooterActionBar-togglePopover"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                        tag: "div",
                        className: "CertsFooterActionBar-submit",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body2",
                                className: progressMessageClasses,
                                children: footerNotice
                            }),
                            shouldShowReviewAndSubmitButton && /*#__PURE__*/ (0, $hopDi$jsx)((0, $eb340908ccb18f38$export$2e2bcd8739ae039), {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                tag: "div",
                className: footerPhase2,
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $8107c65abb1d6a90$export$2e2bcd8739ae039), {})
            })
        ]
    });
}
var $bf993c45fc2d1cb4$export$2e2bcd8739ae039 = $bf993c45fc2d1cb4$var$CertsFooterActionBar;


var $51ca153ebce16509$export$2e2bcd8739ae039 = (0, $bf993c45fc2d1cb4$export$2e2bcd8739ae039);


/* eslint-disable jsx-a11y/anchor-is-valid */ 




function $9c2b6add8bf30d68$var$CertsHeader() {
    const { certificationName: certificationName, campaignKey: campaignKey } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const onCloseClick = ()=>{
        window.location.replace(`/ECM/certification/list?campaignKey=${campaignKey}&type=list`);
    };
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
        dataTheme: "dark",
        tag: "header",
        className: "CertsHeader",
        dataTestId: "certs-header",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                kind: "h1",
                className: "CertsHeader-text",
                children: certificationName || ""
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                className: "CertsHeader-controls",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                    type: "button",
                    kind: "outlined",
                    size: "medium",
                    className: "CertsHeader-button",
                    leftIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "Download",
                        size: "smallMedium"
                    }),
                    children: "Export"
                })
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                tag: "div",
                className: "CertsHeader-closeBtn",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                    size: "large",
                    kind: "ghost",
                    icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "Close",
                        size: "medium"
                    }),
                    onClick: onCloseClick
                })
            })
        ]
    });
}
var $9c2b6add8bf30d68$export$2e2bcd8739ae039 = $9c2b6add8bf30d68$var$CertsHeader;


var $6c53f4b34b441c38$export$2e2bcd8739ae039 = (0, $9c2b6add8bf30d68$export$2e2bcd8739ae039);



function $7d04cd0c9db22b5a$var$CertificationDetails() {
    const [showFilterBar, setShowFilterBar] = (0, $hopDi$useState)(false);
    const [isMoreDataAvailable, setIsMoreDataAvailable] = (0, $hopDi$useState)(true);
    const [showSavCompanion, setShowSaviCompanion] = (0, $hopDi$useState)(true);
    const dispatch = (0, $hopDi$useDispatch)();
    const location = (0, $hopDi$useLocation)();
    const detailsListRef = (0, $hopDi$useRef)(null);
    const { campaignKey: campaignKey, isSidePanelVisible: isSidePanelVisible, saviCompanionDetails: { isSaviEnabled: isSaviEnabled } } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const queryParams = new URLSearchParams(location?.search);
    const certKey = queryParams.get("certkey");
    const areControlsVisible = (0, $54e13f0d39960013$export$2e2bcd8739ae039)(detailsListRef, isMoreDataAvailable);
    const pageClasses = (0, $hopDi$classnames)("CertificationDetails", isSidePanelVisible && "CertificationDetails--isSidePanelVisible");
    (0, $hopDi$useEffect)(()=>{
        if (certKey) {
            dispatch((0, $d623f23401a154f0$export$1a246502936ad896)(certKey));
            dispatch((0, $d623f23401a154f0$export$889bd3e7f249bccd)(certKey));
            dispatch((0, $d623f23401a154f0$export$c594ad0cf83b2327)(certKey, true)).catch((error)=>(0, $hopDi$Logger).log(error.message));
        }
    }, [
        certKey
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (campaignKey) dispatch((0, $d623f23401a154f0$export$7f8f83f9a8bce93a)(campaignKey));
    }, [
        campaignKey
    ]);
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: pageClasses,
        "data-testid": "cert-details",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $6c53f4b34b441c38$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $2c4c83dadce0c268$export$2e2bcd8739ae039), {
                areControlsVisible: areControlsVisible,
                showFilterBar: showFilterBar,
                setShowFilterBar: setShowFilterBar,
                setShowSaviCompanion: setShowSaviCompanion,
                isSaviEnabled: isSaviEnabled
            }),
            isSaviEnabled && showSavCompanion && /*#__PURE__*/ (0, $hopDi$jsx)((0, $e40ef6d119a5d30a$export$2e2bcd8739ae039), {
                certKey: certKey,
                showSavCompanion: showSavCompanion,
                setShowSaviCompanion: setShowSaviCompanion
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $deb4d0ab4728ac1f$export$2e2bcd8739ae039), {
                areControlsVisible: areControlsVisible,
                isMoreDataAvailable: isMoreDataAvailable,
                setIsMoreDataAvailable: setIsMoreDataAvailable,
                showFilterBar: showFilterBar,
                detailsListRef: detailsListRef
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $51ca153ebce16509$export$2e2bcd8739ae039), {})
        ]
    });
}
var $7d04cd0c9db22b5a$export$2e2bcd8739ae039 = $7d04cd0c9db22b5a$var$CertificationDetails;


function $25630133a83ede0d$var$Routes() {
    const allowedRoutes = {
        staticRoutes: [],
        dynamicRoutes: []
    };
    (0, $hopDi$useEffect)(()=>{
        (0, $8420256091f3759b$export$9bc070677037150b)();
        (0, $8420256091f3759b$export$2e2bcd8739ae039)();
        return ()=>{
            (0, $hopDi$removeClassesForHidingElements)();
        };
    }, []);
    const certGen2Flag = window.localStorage.getItem("certGen2Flag");
    if (certGen2Flag === "0") allowedRoutes.staticRoutes = [];
    else if (certGen2Flag === "1") allowedRoutes.staticRoutes = [
        "/certification/usermanagement"
    ];
    return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $4b5d3b67c109436c$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Suspense), {
                fallback: ()=>{},
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$BrowserRouter), {
                    basename: "/ECMv6",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Route404), {
                        routes: allowedRoutes,
                        render: (path)=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Global404), {
                                path: path
                            }),
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Switch), {
                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Route), {
                                exact: true,
                                path: "/certification/usermanagement",
                                component: (0, $7d04cd0c9db22b5a$export$2e2bcd8739ae039)
                            })
                        })
                    })
                })
            }, "Certs")
        })
    });
}
var $25630133a83ede0d$export$2e2bcd8739ae039 = $25630133a83ede0d$var$Routes;


/* eslint-disable default-param-last */ 


const $c7a299b42c530c44$var$INITIAL_STATE = {
    certKey: null,
    certDetailsLists: null,
    totalItems: 0,
    isLoading: true,
    error: null,
    isError: false,
    isViewApiError: false,
    isViewApiLoading: false,
    campaignKey: null,
    isAuditor: true,
    columnPickerList: null,
    certDetailsView: null,
    certificationName: null,
    isColPickerwApiLoading: false,
    viewColumnsList: null,
    columnNames: null,
    searchText: "",
    certsFilters: null,
    rowsFilters: null,
    viewRowsList: null,
    colsFilters: null,
    advancedFilters: null,
    triggerClearBtnForFilters: null,
    triggerClearBtnForSearch: null,
    isTriggeredFromSearchOrFilter: false,
    accessRequestHistory: {
        isOpen: false,
        isLoading: true,
        arsTaskKeys: null,
        arsData: null,
        isError: false,
        error: null
    },
    bulkAction: {
        showBulkSelectCheckBox: true,
        actionBySelectAll: false,
        isChecked: false,
        isIndeterminate: false,
        isDisabled: true,
        isSelecting: false,
        atleastOneIsSelected: false,
        showFooter: false,
        selectedItemsMap: [],
        bulkActionFooterData: null,
        alert: {
            isAlert: false,
            alertText: null
        },
        isSubmittingAction: false
    },
    tabs: {
        tabData: [
            {
                key: (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49),
                count: 0,
                label: "To Do",
                isActive: true,
                isHighlighted: false
            },
            {
                key: (0, $d44c789d5b60f9bf$export$807a0bc890800408),
                count: 0,
                label: "Done",
                isActive: false,
                isHighlighted: false
            },
            {
                key: (0, $d44c789d5b60f9bf$export$d5eea126dff5a615),
                count: 0,
                label: "All",
                isActive: false,
                isHighlighted: false
            },
            {
                key: (0, $d44c789d5b60f9bf$export$b2766b46106d3053),
                count: 0,
                label: "Consulted",
                isActive: false,
                isHighlighted: false
            }
        ],
        isLoading: false,
        isError: false,
        errorMessage: false
    },
    shouldShowReviewAndSubmitButton: false,
    reviewAndSubmit: {
        primaryCertifier: true,
        primaryCertifierName: "",
        withESignature: false,
        enableloginSignature: "",
        noOfTries: "",
        userAttribute: "",
        step1Data: {},
        step2Data: {
            predefComments: []
        }
    },
    isLoadingReviewAndSubmit: true,
    isSubmittingReviewAndSubmit: false,
    reviewAndSubmitError: false,
    actions: {
        approve: {
            entValueKey: null,
            accountKey: null,
            isSuccess: false,
            isLoading: false,
            isError: false,
            errorMessage: null
        },
        approveUser: {
            entValueKey: null,
            userKey: null,
            isSuccess: false,
            isLoading: false,
            isError: false,
            errorMessage: null
        },
        terminateUser: {
            userKey: null,
            isSuccess: false,
            isLoading: false,
            isError: false,
            errorMessage: null
        },
        changeEndDate: {
            userKey: null,
            isSuccess: false,
            isLoading: false,
            isError: false,
            errorMessage: null
        }
    },
    isSidePanelVisible: false,
    isSidePanelLoading: false,
    isSidePanelError: false,
    sidePanelUsers: {
        summary: null,
        history: {
            employment: null,
            audit: null
        }
    },
    sidePanelRoles: {
        summary: null,
        history: {
            access: null,
            audit: null
        },
        entitlements: null,
        children: null
    },
    action: {
        isActionLoading: false,
        isActionSuccess: false,
        isActionError: false,
        errorMessage: null,
        userKey: null,
        buttonActionType: null
    },
    enableComments: {
        users: [],
        accEntRole: []
    },
    sidePanelAccounts: {
        summary: null,
        history: {
            access: null,
            audit: null
        }
    },
    sidePanelEntitlements: {
        summary: null,
        history: {
            access: null,
            audit: null
        },
        sod: null,
        privileges: null,
        children: null,
        dependents: null
    },
    progressBreakdowndetails: {
        byTypeDetails: null,
        byDecisionDetails: null,
        isLoading: false,
        errorMessage: null,
        initialLoadError: false
    },
    dynamicSortFilter: {
        sortDirection: null,
        sortByColumn: null
    },
    usersListDetails: {
        list: [],
        isLoading: false,
        errorMessage: null
    },
    reassignConfigMap: null,
    isPopoverUserReassignMsgShown: false,
    isWarnModalReassignShown: false,
    saviCompanionDetails: {
        showIntro: false,
        isSaviEnabled: false,
        statusDetails: {
            smartActionDetails: {}
        }
    }
};
const $c7a299b42c530c44$var$certificationDetailsReducer = (state = $c7a299b42c530c44$var$INITIAL_STATE, action)=>{
    switch(action?.type){
        case 0, $d6d78fc758ee4148$export$12cd07f9e71f98b:
            return {
                ...state,
                triggerClearBtnForSearch: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$8a89d25d4ad8783e:
            return {
                ...state,
                triggerClearBtnForFilters: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$8c4d8141d3ba5d38:
            return {
                ...state,
                advancedFilters: action?.payload?.results
            };
        case 0, $d6d78fc758ee4148$export$e87c818aed68e8cb:
            return {
                ...state,
                accessRequestHistory: {
                    ...state.accessRequestHistory,
                    ...action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$7a8caab59b607807:
            return {
                ...state,
                accessRequestHistory: {
                    ...state.accessRequestHistory,
                    isLoading: action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$8671c3354e9690ea:
            return {
                ...state,
                accessRequestHistory: {
                    ...state.accessRequestHistory,
                    ...action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$dcc76e3383a21811:
            return {
                ...state,
                accessRequestHistory: {
                    ...state.accessRequestHistory,
                    arsData: action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$afe1eb1cba0072ef:
            return {
                ...state,
                bulkAction: {
                    ...state.bulkAction,
                    actionBySelectAll: action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$b0c18ac3058b419e:
            return {
                ...state,
                bulkAction: {
                    ...state.bulkAction,
                    showBulkSelectCheckBox: action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$bfbc1bdccfb4abf5:
            return {
                ...state,
                bulkAction: {
                    ...state.bulkAction,
                    isChecked: action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$768f00e6b30d478:
            return {
                ...state,
                bulkAction: {
                    ...state.bulkAction,
                    showFooter: action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$2d1f20523798a1b7:
            return {
                ...state,
                bulkAction: {
                    ...state.bulkAction,
                    bulkActionFooterData: action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$69729db10395ff90:
            return {
                ...state,
                bulkAction: {
                    ...state.bulkAction,
                    isIndeterminate: action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$60473f3971dee5df:
            return {
                ...state,
                bulkAction: {
                    ...state.bulkAction,
                    isDisabled: action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$2890f4c8d2907863:
            return {
                ...state,
                bulkAction: {
                    ...state.bulkAction,
                    isSelecting: action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$42cd2e4c8af9ab41:
            return {
                ...state,
                bulkAction: {
                    ...state.bulkAction,
                    atleastOneIsSelected: action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$8cf310caad6b6ea7:
            return {
                ...state,
                bulkAction: {
                    ...state.bulkAction,
                    selectedItemsMap: action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$98054ce8e1cd6185:
            return {
                ...state,
                bulkAction: {
                    ...state.bulkAction,
                    alert: {
                        isAlert: action?.payload?.isAlert,
                        alertText: action?.payload?.alertText
                    }
                }
            };
        case 0, $d6d78fc758ee4148$export$c19826a63dd39ec7:
            return {
                ...state,
                bulkAction: {
                    ...state.bulkAction,
                    isSubmittingAction: action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$f3d779ad78275d3b:
            return {
                ...state,
                certDetailsLists: action?.payload?.results,
                totalItems: action?.payload?.total,
                searchText: action?.payload?.searchText,
                error: action?.payload?.error
            };
        case 0, $d6d78fc758ee4148$export$51750fb5a6bddff5:
            return {
                ...state,
                isAuditor: action?.payload?.isAuditor,
                bulkAction: {
                    ...state.bulkAction,
                    isDisabled: action?.payload?.isAuditor
                }
            };
        case 0, $d6d78fc758ee4148$export$855d326a33362542:
            return {
                ...state,
                viewColumnsList: action?.payload?.columnList
            };
        case 0, $d6d78fc758ee4148$export$f8b68a93cd1396c:
            return {
                ...state,
                viewRowsList: action?.payload?.rowsList
            };
        case 0, $d6d78fc758ee4148$export$9f85bed13d6d6867:
            return {
                ...state,
                columnPickerList: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$7ce0be7ec08b7bd9:
            return {
                ...state,
                campaignKey: action?.payload?.campaignKey
            };
        case 0, $d6d78fc758ee4148$export$dd0462c52301fb4d:
            return {
                ...state,
                certificationName: action?.payload?.certification_name
            };
        case 0, $d6d78fc758ee4148$export$5e310ea02d328fb1:
            return {
                ...state,
                certificationStartDate: action?.payload?.certification_start_date
            };
        case 0, $d6d78fc758ee4148$export$740ea107ca859e41:
            return {
                ...state,
                certKey: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$f0d808954e0679c6:
            return {
                ...state,
                isLoading: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$e560b62bb0ef76ae:
            return {
                ...state,
                isViewApiLoading: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$3b55c5d9f617705a:
            return {
                ...state,
                isColPickerwApiLoading: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$be9207d1796cf80:
            return {
                ...state,
                isError: action?.payload?.isError,
                error: action?.payload?.error
            };
        case 0, $d6d78fc758ee4148$export$1aaf381820aaad35:
            return {
                ...state,
                isViewApiError: action?.payload?.isError
            };
        case 0, $d6d78fc758ee4148$export$20c37c78e4076fd7:
            return {
                ...state,
                isSidePanelVisible: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$903196cd760f40e2:
            return {
                ...state,
                isTriggeredFromSearchOrFilter: action?.payload
            };
        // Certs Tab Selections (set and get)
        case 0, $d6d78fc758ee4148$export$41e9b850f4b31bd:
            return {
                ...state,
                tabs: {
                    ...state.tabs,
                    tabData: action?.payload?.results
                }
            };
        case 0, $d6d78fc758ee4148$export$bcfd799e4df08939:
            return {
                ...state,
                tabs: {
                    ...state.tabs,
                    isLoading: true,
                    isError: false,
                    errorMessage: null
                }
            };
        case 0, $d6d78fc758ee4148$export$8b461e828675fe2:
            return {
                ...state,
                tabs: {
                    ...state.tabs,
                    isLoading: false,
                    isError: true,
                    errorMessage: action.payload.error
                }
            };
        case 0, $d6d78fc758ee4148$export$b61e16101d4e3f64:
            return {
                ...state,
                tabs: {
                    ...state.tabs,
                    isLoading: false,
                    isError: false,
                    errorMessage: null,
                    tabData: state.tabs.tabData.map((tab)=>tab.key === action.payload.tab ? {
                            ...tab,
                            count: action.payload.count
                        } : tab)
                }
            };
        case 0, $d6d78fc758ee4148$export$1b59f0ddd56aa357:
            return {
                ...state,
                shouldShowReviewAndSubmitButton: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$1d889ec5a0bd35b5:
            return {
                ...state,
                isLoadingReviewAndSubmit: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$8fa9055a97f67430:
            return {
                ...state,
                isSubmittingReviewAndSubmit: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$32524a0d8ac0b191:
            return {
                ...state,
                reviewAndSubmitError: action?.payload?.isError,
                error: action?.payload?.error
            };
        case 0, $d6d78fc758ee4148$export$6375a4b78a6ebe:
            return {
                ...state,
                reviewAndSubmit: {
                    ...state.reviewAndSubmit,
                    ...action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$b1c80b328234b28e:
            return {
                ...state,
                reviewAndSubmit: {
                    ...state.reviewAndSubmit,
                    step1Data: {
                        ...state.reviewAndSubmit.step1Data,
                        ...action?.payload?.results
                    }
                }
            };
        case 0, $d6d78fc758ee4148$export$d954cd82d0ab56d0:
            return {
                ...state,
                certsFilters: action?.payload?.results
            };
        case 0, $d6d78fc758ee4148$export$af468c26aae4b8fa:
            return {
                ...state,
                rowsFilters: action?.payload?.results
            };
        case 0, $d6d78fc758ee4148$export$9d483e8c06e94386:
            return {
                ...state,
                colsFilters: action?.payload?.results
            };
        case 0, $d6d78fc758ee4148$export$3f218b7834ef2f49:
            return {
                ...state,
                columnNames: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$1b7cff865d967245:
            return {
                ...state,
                isSidePanelError: action?.payload?.isSidePanelError,
                error: action?.payload?.error
            };
        case 0, $d6d78fc758ee4148$export$9a3ca9b6c1caafdf:
            return {
                ...state,
                isSidePanelLoading: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$44cea83c7eb86289:
            return {
                ...state,
                sidePanelEntitlements: {
                    ...state.sidePanelEntitlements,
                    summary: action?.payload?.results
                },
                error: action?.payload?.error
            };
        case 0, $d6d78fc758ee4148$export$a252b37c42fd39c0:
            return {
                ...state,
                sidePanelEntitlements: {
                    ...state.sidePanelEntitlements,
                    history: {
                        ...state.sidePanelEntitlements.history,
                        audit: action?.payload?.results
                    }
                },
                error: action?.payload?.error
            };
        case 0, $d6d78fc758ee4148$export$46e200503484c25f:
            if (action?.loadMoreStatus === (0, $d6d78fc758ee4148$export$95aee1eca5275acc)) return {
                ...state,
                sidePanelEntitlements: {
                    ...state.sidePanelEntitlements,
                    sod: action?.payload?.results
                },
                error: action?.payload?.error
            };
            if (action?.loadMoreStatus === (0, $d6d78fc758ee4148$export$2e6684ed5543ad11)) return {
                ...state,
                sidePanelEntitlements: {
                    ...state.sidePanelEntitlements,
                    sod: {
                        ...state.sidePanelEntitlements.sod,
                        risks: [
                            ...state.sidePanelEntitlements.sod.risks,
                            ...action.payload.results
                        ]
                    }
                },
                error: action?.payload?.error
            };
            return state;
        case 0, $d6d78fc758ee4148$export$a71fe6648e4ae608:
            return {
                ...state,
                sidePanelEntitlements: {
                    ...state.sidePanelEntitlements,
                    privileges: action?.payload?.results
                },
                error: action?.payload?.error
            };
        case 0, $d6d78fc758ee4148$export$842ba02ccf54b42b:
            if (action?.loadMoreStatus === (0, $d6d78fc758ee4148$export$95aee1eca5275acc)) return {
                ...state,
                sidePanelEntitlements: {
                    ...state.sidePanelEntitlements,
                    children: action?.payload?.results
                },
                error: action?.payload?.error
            };
            if (action?.loadMoreStatus === (0, $d6d78fc758ee4148$export$2e6684ed5543ad11)) return {
                ...state,
                sidePanelEntitlements: {
                    ...state.sidePanelEntitlements,
                    children: {
                        ...state.sidePanelEntitlements.children,
                        childEntList: [
                            ...state.sidePanelEntitlements.children.childEntList,
                            ...action.payload.results
                        ]
                    }
                },
                error: action?.payload?.error
            };
            return state;
        case 0, $d6d78fc758ee4148$export$b98808434921fbb1:
            return {
                ...state,
                sidePanelAccounts: {
                    ...state.sidePanelAccounts,
                    summary: action?.payload?.results
                },
                error: action?.payload?.error
            };
        case 0, $d6d78fc758ee4148$export$7f0539351068ca18:
            return {
                ...state,
                sidePanelAccounts: {
                    ...state.sidePanelAccounts,
                    history: {
                        ...state.sidePanelAccounts.history,
                        audit: action?.payload?.results
                    }
                },
                error: action?.payload?.error
            };
        case 0, $d6d78fc758ee4148$export$a7a89423fc1f2d99:
            return {
                ...state,
                sidePanelUsers: {
                    ...state.sidePanelUsers,
                    summary: action?.payload?.results
                },
                error: action?.payload?.error
            };
        case 0, $d6d78fc758ee4148$export$e6ae9922b78d19ee:
            return {
                ...state,
                sidePanelUsers: {
                    ...state.sidePanelUsers,
                    history: {
                        ...state.sidePanelUsers.history,
                        audit: action?.payload?.results
                    }
                },
                error: action?.payload?.error
            };
        case 0, $d6d78fc758ee4148$export$85fb16097b911:
            return {
                ...state,
                sidePanelRoles: {
                    ...state.sidePanelRoles,
                    summary: action?.payload?.results
                },
                error: action?.payload?.error
            };
        case 0, $d6d78fc758ee4148$export$b0fdc72ce6a50d97:
            return {
                ...state,
                sidePanelRoles: {
                    ...state.sidePanelRoles,
                    history: {
                        ...state.sidePanelRoles.history,
                        audit: action?.payload?.results
                    }
                },
                error: action?.payload?.error
            };
        case 0, $d6d78fc758ee4148$export$940b9d07f90752d:
            if (action?.loadMoreStatus === (0, $d6d78fc758ee4148$export$95aee1eca5275acc)) return {
                ...state,
                sidePanelRoles: {
                    ...state.sidePanelRoles,
                    entitlements: action?.payload?.results
                },
                error: action?.payload?.error
            };
            if (action?.loadMoreStatus === (0, $d6d78fc758ee4148$export$2e6684ed5543ad11)) return {
                ...state,
                sidePanelRoles: {
                    ...state.sidePanelRoles,
                    entitlements: {
                        ...state.sidePanelRoles.entitlements,
                        roleEntList: [
                            ...state.sidePanelRoles.entitlements.roleEntList,
                            ...action.payload.results
                        ]
                    }
                }
            };
            return state;
        case 0, $d6d78fc758ee4148$export$d4c8fbbc4fca0999:
            if (action?.loadMoreStatus === (0, $d6d78fc758ee4148$export$95aee1eca5275acc)) return {
                ...state,
                sidePanelRoles: {
                    ...state.sidePanelRoles,
                    children: action?.payload?.results
                },
                error: action?.payload?.error
            };
            if (action?.loadMoreStatus === (0, $d6d78fc758ee4148$export$2e6684ed5543ad11)) return {
                ...state,
                sidePanelRoles: {
                    ...state.sidePanelRoles,
                    children: {
                        ...state.sidePanelRoles.children,
                        childRoleList: [
                            ...state.sidePanelRoles.children.childRoleList,
                            ...action.payload.results
                        ]
                    }
                }
            };
            return state;
        case 0, $d6d78fc758ee4148$export$8ca82b86b34f725b:
            return {
                ...state,
                action: {
                    ...state.action,
                    isActionLoading: true,
                    isActionSuccess: false,
                    isActionError: false,
                    errorMessage: null,
                    buttonActionType: action.payload ? action.payload : null
                }
            };
        case 0, $d6d78fc758ee4148$export$b3c7c737b53ea33e:
            return {
                ...state,
                action: {
                    ...state.action,
                    isActionLoading: false,
                    isActionSuccess: true,
                    isActionError: false,
                    errorMessage: null
                }
            };
        case 0, $d6d78fc758ee4148$export$3564fc123aed043c:
            return {
                ...state,
                action: {
                    ...state.action,
                    isActionLoading: false,
                    isActionSuccess: false,
                    isActionError: false,
                    errorMessage: null,
                    buttonActionType: null
                }
            };
        case 0, $d6d78fc758ee4148$export$5755ae8e491f730:
            return {
                ...state,
                action: {
                    ...state.action,
                    isActionLoading: false,
                    isActionSuccess: false,
                    isActionError: true,
                    errorMessage: action.payload.error,
                    buttonActionType: null
                }
            };
        case 0, $d6d78fc758ee4148$export$87218027c7ad9093:
            return {
                ...state,
                enableComments: {
                    users: action.payload.enableIndividualCommentsForUsers,
                    accEntRole: action.payload.enableIndividualCommentsForAccountEntitlementRoles
                }
            };
        case 0, $d6d78fc758ee4148$export$f7b4124f0c0fddd2:
            return {
                ...state,
                configMap: action?.payload?.configMap
            };
        case 0, $d6d78fc758ee4148$export$a8aa77f63d5aad19:
            return {
                ...state,
                enableIndividualCommentsForUsers: action?.payload?.enableIndividualCommentsForUsers
            };
        case 0, $d6d78fc758ee4148$export$b77c91b145bf9647:
            if (action.payload.groupByType === (0, $bf14b63763e2d183$export$4767a28fbd1026ef)) return {
                ...state,
                progressBreakdowndetails: {
                    ...state.progressBreakdowndetails,
                    byDecisionDetails: action.payload.data,
                    errorMessage: null
                }
            };
            if (action.payload.groupByType === (0, $bf14b63763e2d183$export$14ae8ea77646ac77)) return {
                ...state,
                progressBreakdowndetails: {
                    ...state.progressBreakdowndetails,
                    byTypeDetails: action.payload.data,
                    errorMessage: null
                }
            };
            return state;
        case 0, $d6d78fc758ee4148$export$5296abadcbacb235:
            if (action.payload) return {
                ...state,
                progressBreakdowndetails: {
                    ...state.progressBreakdowndetails,
                    isLoading: action.payload,
                    errorMessage: null,
                    initialLoadError: false
                }
            };
            return {
                ...state,
                progressBreakdowndetails: {
                    ...state.progressBreakdowndetails,
                    isLoading: action.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$569cf9037aa74da:
            return {
                ...state,
                progressBreakdowndetails: {
                    ...state.progressBreakdowndetails,
                    errorMessage: action.payload.initialLoad ? null : action.payload.error,
                    initialLoadError: !!action.payload.initialLoad
                }
            };
        case 0, $d6d78fc758ee4148$export$e7b0a9aed86b0918:
            return {
                ...state,
                dynamicSortFilter: {
                    ...state.dynamicSortFilter,
                    sortDirection: action.payload.sortDirection,
                    sortByColumn: action.payload.columnName
                }
            };
        case 0, $d6d78fc758ee4148$export$8810396661da9a69:
            return {
                ...state,
                dynamicSortFilter: {
                    ...state.dynamicSortFilter,
                    sortDirection: null,
                    sortByColumn: null
                }
            };
        case 0, $d6d78fc758ee4148$export$1bdde0917053ab5d:
            return {
                ...state,
                usersListDetails: {
                    ...state.usersListDetails,
                    list: action.payload.data,
                    errorMessage: null
                }
            };
        case 0, $d6d78fc758ee4148$export$3454dc93d4b256c8:
            return {
                ...state,
                usersListDetails: {
                    ...state.usersListDetails,
                    isLoading: action.payload,
                    errorMessage: null
                }
            };
        case 0, $d6d78fc758ee4148$export$3d55f922eb0f4b:
            return {
                ...state,
                usersListDetails: {
                    ...state.usersListDetails,
                    errorMessage: action.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$dd6b8d2bd42778be:
            return {
                ...state,
                reassignConfigMap: action.payload
            };
        case 0, $d6d78fc758ee4148$export$7fbc63266c535cea:
            return {
                ...state,
                isPopoverUserReassignMsgShown: !state.isPopoverUserReassignMsgShown
            };
        case 0, $d6d78fc758ee4148$export$6eb1d8263e7e2d01:
            return {
                ...state,
                isWarnModalReassignShown: !state.isWarnModalReassignShown
            };
        case 0, $d6d78fc758ee4148$export$df3ba5c051a876de:
            return {
                ...state,
                saviCompanionDetails: {
                    ...state.saviCompanionDetails,
                    statusDetails: {
                        ...state.saviCompanionDetails.statusDetails,
                        loading: true
                    }
                }
            };
        case 0, $d6d78fc758ee4148$export$4009fb2303280d3a:
            return {
                ...state,
                saviCompanionDetails: {
                    ...state.saviCompanionDetails,
                    statusDetails: {
                        ...state.saviCompanionDetails.statusDetails,
                        loading: false,
                        smartActionDetails: {
                            savi_approve: {
                                ...action.payload.savi_approve
                            },
                            savi_revoke: {
                                ...action.payload.savi_revoke
                            }
                        }
                    }
                }
            };
        case 0, $d6d78fc758ee4148$export$1e4b8a34c93a7dd0:
            return {
                ...state,
                saviCompanionDetails: {
                    ...state.saviCompanionDetails,
                    isSaviEnabled: action.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$a0f86ea1258b795c:
            return {
                ...state,
                saviCompanionDetails: {
                    ...state.saviCompanionDetails,
                    isApplyActionLoading: true
                }
            };
        case 0, $d6d78fc758ee4148$export$b021d9c474ee48de:
            return {
                ...state,
                saviCompanionDetails: {
                    ...state.saviCompanionDetails,
                    isApplyActionLoading: false
                }
            };
        default:
            return state;
    }
};
var $c7a299b42c530c44$export$2e2bcd8739ae039 = $c7a299b42c530c44$var$certificationDetailsReducer;


var $66056242d625951a$export$2e2bcd8739ae039 = (0, $c7a299b42c530c44$export$2e2bcd8739ae039);


var $851643787bf2f777$export$2e2bcd8739ae039 = (0, $66056242d625951a$export$2e2bcd8739ae039);




export {$25630133a83ede0d$export$2e2bcd8739ae039 as CertsRoutes, $851643787bf2f777$export$2e2bcd8739ae039 as certsReducer};
//# sourceMappingURL=module.js.map
